export const UnderReviewClock = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9903 3.91211C9.84647 3.9168 7.7919 4.77057 6.27954 6.28893C4.7659 7.80729 3.91681 9.86511 3.91993 12.0089C3.92306 14.1528 4.77683 16.2073 6.29363 17.7213C7.81199 19.2365 9.86824 20.0856 12.012 20.084C14.1558 20.0824 16.2104 19.2302 17.7256 17.7134C19.2408 16.1982 20.0915 14.1419 20.0915 11.9983C20.0883 9.85286 19.233 7.79504 17.7131 6.27988C16.1947 4.76308 14.1354 3.91243 11.9899 3.91243L11.9903 3.91211ZM15.9371 15.6087C15.8136 15.7557 15.6322 15.8401 15.4414 15.8417C15.2882 15.8401 15.1412 15.7854 15.0239 15.6884L11.5822 12.7987C11.432 12.6783 11.346 12.4953 11.3492 12.303V8.79562C11.3492 8.43753 11.64 8.14668 11.9981 8.14668C12.3562 8.14668 12.647 8.43753 12.647 8.79562V11.9981L15.8495 14.7048C16.1185 14.9316 16.1607 15.3303 15.9449 15.6086L15.9371 15.6087Z"
      fill="#EB9757"
    />
    <path
      d="M21.9343 5.44167V3.24779C21.9343 2.8897 21.6434 2.59885 21.2853 2.59885C20.9272 2.59885 20.638 2.8897 20.638 3.24779V3.6559C18.0594 0.992944 14.3972 -0.329949 10.7116 0.070357C7.02749 0.470663 3.73421 2.54881 1.78912 5.70267C-0.157687 8.85664 -0.537658 12.7329 0.757094 16.2059C2.05185 19.6773 4.87905 22.3574 8.41456 23.4679C11.9501 24.5765 15.8014 23.9917 18.8473 21.8807C21.8933 19.7698 23.7947 16.3717 23.9997 12.6705C24.0106 12.3124 23.7292 12.0137 23.3711 12.0028C23.013 11.9903 22.7143 12.2717 22.7034 12.6298C22.5126 15.9542 20.7894 19.0003 18.0406 20.8769C15.2901 22.7534 11.8266 23.2475 8.66143 22.2139C5.49808 21.1803 2.99309 18.7378 1.87983 15.5996C0.768062 12.4628 1.17617 8.98654 2.98224 6.1908C4.78986 3.39646 7.79232 1.59809 11.1105 1.32468C14.4271 1.04947 17.6843 2.33169 19.9252 4.79297H19.1246C18.7665 4.79297 18.4757 5.08382 18.4757 5.44191C18.4757 5.8 18.7665 6.08929 19.1246 6.08929H21.3263C21.6687 6.06896 21.9343 5.78412 21.9343 5.44167Z"
      fill="#EB9757"
    />
  </svg>
);

export const Reject = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#CD2C2C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8V12"
      stroke="#CD2C2C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16H12.01"
      stroke="#CD2C2C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Verified = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C5.375 0 0 5.375 0 12C0 18.625 5.375 24 12 24C18.625 24 24 18.625 24 12C24 5.375 18.625 0 12 0ZM18.175 9.1L11.125 16.175C10.9 16.4 10.575 16.55 10.25 16.55C9.925 16.55 9.6 16.425 9.375 16.175L5.825 12.625C5.325 12.125 5.325 11.35 5.825 10.85C6.325 10.35 7.1 10.35 7.6 10.85L10.25 13.5L16.425 7.325C16.925 6.825 17.7 6.825 18.2 7.325C18.675 7.825 18.675 8.6 18.175 9.1Z"
      fill="#168A2F"
    />
  </svg>
);
export const Pending = () => (
  <svg
    width="15"
    height="24"
    viewBox="0 0 15 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0V1.38494C0.000115242 2.91994 0.383025 4.43068 1.11407 5.78042C1.84512 7.13016 2.90122 8.27629 4.18679 9.11506C4.66647 9.42816 5.0605 9.85594 5.33324 10.3597C5.60598 10.8634 5.74881 11.4272 5.74881 12C5.74881 12.5728 5.60598 13.1366 5.33324 13.6403C5.0605 14.1441 4.66647 14.5718 4.18679 14.8849C2.90122 15.7237 1.84512 16.8698 1.11407 18.2196C0.383025 19.5693 0.000115169 21.0801 0 22.6151V24H14.7699V22.6151C14.7698 21.0801 14.3869 19.5693 13.6558 18.2196C12.9248 16.8698 11.8687 15.7237 10.5831 14.8849C10.1034 14.5718 9.70938 14.1441 9.43664 13.6403C9.16391 13.1366 9.02107 12.5728 9.02107 12C9.02107 11.4272 9.16391 10.8634 9.43664 10.3597C9.70938 9.85594 10.1034 9.42816 10.5831 9.11506C11.8687 8.27629 12.9248 7.13016 13.6558 5.78042C14.3869 4.43068 14.7698 2.91994 14.7699 1.38494V0H0ZM1.09091 1.09091H13.679V1.38494C13.6787 2.73849 13.341 4.07062 12.6962 5.26075C12.0515 6.45088 11.1202 7.46145 9.9865 8.20099C9.3547 8.6132 8.83568 9.17647 8.47643 9.83981C8.11718 10.5032 7.92903 11.2456 7.92903 12C7.92903 12.7544 8.11718 13.4968 8.47643 14.1602C8.83568 14.8235 9.3547 15.3868 9.9865 15.799C11.1202 16.5385 12.0515 17.5491 12.6962 18.7393C13.341 19.9294 13.6787 21.2615 13.679 22.6151V22.9091H1.09091V22.6151C1.09115 21.2615 1.42892 19.9294 2.07365 18.7393C2.71838 17.5491 3.64972 16.5385 4.78338 15.799C5.41518 15.3868 5.9342 14.8235 6.29345 14.1602C6.65271 13.4968 6.84085 12.7544 6.84085 12C6.84085 11.2456 6.65271 10.5032 6.29345 9.83981C5.9342 9.17647 5.41518 8.6132 4.78338 8.20099C3.64972 7.46145 2.71838 6.45088 2.07365 5.26075C1.42892 4.07062 1.09115 2.73849 1.09091 1.38494V1.09091Z"
      fill="#CD2C2C"
    />
    <path
      d="M2.50391 4.9082H12.2657C11.6633 6.05801 10.7762 7.03419 9.68914 7.7436C8.98152 8.20541 8.40023 8.83639 7.99788 9.57943C7.59553 10.3225 7.38481 11.1541 7.38481 11.9991C7.38481 11.1541 7.17409 10.3225 6.77173 9.57943C6.36937 8.83639 5.78807 8.2054 5.08044 7.7436C3.99339 7.03419 3.10632 6.05801 2.50391 4.9082Z"
      fill="#CD2C2C"
    />
    <path
      d="M4.33789 22.3652L7.38471 19.3184L10.4315 22.3652H4.33789Z"
      fill="#CD2C2C"
    />
  </svg>
);
// export const UnderReview=()=>(

// )
export const UploadFile = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.4375 0.9375C8.4375 0.418945 8.01855 0 7.5 0C6.98145 0 6.5625 0.418945 6.5625 0.9375V8.04785L4.41211 5.89746C4.0459 5.53125 3.45117 5.53125 3.08496 5.89746C2.71875 6.26367 2.71875 6.8584 3.08496 7.22461L6.83496 10.9746C7.20117 11.3408 7.7959 11.3408 8.16211 10.9746L11.9121 7.22461C12.2783 6.8584 12.2783 6.26367 11.9121 5.89746C11.5459 5.53125 10.9512 5.53125 10.585 5.89746L8.4375 8.04785V0.9375ZM1.875 10.3125C0.84082 10.3125 0 11.1533 0 12.1875V13.125C0 14.1592 0.84082 15 1.875 15H13.125C14.1592 15 15 14.1592 15 13.125V12.1875C15 11.1533 14.1592 10.3125 13.125 10.3125H10.1514L8.82422 11.6396C8.0918 12.3721 6.90527 12.3721 6.17285 11.6396L4.84863 10.3125H1.875ZM12.6562 11.9531C12.8427 11.9531 13.0216 12.0272 13.1534 12.1591C13.2853 12.2909 13.3594 12.4698 13.3594 12.6562C13.3594 12.8427 13.2853 13.0216 13.1534 13.1534C13.0216 13.2853 12.8427 13.3594 12.6562 13.3594C12.4698 13.3594 12.2909 13.2853 12.1591 13.1534C12.0272 13.0216 11.9531 12.8427 11.9531 12.6562C11.9531 12.4698 12.0272 12.2909 12.1591 12.1591C12.2909 12.0272 12.4698 11.9531 12.6562 11.9531Z"
      fill="white"
    />
  </svg>
);
export const UploadDocument = () => (
  <svg
    width="39"
    height="30"
    viewBox="0 0 39 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7143 0C8.35045 0 6.42857 1.92188 6.42857 4.28571V19.2857C6.42857 21.6496 8.35045 23.5714 10.7143 23.5714H34.2857C36.6496 23.5714 38.5714 21.6496 38.5714 19.2857V4.28571C38.5714 1.92188 36.6496 0 34.2857 0H10.7143ZM26.5179 7.14509L32.9464 16.7879C33.2746 17.2835 33.308 17.9129 33.0268 18.4353C32.7455 18.9576 32.2031 19.2857 31.6071 19.2857H21.9643H18.75H13.3929C12.7768 19.2857 12.2143 18.9308 11.9464 18.375C11.6786 17.8192 11.7522 17.1562 12.1406 16.6741L16.4263 11.317C16.7344 10.9353 17.1897 10.7143 17.6786 10.7143C18.1674 10.7143 18.6295 10.9353 18.9308 11.317L20.0893 12.7634L23.8393 7.13839C24.1406 6.69643 24.6429 6.42857 25.1786 6.42857C25.7143 6.42857 26.2165 6.69643 26.5179 7.14509ZM12.8571 6.42857C12.8571 5.86025 13.0829 5.31521 13.4848 4.91334C13.8866 4.51148 14.4317 4.28571 15 4.28571C15.5683 4.28571 16.1134 4.51148 16.5152 4.91334C16.9171 5.31521 17.1429 5.86025 17.1429 6.42857C17.1429 6.99689 16.9171 7.54194 16.5152 7.9438C16.1134 8.34566 15.5683 8.57143 15 8.57143C14.4317 8.57143 13.8866 8.34566 13.4848 7.9438C13.0829 7.54194 12.8571 6.99689 12.8571 6.42857ZM3.21429 5.89286C3.21429 5.00223 2.49777 4.28571 1.60714 4.28571C0.716518 4.28571 0 5.00223 0 5.89286V20.8929C0 25.9219 4.07813 30 9.10714 30H30.5357C31.4263 30 32.1429 29.2835 32.1429 28.3929C32.1429 27.5022 31.4263 26.7857 30.5357 26.7857H9.10714C5.85268 26.7857 3.21429 24.1473 3.21429 20.8929V5.89286Z"
      fill="#0162E8"
    />
  </svg>
);
export const EducationCapWithBook = () => (
  <svg
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2445 4.16087C21.247 4.50009 21.045 4.80562 20.7319 4.93658L13.712 7.9596C12.9463 8.28757 12.0795 8.28757 11.3138 7.9596L4.29008 4.93658C3.9808 4.80314 3.78 4.49884 3.78 4.16336C3.78 3.82664 3.98078 3.52235 4.29008 3.39015L11.2739 0.397075C12.0608 0.0603501 12.9513 0.0603501 13.7382 0.397075L20.7221 3.40636C21.0326 3.52858 21.2395 3.82664 21.2445 4.16087ZM21.0175 10.7594H20.9814C20.3191 10.7594 19.7829 11.2944 19.7804 11.9566V12.7248C19.7829 13.387 20.3191 13.922 20.9814 13.922H21.0312C21.6934 13.922 22.2297 13.387 22.2322 12.7248V11.9566C22.231 11.6361 22.1025 11.3293 21.8743 11.1048C21.6461 10.8803 21.338 10.7556 21.0175 10.7594ZM24.5869 20.9693H1.41298C0.632296 20.9693 0 21.6016 0 22.3823V22.4459C0.00124703 23.2254 0.633541 23.8552 1.41298 23.8552H12.6471V22.1067C12.6471 21.9683 12.7594 21.8573 12.8966 21.8573C13.035 21.8573 13.146 21.9683 13.146 22.1067V23.8527H24.587C25.3665 23.8527 25.9988 23.2216 26 22.4422V22.3786C25.9988 21.5991 25.3663 20.9693 24.5869 20.9693ZM3.59545 13.0775L7.82821 14.4842C8.80844 14.8097 9.72756 15.2923 10.5519 15.9134H11.0744C11.1729 15.9134 11.2727 15.9209 11.37 15.9334C10.3773 15.0791 9.22746 14.4256 7.98519 14.0116L3.75498 12.6049C3.69138 12.5824 3.62279 12.5874 3.56417 12.6161C3.50431 12.646 3.45942 12.6984 3.43821 12.7608C3.39456 12.8917 3.4645 13.0326 3.59545 13.0775ZM13.6646 19.0362H22.095C22.2335 19.0362 22.3444 19.1484 22.3444 19.2856C22.3444 19.424 22.2335 19.535 22.095 19.535H13.6646V20.4492L24.3797 20.4504V20.1037C24.3797 19.459 24.2088 18.8255 23.8845 18.268H15.9927C15.1547 18.2705 14.3393 18.5399 13.6646 19.0362ZM15.993 17.7691H23.5419C22.8435 16.9111 21.7959 16.4135 20.6885 16.4123H14.5003C13.9977 16.4147 13.5163 16.6205 13.1696 16.9847C13.4801 17.4075 13.6522 17.9138 13.6647 18.4376C14.3643 18.0048 15.1699 17.7729 15.993 17.7691ZM12.9338 18.667L13.1633 18.8366V18.5036V18.5049C13.1633 17.9512 12.9438 17.4212 12.5522 17.0296C12.1606 16.6392 11.6306 16.4197 11.0781 16.4197H4.8886C3.81359 16.4185 2.79968 16.921 2.14871 17.7766H10.1602C11.1542 17.7741 12.1232 18.0859 12.9301 18.667L12.9338 18.667ZM13.1633 20.4666V19.5525H3.79491C3.65648 19.5525 3.54549 19.4402 3.54549 19.303C3.54549 19.1646 3.65648 19.0536 3.79491 19.0536H12.5969C11.8873 18.5423 11.0343 18.2667 10.1601 18.268H1.82577C1.56388 18.7618 1.4267 19.313 1.4267 19.8717V20.4666H13.1633ZM13.9116 8.41834C13.0199 8.79871 12.0122 8.79871 11.1205 8.41834L6.27161 6.33568V10.5333C6.27161 11.3078 6.76298 11.9974 7.49626 12.2493C10.7476 13.3668 14.278 13.3668 17.5294 12.2493C18.2627 11.9974 18.754 11.3078 18.7528 10.5333V6.33568L13.9116 8.41834ZM20.9353 5.39533L20.7495 5.47514L20.7483 10.2838C20.8256 10.2701 20.9029 10.2626 20.9815 10.2602H21.0314C21.1074 10.2626 21.1823 10.2701 21.2571 10.2838V5.20569C21.1573 5.28176 21.0476 5.34536 20.9316 5.39525L20.9353 5.39533Z"
      fill="#560CB4"
    />
  </svg>
);
export const BackgroundInformation = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.4048 22.5322L20.4855 17.6113C19.6953 18.7221 18.7241 19.6933 17.6133 20.4852L22.5326 25.4045C23.326 26.1979 24.6114 26.1979 25.4048 25.4045C26.1983 24.611 26.1983 23.3256 25.4048 22.5322Z"
      fill="#560CB4"
    />
    <path
      d="M21.1236 10.5622C21.1236 4.72887 16.3947 0 10.5622 0C4.72887 0 0 4.72887 0 10.5622C0 16.3955 4.72887 21.1244 10.5622 21.1244C16.3947 21.1244 21.1236 16.3955 21.1236 10.5622ZM10.5621 18.687C6.0824 18.687 2.43738 15.0419 2.43738 10.5622C2.43738 6.08245 6.0824 2.43743 10.5621 2.43743C15.0426 2.43743 18.6861 6.08245 18.6861 10.5622C18.6861 15.0419 15.0427 18.687 10.5621 18.687Z"
      fill="#560CB4"
    />
    <path
      d="M14.6242 12.1873H13.8126C12.9144 12.1873 12.1876 11.4605 12.1876 10.5623V10.4599C12.9239 9.59115 13.4063 8.2788 13.4063 7.31241C13.4063 5.9477 13.0953 4.50525 11.4196 4.14898C11.1354 4.11089 10.8562 4.0625 10.5626 4.0625C10.269 4.0625 9.98976 4.11089 9.70569 4.14898C8.02996 4.50525 7.71894 5.9477 7.71894 7.31241C7.71894 8.2788 8.20134 9.59115 8.93765 10.4592V10.5623C8.93765 11.4605 8.21084 12.1873 7.3127 12.1873H6.50022C6.50022 12.1873 5.62584 12.438 4.7832 13.4782C5.85435 15.5959 8.02681 17.0621 10.5626 17.0621C13.0968 17.0621 15.2685 15.5959 16.3412 13.4782C15.5002 12.4372 14.6242 12.1873 14.6242 12.1873Z"
      fill="#560CB4"
    />
  </svg>
);
export const Applications = () => (
  <svg
    width="29"
    height="24"
    viewBox="0 0 29 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.42332 14.7572V7.76375L5.28169 8.59515L3.96127 12.5565C3.91236 12.7521 3.91236 12.8988 3.96127 12.9966C4.05908 13.1434 4.15688 13.1923 4.3036 13.2412L13.1064 14.7083C13.1553 14.7083 13.1553 14.7083 13.2042 14.7083C13.2531 14.7083 13.2531 14.7083 13.302 14.7083L22.1048 13.2412C22.2516 13.2412 22.3494 13.1434 22.4472 12.9966C22.545 12.8499 22.545 12.7032 22.4961 12.6054L21.0289 8.2039C21.0289 8.155 20.98 8.10609 20.98 8.05718C20.8822 7.95937 19.2684 5.90534 13.2042 5.90534C8.46048 5.90534 6.4554 7.17688 5.77073 7.76375L3.42332 6.68783V5.17176L13.2042 1.01479L24.6968 5.90534L22.3005 6.98126L22.6917 7.86156L26.115 6.29659C26.3106 6.19877 26.4084 6.05206 26.4084 5.85644C26.4084 5.66081 26.3106 5.46519 26.115 5.41629L13.3998 0.0366791C13.302 -0.0122264 13.1553 -0.0122264 13.0086 0.0366791L0.293427 5.41629C0.097809 5.5141 0 5.70972 0 5.90534C0 6.10096 0.097809 6.29659 0.293427 6.34549L2.44523 7.3236V14.7572C1.61385 14.9529 0.97809 15.7354 0.97809 16.6646V19.1098C0.97809 19.4033 1.17371 19.5989 1.46714 19.5989H4.40141C4.69483 19.5989 4.89045 19.4033 4.89045 19.1098V16.6646C4.89045 15.7354 4.25469 15.0018 3.42332 14.7572ZM13.2042 6.88345C18.1925 6.88345 19.8552 8.35062 20.0998 8.59515L21.3713 12.3609L13.2042 13.7302L5.03717 12.3609L6.30868 8.59515C6.60211 8.30171 8.26486 6.88345 13.2042 6.88345ZM1.71166 5.90534L2.44523 5.61191V6.24768L1.71166 5.90534ZM3.91236 18.6208H1.95618V16.6646C1.95618 16.1266 2.39632 15.6864 2.93427 15.6864C3.47222 15.6864 3.91236 16.1266 3.91236 16.6646V18.6208Z"
      fill="white"
    />
    <path
      d="M25.4306 14.2188C25.3817 14.2188 25.3328 14.2188 25.3328 14.2188L12.6176 17.1531C12.3731 17.202 12.2264 17.4465 12.2264 17.691C12.2753 17.9356 12.4709 18.1312 12.7154 18.1312C13.0088 18.1312 13.2533 18.1801 13.4979 18.3268L12.1285 18.6202C11.6884 18.6692 11.2972 18.8648 11.0037 19.256C10.4169 19.9407 10.2213 20.9188 10.5147 21.848C10.9059 23.1685 11.884 23.9999 13.0088 23.9999C13.1066 23.9999 13.2533 23.9999 13.3512 23.9509L26.1152 21.0166C27.7291 20.4787 28.4137 19.5005 28.4137 17.6421C28.3648 15.7348 27.0444 14.2188 25.4306 14.2188ZM12.9599 23.0217C12.2753 23.0217 11.6884 22.4349 11.395 21.5546C11.1994 20.9677 11.3461 20.3319 11.6884 19.8918C11.884 19.6962 12.0307 19.5984 12.2264 19.5984C12.7643 19.5984 13.0577 19.9407 13.1066 20.283C13.1555 20.4787 13.1555 20.8699 12.5687 21.0655L12.8621 21.9947C13.8402 21.6524 14.1825 20.821 14.0358 20.1363C13.9869 19.794 13.8402 19.5005 13.6446 19.256L14.2803 19.1093C14.5249 19.5005 14.6227 19.9896 14.6227 20.5765C14.6716 21.8969 13.8891 23.0217 12.9599 23.0217ZM25.8218 20.0874L15.1606 22.5327C15.454 21.9947 15.6497 21.3101 15.6497 20.5276C15.6497 19.3049 15.1606 18.3268 14.4271 17.691L25.4795 15.1969C26.5554 15.2458 27.3868 16.3217 27.3868 17.6421C27.3868 19.1093 26.9955 19.6962 25.8218 20.0874Z"
      fill="white"
    />
  </svg>
);
export const Dashboard = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.32423 0.104428H9.65759C10.8186 0.104428 11.8747 0.578666 12.6389 1.34383C13.4032 2.10808 13.8783 3.16326 13.8783 4.32515V9.6585C13.8783 10.8195 13.4041 11.8756 12.6389 12.6398C11.8747 13.4041 10.8186 13.8792 9.65759 13.8792H4.32423C3.16326 13.8792 2.10808 13.405 1.34292 12.6398C0.578666 11.8756 0.103516 10.8195 0.103516 9.6585V4.32515C0.103516 3.16418 0.577754 2.109 1.34292 1.34383C2.10808 0.578666 3.16326 0.104428 4.32423 0.104428ZM20.3425 15.9039H25.6759C26.8369 15.9039 27.892 16.3781 28.6572 17.1433C29.4215 17.9075 29.8966 18.9636 29.8966 20.1246V25.4579C29.8966 26.6189 29.4224 27.6741 28.6572 28.4392C27.892 29.2044 26.8369 29.6787 25.6759 29.6787H20.3425C19.1816 29.6787 18.1255 29.2044 17.3612 28.4392C16.597 27.675 16.1218 26.6198 16.1218 25.4579V20.1246C16.1218 18.9636 16.5961 17.9075 17.3612 17.1433C18.1255 16.379 19.1816 15.9039 20.3425 15.9039ZM25.6759 17.3001H20.3425C19.5664 17.3001 18.8605 17.6184 18.3489 18.13C17.8373 18.6417 17.519 19.3476 17.519 20.1237V25.457C17.519 26.2331 17.8373 26.9381 18.3489 27.4506C18.8605 27.9623 19.5664 28.2806 20.3425 28.2806H25.6759C26.452 28.2806 27.1579 27.9632 27.6695 27.4506C28.1812 26.9381 28.4994 26.2331 28.4994 25.457V20.1237C28.4994 19.3476 28.1821 18.6417 27.6695 18.13C27.1579 17.6184 26.452 17.3001 25.6759 17.3001ZM4.32423 15.9039H9.65759C10.8186 15.9039 11.8747 16.3781 12.6389 17.1433C13.4032 17.9075 13.8783 18.9636 13.8783 20.1246V25.4579C13.8783 26.6189 13.4041 27.6741 12.6389 28.4392C11.8747 29.2044 10.8186 29.6787 9.65759 29.6787H4.32423C3.16326 29.6787 2.10808 29.2044 1.34292 28.4392C0.578666 27.675 0.103516 26.6198 0.103516 25.4579V20.1246C0.103516 18.9636 0.577754 17.9075 1.34292 17.1433C2.10808 16.379 3.16326 15.9039 4.32423 15.9039ZM9.65759 17.3001H4.32423C3.54813 17.3001 2.84224 17.6184 2.33061 18.13C1.81898 18.6417 1.50069 19.3476 1.50069 20.1237V25.457C1.50069 26.2331 1.81807 26.9381 2.33061 27.4506C2.84224 27.9623 3.54813 28.2806 4.32423 28.2806H9.65759C10.4337 28.2806 11.1396 27.9632 11.6512 27.4506C12.1628 26.9381 12.4811 26.2331 12.4811 25.457V20.1237C12.4811 19.3476 12.1628 18.6417 11.6512 18.13C11.1396 17.6184 10.4337 17.3001 9.65759 17.3001ZM20.3425 0.103516H25.6759C26.8369 0.103516 27.892 0.577754 28.6572 1.34292C29.4215 2.10717 29.8966 3.16235 29.8966 4.32424V9.65759C29.8966 10.8186 29.4224 11.8747 28.6572 12.6389C27.892 13.4032 26.8369 13.8783 25.6759 13.8783H20.3425C19.1816 13.8783 18.1255 13.4041 17.3612 12.6389C16.597 11.8747 16.1218 10.8186 16.1218 9.65759V4.32424C16.1218 3.16326 16.5961 2.10808 17.3612 1.34292C18.1255 0.577754 19.1816 0.103516 20.3425 0.103516ZM25.6759 1.49978H20.3425C19.5664 1.49978 18.8605 1.81716 18.3489 2.3297C17.8373 2.84224 17.519 3.54721 17.519 4.32332V9.65668C17.519 10.4328 17.8373 11.1387 18.3489 11.6503C18.8605 12.1619 19.5664 12.4802 20.3425 12.4802H25.6759C26.452 12.4802 27.1579 12.1619 27.6695 11.6503C28.1812 11.1387 28.4994 10.4328 28.4994 9.65668V4.32332C28.4994 3.54721 28.1821 2.84224 27.6695 2.3297C27.1579 1.81807 26.452 1.49978 25.6759 1.49978ZM9.65759 1.49978H4.32423C3.54813 1.49978 2.84224 1.81716 2.33061 2.3297C1.81898 2.84224 1.50069 3.54721 1.50069 4.32332V9.65668C1.50069 10.4328 1.81807 11.1387 2.33061 11.6503C2.84224 12.1619 3.54813 12.4802 4.32423 12.4802H9.65759C10.4337 12.4802 11.1396 12.1619 11.6512 11.6503C12.1628 11.1387 12.4811 10.4328 12.4811 9.65668V4.32332C12.4811 3.54721 12.1628 2.84224 11.6512 2.3297C11.1396 1.81807 10.4337 1.49978 9.65759 1.49978Z"
      fill="#fff"
    />
  </svg>
);
export const ConnectPhone = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 97 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.0029 36.4058L40.4599 33.8316C40.9756 33.5269 41.2959 33.062 41.4365 32.5268C41.6396 31.7612 41.5459 30.8355 41.2138 29.9331L37.1904 19.0111C37.0068 18.6946 36.6357 18.4681 36.1865 18.3509C35.6123 18.2025 34.9599 18.2337 34.3701 18.4485C34.2139 18.5071 34.0733 18.5696 33.9522 18.64L27.9874 22.0775C22.7726 25.0853 23.4562 34.2965 27.1358 44.4605C28.671 48.6988 30.7413 53.0777 33.1592 57.2655C35.585 61.4686 38.3428 65.4569 41.2373 68.8945C48.1943 77.1601 55.8313 82.3475 61.0463 79.3355L62.9057 78.2613C62.9877 78.2105 63.0659 78.1636 63.1518 78.1206L67.0073 75.8979C67.1518 75.8081 67.2807 75.7222 67.3862 75.6323C67.8706 75.2222 68.226 74.6714 68.3823 74.1011C68.4956 73.648 68.4917 73.2066 68.3042 72.8863L68.1948 72.7301L60.8667 63.9449C60.2573 63.2144 59.5034 62.6715 58.73 62.4644C58.1948 62.3198 57.6323 62.3628 57.1167 62.6597L52.5464 65.2925C51.7261 65.7612 50.7495 65.7144 49.9956 65.2534C46.1987 62.9018 42.4175 58.4643 39.5856 53.5584L39.5075 53.4139C36.7145 48.535 34.7927 43.1049 34.6559 38.6909C34.6246 37.6987 35.1754 36.8276 36.0036 36.3979L36.0029 36.4058ZM66.0539 92.5658C65.9875 92.597 65.9211 92.6283 65.8508 92.6517C61.1477 94.5345 56.1125 95.6869 50.9248 95.9955C45.8975 96.2963 40.7338 95.808 35.6088 94.433C23.2538 91.1205 13.3158 83.277 7.10881 73.163C0.874415 63.007 -1.59039 50.554 1.04631 38.116C1.33147 36.7683 2.65571 35.909 4.00331 36.1902C5.35102 36.4753 6.21031 37.7996 5.92911 39.1472C3.56581 50.2922 5.77677 61.4562 11.3666 70.5612C16.9213 79.6081 25.8236 86.6352 36.9016 89.6042C41.5071 90.8386 46.1399 91.2761 50.6356 91.0104C55.2333 90.7369 59.702 89.7213 63.8736 88.069C64.2486 87.7995 64.5181 87.3151 64.6353 86.7448C64.7681 86.0964 64.6861 85.362 64.3306 84.6862L63.5728 83.6354L63.5494 83.6471C55.7877 88.1276 45.9044 82.1549 37.4324 72.0921C34.323 68.4007 31.3972 64.1702 28.8465 59.7601C26.2879 55.3304 24.0887 50.6781 22.452 46.1551C17.9754 33.7921 17.745 22.2411 25.5106 17.7601L31.4559 14.3226C31.8465 14.096 32.2489 13.9085 32.6551 13.7601C34.1942 13.1976 35.9207 13.1195 37.4598 13.5257C39.1239 13.9632 40.6121 14.9671 41.5106 16.5296C41.6942 16.846 41.8465 17.1624 41.9598 17.471L45.9051 28.209C46.5809 30.0449 46.7411 32.0332 46.2645 33.8106C45.7918 35.5762 44.7254 37.1192 42.9559 38.1387L39.7606 39.9785C40.1981 43.3066 41.7254 47.2558 43.8309 50.9355L43.9051 51.0566C46.0496 54.7754 48.7371 58.1269 51.4285 60.1894L54.6199 58.3417C56.3894 57.3183 58.2605 57.1659 60.0222 57.6386C61.7956 58.1152 63.4363 59.2519 64.6941 60.7597L72.0222 69.5449C72.2488 69.8183 72.448 70.1074 72.6238 70.4043C73.5222 71.9629 73.6511 73.7481 73.2019 75.4043C72.7722 76.9434 71.8425 78.4043 70.5886 79.4512C70.2331 79.7402 69.8698 79.9941 69.5066 80.2051L67.9207 81.1231L68.4558 81.8613L68.5926 82.0762C69.6473 83.9004 69.8895 85.9239 69.5262 87.7168C69.1238 89.6973 67.9753 91.4356 66.3426 92.4082L66.2879 92.4394L66.2683 92.4511L66.2332 92.4707L66.2136 92.4824L66.1785 92.5019L66.159 92.5136L66.1238 92.5293L66.1004 92.541L66.0652 92.5566L66.0539 92.5658ZM77.2339 86.1751C76.1401 87.0111 74.5737 86.8001 73.7378 85.7064C72.9019 84.6126 73.1128 83.0462 74.2066 82.2103C77.9136 79.3783 81.1754 75.9291 83.8199 71.9763C86.3668 68.1677 88.3472 63.8708 89.6011 59.1793C92.6753 47.6993 90.812 36.0583 85.3081 26.5233C79.8003 16.9881 70.6561 9.5463 59.1751 6.4723C50.5931 4.1754 41.9171 4.6364 34.1011 7.31996C26.0425 10.0856 18.8981 15.2028 13.6991 22.078C12.8671 23.1796 11.3046 23.3983 10.203 22.5662C9.10138 21.7342 8.88268 20.1717 9.7147 19.0701C15.5233 11.3904 23.4997 5.67514 32.4847 2.59314C41.2074 -0.399059 50.8867 -0.918559 60.4687 1.64783C73.2777 5.08143 83.4847 13.3818 89.6287 24.0228C95.7771 34.6708 97.8631 47.6638 94.4295 60.4678C93.035 65.6826 90.8201 70.4758 87.9647 74.7448C85.0116 79.1628 81.3709 83.0104 77.2377 86.1708L77.2339 86.1751ZM5.81593 25.1202C6.47218 23.9054 7.99173 23.4561 9.20263 24.1163C10.4174 24.7725 10.8667 26.2921 10.2065 27.503C9.70653 28.4248 9.26903 29.2921 8.90183 30.1007C8.51511 30.9483 8.14011 31.8468 7.78464 32.7882C7.30025 34.0773 5.85883 34.7257 4.57373 34.2452C3.28463 33.7608 2.63623 32.3194 3.11673 31.0343C3.49173 30.046 3.9097 29.0459 4.37063 28.0382C4.85891 26.9679 5.33938 25.9991 5.81203 25.1241L5.81593 25.1202ZM52.8589 37.8582C51.5269 37.5027 50.7378 36.1315 51.0933 34.7995C51.4488 33.4675 52.8199 32.6785 54.1519 33.034C58.1011 34.0926 61.2535 36.659 63.1558 39.9481C65.062 43.2372 65.7066 47.2528 64.648 51.2061C64.2926 52.5381 62.9214 53.3271 61.5894 52.9716C60.2574 52.6162 59.4683 51.245 59.8238 49.913C60.527 47.2841 60.1012 44.62 58.8434 42.4442C57.5895 40.2606 55.4918 38.5615 52.8629 37.8545L52.8589 37.8582ZM54.9839 29.9363C53.6519 29.5808 52.8628 28.2097 53.2183 26.8777C53.5738 25.5457 54.9449 24.7566 56.2769 25.1121C62.4136 26.7566 67.3079 30.7409 70.2569 35.8461C73.21 40.9515 74.2139 47.1861 72.5694 53.326C72.214 54.6581 70.8428 55.4471 69.5108 55.0916C68.1788 54.7362 67.3897 53.3651 67.7452 52.0331C69.0343 47.2167 68.253 42.3339 65.9444 38.3381C63.6397 34.3381 59.8038 31.2208 54.9834 29.9279L54.9839 29.9363ZM57.105 22.0144C55.773 21.6589 54.9839 20.2878 55.3394 18.9558C55.6949 17.6238 57.066 16.8347 58.398 17.1902C66.7261 19.4207 73.367 24.823 77.367 31.7522C81.3631 38.678 82.7225 47.1231 80.492 55.4511C80.1366 56.7831 78.7654 57.5723 77.4334 57.2168C76.1014 56.8613 75.3123 55.4902 75.6678 54.1581C77.5467 47.1503 76.4061 40.0452 73.0506 34.2322C69.6951 28.4236 64.117 23.8882 57.1096 22.0092L57.105 22.0144Z"
      fill="white"
    />
  </svg>
);
export const MinusIconAccordion = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="4" fill="#1776f0" fillOpacity="0.1" />
    <path
      d="M6.66406 16H25.3307"
      stroke="#1776f0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PlusIconAccordion = () => (
  <svg
    className="max-w-[20px] sm:max-w-[25px] lg:max-w-[30px] xl:max-w-[32px] w-full"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="4" fill="#1776f0" fillOpacity="0.1" />
    <path
      d="M16 6.66602V25.3327"
      stroke="#1776f0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66406 16H25.3307"
      stroke="#1776f0"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const WhitePlus = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.525 16.5C6.9 16.5 6.375 15.975 6.375 15.35V10.125H1.15C0.525 10.125 0 9.6 0 8.975V8.025C0 7.4 0.525 6.875 1.15 6.875H6.375V1.65C6.375 1.025 6.9 0.5 7.525 0.5H8.475C9.1 0.5 9.625 1.025 9.625 1.65V6.875H14.85C15.475 6.875 16 7.4 16 8.025V8.975C16 9.6 15.475 10.125 14.85 10.125H9.625V15.35C9.625 15.975 9.1 16.5 8.475 16.5H7.525Z"
      fill="white"
    />
  </svg>
);
export const BlueEducationCap = () => (
  <svg
    className="w-full h-full"
    width="36"
    height="22"
    viewBox="0 0 36 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7784 0.882222C17.5882 0.810093 17.3782 0.810093 17.188 0.882222L0 7.32837L0.969021 7.69467L17.2526 13.7755C17.4428 13.8477 17.6528 13.8477 17.843 13.7755L32.9077 8.11824C33.0696 8.05871 33.2094 7.95095 33.3081 7.80949C33.4068 7.66803 33.4597 7.4997 33.4597 7.32721C33.4597 7.15472 33.4068 6.98638 33.3081 6.84493C33.2094 6.70347 33.0696 6.5957 32.9077 6.53617L17.7784 0.882222Z"
      fill="#1776f0"
    />
    <path
      d="M7.54586 12.0988C7.48228 12.0756 7.41399 12.068 7.34686 12.0769C7.27972 12.0857 7.21572 12.1107 7.16035 12.1497C7.10497 12.1887 7.05986 12.2405 7.02888 12.3007C6.99789 12.3609 6.98196 12.4277 6.98243 12.4954V17.3459C6.98243 19.4691 11.657 21.173 17.4855 21.173C21.4298 21.173 24.8287 20.3798 26.6496 19.2303C27.5014 18.6805 28.0019 18.0132 28.0019 17.3462V12.4278C28.0019 12.3599 27.9855 12.293 27.9539 12.2329C27.9224 12.1727 27.8767 12.1211 27.8208 12.0825C27.7649 12.0439 27.7005 12.0195 27.6331 12.0113C27.5657 12.0031 27.4973 12.0115 27.4338 12.0356L17.6297 15.7045C17.5353 15.7406 17.431 15.7406 17.3366 15.7045L7.54586 12.0988ZM34.493 8.46119C34.4179 8.48539 34.3514 8.53047 34.3011 8.59116C34.2508 8.65185 34.2188 8.72563 34.2089 8.80384L33.9971 10.4851L33.2759 15.5923C33.2674 15.6519 33.2718 15.7126 33.2888 15.7703C33.3058 15.828 33.3351 15.8813 33.3746 15.9267C33.4141 15.9721 33.4629 16.0085 33.5177 16.0334C33.5724 16.0582 33.6319 16.071 33.6921 16.0708H35.5809C35.6408 16.0708 35.7001 16.0578 35.7546 16.0329C35.8091 16.008 35.8577 15.9716 35.897 15.9263C35.9363 15.881 35.9654 15.8278 35.9824 15.7703C35.9994 15.7128 36.0038 15.6524 35.9954 15.593L35.0397 8.79984C35.0317 8.73897 35.0103 8.68064 34.977 8.62907C34.9436 8.5775 34.8993 8.53397 34.8471 8.50163C34.7949 8.46929 34.7362 8.44894 34.6752 8.44206C34.6142 8.43518 34.5524 8.44194 34.4943 8.46185L34.493 8.46119Z"
      fill="#1776f0"
    />
  </svg>
);
export const UploadDocs = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="27"
    height="30"
    viewBox="0 0 27 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.72263 25.4327C2.31491 26.0584 0.782065 25.683 0 25.4327V25.6204C0 28.0292 1.9708 30 4.37956 30H19.4578C21.0219 30 22.4296 29.1554 23.1804 27.9041L6.03754 22.6486C5.5683 24.025 4.78624 24.9635 3.72263 25.4327ZM17.7372 18.4567C17.7372 15.0782 20.4588 12.3253 23.8373 12.2628V4.37956C23.8373 1.9708 21.8665 0 19.4578 0H4.37956C1.9708 0 0 1.9708 0 4.37956V24.3691C0.406674 24.5568 2.00208 25.1512 3.34724 24.5255C4.25443 24.1189 4.88008 23.243 5.22419 21.8978C5.25547 21.7727 5.34932 21.6476 5.47445 21.585C5.59958 21.5224 5.72471 21.4911 5.84984 21.5537L23.6184 26.9969C23.7748 26.5589 23.8373 26.0897 23.8373 25.5892V24.6507C20.4588 24.5881 17.7372 21.8352 17.7372 18.4567ZM3.97289 4.81752H19.8332C20.0834 4.81752 20.3024 5.03649 20.3024 5.28676C20.3024 5.53702 20.0834 5.75599 19.8332 5.75599H3.97289C3.72263 5.75599 3.50365 5.53702 3.50365 5.28676C3.50365 5.03649 3.72263 4.81752 3.97289 4.81752ZM3.97289 9.63503H19.8332C20.0834 9.63503 20.3024 9.85401 20.3024 10.1043C20.3024 10.3545 20.0834 10.5735 19.8332 10.5735H3.97289C3.72263 10.5735 3.50365 10.3545 3.50365 10.1043C3.50365 9.82273 3.72263 9.63503 3.97289 9.63503ZM16.2357 15.3598H4.00417C3.75391 15.3598 3.53493 15.1408 3.53493 14.8905C3.53493 14.6403 3.75391 14.4213 4.00417 14.4213H16.2357C16.4859 14.4213 16.7049 14.6403 16.7049 14.8905C16.7049 15.1721 16.4859 15.3598 16.2357 15.3598ZM26.3399 17.5495L23.9937 15.2033C23.9625 15.1721 23.8999 15.1408 23.8373 15.1095C23.7748 15.0782 23.7122 15.0782 23.6809 15.0782C23.6496 15.0782 23.5558 15.0782 23.5245 15.1095C23.4619 15.1408 23.3994 15.1721 23.3681 15.2033L21.0219 17.5495C20.8342 17.7372 20.8342 18.0188 21.0219 18.2065C21.2096 18.3942 21.4911 18.3942 21.6788 18.2065L23.243 16.6423V21.1783C23.243 21.4286 23.4619 21.6475 23.7122 21.6475C23.9625 21.6475 24.1814 21.4286 24.1814 21.1783V16.6423L25.7456 18.2065C25.8394 18.3003 25.9646 18.3316 26.0897 18.3316C26.2148 18.3316 26.3399 18.3003 26.4338 18.2065C26.4964 18.0188 26.4964 17.7372 26.3399 17.5495Z"
      fill={color ? color : "#1776f0"}
    />
  </svg>
);
export const Book = () => (
  <svg
    className="w-full h-full"
    width="30"
    height="26"
    viewBox="0 0 30 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.7746 21.964C25.6631 21.5787 25.6035 21.1706 25.6035 20.7499C25.6035 20.3291 25.6631 19.921 25.7759 19.5345H4.39647C4.06319 19.5345 3.75903 19.6714 3.54105 19.8906C3.31927 20.1112 3.18239 20.4153 3.18239 20.7486C3.18239 21.0806 3.32052 21.3848 3.54105 21.6053C3.76029 21.8271 4.06319 21.964 4.39647 21.964H25.7746ZM2.10375 17.0024C1.80846 16.8212 1.53472 16.6045 1.2914 16.3612C0.495537 15.5653 0 14.4652 0 13.2562C0 12.046 0.494239 10.9472 1.2914 10.1501C2.08726 9.35421 3.18731 8.85867 4.39631 8.85867H5.39241L5.32651 8.7953C4.48247 7.95126 3.96163 6.78915 3.96163 5.50654C3.96163 4.22529 4.4825 3.06188 5.32398 2.22037C6.16802 1.37633 7.33014 0.855485 8.61275 0.855485C9.89536 0.855485 11.0574 1.37636 11.8989 2.21784C12.4375 2.75646 12.8443 3.42434 13.0687 4.17076C13.4425 3.96545 13.8658 3.85266 14.303 3.85266C14.7707 3.85266 15.2243 3.98319 15.6172 4.21638L15.6578 4.24299L15.7465 4.30129C15.9607 3.5029 16.3827 2.78811 16.9504 2.22035C17.7945 1.37631 18.9566 0.855469 20.2392 0.855469C21.5217 0.855469 22.6839 1.37634 23.5254 2.21782C24.3694 3.06186 24.8902 4.22398 24.8902 5.50659C24.8902 6.7892 24.3694 7.95125 23.5279 8.79276L23.4595 8.85865H30V10.1564C29.1484 10.1564 28.374 10.5049 27.8126 11.0663C27.6238 11.2551 27.4591 11.4681 27.3108 11.7215C27.0497 12.179 26.9027 12.6999 26.9027 13.2537C26.9027 13.8062 27.0497 14.3258 27.3196 14.8023C27.459 15.0406 27.6238 15.2535 27.8126 15.4423C28.374 16.0038 29.1484 16.3523 30 16.3523V17.65C29.1484 17.65 28.374 17.9985 27.8126 18.5599C27.6238 18.7488 27.4591 18.9617 27.307 19.2228C27.0497 19.6764 26.9027 20.1948 26.9027 20.7473C26.9027 21.3024 27.0497 21.8233 27.3196 22.296C27.459 22.5355 27.6238 22.7471 27.8126 22.936C28.374 23.4974 29.1484 23.8459 30 23.8459V25.1436H4.3978C3.18877 25.1436 2.08875 24.6494 1.29289 23.8522C0.497023 23.0564 0.0014859 21.9563 0.0014859 20.7473C0.0014859 19.537 0.495725 18.4383 1.29289 17.6412C1.53748 17.3966 1.80997 17.1811 2.10523 16.9999L2.10375 17.0024ZM22.8875 5.50651C22.8875 5.86517 22.5973 6.15537 22.2386 6.15537C21.88 6.15537 21.5898 5.86516 21.5898 5.50651C21.5898 5.13267 21.439 4.79428 21.1817 4.53701C20.9282 4.29622 20.5987 4.15554 20.2388 4.15554C19.8802 4.15554 19.59 3.86533 19.59 3.50668C19.59 3.14803 19.8802 2.85782 20.2388 2.85782C20.9498 2.85782 21.5961 3.14042 22.0726 3.59791L22.1119 3.63466C22.591 4.11372 22.8888 4.77776 22.8888 5.50774L22.8875 5.50651ZM11.2625 5.50651C11.2625 5.86517 10.9722 6.15537 10.6136 6.15537C10.2549 6.15537 9.96473 5.86516 9.96473 5.50651C9.96473 5.13267 9.81392 4.79428 9.55666 4.53701C9.30319 4.29622 8.97368 4.15554 8.61379 4.15554C8.25513 4.15554 7.96493 3.86533 7.96493 3.50668C7.96493 3.14803 8.25514 2.85782 8.61379 2.85782C9.32475 2.85782 9.97109 3.14042 10.4476 3.59791L10.4869 3.63466C10.9659 4.11372 11.2637 4.77776 11.2637 5.50774L11.2625 5.50651ZM13.2597 5.69407C13.2116 6.90183 12.7008 7.99296 11.8999 8.79392L11.8327 8.85855H17.0171L16.9513 8.79519C16.2263 8.07028 15.7397 7.1084 15.6168 6.03878C15.5369 5.98302 15.4672 5.90825 15.4178 5.81573C15.3113 5.61803 15.158 5.45708 14.9654 5.33541C14.7601 5.21375 14.5358 5.15039 14.3 5.15039C14.0656 5.15039 13.84 5.21502 13.6474 5.32908C13.4953 5.42032 13.3622 5.54325 13.2571 5.69406L13.2597 5.69407ZM17.8663 7.87892C18.4721 8.48344 19.3111 8.85854 20.2387 8.85854C21.1651 8.85854 22.0041 8.48344 22.6111 7.87892C23.2169 7.27314 23.5908 6.4342 23.5908 5.50652C23.5908 4.5801 23.2157 3.74115 22.6111 3.13411C22.0054 2.52833 21.1664 2.15449 20.2387 2.15449C19.3123 2.15449 18.4734 2.52959 17.8663 3.13411C17.2618 3.73989 16.8867 4.5801 16.8867 5.50652C16.8867 6.43293 17.2618 7.27188 17.8663 7.87892ZM8.61256 8.85854C9.53897 8.85854 10.3779 8.48344 10.985 7.87892C11.5907 7.27314 11.9646 6.4342 11.9646 5.50652C11.9646 4.5801 11.5895 3.74115 10.985 3.13411C10.3792 2.52833 9.54024 2.15449 8.61256 2.15449C7.68615 2.15449 6.8472 2.52959 6.24015 3.13411C5.63564 3.73989 5.26053 4.5801 5.26053 5.50652C5.26053 6.43293 5.63564 7.27188 6.24015 7.87892C6.84593 8.48344 7.68488 8.85854 8.61256 8.85854ZM25.7743 12.0408H4.39495C4.06166 12.0408 3.7575 12.1776 3.53952 12.3969C3.319 12.6199 3.18086 12.9241 3.18086 13.2561C3.18086 13.5894 3.31773 13.8936 3.53699 14.1115C3.7575 14.3333 4.06166 14.4702 4.39495 14.4702H25.7734C25.6619 14.0849 25.6023 13.6769 25.6023 13.2561C25.6023 12.8354 25.6616 12.4273 25.7743 12.0408Z"
      fill="#1776f0"
    />
  </svg>
);
export const User = ({
  color,
  className,
}: {
  color?: string;
  className?: string;
}) => (
  <svg
    className={className || "w-full h-full"}
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9111 6.91063C21.9111 10.7277 18.8174 13.8213 15.0005 13.8213C11.1836 13.8213 8.08984 10.7275 8.08984 6.91063C8.08984 3.09374 11.1836 0 15.0005 0C18.8174 0 21.9111 3.09374 21.9111 6.91063Z"
      fill={color ? color : "#1776f0"}
    />
    <path
      d="M15 16.1797C7.55349 16.1797 0 18.9654 0 25.1797C0 27.9118 6.42857 30.0009 15 30.0009C23.5714 30.0009 30 27.9116 30 25.1797C30 18.9654 22.4465 16.1797 15 16.1797Z"
      fill={color ? color : "#1776f0"}
    />
  </svg>
);
export const DocumentUpload = () => (
  <svg
    className="w-full h-full"
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.6869 118.686C12.2423 121.606 4.1359 119.854 0 118.686V119.562C0 130.803 10.4225 140 23.161 140H102.901C111.173 140 118.618 136.058 122.588 130.219L31.9291 105.693C29.4476 112.117 25.3117 116.496 19.6869 118.686ZM93.8021 86.1314C93.8021 70.365 108.195 57.5182 126.062 57.2263V20.438C126.062 9.19708 115.64 0 102.901 0H23.161C10.4225 0 0 9.19708 0 20.438V113.723C2.15067 114.599 10.5879 117.372 17.7016 114.453C22.4993 112.555 25.808 108.467 27.6278 102.19C27.7932 101.606 28.2895 101.022 28.9513 100.73C29.613 100.438 30.2748 100.292 30.9365 100.584L124.904 125.985C125.731 123.942 126.062 121.752 126.062 119.416V115.036C108.195 114.745 93.8021 101.898 93.8021 86.1314ZM21.0103 22.4817H104.886C106.21 22.4817 107.368 23.5036 107.368 24.6715C107.368 25.8394 106.21 26.8613 104.886 26.8613H21.0103C19.6869 26.8613 18.5288 25.8394 18.5288 24.6715C18.5288 23.5036 19.6869 22.4817 21.0103 22.4817ZM21.0103 44.9635H104.886C106.21 44.9635 107.368 45.9854 107.368 47.1533C107.368 48.3212 106.21 49.3431 104.886 49.3431H21.0103C19.6869 49.3431 18.5288 48.3212 18.5288 47.1533C18.5288 45.8394 19.6869 44.9635 21.0103 44.9635ZM85.8612 71.6788H21.1758C19.8523 71.6788 18.6943 70.657 18.6943 69.4891C18.6943 68.3212 19.8523 67.2993 21.1758 67.2993H85.8612C87.1847 67.2993 88.3428 68.3212 88.3428 69.4891C88.3428 70.8029 87.1847 71.6788 85.8612 71.6788ZM139.297 81.8978L126.889 70.9489C126.724 70.8029 126.393 70.6569 126.062 70.5109C125.731 70.365 125.4 70.3649 125.235 70.3649C125.069 70.3649 124.573 70.365 124.408 70.5109C124.077 70.6569 123.746 70.8029 123.581 70.9489L111.173 81.8978C110.18 82.7737 110.18 84.0876 111.173 84.9635C112.166 85.8394 113.654 85.8394 114.647 84.9635L122.919 77.6642V98.8321C122.919 100 124.077 101.022 125.4 101.022C126.724 101.022 127.882 100 127.882 98.8321V77.6642L136.154 84.9635C136.65 85.4014 137.312 85.5475 137.974 85.5475C138.635 85.5475 139.297 85.4014 139.793 84.9635C140.124 84.0876 140.124 82.7737 139.297 81.8978Z"
      fill="#1776f0"
    />
  </svg>
);
export const SayItMike = () => (
  <svg
    className="w-full h-full"
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M88.0081 76.2508C83.2219 94.5005 67.6547 107.701 49.1149 109.701V135C49.1149 137.75 46.8479 140 44.0769 140C41.306 140 39.039 137.75 39.039 135V109.701C20.4992 107.701 4.93226 94.5005 0.145775 76.2508C-0.509162 73.5508 1.10299 70.8508 3.77312 70.1508C6.49363 69.4508 9.21413 71.1008 9.91945 73.7508C13.9498 89.2008 27.9562 100.001 44.0777 100.001C60.1993 100.001 74.2056 89.2005 78.236 73.7508C78.8406 71.5008 80.9061 70.0007 83.1732 70.0007C83.5763 70.0007 83.9793 70.0507 84.3824 70.1507C87.0524 70.8507 88.6646 73.5507 88.0097 76.2507L88.0081 76.2508ZM19.3917 70.0008C21.7091 81.4009 31.8858 90.001 44.0769 90.001C56.268 90.001 66.4455 81.4009 68.7622 70.0008H19.3917ZM54.1529 30.0006C54.1529 27.2505 56.4199 25.0006 59.1909 25.0006H69.2668C69.2668 11.2005 57.9817 0.000400546 44.0769 0.000400546C30.1721 0.000400546 18.887 11.2005 18.887 25.0006H28.963C31.734 25.0006 34.001 27.2505 34.001 30.0006C34.001 32.7507 31.734 35.0006 28.963 35.0006H18.887V45.0007H28.963C31.734 45.0007 34.001 47.2506 34.001 50.0007C34.001 52.7508 31.734 55.0007 28.963 55.0007H18.887V60.0008H69.2668V55.0007H59.1909C56.4199 55.0007 54.1529 52.7508 54.1529 50.0007C54.1529 47.2506 56.4199 45.0007 59.1909 45.0007H69.2668V35.0006H59.1909C56.4199 35.0006 54.1529 32.7507 54.1529 30.0006ZM140 10.0501L139.798 40.0503C139.798 45.5503 135.264 50.0004 129.723 50.0004H111.434L97.8317 63.5506C96.8241 64.5006 95.5647 65.0006 94.2547 65.0006C93.5998 65.0006 92.9448 64.8506 92.2898 64.6006C90.4258 63.8006 89.1663 61.9506 89.2167 59.9506L89.3679 50.0005H84.1787C81.5086 50.0005 78.9392 48.9505 77.0752 47.0504C75.1608 45.1504 74.1027 42.6503 74.1027 39.9503L74.3042 9.95014C74.3042 4.45011 78.8384 0 84.3802 0H129.923C132.594 0 135.163 1.05001 137.027 2.9501C138.941 4.85011 140 7.35005 140 10.0501ZM104.533 25.0002C104.533 22.2501 102.266 20.0002 99.4947 20.0002C96.7237 20.0002 94.4567 22.2501 94.4567 25.0002C94.4567 27.7503 96.7237 30.0003 99.4947 30.0003C102.266 30.0003 104.533 27.7503 104.533 25.0002ZM119.647 25.0002C119.647 22.2501 117.38 20.0002 114.609 20.0002C111.838 20.0002 109.571 22.2501 109.571 25.0002C109.571 27.7503 111.838 30.0003 114.609 30.0003C117.38 30.0003 119.647 27.7503 119.647 25.0002Z"
      fill="#C53DBD"
    />
  </svg>
);
export const PreferencesMenu = () => (
  <svg
    className="w-[20px] sm:w-[34px]"
    width="34"
    height="21"
    viewBox="0 0 34 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line y1="1.5" x2="29.75" y2="1.5" stroke="black" strokeWidth="2" />
    <line y1="10" x2="17" y2="10" stroke="black" strokeWidth="2" />
    <line y1="18.5" x2="19.8333" y2="18.5" stroke="black" strokeWidth="2" />
    <path
      d="M31.4923 7.87719C31.1461 7.51984 30.7351 7.23636 30.2827 7.04295C29.8304 6.84955 29.3455 6.75 28.8559 6.75C28.3662 6.75 27.8814 6.84955 27.429 7.04295C26.9767 7.23636 26.5657 7.51984 26.2195 7.87719L25.5011 8.61848L24.7827 7.87719C24.0835 7.1557 23.1352 6.75037 22.1464 6.75037C21.1575 6.75037 20.2092 7.1557 19.51 7.87719C18.8108 8.59868 18.418 9.57723 18.418 10.5976C18.418 11.6179 18.8108 12.5965 19.51 13.318L20.2284 14.0592L25.5011 19.5L30.7739 14.0592L31.4923 13.318C31.8386 12.9608 32.1133 12.5367 32.3007 12.0699C32.4882 11.6031 32.5846 11.1028 32.5846 10.5976C32.5846 10.0923 32.4882 9.59201 32.3007 9.12524C32.1133 8.65847 31.8386 8.23438 31.4923 7.87719Z"
      fill="black"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const EditPencil = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 0C20.418 0 24.4175 1.79088 27.3133 4.68665C30.2092 7.58242 32 11.583 32 16C32 20.418 30.2091 24.4175 27.3133 27.3133C24.4176 30.2092 20.417 32 16 32C11.582 32 7.58249 30.2091 4.68665 27.3133C1.79081 24.4176 0 20.417 0 16C0 11.582 1.79088 7.58249 4.68665 4.68665C7.58242 1.79081 11.583 0 16 0ZM20.4441 8.02152L23.1975 10.7749L23.9851 9.98728L21.2317 7.23387L20.4441 8.02152ZM22.262 11.7104L19.5086 8.95697L7.98115 20.4845L7.95404 23.265L10.7346 23.2379L22.262 11.7104ZM21.7008 5.82951L25.3896 9.51837C25.6472 9.77595 25.6472 10.1962 25.3896 10.4538L11.4831 24.3617C11.3407 24.5027 11.1496 24.5678 10.9652 24.5529L7.29544 24.5895C6.93075 24.5922 6.63388 24.2994 6.63114 23.9361L6.66774 20.1996C6.67045 20.0193 6.74231 19.8567 6.86025 19.7374L20.7668 5.82942C21.0244 5.57184 21.4433 5.57184 21.7022 5.82942L21.7008 5.82951Z"
      fill={color ? color : "black"}
    />
  </svg>
);
export const EditPencilWithOutCircle = ({ color }: { color?: string }) => (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6394 26.5003H2.48989C1.1172 26.5003 0 25.3842 0 24.0105V7.86098C0 6.48829 1.11717 5.37109 2.48989 5.37109H9.35659C9.96811 5.37109 10.4631 5.86608 10.4631 6.47759C10.4631 7.08911 9.96811 7.58409 9.35659 7.58409H2.48989C2.33701 7.58409 2.213 7.70811 2.213 7.86098V24.0116C2.213 24.1644 2.33701 24.2884 2.48989 24.2884H18.6405C18.7933 24.2884 18.9173 24.1644 18.9173 24.0116L18.9163 17.1449C18.9163 16.5333 19.4113 16.0384 20.0228 16.0384C20.6343 16.0384 21.1293 16.5333 21.1293 17.1449V24.0116C21.1293 25.3842 20.0121 26.5003 18.6394 26.5003Z"
      fill={color ? color : "white"}
    />
    <path
      d="M25.6105 5.37648L24.0592 6.92985C23.7674 7.22171 23.2938 7.22277 23.0019 6.92985L19.5724 3.50143C19.2806 3.20957 19.2806 2.73596 19.5724 2.44411L21.1247 0.88967C21.6443 0.37011 22.4889 0.37011 23.0084 0.88967L25.6116 3.49286C26.1312 4.01349 26.1311 4.85692 25.6105 5.37648Z"
      fill={color ? color : "white"}
    />
    <path
      d="M21.8299 9.16187L12.5472 18.4414C12.4894 18.4991 12.4167 18.5386 12.3376 18.5568L7.31499 19.7061C7.00389 19.7777 6.72487 19.4987 6.79649 19.1876L7.94574 14.165C7.96392 14.0858 8.00454 14.0131 8.0612 13.9554L17.344 4.67592C17.6358 4.38407 18.1094 4.38407 18.4013 4.67592L21.8297 8.10435C22.1216 8.3962 22.1216 8.86981 21.8297 9.16167L21.8299 9.16187Z"
      fill={color ? color : "white"}
    />
  </svg>
);
export const WarningAlert = () => (
  <svg
    className="min-h-full min-w-full"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1028_6530)">
      <path
        d="M16.0026 2.66732C8.63881 2.66732 2.66927 8.63686 2.66927 16.0007C2.66927 23.3644 8.63881 29.334 16.0026 29.334C23.3664 29.334 29.3359 23.3644 29.3359 16.0007C29.3359 8.63686 23.3664 2.66732 16.0026 2.66732Z"
        stroke="#EB9757"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 21.334V16.0007"
        stroke="#EB9757"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.666H15.9867"
        stroke="#EB9757"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1028_6530">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="matrix(-1 0 0 -1 32 32)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const BlueStart = () => (
  <svg
    className="h-full w-full"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 16C0 7.16672 7.16672 0 16 0C16 8.83328 8.83328 16 0 16Z"
      fill="#1776f0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 16C0 24.8333 7.16672 32 16 32C16 23.1667 8.83328 16 0 16Z"
      fill="#1776f0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 16C32 7.16672 24.8333 0 16 0C16 8.83328 23.1667 16 32 16Z"
      fill="#1776f0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 16C32 24.8333 24.8333 32 16 32C16 23.1667 23.1667 16 32 16Z"
      fill="#1776f0"
    />
  </svg>
);
export const BlueDownArrow = () => (
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.75L7.5 8.25L14 1.75"
      stroke="#1776f0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const StepCompleted = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="44"
    viewBox="0 0 48 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="20" r="20" fill="#EB9757" />
    <g filter="url(#filter0_d_2967_5694)">
      <path
        d="M36 11L19.5 28L12 20.2727"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2967_5694"
        x="0"
        y="3"
        width="48"
        height="41"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.921569 0 0 0 0 0.341176 0 0 0 0 0.890196 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2967_5694"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2967_5694"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export const StepInProgress = () => (
  <svg
    className="w-full h-full"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20.5"
      cy="20"
      r="12.5"
      fill="#EB9757"
      stroke="white"
      strokeWidth="9"
    />
    <circle cx="20.5" cy="20" r="18.5" stroke="#EB9757" strokeWidth="3" />
  </svg>
);
export const RejectedApplication = () => (
  <svg
    className="w-full h-full"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.9627 13.4492L18.0002 16.4102L15.0377 13.4492L13.4492 15.0377L16.4102 18.0002L13.4492 20.9627L15.0377 22.5512L18.0002 19.5902L20.9627 22.5512L22.5512 20.9627L19.5902 18.0002L22.5512 15.0377L20.9627 13.4492Z"
      fill="white"
    />
    <path
      d="M18 0C8.07437 0 0 8.07437 0 18C0 27.9256 8.07437 36 18 36C27.9256 36 36 27.9256 36 18C36 8.07437 27.9256 0 18 0ZM18 32.4C10.0604 32.4 3.6 25.9396 3.6 18C3.6 10.0604 10.0604 3.6 18 3.6C25.9396 3.6 32.4 10.0604 32.4 18C32.4 25.9396 25.9396 32.4 18 32.4Z"
      fill="white"
    />
    <path
      d="M18.0008 4.80078C10.7228 4.80078 4.80078 10.7228 4.80078 18.0008C4.80078 25.2787 10.7228 31.2008 18.0008 31.2008C25.2787 31.2008 31.2008 25.2787 31.2008 18.0008C31.2008 10.7228 25.2787 4.80078 18.0008 4.80078ZM7.20078 18.0008H6.00078C6.00078 17.5388 6.02778 17.0723 6.08028 16.6148L7.27279 16.7513C7.22479 17.1638 7.20078 17.5838 7.20078 18.0008ZM7.50078 15.4688L6.33377 15.1868C6.83477 13.1092 7.89077 11.1951 9.38926 9.65025L10.2503 10.4858C8.90177 11.8763 7.95075 13.5998 7.50074 15.4674L7.50078 15.4688ZM24.2497 20.9619L20.9632 24.2484L18.0007 21.2859L15.0382 24.2484L11.7517 20.9619L14.7142 17.9994L11.7517 15.0369L15.0382 11.7504L18.0007 14.7129L20.9632 11.7504L24.2497 15.0369L21.2872 17.9994L24.2497 20.9619Z"
      fill="white"
    />
  </svg>
);
export const UnderReview = () => (
  <svg
    className="w-full h-full"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 0V4.5C21.5804 4.5 25.0142 5.92232 27.5459 8.45406C30.0777 10.9858 31.5 14.4196 31.5 18H36C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0Z"
      fill="white"
    />
    <path
      d="M2.25 20.25C3.49264 20.25 4.5 19.2426 4.5 18C4.5 16.7574 3.49264 15.75 2.25 15.75C1.00736 15.75 0 16.7574 0 18C0 19.2426 1.00736 20.25 2.25 20.25Z"
      fill="white"
    />
    <path
      d="M6.4479 11.2507C7.06922 10.1745 6.7005 8.79842 5.62434 8.1771C4.54818 7.55578 3.1721 7.9245 2.55078 9.00066C1.92946 10.0768 2.29818 11.4529 3.37434 12.0742C4.4505 12.6955 5.82658 12.3268 6.4479 11.2507Z"
      fill="white"
    />
    <path
      d="M11.2493 6.4518C12.3255 5.83048 12.6942 4.4544 12.0729 3.37824C11.4516 2.30209 10.0755 1.93337 8.99934 2.55469C7.92318 3.17601 7.55446 4.55209 8.17578 5.62824C8.7971 6.7044 10.1732 7.07312 11.2493 6.4518Z"
      fill="white"
    />
    <path
      d="M33.444 26.9968C34.0653 25.9206 33.6966 24.5445 32.6204 23.9232C31.5443 23.3019 30.1682 23.6706 29.5469 24.7468C28.9256 25.8229 29.2943 27.199 30.3704 27.8203C31.4466 28.4416 32.8227 28.0729 33.444 26.9968Z"
      fill="white"
    />
    <path
      d="M27.0032 33.4459C28.0794 32.8246 28.4481 31.4485 27.8268 30.3724C27.2055 29.2962 25.8294 28.9275 24.7532 29.5488C23.6771 30.1701 23.3084 31.5462 23.9297 32.6224C24.551 33.6985 25.9271 34.0673 27.0032 33.4459Z"
      fill="white"
    />
    <path
      d="M18 36C19.2426 36 20.25 34.9926 20.25 33.75C20.25 32.5074 19.2426 31.5 18 31.5C16.7574 31.5 15.75 32.5074 15.75 33.75C15.75 34.9926 16.7574 36 18 36Z"
      fill="white"
    />
    <path
      d="M12.069 32.6218C12.6903 31.5456 12.3216 30.1695 11.2454 29.5482C10.1693 28.9269 8.7932 29.2956 8.17188 30.3718C7.55055 31.4479 7.91927 32.824 8.99543 33.4453C10.0716 34.0666 11.4477 33.6979 12.069 32.6218Z"
      fill="white"
    />
    <path
      d="M5.62824 27.8209C6.7044 27.1996 7.07312 25.8235 6.4518 24.7474C5.83048 23.6712 4.4544 23.3025 3.37824 23.9238C2.30209 24.5451 1.93337 25.9212 2.55469 26.9974C3.17601 28.0735 4.55209 28.4423 5.62824 27.8209Z"
      fill="white"
    />
    <path
      d="M18 9C16.22 9 14.4799 9.52784 12.9999 10.5168C11.5198 11.5057 10.3663 12.9113 9.68509 14.5558C9.0039 16.2004 8.82567 18.01 9.17294 19.7558C9.5202 21.5016 10.3774 23.1053 11.636 24.364C12.8947 25.6226 14.4984 26.4798 16.2442 26.8271C17.99 27.1743 19.7996 26.9961 21.4442 26.3149C23.0887 25.6337 24.4943 24.4802 25.4832 23.0001C26.4722 21.5201 27 19.78 27 18C27 15.6131 26.0518 13.3239 24.364 11.636C22.6761 9.94821 20.387 9 18 9ZM18 22.5C17.11 22.5 16.24 22.2361 15.4999 21.7416C14.7599 21.2471 14.1831 20.5443 13.8425 19.7221C13.502 18.8998 13.4128 17.995 13.5865 17.1221C13.7601 16.2492 14.1887 15.4474 14.818 14.818C15.4474 14.1887 16.2492 13.7601 17.1221 13.5865C17.995 13.4128 18.8998 13.5019 19.7221 13.8425C20.5443 14.1831 21.2472 14.7599 21.7416 15.4999C22.2361 16.24 22.5 17.11 22.5 18C22.5 19.1935 22.0259 20.3381 21.182 21.182C20.3381 22.0259 19.1935 22.5 18 22.5Z"
      fill="white"
    />
  </svg>
);
export const Dropped = () => (
  <svg
    className="h-full w-full"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3718 3.09963C13.1172 2.9692 13.8529 2.90115 14.5886 2.90115C15.3243 2.90115 16.06 2.9692 16.8094 3.09963C17.6285 3.24518 18.3992 2.70834 18.5429 1.92764C18.6865 1.13939 18.1508 0.38327 17.3393 0.239596C15.5146 -0.0798653 13.6666 -0.0798653 11.8381 0.239596C11.0286 0.379476 10.4909 1.13939 10.6345 1.92764C10.7782 2.71211 11.5586 3.23948 12.368 3.09963H12.3718Z"
      fill="white"
    />
    <path
      d="M4.93719 5.1331C4.6596 4.90059 4.31601 4.78906 3.97242 4.78906C3.54924 4.78906 3.128 4.96297 2.83485 5.30133C2.2331 5.99319 1.69729 6.73416 1.24501 7.49787C0.79271 8.26154 0.400598 9.08569 0.0880669 9.93637C-0.0458756 10.2993 -0.0264645 10.6963 0.142424 11.0441C0.311307 11.3919 0.614137 11.6584 0.986839 11.7889C1.74777 12.0554 2.62135 11.6433 2.89502 10.9137C3.14932 10.2218 3.46572 9.55834 3.82874 8.94401C4.19563 8.32401 4.62853 7.72856 5.11574 7.16712C5.64762 6.55656 5.56804 5.63785 4.94103 5.11992L4.93719 5.1331Z"
      fill="white"
    />
    <path
      d="M3.83264 21.0472C3.46576 20.4329 3.15128 19.7694 2.89893 19.0775C2.67957 18.4877 2.10301 18.1191 1.49351 18.1191C1.33045 18.1191 1.15574 18.1475 0.990744 18.2061C0.618032 18.3365 0.315191 18.6031 0.146328 18.9509C-0.0225554 19.3044 -0.0419706 19.6957 0.0919719 20.0586C0.404508 20.9111 0.798583 21.7334 1.24892 22.4971C1.70122 23.2608 2.237 24.0018 2.83876 24.6937C3.35121 25.2796 4.33542 25.3609 4.9411 24.8638C5.5681 24.3458 5.64771 23.431 5.11581 22.8166C4.62856 22.2551 4.19565 21.6597 3.83462 21.0397L3.83264 21.0472Z"
      fill="white"
    />
    <path
      d="M11.8409 29.7594C12.9978 29.9635 14.1568 30.0391 15.3137 29.9824C15.4321 29.9768 15.5467 29.9673 15.667 29.9579L16.0106 29.9333C16.195 29.9182 16.3775 29.8955 16.558 29.8747L16.6978 29.8558C16.8919 29.8312 17.0861 29.7972 17.2744 29.7688L17.3481 29.7537C20.8113 29.1394 23.9834 27.3625 26.2833 24.75L26.3629 24.6725C26.8598 24.1016 27.3373 23.4533 27.7586 22.7747L27.8285 22.6631C27.8634 22.6045 27.8984 22.5516 27.9333 22.493C27.9721 22.425 28.0071 22.3569 28.0478 22.2945L28.1624 22.096C28.242 21.9467 28.3215 21.7955 28.4011 21.6461C28.4458 21.563 28.4866 21.4817 28.5254 21.3985C28.5642 21.321 28.5991 21.2397 28.6399 21.1566C28.7195 20.977 28.7836 20.8466 28.8379 20.7104L28.8767 20.6084C29.6222 18.8183 30.0007 16.9298 30.0007 14.9998C30.0007 12.9583 29.5833 10.9735 28.7641 9.10571C28.7641 9.10571 28.7486 9.08114 28.735 9.05657C28.4807 8.48569 28.2128 7.96776 27.9352 7.49894C27.4829 6.73527 26.9471 5.99425 26.3454 5.3024C25.8135 4.69184 24.874 4.61432 24.243 5.13228C23.9402 5.38368 23.7558 5.73151 23.7208 6.11903C23.6859 6.50654 23.8101 6.88269 24.0683 7.17948C24.5556 7.74092 24.9885 8.33632 25.3495 8.95637C25.7164 9.57069 26.0309 10.2342 26.2832 10.926C26.7705 12.2511 27.0131 13.6159 27.0131 15.0053C27.0131 16.3947 26.7705 17.7689 26.2872 19.0751L26.2716 19.1129C26.1571 19.4229 26.029 19.7235 25.8795 20.043L25.8407 20.1356C25.7223 20.387 25.5825 20.6479 25.4136 20.939C25.369 21.0108 25.3282 21.0883 25.2835 21.162C25.1399 21.3983 24.9846 21.6308 24.8215 21.8633C24.7672 21.9352 24.7128 22.0127 24.6585 22.0864C24.4954 22.3094 24.3207 22.5325 24.1363 22.7442C22.2669 24.9313 19.6579 26.4076 16.8003 26.9104C16.4431 26.9728 16.0743 27.022 15.7113 27.056H15.6608C14.5718 27.1524 13.4634 27.1051 12.3666 26.9104C11.5571 26.7706 10.7807 27.2923 10.6331 28.0824C10.5632 28.4643 10.6486 28.8461 10.8758 29.1656C11.1048 29.485 11.4426 29.6987 11.8347 29.7648L11.8409 29.7594Z"
      fill="white"
    />
    <path
      d="M9.55983 19.8968C10.1208 20.4431 11.105 20.4431 11.666 19.8968L14.5876 17.0519L17.5091 19.8968C18.0701 20.4431 19.0543 20.4431 19.6153 19.8968C20.1763 19.3505 20.1977 18.411 19.6153 17.8458L16.6938 15.0009L19.6153 12.156C20.1977 11.5889 20.1977 10.6703 19.6153 10.1051C19.0329 9.53796 18.0701 9.55877 17.5091 10.1051L14.5876 12.9499L11.666 10.1051C11.105 9.55877 10.1208 9.55877 9.55983 10.1051C8.99882 10.6513 8.97745 11.5908 9.55983 12.156L12.4813 15.0009L9.55983 17.8458C8.97745 18.4129 8.97745 19.3316 9.55983 19.8968Z"
      fill="white"
    />
  </svg>
);
export const WhiteProgress = () => (
  <svg
    className="h-full w-full"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0218 10.4636V7.83534C10.2894 7.82867 6.06318 10.8503 5.1707 15.1736C4.28759 19.4452 6.9238 23.6601 11.4387 25.1967C12.7306 25.6367 13.3793 26.93 12.89 28.09C12.455 29.12 11.2644 29.695 10.1 29.5017C9.95375 29.4783 9.8075 29.4417 9.665 29.3933C2.88698 27.09 -1.07108 20.7651 0.254523 14.3586C1.59325 7.877 7.92878 3.36207 15.0218 3.3704V1.1921C15.0218 0.14712 16.5012 -0.391205 17.3974 0.330451L23.161 4.96538C23.7442 5.43537 23.7442 6.22203 23.161 6.69202L17.3974 11.3269C16.5012 12.0469 15.0218 11.5103 15.0218 10.4636ZM18.3274 25.2684C17.9561 25.3884 17.5736 25.4884 17.1874 25.5651C15.8393 25.8334 14.9862 27.0317 15.2843 28.2417C15.5074 29.1483 16.3137 29.8033 17.2699 29.9633C17.5905 30.015 17.928 30.0133 18.2655 29.9467C18.8542 29.8283 19.4336 29.6783 19.9998 29.4983C21.2992 29.0833 21.9817 27.7984 21.5204 26.6317C21.0573 25.4634 19.6249 24.8534 18.3274 25.2684ZM23.2979 21.8168C23.191 21.9601 23.0804 22.1001 22.9623 22.2368C22.1204 23.2184 22.3229 24.6267 23.4179 25.3834C23.7442 25.6067 24.1079 25.7484 24.4867 25.8101C25.3791 25.9584 26.3316 25.6634 26.926 24.9717C27.1041 24.7617 27.2785 24.5451 27.4454 24.3234C28.216 23.2951 27.9141 21.9018 26.7704 21.2085C25.6248 20.5201 24.0704 20.7885 23.2979 21.8168ZM27.5654 14.9336C26.1854 14.9002 25.0341 15.9219 24.9985 17.1619C24.9648 18.2768 25.846 19.2068 27.031 19.4035C27.1585 19.4252 27.2916 19.4385 27.4247 19.4402C28.8028 19.4768 29.9541 18.4818 29.9972 17.2435C29.9972 17.2402 29.9991 17.1952 29.9991 17.1919C30.0366 15.9519 28.936 14.9552 27.5654 14.9336Z"
      fill="white"
    />
  </svg>
);

export const Google = () => {
  return (
    <svg
      className="w-full h-full"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_6892)">
        <path
          d="M32.4383 16.3686C32.4383 15.2809 32.3501 14.1874 32.162 13.1174H17.0703V19.2787H25.7126C25.3539 21.2659 24.2016 23.0237 22.5143 24.1408V28.1386H27.6703C30.6981 25.3519 32.4383 21.2365 32.4383 16.3686Z"
          fill="#4285F4"
        />
        <path
          d="M17.0702 32.0012C21.3855 32.0012 25.0247 30.5843 27.6761 28.1386L22.5202 24.1408C21.0856 25.1167 19.2337 25.6694 17.0761 25.6694C12.9019 25.6694 9.3627 22.8533 8.09281 19.0671H2.77222V23.1884C5.48837 28.5913 11.0206 32.0012 17.0702 32.0012V32.0012Z"
          fill="#34A853"
        />
        <path
          d="M8.08697 19.0671C7.41675 17.08 7.41675 14.9282 8.08697 12.9411V8.81982H2.77225C0.502917 13.3409 0.502917 18.6673 2.77225 23.1884L8.08697 19.0671V19.0671Z"
          fill="#FBBC04"
        />
        <path
          d="M17.0702 6.33288C19.3513 6.29761 21.556 7.15596 23.208 8.73156L27.7761 4.16349C24.8836 1.44734 21.0445 -0.0459547 17.0702 0.00107822C11.0206 0.00107822 5.48837 3.41096 2.77222 8.81974L8.08693 12.941C9.35094 9.14897 12.896 6.33288 17.0702 6.33288V6.33288Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_6892">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.750244)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Apple = () => {
  return (
    <svg
      className="w-full h-full"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.0408 22.8598C27.5972 23.8846 27.0721 24.828 26.4637 25.6953C25.6345 26.8776 24.9555 27.696 24.4322 28.1505C23.621 28.8965 22.7519 29.2786 21.8213 29.3003C21.1531 29.3003 20.3474 29.1102 19.4095 28.7245C18.4685 28.3406 17.6037 28.1505 16.813 28.1505C15.9838 28.1505 15.0944 28.3406 14.1431 28.7245C13.1903 29.1102 12.4228 29.3111 11.8359 29.3311C10.9435 29.3691 10.0539 28.9762 9.16597 28.1505C8.59924 27.6562 7.89037 26.8088 7.04118 25.6084C6.13006 24.3264 5.381 22.8399 4.79417 21.1451C4.1657 19.3146 3.85065 17.542 3.85065 15.8258C3.85065 13.86 4.27542 12.1645 5.12624 10.7437C5.79491 9.60246 6.68448 8.70221 7.79784 8.04132C8.91121 7.38043 10.1142 7.04366 11.4097 7.02211C12.1186 7.02211 13.0482 7.24138 14.2034 7.67231C15.3553 8.10469 16.0949 8.32396 16.4192 8.32396C16.6617 8.32396 17.4833 8.06757 18.8763 7.55643C20.1935 7.0824 21.3052 6.88613 22.216 6.96344C24.6839 7.16261 26.538 8.13547 27.771 9.88818C25.5639 11.2255 24.472 13.0986 24.4938 15.5015C24.5137 17.3732 25.1927 18.9307 26.5271 20.1674C27.1319 20.7414 27.8072 21.185 28.5587 21.5C28.3957 21.9726 28.2237 22.4253 28.0408 22.8598ZM22.3808 0.587078C22.3808 2.05408 21.8448 3.42381 20.7765 4.69163C19.4873 6.19881 17.928 7.06973 16.2371 6.9323C16.2155 6.75631 16.203 6.57108 16.203 6.37643C16.203 4.96811 16.8161 3.46093 17.9048 2.22861C18.4484 1.60466 19.1397 1.08586 19.978 0.671996C20.8145 0.264311 21.6058 0.0388529 22.35 0.000244141C22.3717 0.196359 22.3808 0.392487 22.3808 0.587059V0.587078Z"
        fill="black"
      />
    </svg>
  );
};
export const Home = () => {
  return (
    <svg
      className="w-[32px] h-[32px]"
      width="32"
      height="29"
      viewBox="0 0 32 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.55492 15.1493H0.776024C0.337402 15.1493 0 14.8119 0 14.4071C0 14.1709 0.10122 13.9684 0.269921 13.7997L15.4193 0.202441C15.7229 -0.0674803 16.1615 -0.0674803 16.4315 0.202441L31.7495 13.8335C32.0532 14.1034 32.0869 14.5758 31.817 14.9132C31.682 15.0819 31.4458 15.1831 31.2434 15.1831H27.397V28.2068C27.397 28.6117 27.0596 28.9491 26.6547 28.9491H20.2441C19.8055 28.9491 19.4681 28.6117 19.4681 28.2068V19.8055H12.1802V28.173C12.1802 28.5779 11.8428 28.9153 11.4042 28.9153H5.33095C4.89232 28.9153 4.55492 28.5779 4.55492 28.173V15.1493Z"
        fill="black"
      />
    </svg>
  );
};
export const EducationLoan = () => {
  return (
    <svg
      className="w-[32px] h-[32px]"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1052 19.3019C18.8309 20.8791 16.6294 23.605 16.768 27.2191L16.7694 27.2205C16.8322 28.6148 17.2166 29.9763 17.888 31.1992C18.1566 31.6935 18.6723 32.0006 19.2337 32.0006H29.527C30.0885 32.0006 30.6056 31.6935 30.8728 31.1992C31.5456 29.9763 31.9285 28.6149 31.9928 27.2205C32.1328 23.6047 29.9299 20.8803 28.6556 19.3033V19.3019C27.9484 18.4262 27.1541 17.6233 26.2855 16.9047H26.9041C27.6141 16.9047 28.1898 16.329 28.1898 15.6189C28.1898 14.9089 27.6141 14.3332 26.9041 14.3332H26.1298C27.5641 12.9603 28.3241 11.5132 27.9098 10.6259C27.7798 10.343 27.5513 10.1144 27.2684 9.98443C26.4455 9.64442 25.4841 10.5016 25.3426 10.6259C24.8012 11.133 24.4583 11.8159 24.3755 12.5531C24.2983 11.8173 23.9583 11.133 23.4183 10.6259C23.284 10.5059 22.3183 9.64299 21.4926 9.98443C21.2097 10.1144 20.9826 10.343 20.8511 10.6259C20.4368 11.513 21.1968 12.9602 22.6312 14.3332H21.8569C21.1468 14.3332 20.5711 14.9089 20.5711 15.6189C20.5711 16.329 21.1468 16.9047 21.8569 16.9047H22.4754C21.6083 17.6233 20.8138 18.4262 20.1052 19.3019ZM21.8281 23.1906C21.8838 22.1234 22.6638 21.2348 23.7138 21.0406V20.572C23.7138 20.2034 24.0124 19.9049 24.381 19.9049C24.7481 19.9049 25.0467 20.2034 25.0467 20.572V21.0406C26.0981 21.2349 26.8782 22.1234 26.9324 23.1906C26.9324 23.5592 26.6339 23.8578 26.2653 23.8578C25.8981 23.8578 25.5996 23.5592 25.5996 23.1906C25.5724 22.8563 25.3581 22.5649 25.0467 22.4392V24.1835C26.1267 24.3264 26.9324 25.2449 26.9324 26.3335C26.9324 27.4222 26.1267 28.3422 25.0467 28.485V28.9536C25.0467 29.3207 24.7481 29.6193 24.381 29.6193C24.0124 29.6193 23.7138 29.3207 23.7138 28.9536V28.485C22.6638 28.2907 21.8838 27.4007 21.8281 26.3335C21.8281 25.9664 22.1267 25.6678 22.4952 25.6678C22.8638 25.6678 23.1624 25.9664 23.1624 26.3335C23.1881 26.6693 23.4024 26.9593 23.7138 27.085V25.3421C22.6638 25.1478 21.8838 24.2578 21.8281 23.1906Z"
        fill="black"
      />
      <path
        d="M0.761483 30.4765H16.3047C15.9018 29.4508 15.6733 28.3637 15.6275 27.2622C15.4747 23.2235 17.9062 20.2063 19.2162 18.5836C19.5434 18.1792 19.8948 17.8064 20.2519 17.4335C19.6876 16.9378 19.3848 16.2078 19.4348 15.4592C19.4833 14.7092 19.879 14.0249 20.5034 13.6077C19.6276 12.3277 19.3605 11.1163 19.8176 10.1405V10.1419C20.0691 9.59906 20.5105 9.16761 21.0591 8.93048C21.3277 8.81619 21.6148 8.76047 21.9048 8.7619C22.7605 8.8219 23.5677 9.18047 24.1835 9.7762C24.252 9.83763 24.3206 9.9062 24.382 9.9662V6.85755H19.0476C18.6276 6.85613 18.2876 6.51612 18.2862 6.09612V0.000244141H0.761436C0.341439 0.00167266 0.00142632 0.34168 0 0.76168V29.7153C0.00142851 30.1353 0.341483 30.4751 0.761483 30.4765ZM5.33302 4.19019H11.4289C11.8503 4.19019 12.1903 4.53163 12.1903 4.95305C12.1903 5.37305 11.8503 5.71449 11.4289 5.71449H5.33302C4.91303 5.71449 4.57159 5.37305 4.57159 4.95305C4.57159 4.53163 4.91302 4.19019 5.33302 4.19019ZM5.33302 7.61885H16.0004C16.4219 7.61885 16.7619 7.96028 16.7619 8.38171C16.7619 8.8017 16.4219 9.14314 16.0004 9.14314H5.33302C4.91303 9.14314 4.57159 8.80171 4.57159 8.38171C4.57159 7.96028 4.91302 7.61885 5.33302 7.61885ZM5.33302 11.0475H16.0004C16.4219 11.0475 16.7619 11.3889 16.7619 11.8104C16.7619 12.2304 16.4219 12.5718 16.0004 12.5718H5.33302C4.91303 12.5718 4.57159 12.2304 4.57159 11.8104C4.57159 11.3889 4.91302 11.0475 5.33302 11.0475ZM5.33302 14.4762H16.0004C16.4219 14.4762 16.7619 14.8176 16.7619 15.239C16.7619 15.659 16.4219 16.0005 16.0004 16.0005H5.33302C4.91303 16.0005 4.57159 15.659 4.57159 15.239C4.57159 14.8176 4.91302 14.4762 5.33302 14.4762ZM5.33302 25.1436H9.90456C10.326 25.1436 10.6674 25.485 10.6674 25.905C10.6674 26.3264 10.326 26.6679 9.90456 26.6679H5.33302C4.91303 26.6679 4.57159 26.3264 4.57159 25.905C4.57159 25.485 4.91302 25.1436 5.33302 25.1436Z"
        fill="black"
      />
    </svg>
  );
};
export const Travel = () => {
  return (
    <svg
      className="w-[24px] h-[32px]"
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.0162 24.8073C24.1219 21.53 21.8193 13.1063 21.1508 10.7775C21.124 10.6818 21.1431 10.581 21.2005 10.5032L25.973 5.82513C26.0317 5.76645 26.0904 5.70521 26.1465 5.64398C26.3187 5.459 26.4769 5.25998 26.6159 5.04696C27.0816 4.33639 27.8126 2.94716 27.523 1.58856C27.449 1.24413 27.1798 0.972385 26.8354 0.895852C26.3698 0.792522 25.8977 0.810386 25.4525 0.895851C24.6003 1.05914 23.8375 1.47504 23.368 1.77608C23.1014 1.9483 22.8539 2.14731 22.6319 2.37184L17.8901 7.1315C17.8085 7.19784 17.7 7.22208 17.598 7.19146C15.2724 6.50385 6.86825 4.13371 3.59855 3.21406C2.78592 2.9857 1.91465 3.21152 1.31636 3.80471L0.832853 4.28311C0.823923 4.29204 0.816268 4.2997 0.80989 4.30863L0.790755 4.32776C0.675943 4.44257 0.700179 4.63521 0.839233 4.71813L12.8997 11.8187C12.9916 11.8722 13.0145 11.9896 12.9584 12.0738L10.7323 14.282C10.3024 14.7094 9.88649 15.1508 9.48847 15.6075C8.97437 16.193 8.48832 16.8015 8.03037 17.4304L6.8631 19.034C6.858 19.0417 6.85162 19.0506 6.84524 19.057C6.75084 19.1565 6.6271 19.2215 6.49442 19.247C6.39747 19.2649 6.29669 19.2611 6.19846 19.2317L2.40584 18.1538C2.14178 18.0785 1.87005 18.0696 1.60981 18.1181C1.27558 18.1819 0.961767 18.3426 0.711707 18.5901L0.266481 19.0328C0.258827 19.0404 0.251172 19.0506 0.244793 19.0596L0.226934 19.0774C0.161873 19.1425 0.177183 19.2496 0.256277 19.2956L4.8144 21.8457C4.91773 21.9032 4.97258 22.0167 4.95472 22.1341L4.76975 23.3472C4.75827 23.4225 4.82333 23.4876 4.89859 23.4761L6.11304 23.3C6.22913 23.2834 6.34266 23.3408 6.3988 23.4429L8.91306 28.0213C8.95771 28.1016 9.06486 28.1169 9.12993 28.0519L9.57515 27.6092C9.59939 27.585 9.62108 27.5607 9.64404 27.5352C10.0676 27.0964 10.2283 26.4662 10.0663 25.8755L9.01894 22.0752C8.96026 21.8635 9.01383 21.6415 9.15034 21.4795C9.1733 21.4565 9.19881 21.4361 9.22688 21.4157L10.8406 20.2612C11.9518 19.4664 12.9966 18.5849 13.9661 17.6231L16.2764 15.3306C16.3619 15.2758 16.4779 15.3 16.5315 15.3919L23.535 27.5083C23.6166 27.6486 23.8092 27.6754 23.924 27.5606L24.4076 27.0822C25.0058 26.489 25.2393 25.6177 25.0161 24.805L25.0162 24.8073Z"
        fill="black"
      />
    </svg>
  );
};
export const FeeTransfer = () => {
  return (
    <svg
      className="min-w-[32px] h-[32px]"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8263 17.8022C15.8638 17.7967 15.9028 17.7939 15.9417 17.7925V17.7911C16.0363 17.773 16.124 17.7257 16.1922 17.6575C16.2854 17.5657 16.3396 17.4419 16.3396 17.3111C16.341 17.2151 16.3146 17.1205 16.2617 17.0384C16.2116 16.9591 16.1379 16.8951 16.0516 16.8561C16.0475 16.8561 16.0516 16.8561 16.035 16.8534C16.0294 16.852 16.0238 16.8506 16.0183 16.8492C15.2767 16.8102 14.5713 16.5167 14.0203 16.0186C13.4833 15.5163 13.1536 14.8318 13.0951 14.0986C13.0923 14.0763 13.0909 14.0541 13.0895 14.0318H13.0882C12.9977 12.8172 13.6294 11.6624 14.702 11.0851V10.9724C14.7006 10.2628 15.2697 9.6854 15.9779 9.67567C16.6874 9.66593 17.2718 10.2294 17.2871 10.939C17.582 11.0545 17.8561 11.2145 18.101 11.4148C18.3779 11.6277 18.5546 11.9435 18.5949 12.2899C18.6339 12.6363 18.5309 12.9842 18.3111 13.2541C18.0899 13.524 17.7699 13.6937 17.422 13.7229C17.0756 13.7535 16.7306 13.6422 16.4662 13.4141C16.4175 13.3723 16.3619 13.3417 16.302 13.3222C16.2394 13.3042 16.1754 13.2986 16.1114 13.3055C15.982 13.3167 15.8624 13.3779 15.7789 13.4767C15.6954 13.5782 15.6551 13.7076 15.6662 13.8398C15.6676 13.9455 15.7066 14.0485 15.7775 14.1292C15.8986 14.221 16.0474 14.2711 16.1991 14.2711C16.5191 14.2906 16.8321 14.3713 17.1215 14.5104C17.6599 14.7567 18.1149 15.1532 18.4335 15.6513C19.2098 16.8701 19.0331 18.4631 18.0105 19.483C17.7977 19.6958 17.5528 19.8753 17.2871 20.0172V20.1285C17.2871 20.8367 16.7166 21.4113 16.0085 21.4197C15.3017 21.4266 14.7188 20.8645 14.702 20.1564L14.677 20.1466C14.3097 19.9964 13.9744 19.7751 13.692 19.4969C13.4485 19.2562 13.3094 18.9292 13.3066 18.5884C13.3052 18.2461 13.4388 17.9178 13.6781 17.6743C14.1775 17.1664 14.9942 17.1609 15.5021 17.6604C15.5466 17.7049 15.6009 17.7411 15.6593 17.7647C15.7136 17.787 15.7692 17.7981 15.8276 17.8009L15.8263 17.8022ZM20.9769 10.5744C19.4297 9.02726 17.2509 8.28709 15.0804 8.57232C12.9114 8.85753 10.9969 10.1361 9.90345 12.0311C8.80851 13.926 8.65824 16.2218 9.49442 18.2445C10.332 20.2661 12.0628 21.784 14.1763 22.3501C16.2899 22.9163 18.5476 22.467 20.284 21.1355C22.0189 19.8026 23.0374 17.7393 23.0374 15.5507C23.0402 13.6836 22.2986 11.8928 20.9768 10.5739L20.9769 10.5744ZM16.0001 5.92741C13.0074 5.92741 10.1859 7.31731 8.36336 9.69074C6.54075 12.0629 5.92578 15.1487 6.69936 18.0398C7.47293 20.9295 9.54735 23.2962 12.3105 24.4413C15.075 25.5877 18.2151 25.3832 20.8059 23.8875C23.3979 22.3919 25.147 19.7762 25.5377 16.81C25.9284 13.8438 24.9186 10.8637 22.8038 8.74734C21.0007 6.94005 18.5531 5.92602 16.0001 5.92741ZM29.4983 6.75523L29.2562 7.41611C27.6215 4.75314 25.2215 2.6441 22.3707 1.36401C19.5199 0.0839996 16.3492 -0.306936 13.273 0.24125C12.9335 0.298295 12.6302 0.488901 12.4326 0.769953C12.2337 1.051 12.1557 1.4002 12.217 1.73971C12.2782 2.07779 12.4716 2.37832 12.7554 2.57308C13.0392 2.76783 13.3898 2.8416 13.7279 2.77621C16.2197 2.33655 18.7866 2.63291 21.1128 3.63045C23.439 4.628 25.4232 6.28227 26.8226 8.39142L26.3426 8.21611C26.0212 8.09785 25.6664 8.11177 25.3562 8.25646C25.0445 8.39977 24.8038 8.66132 24.6856 8.98273C24.4393 9.65195 24.783 10.3949 25.4522 10.6398L28.9708 11.9323H28.9722C29.6414 12.1771 30.3829 11.8335 30.6278 11.1643L31.9203 7.64431C32.1666 6.97509 31.8229 6.23215 31.1537 5.98728C30.4845 5.74102 29.743 6.08468 29.4967 6.75387L29.4983 6.75523ZM2.50146 24.3455L2.74355 23.6847V23.6861C4.37831 26.349 6.77828 28.4581 9.62909 29.7382C12.4799 31.0167 15.6506 31.4091 18.7268 30.8609C19.4266 30.7343 19.8927 30.0651 19.7675 29.3653C19.6409 28.6655 18.9717 28.1994 18.2719 28.326C15.7801 28.7656 13.2132 28.4693 10.887 27.4717C8.56082 26.4742 6.57658 24.8199 5.17718 22.7107L5.65719 22.8861C6.3264 23.1309 7.06796 22.7873 7.31282 22.1181C7.55909 21.4489 7.21543 20.7073 6.54484 20.4624L3.02625 19.1699C2.35703 18.9251 1.61548 19.2687 1.37061 19.9379L0.0794841 23.4579C-0.038776 23.7793 -0.024864 24.1354 0.119831 24.4457C0.263134 24.756 0.524693 24.9967 0.846104 25.1149C1.51532 25.3612 2.25687 25.0175 2.50313 24.3483L2.50146 24.3455Z"
        fill="black"
      />
    </svg>
  );
};

export const Document = () => {
  return (
    <svg
      className="w-full h-full"
      width="32"
      height="38"
      viewBox="0 0 32 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.8182 11.6364H20.3636V0H0.727273C0.363636 0 0 0.363636 0 0.727273V37.0909C0 37.4545 0.363636 37.8182 0.727273 37.8182H31.2727C31.6364 37.8182 32 37.4545 32 37.0909V11.6364H21.8182ZM7.27273 21.8182H21.8182V23.2727H7.27273V21.8182ZM24.7273 29.0909H7.27273V27.6364H24.7273V29.0909ZM24.7273 17.4545H7.27273V16H24.7273V17.4545Z"
        fill="black"
      />
      <path
        d="M21.8164 0.363636V9.74545C21.8164 10.0364 22.0346 10.1818 22.2528 10.1818H31.6346C31.78 10.1818 31.8528 10.1091 31.9982 10.0364L21.9619 0C21.8891 0.0727273 21.8164 0.218182 21.8164 0.363636Z"
        fill="black"
      />
    </svg>
  );
};

export const VisaProcessing = () => {
  return (
    <svg
      className="h-full w-full"
      width="32"
      height="37"
      viewBox="0 0 32 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6017 5.54907C9.10906 5.84519 7.80661 6.68055 6.90625 7.841C7.52015 8.16841 8.29775 8.51992 9.1885 8.78228C9.56888 7.43892 10.1419 6.31465 10.6017 5.54907Z"
        fill="black"
      />
      <path
        d="M13.2658 9.0565C12.8662 7.68423 12.2451 6.55516 11.8165 5.8811C11.3904 6.55522 10.7669 7.6843 10.3672 9.0541C11.3398 9.22022 12.2907 9.21781 13.2657 9.0541L13.2658 9.0565Z"
        fill="black"
      />
      <path
        d="M6.90625 15.4342C7.80661 16.5946 9.10906 17.43 10.6017 17.7261C10.1419 16.9581 9.56888 15.8338 9.1885 14.4905C8.29775 14.7529 7.52015 15.1044 6.90625 15.4318V15.4342Z"
        fill="black"
      />
      <path
        d="M10.0984 10.2319C10.0238 10.6845 9.98047 11.1564 9.98047 11.6379C9.98047 12.1193 10.0238 12.5888 10.0984 13.0414C11.2468 12.8391 12.3807 12.8391 13.5339 13.0414C13.6085 12.5888 13.6518 12.1193 13.6518 11.6379C13.6518 11.1564 13.6085 10.6869 13.5339 10.2343C12.9537 10.3354 12.3783 10.3884 11.8149 10.3884C11.2516 10.3884 10.6762 10.3354 10.0984 10.2343L10.0984 10.2319Z"
        fill="black"
      />
      <path
        d="M16.7228 7.84124C15.8224 6.68086 14.52 5.84545 13.0273 5.54932C13.4872 6.3173 14.0602 7.44157 14.4405 8.78493C15.3265 8.52252 16.1065 8.16862 16.7228 7.84124Z"
        fill="black"
      />
      <path
        d="M8.77367 11.6376C8.77367 11.0574 8.82904 10.4964 8.92053 9.95714C7.87089 9.65621 6.96326 9.23729 6.2627 8.85938C5.8414 9.69478 5.60547 10.6385 5.60547 11.6376C5.60547 12.6367 5.84381 13.5779 6.2627 14.4134C6.96326 14.0354 7.87089 13.6165 8.92053 13.3156C8.82904 12.7787 8.77367 12.2178 8.77367 11.6376Z"
        fill="black"
      />
      <path
        d="M19.0575 23.3665C19.3271 22.7599 19.8399 22.2928 20.4683 22.081L21.3566 21.7825C22.1487 21.5176 23.0009 21.6838 23.6268 22.2062V0H5.08213C2.27984 0 0 2.27984 0 5.08454V29.0361C0 31.8384 2.27984 34.1182 5.08213 34.1182H22.9119L19.0528 25.2779C18.788 24.6712 18.7904 23.9731 19.0576 23.3688L19.0575 23.3665ZM16.7006 23.7758H6.92656C6.59433 23.7758 6.3247 23.5062 6.3247 23.174C6.3247 22.8417 6.59433 22.5721 6.92656 22.5721H16.7006C17.0328 22.5721 17.3024 22.8417 17.3024 23.174C17.3024 23.5062 17.0328 23.7758 16.7006 23.7758ZM18.1114 15.545L18.109 15.5498C16.7993 17.6516 14.4689 19.0527 11.8158 19.0527C9.16283 19.0527 6.85648 17.666 5.54183 15.5812C5.53702 15.5739 5.5322 15.5643 5.52498 15.5571C4.81481 14.4183 4.40071 13.0774 4.40071 11.6401C4.40071 10.2029 4.80998 8.87156 5.51537 7.73767C5.51537 7.73767 5.51537 7.73286 5.51778 7.73045C5.51778 7.72564 5.52259 7.72323 5.525 7.72082C6.83705 5.62396 9.16503 4.22519 11.8132 4.22519C14.4613 4.22519 16.7918 5.6239 18.1014 7.72082C18.1014 7.72564 18.1062 7.72804 18.1086 7.73045C18.1086 7.73045 18.1086 7.73527 18.111 7.73767C18.8164 8.87156 19.2257 10.2077 19.2257 11.6401C19.2257 13.0726 18.8168 14.4087 18.1114 15.545Z"
        fill="black"
      />
      <path
        d="M30.3532 16.8521L24.8329 13.5684V23.5519L26.8792 25.916C27.0959 26.1664 27.0694 26.5467 26.819 26.7658C26.5687 26.9825 26.1883 26.956 25.9692 26.7057L22.996 23.2702C22.6854 22.9115 22.1943 22.7767 21.7417 22.9284L20.8534 23.2269C20.5404 23.3328 20.2924 23.5567 20.16 23.86C20.0252 24.1634 20.0252 24.4956 20.1576 24.7989L25.2518 36.4681H31.9997V19.7507C31.9997 18.5687 31.369 17.4588 30.353 16.8546L30.3532 16.8521Z"
        fill="black"
      />
      <path
        d="M14.707 9.96193C14.7985 10.4988 14.8539 11.0597 14.8539 11.6399C14.8539 12.2201 14.7985 12.7787 14.707 13.3156C15.7543 13.6165 16.6643 14.0354 17.3649 14.4158C17.7838 13.5804 18.0221 12.6367 18.0221 11.64C18.0221 10.6433 17.7837 9.69962 17.3649 8.86182C16.6619 9.2422 15.7543 9.66098 14.707 9.96193Z"
        fill="black"
      />
      <path
        d="M10.3672 14.218C10.7668 15.5879 11.3879 16.7169 11.8165 17.391C12.2426 16.7169 12.8661 15.5878 13.2658 14.218C12.2908 14.0543 11.3398 14.0543 10.3697 14.218H10.3672Z"
        fill="black"
      />
      <path
        d="M13.0258 17.7285C14.5209 17.4324 15.8209 16.5971 16.7213 15.4366C16.1074 15.1092 15.3274 14.7553 14.439 14.4929C14.0587 15.8363 13.4857 16.963 13.0234 17.7309L13.0258 17.7285Z"
        fill="black"
      />
    </svg>
  );
};

export const InterviewPreparation = () => {
  return (
    <svg
      className="w-full h-full"
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37586 13.1373C9.65545 13.1373 11.512 15.0122 11.512 17.3178C11.512 19.6218 9.65695 21.4983 7.37586 21.4983C5.09627 21.4983 3.23974 19.6234 3.23974 17.3178C3.23974 15.0137 5.09477 13.1373 7.37586 13.1373ZM14.1703 17.8224V15.5327C14.1703 15.4223 14.0816 15.331 13.9707 15.331H13.478V18.0225H13.9707C14.08 18.0225 14.1703 17.9328 14.1703 17.8208V17.8224ZM10.1292 21.5146L10.0753 21.5034L10.0294 21.5338C9.23413 22.0462 8.31688 22.3184 7.3759 22.3184C6.46818 22.3184 5.57948 22.0654 4.80485 21.5883L4.75733 21.5595L4.70347 21.5723C2.55694 22.0702 0 23.4184 0 27.0099V30.0377C0 30.5677 0.426142 31 0.952089 31H13.7996C14.324 31 14.7517 30.5693 14.7517 30.0377V26.8914C14.7517 23.9789 13.1977 22.1695 10.1306 21.5149L10.1292 21.5146ZM32 0.634193V27.5318C32 28.017 31.6103 28.4109 31.1303 28.4109H15.5612V26.8914C15.5612 25.3975 15.1747 24.1246 14.4111 23.1079C13.6491 22.0927 12.5292 21.3562 11.0828 20.9159L10.8769 20.8534L11.0226 20.6933C11.8606 19.7679 12.3232 18.5702 12.3232 17.3197C12.3232 14.934 10.6424 12.8715 8.32639 12.4137L8.21709 12.3928V10.8381L8.366 10.8541C9.9723 11.0287 12.6684 11.7876 12.6684 14.9243V18.4356C12.6684 18.6613 12.8506 18.8455 13.0739 18.8455H13.9705C14.5266 18.8455 14.9796 18.3875 14.9796 17.8255V15.5359C14.9796 14.9739 14.5266 14.516 13.9705 14.516H13.4652L13.4541 14.3911C13.2292 11.8917 11.3646 10.3001 8.33901 10.0265L8.21544 10.0153V0.634065C8.21544 0.285016 8.49742 0 8.84278 0H31.371C31.7163 0 31.9983 0.285003 31.9983 0.634065L32 0.634193ZM28.3961 24.2863C28.3961 24.0605 28.2139 23.8764 27.9905 23.8764H16.6463C16.423 23.8764 16.2408 24.0605 16.2408 24.2863C16.2408 24.5121 16.423 24.6962 16.6463 24.6962H27.9905C28.2139 24.6962 28.3961 24.5121 28.3961 24.2863ZM28.3961 21.0072C28.3961 20.7814 28.2139 20.5973 27.9905 20.5973H16.6463C16.423 20.5973 16.2408 20.7814 16.2408 21.0072C16.2408 21.2329 16.423 21.417 16.6463 21.417H27.9905C28.2139 21.417 28.3961 21.2329 28.3961 21.0072ZM28.3961 17.728C28.3961 17.5022 28.2139 17.3181 27.9905 17.3181H16.6463C16.423 17.3181 16.2408 17.5022 16.2408 17.728C16.2408 17.9538 16.423 18.1379 16.6463 18.1379H27.9905C28.2139 18.1379 28.3961 17.9538 28.3961 17.728ZM28.3961 14.4504C28.3961 14.2247 28.2139 14.0406 27.9905 14.0406H16.6463C16.423 14.0406 16.2408 14.2247 16.2408 14.4504C16.2408 14.6762 16.423 14.8603 16.6463 14.8603H27.9905C28.2139 14.8603 28.3961 14.6762 28.3961 14.4504ZM28.3961 11.1713C28.3961 10.9455 28.2139 10.7614 27.9905 10.7614H16.6463C16.423 10.7614 16.2408 10.9455 16.2408 11.1713C16.2408 11.3971 16.423 11.5812 16.6463 11.5812H27.9905C28.2139 11.5812 28.3961 11.3971 28.3961 11.1713ZM28.3961 7.89214C28.3961 7.66638 28.2139 7.48225 27.9905 7.48225H12.2267C12.0034 7.48225 11.8212 7.66638 11.8212 7.89214C11.8212 8.11791 12.0034 8.30204 12.2267 8.30204H27.9905C28.2139 8.30204 28.3961 8.11791 28.3961 7.89214ZM28.3961 4.61299C28.3961 4.38723 28.2139 4.2031 27.9905 4.2031H12.2267C12.0034 4.2031 11.8212 4.38723 11.8212 4.61299C11.8212 4.83875 12.0034 5.02289 12.2267 5.02289H27.9905C28.2139 5.02289 28.3961 4.83875 28.3961 4.61299ZM0.828598 18.0452H2.05471V15.3425L0.822231 15.3313H0.817478C0.71134 15.3361 0.628967 15.4257 0.628967 15.533V17.845C0.628967 17.9555 0.717678 18.0468 0.82857 18.0468L0.828598 18.0452ZM7.37606 10.8032V9.98342C3.53928 9.98342 1.25036 11.8311 1.25036 14.9263H2.06144C2.06144 11.2037 5.77786 10.8032 7.37606 10.8032Z"
        fill="black"
      />
    </svg>
  );
};

export const Close = ({ color }: { color?: string }) => {
  return (
    <svg
      className="w-full h-full"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7301 0.269931C23.3701 -0.09 22.7866 -0.0899539 22.4267 0.269931L12 10.6967L1.57327 0.269987C1.21335 -0.0899437 0.629857 -0.0899437 0.269936 0.269987C-0.0899814 0.629872 -0.089977 1.21337 0.26994 1.5733L10.6966 12L0.269967 22.4267C-0.089936 22.7866 -0.0899496 23.3701 0.269963 23.73C0.629884 24.0899 1.2134 24.0899 1.5733 23.73L12 13.3033L22.4267 23.73C22.7866 24.09 23.3701 24.09 23.73 23.73C24.09 23.3701 24.09 22.7866 23.73 22.4267L13.3033 12L23.7301 1.57324C24.09 1.21336 24.09 0.629862 23.7301 0.269931Z"
        fill={color ? color : "black"}
      />
    </svg>
  );
};

export const HamBurgerMenu = ({ color }: { color?: string }) => {
  return (
    <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23 4H5" stroke={color ? color : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23 10H5" stroke={color ? color : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23 16H5" stroke={color ? color : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const AboutUs = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9992 5.64318V6.92923C20.9992 8.11241 20.0389 9.07266 18.8558 9.07266H16.2837C15.1005 9.07266 14.1402 8.11241 14.1402 6.92923V6.07186C14.1402 5.83609 13.9473 5.64318 13.7115 5.64318H9.4247V22.7906H22.2853V5.64318H20.9992ZM15.4263 18.5037H13.7115V13.3595H15.4263V18.5037ZM17.9984 18.5037H16.2837V15.0743H17.9984V18.5037ZM18.8558 3.07106H13.7115C13.0042 3.07106 12.4255 3.64978 12.4255 4.35712V4.7858H13.7115C14.4232 4.7858 14.9976 5.36452 14.9976 6.07186V6.92923C14.9976 7.64084 15.5763 8.21529 16.2837 8.21529H18.8558C19.5674 8.21529 20.1418 7.64084 20.1418 6.92923V4.35712C20.1418 3.64978 19.5674 3.07106 18.8558 3.07106ZM8.76882 2.32086C8.05719 1.38633 6.97263 0.494659 5.43793 0.494659C4.63629 0.494659 3.70605 0.739013 2.64289 1.34774C-0.615109 3.2168 -0.164995 5.75893 0.392291 7.10927C0.439466 7.22073 0.529473 7.30648 0.649518 7.34933C0.778118 7.39222 0.919592 7.37935 1.03961 7.31506L2.24851 6.62056L2.85294 4.40427C2.88724 4.28425 2.97299 4.18134 3.08874 4.1299H3.093V4.12564C3.20876 4.07417 3.34165 4.07846 3.4574 4.13419L5.14642 4.95729L8.61876 2.96818C8.62306 2.96818 8.62306 2.96818 8.62306 2.96389C8.62735 2.96389 8.63164 2.96389 8.63593 2.9596C8.63593 2.95531 8.64019 2.95531 8.65307 2.94675C8.75166 2.88244 8.82455 2.77098 8.84598 2.65096C8.86741 2.53092 8.8374 2.41516 8.76882 2.32086ZM9.0346 4.23707C8.96171 4.10847 8.88026 3.98416 8.78596 3.86412L5.3779 5.81466C5.25359 5.88753 5.10354 5.89182 4.97494 5.82751L3.54744 5.13304L3.02872 7.01926C2.99871 7.12644 2.92584 7.22073 2.82722 7.27647L1.96985 7.76946C2.02987 7.90236 2.09848 8.03096 2.17135 8.15956C3.25591 10.0243 6.4239 10.2644 7.58564 9.59993C7.90716 9.41131 8.26297 9.03836 8.56732 8.56681V5.21449C8.56732 4.97872 8.76024 4.7858 8.99601 4.7858H9.27467C9.21464 4.59289 9.13319 4.40856 9.0346 4.23707ZM8.01004 10.3416C7.6628 10.5388 7.21698 10.6674 6.72827 10.736C5.24501 11.5976 4.30619 13.4667 4.28047 15.6144C4.24617 18.5466 5.8366 21.3674 8.56732 23.2836V9.90431C8.38299 10.0801 8.19866 10.2344 8.01004 10.3416ZM23.1426 7.35792V23.2193C23.1426 23.4593 22.9497 23.648 22.7139 23.648H9.4247V24.5053H24V7.35792H23.1426Z"
        fill="black"
      />
    </svg>
  );
};

export const Globe = ({
  color,
  className,
}: {
  color?: string;
  className?: string;
}) => {
  return (
    <svg
      className={`w-full h-full ${className}`}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.53027 6.65003C2.79003 7.04026 4.14002 7.34026 5.52056 7.5805C6.24008 4.43051 7.62055 2.06112 9.30115 0.830525C6.03056 1.55004 3.20967 3.65004 1.53057 6.64991L1.53027 6.65003Z"
        fill={color ? color : "black"}
      />
      <path
        d="M12.3301 16.25C14.2801 16.25 16.1995 16.4304 17.9995 16.7C18.269 15.35 18.419 13.9402 18.419 12.5C18.419 11.0597 18.269 9.64999 17.9995 8.29999C16.169 8.59999 14.2801 8.74999 12.3301 8.74999V16.25Z"
        fill={color ? color : "black"}
      />
      <path
        d="M14.7002 0.800019C16.3807 2.0305 17.7599 4.43061 18.5099 7.55C19.8904 7.30976 21.2404 7.00976 22.5002 6.61952C20.7904 3.65001 17.9696 1.55002 14.7002 0.800019Z"
        fill={color ? color : "black"}
      />
      <path
        d="M1.53027 18.35C3.21075 21.35 6.06086 23.45 9.29965 24.2C7.61917 22.9695 6.23996 20.5694 5.48996 17.4194C4.13996 17.6596 2.78997 17.9597 1.53027 18.35Z"
        fill={color ? color : "black"}
      />
      <path
        d="M12.3301 0.530636V8.12091C14.2203 8.12091 16.0801 7.97091 17.8801 7.67091C16.8898 3.56003 14.6995 0.740335 12.3301 0.530636Z"
        fill={color ? color : "black"}
      />
      <path
        d="M0 12.5C0 14.3305 0.419518 16.1597 1.23048 17.7806C2.54999 17.3903 3.93047 17.0611 5.37076 16.8208C5.10006 15.4404 4.95007 14.0002 4.95007 12.5002C4.95007 11.0003 5.10007 9.56002 5.36959 8.18086C3.92936 7.94063 2.5196 7.61134 1.22931 7.2211C0.419549 8.86993 0 10.6405 0 12.5005V12.5Z"
        fill={color ? color : "black"}
      />
      <path
        d="M12.3301 24.4694C14.7301 24.2291 16.8898 21.4388 17.8801 17.3291C16.1105 17.0595 14.2495 16.9096 12.3301 16.8791V24.4694Z"
        fill={color ? color : "black"}
      />
      <path
        d="M14.7005 24.2C17.9699 23.45 20.8199 21.35 22.4699 18.35C21.2101 17.9597 19.8601 17.6597 18.4796 17.4195C17.7601 20.5695 16.3808 22.9695 14.7002 24.2001L14.7005 24.2Z"
        fill={color ? color : "black"}
      />
      <path
        d="M11.6691 24.4694V16.8803C9.77889 16.8803 7.91913 17.0303 6.11914 17.3303C7.10938 21.44 9.29973 24.2597 11.6691 24.4694Z"
        fill={color ? color : "black"}
      />
      <path
        d="M18.6309 8.1806C18.9004 9.55991 19.0504 11.0001 19.0504 12.5C19.0504 13.9999 18.9004 15.4402 18.6309 16.8194C20.0711 17.0596 21.4504 17.3889 22.7711 17.7791C23.5809 16.1596 24.0005 14.3303 24.0005 12.4997C24.0005 10.64 23.5809 8.86916 22.77 7.21916C21.4505 7.6094 20.07 7.93985 18.6309 8.18009L18.6309 8.1806Z"
        fill={color ? color : "black"}
      />
      <path
        d="M5.58008 12.5C5.58008 13.9402 5.73008 15.35 5.9996 16.7C7.83007 16.4 9.71898 16.25 11.669 16.25V8.74999C9.71898 8.74999 7.82869 8.56953 5.9996 8.29999C5.73007 9.64999 5.58008 11.0597 5.58008 12.5Z"
        fill={color ? color : "black"}
      />
      <path
        d="M11.6691 0.530636C9.26913 0.770869 7.10944 3.56123 6.11914 7.67091C7.88865 7.94044 9.74973 8.09043 11.6691 8.12091V0.530636Z"
        fill={color ? color : "black"}
      />
    </svg>
  );
};

export const EducationCap = ({ color }: { color?: string }) => {
  return (
    <svg
      className="w-full h-full"
      width="32"
      height="25"
      viewBox="0 0 32 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8024 0.563835C15.6333 0.478742 15.4466 0.478742 15.2776 0.563835L0 8.16857L0.861317 8.6007L15.335 15.7745C15.504 15.8596 15.6907 15.8596 15.8598 15.7745L29.2501 9.1004C29.394 9.03018 29.5182 8.90304 29.606 8.73616C29.6937 8.56928 29.7407 8.37069 29.7407 8.1672C29.7407 7.96371 29.6937 7.76511 29.606 7.59823C29.5182 7.43135 29.394 7.30421 29.2501 7.23399L15.8024 0.563835Z"
        fill={color ? color : "black"}
      />
      <path
        d="M6.70785 13.7949C6.65133 13.7674 6.59063 13.7585 6.53096 13.769C6.47128 13.7794 6.4144 13.8089 6.36518 13.8549C6.31596 13.9009 6.27587 13.962 6.24832 14.033C6.22078 14.1041 6.20662 14.1829 6.20704 14.2628V19.985C6.20704 22.4898 10.3621 24.5 15.5427 24.5C19.0487 24.5 22.0698 23.5642 23.6882 22.2081C24.4453 21.5595 24.8902 20.7723 24.8902 19.9854V14.183C24.8903 14.1029 24.8756 14.024 24.8476 13.953C24.8196 13.882 24.779 13.8212 24.7293 13.7756C24.6796 13.7301 24.6224 13.7013 24.5624 13.6916C24.5025 13.682 24.4417 13.6918 24.3853 13.7203L15.6709 18.0486C15.587 18.0912 15.4943 18.0912 15.4104 18.0486L6.70785 13.7949ZM30.6599 9.50344C30.5932 9.53199 30.534 9.58518 30.4893 9.65678C30.4446 9.72837 30.4161 9.81541 30.4074 9.90768L30.2191 11.8912L29.578 17.9163C29.5705 17.9865 29.5744 18.0581 29.5895 18.1262C29.6047 18.1943 29.6307 18.2572 29.6658 18.3108C29.7009 18.3643 29.7442 18.4072 29.7929 18.4366C29.8416 18.4659 29.8945 18.481 29.948 18.4808H31.6268C31.6801 18.4807 31.7328 18.4654 31.7813 18.436C31.8297 18.4066 31.8729 18.3637 31.9078 18.3103C31.9428 18.2569 31.9686 18.1941 31.9837 18.1263C31.9988 18.0584 32.0028 17.9871 31.9953 17.917L31.1459 9.90296C31.1387 9.83115 31.1197 9.76234 31.09 9.70149C31.0604 9.64065 31.021 9.5893 30.9746 9.55115C30.9282 9.51299 30.876 9.48899 30.8218 9.48088C30.7676 9.47276 30.7127 9.48074 30.661 9.50422L30.6599 9.50344Z"
        fill={color ? color : "black"}
      />
    </svg>
  );
};

export const Services = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7231 16.8706L16.9792 18.455C17.0358 18.6397 17.0668 18.8319 17.07 19.0273L21.6374 17.8091C21.6161 17.6489 21.5638 17.4899 21.4783 17.3415C21.1249 16.7297 20.336 16.5183 19.7242 16.8717L19.7231 16.8706ZM0.633321 15.0033L2.66721 14.4588C3.12097 14.3371 3.59179 14.6093 3.7135 15.063L5.68225 22.4118C5.80397 22.8656 5.53171 23.3364 5.07797 23.4581L3.04409 24.0026C2.59032 24.1243 2.1195 23.8521 1.99779 23.3983L0.0290382 16.0496C-0.092674 15.5958 0.179577 15.125 0.633321 15.0033ZM15.415 1.78688C16.4047 2.04739 17.2888 2.56948 17.9891 3.27412L19.5106 2.39546L20.9562 4.90019L19.4358 5.77779C19.5639 6.25184 19.6333 6.75043 19.6333 7.26397C19.6333 7.77858 19.5639 8.27717 19.4358 8.75015L20.9562 9.62775L19.5106 12.1325L17.9891 11.2538C17.2888 11.9585 16.4058 12.4806 15.415 12.7411V14.4963H12.5227V12.7411C11.533 12.4806 10.649 11.9585 9.94861 11.2538L8.42721 12.1325L6.98159 9.62775L8.50193 8.75015C8.37381 8.2761 8.30441 7.77751 8.30441 7.26397C8.30441 6.74936 8.37381 6.25077 8.50193 5.77779L6.98159 4.90019L8.42721 2.39546L9.94861 3.27412C10.649 2.56948 11.532 2.04738 12.5227 1.78688V0.0316467H15.415V1.78688ZM13.9694 2.97413C11.6003 2.97413 9.67855 4.89483 9.67855 7.26498C9.67855 9.63412 11.5992 11.5558 13.9694 11.5558C16.3385 11.5558 18.2603 9.63513 18.2603 7.26498C18.2603 4.89584 16.3395 2.97413 13.9694 2.97413ZM15.1662 3.77274C15.4022 4.13467 15.5666 4.55534 15.6851 4.96958H16.8595C16.4207 4.41868 15.8335 4.00121 15.1662 3.77274ZM12.7726 3.77274C12.1053 4.00122 11.5181 4.41868 11.0793 4.96958H12.2537C12.3722 4.55534 12.5366 4.13467 12.7726 3.77274ZM12.8793 4.96958H15.0595C14.9089 4.50303 14.5203 3.57415 13.9694 3.57415C13.4196 3.57415 13.0299 4.503 12.8793 4.96958ZM10.6906 5.5696C10.4707 5.99347 10.3308 6.46535 10.2913 6.96504H11.959C11.974 6.47178 12.0274 6.00202 12.1106 5.5696H10.6906ZM12.559 6.96504H15.3808C15.3648 6.46645 15.3071 5.99453 15.2174 5.5696H12.7212C12.6316 5.99453 12.575 6.46535 12.5579 6.96504H12.559ZM15.981 6.96504H17.6487C17.6081 6.46538 17.4682 5.99347 17.2494 5.5696H15.8294C15.9127 6.002 15.966 6.47178 15.981 6.96504ZM10.2916 7.56506C10.3321 8.06471 10.472 8.53663 10.6908 8.96049H12.1108C12.0265 8.5281 11.9742 8.05832 11.9592 7.56506H10.2916ZM12.7226 8.96049H15.2188C15.3085 8.53556 15.365 8.06474 15.3821 7.56506H12.5604C12.5764 8.06365 12.634 8.53556 12.7237 8.96049H12.7226ZM15.8294 8.96049H17.2494C17.4693 8.53663 17.6092 8.06474 17.6487 7.56506H15.981C15.9661 8.05832 15.9127 8.52807 15.8294 8.96049ZM11.0805 9.56051C11.5182 10.1114 12.1065 10.5289 12.7738 10.7574C12.5378 10.3954 12.3734 9.97476 12.2549 9.56051H11.0805ZM15.1674 10.7574C15.8347 10.5289 16.4219 10.1114 16.8607 9.56051H15.6863C15.5678 9.97476 15.4034 10.3954 15.1674 10.7574ZM15.0607 9.56051H12.8805C13.03 10.0271 13.4208 10.9559 13.9706 10.9559C14.5204 10.9559 14.9101 10.0271 15.0607 9.56051ZM16.2767 19.827C15.9073 20.4676 15.2208 20.6587 14.5717 20.2999L10.7709 18.1059C10.6278 18.0226 10.4453 18.0718 10.362 18.2148C10.2787 18.3579 10.3278 18.5405 10.4709 18.6237C11.7297 19.3508 13.0108 20.1323 14.2834 20.8242C15.24 21.3537 16.2693 21.0377 16.8074 20.1003C16.8736 19.9519 16.9259 19.811 16.9654 19.6765L21.7881 18.3889C22.7672 18.1262 23.7441 18.5661 23.9587 19.3658C24.1733 20.1655 23.5466 21.0345 22.5675 21.2972L15.459 23.2019C14.7992 23.3791 14.1789 23.3385 13.6098 23.0823L9.18642 21.0911C8.70065 20.8722 8.17216 20.8381 7.60844 20.9897L6.03685 21.4103L4.52077 15.7518L8.93024 14.5699C9.49396 14.4194 10.032 14.4898 10.5371 14.7813L15.6703 17.7452C16.5404 18.247 16.629 19.1449 16.2767 19.8261L16.2767 19.827ZM17.5718 16.0251C18.1622 15.6631 18.9384 15.8393 19.3164 16.4137L16.7198 17.9127C16.4604 17.5294 16.1732 17.3426 15.7867 17.1195L17.5718 16.024L17.5718 16.0251Z"
        fill="black"
      />
    </svg>
  );
};

export const Search = ({
  color,
  className,
  width,
  height,
}: {
  color?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
}) => {
  return (
    <svg
      className={className}
      width={width ?? "24"}
      height={height ?? "24"}
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M80.1002 74.4008L65.2002 59.5008C76.6002 45.3008 75.5002 24.3008 62.5002 11.4008C55.7002 4.60078 46.6002 0.800781 36.9002 0.800781C27.2002 0.800781 18.2002 4.60078 11.3002 11.4008C4.50019 18.2008 0.700195 27.3008 0.700195 37.0008C0.700195 46.7008 4.50019 55.7008 11.3002 62.6008C18.1002 69.4008 27.2002 73.2008 36.9002 73.2008C45.1002 73.2008 53.1002 70.4008 59.5002 65.3008L74.4002 80.2008C75.2002 81.0008 76.2002 81.4008 77.2002 81.4008C78.3002 81.4008 79.3002 81.0008 80.0002 80.2008C81.6002 78.5008 81.6002 76.0008 80.1002 74.4008ZM65.1002 36.9008C65.1002 44.4008 62.2002 51.5008 56.9002 56.8008C51.6002 62.1008 44.5002 65.0008 37.0002 65.0008C29.5002 65.0008 22.4002 62.1008 17.1002 56.8008C11.8002 51.5008 8.9002 44.4008 8.9002 36.9008C8.9002 29.4008 11.8002 22.3008 17.1002 17.0008C22.4002 11.7008 29.5002 8.80078 37.0002 8.80078C44.5002 8.80078 51.6002 11.7008 56.9002 17.0008C62.2002 22.3008 65.1002 29.4008 65.1002 36.9008Z"
        fill={color ? color : "black"}
      />
    </svg>
  );
};

export const Facebook = () => {
  return (
    <svg
      className="w-full h-full"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1883 62.3481L27.1771 40.9057L19.4927 40.9073C19.2976 40.8937 19.443 40.9113 19.3878 40.8478L19.3898 32.0076L27.187 31.9994C27.2003 30.7702 27.1879 29.5489 27.1879 28.334C27.1879 24.8824 26.9978 21.7492 28.653 18.6734C29.5316 17.0406 30.7521 15.7959 32.2493 14.9064C33.5231 14.1497 34.8479 13.7119 36.3552 13.4653C36.9329 13.371 37.4498 13.3539 38.0212 13.2924C38.0312 13.241 37.9617 13.1734 38.2681 13.1704C38.3523 13.1695 38.4533 13.1763 38.5418 13.1766C38.7259 13.1773 39.0112 13.2035 39.1539 13.1556L39.3467 13.0992C39.4153 13.0921 39.5467 13.0987 39.6217 13.0993C44.3598 13.1344 49.2132 13.0996 53.9662 13.0996C54.18 13.0996 55.9999 13.0434 56.1916 13.127C56.142 12.9504 55.8121 12.6086 55.6697 12.4358C55.4702 12.1937 55.345 12.0114 55.1209 11.7908L52.1368 8.79638C51.9366 8.6068 51.6769 8.43339 51.4593 8.23928C50.0737 7.00352 47.3484 5.28685 45.631 4.4676C40.4972 2.01876 35.5469 0.967142 29.6742 1.36082C26.9919 1.54057 23.986 2.19111 21.7319 3.03576C19.1301 4.01043 17.6955 4.69664 15.3 6.20664C14.4198 6.76133 13.9648 7.15001 13.2034 7.69593C12.7692 8.00721 12.2818 8.46136 11.8844 8.76796L11.2586 9.33761C9.41694 10.8984 7.09343 13.8307 5.81322 15.9223C-0.761365 26.6642 -0.202144 40.4196 7.59852 50.6829L8.68733 52.0243C8.98153 52.4103 10.1166 53.5494 10.4199 53.8787L11.9628 55.3039C12.0863 55.4013 12.1896 55.4903 12.3033 55.58L13.658 56.6559C14.3752 57.2108 15.7182 58.0929 16.5346 58.5599C18.5736 59.7266 20.9418 60.8154 23.2361 61.4605C23.8635 61.6368 24.4748 61.8127 25.1243 61.9601C25.7293 62.0976 26.5729 62.2933 27.1883 62.3481Z"
        fill="#1776F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3887 40.848C19.9638 41.0177 25.7577 40.7851 27.2098 40.8841L27.2282 62.3523C27.5659 62.5203 30.6825 62.7153 31.2159 62.7186C32.392 62.7261 33.2343 62.7109 34.3765 62.6381C34.7019 62.6172 35.1294 62.5372 35.4244 62.5597L35.975 62.4449C36.1508 62.4642 36.6275 62.4077 36.7836 62.3464L36.7888 40.8883L43.9505 40.8823L45.3047 31.9999L36.8077 32.0034C36.7534 31.7905 36.7906 27.7621 36.7906 27.1772C36.7906 25.5416 36.8217 24.3368 37.6727 23.1839C38.4338 22.153 39.5212 21.6604 40.8524 21.5046C42.3778 21.326 44.1134 21.5425 45.6743 21.4452L45.6657 13.8816C44.0493 13.5051 39.5589 13.2322 38.0221 13.2925C37.4506 13.3541 36.9338 13.3712 36.3561 13.4655C34.8488 13.7121 33.524 14.1499 32.2501 14.9066C30.753 15.7961 29.5325 17.0408 28.6538 18.6736C26.9987 21.7493 27.1887 24.8826 27.1887 28.3342C27.1887 29.5491 27.2011 30.7704 27.1878 31.9996L19.3906 32.0078L19.3887 40.848Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.8072 32.0033L45.3042 31.9999L43.9501 40.8822L36.7883 40.8883L36.7832 62.3464C37.2133 62.3163 37.8632 62.1761 38.3023 62.0806C38.818 61.9683 39.3048 61.8442 39.7743 61.7336C42.1938 61.1644 45.2872 59.8327 47.4175 58.5773C48.1775 58.1295 48.9151 57.6776 49.6028 57.1773C50.1652 56.7682 51.6248 55.7035 52.1118 55.2136C52.2045 55.1205 52.2539 55.1015 52.3464 55.0224C52.4547 54.93 52.4692 54.8878 52.5864 54.7997C52.9084 54.5571 54.1609 53.2694 54.4075 52.9956C54.6146 52.7659 54.8663 52.548 55.0562 52.2963C55.2627 52.0223 55.8015 51.4634 56.0744 51.0773L56.8563 50.0475C59.6186 46.1769 61.3284 42.2433 62.2301 37.454C62.4296 36.3942 62.5406 35.3528 62.6306 34.2455C62.6634 33.8414 62.7951 30.9569 62.6605 30.7866L62.6044 32.4611C62.6046 32.2682 62.6044 32.0753 62.6044 31.8824H45.329C45.3068 31.9758 44.5075 31.9212 44.365 31.9212H37.3468C37.2175 31.9208 37.0372 31.8986 36.92 31.9376C36.7917 31.9804 36.8949 31.8912 36.8072 32.0033Z"
        fill="#1776F0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.0213 13.2923C39.5581 13.232 44.0485 13.5049 45.6649 13.8813L45.6735 21.4449C44.1126 21.5423 42.377 21.3258 40.8516 21.5044C39.5204 21.6602 38.433 22.1528 37.6719 23.1837C36.8209 24.3366 36.7898 25.5414 36.7898 27.177C36.7898 27.7619 36.7526 31.7903 36.8069 32.0032C36.8945 31.891 36.7913 31.9802 36.9196 31.9374C37.0368 31.8984 37.2172 31.9206 37.3464 31.9211H44.3646C44.5071 31.9211 45.3064 31.9756 45.3287 31.8822H62.604C62.604 32.0751 62.6042 32.268 62.604 32.4609L62.6601 30.7864C62.8018 29.8162 62.2309 26.4973 62.0029 25.419C61.2782 21.9912 59.9165 18.7276 58.0784 15.7735C57.8566 15.4172 56.3997 13.2064 56.1917 13.1269C56 13.0433 54.18 13.0996 53.9663 13.0996C49.2133 13.0996 44.3599 13.1343 39.6217 13.0993C39.5467 13.0987 39.4153 13.092 39.3467 13.0991L39.154 13.1555C39.0112 13.2034 38.726 13.1773 38.5418 13.1765C38.4534 13.1762 38.3524 13.1694 38.2682 13.1703C37.9617 13.1733 38.0313 13.2409 38.0213 13.2923Z"
        fill="#1776F0"
        stroke="#1776F0"
        strokeWidth="0.639874"
        strokeMiterlimit="22.9256"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1882 62.3479L27.2272 62.352L27.2088 40.8838C25.7567 40.7848 19.9628 41.0174 19.3877 40.8477C19.4429 40.9112 19.2975 40.8936 19.4926 40.9072L27.177 40.9056L27.1882 62.3479Z"
        fill="#93ACF3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4238 62.5597C35.569 62.5469 35.9029 62.5561 35.9744 62.4448L35.4238 62.5597Z"
        fill="#878787"
      />
    </svg>
  );
};

export const Twitter = () => {
  return (
    <svg
      className="w-full h-full"
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.7166 11.3903C34.6048 11.8966 33.4077 12.239 32.1521 12.392C33.4344 11.6052 34.4183 10.3577 34.8818 8.87152C33.6812 9.60003 32.3545 10.13 30.9372 10.4141C29.8077 9.17749 28.1932 8.40527 26.4065 8.40527C22.9805 8.40527 20.201 11.2556 20.201 14.7706C20.201 15.2696 20.2543 15.7541 20.3609 16.2203C15.2014 15.9544 10.6281 13.4229 7.5644 9.56724C7.02981 10.5107 6.72433 11.6052 6.72433 12.7709C6.72433 14.9782 7.82016 16.927 9.48609 18.0689C8.47019 18.038 7.51112 17.7484 6.67283 17.2749V17.3532C6.67283 20.4384 8.81297 23.0119 11.6547 23.5947C11.1343 23.744 10.5855 23.8187 10.0189 23.8187C9.6193 23.8187 9.22856 23.7804 8.85027 23.7058C9.64061 26.2337 11.9317 28.075 14.6491 28.1242C12.5249 29.8325 9.84663 30.8506 6.93923 30.8506C6.43839 30.8506 5.94287 30.8215 5.45801 30.7632C8.20556 32.5662 11.4699 33.6208 14.9741 33.6208C26.3941 33.6208 32.6369 23.9225 32.6369 15.51C32.6369 15.2332 32.6316 14.9564 32.6209 14.685C33.834 13.7871 34.8872 12.667 35.7166 11.3903Z"
        fill="white"
      />
    </svg>
  );
};

export const LinkedIn = () => {
  return (
    <svg
      className="w-full h-full"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6040_22121)">
        <path
          d="M31.9994 62.72C48.9656 62.72 62.7195 48.9661 62.7195 31.9999C62.7195 15.0336 48.9656 1.27979 31.9994 1.27979C15.0332 1.27979 1.2793 15.0336 1.2793 31.9999C1.2793 48.9661 15.0332 62.72 31.9994 62.72Z"
          fill="#0A66C2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.3001 28.8087L34.2431 25.275H26.2812L26.2849 52.1383H34.2499L34.2432 41.2561C34.2432 40.7595 34.1942 37.8521 34.2738 37.6397C34.2162 37.0448 34.4859 35.7662 34.6656 35.2373C34.865 34.6502 35.2642 33.8556 35.6825 33.4449C35.8001 33.3295 35.9203 33.1916 36.0402 33.0943C37.174 32.1748 38.3356 31.9465 39.8666 32.0266C39.9115 31.9959 48.7952 32.0127 50.3096 32.0127C50.667 32.0127 51.557 32.0558 51.8509 31.9953C51.6465 30.6271 50.9633 29.1534 50.2184 28.0688C50.0886 27.8796 49.954 27.7101 49.8163 27.5432C48.6477 26.1277 46.8202 25.0256 44.4825 24.6166C41.6735 24.1251 39.2091 24.6075 37.0014 26.0389C36.8163 26.159 36.6339 26.2967 36.4656 26.43C36.3605 26.5133 36.3091 26.5558 36.2081 26.6362C35.845 26.9256 35.378 27.4159 35.0685 27.7595C34.7993 28.0587 34.5501 28.4302 34.3001 28.8087Z"
          fill="#FEFEFE"
          stroke="#FEFEFE"
          strokeWidth="0.639874"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6375 25.2632C12.5801 25.5039 12.6225 26.6113 12.6225 26.941V48.8085C12.6225 49.2614 12.586 51.9283 12.6549 52.1495H20.9344C20.9912 51.9179 20.9498 50.7947 20.9498 50.4717V38.6926C20.9498 38.5313 20.9862 25.4552 20.9344 25.2632H12.6375Z"
          fill="#FEFEFE"
          stroke="#FEFEFE"
          strokeWidth="0.639874"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.8416 37.4967C43.9322 37.6748 43.8802 50.7119 43.8741 52.138H52.1398V38.9654C52.1398 37.5059 52.1754 36.0026 52.1231 34.5485H43.8468C43.5837 34.5485 43.3712 34.5 43.3359 34.6123C43.3362 34.7461 43.4886 35.0908 43.5356 35.2693C43.5957 35.4969 43.6463 35.717 43.693 35.9586C43.7583 36.2971 43.8809 37.1637 43.8416 37.4967Z"
          fill="#FEFEFE"
          stroke="#FEFEFE"
          strokeWidth="0.639874"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6404 17.3162C21.7318 16.573 21.6141 15.7819 21.3869 15.1283C21.1431 14.4264 20.668 13.6882 20.1998 13.2346C19.4276 12.4866 18.4157 11.9765 17.2757 11.8495C14.3849 11.5275 12.1302 13.7124 11.852 16.2378C11.5315 19.1469 13.6854 21.4343 16.2147 21.7133C17.5383 21.8594 19.0551 21.3989 19.9486 20.5473C20.1708 20.3353 20.3494 20.1915 20.5548 19.9262C21.1633 19.1405 21.5079 18.3944 21.6404 17.3162Z"
          fill="#FEFEFE"
          stroke="#FEFEFE"
          strokeWidth="0.639874"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.3373 34.6124C43.3725 34.5 43.585 34.5486 43.8481 34.5486H52.1244L52.1321 34.5286C52.1741 34.1086 51.9661 32.3135 51.8515 31.9951C51.5576 32.0556 50.6676 32.0125 50.3102 32.0125C48.7958 32.0125 39.9121 31.9957 39.8672 32.0264C40.6935 32.1738 41.351 32.2641 42.0583 32.8485C42.58 33.2797 42.9224 33.7453 43.21 34.369C43.2447 34.4443 43.2803 34.5501 43.3373 34.6124Z"
          fill="#FEFEFE"
          stroke="#FEFEFE"
          strokeWidth="0.639874"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.2735 37.6394C34.194 37.8518 34.243 40.7592 34.243 41.2558L34.2497 52.138H26.2847L26.281 25.2747H34.2429L34.2998 28.8084C34.2356 28.738 34.2695 28.5039 34.2695 28.3862C34.2696 27.9346 34.289 25.4493 34.2604 25.267C34.1794 25.2395 26.5293 25.2048 26.2714 25.2612C26.211 25.5542 26.257 26.5667 26.257 26.941V45.4547C26.257 45.8644 26.2203 51.9206 26.2714 52.1514C26.5293 52.2078 34.1794 52.1732 34.2692 52.1457L34.2735 37.6394Z"
          fill="#FEFEFE"
          stroke="#FEFEFE"
          strokeWidth="0.639874"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M52.123 34.5488C52.1753 36.0028 52.1398 37.5062 52.1398 38.9657V52.1383H43.8741C43.8801 50.7122 43.9321 37.675 43.8416 37.497C43.8192 37.732 43.8535 38.1567 43.8535 38.4204C43.8535 39.8655 43.8252 51.9154 43.8632 52.1461C43.9243 52.1667 51.8962 52.206 52.1526 52.1522C52.1975 51.9538 52.1674 51.2917 52.1674 51.0446C52.1674 48.3749 52.207 34.6886 52.1307 34.5288L52.123 34.5488Z"
          fill="#FEFEFE"
          stroke="#FEFEFE"
          strokeWidth="0.639874"
          strokeMiterlimit="22.9256"
        />
      </g>
      <defs>
        <clipPath id="clip0_6040_22121">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const YouTube = () => {
  return (
    <svg
      className="w-full h-full"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="26" fill="white" />
      <g clipPath="url(#clip0_6040_22099)">
        <mask
          id="mask0_6040_22099"
          maskUnits="userSpaceOnUse"
          x="1"
          y="1"
          width="62"
          height="62"
        >
          <path
            d="M31.9994 1.28027C48.9656 1.28027 62.7195 15.0342 62.7195 32.0004C62.7195 48.9666 48.9656 62.7205 31.9994 62.7205C15.0332 62.7205 1.2793 48.9666 1.2793 32.0004C1.2793 15.0342 15.0332 1.28027 31.9994 1.28027Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_6040_22099)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.497 18.5809C22.8957 18.7195 25.0547 19.9784 25.5515 20.2744L46.2091 31.9524C46.1949 31.9686 46.1748 31.9886 46.1639 31.9985C46.1531 32.0085 46.1318 32.0313 46.1184 32.0431L44.741 32.8554C44.2337 33.1613 43.7649 33.4165 43.2559 33.6971L28.4516 42.086C28.0033 42.3563 22.9528 45.2618 22.497 45.4179V18.5809ZM-13.9219 28.4529V34.4753L-13.488 43.3533C-13.2907 46.1296 -12.9998 49.0524 -12.4896 51.7167C-11.5492 56.6269 -8.81829 60.4281 -3.84305 61.7683C2.41964 63.4552 25.4402 63.6694 31.7658 63.6688C38.6512 63.6683 60.6066 63.4695 67.4681 61.8617C70.9446 61.0472 73.8428 58.6453 75.2393 55.6758C77.8329 50.1597 77.6929 35.4535 77.9188 34.8382V29.4842C77.8227 29.2054 77.7802 25.9487 77.7471 25.2288C77.6833 23.8377 77.6044 22.4484 77.5032 21.062C77.181 16.6486 76.728 10.2916 74.3133 6.72943C73.283 5.20945 71.5117 3.66029 69.4696 2.80929C64.9831 0.939932 51.361 0.684133 45.4178 0.524485C44.2014 0.49183 37.3332 0.496819 36.8177 0.332031H26.4232C25.4316 0.685796 0.932469 0.177221 -5.35215 2.7724C-7.50513 3.6615 -9.08512 5.05464 -10.1862 6.55043C-11.524 8.36809 -12.0711 10.0341 -12.5653 12.7114C-13.0133 15.1375 -13.2822 17.8027 -13.4689 20.3332C-13.5482 21.4069 -13.7958 28.1395 -13.9219 28.4529Z"
            fill="#FF0032"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6040_22099">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Instagram = () => {
  return (
    <svg
      className="w-full h-full"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6040_22112"
        className="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="64"
        height="64"
      >
        <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6040_22112)">
        <path
          d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
          fill="url(#paint0_radial_6040_22112)"
        />
        <path
          d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
          fill="url(#paint1_radial_6040_22112)"
        />
        <path
          d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
          fill="url(#paint2_radial_6040_22112)"
        />
        <path
          d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
          fill="url(#paint3_radial_6040_22112)"
        />
      </g>
      <path
        d="M32.6323 13.0527C27.4293 13.0527 26.7764 13.0755 24.7328 13.1685C22.6933 13.2619 21.3011 13.5848 20.083 14.0585C18.823 14.5479 17.7541 15.2024 16.6892 16.2677C15.6236 17.3325 14.969 18.4014 14.4781 19.661C14.0031 20.8795 13.6798 22.2721 13.588 24.3108C13.4966 26.3543 13.4727 27.0077 13.4727 32.2106C13.4727 37.4136 13.4958 38.0646 13.5884 40.1081C13.6822 42.1476 14.0051 43.5397 14.4784 44.7579C14.9682 46.0179 15.6227 47.0867 16.688 48.1516C17.7525 49.2173 18.8214 49.8734 20.0806 50.3627C21.2995 50.8365 22.6921 51.1594 24.7312 51.2528C26.7748 51.3458 27.4273 51.3685 32.6299 51.3685C37.8334 51.3685 38.4843 51.3458 40.5279 51.2528C42.5674 51.1594 43.9612 50.8365 45.1801 50.3627C46.4397 49.8734 47.507 49.2173 48.5715 48.1516C49.6371 47.0867 50.2917 46.0179 50.7826 44.7583C51.2536 43.5397 51.5769 42.1472 51.6727 40.1085C51.7645 38.065 51.7884 37.4136 51.7884 32.2106C51.7884 27.0076 51.7645 26.3547 51.6727 24.3112C51.5769 22.2717 51.2536 20.8795 50.7826 19.6614C50.2917 18.4014 49.6371 17.3325 48.5715 16.2677C47.5058 15.202 46.4401 14.5474 45.1789 14.0585C43.9576 13.5848 42.5646 13.2619 40.5251 13.1685C38.4815 13.0755 37.831 13.0527 32.6264 13.0527H32.6323ZM30.9137 16.5052C31.4238 16.5044 31.9929 16.5052 32.6323 16.5052C37.7476 16.5052 38.3538 16.5235 40.3738 16.6153C42.2417 16.7007 43.2555 17.0128 43.9308 17.275C44.8249 17.6223 45.4623 18.0374 46.1324 18.7079C46.8029 19.3784 47.218 20.017 47.5661 20.9111C47.8283 21.5856 48.1408 22.5993 48.2258 24.4673C48.3176 26.4868 48.3376 27.0935 48.3376 32.2062C48.3376 37.319 48.3176 37.9257 48.2258 39.9452C48.1404 41.8131 47.8283 42.8269 47.5661 43.5014C47.2188 44.3955 46.8029 45.0321 46.1324 45.7022C45.4619 46.3727 44.8253 46.7878 43.9308 47.135C43.2563 47.3985 42.2417 47.7098 40.3738 47.7952C38.3542 47.887 37.7476 47.9069 32.6323 47.9069C27.5167 47.9069 26.9105 47.887 24.8909 47.7952C23.023 47.709 22.0092 47.3969 21.3335 47.1346C20.4394 46.7874 19.8008 46.3723 19.1303 45.7018C18.4597 45.0313 18.0447 44.3943 17.6966 43.4998C17.4344 42.8253 17.1219 41.8115 17.0369 39.9436C16.9451 37.9241 16.9267 37.3174 16.9267 32.2015C16.9267 27.0855 16.9451 26.482 17.0369 24.4625C17.1223 22.5946 17.4344 21.5808 17.6966 20.9055C18.0438 20.0114 18.4597 19.3728 19.1303 18.7023C19.8008 18.0318 20.4394 17.6167 21.3335 17.2687C22.0088 17.0052 23.023 16.6939 24.8909 16.6081C26.6582 16.5283 27.3431 16.5044 30.9137 16.5003L30.9137 16.5052ZM42.8588 19.6862C41.5896 19.6862 40.5598 20.7147 40.5598 21.9843C40.5598 23.2535 41.5896 24.2833 42.8588 24.2833C44.128 24.2833 45.1578 23.2535 45.1578 21.9843C45.1578 20.7151 44.128 19.6854 42.8588 19.6854L42.8588 19.6862ZM32.6323 22.3722C27.199 22.3722 22.7939 26.7774 22.7939 32.2106C22.7939 37.6439 27.199 42.047 32.6323 42.047C38.0657 42.047 42.4692 37.6439 42.4692 32.2106C42.4692 26.7774 38.0653 22.3722 32.632 22.3722H32.6323ZM32.6323 25.8247C36.159 25.8247 39.0184 28.6836 39.0184 32.2106C39.0184 35.7373 36.159 38.5966 32.6323 38.5966C29.1053 38.5966 26.2463 35.7373 26.2463 32.2106C26.2463 28.6836 29.1053 25.8247 32.6323 25.8247Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_6040_22112"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(61.9334 29.9976) rotate(164.25) scale(40.8924 29.461)"
        >
          <stop stopColor="#FF005F" />
          <stop offset="1" stopColor="#FC01D8" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_6040_22112"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.9995 68.9293) rotate(-90) scale(51.086 54.2012)"
        >
          <stop stopColor="#FFCC00" />
          <stop offset="0.1242" stopColor="#FFCC00" />
          <stop offset="0.5672" stopColor="#FE4A05" />
          <stop offset="0.6942" stopColor="#FF0F3F" />
          <stop offset="1" stopColor="#FE0657" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_6040_22112"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.6172 63.0974) rotate(-59.8703) scale(21.1245 27.5017)"
        >
          <stop stopColor="#FFCC00" />
          <stop offset="1" stopColor="#FFCC00" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_6040_22112"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.68343 2.60606) rotate(164.274) scale(40.4388 13.7775)"
        >
          <stop stopColor="#780CFF" />
          <stop offset="1" stopColor="#820BFF" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export const UpRightArrow = ({ color }: { color?: string }) => {
  return (
    <svg
      className="w-full h-full"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83301 22.6668L23.1663 9.3335"
        stroke={color ? color : "black"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.83301 9.3335H23.1663V22.6668"
        stroke={color ? color : "black"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PurpleTriangle = () => {
  return (
    <svg
      className="w-full h-full"
      width="44"
      height="38"
      viewBox="0 0 44 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22 38L0.349365 0.5H43.6506L22 38Z" fill="#5E57EB" />
    </svg>
  );
};

export const SideRightArrow = ({ color }: { color?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 18L15 12L9 6"
        stroke={color ? color : "black"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BlueBanner = () => {
  return (
    <svg
      className="w-full h-full"
      width="92"
      height="114"
      viewBox="0 0 92 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92 0H0V102.444L0.5 101L5 114V107L13.5 112L18 104.5L26.5 114V95L37 114L38.5 107.5L48 114L54.5 107L63.5 114L70.5 91L75.5 112L80 107L85 112L87 101L92 106.238V0Z"
        fill="#1776f0"
      />
    </svg>
  );
};

export const PinkSearch = ({ color }: { color?: string }) => {
  return (
    <svg
      className="w-full h-full"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 38C30.8366 38 38 30.8366 38 22C38 13.1634 30.8366 6 22 6C13.1634 6 6 13.1634 6 22C6 30.8366 13.1634 38 22 38Z"
        stroke={color ? color : "#EB57E3"}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.9988 42L33.2988 33.3"
        stroke={color ? color : "#EB57E3"}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const BlueGlow = () => {
  return (
    <svg
      className="w-full h-full"
      width="996"
      height="1618"
      viewBox="0 0 996 1618"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_107_148)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M179.346 402.494C264.204 391.689 352.48 416.608 422.803 465.34C491.98 513.279 534.97 589.623 563.62 668.79C590.71 743.644 611.335 828.597 580.883 902.146C551.901 972.144 460.436 987.911 408.617 1043.16C359.851 1095.15 356.096 1193.61 287.95 1214.46C219.931 1235.27 161.341 1158.27 92.6375 1139.85C21.489 1120.77 -70.7273 1158.65 -121.011 1104.79C-170.986 1051.26 -131.246 963.05 -140.298 890.365C-149.122 819.509 -194.494 751.392 -173.52 683.142C-151.818 612.52 -85.1042 568.63 -27.2984 522.655C36.357 472.027 98.6807 412.766 179.346 402.494Z"
          fill="#5B57EB"
          fillOpacity="0.15"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_107_148"
          x="-579"
          y="0"
          width="1575"
          height="1618"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_107_148"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const PinkOvalGlow = () => {
  return (
    <svg
      className="w-full h-full"
      width="1376"
      height="1634"
      viewBox="0 0 1376 1634"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_107_144)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M638.058 402.847C729.456 411.656 813.218 461.845 877.463 527.459C934.457 585.667 963.709 665.638 974.44 746.398C983.421 813.992 951.519 876.892 932.599 942.401C916.429 998.386 911.679 1060.15 871.606 1102.45C832.202 1144.05 770.682 1149.11 717.235 1169.75C658.169 1192.56 604.388 1226.46 541.174 1230.06C458.113 1234.79 365.309 1244.31 299.379 1193.56C231.354 1141.2 185.933 1049.08 195.197 963.73C204.306 879.81 317.562 846.094 345.729 766.521C378.543 673.819 305.435 554.905 367.042 478.263C427.01 403.659 542.791 393.665 638.058 402.847Z"
          fill="#ED407D"
          fillOpacity="0.15"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_107_144"
          x="-206"
          y="0"
          width="1582"
          height="1634"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_107_144"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const PinkGlow = () => {
  return (
    <svg
      className="w-full h-full"
      width="1066"
      height="1670"
      viewBox="0 0 1066 1670"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_107_146)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M907.465 449.32C1018.41 436.268 1141.52 359.255 1229.16 428.524C1318.07 498.803 1285.89 636.914 1288.16 750.228C1290.52 867.334 1311.61 990.666 1242.35 1085.12C1164.02 1191.95 1039.67 1277.71 907.465 1269.45C779.285 1261.44 701.688 1137.63 611.962 1045.74C523.989 955.647 390.991 875.795 400.481 750.228C409.844 626.352 546.667 559.653 653.494 496.248C730.456 450.569 818.582 459.776 907.465 449.32Z"
          fill="#EB57E3"
          fillOpacity="0.15"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_107_146"
          x="0"
          y="0"
          width="1693"
          height="1670"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="200"
            result="effect1_foregroundBlur_107_146"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const WhiteSpinner = ({ className }: { className?: string }) => {
  return (
    <svg
      className={`size-[32px] animate-spin text-white mx-auto ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};

export const WhiteFlame = () => {
  return (
    <svg
      className="w-full"
      width="19"
      height="26"
      viewBox="0 0 19 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1817 25.8386C4.29583 25.0572 3.03 24.0069 2.08603 22.5514C-0.473987 18.6985 0.307459 13.7138 3.99901 10.2921C5.13158 9.24187 6.34335 8.27185 7.4748 7.1935C9.28044 5.49621 10.0077 3.3675 9.57635 0.888752C9.54927 0.700164 9.54927 0.484493 9.52218 0C14.6141 4.04153 14.9641 9.2148 14.0212 14.8453C15.6913 14.0096 16.1227 13.0667 16.5541 9.37617C20.1915 14.5764 20.2987 23.8443 13.2397 26C15.0182 22.7669 14.6681 19.9924 11.8383 17.5937C10.3025 16.3277 8.90101 15.0336 9.30535 12.6903C6.55881 14.7377 6.47852 17.5665 6.88185 20.6109C5.72321 19.9108 5.56173 18.9678 5.40023 17.9436C4.29579 20.5838 3.91861 23.1969 6.18167 25.8384L6.1817 25.8386Z"
        fill="white"
      />
    </svg>
  );
};

export const CardFavorite = ({ isFavorite }: { isFavorite: boolean }) => {
  return (
    <svg
      className="w-full h-full"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="white" fillOpacity="0.6" />
      <circle cx="20" cy="20" r="20" fill="white" fillOpacity="0.6" />
      <g clipPath="url(#clip0_78_2021)">
        <path
          className="duration-300 easeLinear"
          d="M27.0698 14.088C26.6611 13.6792 26.176 13.355 25.642 13.1337C25.1081 12.9125 24.5357 12.7986 23.9578 12.7986C23.3798 12.7986 22.8074 12.9125 22.2735 13.1337C21.7395 13.355 21.2544 13.6792 20.8458 14.088L19.9978 14.936L19.1498 14.088C18.3244 13.2627 17.205 12.799 16.0378 12.799C14.8705 12.799 13.7511 13.2627 12.9258 14.088C12.1004 14.9134 11.6367 16.0328 11.6367 17.2C11.6367 18.3673 12.1004 19.4867 12.9258 20.312L13.7738 21.16L19.9978 27.384L26.2218 21.16L27.0698 20.312C27.4785 19.9034 27.8028 19.4183 28.0241 18.8843C28.2453 18.3504 28.3592 17.778 28.3592 17.2C28.3592 16.6221 28.2453 16.0497 28.0241 15.5158C27.8028 14.9818 27.4785 14.4966 27.0698 14.088Z"
          stroke={isFavorite ? "#5E57EB" : "#5E57EB"}
          strokeWidth="2"
          fill={isFavorite ? "#5E57EB" : "transparent"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_2021">
          <rect
            width="19.2"
            height="19.2"
            fill="white"
            transform="translate(10.3984 10.4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ThreeStarTrophy = () => {
  return (
    <svg
      width="32"
      height="41"
      viewBox="0 0 32 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.17627 15.1751V15.9169C8.17627 17.4146 9.23955 18.787 10.8486 19.5253C11.1117 20.0975 11.4685 20.6168 11.8977 21.0672C10.5801 20.7881 9.38437 20.1629 8.51186 19.2974C7.55633 18.3489 7.03179 17.1479 7.03179 15.9169V14.6046C7.03179 14.2884 7.28789 14.0324 7.60403 14.0324H10.3275V15.1768L8.17627 15.1751ZM21.1489 19.5253C20.8857 20.0975 20.529 20.6168 20.0998 21.0672C21.4174 20.7881 22.6131 20.1629 23.4856 19.2974C24.4394 18.3489 24.9657 17.1479 24.9657 15.9169V14.6046C24.9657 14.2884 24.7096 14.0324 24.3934 14.0324H21.67V15.1768H23.8212V15.9186C23.8212 17.4146 22.7579 18.787 21.1489 19.5253ZM15.9985 22.8263C15.8307 22.8263 15.6646 22.8192 15.5021 22.8034C15.1418 24.1863 14.5731 25.5745 13.9337 26.6519H17.9377C17.3019 25.5763 16.7332 24.1934 16.3729 22.8139C16.2493 22.8228 16.1256 22.8263 15.9985 22.8263ZM12.028 28.9638H19.8435L19.363 27.7963H12.5085L12.028 28.9638ZM10.0676 40.8467H21.9311V30.1082H10.0676V40.8467ZM0 40.8467H8.92272V33.3067H0V40.8467ZM23.0755 36.5284V40.8467H32V36.5284H23.0755ZM13.7006 5.10756L13.3014 7.19346C13.259 7.41247 13.3473 7.63325 13.5275 7.76394C13.6264 7.83635 13.7447 7.87344 13.8631 7.87344C13.9585 7.87344 14.0538 7.85048 14.1386 7.80279L15.9984 6.7784L17.8583 7.80279C18.0526 7.91053 18.291 7.89463 18.4712 7.76394C18.6495 7.635 18.7379 7.41246 18.6972 7.19346L18.2998 5.10756L19.8488 3.65218C20.0113 3.50028 20.0696 3.26891 20.0025 3.05873C19.9336 2.84855 19.7499 2.69666 19.5291 2.6684L17.4202 2.40523L16.5177 0.481834C16.4223 0.282251 16.221 0.15332 15.9985 0.15332C15.7777 0.15332 15.5746 0.282255 15.481 0.481834L14.5767 2.40523L12.4714 2.67017C12.2524 2.69843 12.0669 2.85032 11.998 3.0605C11.9291 3.27068 11.9892 3.50382 12.1499 3.65395L13.7006 5.10756ZM3.7429 7.12812L3.34373 9.21403C3.30134 9.43127 3.38965 9.65381 3.56981 9.7845C3.67048 9.85692 3.78705 9.89401 3.90539 9.89401C4.00077 9.89401 4.09437 9.87105 4.18092 9.82336L6.04251 8.79897L7.90234 9.82336C8.09662 9.9311 8.33506 9.9152 8.51523 9.7845C8.69361 9.65557 8.78193 9.43126 8.7413 9.21403L8.34214 7.12812L9.89112 5.67274C10.0536 5.52085 10.1119 5.28947 10.0448 5.0793C9.97589 4.86912 9.79221 4.71723 9.57142 4.68897L7.46431 4.42403L6.56354 2.5024C6.51585 2.40172 6.44167 2.31871 6.35159 2.26219C6.26151 2.20391 6.15554 2.17388 6.04427 2.17388C5.82173 2.17388 5.62038 2.30282 5.52679 2.5024L4.62249 4.4258L2.51361 4.69073C2.2946 4.71899 2.10915 4.87088 2.04026 5.08106C1.97138 5.29124 2.02966 5.52261 2.19215 5.67451L3.7429 7.12812ZM23.6569 7.12812L23.2578 9.21403C23.2154 9.43127 23.3037 9.65381 23.4838 9.7845C23.664 9.91344 23.9024 9.92933 24.0967 9.82336L25.9583 8.79897L27.8182 9.82336C27.9047 9.87105 28.0001 9.89401 28.0937 9.89401C28.212 9.89401 28.3304 9.85692 28.4293 9.7845C28.6094 9.65557 28.696 9.43126 28.6553 9.21403L28.2562 7.12812L29.8069 5.67274C29.9676 5.52085 30.0277 5.28947 29.9588 5.0793C29.8899 4.86912 29.7062 4.71722 29.4855 4.68896L27.3783 4.42403L26.4776 2.5024C26.4317 2.40172 26.3575 2.31871 26.2674 2.26219C26.1773 2.2039 26.0713 2.17388 25.9601 2.17388C25.7393 2.17388 25.5362 2.30282 25.4426 2.5024L24.5401 4.42579L22.4312 4.69073C22.2122 4.71899 22.0267 4.87088 21.9578 5.08106C21.8889 5.29124 21.949 5.52261 22.1115 5.67451L23.6569 7.12812ZM20.5254 12.9957H11.4734V17.1551C11.4734 18.289 11.892 19.3275 12.5843 20.1223C12.6108 20.1523 12.6373 20.1824 12.6638 20.2124C12.6656 20.2142 12.6656 20.2142 12.6656 20.2142C13.312 20.9171 14.1775 21.417 15.1542 21.6024C15.1665 21.6042 15.1789 21.6059 15.193 21.6095C15.4544 21.6572 15.7247 21.6819 16.0002 21.6819C16.2439 21.6819 16.4841 21.6625 16.7173 21.6254C17.7452 21.4611 18.6583 20.9489 19.333 20.2159L19.3348 20.2142C19.3613 20.1841 19.3878 20.1541 19.4143 20.1241C20.1048 19.3293 20.5252 18.2907 20.5252 17.1568L20.5254 12.9957ZM20.9917 10.7967H11.0073V11.8511H20.9917V10.7967Z"
        fill="black"
      />
    </svg>
  );
};

export const Institute = () => {
  return (
    <svg
      className="size-[24px] sm:size-[34px]"
      width="32"
      height="31"
      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7377 12.09H16.7869V13.1392H15.7377V12.09ZM4.72131 18.9097H5.77049V17.8605H4.72131V18.9097ZM4.72131 24.6802H5.77049V23.631H4.72131V24.6802ZM26.7541 18.9097H27.8033V17.8605H26.7541V18.9097ZM26.7541 24.6802H27.8033V23.631H26.7541V24.6802ZM15.7377 18.9097H16.7869V17.8605H15.7377V18.9097ZM15.7377 24.6802H16.7869V23.631H15.7377V24.6802ZM32 13.1392V30.4506C32 30.7404 31.7651 30.9752 31.4754 30.9752H0.52459C0.234855 30.9752 0 30.7404 0 30.4506V13.1392C0 12.27 0.704598 11.5654 1.57377 11.5654H8.39344C9.26265 11.5654 9.96721 12.27 9.96721 13.1392V29.9261H11.0164V7.36868C11.0164 6.49947 11.721 5.79491 12.5902 5.79491H15.7377V3.95884C15.7377 3.91357 15.7434 3.86961 15.7542 3.82769C15.7434 3.78578 15.7377 3.74182 15.7377 3.69655V0.549004C15.7377 0.259269 15.9726 0.0244141 16.2623 0.0244141H22.0328C22.2523 0.0244141 22.4486 0.161101 22.5248 0.367011C22.601 0.57289 22.5409 0.804447 22.3742 0.947314L21.0028 2.12277L22.3742 3.29824C22.5409 3.4411 22.601 3.67266 22.5248 3.87854C22.4486 4.08445 22.2523 4.22114 22.0328 4.22114H16.7869V5.79491H19.4098C20.279 5.79491 20.9836 6.49947 20.9836 7.36868V29.9261H22.0328V13.1392C22.0328 12.27 22.7374 11.5654 23.6066 11.5654H30.4262C31.2954 11.5654 32 12.27 32 13.1392ZM6.81967 23.1064C6.81967 22.8166 6.58482 22.5818 6.29508 22.5818H4.19672C3.90699 22.5818 3.67213 22.8166 3.67213 23.1064V25.2047C3.67213 25.4945 3.90699 25.7293 4.19672 25.7293H6.29508C6.58482 25.7293 6.81967 25.4945 6.81967 25.2047V23.1064ZM6.81967 17.3359C6.81967 17.0462 6.58482 16.8113 6.29508 16.8113H4.19672C3.90699 16.8113 3.67213 17.0462 3.67213 17.3359V19.4343C3.67213 19.724 3.90699 19.9588 4.19672 19.9588H6.29508C6.58482 19.9588 6.81967 19.724 6.81967 19.4343V17.3359ZM17.8361 23.1064C17.8361 22.8166 17.6012 22.5818 17.3115 22.5818H15.2131C14.9234 22.5818 14.6885 22.8166 14.6885 23.1064V25.2047C14.6885 25.4945 14.9234 25.7293 15.2131 25.7293H17.3115C17.6012 25.7293 17.8361 25.4945 17.8361 25.2047V23.1064ZM17.8361 17.3359C17.8361 17.0462 17.6012 16.8113 17.3115 16.8113H15.2131C14.9234 16.8113 14.6885 17.0462 14.6885 17.3359V19.4343C14.6885 19.724 14.9234 19.9588 15.2131 19.9588H17.3115C17.6012 19.9588 17.8361 19.724 17.8361 19.4343V17.3359ZM17.8361 11.5654C17.8361 11.2757 17.6012 11.0408 17.3115 11.0408H15.2131C14.9234 11.0408 14.6885 11.2757 14.6885 11.5654V13.6638C14.6885 13.9535 14.9234 14.1883 15.2131 14.1883H17.3115C17.6012 14.1883 17.8361 13.9535 17.8361 13.6638V11.5654ZM28.8525 23.1064C28.8525 22.8166 28.6176 22.5818 28.3279 22.5818H26.2295C25.9398 22.5818 25.7049 22.8166 25.7049 23.1064V25.2047C25.7049 25.4945 25.9398 25.7293 26.2295 25.7293H28.3279C28.6176 25.7293 28.8525 25.4945 28.8525 25.2047V23.1064ZM28.8525 17.3359C28.8525 17.0462 28.6176 16.8113 28.3279 16.8113H26.2295C25.9398 16.8113 25.7049 17.0462 25.7049 17.3359V19.4343C25.7049 19.724 25.9398 19.9588 26.2295 19.9588H28.3279C28.6176 19.9588 28.8525 19.724 28.8525 19.4343V17.3359Z"
        fill="black"
      />
    </svg>
  );
};

export const Calender = ({ color }: { color?: string }) => {
  return (
    <svg
      className="w-full h-full"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 15.3397V26.5572C32 29.8304 29.3311 32.4993 26.0578 32.4993H5.94285C2.66959 32.4993 0.000695345 29.8305 0.000695345 26.5572V15.3397H32ZM9.44034 0.5C10.2321 0.5 10.8732 1.14244 10.8732 1.9329V5.73184C10.8732 6.52365 10.2321 7.16474 9.44034 7.16474C8.64853 7.16474 8.00744 6.52365 8.00744 5.73184V1.9329C8.00744 1.14108 8.64853 0.5 9.44034 0.5ZM22.5604 0.5C23.3508 0.5 23.9933 1.14244 23.9933 1.9329V5.73184C23.9933 6.52365 23.3508 7.16474 22.5604 7.16474C21.7699 7.16474 21.1275 6.52365 21.1275 5.73184V1.9329C21.1275 1.14108 21.7699 0.5 22.5604 0.5ZM31.9997 12.4684V9.99653C31.9997 6.72327 29.3308 4.05437 26.0575 4.05437V5.73174C26.0575 7.66309 24.4901 9.22923 22.56 9.22923C20.63 9.22923 19.0625 7.66323 19.0625 5.73174V4.05437H12.9371V5.73174C12.9371 7.66309 11.3711 9.22923 9.43964 9.22923C7.50829 9.22923 5.94215 7.66323 5.94215 5.73174V4.05437C2.66889 4.05437 0 6.72323 0 9.99653V12.4684H31.9997ZM10.1312 24.6135L13.581 28.0633C14.1854 28.6677 15.166 28.6677 15.7705 28.0633L21.8687 21.9637C22.4731 21.3593 22.4731 20.3787 21.8687 19.7743C21.2643 19.1699 20.2837 19.1699 19.6793 19.7743L14.6756 24.7794L12.3205 22.4243C11.7161 21.8199 10.7355 21.8199 10.1311 22.4243C9.52667 23.0287 9.52681 24.0091 10.1312 24.6135Z"
        fill={color ? color : "black"}
      />
    </svg>
  );
};

export const Fee = ({ color }: { color?: string }) => {
  return (
    <svg
      className="w-full h-full"
      width="32"
      height="29"
      viewBox="0 0 32 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 21.835C19.4402 21.835 16 19.9728 16 17.5047C16 15.0365 19.44 13.1743 24 13.1743C28.5601 13.1743 32.0001 15.0365 32.0001 17.5047C32.0001 19.9728 28.5601 21.835 24 21.835Z"
        fill={color ? color : "black"}
      />
      <path
        d="M24 23.0202C20.2059 23.0202 17.1957 21.7298 16.2874 19.875C16.1037 20.2498 16 20.6453 16 21.0602C16 23.5283 19.44 25.3905 24 25.3905C28.5601 25.3905 32.0001 23.5283 32.0001 21.0602C32.0001 20.6453 31.8949 20.2498 31.7127 19.875C30.806 21.7298 27.7956 23.0202 24 23.0202Z"
        fill={color ? color : "black"}
      />
      <path
        d="M24 26.5758C20.2059 26.5758 17.1957 25.2855 16.2874 23.4307C16.1037 23.8055 16 24.201 16 24.6158C16 27.084 19.44 28.9462 24 28.9462C28.5601 28.9462 32.0001 27.084 32.0001 24.6158C32.0001 24.201 31.8949 23.8055 31.7127 23.4307C30.806 25.2855 27.7956 26.5758 24 26.5758Z"
        fill={color ? color : "black"}
      />
      <path
        d="M16.794 10.5522C16.6474 10.5522 16.4888 10.5759 16.3244 10.6234C15.1851 10.9463 14.2222 12.1493 14.2222 13.2471C14.2222 13.65 14.3555 13.973 14.597 14.1552C14.8577 14.3522 15.2399 14.3922 15.6755 14.2693C16.8148 13.9463 17.7777 12.7434 17.7777 11.6456C17.7777 11.2426 17.6444 10.9196 17.4029 10.7374C17.2414 10.616 17.0326 10.5537 16.794 10.5537V10.5522Z"
        fill={color ? color : "black"}
      />
      <path
        d="M14.8148 20.5535C11.9955 21.3254 9.10505 22.0217 6.19994 22.0824H6.17476C5.86513 22.0824 5.56734 21.9609 5.34513 21.7446C5.11699 21.5224 4.98958 21.2172 4.98958 20.8972C4.98958 19.9965 4.18662 19.4158 3.39552 19.3091C2.80885 19.2291 2.37035 18.7284 2.37035 18.1342V10.2749C2.37035 9.93269 2.5185 9.60677 2.77627 9.38156C3.03405 9.15638 3.37626 9.05416 3.71554 9.10008C4.09035 9.15342 4.36589 8.99193 4.52886 8.84971C4.81774 8.59786 4.98958 8.2038 4.98958 7.79788C4.98958 7.15345 5.50514 6.62605 6.14957 6.6127C9.27401 6.54752 12.3849 5.67639 15.6799 4.75495C18.9718 3.83347 22.3746 2.88089 25.8 2.80978C26.1141 2.79941 26.4267 2.92534 26.6533 3.14755C26.8815 3.36978 27.0089 3.67495 27.0089 3.99497C27.0089 4.8957 27.8119 5.47642 28.603 5.58311C29.1896 5.66311 29.6281 6.16382 29.6281 6.75793V13.0616C30.5985 13.4941 31.4015 14.0468 31.9985 14.6912L32 4.74176C32 3.01436 30.6755 0.869168 28.7081 0.430747C24.2666 -0.58259 19.9022 0.639634 15.6799 1.82186C11.5615 2.97446 7.67263 4.06335 3.81332 3.18184C2.72147 2.93888 1.72296 3.12406 0.999987 3.70332C0.355553 4.22036 0 5.00997 0 5.92406V20.1462C0 21.8736 1.32444 24.0188 3.29184 24.4572C4.45331 24.7224 5.60887 24.835 6.75847 24.835C9.48586 24.835 12.1762 24.2024 14.8146 23.4839L14.8148 20.5535Z"
        fill={color ? color : "black"}
      />
      <path
        d="M24.8444 5.22632C22.0563 5.43076 19.2606 6.21299 16.3198 7.03666C13.345 7.86925 10.2798 8.72849 7.18809 8.93739C6.98513 9.59221 6.60737 10.1803 6.08885 10.6352C5.68885 10.9848 5.22961 11.2307 4.74219 11.3641V17.2217C5.9007 17.6661 6.77922 18.5594 7.15699 19.6646C9.66957 19.4809 12.1897 18.8261 14.8161 18.0958V17.1861C14.8161 17.0306 14.8457 16.881 14.902 16.7447C14.9065 16.7239 14.9139 16.7047 14.9183 16.6854C14.2754 16.6335 13.6709 16.4247 13.1702 16.0469C12.3331 15.4143 11.8531 14.3935 11.8531 13.2469C11.8531 11.1062 13.5331 8.9522 15.6768 8.34311C16.8264 8.01718 17.9775 8.19941 18.8323 8.84532C19.6693 9.47792 20.1494 10.4987 20.1494 11.6453C20.1494 11.9223 20.1197 12.1994 20.0664 12.4749C21.2442 12.1638 22.5701 11.992 24.0012 11.992C25.1656 11.992 26.2589 12.1061 27.2604 12.3149V7.67207C26.1019 7.22762 25.2234 6.33432 24.8456 5.22765L24.8444 5.22632Z"
        fill={color ? color : "black"}
      />
    </svg>
  );
};

export const TimeClock = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9845 6.35449C14.7687 6.36153 11.6869 7.64218 9.41833 9.91972C7.14787 12.1973 5.87424 15.284 5.87892 18.4997C5.88361 21.7155 7.16426 24.7973 9.43946 27.0682C11.717 29.3411 14.8014 30.6147 18.017 30.6123C21.2328 30.61 24.3147 29.3317 26.5874 27.0565C28.8603 24.7836 30.1362 21.6992 30.1362 18.4837C30.1315 15.2656 28.8485 12.1789 26.5687 9.90615C24.2911 7.63095 21.2021 6.35497 17.9839 6.35497L17.9845 6.35449ZM23.9047 23.8993C23.7194 24.1198 23.4473 24.2465 23.1611 24.2488C22.9312 24.2465 22.7108 24.1644 22.5348 24.0189L17.3723 19.6843C17.1471 19.5037 17.0181 19.2293 17.0228 18.9408V13.6798C17.0228 13.1426 17.459 12.7063 17.9962 12.7063C18.5333 12.7063 18.9696 13.1426 18.9696 13.6798V18.4834L23.7733 22.5436C24.1767 22.8837 24.24 23.4818 23.9163 23.8993L23.9047 23.8993Z"
      fill={color ? color : "black"}
    />
    <path
      d="M32.9014 8.64883V5.35801C32.9014 4.82088 32.4651 4.38461 31.928 4.38461C31.3909 4.38461 30.9569 4.82088 30.9569 5.35801V5.97018C27.0891 1.97574 21.5958 -0.00859615 16.0673 0.591864C10.5412 1.19232 5.60132 4.30955 2.68369 9.04033C-0.23653 13.7713 -0.806487 19.5856 1.13564 24.7952C3.07777 30.0023 7.31858 34.0225 12.6218 35.6881C17.9251 37.3511 23.7021 36.4739 28.271 33.3074C32.8399 30.141 35.6921 25.0439 35.9995 19.4921C36.016 18.9549 35.5938 18.5069 35.0566 18.4905C34.5195 18.4717 34.0715 18.8939 34.0551 19.431C33.7689 24.4177 31.1841 28.9868 27.0609 31.8017C22.9351 34.6164 17.74 35.3576 12.9921 33.8071C8.24713 32.2568 4.48963 28.593 2.81975 23.8857C1.15209 19.1806 1.76426 13.9661 4.47336 9.77253C7.18479 5.58102 11.6885 2.88346 16.6657 2.47334C21.6406 2.06053 26.5264 3.98386 29.8878 7.67579H28.6869C28.1498 7.67579 27.7135 8.11206 27.7135 8.64919C27.7135 9.18632 28.1498 9.62026 28.6869 9.62026H31.9894C32.5031 9.58976 32.9014 9.16251 32.9014 8.64883Z"
      fill={color ? color : "black"}
    />
  </svg>
);

export const WhitePanicle = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 13.834H14"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2.83414C11.2652 2.56892 11.6249 2.41992 12 2.41992C12.1857 2.41992 12.3696 2.4565 12.5412 2.52757C12.7128 2.59864 12.8687 2.70281 13 2.83414C13.1313 2.96546 13.2355 3.12136 13.3066 3.29294C13.3776 3.46452 13.4142 3.64842 13.4142 3.83414C13.4142 4.01985 13.3776 4.20375 13.3066 4.37533C13.2355 4.54691 13.1313 4.70281 13 4.83414L4.66667 13.1675L2 13.8341L2.66667 11.1675L11 2.83414Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SortUpArrow = () => (
  <svg
    className="w-full h-full max-w-[24px] md:max-w-[32px]"
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.9644 3.94537C31.9644 3.29801 31.425 2.75854 30.7776 2.75854H13.8743C13.227 2.75854 12.6875 3.29801 12.6875 3.94537C12.6875 4.59273 13.227 5.1322 13.8743 5.1322H30.7776C31.4609 5.1322 31.9644 4.59273 31.9644 3.94537Z"
      fill="black"
    />
    <path
      d="M30.8116 8.65601H15.5267C14.8793 8.65601 14.3398 9.19547 14.3398 9.84283C14.3398 10.4902 14.8793 11.0297 15.5267 11.0297H30.8116C31.4589 11.0297 31.9984 10.4902 31.9984 9.84283C31.9984 9.19547 31.4589 8.65601 30.8116 8.65601Z"
      fill="black"
    />
    <path
      d="M30.8153 14.4824H17.7962C17.1488 14.4824 16.6094 15.0219 16.6094 15.6692C16.6094 16.3166 17.1488 16.8561 17.7962 16.8561H30.8153C31.4627 16.8561 32.0022 16.3166 32.0022 15.6692C32.0022 15.0219 31.4627 14.4824 30.8153 14.4824Z"
      fill="black"
    />
    <path
      d="M30.8105 20.3435H20.0931C19.4457 20.3435 18.9062 20.883 18.9062 21.5303C18.9062 22.1777 19.4457 22.7172 20.0931 22.7172H30.8105C31.4578 22.7172 31.9973 22.1777 31.9973 21.5303C31.9973 20.883 31.4578 20.3435 30.8105 20.3435Z"
      fill="black"
    />
    <path
      d="M6.82425 1.21064C6.39268 0.77907 5.60146 0.77907 5.16989 1.21064L0.350653 6.02988C-0.116884 6.49742 -0.116884 7.2167 0.350653 7.68424C0.818191 8.15178 1.53748 8.15178 2.00502 7.68424L4.81024 4.87902V21.9262C4.81024 22.5735 5.34971 23.113 5.99707 23.113C6.64443 23.113 7.1839 22.5735 7.1839 21.9262V4.84305L9.98912 7.64828C10.2049 7.86406 10.5286 8.00792 10.8163 8.00792C11.104 8.00792 11.4277 7.90003 11.6435 7.64828C12.111 7.18074 12.111 6.46145 11.6435 5.99391L6.82425 1.21064Z"
      fill="black"
    />
  </svg>
);

export const Filter = () => (
  <svg
    className="w-full h-full max-w-[14px] sm:max-w-[16px]"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.907 11.83L23.8476 1.23347C24.0103 1.04168 24.0454 0.773574 23.94 0.545644C23.8336 0.317709 23.6056 0.172119 23.3546 0.172119H0.645403C0.394374 0.172119 0.166434 0.317717 0.0600132 0.545644C-0.0454201 0.77358 -0.0102757 1.04168 0.152393 1.23347L9.093 11.83C9.19441 11.9465 9.24863 12.0981 9.24462 12.2537V23.4968C9.2416 23.6233 9.3129 23.7398 9.42636 23.795C9.54083 23.8512 9.67639 23.8342 9.7738 23.7538L14.7552 19.6621V12.2538C14.7512 12.0981 14.8056 11.9465 14.907 11.83Z"
      fill="black"
    />
  </svg>
);

export const StudentDashboardLogo = () => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.3084 45.9995C22.364 45.9995 19.1672 42.8029 19.1672 38.8583V18.7911H38.8588C42.8032 18.7911 46 21.9876 46 25.9322V38.8588C46 42.8032 42.8035 46 38.8588 46L26.3084 45.9995ZM11.9491 45.9995H3.38355C2.48533 45.9995 1.62576 45.6439 0.991707 45.0099C0.357655 44.3758 5.34058e-05 43.5142 5.34058e-05 42.618V22.1767C5.34058e-05 21.2785 0.355671 20.4189 0.991707 19.7849C1.62576 19.1508 2.48736 18.7932 3.38355 18.7932H15.3326V42.6181C15.3326 43.5143 14.977 44.3759 14.341 45.0099C13.7069 45.644 12.8453 45.9995 11.9491 45.9995ZM11.9491 -5.72205e-05C13.8187 -5.72205e-05 15.3326 1.51594 15.3326 3.38345V15.3325H3.3835C1.51391 15.3325 0 13.8186 0 11.949V3.3835C0 1.51599 1.51397 -3.8147e-06 3.3835 -3.8147e-06L11.9491 -5.72205e-05ZM22.5487 -5.72205e-05H42.6138C44.4834 -5.72205e-05 45.9973 1.51594 45.9973 3.38345V11.949C45.9973 13.8165 44.4834 15.3325 42.6138 15.3325H19.1651V3.3834C19.1651 1.51588 20.6792 -5.72205e-05 22.5487 -5.72205e-05Z"
      fill="#1776f0"
    />
  </svg>
);

export const NotificationBell = ({ color }: { color?: string }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 10.668C24 8.54624 23.1571 6.51141 21.6569 5.01111C20.1566 3.51082 18.1217 2.66797 16 2.66797C13.8783 2.66797 11.8434 3.51082 10.3431 5.01111C8.84286 6.51141 8 8.54624 8 10.668C8 20.0013 4 22.668 4 22.668H28C28 22.668 24 20.0013 24 10.668Z"
      stroke={color ? color : "black"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3067 28C18.0723 28.4041 17.7358 28.7395 17.331 28.9727C16.9262 29.2059 16.4672 29.3286 16 29.3286C15.5329 29.3286 15.0739 29.2059 14.6691 28.9727C14.2642 28.7395 13.9278 28.4041 13.6934 28"
      stroke={color ? color : "black"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Flag = () => (
  <svg
    className="w-full h-full"
    width="32"
    height="40"
    viewBox="0 0 32 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32 5.51979V20.7593C32 21.0143 31.8739 21.2581 31.6498 21.4381C31.4257 21.6181 31.1199 21.7193 30.8047 21.7193C29.376 21.7362 27.952 21.5956 26.5699 21.2993C25.3747 21.0537 24.1444 20.9393 22.9095 20.96C21.6675 20.9393 20.4279 21.0537 19.2256 21.2993C17.8436 21.5956 16.4196 21.7362 14.9909 21.7193C13.5622 21.7362 12.1382 21.5956 10.7585 21.2993C9.94374 21.1287 9.11034 21.0218 8.26757 20.9806V34.4408V34.4389C10.2892 34.5608 12.0891 35.5151 13.0252 36.9588L14.0711 38.6181V38.62C14.2695 38.905 14.2695 39.2537 14.0711 39.5388C13.8493 39.8219 13.4641 39.9962 13.0486 40H1.17073C0.755191 39.9963 0.370025 39.8219 0.150576 39.5388C-0.0501918 39.2538 -0.0501918 38.905 0.150576 38.62L1.22212 36.9607V36.9588C2.15825 35.4982 3.98383 34.5401 6.02652 34.4389V0.95997C6.02419 0.466881 6.48641 0.0525103 7.09807 0C7.41322 0 7.71434 0.10312 7.93379 0.283114C8.15557 0.463109 8.27463 0.708727 8.26762 0.959989V3.8399C9.30182 3.88302 10.329 4.01052 11.3305 4.22051C12.5257 4.4755 13.756 4.59738 14.9909 4.5805C16.2352 4.59738 17.4748 4.4755 18.6771 4.22051C20.0568 3.92427 21.4808 3.78365 22.9095 3.80053C24.3382 3.78365 25.7622 3.92427 27.1443 4.22051C28.3769 4.48488 29.6515 4.60675 30.9284 4.5805C31.5354 4.62175 32.0023 5.03045 32 5.51979Z"
      fill="black"
    />
  </svg>
);

// export const Globe=()=>(
//   <svg className="w-full " width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M36.4994 8.70898C33.9692 9.9692 31.2652 10.8449 28.4766 11.3073C28.9694 13.9706 29.2292 16.6718 29.253 19.3802H40.0011C39.8849 15.5603 38.669 11.8551 36.4994 8.70898Z" fill="black"/>
// <path d="M4.26562 32.3919C4.31451 32.454 4.36141 32.518 4.41098 32.5795C4.52354 32.7191 4.63903 32.8558 4.75506 32.992C4.89164 33.1523 5.02952 33.3113 5.17079 33.4668C5.29007 33.5982 5.41166 33.7271 5.53416 33.8549C5.68014 34.0074 5.8282 34.1575 5.97833 34.3052C6.10345 34.4278 6.23014 34.5486 6.35841 34.6675C6.51328 34.8115 6.67022 34.9529 6.82923 35.0917C6.96076 35.2064 7.09362 35.3195 7.22782 35.4307C7.38984 35.5648 7.55397 35.696 7.7202 35.8245C7.85801 35.9314 7.99656 36.0372 8.13698 36.1405C8.30636 36.2649 8.47821 36.3857 8.65127 36.5047C8.79425 36.6031 8.93757 36.7008 9.08293 36.7953C9.25909 36.9099 9.43794 37.0201 9.61747 37.1291C9.76572 37.219 9.91392 37.3089 10.0644 37.395C10.2469 37.4995 10.4323 37.5988 10.6179 37.6974C10.7704 37.7784 10.9227 37.86 11.0774 37.9372C11.2657 38.0311 11.4568 38.1192 11.648 38.2072C11.8049 38.2794 11.9612 38.3528 12.12 38.421C12.3143 38.5044 12.5113 38.5813 12.7081 38.6586C12.8678 38.7213 13.0267 38.7858 13.1881 38.8444C13.3884 38.9172 13.5914 38.9827 13.7941 39.0492C13.9562 39.1023 14.1173 39.1578 14.2809 39.2069C14.487 39.2687 14.6957 39.3224 14.9039 39.3776C15.0673 39.4208 15.2295 39.4673 15.394 39.5065C15.609 39.5577 15.8265 39.5999 16.0435 39.644C16.1576 39.6672 16.2713 39.6924 16.3859 39.7136C14.3912 37.8178 12.7706 34.3785 11.7854 30.0078C9.17744 30.4379 6.64493 31.2408 4.26562 32.3919Z" fill="black"/>
// <path d="M20.0017 40.0511C22.9197 40.0511 25.5301 35.8611 26.9175 29.7963C22.3322 29.1141 17.6712 29.1141 13.0859 29.7963C14.4733 35.8611 17.0838 40.0511 20.0017 40.0511Z" fill="black"/>
// <path d="M3.50171 31.3426C6.03191 30.0824 8.73593 29.2067 11.5245 28.7444C11.0316 26.081 10.7719 23.3798 10.7481 20.6714H0C0.116192 24.4913 1.33205 28.1966 3.50171 31.3426Z" fill="black"/>
// <path d="M0 19.3802H10.7481C10.7719 16.6718 11.0316 13.9706 11.5245 11.3073C8.73593 10.845 6.0319 9.96923 3.50171 8.70898C1.33206 11.8551 0.116193 15.5603 0 19.3802Z" fill="black"/>
// <path d="M24.6053 39.5065C24.7695 39.4674 24.9316 39.421 25.0946 39.3778C25.3031 39.3225 25.512 39.2687 25.7183 39.2069C25.8818 39.1579 26.043 39.1023 26.205 39.0492C26.4077 38.9828 26.6108 38.9173 26.8111 38.8445C26.9725 38.7858 27.1314 38.7213 27.2911 38.6586C27.4879 38.5813 27.6849 38.5044 27.8791 38.421C28.0379 38.3529 28.1943 38.2794 28.3512 38.2072C28.5424 38.1192 28.7335 38.0311 28.9218 37.9372C29.0764 37.8601 29.2287 37.7785 29.3813 37.6974C29.5669 37.5988 29.7522 37.4995 29.9347 37.395C30.0853 37.309 30.2335 37.2191 30.3817 37.1291C30.5612 37.0201 30.7401 36.9099 30.9162 36.7954C31.0616 36.7008 31.2049 36.6031 31.3479 36.5048C31.521 36.3857 31.693 36.2649 31.8624 36.1403C32.0026 36.0373 32.1408 35.9317 32.2783 35.8251C32.4447 35.696 32.6093 35.5644 32.772 35.4302C32.906 35.3193 33.0386 35.2065 33.1697 35.0919C33.3288 34.9531 33.4858 34.8117 33.6408 34.6676C33.7689 34.5485 33.8956 34.4277 34.0208 34.3053C34.1713 34.1579 34.3193 34.0078 34.465 33.855C34.5875 33.7271 34.7091 33.5982 34.8284 33.4668C34.9696 33.3113 35.1075 33.1524 35.2441 32.9921C35.3601 32.8559 35.4756 32.7191 35.5882 32.5795C35.6378 32.5181 35.6846 32.4541 35.7335 32.392C33.3543 31.2408 30.8217 30.4379 28.2138 30.0078C27.2286 34.3785 25.608 37.8178 23.6133 39.7137C23.7277 39.6925 23.8411 39.6673 23.9551 39.6441C24.1723 39.6 24.39 39.5577 24.6053 39.5065Z" fill="black"/>
// <path d="M40.0011 20.6714H29.253C29.2292 23.3798 28.9694 26.081 28.4766 28.7443C31.2652 29.2066 33.9692 30.0824 36.4994 31.3426C38.669 28.1966 39.8849 24.4913 40.0011 20.6714Z" fill="black"/>
// <path d="M27.1831 11.522C24.8057 11.884 22.4042 12.0636 19.9994 12.0594C17.5947 12.0636 15.1931 11.8839 12.8157 11.522C12.3272 14.1137 12.0673 16.7434 12.0391 19.3806H27.9598C27.9315 16.7434 27.6716 14.1137 27.1831 11.522Z" fill="black"/>
// <path d="M12.8157 28.53C17.5781 27.8134 22.4208 27.8134 27.1831 28.53C27.6716 25.9383 27.9315 23.3086 27.9598 20.6714H12.0391C12.0674 23.3086 12.3272 25.9382 12.8157 28.53Z" fill="black"/>
// <path d="M20.0017 0C17.0838 0 14.4733 4.18996 13.0859 10.2548C15.375 10.5992 17.6869 10.7702 20.0017 10.7664C22.3166 10.7702 24.6284 10.5992 26.9175 10.2548C25.5301 4.19002 22.9197 0 20.0017 0Z" fill="black"/>
// <path d="M35.2441 7.058C35.1075 6.89771 34.9696 6.73874 34.8284 6.58323C34.7091 6.45186 34.5875 6.32295 34.465 6.19511C34.319 6.04266 34.171 5.89255 34.0209 5.74479C33.8957 5.6222 33.769 5.50143 33.6408 5.38248C33.4858 5.23844 33.3288 5.09699 33.1697 4.95813C33.0385 4.84363 32.9059 4.73087 32.772 4.61984C32.6095 4.48541 32.445 4.3538 32.2784 4.22498C32.1408 4.11831 32.0026 4.0127 31.8624 3.90974C31.693 3.7852 31.521 3.66434 31.3479 3.54532C31.2049 3.44695 31.0616 3.34928 30.9163 3.25471C30.7401 3.14015 30.5613 3.02991 30.3817 2.92094C30.2335 2.83099 30.0853 2.7411 29.9348 2.65504C29.7522 2.55058 29.5669 2.45128 29.3813 2.35266C29.2287 2.27159 29.0765 2.19001 28.9218 2.11288C28.7335 2.01894 28.5424 1.93084 28.3512 1.84283C28.1943 1.77065 28.038 1.69721 27.8791 1.62902C27.6849 1.5456 27.4879 1.46873 27.2911 1.39146C27.1314 1.32874 26.9725 1.26423 26.8111 1.20562C26.6108 1.13281 26.4078 1.06731 26.205 1.00086C26.043 0.94776 25.8818 0.892197 25.7183 0.843145C25.512 0.78132 25.3031 0.727539 25.0947 0.672295C24.9316 0.629082 24.7696 0.582667 24.6053 0.543606C24.39 0.49235 24.1723 0.450085 23.9551 0.405977C23.8411 0.382842 23.7277 0.357614 23.6133 0.336426C25.608 2.23227 27.2286 5.67158 28.2138 10.0422C30.8217 9.61219 33.3542 8.80926 35.7335 7.65812C35.6847 7.59603 35.6377 7.53206 35.5882 7.4706C35.4756 7.33094 35.3601 7.19418 35.2441 7.058Z" fill="black"/>
// <path d="M15.394 0.543563C15.2295 0.582727 15.0673 0.629203 14.9039 0.672467C14.6957 0.727591 14.487 0.781389 14.2809 0.843162C14.1173 0.892214 13.9562 0.947777 13.7941 1.00088C13.5914 1.06733 13.3884 1.13283 13.1881 1.20564C13.0267 1.26425 12.8678 1.32875 12.7081 1.39147C12.5113 1.46875 12.3143 1.54565 12.12 1.62904C11.9612 1.69722 11.8049 1.77067 11.6479 1.84284C11.4567 1.93085 11.2657 2.01896 11.0773 2.1129C10.9227 2.19002 10.7704 2.27162 10.6179 2.35267C10.4322 2.45129 10.2469 2.5506 10.0644 2.65505C9.91391 2.74111 9.76571 2.831 9.61746 2.92096C9.43793 3.02994 9.25909 3.14018 9.08292 3.25473C8.93757 3.3493 8.79426 3.44698 8.65127 3.54533C8.4782 3.66435 8.30635 3.7851 8.13697 3.90959C7.99657 4.01284 7.85798 4.11861 7.72019 4.22554C7.55424 4.35428 7.39011 4.48555 7.22781 4.61934C7.09349 4.73047 6.96063 4.84348 6.82922 4.95837C6.67016 5.0971 6.51322 5.23848 6.3584 5.3825C6.23029 5.50163 6.10359 5.6224 5.97832 5.74482C5.82788 5.89222 5.67982 6.04233 5.53415 6.19514C5.41166 6.32299 5.29006 6.45189 5.17079 6.58326C5.02953 6.73876 4.89164 6.89773 4.75506 7.05802C4.63904 7.19423 4.52354 7.33097 4.41098 7.47059C4.3614 7.53205 4.31451 7.59603 4.26562 7.65811C6.64491 8.8093 9.17741 9.61224 11.7853 10.0423C12.7706 5.67164 14.3912 2.23227 16.3859 0.336426C16.2712 0.357666 16.1576 0.382842 16.0434 0.406081C15.8265 0.450197 15.609 0.492341 15.394 0.543563Z" fill="black"/>
// </svg>
// )

export const StudentWithBook = () => (
  <svg
    className="w-full h-full"
    width="40"
    height="50"
    viewBox="0 0 40 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.8927 11.4954C34.712 11.8567 34.3531 12.157 33.9308 12.2766C33.7502 12.3376 33.6306 12.3376 33.4499 12.3376C32.969 12.3376 32.4881 12.157 32.1878 11.798C32.0072 11.5588 31.7069 11.0168 32.0682 10.2967C32.2488 9.9354 32.6077 9.57649 32.8494 9.27622C32.9104 9.21523 32.9104 9.21523 32.969 9.15658V6.51513C32.908 6.51513 32.908 6.51513 32.8494 6.57612L20.5381 9.45923C20.3575 9.52022 20.2379 9.52022 20.0572 9.52022C19.8766 9.52022 19.757 9.52022 19.5763 9.45923L6.90358 6.57612C6.06377 6.39549 5.52184 5.79493 5.52184 5.07475C5.52184 4.35458 6.00275 3.75403 6.84256 3.51237L19.5153 0.0897308C19.8766 -0.0299103 20.2965 -0.0299103 20.6554 0.0897308L32.9666 3.51237C33.7478 3.75165 34.2873 4.35218 34.2873 5.07475C34.2873 5.31404 34.2263 5.61431 34.0481 5.79493V9.15896C34.109 9.21995 34.1677 9.2786 34.2287 9.33959C34.651 9.81346 35.3735 10.6533 34.8927 11.4954ZM29.788 9.75244C29.727 9.69145 29.5487 9.57181 29.3071 9.6328L21.4387 10.9535C20.1766 11.1928 18.8559 11.1342 17.6548 10.9535L10.5677 9.69141H10.4481C10.2675 9.69141 10.0868 9.75241 9.9672 9.87205C9.90621 9.93304 9.84756 10.0527 9.90621 10.1113L10.3261 12.1522C10.4458 12.7528 11.0463 13.2337 11.9471 13.473C17.5327 15.0353 22.9377 14.613 26.4798 14.0125C28.1008 13.7122 29.3629 12.8114 29.5435 11.7299L29.8438 9.98932C29.9071 9.87203 29.8467 9.81343 29.788 9.75244ZM27.9254 14.6764C27.5641 14.8571 27.0856 14.9157 26.6632 15.0377C24.8616 15.338 22.6401 15.6383 20.1185 15.6383C17.5356 15.6383 14.7136 15.338 11.8303 14.5568C11.5301 16.4781 12.1916 18.641 13.571 20.201C15.0723 21.822 17.2939 22.8424 19.7572 22.9645H20.2381C22.5207 22.9645 24.7422 22.1247 26.1826 20.6819C27.5666 19.2415 28.2256 17.02 27.9254 14.6764ZM28.2866 19.4808C27.9254 20.201 27.5054 20.8626 26.9659 21.4021C26.0651 22.3029 24.925 23.0231 23.6629 23.443C22.5814 23.8043 21.4413 23.9826 20.2989 23.9826H19.818C17.1155 23.8629 14.5937 22.7204 12.9117 20.8602C12.4917 20.3793 12.1305 19.8397 11.8302 19.2978C9.66726 20.4989 7.92664 22.1809 6.90619 24.1022L19.9987 26.7483L32.9105 24.1655C31.9487 22.3052 30.3275 20.6819 28.2866 19.4808ZM2.94412 31.3723H2.16293C0.961837 31.3723 0 32.3341 0 33.5352V36.9578C0 38.1589 0.961837 39.1208 2.16293 39.1208H2.94412C4.14522 39.1208 5.10705 38.1589 5.10705 36.9578V33.5938C5.10471 32.3927 4.14522 31.3723 2.94412 31.3723ZM37.8347 31.3723H37.0535C35.8524 31.3723 34.8906 32.3341 34.8906 33.5352L34.8929 36.9578C34.8929 38.1589 35.8548 39.1208 37.0559 39.1208H37.8371C39.0382 39.1208 40 38.1589 40 36.9578V33.5938C39.9977 32.3927 39.0358 31.3723 37.8347 31.3723ZM36.9949 30.3518V25.6085C36.9949 25.3082 36.8143 25.0689 36.6946 25.0079C36.3944 24.7686 35.9135 24.6466 35.4325 24.7076L20.5384 27.7104V49.9919L36.0913 46.7499C36.6309 46.6302 36.9922 46.269 36.9922 45.8491V40.2049C35.2515 40.1439 33.8698 38.7645 33.8698 37.0215V33.6575C33.8721 31.8535 35.2519 30.4128 36.9949 30.3518ZM4.62422 24.7076C4.14331 24.588 3.72339 24.7076 3.3621 25.0079C3.24246 25.1275 3.06183 25.3082 3.06183 25.6085L3.06418 30.3518C4.74619 30.4128 6.12793 31.8532 6.12793 33.5352L6.12558 36.9578C6.12558 38.6985 4.74384 40.0802 3.06183 40.1412V45.7854C3.06183 46.2053 3.4231 46.5666 3.96265 46.6862L19.5156 49.9282L19.518 27.7104L4.62422 24.7076Z"
      fill="black"
    />
  </svg>
);
export const HandWithGlobe = () => (
  <svg
    className="w-full h-full"
    width="40"
    height="37"
    viewBox="0 0 40 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.80474 20.9205H0.258242C0.189891 20.9212 0.124543 20.9486 0.0762505 20.997C0.0279581 21.0454 0.000578691 21.1108 0 21.1791V33.8228C0.000694374 33.8911 0.0281248 33.9563 0.0764049 34.0046C0.124685 34.0529 0.189967 34.0803 0.258242 34.081H3.80474V20.9205ZM4.78792 33.0921L5.55598 33.1885C6.11238 33.2544 6.65769 33.3933 7.17788 33.6014L12.801 35.8065C13.706 36.1736 14.6923 36.2936 15.659 36.1541L26.6376 34.6948C27.7385 34.5639 28.774 34.1026 29.6076 33.3716L39.2972 25.1097C39.9171 24.4181 40.1269 24.0093 39.9266 23.8834C39.5076 23.6199 38.4069 23.633 36.6246 23.9225L27.5883 29.2562C27.5197 29.2971 27.4419 29.3203 27.3621 29.3238L25.4953 29.4127L17.6013 31.215C16.4482 31.4911 15.2414 31.445 14.1126 31.0817L11.8854 30.3927C11.761 30.3545 11.657 30.2684 11.5962 30.1535C11.5353 30.0385 11.5226 29.9041 11.5609 29.7798C11.5991 29.6555 11.6852 29.5515 11.8002 29.4906C11.9151 29.4298 12.0495 29.4171 12.1738 29.4553L14.4011 30.1461C15.3652 30.4592 16.3972 30.4982 17.3822 30.259L23.5276 28.854C24.1848 28.5809 24.7562 28.1356 25.1815 27.565C25.3231 27.3568 25.379 27.1021 25.3375 26.8538C25.2745 26.6059 25.1382 26.3829 24.9464 26.2138C24.5271 25.8389 24.0111 25.5892 23.4569 25.4933L14.694 24.2132L14.6651 24.2083C13.3696 23.9622 12.1233 23.505 10.976 22.8548C9.70875 22.1801 8.686 21.6365 4.7897 21.9401V33.0921H4.78792ZM25.0117 5.7473C26.1079 5.97351 27.1781 6.3116 28.2053 6.75626C29.0554 7.11478 29.8422 7.60779 30.5357 8.21637C30.066 6.27894 29.0718 4.50832 27.662 3.09879C26.2523 1.68926 24.4815 0.695305 22.544 0.225983C23.1526 0.918498 23.6457 1.70446 24.0045 2.55372C24.4488 3.58108 24.7868 4.65117 25.0135 5.7473H25.0117ZM9.46161 8.21637C10.1543 7.60817 10.9403 7.11518 11.7893 6.75626C12.8166 6.3118 13.8867 5.97372 14.9829 5.7473C15.2096 4.65117 15.5476 3.58108 15.9919 2.55372C16.3507 1.70446 16.8438 0.918498 17.4524 0.225983C15.5152 0.695587 13.7446 1.68966 12.3351 3.09915C10.9255 4.50865 9.93133 6.27912 9.46161 8.21637ZM14.9829 15.7774C13.8867 15.5505 12.8166 15.212 11.7893 14.7671C10.9403 14.4082 10.1543 13.9152 9.46161 13.307C9.93075 15.2449 10.9247 17.0161 12.3343 18.4263C13.7439 19.8364 15.5147 20.831 17.4524 21.3009C16.8438 20.6084 16.3507 19.8225 15.9919 18.9732C15.5476 17.9458 15.2096 16.8757 14.9829 15.7796V15.7774ZM30.5357 13.3083C29.8427 13.9163 29.0564 14.4088 28.2071 14.7671C27.1798 15.2116 26.1097 15.5496 25.0135 15.7761C24.7868 16.8722 24.4488 17.9423 24.0045 18.9696C23.646 19.8202 23.1529 20.6073 22.544 21.3009C24.4817 20.8314 26.2527 19.8371 27.6625 18.4272C29.0723 17.0173 30.0664 15.2462 30.5357 13.3083ZM19.5064 5.24281C18.3424 5.26272 17.1813 5.36535 16.0319 5.54995C16.2365 4.65865 16.5228 3.7881 16.8871 2.9493C17.6014 1.34385 18.5152 0.263764 19.5064 -0.0078125V5.24281ZM19.5064 21.5325C18.5152 21.2605 17.6005 20.1813 16.8871 18.5754C16.5228 17.7366 16.2365 16.866 16.0319 15.9747C17.1813 16.1593 18.3424 16.262 19.5064 16.2819V21.5325ZM20.4905 16.2819C21.6544 16.262 22.8155 16.1593 23.9649 15.9747C23.7601 16.866 23.4739 17.7365 23.1098 18.5754C22.3986 20.1813 21.4816 21.2605 20.4905 21.5325V16.2819ZM20.4905 -0.0078125C21.4816 0.263764 22.3964 1.3434 23.1098 2.9493C23.4739 3.78817 23.7601 4.65871 23.9649 5.54995C22.8155 5.36535 21.6544 5.26272 20.4905 5.24281V-0.0078125ZM25.518 10.2703C25.498 9.10648 25.3954 7.94554 25.2108 6.79626C26.102 7.00062 26.9725 7.28689 27.811 7.65144C29.4169 8.36483 30.4966 9.27957 30.7681 10.2703H25.518ZM20.49 10.2703V6.22555C21.7272 6.24638 22.9608 6.36528 24.1792 6.58114C24.3952 7.7995 24.5141 9.03311 24.5348 10.2703H20.49ZM15.4621 10.2703C15.4831 9.03313 15.602 7.79956 15.8177 6.58114C17.0361 6.36536 18.2696 6.24646 19.5068 6.22555V10.2703H15.4621ZM9.22826 10.2703C9.49984 9.27957 10.579 8.36483 12.1854 7.65144C13.0239 7.28696 13.8944 7.00069 14.7856 6.79626C14.601 7.94554 14.4984 9.10648 14.4784 10.2703H9.22826ZM14.4784 11.2557C14.4983 12.4197 14.601 13.5808 14.7856 14.7302C13.8944 14.5258 13.0239 14.2395 12.1854 13.875C10.5795 13.1639 9.49984 12.2469 9.22826 11.2557H14.4784ZM19.5064 11.2557V15.3005C18.2692 15.2796 17.0356 15.1607 15.8172 14.9449C15.6016 13.7265 15.4827 12.4929 15.4616 11.2557H19.5064ZM24.5343 11.2557C24.5137 12.4929 24.3948 13.7265 24.1787 14.9449C22.9604 15.1607 21.7268 15.2796 20.4896 15.3005V11.2557H24.5343ZM30.7681 11.2557C30.4966 12.2469 29.4169 13.1616 27.811 13.875C26.9725 14.2396 26.102 14.5259 25.2108 14.7302C25.3954 13.5808 25.4981 12.4197 25.518 11.2557H30.7681Z"
      fill="black"
    />
  </svg>
);

export const Favourites = () => (
  <svg
    className="w-full h-full"
    width="36"
    height="37"
    viewBox="0 0 36 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.2592 7.12672C30.4931 6.36023 29.5834 5.75219 28.5822 5.33735C27.581 4.92251 26.5079 4.70898 25.4242 4.70898C24.3405 4.70898 23.2674 4.92251 22.2662 5.33735C21.265 5.75219 20.3553 6.36023 19.5892 7.12672L17.9992 8.71672L16.4092 7.12672C14.8617 5.57918 12.7628 4.70979 10.5742 4.70979C8.38565 4.70979 6.28674 5.57918 4.7392 7.12672C3.19166 8.67426 2.32227 10.7732 2.32227 12.9617C2.32227 15.1503 3.19166 17.2492 4.7392 18.7967L6.3292 20.3867L17.9992 32.0567L29.6692 20.3867L31.2592 18.7967C32.0257 18.0306 32.6337 17.1209 33.0486 16.1198C33.4634 15.1186 33.6769 14.0455 33.6769 12.9617C33.6769 11.878 33.4634 10.8049 33.0486 9.80369C32.6337 8.8025 32.0257 7.89286 31.2592 7.12672Z"
      fill="black"
    />
  </svg>
);

export const Sessions = () => (
  <svg
    className="w-full h-full"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2048 20.1628C31.6031 20.1628 32.9408 20.4236 34.1716 20.8986V11.2793L0 11.2928V37.2145C0 37.5173 0.244016 37.7613 0.54682 37.7613H21.3638C19.9953 35.9254 19.1849 33.6485 19.1849 31.1827C19.1849 29.853 19.4205 28.5778 19.8525 27.3974H18.8154C18.4771 27.3974 18.2028 27.1231 18.2028 26.7848V22.2605C18.2028 21.9222 18.4771 21.6479 18.8154 21.6479H23.3397C23.629 21.6479 23.8716 21.8485 23.9355 22.1186C25.715 20.8855 27.8761 20.1628 30.2048 20.1628ZM10.8314 29.7046H15.3557C15.694 29.7046 15.9684 29.9789 15.9684 30.3172V34.8415C15.9684 35.1798 15.694 35.4541 15.3557 35.4541H10.8314C10.4932 35.4541 10.2188 35.1798 10.2188 34.8415V30.3172C10.2188 29.9789 10.4932 29.7046 10.8314 29.7046ZM2.84748 29.7046H7.3718C7.71007 29.7046 7.98441 29.9789 7.98441 30.3172V34.8415C7.98441 35.1798 7.71007 35.4541 7.3718 35.4541H2.84748C2.50921 35.4541 2.23487 35.1798 2.23487 34.8415V30.3172C2.23487 29.9789 2.50921 29.7046 2.84748 29.7046ZM2.84748 21.6483H7.3718C7.71007 21.6483 7.98441 21.9227 7.98441 22.261V26.7853C7.98441 27.1235 7.71007 27.3979 7.3718 27.3979H2.84748C2.50921 27.3979 2.23487 27.1235 2.23487 26.7853V22.261C2.23487 21.9227 2.50921 21.6483 2.84748 21.6483ZM10.8314 21.6483H15.3557C15.694 21.6483 15.9684 21.9227 15.9684 22.261V26.7853C15.9684 27.1235 15.694 27.3979 15.3557 27.3979H10.8314C10.4932 27.3979 10.2188 27.1235 10.2188 26.7853V22.261C10.2188 21.9227 10.4932 21.6483 10.8314 21.6483ZM26.7998 13.5916H31.3241C31.6624 13.5916 31.9367 13.866 31.9367 14.2042V18.7285C31.9367 19.0668 31.6624 19.3412 31.3241 19.3412H26.7998C26.4615 19.3412 26.1872 19.0668 26.1872 18.7285V14.2042C26.1872 13.866 26.4615 13.5916 26.7998 13.5916ZM18.8158 13.5916H23.3402C23.6784 13.5916 23.9528 13.866 23.9528 14.2042V18.7285C23.9528 19.0668 23.6784 19.3412 23.3402 19.3412H18.8158C18.4776 19.3412 18.2032 19.0668 18.2032 18.7285V14.2042C18.2032 13.866 18.4776 13.5916 18.8158 13.5916ZM10.8319 13.5916H15.3562C15.6945 13.5916 15.9688 13.866 15.9688 14.2042V18.7285C15.9688 19.0668 15.6945 19.3412 15.3562 19.3412H10.8319C10.4936 19.3412 10.2193 19.0668 10.2193 18.7285V14.2042C10.2193 13.866 10.4936 13.5916 10.8319 13.5916ZM2.84794 13.5916H7.37227C7.71053 13.5916 7.98488 13.866 7.98488 14.2042V18.7285C7.98488 19.0668 7.71053 19.3412 7.37227 19.3412H2.84794C2.50968 19.3412 2.23534 19.0668 2.23534 18.7285V14.2042C2.23534 13.866 2.50968 13.5916 2.84794 13.5916Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2049 21.3887C24.7954 21.3887 20.4102 25.774 20.4102 31.1834C20.4102 33.8881 21.5066 36.3371 23.2791 38.1091C25.0516 39.8816 27.5002 40.9781 30.2049 40.9781C35.6147 40.9781 39.9996 36.5932 39.9996 31.1834C39.9996 25.7735 35.6147 21.3887 30.2049 21.3887ZM29.5927 24.9299C29.5927 24.5917 29.8671 24.3173 30.2053 24.3173C30.5436 24.3173 30.8179 24.5917 30.8179 24.9299V30.931L33.1979 33.2937C33.4373 33.5316 33.4382 33.9179 33.2002 34.1573C32.9623 34.3962 32.576 34.3976 32.3366 34.1596L29.8083 31.6495C29.6767 31.537 29.5927 31.37 29.5927 31.1834V24.9299ZM22.073 30.6006C22.8783 30.6006 22.8783 31.8254 22.073 31.8254H21.5341C20.7288 31.8254 20.7288 30.6006 21.5341 30.6006H22.073ZM24.0429 36.5242C24.6093 35.955 25.4752 36.8158 24.9088 37.3855L24.5276 37.7667C23.9612 38.3359 23.0953 37.4751 23.6617 36.9054L24.0429 36.5242ZM29.6221 39.3157C29.6221 38.5104 30.8469 38.5104 30.8469 39.3157V39.8546C30.8469 40.6599 29.6221 40.6599 29.6221 39.8546V39.3157ZM35.5457 37.3458C34.9765 36.7794 35.8373 35.9135 36.407 36.4799L36.7882 36.8611C37.3574 37.4275 36.4965 38.2934 35.9269 37.727L35.5457 37.3458ZM38.3372 31.7666C37.5319 31.7666 37.5319 30.5418 38.3372 30.5418H38.8761C39.6814 30.5418 39.6814 31.7666 38.8761 31.7666H38.3372ZM36.3673 25.843C35.8009 26.4122 34.9349 25.5514 35.5014 24.9817L35.8825 24.6005C36.449 24.0313 37.3149 24.8921 36.7485 25.4618L36.3673 25.843ZM30.7881 23.0515C30.7881 23.8568 29.5633 23.8568 29.5633 23.0515V22.5126C29.5633 21.7073 30.7881 21.7073 30.7881 22.5126V23.0515ZM24.8645 25.0214C25.4337 25.5878 24.5729 26.4538 24.0032 25.8873L23.622 25.5062C23.0528 24.9397 23.9136 24.0738 24.4833 24.6402L24.8645 25.0214Z"
      fill="black"
    />
    <path d="M6.76052 30.9316H3.46094V34.2312H6.76052V30.9316Z" fill="black" />
    <path d="M14.7429 30.9316H11.4434V34.2312H14.7429V30.9316Z" fill="black" />
    <path d="M6.76052 22.875H3.46094V26.1746H6.76052V22.875Z" fill="black" />
    <path d="M14.7429 22.875H11.4434V26.1746H14.7429V22.875Z" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.3875 26.1746C20.9786 25.0184 21.7732 23.9719 22.7273 23.0906V22.875H19.4277V26.1741L20.3875 26.1746Z"
      fill="black"
    />
    <path d="M6.76052 14.8184H3.46094V18.1179H6.76052V14.8184Z" fill="black" />
    <path d="M14.7429 14.8184H11.4434V18.1179H14.7429V14.8184Z" fill="black" />
    <path d="M22.7273 14.8184H19.4277V18.1179H22.7273V14.8184Z" fill="black" />
    <path d="M30.7117 14.8184H27.4121V18.1179H30.7117V14.8184Z" fill="black" />
    <path
      d="M6.74881 0.210938H7.7762C8.23064 0.210938 8.59969 0.579994 8.59969 1.03443V4.08627C8.59969 4.5407 8.2311 4.9093 7.77666 4.9093H6.74881C6.29437 4.9093 5.92578 4.5407 5.92578 4.08627V1.03443C5.92578 0.579994 6.29484 0.210938 6.74928 0.210938H6.74881Z"
      fill="black"
    />
    <path
      d="M26.3958 0.211404H27.4231C27.8776 0.211404 28.2462 0.580461 28.2462 1.03443V4.08627C28.2462 4.5407 27.8776 4.9093 27.4231 4.9093H26.3953C25.9409 4.9093 25.5723 4.5407 25.5723 4.08627V1.03443C25.5723 0.579994 25.9413 0.211404 26.3958 0.211404Z"
      fill="black"
    />
    <path
      d="M16.5715 0.211404H17.5989C18.0534 0.211404 18.422 0.580461 18.422 1.03443V4.08627C18.422 4.5407 18.0534 4.9093 17.5989 4.9093H16.5711C16.1166 4.9093 15.748 4.54024 15.748 4.08627V1.03443C15.748 0.579994 16.1171 0.211404 16.5715 0.211404Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.6468 3.04883V4.08601C19.6468 5.21278 18.7239 6.13379 17.599 6.13379H16.5716C15.4458 6.13379 14.5239 5.21045 14.5239 4.08601V3.04883H9.82363V4.08601C9.82363 5.21325 8.90308 6.13379 7.77585 6.13379H6.74847C5.62217 6.13379 4.70022 5.21091 4.70022 4.08601V3.04883H0.54682C0.247282 3.04883 0 3.29611 0 3.59565V10.0735L34.1716 10.06V3.59565C34.1716 3.29378 33.9262 3.04883 33.6248 3.04883H29.4713V4.08601C29.4713 5.21325 28.5508 6.13379 27.4236 6.13379H26.3962C25.2704 6.13379 24.3479 5.21045 24.3479 4.08601V3.04883H19.6477H19.6468Z"
      fill="black"
    />
  </svg>
);

export const Resources = () => (
  <svg
    className="w-full h-full"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.1612 26.5411C32.2314 26.2955 32.4349 26.113 32.6805 26.078L36.2734 25.5867C36.5892 25.5376 36.8208 25.271 36.8208 24.9552V20.1376C36.8208 19.8428 36.6033 19.592 36.3103 19.5516L32.6806 19.0534C32.4349 19.0183 32.2314 18.8358 32.1613 18.5902C31.9087 17.7201 31.5788 16.892 31.1719 16.099L25.7192 21.5517C25.7823 21.9798 25.8034 22.4219 25.7893 22.878C25.642 26.4779 22.8 29.5303 19.2139 29.9093C14.4492 30.4146 10.4912 26.3866 11.0876 21.6218C11.5297 18.0711 14.5893 15.2992 18.1612 15.1798C18.5962 15.1657 19.0173 15.1938 19.4313 15.2499L24.8768 9.80443C24.0838 9.39742 23.2488 9.06061 22.3856 8.81499C22.14 8.74482 21.9646 8.54131 21.9295 8.29573L21.4242 4.70282C21.3821 4.38704 21.1155 4.14844 20.7997 4.14844H16.0207C15.7049 4.14844 15.4312 4.38703 15.3891 4.70282L14.8909 8.29573C14.8558 8.54134 14.6804 8.74484 14.4348 8.81499C13.4032 9.10972 12.4138 9.52374 11.4875 10.036C11.2699 10.1553 10.9962 10.1413 10.7998 9.98692L7.91563 7.8045C7.66125 7.61152 7.30511 7.63608 7.08055 7.86064L3.7052 11.229C3.48064 11.4535 3.45608 11.8079 3.6473 12.0606L5.83147 14.9552C5.98585 15.1587 5.99989 15.4254 5.8806 15.6429C5.36659 16.571 4.95255 17.5639 4.6578 18.5972C4.58938 18.8393 4.38938 19.0183 4.14028 19.0533L0.547379 19.5446C0.231599 19.5937 0 19.8604 0 20.1761V24.9551C0 25.2709 0.231572 25.5376 0.547379 25.5867L4.14028 26.0779C4.3894 26.113 4.5894 26.2919 4.6578 26.534C4.95253 27.5691 5.36654 28.5603 5.8806 29.4883C5.99989 29.7059 5.98586 29.9725 5.83147 30.176L3.6473 33.0619C3.45608 33.3146 3.48064 33.6707 3.7052 33.8953L7.08055 37.2706C7.30511 37.4952 7.663 37.5233 7.91563 37.3268L10.7998 35.1443C10.9963 34.99 11.27 34.9759 11.4875 35.0952C12.4138 35.6075 13.4015 36.0215 14.4313 36.3163C14.6734 36.3864 14.8558 36.5864 14.8909 36.8355L15.412 40.5828C15.4435 40.8092 15.6365 40.9758 15.8646 40.9758H20.7994C21.1152 40.9758 21.3819 40.7372 21.424 40.4214L21.9292 36.8355C21.9643 36.5847 22.1468 36.3847 22.3888 36.3145C23.4187 36.0197 24.4063 35.6057 25.3256 35.0952C25.5502 34.9759 25.8169 34.99 26.0204 35.1443L28.9045 37.3338C29.1572 37.5232 29.5151 37.4952 29.7396 37.2706L33.122 33.8953C33.3465 33.6707 33.3676 33.3128 33.1781 33.0602L30.9887 30.176C30.8413 29.9725 30.8203 29.7058 30.9466 29.4883C31.4518 28.562 31.8659 27.5726 32.1606 26.541L32.1612 26.5411Z"
      fill="black"
    />
    <path
      d="M18.0566 22.9195L22.1969 22.1757L18.8005 18.7793L18.0566 22.9195Z"
      fill="black"
    />
    <path
      d="M25.0589 20.2247L35.0588 10.2247L30.7501 5.91602L20.7573 15.9088L19.3398 17.3333L23.6485 21.642L25.0589 20.2247Z"
      fill="black"
    />
    <path
      d="M39.6626 5.62205C40.1117 5.17294 40.1117 4.44313 39.6626 3.98701L36.989 1.3134C36.5329 0.864284 35.8031 0.864284 35.354 1.3134L33.7891 2.87829L38.0978 7.18699L39.6626 5.62205Z"
      fill="black"
    />
    <path
      d="M31.748 4.91982L32.8007 3.86719L37.1094 8.17589L36.0567 9.22852L31.748 4.91982Z"
      fill="black"
    />
  </svg>
);

export const Settings = () => (
  <svg
    className="w-full h-full"
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.1828 17.3406H34.7635C34.3595 17.3406 34.0049 17.073 33.8907 16.686C33.6248 15.8235 33.2788 14.99 32.8543 14.1939C32.6617 13.8445 32.7214 13.4081 33.0009 13.1218L35.4197 10.7029H35.418C36.1237 9.99382 36.1237 8.84833 35.418 8.13922L32.8543 5.53973C32.1452 4.83402 30.9997 4.83402 30.2906 5.53973L27.8735 7.95856C27.5871 8.23811 27.1508 8.29607 26.7996 8.10345C26.0053 7.68071 25.17 7.33299 24.3092 7.06706C23.9206 6.96308 23.6461 6.61532 23.6359 6.21307V2.79367C23.6359 2.31126 23.445 1.84931 23.104 1.50842C22.7631 1.16752 22.3012 0.976562 21.8188 0.976562H18.1812C17.1772 0.976562 16.3641 1.78966 16.3641 2.79367V6.21307C16.3641 6.61706 16.0965 6.97162 15.7095 7.08582C14.847 7.35174 14.0135 7.69775 13.2174 8.12222C12.868 8.31484 12.4316 8.25517 12.1452 7.97562L9.70939 5.53977C9.00028 4.83406 7.85479 4.83406 7.14568 5.53977L4.56321 8.12224C3.8575 8.83135 3.8575 9.97684 4.56321 10.6859L6.98204 13.1031C7.26159 13.3895 7.31955 13.8258 7.12693 14.177C6.70419 14.9713 6.35647 15.8066 6.09054 16.6674C5.97804 17.056 5.62178 17.3219 5.21779 17.3219H1.81711C0.813099 17.3219 0 18.1367 0 19.1407V22.7766C0 23.259 0.190914 23.721 0.531855 24.0619C0.872795 24.4028 1.3347 24.5954 1.81711 24.5954H5.23651C5.6405 24.5954 5.99506 24.8613 6.10926 25.25C6.37518 26.1108 6.72119 26.9443 7.14565 27.7404C7.33827 28.0915 7.27861 28.5262 6.99906 28.8126L4.56321 31.2672C3.8575 31.9763 3.8575 33.1218 4.56321 33.8309L7.14568 36.4134C7.85479 37.1191 9.00028 37.1191 9.70939 36.4134L12.1282 33.9945H12.1265C12.4129 33.715 12.8492 33.657 13.2004 33.8496C13.9947 34.2724 14.83 34.6201 15.6908 34.886C16.0794 34.9985 16.3453 35.3548 16.3453 35.7588V39.1595C16.3453 39.6419 16.5363 40.1038 16.8772 40.4447C17.2181 40.7856 17.6818 40.9766 18.1642 40.9766H21.8C22.2825 40.9766 22.7444 40.7856 23.0853 40.4447C23.4262 40.1038 23.6189 39.6419 23.6189 39.1595V35.7401C23.6189 35.3361 23.8848 34.9815 24.2734 34.8673C25.1343 34.6014 25.9678 34.2554 26.7638 33.8309C27.115 33.6383 27.5496 33.698 27.836 33.9775L30.2548 36.3963V36.3946C30.9639 37.1003 32.1094 37.1003 32.8185 36.3946L35.401 33.8122V33.8139C36.105 33.1048 36.105 31.9593 35.401 31.2502L32.9822 28.8313C32.7026 28.545 32.643 28.1086 32.8373 27.7592C33.26 26.9631 33.6077 26.1296 33.8737 25.2671C33.9862 24.8801 34.3424 24.6125 34.7464 24.6125H38.1829C38.6653 24.6125 39.1273 24.4216 39.4681 24.0806C39.809 23.7397 40 23.2778 40 22.7954V19.1578C40 18.6754 39.8091 18.2134 39.4681 17.8725C39.1272 17.5316 38.6653 17.3406 38.1828 17.3406ZM27.2735 20.9765C27.2683 21.5919 27.1814 22.2021 27.0178 22.7953C26.8644 23.4328 26.6206 24.0448 26.2916 24.6124C25.6592 25.7187 24.7421 26.6357 23.6359 27.2681C23.0682 27.5954 22.4563 27.8409 21.8187 27.9943C20.5931 28.3335 19.2977 28.3335 18.0721 27.9943C17.4346 27.8409 16.8226 27.5971 16.255 27.2681C15.1896 26.6204 14.3117 25.705 13.7083 24.6124C13.3793 24.0448 13.1356 23.4328 12.9821 22.7953C12.6429 21.5697 12.6429 20.2742 12.9821 19.0486C13.1355 18.4111 13.381 17.7991 13.7083 17.2315C14.3561 16.1661 15.2714 15.2883 16.364 14.6849C16.9317 14.3559 17.5436 14.1121 18.1812 13.9587C19.4068 13.6195 20.7022 13.6195 21.9278 13.9587C22.5653 14.1121 23.1773 14.3559 23.7449 14.6849C24.8103 15.3326 25.6882 16.248 26.2916 17.3406C26.6206 17.9082 26.8643 18.5202 27.0178 19.1577C27.1814 19.7509 27.2683 20.3611 27.2735 20.9765Z"
      fill="black"
    />
  </svg>
);

export const Support = () => (
  <svg
    className="w-full h-full"
    width="30"
    height="41"
    viewBox="0 0 30 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.3333 39.6432C29.3334 39.8184 29.299 39.9918 29.232 40.1536C29.1651 40.3154 29.0669 40.4624 28.943 40.5863C28.8192 40.7101 28.6722 40.8083 28.5104 40.8753C28.3485 40.9422 28.1751 40.9767 28 40.9766H1.33333C1.15821 40.9767 0.984783 40.9422 0.822971 40.8753C0.661158 40.8083 0.514133 40.7101 0.390302 40.5863C0.26647 40.4624 0.168261 40.3154 0.101291 40.1536C0.0343197 39.9918 -9.96892e-05 39.8184 2.16868e-07 39.6432C2.16868e-07 35.7534 1.54523 32.0229 4.29577 29.2723C7.0463 26.5218 10.7768 24.9766 14.6667 24.9766C18.5565 24.9766 22.287 26.5218 25.0376 29.2723C27.7881 32.0229 29.3333 35.7534 29.3333 39.6432ZM14.6667 6.3099C13.0844 6.3099 11.5377 6.77909 10.2221 7.65814C8.90651 8.53719 7.88113 9.78662 7.27563 11.2484C6.67013 12.7102 6.5117 14.3188 6.82038 15.8706C7.12907 17.4225 7.89099 18.8479 9.00981 19.9667C10.1286 21.0856 11.5541 21.8475 13.1059 22.1562C14.6578 22.4649 16.2663 22.3064 17.7281 21.7009C19.1899 21.0954 20.4394 20.0701 21.3184 18.7545C22.1975 17.4389 22.6667 15.8921 22.6667 14.3099C22.6643 12.1889 21.8207 10.1554 20.321 8.6556C18.8212 7.15582 16.7877 6.31222 14.6667 6.3099ZM2.66667 18.3099C3.37363 18.309 4.05137 18.0277 4.55127 17.5278C5.05117 17.0279 5.33242 16.3502 5.33333 15.6432V12.9766C5.33333 12.2693 5.05238 11.591 4.55228 11.0909C4.05219 10.5908 3.37391 10.3099 2.66667 10.3099C1.95942 10.3099 1.28115 10.5908 0.781049 11.0909C0.280952 11.591 2.16868e-07 12.2693 2.16868e-07 12.9766V15.6432C0.00091748 16.3502 0.282164 17.0279 0.782062 17.5278C1.28196 18.0277 1.9597 18.309 2.66667 18.3099ZM14.6667 3.64323C16.4589 3.64506 18.2217 4.09876 19.7922 4.96237C21.3626 5.82599 22.6899 7.07165 23.6514 8.58415C24.4158 8.06633 25.3023 7.75741 26.223 7.68807C25.0599 5.64949 23.3782 3.95486 21.3486 2.77614C19.319 1.59742 17.0137 0.976562 14.6667 0.976562C12.3196 0.976562 10.0143 1.59742 7.98473 2.77614C5.95514 3.95486 4.27346 5.64949 3.11035 7.68807C4.03102 7.75741 4.91756 8.06633 5.68196 8.58415C6.64343 7.07165 7.97074 5.82599 9.54117 4.96237C11.1116 4.09876 12.8744 3.64506 14.6667 3.64323ZM26.6667 10.3099C25.9597 10.3108 25.282 10.5921 24.7821 11.092C24.2822 11.5919 24.0009 12.2696 24 12.9766V15.6432C24.0007 16.0882 24.1129 16.5259 24.3264 16.9163C24.5399 17.3067 24.8477 17.6375 25.2219 17.8783C25.0183 18.7576 24.5233 19.5423 23.8174 20.1048C23.1114 20.6673 22.236 20.9745 21.3333 20.9766C20.9797 20.9766 20.6406 21.117 20.3905 21.3671C20.1405 21.6171 20 21.9563 20 22.3099C20 22.6635 20.1405 23.0027 20.3905 23.2527C20.6406 23.5028 20.9797 23.6432 21.3333 23.6432C22.9212 23.6389 24.4552 23.0673 25.6587 22.0316C26.8622 20.9958 27.6561 19.5642 27.897 17.9947C28.3284 17.7713 28.6903 17.4341 28.9435 17.0195C29.1967 16.605 29.3315 16.129 29.3333 15.6432V12.9766C29.3324 12.2696 29.0512 11.5919 28.5513 11.092C28.0514 10.5921 27.3736 10.3108 26.6667 10.3099Z"
      fill="black"
    />
  </svg>
);

export const LogOut = () => (
  <svg
    className="w-full h-full"
    width="40"
    height="48"
    viewBox="0 0 40 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.8944 23.5132C40.1601 23.4982 35.1205 18.5893 35.0863 18.4864C33.8992 17.323 32.1444 19.0499 33.2843 20.2542L35.7183 22.7375H31.0366L31.0344 2.95008C31.0344 1.32596 29.7124 0.00390625 28.0883 0.00390625H2.94617C1.32205 0.00390625 0 1.32596 0 2.95008V45.0514C0 46.6755 1.32205 47.9976 2.94617 47.9976H28.0883C29.7124 47.9976 31.0344 46.6755 31.0344 45.0514V27.7899H28.5082V45.0514C28.5082 45.2871 28.3154 45.4714 28.0882 45.4714H7.66016L16.6444 41.7838C17.4608 41.4474 17.9921 40.6546 17.9921 39.7718V8.22956C17.9921 7.34463 17.4608 6.55399 16.6444 6.21758L7.66016 2.53003H28.0882C28.3154 2.53003 28.5082 2.7143 28.5082 2.94999V22.7374H22.9588C21.3004 22.7631 21.2961 25.2358 22.9588 25.2636H35.7163L33.2823 27.7469C32.1467 28.9468 33.8994 30.6846 35.0843 29.5147C36.0678 28.5248 38.1804 26.35 39.1768 25.3472C39.7017 24.8672 40.2331 24.2694 39.8924 23.5109L39.8944 23.5132Z"
      fill="currentColor"
    />
  </svg>
);

export const WhiteBanner = () => (
  <svg
    width="256"
    height="32"
    viewBox="0 0 256 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.728344 29.0866C3.32833 18.6867 4.62833 13.4867 7.52745 9.61493C10.0854 6.19882 13.508 3.52655 17.4425 1.87352C21.9018 0 27.2618 0 37.9818 0H217.559C228.431 0 233.867 0 238.369 1.9149C242.34 3.60416 245.782 6.33303 248.333 9.81417C251.225 13.7603 252.465 19.0527 254.946 29.6375L255.5 32H0L0.728344 29.0866Z"
      fill="white"
    />
  </svg>
);

export const DoubleQuotes = () => (
  <svg
    width="38"
    height="31"
    viewBox="0 0 38 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.6 0.579996L37.84 3.7C34.08 8.18 32.2 12.42 32.2 16.42C32.2 17.86 32.84 19.38 34.12 20.98C35.4 22.5 36.04 24.02 36.04 25.54C36.04 26.98 35.4 28.22 34.12 29.26C32.92 30.3 31.4 30.82 29.56 30.82C27.72 30.82 26.16 30.06 24.88 28.54C23.6 26.94 22.96 24.54 22.96 21.34C22.96 18.06 23.92 14.54 25.84 10.78C27.84 6.94 30.76 3.54 34.6 0.579996ZM11.68 0.579996L14.92 3.7C11.16 8.18 9.28 12.42 9.28 16.42C9.28 17.86 9.92 19.38 11.2 20.98C12.48 22.5 13.12 24.02 13.12 25.54C13.12 26.98 12.48 28.22 11.2 29.26C10 30.3 8.48 30.82 6.64 30.82C4.8 30.82 3.24 30.06 1.96 28.54C0.68 26.94 0.0400004 24.54 0.0400004 21.34C0.0400004 18.06 1 14.54 2.92 10.78C4.92 6.94 7.84 3.54 11.68 0.579996Z"
      fill="#1776f0"
    />
  </svg>
);

export const WhiteCalender = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="149"
    height="149"
    viewBox="0 0 149 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M117.958 24.832H31.0417C24.1841 24.832 18.625 30.3912 18.625 37.2487V124.165C18.625 131.023 24.1841 136.582 31.0417 136.582H117.958C124.816 136.582 130.375 131.023 130.375 124.165V37.2487C130.375 30.3912 124.816 24.832 117.958 24.832Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M99.332 12.418V37.2513"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.668 12.418V37.2513"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.625 62.082H130.375"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlackCalender = () => (
  <svg
    className="h-full w-full"
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M125.365 11.8674H122.086V17.5446V21.3649C122.086 27.0839 117.416 31.7366 111.675 31.7366H110.149C104.409 31.7366 99.7391 27.0839 99.7391 21.3649V17.5446V11.8674H40.2609V17.5446V21.3649C40.2609 27.0839 35.5911 31.7366 29.8496 31.7366H28.3236C22.5836 31.7366 17.9138 27.0839 17.9138 21.3649V17.5446V11.8674H14.6331C6.56444 11.8674 0 18.4078 0 26.4485V125.419C0 133.46 6.56444 140 14.6347 140H102.004C103.006 140 103.933 139.72 104.751 139.267C105.557 138.993 106.318 138.556 106.957 137.914C106.957 137.914 137.673 106.827 137.945 106.216C139.191 105.175 140 103.631 140 101.885V26.4485C140 18.4078 133.434 11.8674 125.365 11.8674ZM128.604 100.02L128.361 100.263H111.126C105.663 100.263 101.195 104.715 101.195 110.158V127.575L100.131 128.646H14.6347C12.8784 128.646 11.396 127.169 11.396 125.419V55.2541H128.606L128.604 100.02Z"
      fill="black"
    />
    <path
      d="M28.3243 0C25.0498 0 22.3867 2.65335 22.3867 5.91735V21.3663C22.3867 24.6287 25.0498 27.2821 28.3243 27.2821H29.8503C33.1247 27.2821 35.7894 24.6287 35.7894 21.3663V5.91735C35.7894 2.6549 33.1263 0 29.8503 0H28.3243Z"
      fill="black"
    />
    <path
      d="M110.15 0C106.876 0 104.211 2.65335 104.211 5.91735V21.3663C104.211 24.6287 106.874 27.2821 110.15 27.2821H111.676C114.95 27.2821 117.615 24.6287 117.615 21.3663V5.91735C117.615 2.6549 114.952 0 111.676 0H110.15Z"
      fill="black"
    />
  </svg>
);

export const DotedLine = () => (
  <svg
    width="4"
    height="64"
    viewBox="0 0 4 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="2"
      y1="8.74228e-08"
      x2="2"
      y2="64"
      stroke="black"
      strokeWidth="4"
      strokeDasharray="8 8"
    />
  </svg>
);

export const BackArrow = () => (
  <svg
    className="w-full h-full"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.3307 16H6.66406"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9974 25.3327L6.66406 15.9993L15.9974 6.66602"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GreenCompleted = () => (
  <svg
    className="w-full h-full"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 0C6.71875 0 0 6.71875 0 15C0 23.2812 6.71875 30 15 30C23.2812 30 30 23.2812 30 15C30 6.71875 23.2812 0 15 0ZM22.7188 11.375L13.9062 20.2188C13.625 20.5 13.2188 20.6875 12.8125 20.6875C12.4062 20.6875 12 20.5312 11.7188 20.2188L7.28125 15.7812C6.65625 15.1562 6.65625 14.1875 7.28125 13.5625C7.90625 12.9375 8.875 12.9375 9.5 13.5625L12.8125 16.875L20.5312 9.15625C21.1562 8.53125 22.125 8.53125 22.75 9.15625C23.3438 9.78125 23.3438 10.75 22.7188 11.375Z"
      fill="#097619"
    />
  </svg>
);

export const RedFailed = () => (
  <svg viewBox="0 0 24 24" fill="none" className="w-full h-full">
    <circle cx="12" cy="12" r="10" fill="#ef4444" />
    <path
      d="M15 9l-6 6m0-6l6 6"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const Interview = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.6303 22.159C12.1315 22.159 14.159 20.1315 14.159 17.6303C14.159 15.1291 12.1315 13.1016 9.6303 13.1016C7.12915 13.1016 5.10156 15.1291 5.10156 17.6303C5.10156 20.1315 7.12915 22.159 9.6303 22.159Z"
      fill={color ? color : "black"}
    />
    <path
      d="M13.0298 23.8574H6.23671C5.48603 23.8574 4.76609 24.1556 4.23527 24.6864C3.70446 25.2173 3.40625 25.9372 3.40625 26.6879V31.7827C3.40625 31.9329 3.46589 32.0768 3.57205 32.183C3.67822 32.2892 3.82221 32.3488 3.97234 32.3488H15.2942C15.4443 32.3488 15.5883 32.2892 15.6945 32.183C15.8006 32.0768 15.8603 31.9329 15.8603 31.7827V26.6879C15.8603 25.9372 15.5621 25.2173 15.0313 24.6864C14.5004 24.1556 13.7805 23.8574 13.0298 23.8574Z"
      fill={color ? color : "black"}
    />
    <path
      d="M22.3686 9.70592C24.8697 9.70592 26.8973 7.67833 26.8973 5.17718C26.8973 2.67602 24.8697 0.648438 22.3686 0.648438C19.8674 0.648438 17.8398 2.67602 17.8398 5.17718C17.8398 7.67833 19.8674 9.70592 22.3686 9.70592Z"
      fill={color ? color : "black"}
    />
    <path
      d="M16.375 13.1026H28.3648C28.1443 12.5972 27.7808 12.1672 27.3192 11.8655C26.8576 11.5638 26.3179 11.4035 25.7665 11.4043H18.9734C18.4219 11.4035 17.8822 11.5638 17.4206 11.8655C16.959 12.1672 16.5956 12.5972 16.375 13.1026Z"
      fill={color ? color : "black"}
    />
    <path
      d="M0.574003 29.8015H2.27228V26.688C2.27228 25.637 2.68977 24.6291 3.43291 23.8859C4.17605 23.1428 5.18397 22.7253 6.23493 22.7253H7.16898C6.15133 22.2302 5.30542 21.4415 4.74044 20.4609L0.075842 28.9523C0.026157 29.0384 0 29.136 0 29.2354C0 29.3347 0.026157 29.4324 0.075842 29.5184C0.126191 29.6056 0.1989 29.6779 0.286469 29.7276C0.374038 29.7774 0.473296 29.8029 0.574003 29.8015Z"
      fill={color ? color : "black"}
    />
    <path
      d="M14.1582 14.2346C14.6594 14.9027 15.0065 15.6734 15.1746 16.4915C15.3428 17.3095 15.3279 18.1547 15.1309 18.9663C14.934 19.7779 14.5599 20.5359 14.0354 21.1859C13.511 21.8359 12.8493 22.3618 12.0977 22.7259H13.026C14.077 22.7259 15.0849 23.1434 15.8281 23.8866C16.5712 24.6297 16.9887 25.6376 16.9887 26.6886V29.8021H23.4988C23.6006 29.8024 23.7006 29.7752 23.7883 29.7234C23.876 29.6716 23.948 29.5971 23.9969 29.5077L31.9222 15.0724C31.9719 14.9863 31.9981 14.8887 31.9981 14.7893C31.9981 14.69 31.9719 14.5923 31.9222 14.5063C31.8704 14.4212 31.7971 14.3512 31.7096 14.3035C31.6222 14.2558 31.5237 14.232 31.424 14.2346H14.1582Z"
      fill={color ? color : "black"}
    />
  </svg>
);

export const Warning = ({ color }: { color?: string }) => (
  <svg
    className="size-[20px] sm:size-[30px]"
    width="50"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"
      stroke={color ? color : "black"}
      strokeOpacity="0.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16V12"
      stroke={color ? color : "black"}
      strokeOpacity="0.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8H11.99"
      stroke={color ? color : "black"}
      strokeOpacity="0.5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const Comparison = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 24H12C11.5875 24 11.25 23.6625 11.25 23.25C11.25 22.8375 11.5875 22.5 12 22.5H21C21.825 22.5 22.5 21.825 22.5 21V16.5C22.5 16.0875 22.8375 15.75 23.25 15.75C23.6625 15.75 24 16.0875 24 16.5V21C24 22.6575 22.6575 24 21 24Z"
      fill="black"
    />
    <path
      d="M19.2825 12.9675L15.5325 9.21749C15.0675 8.75249 14.25 9.07499 14.25 9.75V11.25H12C11.5875 11.25 11.25 11.5875 11.25 12C11.25 12.4125 11.5875 12.75 12 12.75H15C15.4125 12.75 15.75 12.4125 15.75 12V11.5575L17.6925 13.5L15.75 15.4425V15C15.75 14.5875 15.4125 14.25 15 14.25H12C11.5875 14.25 11.25 14.5875 11.25 15V22.5H3C2.175 22.5 1.5 21.825 1.5 21V3C1.5 2.175 2.175 1.5 3 1.5H12C12.4125 1.5 12.75 1.16251 12.75 0.75C12.75 0.337488 12.4125 0 12 0H3C1.34251 0 0 1.34251 0 3V21C0 22.6575 1.34251 24 3 24H12C12.4125 24 12.75 23.6625 12.75 23.25V15.75H14.25V17.25C14.25 17.9175 15.06 18.255 15.5325 17.7825L19.2825 14.0325C19.575 13.74 19.575 13.2675 19.2825 12.975V12.9675Z"
      fill="black"
    />
    <path
      d="M21.0019 9.6e-05H12.0019C11.5894 9.6e-05 11.2519 0.337584 11.2519 0.750096V8.2501H9.7519V6.7501C9.7519 6.08261 8.9419 5.7451 8.46938 6.21758L4.71938 9.96758C4.42687 10.2601 4.42687 10.7326 4.71938 11.0251L8.46938 14.7751C8.9419 15.2476 9.7519 14.9101 9.7519 14.2426V12.7426H12.0019C12.4144 12.7426 12.7519 12.4051 12.7519 11.9926C12.7519 11.58 12.4144 11.2426 12.0019 11.2426H9.0019C8.58938 11.2426 8.2519 11.58 8.2519 11.9926V12.4351L6.30938 10.4926L8.2519 8.55005V8.99256C8.2519 9.40507 8.58938 9.74256 9.0019 9.74256H12.0019C12.4144 9.74256 12.7519 9.40507 12.7519 8.99256V1.5H21.0019C21.8269 1.5 22.5019 2.175 22.5019 3V13.5C22.5019 13.9125 22.8394 14.25 23.2519 14.25C23.6644 14.25 24.0019 13.9125 24.0019 13.5V3C24.0019 1.34251 22.6594 9.6e-05 21.0019 9.6e-05Z"
      fill="black"
    />
  </svg>
);

export const Sort = () => (
  <svg
    width="32"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.9644 3.94562C31.9644 3.29826 31.425 2.75879 30.7776 2.75879H13.8743C13.227 2.75879 12.6875 3.29826 12.6875 3.94562C12.6875 4.59298 13.227 5.13244 13.8743 5.13244H30.7776C31.4609 5.13244 31.9644 4.59298 31.9644 3.94562Z"
      fill="black"
    />
    <path
      d="M30.8116 8.65625H15.5267C14.8793 8.65625 14.3398 9.19572 14.3398 9.84308C14.3398 10.4904 14.8793 11.0299 15.5267 11.0299H30.8116C31.4589 11.0299 31.9984 10.4904 31.9984 9.84308C31.9984 9.19572 31.4589 8.65625 30.8116 8.65625Z"
      fill="black"
    />
    <path
      d="M30.8153 14.4829H17.7962C17.1488 14.4829 16.6094 15.0224 16.6094 15.6697C16.6094 16.3171 17.1488 16.8566 17.7962 16.8566H30.8153C31.4627 16.8566 32.0022 16.3171 32.0022 15.6697C32.0022 15.0224 31.4627 14.4829 30.8153 14.4829Z"
      fill="black"
    />
    <path
      d="M30.8105 20.3438H20.0931C19.4457 20.3438 18.9062 20.8832 18.9062 21.5306C18.9062 22.1779 19.4457 22.7174 20.0931 22.7174H30.8105C31.4578 22.7174 31.9973 22.1779 31.9973 21.5306C31.9973 20.8832 31.4578 20.3438 30.8105 20.3438Z"
      fill="black"
    />
    <path
      d="M6.82425 1.21089C6.39268 0.779314 5.60146 0.779314 5.16989 1.21089L0.350653 6.03012C-0.116884 6.49766 -0.116884 7.21695 0.350653 7.68449C0.818191 8.15202 1.53748 8.15202 2.00502 7.68449L4.81024 4.87926V21.9264C4.81024 22.5738 5.34971 23.1132 5.99707 23.1132C6.64443 23.1132 7.1839 22.5738 7.1839 21.9264V4.8433L9.98912 7.64852C10.2049 7.86431 10.5286 8.00817 10.8163 8.00817C11.104 8.00817 11.4277 7.90027 11.6435 7.64852C12.111 7.18098 12.111 6.4617 11.6435 5.99416L6.82425 1.21089Z"
      fill="black"
    />
  </svg>
);

export const Download = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.037 19.4566C12.5978 19.4566 11.4053 18.0886 9.75644 15.9832C9.44118 15.5967 9.19444 15.2458 9.019 15.0704C8.42275 14.4385 8.42275 13.4557 9.05463 12.8594C9.68651 12.2632 10.6693 12.2632 11.2656 12.8951C11.5109 13.1404 11.8276 13.5612 12.2127 14.0533C12.2826 14.1588 12.3881 14.2644 12.458 14.3686V2.29704C12.458 1.4198 13.1598 0.753662 14.0014 0.753662C14.843 0.753662 15.5448 1.45545 15.5448 2.29704V14.403C15.6504 14.2631 15.7203 14.1576 15.7902 14.0877C16.1767 13.597 16.5276 13.1748 16.7373 12.9295C17.3335 12.2976 18.3163 12.2976 18.9482 12.8938C19.5801 13.4901 19.5801 14.4729 18.9839 15.1047C18.8084 15.2802 18.5631 15.6311 18.2464 16.0176C16.6688 18.0531 15.4762 19.4566 14.037 19.4566Z"
      fill="#5E91FF"
    />
    <path
      d="M21.8254 27.2465H6.2463C1.5092 27.2465 0 25.7373 0 21.0002C0 20.1229 0.701792 19.4568 1.54338 19.4568C2.38497 19.4568 3.08676 20.1586 3.08676 21.0002C3.08676 24.0184 3.1923 24.1226 6.20917 24.1226H21.7883C24.8065 24.1226 24.9107 24.017 24.9107 21.0002C24.9107 20.1229 25.6125 19.4568 26.454 19.4568C27.3313 19.4568 27.9974 20.1586 27.9974 21.0002C28.0714 25.7373 26.5625 27.2465 21.8254 27.2465Z"
      fill="#5E91FF"
    />
  </svg>
);

export const MapPin = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="32"
    height="32"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_673_4030)">
      <path
        d="M21 10.5C21 17.5 12 23.5 12 23.5C12 23.5 3 17.5 3 10.5C3 8.11305 3.94821 5.82387 5.63604 4.13604C7.32387 2.44821 9.61305 1.5 12 1.5C14.3869 1.5 16.6761 2.44821 18.364 4.13604C20.0518 5.82387 21 8.11305 21 10.5Z"
        stroke={color ? color : "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13.5C13.6569 13.5 15 12.1569 15 10.5C15 8.84315 13.6569 7.5 12 7.5C10.3431 7.5 9 8.84315 9 10.5C9 12.1569 10.3431 13.5 12 13.5Z"
        stroke={color ? color : "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_673_4030">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const ShareIcon = () => (
  <svg
    width="28"
    height="32"
    viewBox="0 0 28 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6654 30.3893C25.0586 30.3893 26.9987 28.4492 26.9987 26.056C26.9987 23.6628 25.0586 21.7227 22.6654 21.7227C20.2721 21.7227 18.332 23.6628 18.332 26.056C18.332 28.4492 20.2721 30.3893 22.6654 30.3893Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.6654 10.1667C25.0586 10.1667 26.9987 8.22657 26.9987 5.83333C26.9987 3.4401 25.0586 1.5 22.6654 1.5C20.2721 1.5 18.332 3.4401 18.332 5.83333C18.332 8.22657 20.2721 10.1667 22.6654 10.1667Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33333 20.2778C7.72657 20.2778 9.66667 18.3377 9.66667 15.9444C9.66667 13.5512 7.72657 11.6111 5.33333 11.6111C2.9401 11.6111 1 13.5512 1 15.9444C1 18.3377 2.9401 20.2778 5.33333 20.2778Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.07422 18.1252L18.9398 23.8741"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9253 8.01367L9.07422 13.7626"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ReqIcon = () => (
  <svg
    className="w-[25px] sm:w-[32px]"
    width="32"
    height="40"
    viewBox="0 0 32 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9401 6.60935H19.3908V3.99003H25.5595V8.87874L23.8953 11.7602L22.9384 13.4154L22.9401 6.60935ZM23.897 24.363C24.0819 24.3918 24.2327 24.5264 24.283 24.7059L24.5092 25.521C24.6457 25.8675 24.9275 26.1368 25.2794 26.2571C25.371 26.2948 25.4643 26.3253 25.5613 26.3486V17.6324L23.9275 20.4618V20.4636C23.9186 20.4797 23.9078 20.4941 23.897 20.5085C23.8557 20.5623 23.8055 20.6072 23.748 20.6395L22.9401 21.0955V24.2857C23.2561 24.2929 23.5721 24.3181 23.8863 24.3612C23.8898 24.3612 23.8916 24.3612 23.8952 24.3629L23.897 24.363ZM7.42514 32.2354V28.1063H3.29595L7.42514 32.2354ZM18.4357 6.94853H7.12364V2.27721H10.032C10.251 2.27721 10.4413 2.1282 10.4952 1.91456C10.7591 0.866131 11.7034 0.131836 12.7842 0.131836C13.8668 0.131836 14.8093 0.866131 15.0732 1.91456C15.1271 2.1282 15.3192 2.27721 15.5382 2.27721H18.434L18.4357 6.94853ZM14.4178 2.78166C14.4178 2.1192 14.0192 1.52136 13.407 1.26821C12.7949 1.01508 12.0911 1.15511 11.6225 1.62368C11.154 2.09224 11.0139 2.79602 11.2671 3.4082C11.5202 4.02038 12.118 4.41894 12.7787 4.42073C13.6836 4.41893 14.416 3.68646 14.4178 2.78166ZM12.7823 2.09944H12.7805C12.5058 2.09944 12.2563 2.2646 12.1503 2.51953C12.0444 2.77447 12.1018 3.06889 12.2975 3.26458C12.4932 3.45847 12.7859 3.51772 13.0408 3.41179C13.2957 3.30587 13.4627 3.05633 13.4627 2.78164C13.4609 2.40463 13.1557 2.10121 12.7787 2.10121L12.7823 2.09944ZM19.3012 13.8283H12.1306C11.8667 13.8283 11.653 14.0419 11.653 14.3059C11.653 14.5698 11.8666 14.7852 12.1306 14.7852H19.3012C19.5651 14.7852 19.7787 14.5698 19.7787 14.3059C19.7787 14.0419 19.5651 13.8283 19.3012 13.8283ZM11.6549 11.9432C11.6549 12.2071 11.8685 12.4226 12.1324 12.4226H19.303C19.567 12.4226 19.7806 12.2071 19.7806 11.9432C19.7806 11.6793 19.567 11.4657 19.303 11.4657H12.1324C12.005 11.4657 11.8829 11.5159 11.7931 11.6057C11.7034 11.6955 11.6531 11.8175 11.6549 11.945L11.6549 11.9432ZM12.1324 22.354H19.303C19.4323 22.3576 19.558 22.3091 19.6495 22.2193C19.7429 22.1278 19.795 22.0039 19.795 21.8746C19.795 21.7454 19.7429 21.6215 19.6495 21.5317C19.558 21.442 19.4323 21.3935 19.303 21.3971H12.1324C12.0032 21.3935 11.8775 21.442 11.7842 21.5317C11.6908 21.6215 11.6387 21.7454 11.6387 21.8746C11.6387 22.0039 11.6908 22.1278 11.7842 22.2193C11.8775 22.3091 12.0032 22.3576 12.1324 22.354ZM12.1324 19.9932H18.2653C18.5238 19.9842 18.7285 19.7723 18.7285 19.5138C18.7285 19.2553 18.5238 19.0435 18.2653 19.0362H12.1324C12.0032 19.0327 11.8775 19.0811 11.7842 19.1709C11.6908 19.2607 11.6387 19.3845 11.6387 19.5138C11.6387 19.6431 11.6908 19.7669 11.7842 19.8585C11.8775 19.9483 12.0032 19.9968 12.1324 19.9932ZM5.54002 13.1066C5.45025 13.1964 5.39998 13.3184 5.39998 13.4441C5.39998 13.5716 5.45025 13.6937 5.54002 13.7834L6.74466 14.9917C6.93137 15.1766 7.23477 15.1766 7.42151 14.9917L10.4735 11.9379C10.6548 11.7494 10.653 11.4513 10.4681 11.2665C10.2832 11.0816 9.98516 11.0797 9.79668 11.2611L7.08402 13.9755L6.21511 13.1066C6.0284 12.9199 5.72675 12.9199 5.54002 13.1066ZM10.4733 18.8318C10.3835 18.742 10.2615 18.6917 10.1358 18.6917C10.0083 18.6917 9.88625 18.742 9.79648 18.8318L7.08382 21.5462L6.2167 20.6809C6.02819 20.4996 5.73017 20.5032 5.54528 20.6881C5.36038 20.873 5.35857 21.171 5.53989 21.3577L6.74454 22.5606H6.74633C6.8361 22.6503 6.95638 22.7024 7.08385 22.7024C7.21131 22.7024 7.33159 22.6503 7.42136 22.5606L10.4733 19.5068L10.4751 19.5086C10.5649 19.4188 10.6152 19.2967 10.6134 19.1693C10.6134 19.0436 10.5631 18.9215 10.4733 18.8318ZM31.719 6.00448L31.3061 5.7657L31.8339 4.8501C32.175 4.26126 31.9739 3.50721 31.3851 3.1661C30.7962 2.82499 30.0422 3.02786 29.7011 3.61671L29.1715 4.53411L28.7586 4.29534C28.649 4.22532 28.5144 4.20378 28.3887 4.2343C28.2613 4.26662 28.1535 4.3474 28.0889 4.46051C28.0243 4.57182 28.0081 4.70646 28.044 4.83213C28.0799 4.95601 28.1661 5.06193 28.281 5.12297L28.6939 5.36174L26.4659 9.21981L26.4336 9.27367L23.8466 13.7529L23.8089 13.8194L21.2021 18.3381L21.028 18.6397L21.0352 19.3471L21.0513 21.0634L22.5486 20.2196L23.1482 19.8821L23.1626 19.8731L23.3349 19.5715L25.6149 15.6218L25.6311 15.5931L30.825 6.597L31.2379 6.83578L31.2397 6.83219C31.3133 6.87527 31.3959 6.89681 31.4803 6.89681C31.6957 6.89681 31.8842 6.75139 31.9417 6.54134C31.9973 6.33309 31.9057 6.11221 31.719 6.00448ZM30.0386 31.8659C30.0799 32.3237 30.0799 32.7851 30.0386 33.2447L29.5323 33.3829V33.3811C28.904 33.593 28.4049 34.0777 28.1733 34.7006C27.8933 35.3092 27.9022 36.0148 28.2003 36.6162L28.4767 37.1081L28.4749 37.1064C28.132 37.539 27.7406 37.9286 27.3098 38.2733L26.8161 37.995V37.9932C26.2128 37.697 25.5091 37.6898 24.9005 37.9717C24.2793 38.2015 23.7946 38.7006 23.5827 39.3307L23.4445 39.837V39.8352C22.8843 39.8891 22.3188 39.8765 21.7605 39.7993L21.5935 39.2015H21.5953C21.3996 38.5893 20.9364 38.0992 20.335 37.8694C19.7569 37.6073 19.0909 37.627 18.5289 37.9232L18.0783 38.1764L18.0801 38.1782C17.6241 37.7994 17.2166 37.3667 16.8647 36.8909L17.1861 36.3218C17.1987 36.2985 17.2112 36.2751 17.222 36.2536C17.2346 36.2321 17.2453 36.2069 17.2543 36.1872H17.2561C17.4877 35.6648 17.4859 35.0687 17.2471 34.5499C17.0083 34.031 16.5595 33.6396 16.012 33.4745L15.4842 33.3291C15.4285 32.8138 15.4285 32.295 15.4842 31.7797L16.012 31.6343C16.5667 31.5212 17.0371 31.1514 17.2723 30.6361C17.5936 29.8588 17.2364 28.9324 16.8629 28.2233C17.2148 27.7457 17.6241 27.3112 18.0801 26.9324L18.529 27.1856C19.0909 27.4818 19.7587 27.5015 20.3368 27.2394C20.9364 27.0096 21.3996 26.5195 21.5953 25.9073L21.7623 25.3095C22.3206 25.2323 22.8861 25.2197 23.4463 25.2736L23.5845 25.7799C23.7964 26.41 24.2847 26.9109 24.9094 27.1407C25.2721 27.2951 25.6652 27.3615 26.0584 27.3364L26.1015 27.331C26.3529 27.3095 26.5952 27.2359 26.816 27.1138L27.308 26.8373C27.7388 27.182 28.1302 27.5734 28.4749 28.0043L28.1984 28.4962L28.2002 28.4944C27.9004 29.0958 27.8914 29.8014 28.1733 30.41C28.4031 31.0329 28.9022 31.5177 29.5323 31.7295L30.0386 31.8659ZM26.7245 32.5624C26.7227 30.9539 25.7551 29.5051 24.2686 28.8893C22.7838 28.2753 21.0729 28.6146 19.9365 29.7528C18.8001 30.8892 18.459 32.6001 19.0766 34.0849C19.6923 35.5714 21.1411 36.539 22.7497 36.539C24.9436 36.5354 26.7227 34.7563 26.7245 32.5624ZM15.7554 34.3972L14.9224 34.1674C14.7734 34.1261 14.6531 34.0148 14.601 33.8694H7.90471C7.77725 33.8694 7.65517 33.8191 7.5654 33.7276L1.80254 27.9666C1.71457 27.8768 1.66431 27.7547 1.6661 27.6291V6.13058C1.6661 6.00491 1.71637 5.88283 1.80613 5.79307C1.8941 5.70331 2.01618 5.65304 2.14365 5.65304H6.17048L6.16868 3.9888H0V35.5322H16.4627C16.4896 35.3455 16.4663 35.1552 16.3927 34.981C16.2814 34.6992 16.0462 34.4834 15.7554 34.3972Z"
      fill="black"
    />
  </svg>
);
export const ThumbUp = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1973 28.3312C29.7404 25.402 32 20.9605 32 16.0005C32 7.16564 24.8348 0.000488281 16 0.000488281C7.16516 0.000488281 0 7.16564 0 15.9991C0 24.8421 7.16516 31.9991 16 31.9991H29.2277L26.1973 28.3312ZM11.8738 13.4963L15.2905 12.756L19.4099 7.63107C20.0321 6.8519 22.2141 7.063 21.7405 9.55188C21.528 10.6783 21.2058 12.2602 21.1113 12.8755C21.0794 13.0561 21.0322 13.3089 21.3085 13.3089H24.3002C26.2294 13.3089 27.0877 13.6783 26.1974 16.0325L23.6071 22.899C23.096 24.2379 21.6863 25.0878 20.3155 24.6698L11.4572 21.9921L11.5044 14.1268C11.5044 13.8588 11.6071 13.5518 11.8738 13.4963ZM5.44889 12.8977H9.50436V22.8184H5.44889V12.8977Z"
      fill="black"
    />
  </svg>
);

export const HeartIcon = ({ isFavorite }: { isFavorite: boolean }) => (
  <svg
    className="max-w-[18px] sm:max-w-[20px] lg:max-w-[24px] xl:max-w-[28px]"
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill={isFavorite ? "red" : "none"}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2995_1347)">
      <path
        d="M23.9012 5.22321C23.3291 4.6509 22.6499 4.1969 21.9024 3.88715C21.1548 3.5774 20.3536 3.41797 19.5444 3.41797C18.7352 3.41797 17.9339 3.5774 17.1864 3.88715C16.4388 4.1969 15.7596 4.6509 15.1876 5.22321L14.0004 6.41041L12.8132 5.22321C11.6577 4.06772 10.0905 3.41857 8.45637 3.41857C6.82225 3.41857 5.25506 4.06772 4.09957 5.22321C2.94407 6.37871 2.29492 7.9459 2.29492 9.58001C2.29492 11.2141 2.94407 12.7813 4.09957 13.9368L5.28677 15.124L14.0004 23.8376L22.714 15.124L23.9012 13.9368C24.4735 13.3648 24.9275 12.6856 25.2372 11.938C25.547 11.1905 25.7064 10.3892 25.7064 9.58001C25.7064 8.77083 25.547 7.96957 25.2372 7.22202C24.9275 6.47446 24.4735 5.79526 23.9012 5.22321Z"
        stroke={isFavorite ? "red" : "white"}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2995_1347">
        <rect
          width="26.88"
          height="26.88"
          fill="white"
          transform="translate(0.560547 0.0599976)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Scholarship = ({ color }: { color?: string }) => (
  <svg
    width="32"
    height="28"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24.0601C0 24.7601 0.568575 25.3287 1.26859 25.3287C1.9686 25.3287 2.53718 24.7601 2.53718 24.0601V20.3342H3.6621e-05L0 24.0601Z"
      fill={color ? color : "black"}
    />
    <path
      d="M3.68003 18.5515V24.0599C3.6786 24.4028 3.60432 24.7413 3.46289 25.0542L12.9715 23.8713V20.7056C11.8 20.3699 10.6971 19.8342 9.70859 19.1228L3.68003 18.5515Z"
      fill={color ? color : "black"}
    />
    <path
      d="M14.1152 20.9744V27.4314L15.7438 26.62C15.9052 26.54 16.0966 26.54 16.2581 26.62L17.8866 27.4314V20.9744C16.6395 21.1958 15.3622 21.1958 14.1152 20.9744Z"
      fill={color ? color : "black"}
    />
    <path
      d="M28.3206 18.5515L22.2922 19.1229C21.3036 19.8344 20.2007 20.3701 19.0293 20.7058V23.8715L28.5379 25.0543C28.395 24.7415 28.3221 24.4029 28.3207 24.06L28.3206 18.5515Z"
      fill={color ? color : "black"}
    />
    <path
      d="M29.4629 20.3342V24.0601C29.4629 24.7601 30.0315 25.3287 30.7315 25.3287C31.4315 25.3287 32.0001 24.7601 32.0001 24.0601V20.3342H29.4629Z"
      fill={color ? color : "black"}
    />
    <path
      d="M15.9993 19.9969C18.575 19.9969 21.0465 18.9741 22.8678 17.1512C24.6907 15.3298 25.7135 12.8585 25.7135 10.2828C25.7135 7.70705 24.6906 5.23555 22.8678 3.4143C21.0464 1.59143 18.575 0.568604 15.9993 0.568604C13.4236 0.568604 10.9521 1.59147 9.13085 3.4143C7.30798 5.23573 6.28516 7.70705 6.28516 10.2828C6.28944 12.8585 7.31373 15.3271 9.13516 17.1472C10.9552 18.9687 13.4239 19.9929 15.9996 19.9972L15.9993 19.9969ZM15.9993 2.8541C17.9693 2.8541 19.8594 3.63694 21.2521 5.0298C22.6449 6.42266 23.4278 8.31267 23.4278 10.2825C23.4278 12.2525 22.6449 14.1427 21.2521 15.5353C19.8592 16.9282 17.9692 17.711 15.9993 17.711C14.0294 17.711 12.1392 16.9282 10.7466 15.5353C9.35372 14.1424 8.57087 12.2524 8.57087 10.2825C8.5723 8.31256 9.35657 6.4239 10.748 5.03126C12.1409 3.63983 14.0295 2.85552 15.9993 2.8541Z"
      fill={color ? color : "black"}
    />
    <path
      d="M16.0004 16.5683C17.6676 16.5683 19.2662 15.9054 20.4446 14.7268C21.6232 13.5482 22.286 11.9497 22.286 10.2827C22.286 8.61552 21.6232 7.01695 20.4446 5.83851C19.266 4.66007 17.6674 3.99707 16.0004 3.99707C14.3334 3.99707 12.7347 4.65993 11.5563 5.83851C10.3778 7.0171 9.71484 8.61567 9.71484 10.2827C9.71627 11.9498 10.3777 13.547 11.5563 14.7268C12.7363 15.9054 14.3334 16.5668 16.0004 16.5683ZM13.4404 7.87671C13.7033 6.96813 14.489 6.3067 15.429 6.20243V5.71099C15.429 5.39527 15.6847 5.13956 16.0004 5.13956C16.3162 5.13956 16.5719 5.39527 16.5719 5.71099V6.18528C17.6776 6.25671 18.5519 7.15241 18.5947 8.25958C18.5947 8.57529 18.339 8.831 18.0233 8.831C17.7076 8.831 17.4518 8.57529 17.4518 8.25958C17.4076 7.78956 17.0404 7.41386 16.5719 7.3567V9.9167C18.6576 10.9338 18.6633 12.1796 18.5604 12.6881C18.2976 13.5967 17.5119 14.2581 16.5719 14.3624V14.8538C16.5719 15.1695 16.3162 15.4253 16.0004 15.4253C15.6847 15.4253 15.429 15.1695 15.429 14.8538V14.3795C14.3233 14.3081 13.449 13.4124 13.4062 12.3052C13.4047 12.1538 13.4647 12.0081 13.5719 11.901C13.6776 11.7924 13.8233 11.7324 13.9748 11.731C14.2905 11.7295 14.5476 11.9838 14.549 12.2995C14.5933 12.771 14.959 13.1481 15.429 13.2081V10.6481C13.3433 9.63099 13.3376 8.38527 13.4404 7.87671Z"
      fill={color ? color : "black"}
    />
    <path
      d="M15.4296 7.36865C15.0296 7.44294 14.6996 7.72294 14.5611 8.10578C14.4982 8.42578 14.7154 8.88293 15.4296 9.34007V7.36865Z"
      fill={color ? color : "black"}
    />
    <path
      d="M17.4408 12.4601C17.5037 12.1401 17.2865 11.683 16.5723 11.2258V13.1972C16.9723 13.123 17.3023 12.843 17.4408 12.4601Z"
      fill={color ? color : "black"}
    />
  </svg>
);

export const CampIcon = () => (
  <svg
    className="size-[25px] sm:size-[32px]"
    width="32"
    height="34"
    viewBox="0 0 32 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 33.2785H8.16741V19.5988H0V22.4631H5.13492C5.4359 22.4702 5.67613 22.7175 5.67613 23.0185C5.67613 23.3209 5.43591 23.5681 5.13492 23.5752H0V25.8827H4.64187C4.79165 25.8785 4.9372 25.9364 5.0446 26.041C5.15199 26.1456 5.21275 26.2897 5.21275 26.4395C5.21275 26.5893 5.15199 26.7334 5.0446 26.838C4.9372 26.9426 4.79166 26.9991 4.64187 26.9962H0V33.2785ZM20.6406 1.27844H16.5569C16.5569 0.970392 16.3068 0.72168 16.0002 0.72168C15.6935 0.72168 15.4434 0.970377 15.4434 1.27844V4.94939L16.0002 4.56504L16.5569 4.94939V3.93623C18.1706 3.36254 20.416 3.17758 20.6406 1.27844ZM18.9238 23.5751H13.0766V32.7217H18.9238V23.5751ZM9.27973 33.2785V10.5578L16.0002 5.91741L22.7206 10.5578V33.2785H20.0372V23.0184C20.0358 22.7118 19.7871 22.463 19.4804 22.463H12.5198C12.2132 22.463 11.9631 22.7117 11.9631 23.0198V33.2784L9.27973 33.2785ZM16.0002 9.76092C14.8372 9.76092 13.7873 10.4618 13.3422 11.5371C12.8971 12.6125 13.143 13.8489 13.9668 14.6727C14.7892 15.4951 16.0256 15.741 17.1009 15.2959C18.1763 14.8508 18.8772 13.8023 18.8772 12.6379C18.8772 11.0497 17.5884 9.76233 16.0002 9.76092ZM16.0002 10.8744C15.2866 10.8744 14.6436 11.304 14.3709 11.9639C14.0982 12.6223 14.2494 13.3812 14.7539 13.8856C15.2569 14.3901 16.0157 14.5399 16.6756 14.2671C17.3341 13.9944 17.7637 13.3515 17.7637 12.6379C17.7637 11.6643 16.9738 10.8744 16.0002 10.8744ZM30.8866 18.4851L25.0408 12.6379H23.8327V18.4851H30.8866ZM8.16737 12.6379H6.96064L1.11344 18.4851H8.16741L8.16737 12.6379ZM23.8326 33.2785H32V26.9947H27.3581C27.2083 26.9989 27.0628 26.9424 26.9554 26.8378C26.848 26.7319 26.7873 26.5891 26.7873 26.4379C26.7873 26.2882 26.848 26.144 26.9554 26.0394C27.0628 25.9349 27.2083 25.8784 27.3581 25.8826H32V23.5751H26.8651C26.5641 23.5666 26.3239 23.3207 26.3239 23.0183C26.3239 22.7159 26.5641 22.4701 26.8651 22.4616H32V19.5987H23.8326V33.2785Z"
      fill="black"
    />
  </svg>
);

export const ClockIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6.5V12.5L16 14.5M22 12.5C22 18.0228 17.5228 22.5 12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5Z"
      stroke="#A5A5A5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EmailYellow = () => (
  <svg
    className="max-w-[24px] md:max-w-[42px]"
    width="42"
    height="30"
    viewBox="0 0 42 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.729 15.0003L0 27.2905V2.70955C2.54914 5.38008 7.51098 10.5852 11.729 15.0003ZM24.0041 21.5703C22.337 23.209 19.6626 23.209 17.9955 21.5703C17.0547 20.584 15.5677 19.0211 13.8227 17.2003L2.10884 29.4906H39.8905L28.1766 17.2003C26.4316 19.0363 24.9298 20.5992 24.0041 21.5703ZM21.804 19.4763C25.1725 15.9561 35.885 4.72774 39.9058 0.509766H2.0936C6.16008 4.77348 16.7664 15.8959 20.1954 19.4763C20.4078 19.6907 20.698 19.812 20.9996 19.812C21.3011 19.812 21.5916 19.6907 21.804 19.4763ZM30.271 15.0001L42 27.2904V2.69435C39.4964 5.33453 34.5196 10.5544 30.271 15.0001Z"
      fill="#EB9757"
    />
  </svg>
);

export const Graduate = () => (
  <svg
    className="w-full max-w-[25px] lg:max-w-[30px] xl:max-w-[32px]"
    width="32"
    height="40"
    viewBox="0 0 32 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.9141 9.19926C27.7696 9.48827 27.4825 9.72851 27.1447 9.82421C27.0002 9.873 26.9044 9.873 26.7599 9.873C26.3752 9.873 25.9905 9.7285 25.7502 9.44136C25.6057 9.24993 25.3655 8.81641 25.6545 8.24027C25.799 7.95125 26.0862 7.66412 26.2795 7.4239C26.3283 7.37511 26.3283 7.37511 26.3752 7.32819V5.21503C26.3264 5.21503 26.3264 5.21503 26.2795 5.26383L16.4305 7.57031C16.286 7.61911 16.1903 7.61911 16.0458 7.61911C15.9013 7.61911 15.8056 7.61911 15.6611 7.57031L5.52286 5.26383C4.85102 5.11932 4.41747 4.63887 4.41747 4.06273C4.41747 3.48659 4.8022 3.00615 5.47405 2.81283L15.6123 0.0747143C15.9013 -0.0209985 16.2372 -0.0209985 16.5243 0.0747143L26.3733 2.81283C26.9982 3.00425 27.4299 3.48467 27.4299 4.06273C27.4299 4.25416 27.3811 4.49438 27.2384 4.63887V7.33009C27.2872 7.37889 27.3342 7.42581 27.383 7.4746C27.7208 7.85369 28.2988 8.52554 27.9141 9.19926ZM23.8304 7.80488C23.7816 7.75609 23.639 7.66038 23.4457 7.70917L17.151 8.76575C16.1413 8.95717 15.0847 8.91026 14.1238 8.76575L8.4542 7.75606H8.35849C8.21398 7.75606 8.06947 7.80485 7.97376 7.90057C7.92497 7.94936 7.87805 8.04507 7.92497 8.09199L8.2609 9.72471C8.35661 10.2052 8.83704 10.5899 9.5577 10.7813C14.0262 12.0312 18.3502 11.6934 21.1838 11.2129C22.4806 10.9727 23.4903 10.2521 23.6348 9.38689L23.875 7.99439C23.9257 7.90055 23.8773 7.85368 23.8304 7.80488ZM22.3403 11.7441C22.0513 11.8886 21.6684 11.9355 21.3306 12.0331C19.8893 12.2733 18.112 12.5135 16.0948 12.5135C14.0285 12.5135 11.7708 12.2733 9.46426 11.6484C9.22404 13.1854 9.75327 14.9157 10.8568 16.1637C12.0579 17.4605 13.8351 18.2769 15.8058 18.3745H16.1905C18.0165 18.3745 19.7938 17.7027 20.946 16.5484C22.0533 15.3962 22.5805 13.6189 22.3403 11.7441ZM22.6293 15.5876C22.3403 16.1637 22.0043 16.693 21.5727 17.1246C20.8521 17.8453 19.94 18.4214 18.9303 18.7573C18.0651 19.0463 17.1531 19.189 16.2391 19.189H15.8544C13.6924 19.0933 11.6749 18.1793 10.3293 16.6911C9.9934 16.3064 9.70437 15.8747 9.46416 15.4412C7.73381 16.402 6.34131 17.7477 5.52495 19.2847L15.999 21.4016L26.3284 19.3353C25.5589 17.8471 24.262 16.5485 22.6293 15.5876ZM2.3553 25.1007H1.73035C0.76947 25.1007 0 25.8702 0 26.8311V29.5692C0 30.5301 0.76947 31.2995 1.73035 31.2995H2.3553C3.31617 31.2995 4.08564 30.5301 4.08564 29.5692V26.878C4.08377 25.9171 3.31617 25.1007 2.3553 25.1007ZM30.2678 25.1007H29.6428C28.682 25.1007 27.9125 25.8702 27.9125 26.8311L27.9144 29.5692C27.9144 30.5301 28.6838 31.2995 29.6447 31.2995H30.2697C31.2305 31.2995 32 30.5301 32 29.5692V26.878C31.9981 25.9171 31.2287 25.1007 30.2678 25.1007ZM29.5959 24.2844V20.4897C29.5959 20.2495 29.4514 20.058 29.3557 20.0093C29.1155 19.8178 28.7308 19.7202 28.346 19.769L16.4307 22.1712V39.9964L28.8731 37.4028C29.3047 37.3071 29.5937 37.0181 29.5937 36.6822V32.1668C28.2012 32.118 27.0958 31.0145 27.0958 29.6201V26.9289C27.0977 25.4857 28.2016 24.3332 29.5959 24.2844ZM3.69937 19.769C3.31465 19.6733 2.97871 19.769 2.68968 20.0093C2.59397 20.105 2.44946 20.2495 2.44946 20.4897L2.45134 24.2844C3.79695 24.3332 4.90234 25.4855 4.90234 26.8311L4.90047 29.5692C4.90047 30.9617 3.79508 32.0671 2.44946 32.1159V36.6312C2.44946 36.9672 2.73848 37.2562 3.17012 37.3519L15.6125 39.9455L15.6144 22.1712L3.69937 19.769Z"
      fill="black"
    />
  </svg>
);

export const PhoneIcon = ({ color }: { color?: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.2866 17.8882C25.4563 17.0579 24.3159 16.6593 23.1424 16.7811C21.9689 16.9029 20.9392 17.545 20.2971 18.5414L19.965 19.0507C19.4336 19.8921 18.3486 20.2243 17.3854 19.8478C13.9423 18.4971 11.5618 16.0726 10.1337 12.419C9.7905 11.5443 10.1448 10.5258 10.9862 9.98332L11.4512 9.6844C12.4365 9.05336 13.0786 8.02372 13.2115 6.85017C13.3333 5.67663 12.9347 4.53631 12.0933 3.6949L9.53586 1.13744C8.19626 -0.202152 6.10379 -0.379291 4.554 0.716739L2.373 2.27776C0.291614 3.7613 -0.538742 6.44052 0.358041 8.7986C4.17751 18.8512 11.1855 25.8592 21.2052 29.6457C21.8362 29.8782 22.4894 30 23.1316 30C24.9029 30 26.619 29.1475 27.7039 27.6308L29.2649 25.4387C30.372 23.8887 30.1949 21.7963 28.8553 20.4568L26.2866 17.8882Z"
      fill={color ? color : "#5E91FF"}
    />
  </svg>
);

export const BlueApplication = () => (
  <svg
    className="max-w-[24px] sm:max-w-[29px] w-full"
    width="29"
    height="36"
    viewBox="0 0 29 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8333 0.5H4C2.0677 0.5 0.5 2.0677 0.5 4V32C0.5 33.9323 2.0677 35.5 4 35.5H25C26.9323 35.5 28.5 33.9323 28.5 32V12.1667H20.3333C18.401 12.1667 16.8333 10.599 16.8333 8.66667V0.5ZM23.8333 18C23.8333 18.6446 23.3113 19.1667 22.6667 19.1667H14.5C13.8554 19.1667 13.3333 18.6446 13.3333 18C13.3333 17.3554 13.8554 16.8333 14.5 16.8333H22.6667C23.3113 16.8333 23.8333 17.3554 23.8333 18ZM22.6667 27.9165C23.3113 27.9165 23.8333 27.3944 23.8333 26.7498C23.8333 26.1052 23.3113 25.5831 22.6667 25.5831H14.5C13.8554 25.5831 13.3333 26.1052 13.3333 26.7498C13.3333 27.3944 13.8554 27.9165 14.5 27.9165H22.6667ZM7.69413 20.9165C7.33393 20.9165 6.99413 20.7502 6.77394 20.4659L5.41333 18.7159C5.01666 18.2069 5.10854 17.4748 5.6175 17.0796C6.12646 16.683 6.85853 16.7748 7.25374 17.2838L7.69416 17.8496L9.49665 15.5338C9.89186 15.0248 10.6239 14.9329 11.1329 15.3296C11.6419 15.7248 11.7337 16.4569 11.3371 16.9659L8.6158 20.4659C8.39414 20.7502 8.05436 20.9165 7.69413 20.9165ZM6.77394 29.2157C6.99415 29.5001 7.33394 29.6663 7.69413 29.6663C8.05434 29.6663 8.39413 29.5 8.61582 29.2157L11.3371 25.7157C11.7337 25.2067 11.6419 24.4746 11.1329 24.0794C10.624 23.6828 9.89188 23.7746 9.49667 24.2836L7.69418 26.5994L7.25376 26.0336C6.85855 25.5246 6.12648 25.4328 5.61751 25.8294C5.10855 26.2246 5.01667 26.9567 5.41334 27.4657L6.77394 29.2157Z"
      fill="#5E91FF"
    />
    <path
      d="M28.1376 9.8332C27.9698 9.49341 27.7467 9.18132 27.474 8.9086L20.0906 1.52519C19.8179 1.25248 19.5058 1.02937 19.166 0.861664V8.66657C19.166 9.31117 19.6881 9.83324 20.3327 9.83324L28.1376 9.8332Z"
      fill="#5E91FF"
    />
  </svg>
);

export const AlertTriangle = ({ color }: { color: string }) => (
  <svg
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2191 5.14694L2.92572 24.0003C2.69288 24.4035 2.56967 24.8607 2.56837 25.3263C2.56707 25.7919 2.68771 26.2498 2.91829 26.6543C3.14887 27.0588 3.48135 27.3959 3.88266 27.6321C4.28397 27.8682 4.74012 27.9952 5.20572 28.0003H27.7924C28.258 27.9952 28.7141 27.8682 29.1154 27.6321C29.5167 27.3959 29.8492 27.0588 30.0798 26.6543C30.3104 26.2498 30.431 25.7919 30.4297 25.3263C30.4284 24.8607 30.3052 24.4035 30.0724 24.0003L18.7791 5.14694C18.5414 4.75508 18.2067 4.4311 17.8073 4.20625C17.4079 3.9814 16.9574 3.86328 16.4991 3.86328C16.0407 3.86328 15.5902 3.9814 15.1908 4.20625C14.7914 4.4311 14.4567 4.75508 14.2191 5.14694Z"
      stroke={color ? color : "#B86A2F"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 12V17.3333"
      stroke={color ? color : "#B86A2F"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 22.666H16.5133"
      stroke={color ? color : "#B86A2F"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Hourglass = () => (
  <svg
    className="w-full h-full max-w-[22px] max-h-[29px]"
    width="21"
    height="32"
    viewBox="0 0 21 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 0V1.84659C0.500154 3.89326 1.0107 5.90758 1.98543 7.70723C2.96016 9.50688 4.36829 11.035 6.08239 12.1534C6.72196 12.5709 7.24734 13.1412 7.61099 13.8129C7.97464 14.4845 8.16508 15.2362 8.16508 16C8.16508 16.7638 7.97464 17.5155 7.61099 18.1871C7.24734 18.8588 6.72196 19.4291 6.08239 19.8466C4.36829 20.965 2.96016 22.4931 1.98543 24.2928C1.0107 26.0924 0.500154 28.1067 0.5 30.1534V32H20.1932V30.1534C20.193 28.1067 19.6825 26.0924 18.7078 24.2928C17.733 22.4931 16.3249 20.965 14.6108 19.8466C13.9712 19.4291 13.4458 18.8588 13.0822 18.1871C12.7185 17.5155 12.5281 16.7638 12.5281 16C12.5281 15.2362 12.7185 14.4845 13.0822 13.8129C13.4458 13.1412 13.9712 12.5709 14.6108 12.1534C16.3249 11.035 17.733 9.50688 18.7078 7.70723C19.6825 5.90758 20.193 3.89326 20.1932 1.84659V0H0.5ZM1.95455 1.45455H18.7386V1.84659C18.7383 3.65132 18.288 5.42749 17.4283 7.01433C16.5687 8.60118 15.3269 9.9486 13.8153 10.9347C12.9729 11.4843 12.2809 12.2353 11.8019 13.1198C11.3229 14.0042 11.072 14.9942 11.072 16C11.072 17.0058 11.3229 17.9958 11.8019 18.8802C12.2809 19.7647 12.9729 20.5157 13.8153 21.0653C15.3269 22.0514 16.5687 23.3988 17.4283 24.9857C18.288 26.5725 18.7383 28.3487 18.7386 30.1534V30.5455H1.95455V30.1534C1.95486 28.3487 2.40522 26.5725 3.26487 24.9857C4.12451 23.3988 5.3663 22.0514 6.87784 21.0653C7.72024 20.5157 8.41227 19.7647 8.89127 18.8802C9.37028 17.9958 9.62113 17.0058 9.62113 16C9.62113 14.9942 9.37028 14.0042 8.89127 13.1198C8.41227 12.2353 7.72024 11.4843 6.87784 10.9347C5.3663 9.9486 4.12451 8.60118 3.26487 7.01434C2.40522 5.42749 1.95486 3.65132 1.95455 1.84659V1.45455Z"
      fill="black"
    />
    <path
      d="M3.83789 6.54688H16.8536C16.0504 8.07995 14.8676 9.38152 13.4182 10.3274C12.4747 10.9431 11.6997 11.7845 11.1632 12.7752C10.6267 13.7659 10.3458 14.8748 10.3458 16.0014C10.3458 14.8748 10.0648 13.7659 9.52833 12.7752C8.99185 11.7845 8.21678 10.9431 7.27327 10.3274C5.82387 9.38152 4.64111 8.07995 3.83789 6.54688Z"
      fill="black"
    />
    <path
      d="M6.2832 29.8182L10.3456 25.7559L14.408 29.8182H6.2832Z"
      fill="black"
    />
  </svg>
);

export const Backlogs = () => (
  <svg
    className="w-full h-full max-w-[25px] sm:max-w-[32px] max-h-[25px] sm:max-h-[32px]"
    width="33"
    height="31"
    viewBox="0 0 33 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.4554 14.7515C32.2974 14.2906 31.6692 14.4074 31.2982 14.3963C31.0262 10.4907 29.2836 6.83344 26.4218 4.16186C23.5599 1.49027 19.7916 0.00304461 15.8765 0C-4.62542 0.844903 -4.62562 30.0676 15.8766 30.9122C16.0284 30.9118 16.1738 30.8512 16.2811 30.7439C16.3885 30.6366 16.4489 30.4911 16.4494 30.3393V27.0339C16.4497 26.9586 16.435 26.8839 16.4063 26.8143C16.3776 26.7447 16.3354 26.6814 16.2822 26.6282C16.2289 26.5749 16.1657 26.5327 16.0961 26.5041C16.0264 26.4754 15.9518 26.4607 15.8765 26.461C12.959 26.4572 10.1621 25.2966 8.09907 23.2336C6.03608 21.1706 4.87543 18.3736 4.87165 15.4561C5.31439 1.51544 25.049 0.621091 26.8298 14.3963L26.2856 14.3963C26.1727 14.3976 26.0627 14.4321 25.9692 14.4953C25.8757 14.5586 25.8028 14.6478 25.7595 14.7521C25.7162 14.8564 25.7044 14.971 25.7257 15.0819C25.7469 15.1928 25.8002 15.295 25.8789 15.3759L28.7031 18.2002C28.7561 18.2533 28.8191 18.2954 28.8884 18.3242C28.9577 18.3529 29.032 18.3677 29.107 18.3677C29.1821 18.3677 29.2563 18.3529 29.3257 18.3242C29.395 18.2954 29.4579 18.2533 29.5109 18.2002L32.3352 15.3759C32.4145 15.2952 32.4682 15.1929 32.4896 15.0819C32.511 14.9708 32.4991 14.8558 32.4554 14.7515Z"
      fill="black"
    />
    <path
      d="M28.6465 19.8381C28.5766 19.8107 28.5019 19.7974 28.4268 19.799C28.3517 19.8005 28.2777 19.817 28.209 19.8474C28.1402 19.8777 28.0782 19.9214 28.0265 19.9758C27.9747 20.0303 27.9343 20.0945 27.9075 20.1646C27.0947 22.2331 25.7626 24.0572 24.0397 25.461C22.3168 26.8648 20.2613 27.8009 18.0713 28.1791C17.9323 28.2066 17.8083 28.2844 17.7231 28.3977C17.6379 28.5109 17.5974 28.6516 17.6095 28.7928C17.6216 28.9339 17.6853 29.0657 17.7885 29.1628C17.8917 29.26 18.027 29.3156 18.1687 29.3191C20.5732 28.9243 22.8336 27.9108 24.7279 26.3781C26.6222 24.8454 28.0851 22.8463 28.9731 20.5771C29.0005 20.5072 29.0138 20.4325 29.0122 20.3574C29.0106 20.2823 28.9942 20.2083 28.9638 20.1396C28.9334 20.0708 28.8898 20.0088 28.8353 19.9571C28.7809 19.9053 28.7167 19.8649 28.6465 19.8381Z"
      fill="black"
    />
    <path
      d="M22.6258 10.1335L19.4062 6.9082V9.17106C19.4071 9.42703 19.5096 9.67219 19.6911 9.85265C19.8727 10.0331 20.1184 10.1341 20.3744 10.1335H22.6258Z"
      fill="black"
    />
    <path
      d="M12.3076 6.57617C11.6835 6.57712 11.0851 6.82549 10.6438 7.26684C10.2024 7.70818 9.95407 8.30651 9.95312 8.93067V21.9807C9.95408 22.6049 10.2024 23.2032 10.6438 23.6445C11.0851 24.0859 11.6835 24.3343 12.3076 24.3352H20.6143C21.2384 24.3343 21.8368 24.0859 22.2781 23.6445C22.7194 23.2032 22.9678 22.6049 22.9688 21.9807V11.2794H20.3737C19.8141 11.2792 19.2774 11.0572 18.8812 10.662C18.485 10.2669 18.2615 9.73084 18.2598 9.17127V6.57617H12.3076ZM19.8982 21.0412H13.0237C12.8732 21.039 12.7297 20.9776 12.6241 20.8704C12.5185 20.7632 12.4593 20.6188 12.4593 20.4683C12.4593 20.3178 12.5185 20.1734 12.6241 20.0662C12.7297 19.959 12.8733 19.8977 13.0237 19.8955H19.8982C20.0486 19.8977 20.1922 19.959 20.2978 20.0662C20.4034 20.1734 20.4626 20.3178 20.4626 20.4683C20.4626 20.6188 20.4034 20.7632 20.2978 20.8704C20.1922 20.9776 20.0487 21.039 19.8982 21.0412ZM19.8982 17.9591H13.0237C12.8732 17.9569 12.7297 17.8956 12.6241 17.7884C12.5185 17.6812 12.4593 17.5367 12.4593 17.3863C12.4593 17.2358 12.5185 17.0913 12.6241 16.9842C12.7297 16.877 12.8733 16.8156 13.0237 16.8134H19.8982C20.0486 16.8156 20.1922 16.877 20.2978 16.9842C20.4034 17.0913 20.4626 17.2358 20.4626 17.3863C20.4626 17.5367 20.4034 17.6812 20.2978 17.7884C20.1922 17.8956 20.0487 17.9569 19.8982 17.9591ZM19.8982 13.7371C20.0485 13.7395 20.1919 13.8009 20.2973 13.9081C20.4028 14.0153 20.4619 14.1596 20.4619 14.31C20.4619 14.4603 20.4028 14.6046 20.2973 14.7118C20.1919 14.819 20.0485 14.8804 19.8982 14.8828H13.0237C12.8734 14.8804 12.73 14.819 12.6246 14.7118C12.5191 14.6046 12.46 14.4603 12.46 14.3099C12.46 14.1596 12.5191 14.0152 12.6246 13.9081C12.7301 13.8009 12.8734 13.7395 13.0238 13.7371H19.8982Z"
      fill="black"
    />
  </svg>
);

export const ArrowRight = ({ className }: { className?: string }) => (
  <svg
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`w-full h-full ${className}`}
  >
    <path
      d="M1.5 13L7.5 7L1.5 1"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Briefcase = () => (
  <svg
    className="w-full h-full"
    width="88"
    height="79"
    viewBox="0 0 88 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M59.6404 10.8594V5.3906C59.6404 2.4218 57.2342 0 54.2654 0H33.7344C30.7656 0 28.3594 2.4219 28.3594 5.3906V10.8594H31.4844V5.3906C31.4844 4.1406 32.4844 3.125 33.7344 3.125H54.2654C55.5154 3.125 56.5154 4.1406 56.5154 5.3906V10.8594H59.6404Z"
      fill="#EB9757"
    />
    <path
      d="M3.89062 48.4062V74.6252C3.89062 76.7971 5.68753 78.5627 7.90623 78.5627H80.0942C82.313 78.5627 84.1098 76.7971 84.1098 74.6252V48.4062L50.4538 52.7031V59.2812C50.4538 61.1093 48.9694 62.5937 47.1413 62.5937H40.8601C39.032 62.5937 37.5476 61.1093 37.5476 59.2812V52.7031L3.89062 48.4062Z"
      fill="#EB9757"
    />
    <path
      d="M40.8594 45.4688H47.1406C47.246 45.4688 47.3281 45.5742 47.3281 45.6562V59.2812C47.3281 59.3867 47.246 59.4688 47.1406 59.4688H40.8594C40.7539 59.4688 40.6719 59.3633 40.6719 59.2812V45.6562C40.6719 45.5508 40.7539 45.4688 40.8594 45.4688Z"
      fill="#EB9757"
    />
    <path
      d="M82.8904 13.9844H5.1094C2.4375 13.9844 0.25 16.1563 0.25 18.8438V44.7968L2.6406 45.1093L37.5466 49.5468V45.6562C37.5466 43.8281 39.031 42.3437 40.8591 42.3437H47.1403C48.9684 42.3437 50.4528 43.8281 50.4528 45.6562V49.5468L85.3588 45.1093L87.7494 44.7968V18.8438C87.7494 16.1563 85.5623 13.9844 82.8904 13.9844Z"
      fill="#EB9757"
    />
  </svg>
);

export const WrenchMen = () => (
  <svg
    className="w-full h-full"
    width="82"
    height="78"
    viewBox="0 0 82 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.4354 21.1879H22.3575C20.8971 21.1879 20.1197 22.9728 21.1811 24.0343C21.4853 24.3385 21.9011 24.5244 22.3575 24.5244H50.4388C51.8992 24.5244 52.6767 22.7396 51.6153 21.6781C51.311 21.3772 50.8951 21.1879 50.4354 21.1879ZM38.8433 5.30003L38.8974 4.76592H33.8909L35.0944 16.4661H37.6939L38.8433 5.30003ZM23.3942 26.2557C23.2387 31.6238 24.0365 35.9135 25.7876 39.1319C27.5826 42.4245 30.4019 44.6083 34.2522 45.6799C35.7126 46.0889 37.0749 46.0889 38.5386 45.6799C42.389 44.6083 45.2083 42.4245 47.0033 39.1319C48.7577 35.9137 49.5555 31.6205 49.3966 26.2557H23.3942ZM44.9479 51.0243C43.163 54.1445 40.3132 55.7569 36.3953 55.8549C34.2926 55.8008 32.5044 55.3208 31.0305 54.4148C29.7425 53.6204 28.6811 52.4913 27.8461 51.0275C29.5837 49.6415 29.9927 47.9006 30.0468 45.8284C31.8283 46.8188 34.2893 47.7181 36.3987 47.7181C38.5081 47.7181 40.9725 46.8155 42.7505 45.8284C42.8012 47.8972 43.2103 49.6382 44.9479 51.0243ZM14.5239 76.628V55.3244C11.9953 56.2372 9.97718 57.1127 8.46611 57.9511L3.38864 73.7887C5.86654 74.9955 9.78126 75.9384 14.5239 76.628ZM20.9332 77.3615V53.2524C19.2396 53.7493 17.6812 54.2394 16.2547 54.7195V76.8616C17.7489 77.0543 19.3141 77.2195 20.9332 77.3615ZM50.1301 77.5035V52.7548L46.5096 51.7644C44.417 55.5269 41.0501 57.4638 36.4156 57.5753H36.3682C31.9398 57.5145 28.4039 55.5674 26.2811 51.7644C25.0169 52.0956 23.8134 52.4269 22.6607 52.7514V77.5001C31.3856 78.1661 41.4051 78.1661 50.1301 77.5035ZM71.0892 43.9797C70.7173 43.8242 70.3387 43.6923 69.9601 43.5808C69.6862 43.4996 69.4598 43.2867 69.3753 42.9926L68.4253 39.7H64.9975L64.0578 42.952C63.9902 43.2427 63.7705 43.4895 63.4595 43.5807C62.8273 43.7667 61.8503 44.1487 61.2892 44.4731C61.0323 44.632 60.701 44.6523 60.4171 44.4968L57.4186 42.8403L54.9948 45.2642L56.6513 48.2626C56.7865 48.5127 56.7966 48.8237 56.6513 49.0908C56.2761 49.7804 55.9583 50.5478 55.7352 51.305C55.654 51.5788 55.4411 51.8053 55.147 51.8898L51.8578 52.8398V56.2709L55.1064 57.2106C55.3971 57.2783 55.6439 57.498 55.7351 57.809C55.9211 58.4411 56.3031 59.4181 56.6275 59.9792C56.7864 60.2362 56.8067 60.5674 56.6512 60.8514L54.9947 63.8498L57.4186 66.2736L60.417 64.6172V64.6206C60.6671 64.4853 60.9748 64.4752 61.2452 64.6172C61.9348 64.9924 62.7022 65.3102 63.4594 65.5333C63.7332 65.6144 63.9597 65.8274 64.0442 66.1215L64.9942 69.4141H68.4219L69.3617 66.1621C69.4327 65.8714 69.649 65.6246 69.96 65.5333C70.5922 65.3474 71.5691 64.9654 72.1303 64.6409C72.3872 64.482 72.7185 64.4617 73.0024 64.6172L76.0009 66.2737L78.4247 63.8499L76.7682 60.8515C76.633 60.6013 76.6228 60.2903 76.7682 60.0233C77.1434 59.3336 77.4612 58.5663 77.6843 57.809C77.7654 57.5352 77.9784 57.3087 78.2725 57.2242L81.5617 56.2743L81.5651 52.8363L78.3165 51.8966C78.0258 51.829 77.779 51.6092 77.6877 51.2982C77.5018 50.6661 77.1198 49.6891 76.7953 49.1313C76.6364 48.8744 76.6162 48.5431 76.7717 48.2592L78.4281 45.2608L76.0043 42.837L73.0059 44.4934H73.0025C72.7523 44.6286 72.4447 44.6388 72.1743 44.4934C71.8329 44.3075 71.4678 44.1352 71.0892 43.9797ZM56.5401 67.8292V76.8622C55.0425 77.0515 53.4773 77.2172 51.8615 77.3625V58.0633L54.2279 58.7461L54.9209 60.4161L53.2002 63.5329C52.9872 63.8676 53.0278 64.3138 53.3185 64.6079L56.5401 67.8292ZM68.5509 71.1319L69.4028 73.7889C66.9249 74.9924 63.0104 75.9389 58.2677 76.6285V67.772L60.8504 66.3455L62.5204 67.0385L63.5244 70.5102C63.6292 70.8685 63.9605 71.1322 64.3526 71.1322L68.5509 71.1319ZM67.5334 47.6986C71.3195 48.1516 74.0239 51.5896 73.5676 55.3757C73.1146 59.1618 69.6767 61.8662 65.8905 61.4132C62.1044 60.9602 59.4 57.5223 59.8564 53.7362C60.3093 49.9467 63.7473 47.2423 67.5334 47.6986ZM1.38403 41.7726L2.47928 42.016C2.94241 42.1174 3.2365 42.5772 3.13509 43.0437C3.03367 43.5068 2.57393 43.8009 2.10743 43.6995L1.0088 43.4527L0.4375 46.0185L7.57704 47.6106L17.8467 1.59216L10.7072 0L10.1257 2.60632L11.221 2.84972C11.6841 2.95113 11.9782 3.41087 11.8768 3.87738C11.7754 4.3405 11.3156 4.6346 10.8491 4.53319L9.75052 4.28641L9.25359 6.52087L11.3935 6.99751C11.8566 7.09893 12.1507 7.55867 12.0493 8.02517C11.9479 8.4883 11.4881 8.7824 11.0216 8.68098L8.87836 8.20095L8.37806 10.4354L9.4733 10.6788C9.93643 10.7802 10.2305 11.24 10.1291 11.7065C10.0277 12.1696 9.56795 12.4637 9.10145 12.3623L8.00283 12.1155L7.5059 14.35L9.64577 14.8266C10.1089 14.928 10.403 15.3878 10.3016 15.8543C10.2002 16.3174 9.74042 16.6115 9.27392 16.5101L7.13067 16.03L6.63374 18.2645L7.72899 18.5079C8.19212 18.6093 8.48621 19.0691 8.3848 19.5356C8.28338 19.9987 7.82364 20.2928 7.35714 20.1914L6.25851 19.9446L5.76158 22.1791L7.90145 22.6557C8.36458 22.7571 8.65868 23.2169 8.55726 23.6834C8.45585 24.1465 7.9961 24.4406 7.5296 24.3392L5.38635 23.8591L4.88605 26.0936L5.9813 26.337C6.44442 26.4384 6.73852 26.8981 6.63711 27.3647C6.53569 27.8278 6.07595 28.1219 5.60945 28.0205L4.51082 27.7737L4.01389 30.0081L6.15376 30.4848C6.61689 30.5862 6.91099 31.0459 6.80957 31.5124C6.70816 31.9756 6.24841 32.2697 5.78191 32.1683L3.63866 31.6882L3.14173 33.9227L4.23698 34.1661C4.70011 34.2675 4.99421 34.7272 4.89279 35.1937C4.79137 35.6569 4.33163 35.951 3.86513 35.8496L2.76651 35.6028L2.26958 37.8372L4.40945 38.3139C4.87258 38.4153 5.16667 38.875 5.06526 39.3415C4.96384 39.8047 4.5041 40.0988 4.03759 39.9973L1.89435 39.5173L1.38403 41.7726ZM49.9952 19.4618H22.7957C22.7957 15.9664 24.06 12.7955 26.2371 10.3578L26.9977 17.2201C27.1228 18.3492 28.84 18.1599 28.715 17.0308L27.809 8.85688C29.1307 7.78526 30.6588 6.95707 32.3287 6.43982L33.4511 17.3586C33.4646 17.8251 33.8466 18.1969 34.3165 18.1969H38.4744V18.1935C38.9105 18.1935 39.2857 17.8623 39.3331 17.4194L40.4622 6.44269C42.1254 6.96328 43.6499 7.7915 44.9717 8.8665L44.0657 17.0303C43.9406 18.1594 45.6578 18.3487 45.783 17.2196L46.5436 10.364C48.724 12.8047 49.9952 15.9729 49.9952 19.4618Z"
      fill="#EB9757"
    />
  </svg>
);

export const Heart = () => (
  <svg
    className="w-full h-full"
    width="70"
    height="78"
    viewBox="0 0 70 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.4129 55.1188L16.3974 43.844C15.9004 43.3373 15.2301 43.0519 14.499 43.0391C13.7839 43.0327 13.1072 43.3117 12.6005 43.8215C11.7443 44.681 11.5744 46.0086 12.1901 47.0604L12.5172 47.6216C14.2457 50.5751 16.2242 53.3714 18.4337 55.9854L20.4765 58.4033C20.7843 58.7689 20.9319 59.2307 20.8902 59.7052C20.8517 60.1799 20.6272 60.6064 20.2648 60.9207C19.8993 61.2285 19.4375 61.3728 18.9629 61.3343C18.4883 61.2959 18.0553 61.0714 17.7507 60.7058L15.8105 58.4129C13.383 55.5428 11.2087 52.4675 9.31671 49.2191L9.11148 48.8664C7.70372 46.4517 8.03399 43.3699 9.99334 41.3817C10.1729 41.2021 10.3557 41.0257 10.5481 40.875L6.22855 31.5975C5.72828 30.5296 4.62196 29.8081 3.44825 29.7921C2.55679 29.7728 1.72616 30.1224 1.11365 30.7733C0.501154 31.4211 0.199694 32.2709 0.267094 33.1592L2.13343 57.6849C2.3066 59.9681 3.35204 62.1007 5.04844 63.6368L13.922 71.6666C14.464 72.1572 14.7943 72.8371 14.8456 73.565L15.0605 76.6147C15.115 77.3939 15.7627 78 16.5452 78H29.4176C30.2867 78 30.9729 77.2592 30.9024 76.3934L29.5876 59.702C29.3919 57.9864 28.6223 56.3605 27.4134 55.1259L27.4129 55.1188Z"
      fill="#EB9757"
    />
    <path
      d="M68.8858 30.7635C68.2701 30.1125 67.4396 29.7662 66.548 29.7822C65.3743 29.7982 64.2648 30.5198 63.7678 31.5876L59.4482 40.8651C59.6374 41.0158 59.8202 41.1922 60.003 41.3718C61.9655 43.3601 62.2927 46.445 60.8848 48.8565L60.6796 49.2093C58.7876 52.4578 56.6166 55.5331 54.1858 58.403L52.2456 60.6959C51.9378 61.0615 51.508 61.286 51.0334 61.3245C50.5588 61.3629 50.0938 61.2154 49.7315 60.9108C49.3659 60.5997 49.1446 60.17 49.1061 59.6954C49.0676 59.2207 49.212 58.7558 49.5198 58.3934L51.5626 55.9755C53.7689 53.362 55.7507 50.5657 57.4791 47.6117L57.8062 47.0505C58.4219 45.9987 58.252 44.6711 57.3958 43.8117C56.8891 43.305 56.2124 43.026 55.4973 43.0292C54.7662 43.0388 54.0992 43.3242 53.5989 43.8341L42.5834 55.109C41.3744 56.3404 40.6048 57.9695 40.4093 59.6851L39.0944 76.3765C39.0271 77.2424 39.7101 77.9831 40.5792 77.9831H53.4516C54.2341 77.9831 54.8819 77.377 54.9364 76.5978L55.1512 73.5481C55.2025 72.8202 55.536 72.1404 56.0748 71.6497L64.9484 63.6199C66.648 62.0838 67.6902 59.9512 67.8634 57.668L69.7329 33.1423C69.8003 32.254 69.4988 31.4042 68.8864 30.7565L68.8858 30.7635Z"
      fill="#EB9757"
    />
    <path
      d="M56.6309 2.13952C51.1376 -1.28218 42.688 0.0101548 38.1178 4.58955L34.8949 7.80921L31.4572 4.37151C24.7998 -2.27946 13.4252 -1.34301 8.10544 7.1935C4.68374 12.6868 5.97607 21.1364 10.5523 25.7066L32.4198 47.5774C33.7891 48.9468 36.005 48.9468 37.371 47.5774L59.4528 25.4956C66.1102 18.8383 65.1641 7.45703 56.6276 2.14059L56.6309 2.13952ZM45.7115 26.9477C45.7115 27.5537 45.2177 28.0476 44.6116 28.0476H38.74V33.9192C38.74 34.5253 38.2461 35.0191 37.6401 35.0191H32.352C31.746 35.0191 31.2521 34.5253 31.2521 33.9192V28.0476H25.3837C24.7744 28.0476 24.2838 27.5537 24.2838 26.9477V21.6596C24.2838 21.0535 24.7744 20.5597 25.3837 20.5597H31.2521V14.6881C31.2521 14.082 31.746 13.5882 32.352 13.5882H37.6401C38.2494 13.5882 38.74 14.082 38.74 14.6881V20.5597H44.6116C45.2177 20.5597 45.7115 21.0504 45.7115 21.6596V26.9477Z"
      fill="#EB9757"
    />
  </svg>
);

export const Computer = () => (
  <svg
    className="w-full h-full"
    width="90"
    height="78"
    viewBox="0 0 90 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.5662 29.6799C48.3979 30.8482 46.7838 31.5707 45.0006 31.5707C43.2174 31.5707 41.6033 30.8482 40.435 29.6799C39.2667 28.5116 38.5442 26.8975 38.5442 25.1143C38.5442 23.3311 39.2667 21.717 40.435 20.5487C41.6033 19.3804 43.2174 18.6579 45.0006 18.6579C46.7838 18.6579 48.3979 19.3804 49.5662 20.5487C50.7345 21.7171 51.457 23.3311 51.457 25.1143C51.457 26.8937 50.7345 28.5116 49.5662 29.6799ZM55.4922 19.0614C57.2331 20.4795 58.7396 21.9822 59.9617 23.5001C61.7796 20.5678 62.3214 17.7778 61.1685 15.7793C60.0156 13.7848 57.3293 12.8585 53.8781 12.9623C54.5814 14.7878 55.1309 16.8439 55.4922 19.0614ZM47.5715 14.0961C48.54 14.5534 49.5123 15.0607 50.4807 15.618C51.4492 16.1752 52.3754 16.7632 53.2554 17.3781C52.9057 15.8409 52.4599 14.4113 51.9257 13.1277C50.5422 13.3045 49.0781 13.6311 47.5715 14.0961ZM38.9169 11.3482C40.8461 11.648 42.9022 12.2014 45.0005 13.0008C47.0988 12.2014 49.1549 11.648 51.0841 11.3482C49.4508 8.30838 47.3064 6.44441 45.0005 6.44441C42.6946 6.44825 40.5502 8.31212 38.9169 11.3482ZM34.5126 31.1676C32.7717 29.7495 31.2652 28.2467 30.0431 26.7288C28.2252 29.6649 27.6834 32.455 28.8363 34.4535C29.9854 36.448 32.6755 37.3703 36.1267 37.2666C35.4196 35.4411 34.87 33.385 34.5126 31.1676ZM42.4294 36.129C41.4763 35.6794 40.5233 35.1836 39.5741 34.6379C39.5548 34.6302 39.5356 34.6187 39.5202 34.6072C38.5556 34.0499 37.6294 33.4619 36.7494 32.8508C37.0991 34.3881 37.5449 35.8139 38.0791 37.1013C39.4588 36.9207 40.9229 36.594 42.4294 36.129ZM51.0841 38.8769C49.1549 38.5771 47.0988 38.0237 45.0005 37.2243C42.9022 38.0237 40.8461 38.5771 38.9169 38.8769C40.5502 41.9167 42.6946 43.7807 45.0005 43.7807C47.3064 43.7769 49.4508 41.913 51.0841 38.8769ZM61.3376 25.3954C61.2761 25.2993 61.2147 25.2071 61.1493 25.1149C61.2147 25.0188 61.2761 24.9265 61.3376 24.8343C63.6973 21.1911 64.3698 17.5709 62.7904 14.8425C61.2147 12.1139 57.7482 10.888 53.4132 11.107C53.3018 11.1147 53.1865 11.1185 53.0712 11.1262C53.0212 11.0263 52.9713 10.9225 52.9213 10.8226C50.946 6.95641 48.1482 4.56599 45.0007 4.56599C41.8532 4.56599 39.0554 6.95641 37.0762 10.8226C37.0262 10.9225 36.9763 11.0224 36.9263 11.1262C36.811 11.1185 36.6996 11.1108 36.5881 11.107C32.2532 10.8879 28.7866 12.1138 27.211 14.8425C27.1995 14.8655 27.188 14.8848 27.1764 14.9078C25.6469 17.6287 26.3233 21.2182 28.6637 24.8347C28.7252 24.9308 28.7867 25.023 28.852 25.1153C28.7867 25.2113 28.7252 25.3036 28.6637 25.3958C26.3041 29.039 25.6353 32.6554 27.211 35.3837C28.7867 38.1122 32.2569 39.342 36.5881 39.123C36.6995 39.1153 36.8148 39.1115 36.9301 39.1038C36.9801 39.2037 37.03 39.3075 37.08 39.4074C39.0553 43.2736 41.8532 45.664 45.0045 45.664C48.152 45.664 50.9498 43.2736 52.929 39.4074C52.9789 39.3075 53.0289 39.2076 53.0788 39.1038C53.1941 39.1115 53.3056 39.1192 53.417 39.123C57.752 39.3421 61.2185 38.1162 62.7941 35.3875C64.3699 32.659 63.6973 29.0384 61.3376 25.3954ZM47.5718 36.129C48.5403 35.6717 49.5126 35.1644 50.481 34.6071C51.4495 34.0499 52.3757 33.4619 53.2557 32.847C52.906 34.3842 52.4602 35.8138 51.926 37.0974C50.5425 36.9206 49.0784 36.594 47.5718 36.129ZM31.1576 25.115C32.003 24.012 33.0138 22.9091 34.1705 21.8369C34.0822 22.9052 34.036 24.0005 34.036 25.115C34.036 26.2295 34.0822 27.3248 34.1705 28.3931C33.0138 27.321 32.0031 26.218 31.1576 25.115ZM36.1229 12.9666C35.4196 14.7883 34.8701 16.8443 34.5088 19.0618C32.7679 20.4799 31.2614 21.9826 30.0392 23.5005C28.2368 20.5875 27.6873 17.8128 28.8094 15.822L28.8325 15.7836C29.9854 13.7852 32.6755 12.859 36.1229 12.9666ZM42.4294 14.0965C41.461 14.5538 40.4886 15.0611 39.5202 15.6184L39.5164 15.6222V15.6184C38.5518 16.1756 37.6256 16.7636 36.7455 17.3747C37.0952 15.8375 37.541 14.4117 38.0753 13.1242C39.4587 13.3049 40.9229 13.6314 42.4294 14.0965ZM53.7396 20.061C52.4636 19.0656 51.0609 18.1201 49.5506 17.2478L49.5352 17.2401C48.021 16.3677 46.4992 15.626 44.9965 15.0188C43.4939 15.626 41.9682 16.3677 40.454 17.2439V17.2478C38.9398 18.1202 37.5332 19.0733 36.2535 20.0686C36.0306 21.675 35.9114 23.366 35.9114 25.1184C35.9114 26.867 36.0306 28.5619 36.2535 30.1683C37.5333 31.1636 38.936 32.1129 40.454 32.9891C40.4693 32.9968 40.4847 33.0083 40.5001 33.016C41.9989 33.8807 43.5092 34.6109 44.9965 35.2143C46.4991 34.6071 48.0287 33.8615 49.5429 32.9892C51.0571 32.1168 52.4598 31.1675 53.7395 30.1721C53.9624 28.5657 54.0816 26.8709 54.0816 25.1223C54.0816 23.3622 53.9663 21.6674 53.7396 20.061ZM58.8432 25.1146C57.9977 26.2176 56.987 27.3206 55.8302 28.3927C55.9186 27.3244 55.9686 26.2291 55.9686 25.1146C55.9686 24.0001 55.9225 22.9048 55.8302 21.8365C56.9832 22.9048 57.9977 24.0078 58.8432 25.1146ZM61.1683 34.4457C60.0154 36.4402 57.3291 37.3665 53.8779 37.2627C54.5812 35.441 55.1307 33.385 55.492 31.1676C57.2329 29.7495 58.7394 28.2467 59.9615 26.7288C61.7755 29.6611 62.3173 32.4511 61.1683 34.4457ZM28.0023 78H61.9987V73.9148H27.9984L28.0023 78ZM37.1834 64.3414L34.7738 72.0315H55.2228L52.8132 64.3414H37.1834ZM89.2341 51.525H0.765851V58.9999C0.765851 59.9492 1.154 60.8177 1.78432 61.4442C2.41074 62.0706 3.27925 62.4626 4.22855 62.4626H85.7756C86.7248 62.4626 87.5934 62.0745 88.2198 61.4442C88.8462 60.8177 89.2383 59.9492 89.2383 58.9999L89.2341 51.525ZM0.765851 49.6419H89.2341V3.4627C89.2341 2.51346 88.846 1.64487 88.2157 1.01846C87.5892 0.392038 86.7207 0 85.7714 0H4.22442C3.27518 0 2.40659 0.388152 1.78018 1.01846C1.15376 1.64489 0.761719 2.50956 0.761719 3.4627L0.765851 49.6419ZM45 29.6888C46.2644 29.6888 47.4058 29.1776 48.2359 28.3475C49.0622 27.5212 49.5772 26.376 49.5772 25.1116C49.5772 23.8471 49.066 22.7058 48.2359 21.8756C47.4097 21.0494 46.2644 20.5344 45 20.5344C43.7356 20.5344 42.5942 21.0455 41.7641 21.8756C40.9378 22.7019 40.4228 23.8471 40.4228 25.1116C40.4228 26.376 40.9339 27.5173 41.7641 28.3475C42.5942 29.1777 43.7356 29.6888 45 29.6888Z"
      fill="#EB9757"
    />
  </svg>
);

export const Gavel = () => (
  <svg
    className="w-full h-full"
    width="92"
    height="78"
    viewBox="0 0 92 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.8241 37.0712L8.92987 50.471C5.35097 51.6413 1.51774 49.6229 0.466074 46.0101C-0.58559 42.3973 1.56854 38.6318 5.21528 37.716L46.941 27.1659L49.8241 37.0712Z"
      fill="#EB9757"
    />
    <path
      d="M77.4895 39.8527L52.709 47.0274L44.0586 17.1926L68.8565 10.0179L77.4895 39.8527Z"
      fill="#EB9757"
    />
    <path
      d="M67.9385 6.74451H67.9046L43.073 13.9531C41.2752 14.4789 39.3924 13.4443 38.8666 11.6463L38.8327 11.5446C38.3238 9.74672 39.3585 7.86397 41.1564 7.35507L66.0216 0.129546C67.8195 -0.379298 69.7022 0.655357 70.228 2.45324L70.262 2.53805C70.7878 4.33591 69.7534 6.21868 67.9385 6.74451Z"
      fill="#EB9757"
    />
    <path
      d="M80.4071 49.6911L55.5245 56.9166C53.7266 57.4424 51.8438 56.4078 51.3349 54.5929L51.301 54.5081C50.7752 52.7103 51.8099 50.8275 53.6078 50.3017H53.6587L78.4392 43.11H78.4901C80.288 42.5673 82.1707 43.6019 82.6965 45.3999V45.5016C83.2393 47.2995 82.205 49.1822 80.4071 49.6911Z"
      fill="#EB9757"
    />
    <path
      d="M38.4766 77.9995H91.8034L89.3948 70.7569C88.7842 68.9251 87.0542 67.6699 85.1205 67.6699H45.1599C43.2263 67.6699 41.4962 68.908 40.8856 70.7569L38.4766 77.9995Z"
      fill="#EB9757"
    />
  </svg>
);

export const Theater = () => (
  <svg
    className="w-full h-full"
    width="120"
    height="78"
    viewBox="0 0 120 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M93.2985 33.0208L99.1714 38.9653L95.9724 42.9522L89.3594 36.2676L93.2985 33.0208Z"
      fill="#EB9757"
    />
    <path
      d="M100.365 37.4614L94.7305 31.8511L96.8552 30.1083C96.6165 29.3921 96.4494 28.6043 96.4016 27.7926C96.139 23.1134 98.8367 18.6013 103.015 16.5243C105.641 15.2112 108.362 15.1873 111.227 15.3306C113.996 15.4738 117.219 15.4738 119.296 13.3968C119.464 13.3491 119.726 13.4446 119.75 13.5878C119.44 18.8877 118.007 24.1638 115.381 28.7953C113.185 32.6867 109.317 35.9812 104.59 35.7903C103.707 35.7425 102.847 35.5754 102.06 35.3128L100.365 37.4614Z"
      fill="#EB9757"
    />
    <path
      d="M109.63 38.3211C109.607 37.963 109.559 37.581 109.511 37.2229C108.055 37.963 106.455 38.4405 104.76 38.5598C104.76 38.6076 104.784 38.6792 104.784 38.7269C105.023 41.4008 103.041 43.7643 100.367 44.003C99.508 44.0746 98.6963 43.9075 97.9801 43.5972C93.0144 49.661 87.8577 55.5817 82.4145 61.192C81.6745 61.9559 80.9344 62.696 80.1943 63.4361C80.9583 64.2239 81.4596 65.2505 81.5551 66.4203C81.7938 69.0942 79.8123 71.4576 77.1385 71.6964C75.539 71.8396 74.0588 71.1712 73.0561 70.0491C70.9075 71.9112 68.7589 73.7734 66.7773 75.8026C70.2151 76.5905 73.8439 76.8531 77.5682 76.5427C96.9297 74.8477 111.302 57.7303 109.63 38.3211ZM94.4468 62.6722C91.773 62.9109 89.4095 60.9294 89.1708 58.2555C88.932 55.5817 90.9135 53.2182 93.6113 52.9795C96.2851 52.7407 98.6486 54.7222 98.8873 57.42C99.1022 60.0699 97.1207 62.4334 94.4468 62.6722Z"
      fill="#EB9757"
    />
    <path
      d="M55.6032 1.29296C55.1258 0.600621 54.3618 0.147023 53.5262 0.0276548C53.0249 -0.043966 52.5235 0.0276548 52.0699 0.19477C51.7596 0.314138 51.4492 0.481253 51.1866 0.696115C45.4808 5.47083 40.0377 9.21899 28.6499 13.5162C17.2622 17.8135 10.6731 18.6013 3.22456 18.7684C2.89033 18.7684 2.5561 18.84 2.22187 18.9594C1.76828 19.1265 1.33855 19.413 1.00432 19.795C0.455228 20.4396 0.168745 21.2752 0.264239 22.1107C0.884953 27.6972 1.93539 33.5701 4.10789 39.2997C14.1348 65.9188 33.544 83.2271 52.2132 76.2083C70.8823 69.1895 74.0575 43.3582 64.0306 16.7392C61.882 11.0095 58.8023 5.90056 55.6032 1.29296ZM16.2357 39.0371C15.9492 36.5065 18.7901 34.1191 22.5383 33.7133C26.3103 33.3074 29.8197 37.3898 30.1062 39.9204C30.3927 42.451 27.122 40.8993 23.3739 41.329C19.6019 41.7348 16.4983 41.5677 16.2357 39.0371ZM48.7993 67.1125C41.1597 69.9773 32.9949 67.017 30.1062 59.3774C29.7243 58.3747 29.5094 57.372 29.3662 56.3693C29.3423 56.0829 29.4378 55.8202 29.6526 55.6293C29.8675 55.4621 30.154 55.4144 30.4166 55.486C33.8783 56.7036 39.584 58.2554 44.7169 56.3216C49.8497 54.3878 53.1204 49.4699 54.9109 46.2708C55.0541 46.0321 55.2929 45.865 55.5794 45.865C55.8658 45.865 56.1285 45.9843 56.2717 46.2231C56.8447 47.0586 57.3221 47.9658 57.7041 48.9685C60.6167 56.6081 56.4388 64.2476 48.7993 67.1125ZM50.7808 30.6814C47.6533 32.8061 46.1732 36.1007 44.7407 33.9759C43.3083 31.875 43.3561 26.4557 46.4835 24.331C49.611 22.2062 53.3114 22.1824 54.7438 24.3071C56.1762 26.4319 53.9082 28.5566 50.7808 30.6814Z"
      fill="#EB9757"
    />
    <path
      d="M88.1177 37.4138C84.8709 40.5413 78.7354 46.4858 72.6476 52.6452C71.1436 63.4838 66.1301 72.0067 57.2969 76.0174C57.3685 76.1129 57.464 76.1845 57.5356 76.28C58.1086 76.8291 59.2068 77.7363 59.9707 77.9751C63.0982 78.93 87.0434 52.3109 94.7784 44.17L88.1177 37.4138Z"
      fill="#EB9757"
    />
    <path
      d="M71.6687 6.54547C68.0399 7.09456 65.4854 7.97789 63.7188 9.07607C65.1512 11.6544 66.4642 14.3521 67.5385 17.217C71.6925 28.2466 73.5785 39.1329 73.0295 48.6107C75.8227 46.0085 78.6875 43.4779 81.433 40.8041C85.2766 37.0559 89.1441 33.3316 93.5369 30.2519C93.4653 29.8222 93.4175 29.3925 93.3936 28.9389C93.3459 28.1033 93.3698 27.2677 93.4891 26.4322C92.9162 26.7425 92.2955 26.9335 91.6031 27.0051C88.9293 27.2439 86.5658 25.2624 86.327 22.5885C86.0883 19.9147 88.0698 17.5512 90.7675 17.3125C92.94 17.1215 94.8977 18.3868 95.6855 20.2967C96.6882 18.721 97.9535 17.3125 99.4814 16.1904C92.3193 8.98058 82.3163 4.94594 71.6687 6.54547ZM75.5839 20.2012C72.8623 19.8431 70.9286 17.3363 71.2867 14.6147C71.6448 11.8932 74.1515 9.95939 76.8731 10.3175C79.5947 10.6756 81.5285 13.1823 81.1704 15.9039C80.8122 18.6494 78.3055 20.5831 75.5839 20.2012Z"
      fill="#EB9757"
    />
  </svg>
);

export const EconomicsIcon = () => (
  <svg
    className="w-full h-full"
    width="95"
    height="84"
    viewBox="0 0 95 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4366 35.3831H25.6516C26.7571 35.3831 27.6516 36.2776 27.6516 37.3831V66.6561C27.6516 67.7616 26.7571 68.6561 25.6516 68.6561H15.4366C14.3311 68.6561 13.4366 67.7616 13.4366 66.6561V37.3831C13.4366 36.2776 14.3311 35.3831 15.4366 35.3831ZM33.3196 26.594H43.5346C44.6401 26.594 45.5346 27.4885 45.5346 28.594V66.656C45.5346 67.7615 44.6401 68.656 43.5346 68.656H33.3196C32.2141 68.656 31.3196 67.7615 31.3196 66.656V28.594C31.3196 27.4885 32.2141 26.594 33.3196 26.594ZM51.1986 17.8049H61.4136C62.5191 17.8049 63.4136 18.6994 63.4136 19.8049V66.6599C63.4136 67.7654 62.5191 68.6599 61.4136 68.6599H51.1986C50.0931 68.6599 49.1986 67.7654 49.1986 66.6599V19.8049C49.1986 18.6994 50.0931 17.8049 51.1986 17.8049ZM69.0816 9.0158H79.2966C80.4021 9.0158 81.2966 9.91033 81.2966 11.0158V66.6608C81.2966 67.7663 80.4021 68.6608 79.2966 68.6608H69.0816C67.9761 68.6608 67.0816 67.7663 67.0816 66.6608V11.0158C67.0816 9.9103 67.9761 9.0158 69.0816 9.0158ZM88.2226 70.1608C90.0195 70.1608 91.6484 70.8913 92.8242 72.067C94 73.2427 94.7304 74.8717 94.7304 76.6686C94.7304 78.4655 93.9999 80.0944 92.8242 81.2702C91.6485 82.446 90.0195 83.1764 88.2226 83.1764C86.4257 83.1764 84.7968 82.4459 83.621 81.2702C82.9023 80.5515 82.3476 79.6608 82.0272 78.6686H12.7032C12.3829 79.6608 11.8321 80.5514 11.1094 81.2702C9.9336 82.446 8.3047 83.1764 6.5078 83.1764C4.7109 83.1764 3.082 82.4459 1.9062 81.2702C0.7304 80.0944 0 78.4655 0 76.6686C0 74.8717 0.73047 73.2428 1.9062 72.067C2.62495 71.3483 3.5156 70.7936 4.5078 70.4732V12.7032C3.51561 12.3829 2.625 11.8321 1.9062 11.1094C0.7304 9.9336 0 8.3047 0 6.5078C0 4.7109 0.73047 3.082 1.9062 1.9062C3.082 0.730399 4.7109 0 6.5078 0C8.3047 0 9.9336 0.730469 11.1094 1.9062C12.2852 3.082 13.0156 4.7109 13.0156 6.5078C13.0156 8.3047 12.2851 9.9336 11.1094 11.1094C10.3906 11.8281 9.5 12.3828 8.5078 12.7032V70.4732C9.49999 70.7935 10.3906 71.3443 11.1094 72.067C11.8281 72.7858 12.3828 73.6764 12.7032 74.6686H82.0272C82.3475 73.6764 82.8983 72.7858 83.621 72.067C84.7968 70.8912 86.4257 70.1608 88.2226 70.1608Z"
      fill="#EB9757"
    />
  </svg>
);
export const EnglishIcon = () => (
  <svg
    className="w-full h-full"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1077 33.7002H12.0977C12.5377 34.5702 13.1977 35.7502 14.1077 36.9202C15.0077 35.7502 15.6777 34.5702 16.1077 33.7002Z"
      fill="#EB9757"
    />
    <path
      d="M35.7178 9.9502L33.2578 15.8302H38.1878L35.7178 9.9502Z"
      fill="#EB9757"
    />
    <path
      d="M4.2 49.9098H24.19C26.5 49.9098 28.39 48.0298 28.39 45.7098V30.3798H25.73C22.31 30.3798 19.53 27.5998 19.53 24.1798V21.5298H4.2C1.88 21.5298 0 23.4098 0 25.7198V45.7098C0 48.0298 1.88 49.9098 4.2 49.9098ZM7.26 31.6998H13.11V29.7698C13.11 29.2198 13.56 28.7698 14.11 28.7698C14.66 28.7698 15.11 29.2198 15.11 29.7698V31.6998H20.96C21.51 31.6998 21.96 32.1498 21.96 32.6998C21.96 33.2498 21.51 33.6998 20.96 33.6998H18.33C17.9 34.6798 16.96 36.5798 15.46 38.4298C16.62 39.5598 18.04 40.4898 19.7 40.8598C20.24 40.9798 20.58 41.5098 20.46 42.0498C20.36 42.5198 19.95 42.8298 19.49 42.8298C19.42 42.8298 19.34 42.8298 19.27 42.8098C17.2 42.3598 15.49 41.2398 14.11 39.9098C12.72 41.2398 11.01 42.3598 8.94 42.8098C8.87 42.8298 8.8 42.8298 8.73 42.8298C8.27 42.8298 7.85 42.5198 7.75 42.0498C7.63 41.5098 7.98 40.9798 8.52 40.8598C10.18 40.4898 11.59 39.5598 12.75 38.4298C11.25 36.5798 10.31 34.6798 9.89 33.6998H7.26C6.71 33.6998 6.26 33.2498 6.26 32.6998C6.26 32.1498 6.71 31.6998 7.26 31.6998Z"
      fill="#EB9757"
    />
    <path
      d="M25.7273 28.38H45.7173C48.0273 28.38 49.9073 26.5 49.9073 24.18V4.19C49.9073 1.88 48.0273 0 45.7173 0H25.7273C23.4073 0 21.5273 1.88 21.5273 4.19V24.18C21.5273 26.5 23.4073 28.38 25.7273 28.38ZM29.0773 20.64L30.8373 16.45V16.44L34.7973 6.97C34.9573 6.6 35.3173 6.36 35.7173 6.36C36.1273 6.36 36.4873 6.6 36.6473 6.97L40.6073 16.44C40.6073 16.44 40.6073 16.44 40.6073 16.45L42.3573 20.64C42.5773 21.15 42.3373 21.73 41.8273 21.94C41.6973 22 41.5673 22.02 41.4373 22.02C41.0473 22.02 40.6773 21.79 40.5173 21.41L39.0173 17.83H32.4173L30.9273 21.41C30.7173 21.92 30.1273 22.16 29.6173 21.94C29.1073 21.73 28.8673 21.15 29.0773 20.64Z"
      fill="#EB9757"
    />
    <path
      d="M6.11766 19.4399C6.66766 19.4399 7.11766 18.9899 7.11766 18.4399V18.3399C7.11766 14.4399 9.74766 11.1499 13.3177 10.1299L13.1377 10.3499C12.7977 10.7799 12.8677 11.4099 13.2977 11.7499C13.4777 11.8999 13.6977 11.9699 13.9177 11.9699C14.2077 11.9699 14.5077 11.8399 14.6977 11.5899L16.4277 9.40986C16.4577 9.37986 16.4677 9.32986 16.4877 9.29986C16.5277 9.23986 16.5577 9.17986 16.5777 9.11986C16.5977 9.05986 16.6077 8.98986 16.6177 8.92986C16.6277 8.87986 16.6477 8.83986 16.6477 8.78986C16.6477 8.76986 16.6377 8.74986 16.6377 8.72986C16.6377 8.70986 16.6477 8.68986 16.6377 8.66986C16.6277 8.61986 16.6077 8.57986 16.5977 8.52986C16.5777 8.46986 16.5677 8.39986 16.5377 8.33986C16.5077 8.28986 16.4777 8.23986 16.4377 8.18986C16.3977 8.12986 16.3577 8.07986 16.3077 8.03986C16.2977 8.02986 16.2877 8.00986 16.2677 7.99986L14.0877 6.26986C13.6577 5.92986 13.0277 5.99986 12.6777 6.42986C12.3377 6.85986 12.4077 7.48986 12.8377 7.83986L13.1577 8.08986C8.53766 9.20986 5.09766 13.3699 5.09766 18.3199V18.4199C5.11766 18.9899 5.55766 19.4399 6.11766 19.4399Z"
      fill="#EB9757"
    />
    <path
      d="M36.5202 38.2501C36.0902 37.9101 35.4602 37.9801 35.1102 38.4101L33.3802 40.5901C33.3502 40.6201 33.3402 40.6701 33.3202 40.7001C33.2802 40.7601 33.2502 40.8201 33.2302 40.8801C33.2102 40.9501 33.2002 41.0101 33.1902 41.0801C33.1802 41.1201 33.1602 41.1601 33.1602 41.2001C33.1602 41.2201 33.1702 41.2401 33.1702 41.2601C33.1702 41.3301 33.1902 41.3901 33.2102 41.4601C33.2302 41.5201 33.2402 41.5801 33.2602 41.6301C33.2902 41.6801 33.3302 41.7301 33.3602 41.7801C33.4002 41.8401 33.4402 41.8901 33.4902 41.9401C33.5002 41.9501 33.5102 41.9701 33.5302 41.9801L35.7102 43.7101C35.8902 43.8601 36.1102 43.9301 36.3302 43.9301C36.6202 43.9301 36.9202 43.8001 37.1102 43.5501C37.4502 43.1201 37.3802 42.4901 36.9502 42.1401L36.6302 41.8901C41.2502 40.7701 44.6902 36.6101 44.6902 31.6601V31.5601C44.6902 31.0101 44.2402 30.5601 43.6902 30.5601C43.1402 30.5601 42.6902 31.0101 42.6902 31.5601V31.6601C42.6902 35.5601 40.0602 38.8501 36.4902 39.8701L36.6702 39.6501C37.0202 39.2201 36.9502 38.5901 36.5202 38.2501Z"
      fill="#EB9757"
    />
  </svg>
);

export const Users = () => (
  <svg
    className="w-full h-full"
    width="76"
    height="78"
    viewBox="0 0 76 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.129 43.4845C29.129 48.079 25.4031 51.8009 20.8125 51.8009C16.222 51.8009 12.4961 48.079 12.4961 43.4845C12.4961 38.8939 16.222 35.172 20.8125 35.172C25.4031 35.172 29.129 38.8939 29.129 43.4845Z"
      fill="#EB9757"
    />
    <path
      d="M42.8351 53.4478H10.7208C5.23812 53.4478 0.796875 57.889 0.796875 63.3717V78.0001H7.38404V64.7904C7.38404 63.8825 8.12686 63.1397 9.03473 63.1397C9.95834 63.1397 10.6854 63.8825 10.6854 64.7904V78.0001H31.39V66.4415C31.39 63.9811 33.3866 61.9845 35.8665 61.9845H38.1304C38.6727 58.6005 40.3748 55.6095 42.8351 53.4478Z"
      fill="#EB9757"
    />
    <path
      d="M65.7188 43.1269C65.7188 47.7174 61.9968 51.4433 57.4063 51.4433C52.8118 51.4433 49.0898 47.7174 49.0898 43.1269C49.0898 38.5324 52.8118 34.8104 57.4063 34.8104C61.9968 34.8104 65.7188 38.5324 65.7188 43.1269Z"
      fill="#EB9757"
    />
    <path
      d="M64.0198 53.0862H50.7789C44.6044 53.0862 39.6016 58.1052 39.6016 64.2635V77.6543H46.9001V65.1871C46.9001 64.2793 47.6429 63.5365 48.5508 63.5365C49.4586 63.5365 50.2015 64.2793 50.2015 65.1871V77.6543H64.6176V65.1871C64.6176 64.2793 65.3447 63.5365 66.2683 63.5365C67.1761 63.5365 67.9189 64.2793 67.9189 65.1871V77.6543H75.2018V64.2635C75.1978 58.1048 70.1939 53.0862 64.0198 53.0862Z"
      fill="#EB9757"
    />
    <path
      d="M30.185 21.0859C30.0867 19.7338 30.0356 18.3622 30.0356 16.9905C30.0356 15.6189 30.0867 14.2315 30.185 12.8795C25.6455 13.5712 22.4737 14.7621 21.0393 15.8351C21.0235 16.2163 21.0078 16.5936 21.0078 16.9905C21.0078 17.3875 21.0235 17.7648 21.0393 18.146C22.4738 19.219 25.6455 20.3902 30.185 21.0859Z"
      fill="#EB9757"
    />
    <path
      d="M21.848 22.2728C23.5143 27.39 27.5783 31.4539 32.6953 33.1362C31.6734 30.7741 30.9463 27.736 30.5139 24.4503C27.2322 24.0259 24.1944 23.2987 21.848 22.2728Z"
      fill="#EB9757"
    />
    <path
      d="M32.695 0.841367C27.5778 2.52355 23.5295 6.57169 21.8477 11.6887C24.194 10.6668 27.2322 9.93968 30.5178 9.50733C30.9462 6.20988 31.673 3.2035 32.695 0.841367Z"
      fill="#EB9757"
    />
    <path
      d="M33.9023 24.8C34.5783 29.3395 35.7693 32.527 36.8422 33.9457C37.2235 33.9654 37.6008 33.9811 37.9977 33.9811C38.3946 33.9811 38.7719 33.9654 39.1531 33.9497C40.2261 32.5308 41.417 29.3434 42.093 24.804C40.737 24.8826 39.3694 24.9337 37.9977 24.9337C36.626 24.9337 35.2582 24.8826 33.9023 24.8Z"
      fill="#EB9757"
    />
    <path
      d="M42.093 9.18107C41.417 4.62201 40.2261 1.45415 39.1531 0.0353734C38.7719 0.0157213 38.3946 0 37.9977 0C37.6008 0 37.2234 0.0157211 36.8422 0.0314422C35.7693 1.45031 34.5784 4.622 33.9023 9.17714C35.2583 9.08282 36.626 9.03172 37.9977 9.03172C39.3694 9.03172 40.7371 9.08282 42.093 9.18107Z"
      fill="#EB9757"
    />
    <path
      d="M37.9972 21.6283C39.5811 21.6283 41.0668 21.5615 42.4738 21.4475C42.5877 20.0602 42.6546 18.5745 42.6546 16.9906C42.6546 15.4067 42.5877 13.921 42.4738 12.514C41.0668 12.4001 39.5811 12.3333 37.9972 12.3333C36.4133 12.3333 34.9276 12.4001 33.5206 12.514C33.4067 13.9171 33.3398 15.4028 33.3398 16.9906C33.3398 18.5745 33.4067 20.0602 33.5206 21.4475C34.9276 21.5655 36.4133 21.6283 37.9972 21.6283Z"
      fill="#EB9757"
    />
    <path
      d="M54.1445 22.273C51.7982 23.2949 48.76 24.022 45.4743 24.4544C45.0459 27.74 44.3188 30.7782 43.293 33.1402C48.4141 31.4541 52.4743 27.3944 54.1445 22.273Z"
      fill="#EB9757"
    />
    <path
      d="M54.1481 11.6884C52.462 6.57119 48.4178 2.52294 43.3008 0.841064C44.3226 3.2032 45.0498 6.20585 45.4821 9.51126C48.7639 9.93966 51.8016 10.6664 54.1481 11.6884Z"
      fill="#EB9757"
    />
    <path
      d="M45.954 16.9905C45.954 18.3622 45.9029 19.73 45.8047 21.0859C50.3441 20.3941 53.5159 19.219 54.9504 18.146C54.9661 17.7648 54.9818 17.3875 54.9818 16.9905C54.9818 16.5936 54.9661 16.2163 54.9504 15.8351C53.5119 14.7621 50.3441 13.5712 45.8047 12.8795C45.9029 14.2316 45.954 15.619 45.954 16.9905Z"
      fill="#EB9757"
    />
  </svg>
);
export const Leaf = () => (
  <svg
    className="w-full h-full"
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M64.0703 0V13.9286H77.9989L64.0703 0Z" fill="#EB9757" />
    <path
      d="M5.57143 44.5714C2.50007 44.5714 0 47.0701 0 50.1428C0 53.2156 2.50007 55.7143 5.57143 55.7143C7.62382 55.7143 9.4011 54.5858 10.3679 52.9286H25.0714V47.3571H10.3679C9.4011 45.6999 7.62382 44.5714 5.57143 44.5714Z"
      fill="#EB9757"
    />
    <path
      d="M15.8982 34.2447C15.3758 33.7223 14.6685 33.4285 13.9286 33.4285H10.3679C9.4011 31.7713 7.62382 30.6428 5.57143 30.6428C2.50007 30.6428 0 33.1415 0 36.2143C0 39.287 2.50007 41.7857 5.57143 41.7857C7.62382 41.7857 9.4011 40.6572 10.3679 39H12.7751L17.5304 43.7553C18.0527 44.2776 18.76 44.5714 19.5 44.5714H25.0714V39H20.6535L15.8982 34.2447Z"
      fill="#EB9757"
    />
    <path
      d="M17.5304 56.5304L12.7751 61.2857H10.3679C9.4011 59.6284 7.62382 58.4999 5.57143 58.4999C2.50007 58.4999 0 60.9987 0 64.0714C0 67.1441 2.50007 69.6428 5.57143 69.6428C7.62382 69.6428 9.4011 68.5143 10.3679 66.8571H13.9286C14.6685 66.8571 15.3758 66.5633 15.8982 66.041L20.6535 61.2857H25.0714V55.7142H19.5C18.76 55.7142 18.0527 56.008 17.5304 56.5304Z"
      fill="#EB9757"
    />
    <path
      d="M58.4994 25.0714C58.4994 23.533 57.2535 22.2857 55.7137 22.2857H44.5709C39.9987 22.2857 35.9692 24.5303 33.428 27.9434V19.5C33.428 17.9614 32.1809 16.7143 30.6423 16.7143C29.1037 16.7143 27.8566 17.9614 27.8566 19.5V19.5862C25.3154 16.1731 21.2859 13.9286 16.7137 13.9286H5.57087C4.03111 13.9286 2.78516 15.1759 2.78516 16.7143C2.78516 24.3941 9.03397 30.6429 16.7137 30.6429H27.8566V75.2143C27.8566 76.7527 29.1037 78 30.6423 78C32.1809 78 33.428 76.7527 33.428 75.2143V39H44.5709C52.2506 39 58.4994 32.7512 58.4994 25.0714ZM27.8566 29.0518C24.0388 24.9091 18.6002 22.2857 12.5352 22.2857C11.7653 22.2857 11.1423 21.6628 11.1423 20.8929C11.1423 20.123 11.7653 19.5 12.5352 19.5C18.3864 19.5 23.7219 21.6634 27.8566 25.1956V29.0518ZM33.428 33.5527C37.5627 30.0206 42.8982 27.8572 48.7494 27.8572C49.5193 27.8572 50.1423 28.4801 50.1423 29.25C50.1423 30.0199 49.5193 30.6429 48.7494 30.6429C42.6844 30.6429 37.2458 33.2662 33.428 37.4089V33.5527Z"
      fill="#EB9757"
    />
    <path
      d="M61.284 13.9286V0H30.6412C29.1026 0 27.8555 1.24714 27.8555 2.78571V13.9286C28.3608 13.9286 30.1751 13.9286 30.6412 13.9286C33.7125 13.9286 36.2126 16.4273 36.2126 19.5V20.4943C37.977 19.8632 39.8462 19.5 41.784 19.5H44.5698H52.9269H55.7126C57.765 19.5 59.5423 20.6285 60.5091 22.2857H71.034C71.8039 22.2857 72.4269 22.9087 72.4269 23.6786C72.4269 24.4485 71.8039 25.0714 71.034 25.0714H61.284C61.284 28.1175 60.4518 30.9668 59.0227 33.4286H71.034C71.8039 33.4286 72.4269 34.0515 72.4269 34.8214C72.4269 35.5913 71.8039 36.2143 71.034 36.2143H56.9927C53.9307 39.6247 49.5034 41.7857 44.5698 41.7857H41.784H36.2126V66.8571H75.2126C76.751 66.8571 77.9983 65.6098 77.9983 64.0714V16.7143H64.0698C62.5312 16.7143 61.284 15.4671 61.284 13.9286ZM71.034 58.5H40.3912C39.6213 58.5 38.9983 57.877 38.9983 57.1071C38.9983 56.3373 39.6213 55.7143 40.3912 55.7143H71.034C71.8039 55.7143 72.4269 56.3373 72.4269 57.1071C72.4269 57.877 71.8039 58.5 71.034 58.5ZM71.034 47.3571H40.3912C39.6213 47.3571 38.9983 46.7342 38.9983 45.9643C38.9983 45.1944 39.6213 44.5714 40.3912 44.5714H71.034C71.8039 44.5714 72.4269 45.1944 72.4269 45.9643C72.4269 46.7342 71.8039 47.3571 71.034 47.3571Z"
      fill="#EB9757"
    />
  </svg>
);
export const GraduationCap = () => (
  <svg
    className="w-full h-full"
    width="62"
    height="78"
    viewBox="0 0 62 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.21036 40.1602C10.6063 35.1913 15.5167 31.3434 21.2749 29.2769C26.9295 33.8948 35.0633 33.8948 40.718 29.2769C46.4765 31.3438 51.3866 35.1947 54.7826 40.1602C46.7752 39.4485 38.4393 40.3909 30.9977 43.4814C23.5558 40.391 15.2177 39.4485 7.21036 40.1602ZM16.6636 74.9648C21.4244 75.3515 26.0361 76.3622 30.1791 78L30.1758 44.9275C21.2684 41.2293 10.2969 40.7386 0.75633 42.8054C0.584096 42.8412 0.265625 42.9711 0.265625 43.1239V75.9202C0.398867 75.9949 0.535353 76.0079 0.688087 75.9754C5.92017 74.8738 11.3891 74.5358 16.6636 74.9648ZM45.6022 41.7525C40.7081 42.136 35.9893 43.1922 31.8205 44.9242L31.8237 77.9934C40.8518 74.4284 51.7118 73.954 61.3056 75.9721C61.4616 76.0046 61.5981 75.9916 61.7281 75.9168L61.7313 43.1239C61.7313 42.9711 61.4129 42.8411 61.2406 42.8054C56.1289 41.6973 50.7727 41.3495 45.6022 41.7525ZM5.1921 48.7589C4.1229 48.9442 3.83697 47.3225 4.90937 47.1341C11.6493 45.9479 18.9648 46.6531 25.483 48.8629C26.5099 49.2107 25.9802 50.7705 24.9533 50.4228C18.7203 48.3137 11.6362 47.6183 5.1921 48.7589ZM5.1921 55.7848C4.1229 55.9636 3.84995 54.3387 4.92237 54.16C11.6525 53.0388 18.9969 53.8318 25.4768 56.0968C26.5005 56.4543 25.9578 58.0077 24.9341 57.6502C18.7076 55.4729 11.662 54.7059 5.1921 55.7848ZM5.19535 63.0382C4.12948 63.243 3.82075 61.6246 4.88663 61.4199C11.5973 60.1297 18.9421 60.7277 25.4869 62.8303C26.517 63.1617 26.0166 64.7281 24.9831 64.3966C18.7144 62.3818 11.6228 61.7968 5.19535 63.0382ZM5.2051 70.3403C4.14572 70.5613 3.8077 68.9494 4.87038 68.7285C11.5583 67.3311 18.9092 67.8153 25.4864 69.8139C26.5231 70.1291 26.0421 71.702 25.0087 71.3867C18.7075 69.4726 11.6134 68.9982 5.2051 70.3403ZM57.09 47.1337C58.1592 47.3189 57.8764 48.947 56.8073 48.7585C50.3436 47.6211 43.2951 48.3068 37.0456 50.4224C36.0187 50.7701 35.489 49.2103 36.5159 48.8625C43.0154 46.6625 50.3697 45.9443 57.09 47.1337ZM57.0738 54.1596C58.143 54.3383 57.8732 55.9632 56.804 55.7844C50.3371 54.7055 43.2885 55.4757 37.0649 57.6498C36.0444 58.0072 35.4985 56.4539 36.5222 56.0964C42.9989 53.8313 50.3401 53.0351 57.0738 54.1596ZM57.1128 61.4195C58.1786 61.6242 57.87 63.2426 56.804 63.0378C50.3696 61.7997 43.2885 62.3814 37.0133 64.3962C35.9831 64.7277 35.4794 63.1613 36.5096 62.8299C43.048 60.7273 50.4082 60.1228 57.1128 61.4195ZM57.1225 68.6924C58.1851 68.9101 57.8537 70.5219 56.7943 70.3042C50.3761 68.9881 43.2946 69.4821 36.9935 71.4222C35.9601 71.7407 35.4759 70.1678 36.5093 69.8493C43.0738 67.828 50.4313 67.3145 57.1225 68.6924ZM44.7284 17.171L33.4616 21.3534C31.8985 21.9351 30.3224 21.9351 28.7593 21.3534L17.2687 17.0865C17.1192 24.7753 23.3132 31.0862 30.9989 31.0862C38.6519 31.0862 44.8291 24.831 44.7284 17.171ZM45.6579 8.44907V14.3539C45.6579 14.7893 45.4011 15.1598 44.9917 15.3125L32.8863 19.8068C31.6936 20.2488 30.5238 20.2488 29.3311 19.8068L17.2257 15.3125C16.8162 15.1597 16.5595 14.7893 16.5595 14.3539V8.44907L31.105 13.1839L45.6579 8.44907ZM31.1124 0L13.5213 5.726L31.1124 11.4488L46.1653 6.55144H31.1124C30.027 6.55144 30.027 4.90056 31.1124 4.90056H46.1653L31.1124 0ZM46.1653 4.90056H51.7614C52.2164 4.90056 52.5868 5.27103 52.5868 5.72599V10.8086H53.5227V16.3363L51.7614 14.6627L50 16.3363V10.8086H50.9359V6.55143L46.1653 6.55144L48.7034 5.726L46.1653 4.90056Z"
      fill="#EB9757"
    />
  </svg>
);
export const Building = () => (
  <svg
    className="w-full h-full"
    width="78"
    height="78"
    viewBox="0 0 78 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M57.1083 73.0552H67.4878C69.035 69.9161 73.4511 69.7247 75.2558 72.726C76.8781 72.0571 77.9889 70.4652 77.9889 68.6605V39.4753C77.9889 37.057 76.0106 35.0788 73.5924 35.0788C66.064 35.0788 58.5339 35.0788 51.0055 35.0788C48.5926 35.0788 46.609 37.0552 46.609 39.4753V68.6587C46.609 70.4634 47.7251 72.0553 49.3474 72.7243C51.1521 69.7229 55.5683 69.9161 57.1083 73.0552ZM43.3125 74.8599C44.2552 74.8599 44.2552 76.289 43.3125 76.289H24.8878C23.9452 76.289 23.9452 74.8599 24.8878 74.8599H43.3125ZM21.7594 74.8599C22.7021 74.8599 22.7021 76.289 21.7594 76.289H19.969C19.0264 76.289 19.0264 74.8599 19.969 74.8599H21.7594ZM68.3696 33.6443V30.1708H69.9114V33.6443H68.3696ZM56.586 30.1708V33.6443H55.0442V30.1708H56.586ZM53.9299 33.6443V30.1708C53.5543 30.1457 53.2556 29.8363 53.2556 29.4553C53.2556 26.7723 54.4164 24.3344 56.273 22.6352V2.41287C56.273 1.08392 55.1873 0 53.8655 0H11.913C10.584 0 9.50012 1.0857 9.50012 2.41287V39.7901C14.8803 40.1138 19.1123 44.5818 19.1123 50.0121C19.1123 54.6054 16.0644 58.5654 11.7753 59.8335V63.6415H21.7577V44.0273C21.7577 43.632 22.0778 43.3119 22.4731 43.3119H43.3018C43.6917 43.3119 44.0173 43.632 44.0173 44.0273V63.638H45.1781V39.6022H42.0086C41.6187 39.6022 41.2932 39.2821 41.2932 38.8868V31.0186C41.2932 30.6233 41.6169 30.3031 42.0086 30.3031H51.17C51.5653 30.3031 51.8855 30.6233 51.8855 31.0186V33.6443H53.9299ZM52.6063 40.2247C52.6063 39.2821 54.0408 39.2821 54.0408 40.2247V67.9039C54.0408 68.8465 52.6063 68.8465 52.6063 67.9039V40.2247ZM58.5947 40.2247C58.5947 39.2821 60.0238 39.2821 60.0238 40.2247V67.9039C60.0238 68.8465 58.5947 68.8465 58.5947 67.9039V40.2247ZM64.5777 40.2247C64.5777 39.2821 66.0068 39.2821 66.0068 40.2247V67.9039C66.0068 68.8465 64.5777 68.8465 64.5777 67.9039V40.2247ZM70.5607 40.2247C70.5607 39.2821 71.9898 39.2821 71.9898 40.2247V67.9039C71.9898 68.8465 70.5607 68.8465 70.5607 67.9039V40.2247ZM67.833 28.7416H70.2924C69.9275 24.7619 66.5452 21.639 62.5046 21.639C58.4641 21.639 55.0871 24.7619 54.7223 28.7416H57.1816C57.7647 24.4024 63.1289 22.485 66.3037 25.6598C67.1175 26.4754 67.6702 27.5504 67.833 28.7416ZM55.2535 72.887C53.3718 71.0054 50.1433 72.3451 50.1433 75.0066C50.1433 77.6627 53.3736 79.0024 55.2535 77.1207C56.425 75.9545 56.425 74.0586 55.2535 72.887ZM73.5763 72.887C71.6947 71.0054 68.4662 72.3451 68.4662 75.0066C68.4662 77.6627 71.6964 79.0024 73.5763 77.1207C74.7479 75.9545 74.7479 74.0586 73.5763 72.887ZM45.2085 69.2275C45.1888 69.0397 45.1781 68.8519 45.1781 68.6605V65.0707C30.1195 65.0707 15.0664 65.0707 0.0078125 65.0707V69.2275H45.2085ZM45.3265 38.1713C45.8846 35.7477 47.9523 33.9072 50.4581 33.6747V31.7322H42.7312V38.1713H45.3265ZM10.3461 63.6398V54.1027C10.3461 52.171 7.39489 52.171 7.39489 54.1027V63.6398H10.3461ZM11.7771 54.1027V58.3311C17.8656 56.2008 19.7115 48.388 15.1039 43.7805C11.6608 40.3427 6.08382 40.3427 2.64605 43.7805C-1.96327 48.3898 -0.122757 56.2026 5.96756 58.3311V54.1027C5.96577 50.2751 11.7771 50.2751 11.7771 54.1027ZM33.6038 44.7428V63.6398H42.5828V44.7428H33.6038ZM32.1747 63.6398V44.7428H23.1904V63.6398H32.1747ZM35.1242 52.6575C35.1242 51.7203 36.5533 51.7203 36.5533 52.6575V55.725C36.5533 56.6676 35.1242 56.6676 35.1242 55.725V52.6575ZM29.2181 52.6575C29.2181 51.7203 30.6472 51.7203 30.6472 52.6575V55.725C30.6472 56.6676 29.2181 56.6676 29.2181 55.725V52.6575ZM14.6067 30.3031H23.7627C24.158 30.3031 24.4782 30.6233 24.4782 31.0186V38.8868C24.4782 39.2821 24.158 39.6022 23.7627 39.6022H14.6067C14.2114 39.6022 13.8859 39.2821 13.8859 38.8868V31.0186C13.8859 30.6233 14.2096 30.3031 14.6067 30.3031ZM23.0473 31.7322H15.3203V38.1713H23.0473V31.7322ZM28.3112 30.3031H37.4673C37.8626 30.3031 38.1827 30.6233 38.1827 31.0186V38.8868C38.1827 39.2821 37.8626 39.6022 37.4673 39.6022H28.3112C27.9159 39.6022 27.5904 39.2821 27.5904 38.8868V31.0186C27.5904 30.6233 27.9142 30.3031 28.3112 30.3031ZM36.7518 31.7322H29.0249V38.1713H36.7518V31.7322ZM14.6067 17.289H23.7627C24.158 17.289 24.4782 17.6091 24.4782 18.0044V25.878C24.4782 26.2733 24.158 26.5935 23.7627 26.5935H14.6067C14.2114 26.5935 13.8859 26.2733 13.8859 25.878V18.0044C13.8859 17.6074 14.2096 17.289 14.6067 17.289ZM23.0473 18.7181H15.3203V25.1626H23.0473V18.7181ZM28.3112 17.289H37.4673C37.8626 17.289 38.1827 17.6091 38.1827 18.0044V25.878C38.1827 26.2733 37.8626 26.5935 37.4673 26.5935H28.3112C27.9159 26.5935 27.5904 26.2733 27.5904 25.878V18.0044C27.5904 17.6074 27.9142 17.289 28.3112 17.289ZM36.7518 18.7181H29.0249V25.1626H36.7518V18.7181ZM42.0104 17.289H51.1718C51.5671 17.289 51.8873 17.6091 51.8873 18.0044V25.878C51.8873 26.2733 51.5671 26.5935 51.1718 26.5935H42.0104C41.6205 26.5935 41.295 26.2733 41.295 25.878V18.0044C41.295 17.6074 41.6205 17.289 42.0104 17.289ZM50.4564 18.7181H42.7294V25.1626H50.4564V18.7181ZM14.6067 4.27842H23.7627C24.158 4.27842 24.4782 4.59859 24.4782 4.99388V12.8621C24.4782 13.2574 24.158 13.5776 23.7627 13.5776H14.6067C14.2114 13.5776 13.8859 13.2574 13.8859 12.8621V4.99209C13.8859 4.5968 14.2096 4.27842 14.6067 4.27842ZM23.0473 5.70755H15.3203V12.1466H23.0473V5.70755ZM28.3112 4.27842H37.4673C37.8626 4.27842 38.1827 4.59859 38.1827 4.99388V12.8621C38.1827 13.2574 37.8626 13.5776 37.4673 13.5776H28.3112C27.9159 13.5776 27.5904 13.2574 27.5904 12.8621V4.99209C27.5904 4.5968 27.9142 4.27842 28.3112 4.27842ZM36.7518 5.70755H29.0249V12.1466H36.7518V5.70755ZM42.0104 4.27842H51.1718C51.5671 4.27842 51.8873 4.59859 51.8873 4.99388V12.8621C51.8873 13.2574 51.5671 13.5776 51.1718 13.5776H42.0104C41.6205 13.5776 41.295 13.2574 41.295 12.8621V4.99209C41.295 4.5968 41.6205 4.27842 42.0104 4.27842ZM50.4564 5.70755H42.7294V12.1466H50.4564V5.70755Z"
      fill="#EB9757"
    />
  </svg>
);

export const VideoIcon = () => (
  <svg
    width="41"
    height="26"
    viewBox="0 0 41 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.8559 20.0325L36.0322 22.8167C36.9169 23.4071 38.0562 23.4613 38.9969 22.9593C39.9358 22.4574 40.5226 21.477 40.5226 20.4117V5.58823C40.5226 4.52294 39.9358 3.54252 38.9969 3.0406C38.0562 2.53867 36.9169 2.59282 36.0322 3.18323L31.8559 5.96738V4.33333C31.8559 3.18319 31.3991 2.0818 30.5866 1.26931C29.7741 0.456815 28.6727 0 27.5226 0H4.41146C3.26131 0 2.15993 0.456806 1.34743 1.26931C0.534939 2.0818 0.078125 3.18319 0.078125 4.33333V21.6667C0.078125 22.8168 0.53493 23.9182 1.34743 24.7307C2.15993 25.5432 3.26131 26 4.41146 26H27.5226C28.6727 26 29.7741 25.5432 30.5866 24.7307C31.3991 23.9182 31.8559 22.8168 31.8559 21.6667V20.0325ZM18.5564 9.38894L11.1229 16.8224C10.8413 17.1059 10.8413 17.5609 11.1229 17.8443C11.4064 18.126 11.8614 18.126 12.1449 17.8443L19.5783 10.4109V15.1667C19.5783 15.5657 19.9015 15.8889 20.3005 15.8889C20.6996 15.8889 21.0228 15.5657 21.0228 15.1667V8.66691C21.0228 8.55857 20.9975 8.45566 20.9559 8.36357L20.8946 8.25524L20.8115 8.15594L20.7122 8.07288L20.6039 8.01149C20.5118 7.96996 20.4089 7.94468 20.3005 7.94468H13.8008C13.4017 7.94468 13.0785 8.26788 13.0785 8.66691C13.0785 9.06593 13.4017 9.38913 13.8008 9.38913L18.5564 9.38894Z"
      fill="black"
    />
  </svg>
);

export const GlobeStudy = () => (
  <svg
    className="w-full h-full max-w-[25px] sm:max-w-[32px] max-h-[25px] sm:max-h-[32px]"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
  >
    <rect x="0.5" width="32" height="32" fill="url(#pattern0_3649_22134)" />
    <defs>
      <pattern
        id="pattern0_3649_22134"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_3649_22134" transform="scale(0.0078125)" />
      </pattern>
      <image
        id="image0_3649_22134"
        width="128"
        height="128"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const EmailResend = () => (
  <svg
    className="w-full h-full"
    width="162"
    height="162"
    viewBox="0 0 162 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
  >
    <circle
      cx="81"
      cy="81"
      r="79"
      fill="#B7C5FF"
      stroke="white"
      strokeWidth="4"
    />
    <rect
      x="17"
      y="17"
      width="128"
      height="128"
      fill="url(#pattern0_2567_28800)"
    />
    <defs>
      <pattern
        id="pattern0_2567_28800"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use xlinkHref="#image0_2567_28800" transform="scale(0.0078125)" />
      </pattern>
      <image
        id="image0_2567_28800"
        width="128"
        height="128"
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const ListView = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.61734 19.9226H0.92503C0.415019 19.9226 0.00195312 20.3368 0.00195312 20.8457C0.00195312 21.3557 0.415019 21.7688 0.92503 21.7688H4.61734C5.12735 21.7688 5.54041 21.3557 5.54041 20.8457C5.54041 20.3368 5.12735 19.9226 4.61734 19.9226Z"
      fill={color ? color : "white"}
    />
    <path
      d="M23.0771 19.9226H8.30784C7.79783 19.9226 7.38477 20.3368 7.38477 20.8457C7.38477 21.3557 7.79783 21.7688 8.30784 21.7688H23.0771C23.5871 21.7688 24.0002 21.3557 24.0002 20.8457C24.0002 20.3368 23.5871 19.9226 23.0771 19.9226Z"
      fill={color ? color : "white"}
    />
    <path
      d="M4.61734 10.0769H0.92503C0.415019 10.0769 0.00195312 10.49 0.00195312 11C0.00195312 11.51 0.415019 11.9231 0.92503 11.9231H4.61734C5.12735 11.9231 5.54041 11.51 5.54041 11C5.54041 10.49 5.12735 10.0769 4.61734 10.0769Z"
      fill={color ? color : "white"}
    />
    <path
      d="M23.0771 10.0769H8.30784C7.79783 10.0769 7.38477 10.49 7.38477 11C7.38477 11.51 7.79783 11.9231 8.30784 11.9231H23.0771C23.5871 11.9231 24.0002 11.51 24.0002 11C24.0002 10.49 23.5871 10.0769 23.0771 10.0769Z"
      fill={color ? color : "white"}
    />
    <path
      d="M4.61734 0.231201H0.92503C0.415019 0.231201 0.00195312 0.644267 0.00195312 1.15428C0.00195312 1.66314 0.415019 2.07736 0.92503 2.07736H4.61734C5.12735 2.07736 5.54041 1.66314 5.54041 1.15428C5.54041 0.644267 5.12735 0.231201 4.61734 0.231201Z"
      fill={color ? color : "white"}
    />
    <path
      d="M8.30784 2.07736H23.0771C23.5871 2.07736 24.0002 1.66314 24.0002 1.15428C24.0002 0.644267 23.5871 0.231201 23.0771 0.231201H8.30784C7.79783 0.231201 7.38477 0.644267 7.38477 1.15428C7.38477 1.66314 7.79783 2.07736 8.30784 2.07736Z"
      fill={color ? color : "white"}
    />
  </svg>
);

export const CardView = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.28572 17.1429C6.60131 17.1429 6.85714 17.3987 6.85714 17.7143V23.4286C6.85714 23.7442 6.60131 24 6.28572 24H0.571429C0.255838 24 0 23.7442 0 23.4286V17.7143C0 17.3987 0.255838 17.1429 0.571429 17.1429H6.28572ZM14.8571 17.1429C15.1727 17.1429 15.4286 17.3987 15.4286 17.7143V23.4286C15.4286 23.7442 15.1727 24 14.8571 24H9.14286C8.82727 24 8.57143 23.7442 8.57143 23.4286V17.7143C8.57143 17.3987 8.82727 17.1429 9.14286 17.1429H14.8571ZM23.4286 17.1429C23.7442 17.1429 24 17.3987 24 17.7143V23.4286C24 23.7442 23.7442 24 23.4286 24H17.7143C17.3987 24 17.1429 23.7442 17.1429 23.4286V17.7143C17.1429 17.3987 17.3987 17.1429 17.7143 17.1429H23.4286ZM6.28572 8.57143C6.60131 8.57143 6.85714 8.82727 6.85714 9.14286V14.8571C6.85714 15.1727 6.60131 15.4286 6.28572 15.4286H0.571429C0.255838 15.4286 0 15.1727 0 14.8571V9.14286C0 8.82727 0.255838 8.57143 0.571429 8.57143H6.28572ZM14.8571 8.57143C15.1727 8.57143 15.4286 8.82727 15.4286 9.14286V14.8571C15.4286 15.1727 15.1727 15.4286 14.8571 15.4286H9.14286C8.82727 15.4286 8.57143 15.1727 8.57143 14.8571V9.14286C8.57143 8.82727 8.82727 8.57143 9.14286 8.57143H14.8571ZM23.4286 8.57143C23.7442 8.57143 24 8.82727 24 9.14286V14.8571C24 15.1727 23.7442 15.4286 23.4286 15.4286H17.7143C17.3987 15.4286 17.1429 15.1727 17.1429 14.8571V9.14286C17.1429 8.82727 17.3987 8.57143 17.7143 8.57143H23.4286ZM6.28572 0C6.60131 0 6.85714 0.255838 6.85714 0.571429V6.28572C6.85714 6.60131 6.60131 6.85714 6.28572 6.85714H0.571429C0.255838 6.85714 0 6.60131 0 6.28572V0.571429C0 0.255838 0.255838 0 0.571429 0H6.28572ZM14.8571 0C15.1727 0 15.4286 0.255838 15.4286 0.571429V6.28572C15.4286 6.60131 15.1727 6.85714 14.8571 6.85714H9.14286C8.82727 6.85714 8.57143 6.60131 8.57143 6.28572V0.571429C8.57143 0.255838 8.82727 0 9.14286 0H14.8571ZM23.4286 0C23.7442 0 24 0.255838 24 0.571429V6.28572C24 6.60131 23.7442 6.85714 23.4286 6.85714H17.7143C17.3987 6.85714 17.1429 6.60131 17.1429 6.28572V0.571429C17.1429 0.255838 17.3987 0 17.7143 0H23.4286Z"
      fill={color ? color : "white"}
    />
  </svg>
);
export const VerifiedGreenCheck = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6" cy="6" r="6" fill="#3AD365" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.38852 3.8122L5.03954 9.24841L2.64453 6.8534L3.35164 6.14629L4.95663 7.75128L8.60765 3.1875L9.38852 3.8122Z"
      fill="#FBF8FF"
    />
  </svg>
);
export const NotVerifiedYellowCheck = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5074_20957)">
      <path
        d="M8.00065 14.6673C11.6825 14.6673 14.6673 11.6825 14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673Z"
        stroke="#EB9757"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5.33398V8.00065"
        stroke="#EB9757"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.666H8.00667"
        stroke="#EB9757"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5074_20957">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AcademnicLogo = () => (
  <svg
    width="26"
    height="21"
    viewBox="0 0 26 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.338 18.2508C22.2413 17.9177 22.1897 17.5649 22.1897 17.2011C22.1897 16.8373 22.2413 16.4844 22.3391 16.1503H3.81028C3.52143 16.1503 3.25783 16.2686 3.06891 16.4582C2.8767 16.6488 2.75807 16.9118 2.75807 17.2C2.75807 17.487 2.87779 17.75 3.06891 17.9407C3.25892 18.1324 3.52143 18.2508 3.81028 18.2508H22.338ZM1.82325 13.961C1.56733 13.8043 1.33009 13.6169 1.11921 13.4065C0.429465 12.7184 0 11.7673 0 10.7219C0 9.6755 0.428341 8.7255 1.11921 8.03628C1.80896 7.34817 2.76234 6.91971 3.81014 6.91971H4.67342L4.61631 6.86493C3.88481 6.13515 3.43341 5.13037 3.43341 4.0214C3.43341 2.91361 3.88484 1.9077 4.61412 1.18012C5.34562 0.450344 6.35279 1.36433e-05 7.46438 1.36433e-05C8.57598 1.36433e-05 9.58309 0.450372 10.3124 1.17793C10.7792 1.64363 11.1318 2.22109 11.3262 2.86646C11.6502 2.68895 12.017 2.59143 12.396 2.59143C12.8012 2.59143 13.1944 2.70429 13.5349 2.90591L13.5701 2.92892L13.647 2.97932C13.8326 2.28902 14.1983 1.671 14.6904 1.1801C15.4219 0.45033 16.429 0 17.5406 0C18.6521 0 19.6593 0.450359 20.3886 1.17792C21.1202 1.90769 21.5715 2.91248 21.5715 4.02144C21.5715 5.13041 21.1201 6.13514 20.3908 6.86273L20.3315 6.9197H26V8.04174C25.2619 8.04174 24.5908 8.34307 24.1043 8.82849C23.9406 8.99175 23.7978 9.17584 23.6693 9.39498C23.4431 9.79055 23.3157 10.2409 23.3157 10.7197C23.3157 11.1975 23.4431 11.6467 23.677 12.0587C23.7978 12.2647 23.9406 12.4488 24.1043 12.6121C24.5908 13.0975 25.2619 13.3988 26 13.3988V14.5209C25.2619 14.5209 24.5908 14.8222 24.1043 15.3076C23.9406 15.4709 23.7978 15.655 23.666 15.8807C23.4431 16.273 23.3157 16.7211 23.3157 17.1989C23.3157 17.6788 23.4431 18.1292 23.677 18.5379C23.7978 18.7449 23.9406 18.9279 24.1043 19.0912C24.5908 19.5766 25.2619 19.878 26 19.878V21H3.81142C2.7636 21 1.81025 20.5727 1.1205 19.8834C0.430753 19.1953 0.00128778 18.2442 0.00128778 17.1989C0.00128778 16.1524 0.429629 15.2024 1.1205 14.5132C1.33248 14.3017 1.56864 14.1154 1.82453 13.9588L1.82325 13.961ZM19.8358 4.02138C19.8358 4.33148 19.5843 4.5824 19.2735 4.5824C18.9626 4.5824 18.7111 4.33147 18.7111 4.02138C18.7111 3.69814 18.5804 3.40557 18.3575 3.18313C18.1378 2.97494 17.8522 2.8533 17.5403 2.8533C17.2295 2.8533 16.978 2.60238 16.978 2.29229C16.978 1.98219 17.2295 1.73127 17.5403 1.73127C18.1565 1.73127 18.7166 1.97562 19.1296 2.37117L19.1636 2.40294C19.5788 2.81714 19.8358 3.39023 19.8358 4.02138ZM9.76079 4.02138C9.76079 4.33148 9.50928 4.5824 9.19845 4.5824C8.88762 4.5824 8.6361 4.33147 8.6361 4.02138C8.6361 3.69814 8.50539 3.40557 8.28244 3.18313C8.06277 2.97494 7.77719 2.8533 7.46529 2.8533C7.15445 2.8533 6.90294 2.60238 6.90294 2.29229C6.90294 1.98219 7.15446 1.73127 7.46529 1.73127C8.08145 1.73127 8.64161 1.97562 9.05457 2.37117L9.08862 2.40294C9.5038 2.81714 9.76079 3.39023 9.76079 4.02138ZM11.4918 4.18354C11.45 5.2278 11.0074 6.17121 10.3132 6.86373L10.255 6.91961H14.7482L14.6911 6.86483C14.0628 6.23806 13.6411 5.4064 13.5345 4.48159C13.4653 4.43337 13.4049 4.36873 13.3621 4.28874C13.2698 4.1178 13.1369 3.97863 12.97 3.87344C12.7921 3.76825 12.5977 3.71347 12.3934 3.71347C12.1902 3.71347 11.9947 3.76935 11.8277 3.86796C11.6959 3.94686 11.5806 4.05315 11.4894 4.18354L11.4918 4.18354ZM15.4842 6.07261C16.0092 6.59528 16.7362 6.91961 17.5402 6.91961C18.3431 6.91961 19.0702 6.59528 19.5963 6.07261C20.1213 5.54884 20.4453 4.82347 20.4453 4.02138C20.4453 3.22039 20.1202 2.49502 19.5963 1.97015C19.0713 1.44639 18.3442 1.12316 17.5402 1.12316C16.7373 1.12316 16.0103 1.44748 15.4842 1.97015C14.9602 2.49392 14.6351 3.22039 14.6351 4.02138C14.6351 4.82238 14.9602 5.54775 15.4842 6.07261ZM7.46422 6.91961C8.26711 6.91961 8.9942 6.59528 9.5203 6.07261C10.0453 5.54884 10.3693 4.82347 10.3693 4.02138C10.3693 3.22039 10.0442 2.49502 9.5203 1.97015C8.9953 1.44639 8.26821 1.12316 7.46422 1.12316C6.66133 1.12316 5.93424 1.44748 5.40813 1.97015C4.88422 2.49392 4.55913 3.22039 4.55913 4.02138C4.55913 4.82238 4.88422 5.54775 5.40813 6.07261C5.93314 6.59528 6.66023 6.91961 7.46422 6.91961ZM22.3378 9.67101H3.80895C3.5201 9.67101 3.2565 9.78936 3.06758 9.97893C2.87647 10.1718 2.75674 10.4348 2.75674 10.7218C2.75674 11.01 2.87537 11.273 3.06539 11.4615C3.2565 11.6532 3.5201 11.7716 3.80895 11.7716H22.3369C22.2403 11.4384 22.1887 11.0856 22.1887 10.7218C22.1887 10.358 22.24 10.0052 22.3378 9.67101Z"
      fill="#560CB4"
    />
  </svg>
);

export const BlueEditPencil = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9492 16.6675H18.4492"
      stroke="#1776f0"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6992 2.91767C15.0307 2.58615 15.4804 2.3999 15.9492 2.3999C16.1814 2.3999 16.4112 2.44563 16.6257 2.53447C16.8402 2.6233 17.0351 2.75352 17.1992 2.91767C17.3634 3.08182 17.4936 3.2767 17.5824 3.49117C17.6713 3.70565 17.717 3.93552 17.717 4.16767C17.717 4.39982 17.6713 4.62969 17.5824 4.84416C17.4936 5.05864 17.3634 5.25352 17.1992 5.41767L6.78255 15.8343L3.44922 16.6677L4.28255 13.3343L14.6992 2.91767Z"
      stroke="#1776f0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const TaskBell = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.4985 0.252859C6.87052 0.603408 6.8865 1.18765 6.53418 1.5578C5.65815 2.47816 5.01063 3.61164 4.67632 4.86685C4.54507 5.35964 4.03717 5.65326 3.54189 5.52268C3.0466 5.39208 2.7515 4.88674 2.88274 4.39394C3.29832 2.83362 4.10235 1.42786 5.18696 0.288353C5.53928 -0.0817985 6.12648 -0.0976897 6.4985 0.252859Z"
      fill="#FB9318"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5476 0.252859C17.1756 0.603408 17.1596 1.18765 17.512 1.5578C18.388 2.47816 19.0355 3.61164 19.3698 4.86685C19.501 5.35964 20.0089 5.65326 20.5042 5.52268C20.9995 5.39208 21.2946 4.88674 21.1633 4.39394C20.7478 2.83362 19.9438 1.42786 18.8591 0.288353C18.5068 -0.0817985 17.9196 -0.0976897 17.5476 0.252859Z"
      fill="#FB9318"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9727 0C8.29141 0 5.30714 2.96927 5.30714 6.63204V10.3247C5.30714 10.9044 5.06462 11.458 4.63777 11.8526L2.86379 13.4924C1.12881 15.0962 1.59133 17.9296 3.71483 18.9348C4.77814 19.4382 5.87759 19.84 6.99853 20.14C7.02773 20.2064 7.06053 20.2785 7.09705 20.3555C7.27992 20.741 7.56174 21.26 7.95708 21.7845C8.73726 22.8196 10.0615 23.9999 12.0239 23.9999C13.9864 23.9999 15.3107 22.8196 16.0909 21.7845C16.4863 21.26 16.768 20.741 16.9509 20.3555C16.9868 20.2799 17.0189 20.2091 17.0477 20.1437C18.1585 19.8465 19.2481 19.4484 20.3024 18.9494C22.4475 17.9339 22.8629 15.0736 21.0947 13.4954L19.2489 11.8479C18.8097 11.4559 18.5635 10.8935 18.5739 10.3067L18.6373 6.74953C18.7033 3.04137 15.7001 0 11.9727 0ZM14.6445 20.6259C12.9053 20.8614 11.1406 20.8602 9.40156 20.6232C9.41472 20.6411 9.42804 20.659 9.44153 20.6769C10.0528 21.488 10.8932 22.1537 12.0239 22.1537C13.1547 22.1537 13.9952 21.488 14.6065 20.6769C14.6192 20.6598 14.6319 20.6428 14.6445 20.6259ZM19.5052 17.2823C14.7736 19.5222 9.24696 19.5093 4.512 17.2678C3.55711 16.8158 3.36415 15.5498 4.1267 14.8449L5.90069 13.2051C6.70541 12.4612 7.16262 11.4176 7.16262 10.3247V6.63204C7.16262 3.98887 9.31616 1.84615 11.9727 1.84615C14.6626 1.84615 16.8297 4.04089 16.7821 6.71682L16.7187 10.274C16.6987 11.3966 17.1699 12.4724 18.0099 13.2221L19.8557 14.8696C20.6379 15.5678 20.4542 16.8332 19.5052 17.2823Z"
      fill="#FB9318"
    />
  </svg>
);
export const PinkClock = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.366 15.8341C17.679 16.1471 17.679 16.6521 17.366 16.9651C17.21 17.1211 17.005 17.1991 16.8 17.1991C16.595 17.1991 16.39 17.1211 16.234 16.9651L11.434 12.1651C11.284 12.0151 11.2 11.8111 11.2 11.5991V4.40015C11.2 3.95814 11.558 3.60015 12 3.60015C12.442 3.60015 12.8 3.95814 12.8 4.40015V11.2691L17.3661 15.8352L17.366 15.8341ZM24 12C24 18.6171 18.6171 24 12 24C5.38291 24 0 18.6171 0 12C0 5.38291 5.38291 0 12 0C18.6171 0 24 5.38291 24 12ZM22.4 12C22.4 6.26611 17.7339 1.6 12 1.6C6.26611 1.6 1.6 6.26611 1.6 12C1.6 17.7339 6.26611 22.4 12 22.4C17.7339 22.4 22.4 17.7339 22.4 12Z"
      fill="#EB57E3"
    />
  </svg>
);
export const BlueLike = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.986 12.0844C23.8319 10.7897 22.7528 9.77198 21.4268 9.77198H15.6002L16.8335 5.88659C17.0189 5.26996 17.1418 4.622 17.1418 3.97528C17.1418 2.21812 15.723 0.799316 13.9658 0.799316C12.9181 0.799316 12.0545 1.66285 12.0545 2.71063V3.88247C12.0545 4.19079 11.9618 4.49911 11.8076 4.746L8.5401 9.92602C8.32452 10.2343 8.0463 10.4812 7.70789 10.6354V10.6041C7.70789 10.1729 7.36825 9.83329 6.9371 9.83329H0.770789C0.339641 9.83329 0 10.1729 0 10.6041V23.3378C0 23.769 0.339641 24.1086 0.770789 24.1086H3.8854C4.31654 24.1086 4.65618 23.769 4.65618 23.3378C4.65618 22.9067 4.31654 22.567 3.8854 22.567H1.5417V11.3749H6.19789V23.3677C6.19789 23.7989 6.53753 24.1385 6.96868 24.1385C7.36973 24.1385 7.67805 23.8302 7.73946 23.4605L8.97273 24.1084C9.09557 24.1699 9.21962 24.2012 9.34246 24.2012H18.6847C19.8566 24.2012 20.8743 23.3991 21.1826 22.2899L21.3367 21.6732C21.3681 21.5504 21.3982 21.4576 21.4909 21.3649L22.0148 20.5941C22.3845 20.0389 22.5387 19.3609 22.4158 18.7129L22.3219 18.3733C22.2605 18.0963 22.3219 17.8494 22.4761 17.6025L22.7531 17.1713C23.1228 16.6161 23.277 15.9381 23.1541 15.2901L23.0927 15.0432C23.0313 14.7662 23.0927 14.5193 23.2469 14.2724L23.5552 13.7786C23.8948 13.3174 24.049 12.7007 23.9863 12.0841L23.986 12.0844ZM22.2903 12.9467L21.982 13.4405C21.6123 13.9957 21.4581 14.6737 21.5809 15.3217L21.6423 15.5987C21.7038 15.8757 21.6423 16.1226 21.4882 16.3695L21.2112 16.8006C20.8415 17.3559 20.6873 18.0339 20.8101 18.6819L20.8716 18.9589C20.933 19.2359 20.8716 19.4827 20.7174 19.6983L20.1935 20.4691C20.0393 20.716 19.9165 20.9629 19.8539 21.2399L19.6997 21.8565C19.5769 22.319 19.1758 22.6273 18.7133 22.6273L9.49532 22.6285L7.73816 21.6723V12.2384C8.6017 12.0529 9.37248 11.4989 9.86505 10.7282L13.1338 5.57959C13.4421 5.0858 13.6276 4.50049 13.6276 3.88386V2.71201C13.6276 2.52654 13.7818 2.34228 13.9973 2.34228C14.891 2.34228 15.6317 3.08174 15.6317 3.9766C15.6317 4.4704 15.5702 4.96296 15.4161 5.42544L13.8745 10.2971C13.8131 10.544 13.8432 10.7909 13.9973 10.9752C14.1515 11.1607 14.3671 11.2835 14.614 11.2835H21.4897C22.0136 11.2835 22.446 11.6846 22.5074 12.2084C22.4761 12.5156 22.4147 12.7625 22.2906 12.9467L22.2903 12.9467Z"
      fill="#1776f0"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    fill="#000000"
    width="24px"
    height="25px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    id="dashboard-alt"
    className="icon glyph w-[25px] 2xl:w-[25px] 3xl:w-[40px] h-full"
  >
    <path d="M14,10V22H4a2,2,0,0,1-2-2V10Z"></path>
    <path d="M22,10V20a2,2,0,0,1-2,2H16V10Z"></path>
    <path d="M22,4V8H2V4A2,2,0,0,1,4,2H20A2,2,0,0,1,22,4Z"></path>
  </svg>
);

export const ApplicationIcon = () => (
  <svg
    className="h-full w-[25px] 2xl:w-[25px] 3xl:w-[35px]"
    width="27"
    height="33"
    viewBox="0 0 27 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2798 21.6992C18.4056 21.6992 16.0625 24.0439 16.0625 26.9165C16.3295 33.8289 26.2375 33.8259 26.4971 26.9165C26.4971 24.0424 24.1615 21.6992 21.2798 21.6992ZM24.3295 24.7744C24.598 25.0609 24.5785 25.4914 24.289 25.778L20.8688 29.1981C20.5718 29.5011 20.0333 29.5071 19.7378 29.1981L17.8266 27.287C17.5131 26.9735 17.5131 26.4605 17.8266 26.1469C18.1401 25.8334 18.6457 25.8334 18.9577 26.1469L20.2988 27.4955L23.1564 24.6378C23.5014 24.2898 24.1075 24.3243 24.328 24.7743L24.3295 24.7744Z"
      fill="black"
    />
    <path
      d="M7.95696 1.70468H23.2909C23.3855 1.70468 23.4725 1.79169 23.4725 1.88619V18.666C23.4725 19.11 23.831 19.4686 24.275 19.4686C24.719 19.4686 25.0775 19.1085 25.0775 18.666V1.88619C25.0775 0.90064 24.2765 0.0996094 23.2909 0.0996094H7.95694C6.90837 0.11761 6.89641 1.68517 7.95696 1.70468Z"
      fill="black"
    />
    <path
      d="M15.4925 9.47277C16.7046 9.42627 18.0097 9.51478 19.0643 10.1553C19.7663 10.5108 20.6139 11.4034 21.1989 11.9299C20.6738 7.69683 17.0691 4.08894 12.8418 3.58203C13.3743 4.17308 14.2609 5.00111 14.6074 5.70917C15.2495 6.76223 15.347 8.06729 15.2975 9.28088C15.2975 9.38588 15.3785 9.47289 15.4895 9.47289L15.4925 9.47277Z"
      fill="black"
    />
    <path
      d="M14.4553 26.9167C14.4343 23.129 17.6084 20.0688 21.2778 20.0942V14.2017C21.2613 14.1852 21.2373 14.1702 21.2223 14.1537C19.8302 12.9957 18.4696 10.9826 16.4458 11.0801H15.4903C14.4942 11.0801 13.6917 10.27 13.6917 9.28146V8.3259C13.7862 6.29781 11.7431 4.87869 10.561 3.49414H2.30915C1.3221 3.49414 0.519531 4.29667 0.519531 5.28376V29.1323C0.519531 30.1193 1.32206 30.9309 2.30915 30.9309H15.7618C14.9143 29.7653 14.4553 28.3912 14.4538 26.9167H14.4553ZM4.00412 24.1956C4.00412 23.7546 4.35664 23.393 4.80665 23.393H12.3281C12.7781 23.393 13.1306 23.7546 13.1306 24.1956C13.1306 24.6366 12.7781 24.9981 12.3281 24.9981H4.80665C4.35661 24.9981 4.00412 24.6366 4.00412 24.1956ZM14.5678 21.0019H4.80672C3.75216 20.9869 3.74917 19.4073 4.80672 19.3968H14.5678C15.6209 19.4058 15.6268 20.9869 14.5678 21.0019ZM17.0084 15.399C18.0585 15.4185 18.066 16.9846 17.0084 17.0041H4.79923C4.35822 17.0041 3.99671 16.6426 3.99671 16.2016C3.99671 15.7606 4.35823 15.399 4.79923 15.399L17.0084 15.399Z"
      fill="black"
    />
  </svg>
);

export const TextTopThreeElements = () => (
  <svg
    className="w-full h-full"
    width="26"
    height="32"
    viewBox="0 0 26 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.0252 19.5419C14.3242 18.7702 11.1627 14.0719 9.50013 12.1488C6.73423 8.94945 4.58969 5.66512 2.37109 2.11536"
      stroke="black"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M23.758 17.5616C21.6268 15.904 20.4998 11.4936 19.4014 9.24438"
      stroke="black"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M17.0249 25.4828C13.8954 26.912 10.7515 28.2681 7.51953 29.4434"
      stroke="black"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);
export const TextBottomThreeElements = () => (
  <svg
    className="w-full h-full"
    width="32"
    height="35"
    viewBox="0 0 32 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.95167 11.2928C2.41785 11.9334 2.42686 13.7615 2.39121 14.3499C2.2279 17.0445 2.54672 19.6187 2.64596 22.2983"
      stroke="black"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M9.98291 8.84717C15.2958 16.7987 20.4657 24.8088 25.8796 32.6922"
      stroke="black"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M15.7913 4.56723C20.4331 3.50625 25.1574 2.85826 29.8537 2.12158"
      stroke="black"
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export const MeetingVector = () => (
  <svg
    className="w-full h-full"
    width="227"
    height="246"
    viewBox="0 0 227 246"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_5026_53741)">
      <path
        d="M77.1812 80.0926C75.9686 84.0337 73.2402 88.8842 68.0865 94.9474C64.7518 98.8884 68.6928 104.345 73.5434 102.829C83.5476 99.1916 94.7644 94.0379 105.072 88.8842C108.103 89.1874 111.438 89.4905 114.773 89.4905C147.817 89.4905 174.495 70.3916 174.495 46.7453C174.495 23.0989 147.817 4 114.773 4C81.7286 4 54.7476 23.0989 54.7476 46.7453C54.7476 60.3874 63.5391 72.2105 77.1812 80.0926ZM144.179 37.6505C149.333 37.6505 153.577 41.8947 153.577 47.0484C153.577 52.2021 149.333 56.4463 144.179 56.4463C139.025 56.4463 134.781 52.2021 134.781 47.0484C134.781 41.5916 139.025 37.6505 144.179 37.6505ZM114.47 37.6505C119.623 37.6505 123.868 41.8947 123.868 47.0484C123.868 52.2021 119.623 56.4463 114.47 56.4463C109.316 56.4463 105.072 52.2021 105.072 47.0484C105.375 41.5916 109.316 37.6505 114.47 37.6505ZM85.0633 37.6505C90.217 37.6505 94.4612 41.8947 94.4612 47.0484C94.4612 52.2021 90.217 56.4463 85.0633 56.4463C79.9097 56.4463 75.6655 52.2021 75.6655 47.0484C75.6655 41.5916 79.9097 37.6505 85.0633 37.6505Z"
        fill="#5E57EB"
        fillOpacity="0.2"
      />
      <path
        d="M18.3684 133.448C36.6182 133.448 51.4126 118.654 51.4126 100.404C51.4126 82.154 36.6182 67.3596 18.3684 67.3596C0.118613 67.3596 -14.6758 82.154 -14.6758 100.404C-14.6758 118.654 0.118613 133.448 18.3684 133.448Z"
        fill="#5E57EB"
        fillOpacity="0.2"
      />
      <path
        d="M75.9684 175.89C72.6337 158.004 56.8695 144.665 38.0737 144.665H-1.03369C-22.2547 144.665 -39.8379 161.945 -39.8379 183.469V195.899H-61.3621C-63.4842 195.899 -65 197.415 -65 199.537V207.419C-65 209.541 -63.4842 211.057 -61.3621 211.057H52.3221C55.0505 196.202 63.8421 183.772 75.9684 175.89Z"
        fill="#5E57EB"
        fillOpacity="0.2"
      />
      <path
        d="M191.168 195.596C193.594 200.143 195.413 205.297 196.625 210.754H219.362C221.484 210.754 223 209.238 223 207.116V199.234C223 197.112 221.484 195.596 219.362 195.596H191.168Z"
        fill="#5E57EB"
        fillOpacity="0.2"
      />
      <path
        d="M143.876 182.257H105.072C83.8507 182.257 66.2676 199.537 66.2676 221.061V237.432C66.2676 239.554 67.7834 241.07 69.9055 241.07H179.042C181.164 241.07 182.68 239.554 182.68 237.432V221.061C182.68 199.537 165.4 182.257 143.876 182.257Z"
        fill="#5E57EB"
        fillOpacity="0.2"
      />
      <path
        d="M124.474 171.04C142.724 171.04 157.518 156.246 157.518 137.996C157.518 119.746 142.724 104.952 124.474 104.952C106.224 104.952 91.4297 119.746 91.4297 137.996C91.4297 156.246 106.224 171.04 124.474 171.04Z"
        fill="#5E57EB"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_5026_53741"
        x="-69"
        y="0"
        width="296"
        height="245.07"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_5026_53741"
        />
      </filter>
    </defs>
  </svg>
);

export const DocumentVector = () => (
  <svg
    className="w-full h-full"
    width="297"
    height="324"
    viewBox="0 0 297 324"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_7009_19987)">
      <path
        d="M25.2946 75.3752C11.4272 81.8999 5.37663 98.7037 11.9013 112.571L99.1778 298.064C105.703 311.932 122.506 317.982 136.374 311.458L271.278 247.984C285.145 241.459 291.196 224.655 284.671 210.788L217.23 67.4522L175.073 87.2877C161.205 93.8125 144.402 87.7618 137.877 73.8945L118.041 31.7369L25.2946 75.3752ZM134.904 23.8027L154.74 65.9603C157.006 70.7772 162.322 72.6911 167.139 70.4247L209.296 50.5891C208.244 48.3533 206.346 46.627 204.021 45.79L142.028 23.468C139.703 22.6306 137.141 22.751 134.904 23.8027ZM94.2274 156.221L178.543 116.549C183.199 114.358 188.75 116.357 190.941 121.014C193.132 125.67 191.133 131.222 186.477 133.412L102.162 173.084C97.505 175.275 91.9539 173.276 89.7629 168.619C87.572 163.963 89.5708 158.412 94.2274 156.221ZM114.063 198.378L198.378 158.707C203.035 156.516 208.586 158.515 210.777 163.171C212.968 167.828 210.969 173.379 206.312 175.57L121.997 215.241C117.341 217.432 111.789 215.433 109.599 210.777C107.408 206.12 109.406 200.569 114.063 198.378ZM133.898 240.536L218.214 200.865C222.87 198.674 228.421 200.672 230.612 205.329C232.803 209.986 230.804 215.537 226.148 217.728L141.833 257.399C137.176 259.59 131.625 257.591 129.434 252.934C127.243 248.278 129.242 242.727 133.898 240.536Z"
        fill="#5E57EB"
        fillOpacity="0.2"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7009_19987"
        x="5.27246"
        y="18.9166"
        width="286.028"
        height="299.17"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="2"
          result="effect1_foregroundBlur_7009_19987"
        />
      </filter>
    </defs>
  </svg>
);

export const RightAeroPlane = () => (
  <svg
    className="w-full h-full"
    width="109"
    height="377"
    viewBox="0 0 109 377"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.64425 309.996L101.034 371.892L69.703 264.557L48.9264 294.172L4.64425 309.996Z"
      stroke="black"
      strokeWidth="4"
    />
    <path
      d="M17.875 280.816L74.4812 333.469L56.2265 283.386L17.875 280.816Z"
      fill="black"
      stroke="black"
    />
    <path
      d="M28.0001 267C27.3666 252.007 19.6328 238.28 18.1112 223.444C17.3059 215.593 17.0882 205.749 18.6667 198C20.7263 187.889 27.2828 177.759 32.2223 168.778C40.791 153.198 49.1635 136.504 59.8334 122.278C67.7954 111.662 76.5207 99.5898 80.9445 87.0556C87.1521 69.4674 85.0001 53.2186 85.0001 35.4444C85.0001 30.5425 84.1836 25.7898 83.0001 21.0556C82.4253 18.7566 82.4703 14.7459 81.0001 13C78.6301 10.1857 78.6806 4.36115 77.0001 1"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="10 10"
    />
  </svg>
);

export const LeftAeroPlane = () => (
  <svg
    className="w-full h-full"
    width="232"
    height="305"
    viewBox="0 0 232 305"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M173.312 104.312L118 4L223 42.4375L192.062 61.1875L173.312 104.312Z"
      stroke="black"
      strokeWidth="4"
    />
    <path
      d="M203.312 93.0625L154.562 33.0625L203.312 54.625V93.0625Z"
      fill="black"
      stroke="black"
    />
    <path
      d="M214 104C233.59 123.59 232.145 147.135 226 173.333C219.012 203.126 201.291 215.018 173.111 221.111C159.655 224.02 146.255 226 132.444 226C124.926 226 117.407 226 109.889 226C101.573 226 97.3323 228.921 89.7778 230C64.5851 233.599 50.0482 251.181 28 260C11.388 266.645 -2.51346 287.54 -8 304"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="10 10"
    />
  </svg>
);

export const GlowPurpleVector = () => (
  <svg
    className="w-full h-full"
    width="1575"
    height="1618"
    viewBox="0 0 1575 1618"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_5004_42265)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M758.346 402.494C843.204 391.689 931.48 416.608 1001.8 465.34C1070.98 513.279 1113.97 589.623 1142.62 668.79C1169.71 743.644 1190.33 828.597 1159.88 902.146C1130.9 972.144 1039.44 987.911 987.617 1043.16C938.851 1095.15 935.096 1193.61 866.95 1214.46C798.931 1235.27 740.341 1158.27 671.637 1139.85C600.489 1120.77 508.273 1158.65 457.989 1104.79C408.014 1051.26 447.754 963.05 438.702 890.365C429.878 819.509 384.506 751.392 405.48 683.142C427.182 612.52 493.896 568.63 551.702 522.655C615.357 472.027 677.681 412.766 758.346 402.494Z"
        fill="#5B57EB"
        fillOpacity="0.15"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_5004_42265"
        x="0"
        y="0"
        width="1575"
        height="1618"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="200"
          result="effect1_foregroundBlur_5004_42265"
        />
      </filter>
    </defs>
  </svg>
);

export const GlowPinkVector = () => (
  <svg
    className="w-full h-full"
    width="1693"
    height="1670"
    viewBox="0 0 1693 1670"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_f_7013_19973)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M907.465 449.32C1018.41 436.268 1141.52 359.255 1229.16 428.524C1318.07 498.803 1285.89 636.914 1288.16 750.228C1290.52 867.334 1311.61 990.666 1242.35 1085.12C1164.02 1191.95 1039.67 1277.71 907.465 1269.45C779.285 1261.44 701.688 1137.63 611.962 1045.74C523.989 955.647 390.991 875.795 400.481 750.228C409.844 626.352 546.667 559.653 653.494 496.248C730.456 450.569 818.581 459.776 907.465 449.32Z"
        fill="#EB57E3"
        fillOpacity="0.15"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_7013_19973"
        x="0"
        y="0"
        width="1693"
        height="1670"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="200"
          result="effect1_foregroundBlur_7013_19973"
        />
      </filter>
    </defs>
  </svg>
);
export const ContactIcon = () => (
  <svg
    className="w-full h-full"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6040_22158"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="64"
      height="64"
    >
      <circle cx="32" cy="32" r="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6040_22158)">
      <path
        d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
        fill="#5F88F1"
      />
      <path
        d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
        fill="#5F88F1"
      />
      <path
        d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
        fill="#5F88F1"
      />
      <path
        d="M32.0104 0C18.6507 0 14.7435 0.0137875 13.984 0.0767998C11.2424 0.304757 9.53641 0.736554 7.67778 1.66215C6.24545 2.37362 5.1158 3.19829 4.00093 4.35433C1.97056 6.46257 0.740019 9.05626 0.294555 12.1394C0.0779912 13.6361 0.0149784 13.9413 0.00218238 21.5866C-0.00272798 24.135 0.00218238 27.4888 0.00218238 31.9874C0.00218238 45.3399 0.0169376 49.2443 0.0809416 50.0025C0.30244 52.671 0.720812 54.3499 1.60681 56.1864C3.30003 59.7018 6.53386 62.3408 10.3436 63.3255C11.6628 63.6652 13.1197 63.8523 14.9901 63.9409C15.7826 63.9754 23.8598 64 31.942 64C40.0242 64 48.1064 63.9901 48.8791 63.9508C51.0449 63.8488 52.3025 63.68 53.693 63.3205C57.5274 62.3309 60.7022 59.7313 62.4298 56.1667C63.2986 54.3745 63.7391 52.6316 63.9385 50.1024C63.9818 49.551 64 40.7591 64 31.9791C64 23.1975 63.9803 14.4219 63.937 13.8704C63.7352 11.3004 63.2947 9.57226 62.3978 7.74563C61.662 6.25036 60.8449 5.1337 59.6587 3.99198C57.5417 1.96939 54.9526 0.738514 51.8674 0.293437C50.3725 0.0772839 50.0747 0.0132797 42.4257 0H32.0104Z"
        fill="white"
      />
    </g>
    <path
      opacity="0.986"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1055 19.3722C34.4531 19.3575 42.8007 19.3722 51.1481 19.4161C46.1897 22.8104 41.2251 26.1934 36.2543 29.5651C32.85 27.2842 29.4671 24.9704 26.1055 22.6234C26.5372 21.5429 26.5372 20.4592 26.1055 19.3722Z"
      fill="#5F88F1"
    />
    <path
      opacity="0.986"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1103 13.0453C19.0377 12.8924 19.8431 13.1267 20.5267 13.7482C21.6619 15.6377 22.7749 17.5415 23.8657 19.4598C24.7756 21.0031 24.4974 22.2772 23.031 23.2821C21.9327 23.9044 20.849 24.5487 19.7798 25.2152C19.7288 25.2937 19.6994 25.3815 19.6919 25.4788C21.1203 30.3131 23.3903 34.692 26.5018 38.6153C27.1952 39.418 27.9274 40.1795 28.6985 40.8999C30.0716 40.1182 31.4629 39.3713 32.8723 38.6592C34.0727 38.4243 34.9953 38.8197 35.6402 39.8455C36.8047 41.8522 37.947 43.8732 39.0671 45.9085C39.3514 46.9762 39.0731 47.8695 38.2323 48.5885C35.9877 49.6962 33.7324 50.7799 31.4664 51.8397C30.756 51.8278 30.0823 51.6521 29.4454 51.3125C27.7561 50.4536 26.2037 49.3992 24.7883 48.1492C18.622 42.1329 14.3017 34.9715 11.8277 26.6651C11.1595 24.307 10.8959 21.9053 11.0369 19.4598C11.092 18.8655 11.1945 18.2797 11.3444 17.7024C11.4362 17.5526 11.5534 17.4208 11.6959 17.307C13.5704 16.0182 15.4449 14.7295 17.3195 13.4407C17.5912 13.3049 17.8548 13.1731 18.1103 13.0453Z"
      fill="#5F88F1"
    />
    <path
      opacity="0.987"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.7307 20.6895C52.8186 20.6895 52.9064 20.6895 52.9943 20.6895C53.009 27.4848 52.9943 34.28 52.9504 41.0752C52.7224 41.6839 52.2978 42.0793 51.6763 42.2614C47.5461 42.3346 43.4162 42.32 39.2868 42.2175C38.4596 40.709 37.5663 39.2445 36.6067 37.824C35.1952 36.5742 33.599 36.2667 31.8179 36.9014C30.874 37.3805 29.9514 37.8931 29.05 38.4391C25.9066 34.8791 23.5488 30.8371 21.9766 26.3131C22.9762 25.6297 23.9867 24.956 25.008 24.2921C28.5667 26.7378 32.1254 29.1835 35.6841 31.6292C36.0225 31.8607 36.374 31.8901 36.7386 31.7171C42.0904 28.0609 47.4211 24.3851 52.7307 20.6895Z"
      fill="#5F88F1"
    />
    <defs>
      <radialGradient
        id="paint0_radial_6040_22158"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(61.9334 29.9976) rotate(164.25) scale(40.8924 29.461)"
      >
        <stop stopColor="#FF005F" />
        <stop offset="1" stopColor="#FC01D8" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_6040_22158"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.9995 68.9293) rotate(-90) scale(51.086 54.2012)"
      >
        <stop stopColor="#FFCC00" />
        <stop offset="0.1242" stopColor="#FFCC00" />
        <stop offset="0.5672" stopColor="#FE4A05" />
        <stop offset="0.6942" stopColor="#FF0F3F" />
        <stop offset="1" stopColor="#FE0657" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_6040_22158"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(33.6172 63.0974) rotate(-59.8703) scale(21.1245 27.5017)"
      >
        <stop stopColor="#FFCC00" />
        <stop offset="1" stopColor="#FFCC00" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint3_linear_6040_22158"
        x1="38.6268"
        y1="19.3667"
        x2="38.6268"
        y2="29.5651"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6040_22158"
        x1="25.0874"
        y1="13"
        x2="25.0874"
        y2="51.8397"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_6040_22158"
        x1="37.4882"
        y1="20.6895"
        x2="37.4882"
        y2="42.3072"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
    </defs>
  </svg>
);
export const Phone = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.0005 21.998H44.0005C44.0005 11.738 36.2545 4 25.9805 4V8C34.1045 8 40.0005 13.886 40.0005 21.998Z"
      fill="currentColor"
    />
    <path
      d="M25.9996 16C30.2056 16 31.9996 17.794 31.9996 22H35.9996C35.9996 15.55 32.4496 12 25.9996 12V16ZM32.8436 26.886C32.4593 26.5367 31.9543 26.3504 31.4352 26.3665C30.9161 26.3825 30.4236 26.5996 30.0616 26.972L25.2756 31.894C24.1236 31.674 21.8076 30.952 19.4236 28.574C17.0396 26.188 16.3176 23.866 16.1036 22.722L21.0216 17.934C21.3944 17.5723 21.6119 17.0796 21.6279 16.5604C21.644 16.0412 21.4574 15.5361 21.1076 15.152L13.7176 7.026C13.3677 6.64072 12.8813 6.40701 12.3619 6.37452C11.8424 6.34204 11.3308 6.51332 10.9356 6.85201L6.59559 10.574C6.24981 10.921 6.04343 11.3829 6.01559 11.872C5.98559 12.372 5.41359 24.216 14.5976 33.404C22.6096 41.414 32.6456 42 35.4096 42C35.8136 42 36.0616 41.988 36.1276 41.984C36.6166 41.9566 37.0782 41.7493 37.4236 41.402L41.1436 37.06C41.4825 36.6651 41.6541 36.1536 41.622 35.6341C41.5899 35.1147 41.3566 34.6282 40.9716 34.278L32.8436 26.886Z"
      fill="currentColor"
    />
  </svg>
);

export const Mail = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44 8H4V40H44V8ZM40 16L24 26L8 16V12L24 22L40 12V16Z"
      fill="currentColor"
    />
  </svg>
);

export const Location = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 3C19.6255 3.00516 15.4317 4.74521 12.3385 7.83844C9.24522 10.9317 7.50518 15.1255 7.50002 19.5C7.49478 23.0748 8.66249 26.5527 10.824 29.4C10.824 29.4 11.274 29.9925 11.3475 30.078L24 45L36.6585 30.0705C36.7245 29.991 37.176 29.4 37.176 29.4L37.1775 29.3955C39.338 26.5494 40.5051 23.0732 40.5 19.5C40.4949 15.1255 38.7548 10.9317 35.6616 7.83844C32.5683 4.74521 28.3745 3.00516 24 3ZM24 25.5C22.8133 25.5 21.6533 25.1481 20.6666 24.4888C19.6799 23.8295 18.9109 22.8925 18.4567 21.7961C18.0026 20.6997 17.8838 19.4933 18.1153 18.3295C18.3468 17.1656 18.9183 16.0965 19.7574 15.2574C20.5965 14.4182 21.6656 13.8468 22.8295 13.6153C23.9934 13.3838 25.1998 13.5026 26.2961 13.9567C27.3925 14.4108 28.3295 15.1799 28.9888 16.1666C29.6481 17.1533 30 18.3133 30 19.5C29.998 21.0907 29.3653 22.6157 28.2405 23.7404C27.1157 24.8652 25.5907 25.498 24 25.5Z"
      fill="currentColor"
    />
  </svg>
);

export const Coffee = () => (
  <svg
    className="w-full h-full"
    width="78"
    height="89"
    viewBox="0 0 78 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.8909 63.3667C66.1058 64.7183 71.0319 66.7261 73.9609 69.105C76.1757 70.9019 77.2812 72.9331 77.1211 75.0386C77.0235 76.3003 76.4766 77.5308 75.5117 78.6988C74.1601 80.3277 71.9765 81.8472 69.1211 83.1676C62.1914 86.3707 51.2581 88.4645 39.1131 88.4645C26.9491 88.4645 16.3281 86.3629 9.89015 83.1598C7.67135 82.0582 5.94095 80.8121 4.78465 79.484C3.54245 78.0543 2.94875 76.5192 3.07375 74.9293C3.21047 73.1559 4.24565 71.4371 6.07765 69.8707C8.51515 67.7887 12.4018 65.9449 17.2846 64.5348C14.933 59.0114 13.433 51.3548 13.0971 40.8668C13.0346 38.9293 13.9018 37.0777 15.4331 35.8863L15.4409 35.8785C17.7143 34.148 22.355 32.1832 31.8899 31.6871C44.6089 31.0309 55.9369 32.3473 61.4559 34.9098C64.1473 36.1598 65.4989 37.7848 65.3621 39.5075C65.2917 40.3747 65.1511 41.9684 64.8816 44.0309C65.8855 43.7692 67.4636 43.4489 69.1082 43.4919C72.0262 43.5622 75.1355 44.7185 75.9676 48.9763C76.8465 53.488 74.3738 56.6716 71.0301 58.8435C66.9598 61.4841 61.6082 62.5857 60.1241 62.8513L59.8975 63.3747L59.8909 63.3667ZM63.43 52.2147C62.9847 54.1991 62.4418 56.2733 61.7778 58.3397C63.4809 57.9061 66.6449 56.9413 68.9808 55.3202C71.0003 53.914 72.3988 51.9921 71.2386 49.3983C70.6761 48.1405 69.43 48.3905 68.1683 48.9374C66.1292 49.8241 64.0081 51.6835 63.43 52.2108V52.2147ZM60.7464 61.285C62.7855 60.8593 66.9612 59.7928 70.2542 57.6522C73.1175 55.7967 75.3245 53.1131 74.5706 49.246C73.9066 45.8476 71.3948 44.9608 69.0667 44.9022C67.1956 44.8554 65.4222 45.3241 64.6605 45.5585C64.4613 46.9101 64.2152 48.3983 63.9027 49.9804C65.2582 48.9218 67.2504 47.5624 68.9535 47.1913C69.8559 46.996 70.6879 47.0585 71.3676 47.4608C71.8325 47.7343 72.2387 48.1718 72.5317 48.8241C74.0239 52.1561 72.3833 54.6796 69.7934 56.4843C66.8129 58.5585 62.5668 59.6288 61.2504 59.9218C61.0903 60.3828 60.9223 60.8359 60.7504 61.289L60.7464 61.285ZM17.8674 65.8397C13.1291 67.1913 9.34405 68.9413 6.99245 70.9491C5.50025 72.2264 4.59405 73.5936 4.48075 75.0429C4.387 76.2734 4.887 77.4531 5.85185 78.5585C6.90655 79.7694 8.49635 80.8866 10.5198 81.8944C16.8167 85.0311 27.2148 87.0506 39.1098 87.0506C51.0158 87.0506 61.7388 85.0272 68.5238 81.8865C70.7231 80.8709 72.5005 79.7381 73.7543 78.5193C74.9146 77.3865 75.6098 76.1912 75.7074 74.9334C75.8403 73.2381 74.852 71.6561 73.0668 70.2068C70.2152 67.8943 65.3755 65.9802 59.2858 64.6873C57.8796 67.617 56.1569 70.2928 54.0592 72.4178C58.1569 73.2772 60.7077 74.4842 60.7077 75.8201C60.7077 78.4217 51.0554 80.531 39.1646 80.531C27.2776 80.531 17.6257 78.4216 17.6257 75.8201C17.6257 74.6521 19.5748 73.5818 22.8014 72.7615C20.9342 71.031 19.2698 68.7655 17.8674 65.8397ZM58.2504 63.5702L58.3325 63.3984C58.5473 62.9218 58.7583 62.4413 58.9575 61.957L58.9692 61.9335C59.352 61.0077 59.7075 60.0663 60.0356 59.1171L60.059 59.0507C60.9028 56.5937 61.5707 54.1054 62.0981 51.7421L62.1216 51.6406C62.6606 49.2109 63.0513 46.9218 63.3286 44.9648L63.3403 44.8788C63.6958 42.3515 63.8715 40.3866 63.9497 39.3905C63.9965 38.828 63.7544 38.3085 63.3051 37.8202C62.7583 37.2226 61.9262 36.6835 60.8598 36.1874C55.4692 33.6835 44.3908 32.4569 31.9648 33.0976C22.8984 33.5664 18.4648 35.3515 16.3008 36.9999C15.1328 37.914 14.4649 39.3358 14.5117 40.8202C15.0664 58.2382 18.8047 67.6252 24.4453 72.3122C30.0273 76.9528 37.4223 76.9138 45.1873 75.6677C51.3514 74.6755 55.4603 69.6052 58.2463 63.5897L58.2542 63.5663L58.2504 63.5702ZM39.1684 36.5042C51.0594 36.5042 60.7115 38.6136 60.7115 41.2151C60.7115 43.8128 51.0592 45.926 39.1684 45.926C27.2814 45.926 17.6294 43.8127 17.6294 41.2151C17.6294 38.6135 27.2817 36.5042 39.1684 36.5042ZM64.8324 19.9962L65.5004 21.8048C65.8051 22.6291 66.4574 23.2814 67.2816 23.586L69.0941 24.254C69.3676 24.3556 69.5551 24.6212 69.5551 24.9181C69.5551 25.2149 69.3715 25.4806 69.0941 25.5821L67.2816 26.2501C66.4574 26.5548 65.805 27.2071 65.5004 28.0313L64.8324 29.8399C64.7309 30.1172 64.4653 30.3008 64.1684 30.3008C63.8715 30.3008 63.6059 30.1172 63.5043 29.8399L62.8364 28.0313C62.5317 27.2071 61.8793 26.5547 61.0552 26.2501L59.2466 25.5821C58.9692 25.4806 58.7856 25.2149 58.7856 24.9181C58.7856 24.6251 58.9692 24.3595 59.2466 24.254L61.0552 23.586C61.8794 23.2813 62.5318 22.629 62.8364 21.8048L63.5043 19.9962C63.6059 19.7189 63.8715 19.5353 64.1684 19.5353C64.4614 19.5353 64.727 19.7189 64.8324 19.9962ZM64.1684 22.2774L64.1606 22.297C63.7114 23.5079 62.7544 24.465 61.5434 24.9142L61.5278 24.922L61.5434 24.9298C62.7543 25.3751 63.7114 26.3321 64.1606 27.547L64.1684 27.5665L64.1762 27.547C64.6215 26.3361 65.5785 25.379 66.7934 24.9298L66.8129 24.922L66.7934 24.9142C65.5825 24.4689 64.6254 23.5119 64.1762 22.297L64.1684 22.2774ZM5.19139 57.0664L6.21479 58.7031C6.68354 59.4453 7.45309 59.9492 8.32029 60.082L10.2305 60.3711C10.5235 60.4141 10.7578 60.6367 10.8164 60.9258C10.8789 61.2148 10.75 61.5117 10.5 61.668L8.86332 62.6953C8.12113 63.1601 7.61722 63.9297 7.48442 64.8008L7.19536 66.711C7.15239 67 6.92974 67.2344 6.64067 67.2969C6.35161 67.3555 6.05473 67.2305 5.89848 66.9766L4.87508 65.3438C4.40633 64.5977 3.63678 64.0938 2.76958 63.961L0.85938 63.6758C0.56641 63.6329 0.332039 63.4102 0.273439 63.1212C0.210939 62.8321 0.339845 62.5352 0.589849 62.379L2.22265 61.3556C2.96874 60.8907 3.47265 60.1173 3.60545 59.2501L3.89061 57.3399C3.93358 57.0469 4.15624 56.8125 4.4453 56.7539C4.73436 56.6953 5.03124 56.8203 5.18749 57.0703L5.19139 57.0664ZM5.0078 59.4375L5.00389 59.4571C4.81248 60.7344 4.0742 61.8673 2.98049 62.5548L2.96487 62.5626L2.9844 62.5665C4.2617 62.7579 5.3906 63.4962 6.0782 64.5899L6.08601 64.6094L6.08992 64.586C6.28523 63.3126 7.02351 62.1798 8.11722 61.4922L8.13284 61.4844L8.11331 61.4805C6.83601 61.2891 5.70311 60.5508 5.01951 59.4532L5.0078 59.4375ZM11.7344 51.8047L11.5313 53C11.4336 53.5743 11.5899 54.1602 11.961 54.6055L12.7344 55.5391C12.9219 55.7657 12.9493 56.0899 12.8008 56.3438C12.6524 56.6016 12.3633 56.7383 12.0703 56.6876L10.875 56.4805C10.3008 56.3829 9.71485 56.5391 9.26955 56.9102L8.33596 57.6837C8.1094 57.8712 7.78518 57.8985 7.53127 57.754C7.27346 57.6055 7.13674 57.3126 7.18752 57.0235L7.39455 55.8282C7.4922 55.2579 7.33595 54.668 6.96486 54.2227L6.19142 53.293C6.00392 53.0665 5.97658 52.7422 6.1211 52.4883C6.26954 52.2305 6.56251 52.0938 6.85157 52.1446L8.04687 52.3477C8.61718 52.4493 9.20707 52.2891 9.65237 51.918L10.586 51.1446C10.8125 50.9532 11.1328 50.9258 11.3907 51.0743C11.6485 51.2227 11.7852 51.5157 11.7344 51.8047ZM8.3789 53.7891C8.67968 54.3087 8.83984 54.8985 8.83984 55.5C9.35937 55.1993 9.94924 55.0391 10.5507 55.043C10.25 54.5196 10.0898 53.9297 10.0898 53.3321C9.57027 53.6368 8.9804 53.793 8.3789 53.793V53.7891ZM40.9959 1.10914C41.0896 0.991946 41.0975 0.991946 41.2498 0.976326C41.4217 0.956795 41.4217 0.980232 41.5584 1.0818C43.3865 2.449 45.1092 5.6091 45.0037 9.3709C44.9646 10.7459 44.6365 11.8631 44.5779 12.074C44.1014 13.6834 43.4334 14.5779 43.1013 15.1482C41.9685 17.1287 41.7654 19.1443 41.7068 19.8513C41.5428 21.8044 41.8435 23.7068 42.1521 24.7927C42.2342 25.0739 42.1443 25.0739 41.9295 25.2732L41.6404 25.2654C41.4685 25.1833 41.4842 25.1599 41.4138 24.9802C41.3474 24.8161 40.8904 23.6677 40.6326 22.1364C40.0935 18.9567 40.6912 16.7966 41.0701 15.7067C41.1873 15.3669 41.4959 14.6051 41.8904 13.9255C42.1795 13.4294 43.2068 11.7771 43.4529 9.38639C43.4646 9.25358 43.8084 6.81609 42.7303 4.19499C42.0037 2.42549 41.0545 1.66379 41.0428 1.64029C40.9178 1.40982 40.9099 1.41373 40.906 1.38638C40.8904 1.23794 40.8943 1.23013 40.992 1.11294L40.9959 1.10914ZM33.0193 6.11694C33.117 5.99975 33.1209 5.99975 33.2732 5.98413C33.4451 5.9646 33.449 5.98803 33.5857 6.0896C35.4138 7.4568 37.1365 10.6169 37.031 14.3787C36.9919 15.7537 36.6638 16.8709 36.6013 17.0818C36.1287 18.6912 35.4568 19.5857 35.1286 20.1599C33.9958 22.1365 33.7927 24.1521 33.7341 24.8591C33.5662 26.8122 33.8669 28.7146 34.1755 29.8005C34.2576 30.0817 34.1677 30.0817 33.9568 30.281L33.6677 30.2732C33.4958 30.195 33.5154 30.1677 33.4412 29.988C33.3708 29.8239 32.9177 28.6794 32.656 27.1442C32.1208 23.9684 32.7185 21.8083 33.0974 20.7145C33.2146 20.3747 33.5193 19.6129 33.9177 18.9333C34.2068 18.4372 35.2302 16.7849 35.4763 14.3942C35.4919 14.2653 35.8318 11.8239 34.7537 9.20279C34.0271 7.43329 33.0779 6.67159 33.0662 6.64809C32.9412 6.41762 32.9333 6.42153 32.9333 6.39809C32.9177 6.24575 32.9216 6.23793 33.0154 6.12075L33.0193 6.11694Z"
      fill="black"
      fillOpacity="0.2"
    />
  </svg>
);

export const GreenAirplane = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 9.6665L18.3333 2.1665L10.8333 17.9998L9.16667 11.3332L2.5 9.6665Z"
      stroke="#34A853"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UKIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5415_20782)">
      <mask
        id="mask0_5415_20782"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="32"
      >
        <path d="M0 0V32H48V0H0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5415_20782)">
        <path d="M0 0V32H48V0H0Z" fill="#012169" />
        <path d="M0 0L48 32L0 0ZM48 0L0 32L48 0Z" fill="black" />
        <path d="M0 0L48 32M48 0L0 32" stroke="white" strokeWidth="6.4" />
        <mask
          id="mask1_5415_20782"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="48"
          height="32"
        >
          <path
            d="M24 16H48V32L24 16ZM24 16V32H0L24 16ZM24 16H0V0L24 16ZM24 16V0H48L24 16Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_5415_20782)">
          <path d="M0 0L48 32L0 0ZM48 0L0 32L48 0Z" fill="black" />
          <path
            d="M0 0L48 32M48 0L0 32"
            stroke="#C8102E"
            strokeWidth="4.26667"
          />
        </g>
        <path d="M24 0V32V0ZM0 16H48H0Z" fill="black" />
        <path d="M24 0V32M0 16H48" stroke="white" strokeWidth="10.6667" />
        <path d="M24 0V32V0ZM0 16H48H0Z" fill="black" />
        <path d="M24 0V32M0 16H48" stroke="#C8102E" strokeWidth="6.4" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5415_20782">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const CanadaIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5415_20765)">
      <path
        d="M0 0H12L12.495 0.66H35.505L36 0H48V32H36L35.505 31.34H12.495L12 32H0V0Z"
        fill="#FF0000"
      />
      <path
        d="M12 0H36V32H12V0ZM24.45 29.5333L24.225 23.78C24.2217 23.6854 24.2344 23.591 24.2621 23.5038C24.2898 23.4166 24.3319 23.3388 24.3851 23.2761C24.4384 23.2134 24.5015 23.1674 24.5698 23.1416C24.6382 23.1157 24.71 23.1106 24.78 23.1267L29.075 24.1333L28.495 22C28.4715 21.9151 28.4685 21.8225 28.4864 21.7353C28.5043 21.648 28.5423 21.5704 28.595 21.5133L33.3 16.4333L32.24 15.7733C32.1684 15.7282 32.1116 15.6498 32.0803 15.5528C32.049 15.4559 32.0454 15.347 32.07 15.2467L33 11.4333L30.29 12.2C30.2166 12.2204 30.1401 12.2063 30.0736 12.1602C30.0071 12.114 29.9546 12.0386 29.925 11.9467L29.4 10.3L27.285 13.3267C27.2366 13.3947 27.173 13.44 27.1038 13.4557C27.0345 13.4714 26.9632 13.4568 26.9007 13.414C26.8382 13.3712 26.7877 13.3025 26.757 13.2183C26.7262 13.134 26.7167 13.0387 26.73 12.9467L27.75 5.93333L26.115 7.19333C26.0766 7.22333 26.034 7.2425 25.9898 7.24965C25.9457 7.2568 25.9009 7.25179 25.8582 7.23491C25.8156 7.21804 25.776 7.18966 25.7419 7.15155C25.7078 7.11343 25.6799 7.06639 25.66 7.01333L24 2.66667L22.34 7.01333C22.3201 7.06639 22.2922 7.11343 22.2581 7.15155C22.224 7.18966 22.1844 7.21804 22.1418 7.23491C22.0991 7.25179 22.0543 7.2568 22.0102 7.24965C21.966 7.2425 21.9234 7.22333 21.885 7.19333L20.25 5.93333L21.27 12.9467C21.2833 13.0387 21.2738 13.134 21.243 13.2183C21.2123 13.3025 21.1618 13.3712 21.0993 13.414C21.0368 13.4568 20.9655 13.4714 20.8962 13.4557C20.827 13.44 20.7634 13.3947 20.715 13.3267L18.6 10.3L18.075 11.9467C18.0454 12.0386 17.9929 12.114 17.9264 12.1602C17.8599 12.2063 17.7834 12.2204 17.71 12.2L15 11.4333L15.93 15.2467C15.9546 15.347 15.951 15.4559 15.9197 15.5528C15.8884 15.6498 15.8316 15.7282 15.76 15.7733L14.7 16.4333L19.405 21.5133C19.4577 21.5704 19.4957 21.648 19.5136 21.7353C19.5315 21.8225 19.5285 21.9151 19.505 22L18.925 24.1333L23.22 23.1267C23.29 23.1106 23.3618 23.1157 23.4302 23.1416C23.4985 23.1674 23.5616 23.2134 23.6149 23.2761C23.6681 23.3388 23.7102 23.4166 23.7379 23.5038C23.7656 23.591 23.7783 23.6854 23.775 23.78L23.55 29.5333H24.45Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5415_20765">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const USAIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5415_20875)">
      <path d="M0 0H48V32H0V0Z" fill="#B22234" />
      <path
        d="M0 3.69238H48H0ZM48 8.61546H0H48ZM0 13.5385H48H0ZM48 18.4616H0H48ZM0 23.3847H48H0ZM48 28.3078H0H48Z"
        fill="black"
      />
      <path
        d="M0 3.69238H48M48 8.61546H0M0 13.5385H48M48 18.4616H0M0 23.3847H48M48 28.3078H0"
        stroke="white"
        strokeWidth="2.59109"
      />
      <path d="M0 0H19.2V17.2308H0V0Z" fill="#3C3B6E" />
      <path
        d="M1.59865 0.738281L2.05555 2.51947L0.859375 1.41863H2.33794L1.14175 2.51947L1.59865 0.738281Z"
        fill="white"
      />
      <path
        d="M1.59865 4.18457L2.05555 5.96576L0.859375 4.86492H2.33794L1.14175 5.96576L1.59865 4.18457Z"
        fill="white"
      />
      <path
        d="M1.59865 7.63037L2.05555 9.41156L0.859375 8.31072H2.33794L1.14175 9.41156L1.59865 7.63037Z"
        fill="white"
      />
      <path
        d="M1.59865 11.0767L2.05555 12.8578L0.859375 11.757H2.33794L1.14175 12.8578L1.59865 11.0767Z"
        fill="white"
      />
      <path
        d="M1.59865 14.5229L2.05555 16.3041L0.859375 15.2033H2.33794L1.14175 16.3041L1.59865 14.5229Z"
        fill="white"
      />
      <path
        d="M3.20022 2.46143L3.65712 4.24261L2.46094 3.14178H3.9395L2.74331 4.24261L3.20022 2.46143Z"
        fill="white"
      />
      <path
        d="M3.20022 5.90771L3.65712 7.6889L2.46094 6.58807H3.9395L2.74331 7.6889L3.20022 5.90771Z"
        fill="white"
      />
      <path
        d="M3.20022 9.35352L3.65712 11.1347L2.46094 10.0339H3.9395L2.74331 11.1347L3.20022 9.35352Z"
        fill="white"
      />
      <path
        d="M3.20022 12.7998L3.65712 14.581L2.46094 13.4802H3.9395L2.74331 14.581L3.20022 12.7998Z"
        fill="white"
      />
      <path
        d="M4.80178 0.738281L5.25868 2.51947L4.0625 1.41863H5.54106L4.34488 2.51947L4.80178 0.738281Z"
        fill="white"
      />
      <path
        d="M4.80178 4.18457L5.25868 5.96576L4.0625 4.86492H5.54106L4.34488 5.96576L4.80178 4.18457Z"
        fill="white"
      />
      <path
        d="M4.80178 7.63037L5.25868 9.41156L4.0625 8.31072H5.54106L4.34488 9.41156L4.80178 7.63037Z"
        fill="white"
      />
      <path
        d="M4.80178 11.0767L5.25868 12.8578L4.0625 11.757H5.54106L4.34488 12.8578L4.80178 11.0767Z"
        fill="white"
      />
      <path
        d="M4.80178 14.5229L5.25868 16.3041L4.0625 15.2033H5.54106L4.34488 16.3041L4.80178 14.5229Z"
        fill="white"
      />
      <path
        d="M6.39553 2.46143L6.85243 4.24261L5.65625 3.14178H7.13481L5.93863 4.24261L6.39553 2.46143Z"
        fill="white"
      />
      <path
        d="M6.39553 5.90771L6.85243 7.6889L5.65625 6.58807H7.13481L5.93863 7.6889L6.39553 5.90771Z"
        fill="white"
      />
      <path
        d="M6.39553 9.35352L6.85243 11.1347L5.65625 10.0339H7.13481L5.93863 11.1347L6.39553 9.35352Z"
        fill="white"
      />
      <path
        d="M6.39553 12.7998L6.85243 14.581L5.65625 13.4802H7.13481L5.93863 14.581L6.39553 12.7998Z"
        fill="white"
      />
      <path
        d="M8.0049 0.738281L8.4618 2.51947L7.26562 1.41863H8.74419L7.548 2.51947L8.0049 0.738281Z"
        fill="white"
      />
      <path
        d="M8.0049 4.18457L8.4618 5.96576L7.26562 4.86492H8.74419L7.548 5.96576L8.0049 4.18457Z"
        fill="white"
      />
      <path
        d="M8.0049 7.63037L8.4618 9.41156L7.26562 8.31072H8.74419L7.548 9.41156L8.0049 7.63037Z"
        fill="white"
      />
      <path
        d="M8.0049 11.0767L8.4618 12.8578L7.26562 11.757H8.74419L7.548 12.8578L8.0049 11.0767Z"
        fill="white"
      />
      <path
        d="M8.0049 14.5229L8.4618 16.3041L7.26562 15.2033H8.74419L7.548 16.3041L8.0049 14.5229Z"
        fill="white"
      />
      <path
        d="M9.59865 2.46143L10.0556 4.24261L8.85938 3.14178H10.3379L9.14175 4.24261L9.59865 2.46143Z"
        fill="white"
      />
      <path
        d="M9.59865 5.90771L10.0556 7.6889L8.85938 6.58807H10.3379L9.14175 7.6889L9.59865 5.90771Z"
        fill="white"
      />
      <path
        d="M9.59865 9.35352L10.0556 11.1347L8.85938 10.0339H10.3379L9.14175 11.1347L9.59865 9.35352Z"
        fill="white"
      />
      <path
        d="M9.59865 12.7998L10.0556 14.581L8.85938 13.4802H10.3379L9.14175 14.581L9.59865 12.7998Z"
        fill="white"
      />
      <path
        d="M11.2002 0.738281L11.6571 2.51947L10.4609 1.41863H11.9395L10.7433 2.51947L11.2002 0.738281Z"
        fill="white"
      />
      <path
        d="M11.2002 4.18457L11.6571 5.96576L10.4609 4.86492H11.9395L10.7433 5.96576L11.2002 4.18457Z"
        fill="white"
      />
      <path
        d="M11.2002 7.63037L11.6571 9.41156L10.4609 8.31072H11.9395L10.7433 9.41156L11.2002 7.63037Z"
        fill="white"
      />
      <path
        d="M11.2002 11.0767L11.6571 12.8578L10.4609 11.757H11.9395L10.7433 12.8578L11.2002 11.0767Z"
        fill="white"
      />
      <path
        d="M11.2002 14.5229L11.6571 16.3041L10.4609 15.2033H11.9395L10.7433 16.3041L11.2002 14.5229Z"
        fill="white"
      />
      <path
        d="M12.8018 2.46143L13.2587 4.24261L12.0625 3.14178H13.5411L12.3449 4.24261L12.8018 2.46143Z"
        fill="white"
      />
      <path
        d="M12.8018 5.90771L13.2587 7.6889L12.0625 6.58807H13.5411L12.3449 7.6889L12.8018 5.90771Z"
        fill="white"
      />
      <path
        d="M12.8018 9.35352L13.2587 11.1347L12.0625 10.0339H13.5411L12.3449 11.1347L12.8018 9.35352Z"
        fill="white"
      />
      <path
        d="M12.8018 12.7998L13.2587 14.581L12.0625 13.4802H13.5411L12.3449 14.581L12.8018 12.7998Z"
        fill="white"
      />
      <path
        d="M14.4033 0.738281L14.8602 2.51947L13.6641 1.41863H15.1426L13.9464 2.51947L14.4033 0.738281Z"
        fill="white"
      />
      <path
        d="M14.4033 4.18457L14.8602 5.96576L13.6641 4.86492H15.1426L13.9464 5.96576L14.4033 4.18457Z"
        fill="white"
      />
      <path
        d="M14.4033 7.63037L14.8602 9.41156L13.6641 8.31072H15.1426L13.9464 9.41156L14.4033 7.63037Z"
        fill="white"
      />
      <path
        d="M14.4033 11.0767L14.8602 12.8578L13.6641 11.757H15.1426L13.9464 12.8578L14.4033 11.0767Z"
        fill="white"
      />
      <path
        d="M14.4033 14.5229L14.8602 16.3041L13.6641 15.2033H15.1426L13.9464 16.3041L14.4033 14.5229Z"
        fill="white"
      />
      <path
        d="M16.0049 2.46143L16.4618 4.24261L15.2656 3.14178H16.7442L15.548 4.24261L16.0049 2.46143Z"
        fill="white"
      />
      <path
        d="M16.0049 5.90771L16.4618 7.6889L15.2656 6.58807H16.7442L15.548 7.6889L16.0049 5.90771Z"
        fill="white"
      />
      <path
        d="M16.0049 9.35352L16.4618 11.1347L15.2656 10.0339H16.7442L15.548 11.1347L16.0049 9.35352Z"
        fill="white"
      />
      <path
        d="M16.0049 12.7998L16.4618 14.581L15.2656 13.4802H16.7442L15.548 14.581L16.0049 12.7998Z"
        fill="white"
      />
      <path
        d="M17.5987 0.738281L18.0556 2.51947L16.8594 1.41863H18.3379L17.1418 2.51947L17.5987 0.738281Z"
        fill="white"
      />
      <path
        d="M17.5987 4.18457L18.0556 5.96576L16.8594 4.86492H18.3379L17.1418 5.96576L17.5987 4.18457Z"
        fill="white"
      />
      <path
        d="M17.5987 7.63037L18.0556 9.41156L16.8594 8.31072H18.3379L17.1418 9.41156L17.5987 7.63037Z"
        fill="white"
      />
      <path
        d="M17.5987 11.0767L18.0556 12.8578L16.8594 11.757H18.3379L17.1418 12.8578L17.5987 11.0767Z"
        fill="white"
      />
      <path
        d="M17.5987 14.5229L18.0556 16.3041L16.8594 15.2033H18.3379L17.1418 16.3041L17.5987 14.5229Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5415_20875">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const NewZealandIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5415_21105)">
      <path d="M0 0H48V32H0V0Z" fill="#012169" />
      <mask
        id="mask0_5415_21105"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="16"
      >
        <path d="M0 0H24V16H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5415_21105)">
        <path d="M0 0L24 16L0 0ZM0 16L24 0L0 16Z" fill="black" />
        <path d="M0 0L24 16M0 16L24 0" stroke="white" strokeWidth="3.2" />
      </g>
      <mask
        id="mask1_5415_21105"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="16"
      >
        <path
          d="M0 0L12 8H0V0ZM12 0H24L12 8V0ZM12 8H24V16L12 8ZM12 8V16H0L12 8Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_5415_21105)">
        <path d="M0 0L24 16L0 0ZM0 16L24 0L0 16Z" fill="black" />
        <path d="M0 0L24 16M0 16L24 0" stroke="#C8102E" strokeWidth="2.13333" />
      </g>
      <mask
        id="mask2_5415_21105"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="16"
      >
        <path d="M0 0H24V16H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask2_5415_21105)">
        <path d="M12 0V16V0ZM0 8H24H0Z" fill="black" />
        <path d="M12 0V16M0 8H24" stroke="white" strokeWidth="5.33333" />
      </g>
      <mask
        id="mask3_5415_21105"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="16"
      >
        <path d="M0 0H24V16H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask3_5415_21105)">
        <path d="M12 0V16V0ZM0 8H24H0Z" fill="black" />
        <path d="M12 0V16M0 8H24" stroke="#C8102E" strokeWidth="3.2" />
      </g>
      <path d="M36 5.61279V6.82346L37.816 5.61279H36Z" fill="white" />
      <path
        d="M36.3462 7.03658L35.8125 6.05713L37.8154 5.61335L36.3462 7.03658Z"
        fill="white"
      />
      <path
        d="M35.9922 5.61279V6.82346L34.1762 5.61279H35.9922Z"
        fill="white"
      />
      <path
        d="M35.646 7.03658L36.1797 6.05713L34.1768 5.61335L35.646 7.03658Z"
        fill="white"
      />
      <path
        d="M36.6406 6.15625L35.7009 6.61089L37.1256 8.37855L36.6406 6.15625Z"
        fill="white"
      />
      <path
        d="M35.6493 7.12996L36.2344 6.05615L37.0672 8.45883L35.6493 7.12996Z"
        fill="white"
      />
      <path
        d="M35.4297 6.07617L36.3695 6.53081L35.9147 3.85387L35.4297 6.07617Z"
        fill="white"
      />
      <path
        d="M36.5542 6.23997L35.7578 6.53174L35.9258 3.8548L36.5542 6.23997Z"
        fill="white"
      />
      <path
        d="M35.3594 6.15625L36.2991 6.61089L34.8744 8.37855L35.3594 6.15625Z"
        fill="white"
      />
      <path
        d="M36.3507 7.12996L35.7656 6.05615L34.9328 8.45883L36.3507 7.12996Z"
        fill="white"
      />
      <path d="M36 5.87988V6.67988L37.2 5.87988H36Z" fill="#C8102E" />
      <path
        d="M36.2277 6.82055L35.875 6.17334L37.1985 5.8801L36.2277 6.82055Z"
        fill="#C8102E"
      />
      <path
        d="M35.9922 5.87988V6.67988L34.7922 5.87988H35.9922Z"
        fill="#C8102E"
      />
      <path
        d="M35.7645 6.82055L36.1172 6.17334L34.7937 5.8801L35.7645 6.82055Z"
        fill="#C8102E"
      />
      <path
        d="M36.4219 6.23926L35.8009 6.53968L36.7423 7.70774L36.4219 6.23926Z"
        fill="#C8102E"
      />
      <path
        d="M35.7697 6.88242L36.1562 6.17285L36.7065 7.76052L35.7697 6.88242Z"
        fill="#C8102E"
      />
      <path
        d="M35.625 6.18604L36.246 6.48646L35.9455 4.71755L35.625 6.18604Z"
        fill="#C8102E"
      />
      <path
        d="M36.37 6.29402L35.8438 6.48682L35.9547 4.71791L36.37 6.29402Z"
        fill="#C8102E"
      />
      <path
        d="M35.5781 6.23926L36.1991 6.53968L35.2577 7.70774L35.5781 6.23926Z"
        fill="#C8102E"
      />
      <path
        d="M36.2303 6.88242L35.8438 6.17285L35.2935 7.76052L36.2303 6.88242Z"
        fill="#C8102E"
      />
      <path
        d="M40.7656 11.3433L40.7493 12.2864L42.3653 11.2091L40.7656 11.3433Z"
        fill="white"
      />
      <path
        d="M41.046 12.4758L40.5859 11.6787L42.3682 11.1348L41.046 12.4758Z"
        fill="white"
      />
      <path
        d="M40.75 11.209L40.7337 12.1521L39.1503 11.3432L40.75 11.209Z"
        fill="white"
      />
      <path
        d="M40.4319 12.4762L40.9219 11.5244L39.1396 11.29L40.4319 12.4762Z"
        fill="white"
      />
      <path
        d="M41.3203 11.6934L40.4736 12.1419L41.7414 13.627L41.3203 11.6934Z"
        fill="white"
      />
      <path
        d="M40.4415 12.6155L40.9688 11.604L41.6966 13.7421L40.4415 12.6155Z"
        fill="white"
      />
      <path
        d="M40.25 11.6802L41.0687 12.0258L40.6992 9.64371L40.25 11.6802Z"
        fill="white"
      />
      <path
        d="M41.254 11.7062L40.5312 12.0264L40.709 9.64424L41.254 11.7062Z"
        fill="white"
      />
      <path
        d="M40.2031 11.6929L41.0218 12.0385L39.754 13.7293L40.2031 11.6929Z"
        fill="white"
      />
      <path
        d="M41.0639 12.4894L40.5547 11.6035L39.7908 13.7416L41.0639 12.4894Z"
        fill="white"
      />
      <path
        d="M40.7656 11.5591L40.7555 12.1427L41.7555 11.476L40.7656 11.5591Z"
        fill="#C8102E"
      />
      <path
        d="M40.9331 12.2599L40.6484 11.7666L41.7513 11.43L40.9331 12.2599Z"
        fill="#C8102E"
      />
      <path
        d="M40.7578 11.4761L40.7477 12.0597L39.7679 11.5591L40.7578 11.4761Z"
        fill="#C8102E"
      />
      <path
        d="M40.5562 12.2599L40.8594 11.6709L39.7565 11.5258L40.5562 12.2599Z"
        fill="#C8102E"
      />
      <path
        d="M41.1172 11.7754L40.5932 12.0529L41.3778 12.9719L41.1172 11.7754Z"
        fill="#C8102E"
      />
      <path
        d="M40.5644 12.3461L40.8906 11.7202L41.341 13.0433L40.5644 12.3461Z"
        fill="#C8102E"
      />
      <path
        d="M40.4453 11.7676L40.9519 11.9815L40.7233 10.5074L40.4453 11.7676Z"
        fill="#C8102E"
      />
      <path
        d="M41.0566 11.7838L40.6094 11.9819L40.7194 10.5078L41.0566 11.7838Z"
        fill="#C8102E"
      />
      <path
        d="M40.4141 11.7754L40.9207 11.9893L40.1361 13.0356L40.4141 11.7754Z"
        fill="#C8102E"
      />
      <path
        d="M40.9479 12.2684L40.6328 11.7202L40.1601 13.0433L40.9479 12.2684Z"
        fill="#C8102E"
      />
      <path
        d="M30.4766 13.2031L30.4582 14.263L32.2742 13.0523L30.4766 13.2031Z"
        fill="white"
      />
      <path
        d="M30.7904 14.4758L30.2734 13.5801L32.2763 12.9689L30.7904 14.4758Z"
        fill="white"
      />
      <path
        d="M30.4531 13.0527L30.4348 14.1126L28.6555 13.2036L30.4531 13.0527Z"
        fill="white"
      />
      <path
        d="M30.09 14.4763L30.6406 13.4067L28.6377 13.1432L30.09 14.4763Z"
        fill="white"
      />
      <path
        d="M31.1016 13.5962L30.1501 14.1002L31.5748 15.7691L31.1016 13.5962Z"
        fill="white"
      />
      <path
        d="M30.1107 14.6322L30.7031 13.4956L31.5211 15.8983L30.1107 14.6322Z"
        fill="white"
      />
      <path
        d="M29.8984 13.582L30.8184 13.9705L30.4032 11.2935L29.8984 13.582Z"
        fill="white"
      />
      <path
        d="M31.0154 13.6115L30.2031 13.9712L30.4029 11.2942L31.0154 13.6115Z"
        fill="white"
      />
      <path
        d="M29.8438 13.5967L30.7637 13.9851L29.339 15.8852L29.8438 13.5967Z"
        fill="white"
      />
      <path
        d="M30.8066 14.4917L30.2344 13.4961L29.376 15.8988L30.8066 14.4917Z"
        fill="white"
      />
      <path
        d="M30.4609 13.4189L30.4488 14.1193L31.6488 13.3193L30.4609 13.4189Z"
        fill="#C8102E"
      />
      <path
        d="M30.6697 14.2599L30.3281 13.668L31.6516 13.2641L30.6697 14.2599Z"
        fill="#C8102E"
      />
      <path
        d="M30.4531 13.3193L30.441 14.0197L29.2653 13.419L30.4531 13.3193Z"
        fill="#C8102E"
      />
      <path
        d="M30.2143 14.26L30.5781 13.5532L29.2546 13.3791L30.2143 14.26Z"
        fill="#C8102E"
      />
      <path
        d="M30.8828 13.6782L30.2541 14.0113L31.1955 15.1141L30.8828 13.6782Z"
        fill="#C8102E"
      />
      <path
        d="M30.2257 14.3634L30.6172 13.6123L31.1577 15.2L30.2257 14.3634Z"
        fill="#C8102E"
      />
      <path
        d="M30.0859 13.6689L30.6938 13.9256L30.4195 12.1567L30.0859 13.6689Z"
        fill="#C8102E"
      />
      <path
        d="M30.8258 13.6886L30.2891 13.9263L30.421 12.1574L30.8258 13.6886Z"
        fill="#C8102E"
      />
      <path
        d="M30.0547 13.6787L30.6626 13.9354L29.7211 15.1909L30.0547 13.6787Z"
        fill="#C8102E"
      />
      <path
        d="M30.6906 14.2702L30.3125 13.6123L29.7453 15.2L30.6906 14.2702Z"
        fill="#C8102E"
      />
      <path
        d="M36.0078 24.7266V26.0706L38.0238 24.7266H36.0078Z"
        fill="white"
      />
      <path
        d="M36.3894 26.307L35.7969 25.2197L38.0203 24.7271L36.3894 26.307Z"
        fill="white"
      />
      <path d="M36 24.7266V26.0706L33.984 24.7266H36Z" fill="white" />
      <path
        d="M35.6184 26.307L36.2109 25.2197L33.9875 24.7271L35.6184 26.307Z"
        fill="white"
      />
      <path
        d="M36.7031 25.3301L35.6599 25.8348L37.2415 27.7971L36.7031 25.3301Z"
        fill="white"
      />
      <path
        d="M35.6083 26.4108L36.2578 25.2188L37.1823 27.886L35.6083 26.4108Z"
        fill="white"
      />
      <path
        d="M35.375 25.2407L36.4183 25.7454L35.9134 22.7737L35.375 25.2407Z"
        fill="white"
      />
      <path
        d="M36.6184 25.4227L35.7344 25.7466L35.9208 22.7748L36.6184 25.4227Z"
        fill="white"
      />
      <path
        d="M35.2969 25.3301L36.3401 25.8348L34.7585 27.7971L35.2969 25.3301Z"
        fill="white"
      />
      <path
        d="M36.3917 26.4108L35.7422 25.2188L34.8177 27.886L36.3917 26.4108Z"
        fill="white"
      />
      <path
        d="M35.9922 24.9937V25.927L37.3922 24.9937H35.9922Z"
        fill="#C8102E"
      />
      <path
        d="M36.263 26.091L35.8516 25.3359L37.3956 24.9938L36.263 26.091Z"
        fill="#C8102E"
      />
      <path d="M36 24.9937V25.927L34.6 24.9937H36Z" fill="#C8102E" />
      <path
        d="M35.7292 26.091L36.1406 25.3359L34.5966 24.9938L35.7292 26.091Z"
        fill="#C8102E"
      />
      <path
        d="M36.4922 25.4126L35.7677 25.7631L36.8661 27.1258L36.4922 25.4126Z"
        fill="#C8102E"
      />
      <path
        d="M35.7287 26.1633L36.1797 25.3354L36.8217 27.1877L35.7287 26.1633Z"
        fill="#C8102E"
      />
      <path
        d="M35.5703 25.3506L36.2948 25.7011L35.9442 23.6374L35.5703 25.3506Z"
        fill="#C8102E"
      />
      <path
        d="M36.4342 25.4767L35.8203 25.7017L35.9498 23.6379L36.4342 25.4767Z"
        fill="#C8102E"
      />
      <path
        d="M35.5078 25.4126L36.2323 25.7631L35.1339 27.1258L35.5078 25.4126Z"
        fill="#C8102E"
      />
      <path
        d="M36.2713 26.1633L35.8203 25.3354L35.1783 27.1877L36.2713 26.1633Z"
        fill="#C8102E"
      />
    </g>
    <defs>
      <clipPath id="clip0_5415_21105">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SingaporeIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5415_21266)">
      <path d="M0 0H48V32H0V0Z" fill="white" />
      <path d="M0 0H48V16H0V0Z" fill="#ED2939" />
      <path
        d="M10.1389 13.8891C13.3912 13.8891 16.0278 11.2526 16.0278 8.00022C16.0278 4.74787 13.3912 2.11133 10.1389 2.11133C6.88654 2.11133 4.25 4.74787 4.25 8.00022C4.25 11.2526 6.88654 13.8891 10.1389 13.8891Z"
        fill="white"
      />
      <path
        d="M12.803 13.8891C16.0553 13.8891 18.6918 11.2526 18.6918 8.00022C18.6918 4.74787 16.0553 2.11133 12.803 2.11133C9.55061 2.11133 6.91406 4.74787 6.91406 8.00022C6.91406 11.2526 9.55061 13.8891 12.803 13.8891Z"
        fill="#ED2939"
      />
      <path
        d="M13.3649 3.08887L12.4636 5.8622L14.8236 4.14842H11.9062L14.2663 5.86309L13.3649 3.08887Z"
        fill="white"
      />
      <path
        d="M18.0367 6.48249L15.1206 6.48228L17.4797 8.19718L16.5782 5.42264L15.6768 8.19699L18.0367 6.48249Z"
        fill="white"
      />
      <path
        d="M10.4762 11.9732L12.8355 10.2593L9.91887 10.2586L12.279 11.9734L11.3776 9.199L10.4762 11.9732Z"
        fill="white"
      />
      <path
        d="M16.2611 11.962L15.3301 9.20421L14.4609 11.9822L16.7981 10.2447L13.8854 10.2771L16.2611 11.962Z"
        fill="white"
      />
      <path
        d="M8.67347 6.50297L11.0835 8.18902L10.1273 5.40714L9.26476 8.22248L11.6173 6.44964L8.67347 6.50297Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5415_21266">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AustraliaIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5415_21300)">
      <path d="M0 0H48V32H0V0Z" fill="#012169" />
      <mask
        id="mask0_5415_21300"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="16"
      >
        <path d="M0 0H24V16H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5415_21300)">
        <path d="M0 0L24 16L0 0ZM24 0L0 16L24 0Z" fill="black" />
        <path d="M0 0L24 16M24 0L0 16" stroke="white" strokeWidth="3.2" />
      </g>
      <mask
        id="mask1_5415_21300"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="16"
      >
        <path d="M0 0V8H24V16L0 0ZM24 0H12V16H0L24 0Z" fill="white" />
      </mask>
      <g mask="url(#mask1_5415_21300)">
        <path d="M0 0L24 16L0 0ZM24 0L0 16L24 0Z" fill="black" />
        <path d="M0 0L24 16M24 0L0 16" stroke="#E4002B" strokeWidth="2.13333" />
      </g>
      <path d="M12 0V16V0ZM0 8H24H0Z" fill="black" />
      <path d="M12 0V16M0 8H24" stroke="white" strokeWidth="5.33333" />
      <path d="M12 0V16V0ZM0 8H24H0Z" fill="black" />
      <path d="M12 0V16M0 8H24" stroke="#E4002B" strokeWidth="3.2" />
      <path
        d="M12.0019 19.2002L12.6961 22.0781L14.8165 21.0074L13.5618 23.5255L15.5117 25.0683L13.2529 25.3303L13.5639 28.3248L12.0019 26.1335L10.4399 28.3248L10.751 25.3303L8.49219 25.0683L10.442 23.5255L9.18734 21.0074L11.3077 22.0781L12.0019 19.2002Z"
        fill="white"
      />
      <path
        d="M35.9994 24.3813L36.33 25.7518L37.3397 25.2419L36.7422 26.441L37.6707 27.1757L36.5951 27.3004L36.7432 28.7264L35.9994 27.6829L35.2556 28.7264L35.4037 27.3005L34.3281 27.1757L35.2566 26.441L34.6591 25.2419L35.6689 25.7518L35.9994 24.3813Z"
        fill="white"
      />
      <path
        d="M29.9994 11.7144L30.33 13.0848L31.3397 12.575L30.7422 13.774L31.6707 14.5087L30.5951 14.6335L30.7432 16.0594L29.9994 15.0159L29.2556 16.0594L29.4037 14.6335L28.3281 14.5087L29.2566 13.774L28.6591 12.575L29.6689 13.0848L29.9994 11.7144Z"
        fill="white"
      />
      <path
        d="M35.9994 3.04785L36.33 4.4183L37.3397 3.90845L36.7422 5.10752L37.6707 5.84218L36.5951 5.96695L36.7432 7.39292L35.9994 6.34944L35.2556 7.39292L35.4037 5.96696L34.3281 5.84219L35.2566 5.10752L34.6591 3.90845L35.6689 4.4183L35.9994 3.04785Z"
        fill="white"
      />
      <path
        d="M41.3276 9.58105L41.6581 10.9515L42.6678 10.4417L42.0704 11.6407L42.9989 12.3754L41.9232 12.5002L42.0714 13.9261L41.3276 12.8826L40.5838 13.9261L40.7319 12.5002L39.6562 12.3754L40.5848 11.6407L39.9873 10.4417L40.997 10.9515L41.3276 9.58105Z"
        fill="white"
      />
      <path
        d="M38.3964 16L38.6576 16.8539L39.3474 16.9213L38.8191 17.5165L38.9842 18.412L38.3964 17.9259L37.8086 18.412L37.9737 17.5165L37.4453 16.9213L38.1351 16.8539L38.3964 16Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5415_21300">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EuropeIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_21543)">
      <path d="M0 0H48V32H0V0Z" fill="#003399" />
      <path
        d="M23.9943 5.0918L23.4609 6.67204L24.3498 6.83007L23.9943 5.0918Z"
        fill="#FFCC00"
      />
      <path
        d="M23.9979 5.0918L24.5312 6.67204L23.6424 6.83007L23.9979 5.0918Z"
        fill="#FFCC00"
      />
      <path
        d="M25.6609 6.19526L23.8154 6.20384L23.9566 7.02152L25.6609 6.19526Z"
        fill="#FFCC00"
      />
      <path
        d="M25.6594 6.19146L24.1826 7.12474L23.7092 6.40125L25.6594 6.19146Z"
        fill="#FFCC00"
      />
      <path
        d="M25.0472 7.95548L24.4088 6.39465L23.6002 6.71804L25.0472 7.95548Z"
        fill="#FFCC00"
      />
      <path
        d="M25.0387 7.95809L23.5572 6.94006L24.1538 6.35878L25.0387 7.95809Z"
        fill="#FFCC00"
      />
      <path
        d="M22.3234 6.19526L24.1689 6.20384L24.0278 7.02152L22.3234 6.19526Z"
        fill="#FFCC00"
      />
      <path
        d="M22.325 6.19146L23.8017 7.12474L24.2752 6.40125L22.325 6.19146Z"
        fill="#FFCC00"
      />
      <path
        d="M22.9372 7.95548L23.5756 6.39465L24.3842 6.71804L22.9372 7.95548Z"
        fill="#FFCC00"
      />
      <path
        d="M22.9456 7.95809L24.4272 6.94006L23.8306 6.35878L22.9456 7.95809Z"
        fill="#FFCC00"
      />
      <path
        d="M23.9943 24.0547L23.4609 25.6349L24.3498 25.793L23.9943 24.0547Z"
        fill="#FFCC00"
      />
      <path
        d="M23.9979 24.0547L24.5312 25.6349L23.6424 25.793L23.9979 24.0547Z"
        fill="#FFCC00"
      />
      <path
        d="M25.6609 25.1581L23.8154 25.1667L23.9566 25.9844L25.6609 25.1581Z"
        fill="#FFCC00"
      />
      <path
        d="M25.6594 25.1544L24.1826 26.0876L23.7092 25.3641L25.6594 25.1544Z"
        fill="#FFCC00"
      />
      <path
        d="M25.0472 26.9184L24.4088 25.3575L23.6002 25.6809L25.0472 26.9184Z"
        fill="#FFCC00"
      />
      <path
        d="M25.0387 26.921L23.5572 25.9029L24.1538 25.3217L25.0387 26.921Z"
        fill="#FFCC00"
      />
      <path
        d="M22.3234 25.1581L24.1689 25.1667L24.0278 25.9844L22.3234 25.1581Z"
        fill="#FFCC00"
      />
      <path
        d="M22.325 25.1544L23.8017 26.0876L24.2752 25.3641L22.325 25.1544Z"
        fill="#FFCC00"
      />
      <path
        d="M22.9372 26.9184L23.5756 25.3575L24.3842 25.6809L22.9372 26.9184Z"
        fill="#FFCC00"
      />
      <path
        d="M22.9456 26.921L24.4272 25.9029L23.8306 25.3217L22.9456 26.921Z"
        fill="#FFCC00"
      />
      <path
        d="M13.3302 14.5732L12.7969 16.1535L13.6858 16.3115L13.3302 14.5732Z"
        fill="#FFCC00"
      />
      <path
        d="M13.3339 14.5732L13.8672 16.1535L12.9783 16.3115L13.3339 14.5732Z"
        fill="#FFCC00"
      />
      <path
        d="M15.0047 15.6767L13.1592 15.6853L13.3004 16.503L15.0047 15.6767Z"
        fill="#FFCC00"
      />
      <path
        d="M15.0031 15.6729L13.5264 16.6062L13.053 15.8827L15.0031 15.6729Z"
        fill="#FFCC00"
      />
      <path
        d="M14.391 17.4369L13.7525 15.8761L12.9439 16.1995L14.391 17.4369Z"
        fill="#FFCC00"
      />
      <path
        d="M14.3825 17.4395L12.9009 16.4215L13.4975 15.8402L14.3825 17.4395Z"
        fill="#FFCC00"
      />
      <path
        d="M11.6516 15.6767L13.4971 15.6853L13.3559 16.503L11.6516 15.6767Z"
        fill="#FFCC00"
      />
      <path
        d="M11.6609 15.6729L13.1377 16.6062L13.6111 15.8827L11.6609 15.6729Z"
        fill="#FFCC00"
      />
      <path
        d="M12.2809 17.4369L12.9194 15.8761L13.7279 16.1995L12.2809 17.4369Z"
        fill="#FFCC00"
      />
      <path
        d="M12.2894 17.4395L13.7709 16.4215L13.1744 15.8402L12.2894 17.4395Z"
        fill="#FFCC00"
      />
      <path
        d="M17.7429 9.29969L19.2247 8.28093L18.6288 7.70009L17.7429 9.29969Z"
        fill="#FFCC00"
      />
      <path
        d="M17.7415 9.29699L18.3809 7.73601L19.1889 8.05888L17.7415 9.29699Z"
        fill="#FFCC00"
      />
      <path
        d="M17.1161 7.53298L18.627 8.46663L19.0798 7.74441L17.1161 7.53298Z"
        fill="#FFCC00"
      />
      <path
        d="M17.1104 7.53635L18.9629 7.5467L18.8463 8.36331L17.1104 7.53635Z"
        fill="#FFCC00"
      />
      <path
        d="M18.8072 6.44059L18.2661 8.01538L19.1275 8.15417L18.8072 6.44059Z"
        fill="#FFCC00"
      />
      <path
        d="M18.8099 6.44418L19.3052 7.99781L18.4392 8.17187L18.8099 6.44418Z"
        fill="#FFCC00"
      />
      <path
        d="M19.8326 9.2863L18.3616 8.30121L18.9954 7.70009L19.8326 9.2863Z"
        fill="#FFCC00"
      />
      <path
        d="M19.8314 9.28792L19.2444 7.73383L18.4049 8.08104L19.8314 9.28792Z"
        fill="#FFCC00"
      />
      <path
        d="M20.5001 7.52259L18.9523 8.46395L18.5217 7.76901L20.5001 7.52259Z"
        fill="#FFCC00"
      />
      <path
        d="M20.4999 7.52136L18.6398 7.56942L18.7297 8.36331L20.4999 7.52136Z"
        fill="#FFCC00"
      />
      <path
        d="M15.8914 12.8121L15.2519 11.2511L14.4439 11.574L15.8914 12.8121Z"
        fill="#FFCC00"
      />
      <path
        d="M15.8899 12.8148L14.4081 11.7961L15.004 11.2152L15.8899 12.8148Z"
        fill="#FFCC00"
      />
      <path
        d="M13.8002 12.8014L15.2712 11.8164L14.6374 11.2152L13.8002 12.8014Z"
        fill="#FFCC00"
      />
      <path
        d="M13.8014 12.8031L14.3884 11.249L15.2279 11.5962L13.8014 12.8031Z"
        fill="#FFCC00"
      />
      <path
        d="M13.1405 11.0377L14.6883 11.9791L15.1189 11.2841L13.1405 11.0377Z"
        fill="#FFCC00"
      />
      <path
        d="M13.1407 11.0365L15.0008 11.0846L14.911 11.8785L13.1407 11.0365Z"
        fill="#FFCC00"
      />
      <path
        d="M16.5323 11.0476L15.0215 11.9813L14.5686 11.2591L16.5323 11.0476Z"
        fill="#FFCC00"
      />
      <path
        d="M16.5302 11.0515L14.6777 11.0619L14.7943 11.8785L16.5302 11.0515Z"
        fill="#FFCC00"
      />
      <path
        d="M14.8334 9.95572L15.3745 11.5305L14.5131 11.6693L14.8334 9.95572Z"
        fill="#FFCC00"
      />
      <path
        d="M14.8307 9.95931L14.3354 11.5129L15.2014 11.687L14.8307 9.95931Z"
        fill="#FFCC00"
      />
      <path
        d="M16.5219 20.5605L14.6813 20.5592L14.8395 21.3828L16.5219 20.5605Z"
        fill="#FFCC00"
      />
      <path
        d="M16.5093 20.5552L15.0563 21.4864L14.5686 20.7558L16.5093 20.5552Z"
        fill="#FFCC00"
      />
      <path
        d="M15.9349 22.3175L15.2252 20.7562L14.4596 21.0782L15.9349 22.3175Z"
        fill="#FFCC00"
      />
      <path
        d="M15.9245 22.3202L14.4284 21.3002L14.9735 20.7201L15.9245 22.3202Z"
        fill="#FFCC00"
      />
      <path
        d="M13.8285 22.3191L15.2859 21.3007L14.6041 20.7196L13.8285 22.3191Z"
        fill="#FFCC00"
      />
      <path
        d="M13.8434 22.3167L14.364 20.7558L15.2436 21.0789L13.8434 22.3167Z"
        fill="#FFCC00"
      />
      <path
        d="M14.8139 19.4634L15.3731 21.0359L14.5757 21.1664L14.8139 19.4634Z"
        fill="#FFCC00"
      />
      <path
        d="M14.7955 19.4682L14.3887 21.0105L15.2014 21.1914L14.7955 19.4682Z"
        fill="#FFCC00"
      />
      <path
        d="M13.129 20.565L15.0031 20.5524L14.9628 21.3828L13.129 20.565Z"
        fill="#FFCC00"
      />
      <path
        d="M13.121 20.558L14.7374 21.487L15.1267 20.7481L13.121 20.558Z"
        fill="#FFCC00"
      />
      <path
        d="M20.3813 23.7412L18.5406 23.7399L18.6989 24.5635L20.3813 23.7412Z"
        fill="#FFCC00"
      />
      <path
        d="M20.3687 23.7359L18.9156 24.6671L18.428 23.9365L20.3687 23.7359Z"
        fill="#FFCC00"
      />
      <path
        d="M19.7865 25.4981L19.0768 23.9369L18.3111 24.2588L19.7865 25.4981Z"
        fill="#FFCC00"
      />
      <path
        d="M19.776 25.5009L18.2799 24.4808L18.825 23.9008L19.776 25.5009Z"
        fill="#FFCC00"
      />
      <path
        d="M17.68 25.4997L19.1374 24.4813L18.4556 23.9003L17.68 25.4997Z"
        fill="#FFCC00"
      />
      <path
        d="M17.695 25.4973L18.2156 23.9364L19.0951 24.2596L17.695 25.4973Z"
        fill="#FFCC00"
      />
      <path
        d="M18.6654 22.6441L19.2246 24.2165L18.4271 24.3471L18.6654 22.6441Z"
        fill="#FFCC00"
      />
      <path
        d="M18.6471 22.6489L18.2402 24.1911L19.053 24.3721L18.6471 22.6489Z"
        fill="#FFCC00"
      />
      <path
        d="M16.9883 23.7457L18.8624 23.733L18.8222 24.5635L16.9883 23.7457Z"
        fill="#FFCC00"
      />
      <path
        d="M16.9804 23.7387L18.5968 24.6676L18.9861 23.9288L16.9804 23.7387Z"
        fill="#FFCC00"
      />
      <path
        d="M34.662 14.5732L35.1953 16.1535L34.3064 16.3115L34.662 14.5732Z"
        fill="#FFCC00"
      />
      <path
        d="M34.6583 14.5732L34.125 16.1535L35.0139 16.3115L34.6583 14.5732Z"
        fill="#FFCC00"
      />
      <path
        d="M32.9875 15.6767L34.833 15.6853L34.6918 16.503L32.9875 15.6767Z"
        fill="#FFCC00"
      />
      <path
        d="M32.9891 15.6729L34.4658 16.6062L34.9392 15.8827L32.9891 15.6729Z"
        fill="#FFCC00"
      />
      <path
        d="M33.6012 17.4369L34.2397 15.8761L35.0483 16.1995L33.6012 17.4369Z"
        fill="#FFCC00"
      />
      <path
        d="M33.6097 17.4395L35.0912 16.4215L34.4947 15.8402L33.6097 17.4395Z"
        fill="#FFCC00"
      />
      <path
        d="M36.3484 15.6767L34.5029 15.6853L34.6441 16.503L36.3484 15.6767Z"
        fill="#FFCC00"
      />
      <path
        d="M36.3391 15.6729L34.8623 16.6062L34.3889 15.8827L36.3391 15.6729Z"
        fill="#FFCC00"
      />
      <path
        d="M35.7191 17.4369L35.0806 15.8761L34.2721 16.1995L35.7191 17.4369Z"
        fill="#FFCC00"
      />
      <path
        d="M35.7184 17.4395L34.2369 16.4215L34.8335 15.8402L35.7184 17.4395Z"
        fill="#FFCC00"
      />
      <path
        d="M30.2571 9.30018L28.7753 8.28142L29.3712 7.70058L30.2571 9.30018Z"
        fill="#FFCC00"
      />
      <path
        d="M30.2585 9.29748L29.6191 7.7365L28.8111 8.05936L30.2585 9.29748Z"
        fill="#FFCC00"
      />
      <path
        d="M30.8839 7.53298L29.373 8.46663L28.9202 7.74441L30.8839 7.53298Z"
        fill="#FFCC00"
      />
      <path
        d="M30.8896 7.53635L29.0371 7.5467L29.1537 8.36331L30.8896 7.53635Z"
        fill="#FFCC00"
      />
      <path
        d="M29.1928 6.44059L29.7339 8.01538L28.8725 8.15417L29.1928 6.44059Z"
        fill="#FFCC00"
      />
      <path
        d="M29.1901 6.44418L28.6948 7.99781L29.5608 8.17186L29.1901 6.44418Z"
        fill="#FFCC00"
      />
      <path
        d="M28.1674 9.28679L29.6384 8.3017L29.0046 7.70058L28.1674 9.28679Z"
        fill="#FFCC00"
      />
      <path
        d="M28.1686 9.28841L28.7556 7.73432L29.5951 8.08153L28.1686 9.28841Z"
        fill="#FFCC00"
      />
      <path
        d="M27.5077 7.52307L29.0555 8.46444L29.4861 7.76949L27.5077 7.52307Z"
        fill="#FFCC00"
      />
      <path
        d="M27.5079 7.52185L29.368 7.56991L29.2782 8.3638L27.5079 7.52185Z"
        fill="#FFCC00"
      />
      <path
        d="M32.1008 12.8126L32.7403 11.2516L33.5483 11.5745L32.1008 12.8126Z"
        fill="#FFCC00"
      />
      <path
        d="M32.1023 12.8153L33.584 11.7966L32.9882 11.2157L32.1023 12.8153Z"
        fill="#FFCC00"
      />
      <path
        d="M34.192 12.8014L32.721 11.8163L33.3548 11.2152L34.192 12.8014Z"
        fill="#FFCC00"
      />
      <path
        d="M34.1908 12.8031L33.6038 11.249L32.7642 11.5962L34.1908 12.8031Z"
        fill="#FFCC00"
      />
      <path
        d="M34.8595 11.0377L33.3117 11.9791L32.8811 11.2841L34.8595 11.0377Z"
        fill="#FFCC00"
      />
      <path
        d="M34.8593 11.0365L32.9992 11.0846L33.089 11.8785L34.8593 11.0365Z"
        fill="#FFCC00"
      />
      <path
        d="M31.4755 11.0481L32.9863 11.9818L33.4392 11.2596L31.4755 11.0481Z"
        fill="#FFCC00"
      />
      <path
        d="M31.4698 11.0515L33.3223 11.0618L33.2057 11.8785L31.4698 11.0515Z"
        fill="#FFCC00"
      />
      <path
        d="M33.1666 9.95573L32.6255 11.5305L33.4868 11.6693L33.1666 9.95573Z"
        fill="#FFCC00"
      />
      <path
        d="M33.1693 9.95931L33.6645 11.5129L32.7986 11.687L33.1693 9.95931Z"
        fill="#FFCC00"
      />
      <path
        d="M31.4703 20.5605L33.3109 20.5592L33.1526 21.3828L31.4703 20.5605Z"
        fill="#FFCC00"
      />
      <path
        d="M31.4828 20.5552L32.9359 21.4864L33.4236 20.7558L31.4828 20.5552Z"
        fill="#FFCC00"
      />
      <path
        d="M32.0651 22.3175L32.7748 20.7562L33.5404 21.0782L32.0651 22.3175Z"
        fill="#FFCC00"
      />
      <path
        d="M32.0755 22.3202L33.5716 21.3002L33.0265 20.7201L32.0755 22.3202Z"
        fill="#FFCC00"
      />
      <path
        d="M34.1715 22.3191L32.7141 21.3007L33.3959 20.7196L34.1715 22.3191Z"
        fill="#FFCC00"
      />
      <path
        d="M34.1566 22.3167L33.636 20.7558L32.7564 21.0789L34.1566 22.3167Z"
        fill="#FFCC00"
      />
      <path
        d="M33.1862 19.4634L32.6269 21.0358L33.4244 21.1664L33.1862 19.4634Z"
        fill="#FFCC00"
      />
      <path
        d="M33.2045 19.4682L33.6113 21.0105L32.7986 21.1914L33.2045 19.4682Z"
        fill="#FFCC00"
      />
      <path
        d="M34.871 20.565L32.9969 20.5524L33.0372 21.3828L34.871 20.565Z"
        fill="#FFCC00"
      />
      <path
        d="M34.879 20.558L33.2626 21.487L32.8733 20.7481L34.879 20.558Z"
        fill="#FFCC00"
      />
      <path
        d="M27.6187 23.7412L29.4594 23.7399L29.3011 24.5635L27.6187 23.7412Z"
        fill="#FFCC00"
      />
      <path
        d="M27.6313 23.7359L29.0844 24.6671L29.572 23.9365L27.6313 23.7359Z"
        fill="#FFCC00"
      />
      <path
        d="M28.2135 25.4981L28.9232 23.9369L29.6889 24.2588L28.2135 25.4981Z"
        fill="#FFCC00"
      />
      <path
        d="M28.224 25.5009L29.7201 24.4808L29.175 23.9008L28.224 25.5009Z"
        fill="#FFCC00"
      />
      <path
        d="M30.32 25.4997L28.8626 24.4813L29.5444 23.9003L30.32 25.4997Z"
        fill="#FFCC00"
      />
      <path
        d="M30.305 25.4973L29.7844 23.9364L28.9049 24.2596L30.305 25.4973Z"
        fill="#FFCC00"
      />
      <path
        d="M29.3346 22.6441L28.7754 24.2165L29.573 24.347L29.3346 22.6441Z"
        fill="#FFCC00"
      />
      <path
        d="M29.3529 22.6489L29.7598 24.1911L28.947 24.3721L29.3529 22.6489Z"
        fill="#FFCC00"
      />
      <path
        d="M31.0195 23.7457L29.1454 23.733L29.1856 24.5635L31.0195 23.7457Z"
        fill="#FFCC00"
      />
      <path
        d="M31.0274 23.7387L29.411 24.6676L29.0217 23.9288L31.0274 23.7387Z"
        fill="#FFCC00"
      />
    </g>
    <defs>
      <clipPath id="clip0_5419_21543">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const CyprusIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_21770)">
      <path d="M0 0H48V32H0V0Z" fill="white" />
      <path
        d="M24.7017 27.0264C24.6947 27.0234 24.6884 27.0189 24.6832 27.0133L24.6765 27.0071C24.6469 26.9794 24.6187 26.9501 24.5922 26.9194C24.5211 26.8387 24.4258 26.7206 24.342 26.6162C24.1759 26.4091 24.0386 26.2307 24.0127 26.1971L23.9705 26.1421L23.5562 26.0144L23.2538 25.8734L23.4154 25.6917L23.9705 25.9294L24.3847 26.0144L25.1507 26.5778L25.1501 26.5783C25.1486 26.5795 25.0387 26.671 24.9295 26.7703C24.8809 26.8145 24.8195 26.8716 24.7761 26.9187C24.7582 26.9378 24.7417 26.9582 24.7265 26.9795C24.7174 26.9947 24.7091 27.0103 24.7017 27.0264M21.8569 26.172C21.4832 26.1686 21.1171 26.0662 20.7958 25.8751H20.7955V25.8747C20.8346 25.8095 20.8868 25.7532 20.949 25.7094C21.0525 25.6334 21.2392 25.5425 21.541 25.5414H21.5472C21.9045 25.5414 22.3419 25.6628 22.8471 25.9025C22.5476 26.0804 22.2053 26.1736 21.8569 26.172ZM20.2905 25.8248C20.2589 25.8254 20.2276 25.8194 20.1984 25.8072C20.1693 25.7949 20.1431 25.7767 20.1214 25.7537C20.0836 25.7098 20.0576 25.6569 20.0457 25.6002C20.0286 25.5265 20.0223 25.4508 20.027 25.3753C20.0533 25.3639 20.0816 25.3575 20.1103 25.3564H20.1163C20.2502 25.3564 20.3557 25.4726 20.401 25.5877C20.4256 25.6386 20.4308 25.6968 20.4156 25.7513C20.4045 25.7745 20.3866 25.7939 20.3644 25.807C20.3421 25.82 20.3165 25.826 20.2908 25.8243L20.2905 25.8248ZM23.0468 25.5054C22.121 25.3731 21.7285 25.0384 21.5623 24.7809C21.4571 24.6247 21.4076 24.4376 21.4219 24.2497V24.249H21.4226C21.4691 24.2383 21.5166 24.233 21.5643 24.2334C21.8106 24.2334 22.4406 24.3572 23.047 25.5049L23.0474 25.5057L23.0463 25.5051L23.0468 25.5054ZM21.1492 25.3219C20.7537 25.3219 20.4525 25.2536 20.2541 25.1192C20.1698 25.0652 20.1018 24.9891 20.0575 24.8992C20.0414 24.8651 20.0307 24.8287 20.0259 24.7913C20.1577 24.7379 20.2979 24.7081 20.44 24.7033C20.4604 24.7024 20.481 24.7018 20.5026 24.7017C20.8083 24.7017 21.2732 24.8015 21.7637 25.2767L21.7642 25.2771H21.7636C21.5598 25.3052 21.3544 25.3202 21.1487 25.3219L21.1492 25.3219ZM19.234 25.2483C18.8169 25.2483 18.2439 25.1209 17.8866 24.7636L17.8862 24.7632H17.8873C18.1589 24.6991 18.4363 24.6622 18.7152 24.6532C18.7412 24.6526 18.7675 24.6523 18.7939 24.6522C19.1849 24.6522 19.4842 24.7281 19.6836 24.8776C19.7393 24.911 19.7806 24.9639 19.7997 25.026C19.8019 25.0485 19.7978 25.0711 19.7878 25.0913C19.7779 25.1116 19.7625 25.1287 19.7434 25.1407C19.6537 25.2084 19.4932 25.2446 19.2663 25.2482L19.2343 25.2493L19.234 25.2483ZM17.8825 24.555C17.8572 24.555 17.8323 24.5494 17.8094 24.5387C17.7866 24.5279 17.7664 24.5122 17.7503 24.4927C17.7202 24.4532 17.7 24.4071 17.6912 24.3582C17.6776 24.2938 17.6724 24.228 17.6757 24.1623V24.1613C17.6961 24.1519 17.7182 24.1469 17.7406 24.1466C17.7929 24.1485 17.8424 24.1707 17.8787 24.2084C17.919 24.2479 17.9498 24.2962 17.9687 24.3495C17.9876 24.3939 17.991 24.4434 17.9783 24.49C17.9707 24.5092 17.9575 24.5256 17.9403 24.5372C17.9232 24.5487 17.9029 24.5547 17.8823 24.5545L17.8825 24.555ZM21.0041 24.4846C20.9725 24.4852 20.9412 24.4792 20.912 24.4669C20.8829 24.4547 20.8567 24.4365 20.835 24.4135C20.7972 24.3695 20.7711 24.3167 20.7592 24.26C20.7421 24.1863 20.7358 24.1105 20.7405 24.0351C20.7668 24.0236 20.7951 24.0172 20.8238 24.0162H20.8298C20.9637 24.0162 21.0692 24.1323 21.1145 24.2475C21.1391 24.2984 21.1443 24.3566 21.1291 24.4111C21.118 24.4343 21.1002 24.4538 21.0779 24.4668C21.0556 24.4798 21.03 24.4859 21.0043 24.4841L21.0041 24.4846ZM19.4836 24.4216C18.6443 24.3921 18.2089 24.1535 17.9911 23.9585C17.898 23.8769 17.8212 23.7783 17.765 23.668C17.744 23.6266 17.7278 23.583 17.7165 23.538L17.7177 23.5375C17.7848 23.5171 17.8547 23.5067 17.9249 23.5066H17.9445C18.2275 23.5066 18.8037 23.6255 19.4833 24.4215V24.422L19.4836 24.4216ZM20.395 24.3368C19.7198 24.234 19.3372 23.9441 19.1352 23.719C19.0105 23.5851 18.9157 23.4262 18.8572 23.2529C18.9254 23.2373 18.9952 23.2289 19.0652 23.2279C19.0742 23.2279 19.0836 23.2275 19.0931 23.2275C19.1027 23.2275 19.1126 23.2275 19.1226 23.2279C19.4622 23.2353 20.0791 23.3891 20.3949 24.3364H20.3954L20.395 24.3368ZM16.9284 24.0126C16.7134 24.0132 16.4992 23.9876 16.2905 23.9362C15.937 23.8478 15.7853 23.7128 15.7203 23.6151C15.6923 23.5746 15.6736 23.5284 15.6653 23.4799C15.6624 23.461 15.6618 23.4418 15.6637 23.4227L15.6653 23.4221C15.848 23.3768 16.0353 23.353 16.2234 23.3513C16.2362 23.3513 16.249 23.351 16.2621 23.351C16.4154 23.3507 16.5684 23.3655 16.7188 23.3952C17.06 23.4666 17.364 23.6586 17.575 23.936V23.9365H17.5743C17.3628 23.9882 17.1457 24.0137 16.9279 24.0122L16.9284 24.0126ZM18.4958 23.443C18.4644 23.4438 18.4331 23.4381 18.4039 23.4261C18.3748 23.4142 18.3485 23.3963 18.3267 23.3736C18.2887 23.3291 18.2627 23.2758 18.2509 23.2185C18.2338 23.1454 18.2275 23.0702 18.2322 22.9953C18.2586 22.9839 18.2868 22.9775 18.3155 22.9764H18.3215C18.4551 22.9764 18.5609 23.0927 18.6062 23.2078C18.6304 23.2583 18.635 23.3159 18.6192 23.3696C18.6086 23.393 18.5912 23.4126 18.5691 23.4257C18.5471 23.4389 18.5216 23.445 18.496 23.4432L18.4958 23.443ZM17.3172 23.2814C17.0928 23.2178 16.8781 23.1241 16.6789 23.0027C16.3833 22.8207 16.0215 22.4987 15.9774 21.9984H15.9782C16.0006 21.9936 16.0234 21.9909 16.0463 21.9902C16.0517 21.9902 16.0579 21.9899 16.0642 21.9899C16.1525 21.9899 16.3333 22.0147 16.552 22.181C16.8304 22.3933 17.0875 22.7634 17.3173 23.2824L17.3172 23.2814ZM18.0868 23.2531C17.9036 23.1699 17.7335 23.0606 17.5818 22.9286C17.1895 22.591 16.8838 22.1643 16.6902 21.6843C16.7511 21.6558 16.818 21.6427 16.8852 21.646C17.0138 21.6497 17.2096 21.7031 17.4267 21.9374C17.6761 22.2066 17.8987 22.6489 18.0881 23.2521L18.0886 23.2538L18.087 23.2533L18.0868 23.2531ZM16.0926 23.195C15.8355 23.195 15.7475 23.0555 15.7216 22.9955C15.6958 22.933 15.6857 22.8651 15.6921 22.7978V22.7967C15.7339 22.7863 15.7769 22.7807 15.8201 22.78H15.8289C15.9117 22.7779 15.994 22.7954 16.0688 22.831C16.1437 22.8666 16.2092 22.9193 16.26 22.9848C16.2736 23.005 16.3153 23.0752 16.2808 23.1299C16.2531 23.1731 16.1901 23.195 16.0925 23.195L16.0926 23.195ZM15.523 22.4765C15.3239 22.477 15.1251 22.46 14.9289 22.4257C14.6998 22.3841 14.57 22.1894 14.5015 22.0334C14.4554 21.9268 14.4231 21.8147 14.4055 21.6999H14.4061C15.1145 21.7207 15.4491 21.9276 15.605 22.0976C15.7016 22.1981 15.7617 22.3281 15.7759 22.4667H15.7755C15.7744 22.4667 15.6747 22.4763 15.5227 22.4763L15.523 22.4765ZM16.2606 21.7394C16.2031 21.6669 16.1491 21.5917 16.0989 21.5139C16.015 21.3835 15.9374 21.2473 15.9374 21.1361C15.9374 21.0286 15.9121 20.8019 15.897 20.6764C15.8779 20.5172 15.8586 20.381 15.857 20.3694H15.8577C15.8757 20.376 16.3008 20.5355 16.3008 20.9343C16.3008 21.333 16.2614 21.735 16.2611 21.739V21.7396H16.2605L16.2606 21.7394ZM15.7097 21.7016C15.7052 21.7016 15.7008 21.7011 15.6964 21.7004C15.5707 21.6795 15.3497 21.5834 15.1058 21.4435C14.8348 21.2881 14.6147 21.1216 14.4861 20.9746C14.3687 20.8407 14.2994 20.6303 14.2791 20.3492C14.2702 20.222 14.2718 20.0942 14.2838 19.9672C14.3064 19.9599 14.3301 19.9563 14.3539 19.9566C14.448 19.9581 14.5484 20.0004 14.684 20.0938C14.8076 20.1818 14.9234 20.2802 15.0301 20.3879C15.1657 20.5226 15.2939 20.6645 15.4141 20.813L15.4158 20.8152C15.43 20.8405 15.5511 21.059 15.6455 21.2716C15.6927 21.3694 15.729 21.4722 15.7535 21.578C15.7628 21.609 15.7628 21.642 15.7535 21.673C15.7495 21.6831 15.7423 21.6915 15.733 21.6969C15.7255 21.7001 15.7175 21.7018 15.7095 21.7017L15.7097 21.7016Z"
        fill="#4E5B31"
      />
      <path
        d="M23.2983 27.0264C23.3053 27.0234 23.3116 27.0189 23.3168 27.0133L23.3235 27.0071C23.3531 26.9794 23.3813 26.9501 23.4078 26.9194C23.4789 26.8387 23.5742 26.7206 23.658 26.6162C23.8241 26.4091 23.9614 26.2307 23.9873 26.1971L24.0295 26.1421L24.4438 26.0144L24.7462 25.8734L24.5846 25.6917L24.0295 25.9294L23.6153 26.0144L22.8493 26.5778L22.8499 26.5783C22.8514 26.5795 22.9613 26.671 23.0705 26.7703C23.1191 26.8145 23.1805 26.8716 23.2239 26.9187C23.2418 26.9378 23.2583 26.9582 23.2735 26.9795C23.2826 26.9947 23.2909 27.0103 23.2983 27.0264M26.1431 26.172C26.5168 26.1686 26.8829 26.0662 27.2042 25.8751H27.2045V25.8747C27.1654 25.8095 27.1132 25.7532 27.051 25.7094C26.9475 25.6334 26.7608 25.5425 26.459 25.5414H26.4528C26.0955 25.5414 25.6581 25.6628 25.1529 25.9025C25.4524 26.0804 25.7947 26.1736 26.1431 26.172ZM27.7095 25.8248C27.7411 25.8254 27.7724 25.8194 27.8016 25.8072C27.8307 25.7949 27.8569 25.7767 27.8786 25.7537C27.9164 25.7098 27.9424 25.6569 27.9543 25.6002C27.9714 25.5265 27.9777 25.4508 27.973 25.3753C27.9467 25.3639 27.9184 25.3575 27.8897 25.3564H27.8837C27.7498 25.3564 27.6443 25.4726 27.599 25.5877C27.5744 25.6386 27.5692 25.6968 27.5844 25.7513C27.5955 25.7745 27.6134 25.7939 27.6356 25.807C27.6579 25.82 27.6835 25.826 27.7092 25.8243L27.7095 25.8248ZM24.9532 25.5054C25.879 25.3731 26.2715 25.0384 26.4377 24.7809C26.5429 24.6247 26.5924 24.4376 26.5781 24.2497V24.249H26.5774C26.5309 24.2383 26.4834 24.233 26.4357 24.2334C26.1894 24.2334 25.5594 24.3572 24.953 25.5049L24.9526 25.5057L24.9537 25.5051L24.9532 25.5054ZM26.8508 25.3219C27.2463 25.3219 27.5475 25.2536 27.7459 25.1192C27.8302 25.0652 27.8982 24.9891 27.9425 24.8992C27.9586 24.8651 27.9693 24.8287 27.9741 24.7913C27.8423 24.7379 27.7021 24.7081 27.56 24.7033C27.5396 24.7024 27.519 24.7018 27.4974 24.7017C27.1917 24.7017 26.7268 24.8015 26.2363 25.2767L26.2358 25.2771H26.2364C26.4402 25.3052 26.6456 25.3202 26.8513 25.3219L26.8508 25.3219ZM28.766 25.2483C29.1831 25.2483 29.7561 25.1209 30.1134 24.7636L30.1138 24.7632H30.1127C29.8411 24.6991 29.5637 24.6622 29.2848 24.6532C29.2588 24.6526 29.2325 24.6523 29.2061 24.6522C28.8151 24.6522 28.5158 24.7281 28.3164 24.8776C28.2607 24.911 28.2194 24.9639 28.2003 25.026C28.1981 25.0485 28.2022 25.0711 28.2122 25.0913C28.2221 25.1116 28.2375 25.1287 28.2566 25.1407C28.3463 25.2084 28.5068 25.2446 28.7337 25.2482L28.7657 25.2493L28.766 25.2483ZM30.1175 24.555C30.1428 24.555 30.1677 24.5494 30.1906 24.5387C30.2134 24.5279 30.2336 24.5122 30.2497 24.4927C30.2798 24.4532 30.3 24.4071 30.3088 24.3582C30.3224 24.2938 30.3276 24.228 30.3243 24.1623V24.1613C30.3039 24.1519 30.2818 24.1469 30.2594 24.1466C30.2071 24.1485 30.1576 24.1707 30.1213 24.2084C30.081 24.2479 30.0502 24.2962 30.0313 24.3495C30.0124 24.3939 30.009 24.4434 30.0217 24.49C30.0293 24.5092 30.0425 24.5256 30.0597 24.5372C30.0768 24.5487 30.0971 24.5547 30.1177 24.5545L30.1175 24.555ZM26.9959 24.4846C27.0275 24.4852 27.0588 24.4792 27.088 24.4669C27.1171 24.4547 27.1433 24.4365 27.165 24.4135C27.2028 24.3695 27.2289 24.3167 27.2408 24.26C27.2579 24.1863 27.2642 24.1105 27.2595 24.0351C27.2332 24.0236 27.2049 24.0172 27.1762 24.0162H27.1702C27.0363 24.0162 26.9308 24.1323 26.8855 24.2475C26.8609 24.2984 26.8557 24.3566 26.8709 24.4111C26.882 24.4343 26.8998 24.4538 26.9221 24.4668C26.9444 24.4798 26.97 24.4859 26.9957 24.4841L26.9959 24.4846ZM28.5164 24.4216C29.3557 24.3921 29.7911 24.1535 30.0089 23.9585C30.102 23.8769 30.1788 23.7783 30.235 23.668C30.256 23.6266 30.2722 23.583 30.2835 23.538L30.2823 23.5375C30.2152 23.5171 30.1453 23.5067 30.0751 23.5066H30.0555C29.7725 23.5066 29.1963 23.6255 28.5167 24.4215V24.422L28.5164 24.4216ZM27.605 24.3368C28.2802 24.234 28.6628 23.9441 28.8648 23.719C28.9895 23.5851 29.0843 23.4262 29.1428 23.2529C29.0746 23.2373 29.0048 23.2289 28.9348 23.2279C28.9258 23.2279 28.9164 23.2275 28.9069 23.2275C28.8973 23.2275 28.8874 23.2275 28.8774 23.2279C28.5378 23.2353 27.9209 23.3891 27.6051 24.3364H27.6046L27.605 24.3368ZM31.0716 24.0126C31.2866 24.0132 31.5008 23.9876 31.7095 23.9362C32.063 23.8478 32.2147 23.7128 32.2797 23.6151C32.3077 23.5746 32.3264 23.5284 32.3347 23.4799C32.3376 23.461 32.3382 23.4418 32.3363 23.4227L32.3347 23.4221C32.152 23.3768 31.9647 23.353 31.7766 23.3513C31.7638 23.3513 31.751 23.351 31.7379 23.351C31.5846 23.3507 31.4316 23.3655 31.2812 23.3952C30.94 23.4666 30.636 23.6586 30.425 23.936V23.9365H30.4257C30.6372 23.9882 30.8543 24.0137 31.0721 24.0122L31.0716 24.0126ZM29.5042 23.443C29.5356 23.4438 29.5669 23.4381 29.5961 23.4261C29.6252 23.4142 29.6515 23.3963 29.6733 23.3736C29.7113 23.3291 29.7373 23.2758 29.7491 23.2185C29.7662 23.1454 29.7725 23.0702 29.7678 22.9953C29.7414 22.9839 29.7132 22.9775 29.6845 22.9764H29.6785C29.5449 22.9764 29.4391 23.0927 29.3938 23.2078C29.3696 23.2583 29.365 23.3159 29.3808 23.3696C29.3914 23.393 29.4088 23.4126 29.4309 23.4257C29.4529 23.4389 29.4784 23.445 29.504 23.4432L29.5042 23.443ZM30.6828 23.2814C30.9072 23.2178 31.1219 23.1241 31.3211 23.0027C31.6167 22.8207 31.9785 22.4987 32.0226 21.9984H32.0218C31.9994 21.9936 31.9766 21.9909 31.9537 21.9902C31.9483 21.9902 31.9421 21.9899 31.9358 21.9899C31.8475 21.9899 31.6667 22.0147 31.448 22.181C31.1696 22.3933 30.9125 22.7634 30.6827 23.2824L30.6828 23.2814ZM29.9132 23.2531C30.0964 23.1699 30.2665 23.0606 30.4182 22.9286C30.8105 22.591 31.1162 22.1643 31.3098 21.6843C31.2489 21.6558 31.182 21.6427 31.1148 21.646C30.9862 21.6497 30.7904 21.7031 30.5733 21.9374C30.3239 22.2066 30.1013 22.6489 29.9119 23.2521L29.9114 23.2538L29.913 23.2533L29.9132 23.2531ZM31.9074 23.195C32.1645 23.195 32.2525 23.0555 32.2784 22.9955C32.3042 22.933 32.3143 22.8651 32.3079 22.7978V22.7967C32.2661 22.7863 32.2231 22.7807 32.1799 22.78H32.1711C32.0883 22.7779 32.006 22.7954 31.9312 22.831C31.8563 22.8666 31.7908 22.9193 31.74 22.9848C31.7264 23.005 31.6847 23.0752 31.7192 23.1299C31.7469 23.1731 31.8099 23.195 31.9075 23.195L31.9074 23.195ZM32.477 22.4765C32.6761 22.477 32.8749 22.46 33.0711 22.4257C33.3002 22.3841 33.43 22.1894 33.4985 22.0334C33.5446 21.9268 33.5769 21.8147 33.5945 21.6999H33.5939C32.8855 21.7207 32.5509 21.9276 32.395 22.0976C32.2984 22.1981 32.2383 22.3281 32.2241 22.4667H32.2245C32.2256 22.4667 32.3253 22.4763 32.4773 22.4763L32.477 22.4765ZM31.7394 21.7394C31.7969 21.6669 31.8509 21.5917 31.9011 21.5139C31.985 21.3835 32.0626 21.2473 32.0626 21.1361C32.0626 21.0286 32.0879 20.8019 32.103 20.6764C32.1221 20.5172 32.1414 20.381 32.143 20.3694H32.1423C32.1243 20.376 31.6992 20.5355 31.6992 20.9343C31.6992 21.333 31.7386 21.735 31.7389 21.739V21.7396H31.7395L31.7394 21.7394ZM32.2903 21.7016C32.2948 21.7016 32.2992 21.7011 32.3036 21.7004C32.4293 21.6795 32.6503 21.5834 32.8942 21.4435C33.1652 21.2881 33.3853 21.1216 33.5139 20.9746C33.6313 20.8407 33.7006 20.6303 33.7209 20.3492C33.7298 20.222 33.7282 20.0942 33.7162 19.9672C33.6936 19.9599 33.6699 19.9563 33.6461 19.9566C33.552 19.9581 33.4516 20.0004 33.316 20.0938C33.1924 20.1818 33.0766 20.2802 32.9699 20.3879C32.8343 20.5226 32.7061 20.6645 32.5859 20.813L32.5842 20.8152C32.57 20.8405 32.4489 21.059 32.3545 21.2716C32.3073 21.3694 32.271 21.4722 32.2465 21.578C32.2372 21.609 32.2372 21.642 32.2465 21.673C32.2505 21.6831 32.2577 21.6915 32.267 21.6969C32.2745 21.7001 32.2825 21.7018 32.2905 21.7017L32.2903 21.7016Z"
        fill="#4E5B31"
      />
      <path
        d="M38.7801 5.54511L38.6544 5.59514L38.6052 5.61476L38.453 5.60639L38.3104 5.67482L38.0576 5.84756L38.0465 5.85556L37.9523 5.88015L37.8647 5.84239L37.815 5.865L37.7979 5.9674L37.7506 6.04095L37.6924 6.08186L37.4906 6.1025L37.3205 6.19023L37.0991 6.13098L36.9963 6.17124L36.7776 6.36815L36.6659 6.42106L36.6269 6.41882L36.4787 6.41119L36.4162 6.43167L36.3227 6.52196L36.1459 6.53572L36.0908 6.57386L36.0045 6.74772L35.911 6.84415L35.8577 6.85546L35.7997 6.83412L35.7562 6.8418L35.7364 6.95306L35.6941 6.99967L35.5758 7.04042L35.4812 7.11919L35.3982 7.16186L35.2871 7.15908H35.2615L35.1508 7.2202L34.9428 7.23844L34.8562 7.32106L34.8371 7.33871L34.7967 7.36314L34.7306 7.4026L34.7146 7.41242L34.6346 7.39818L34.5412 7.43514L34.5035 7.37706L34.4389 7.41583L34.3535 7.41951L34.2469 7.3721L34.1657 7.33594L34.1063 7.34452L34.0857 7.44799L34.0836 7.45898L34.0212 7.54202L33.9047 7.61258L33.8887 7.63322L33.7562 7.80431L33.5044 8.06916L33.2914 8.17732L33.0707 8.24447L32.916 8.3714L32.5107 8.57231L31.8709 8.89087L31.7401 8.93279L31.5524 8.96276L31.2175 9.08607L30.9221 9.17519L30.9057 9.1802L30.847 9.19791L30.4305 9.32394L30.2366 9.30346L30.1218 9.34516L29.8229 9.31199L29.6149 9.3161L29.4833 9.34346L29.236 9.46207L28.8186 9.66271L28.6806 9.7889L28.4659 9.9009L28.2144 9.98052L28.215 9.87487L28.2135 9.87039L28.1262 9.89796L28.0632 9.91786L27.8592 9.94932H27.7458L27.6753 9.92884L27.6646 9.93252L27.2477 10.0695L26.7827 10.1144L26.55 10.1891L26.3761 10.1863L26.2674 10.2187L26.0541 10.2447L25.9779 10.2244L25.9607 10.2197L25.3341 10.2469L25.0476 10.2146L24.9108 10.2456L24.6815 10.1685L24.3471 10.1298L24.269 10.1063L24.093 10.0542L24.0135 10.1L23.954 10.1063L23.8117 10.0548L23.7605 10.0535L23.6432 10.0962L23.5756 10.0788L23.5128 10.0288L23.3656 10.0069L23.2759 9.93146L22.7746 9.99791L22.6385 9.95791L22.1823 9.825L22.1097 9.82868L22.019 9.89647L21.8831 9.94602L21.7652 9.97668L21.6045 9.98202L21.4179 9.93306L21.2255 9.83983L21.1544 9.82292L20.9958 9.83892L20.9473 9.8433L20.6558 9.68692L20.2802 9.45226L20.0254 9.32959L19.9297 9.31407L19.9168 9.35956L19.9643 9.5089L19.9803 9.65684L19.9755 9.79354L19.9728 9.87818L19.9966 9.95418L20.0886 10.0562L20.127 10.1586L20.155 10.4404L20.1547 10.7263L20.11 11.1824L20.0949 11.2517L20.0415 11.488L19.9928 11.705L19.8037 12.2828L19.7517 12.3544L19.6242 12.4414L19.3352 12.6381L19.1224 12.7607L19.055 12.7886L18.8823 12.8017L18.7747 12.7964L18.6406 12.7238L18.5091 12.6899L18.3367 12.566L18.1447 12.5263L17.9345 12.4048L17.8798 12.339L17.7653 12.3284L17.6066 12.2807V12.2805L17.5483 12.263L17.508 12.2513L17.3054 12.246L17.1166 12.1588L17.0172 12.1348L16.8813 12.1279L16.7391 12.194L16.6671 12.2276L16.576 12.1914L16.5102 12.1955L16.4355 12.3083L16.4263 12.3255L16.3749 12.3527L16.3109 12.3518L16.2608 12.3505L16.2067 12.3742L16.1337 12.4058L16.0693 12.4339L16.0378 12.4475L16.0373 12.447L16.0179 12.4509L15.9835 12.4568L15.9408 12.465L15.8656 12.4211L15.8256 12.3975L15.7586 12.3838L15.7225 12.4099L15.7154 12.5326L15.6824 12.6061L15.5779 12.6985L15.4716 12.7922L15.3975 12.9013L15.2014 13.3488L15.0788 13.5293L15.0406 13.5714L14.9117 13.7133L14.7978 13.8016L14.5352 14.0051L14.2868 14.098L14.0727 14.1417L13.9687 14.1421L13.7714 14.1159L13.5941 14.0615L13.3995 13.9398L13.1861 13.7682L12.8771 13.4629L12.8334 13.4366L12.8243 13.4306L12.7269 13.3683L12.6547 13.3702L12.6264 13.4168L12.611 13.4842L12.5979 13.5439L12.5625 13.8835L12.5651 13.9031L12.5837 14.043L12.8184 14.371L12.8908 14.5452L12.9027 14.5651L12.9511 14.6464L12.988 14.7085L12.9917 14.7148L13.0717 14.9541L13.0153 15.0893L13.0438 15.1799L12.9725 15.2352L12.9595 15.3134L13.1702 15.5775L13.2162 15.6941L13.1648 15.8556L13.0829 15.9447L13.06 15.9691L13.0715 16.0374L13.1685 16.1246L13.3332 16.2712L13.4211 16.4892L13.4879 16.5478L13.5655 16.5313L13.6087 16.5643L13.6742 16.5631L13.7387 16.6276L13.7804 16.6478L13.8463 16.6806L13.8984 16.7485L13.9099 16.9571L14.0071 17.2163L14.0086 17.3568L14.0091 17.3767L14.0696 17.4806L14.0886 17.5627L14.0566 17.7797L14.1336 17.8493L14.2172 17.8323L14.2712 17.8408L14.3579 17.913L14.4629 18.073L14.5656 18.058L14.6308 18.0894L14.9455 18.3739L15.0169 18.4099L15.0208 18.4122L15.0722 18.4379L15.1362 18.5023L15.2352 18.4366L15.2462 18.4355L15.3538 18.426L15.4011 18.458L15.4917 18.5193L15.6109 18.5178L15.8692 18.597L15.9822 18.6259L16.2095 18.7671L16.3061 18.8269L16.3632 18.8733L16.4392 18.9352L16.5909 19.0005L16.7211 19.0317L16.7916 19.0484L16.8449 19.0689L16.8462 19.0656H16.847L16.8457 19.069L17.1275 19.1768L17.2802 19.2125L17.4214 19.2645L17.5242 19.3018L17.5996 19.303L17.7062 19.2133L17.8095 19.2074L17.8954 19.2287L17.9791 19.2147L18.1116 19.133L18.1375 19.0947L18.2315 19.0499L18.5485 19.0106L18.6411 19.0406L18.879 18.9372L19.0383 18.9815L19.1794 18.9315L19.4876 18.9999L19.5695 19.0576L19.6611 19.1624L19.6723 19.1629L19.7743 19.1648L19.7316 19.2358L19.8662 19.377L19.9877 19.5607L19.9959 19.585L20.0843 19.8444L20.15 19.9363L20.196 20.0646L20.1982 20.1482L20.1268 20.2027L20.115 20.2338L20.111 20.2453L20.1255 20.2803L20.1525 20.2655L20.2038 20.2371L20.2663 20.2274L20.3765 20.2391L20.4493 20.2468L20.5642 20.1897L20.6403 20.1519L20.7626 20.2045L20.897 20.203L20.9534 20.2281L21.1134 20.3006L21.1949 20.3083L21.2251 20.2885L21.2443 20.2428L21.2344 20.1895L21.173 20.1191L21.038 19.9624L20.9828 19.8819L20.9407 19.7653L20.9277 19.6162L20.9184 19.5157L20.9351 19.3836L20.9714 19.3364L20.9981 19.2315H20.9986L21.0054 19.204L21.0804 19.1045L21.279 18.9768L21.4924 18.7858L21.661 18.6746L21.8349 18.5993L21.8395 18.578L21.8589 18.5858L22.3011 18.4354L22.3084 18.4346L22.5053 18.4003L23.8344 18.4939L23.8837 18.479V18.4787L23.9279 18.3544L23.9518 18.3314L23.9678 18.3163L24.1139 18.252L24.1822 18.2422L24.3719 18.2891L24.4495 18.3082L24.5739 18.2385L24.6621 18.24L24.8444 18.1405L24.957 18.1433L24.9996 18.1262L25.2189 17.9686L25.4302 17.908L25.4851 17.8788L25.5045 17.8681L25.721 17.7538L25.8586 17.6481L25.9773 17.5851L26.1073 17.5515L26.4476 17.5276L26.516 17.4135L26.6623 17.394L26.7507 17.2943L26.852 17.2532L26.9245 17.1487L26.9853 17.0612L27.0701 17.0121L27.3421 16.995L27.6645 17.035L27.7072 17.0091L27.78 16.7491L27.8563 16.7003L28.0617 16.401L28.0624 16.2919V16.2008L28.0962 16.0711L28.0732 15.837L28.1004 15.5998L28.2281 15.2985L28.3406 15.177L28.5219 15.0543L28.6141 15.0141L28.7447 14.9922V14.9922L28.7639 14.989L28.7972 14.9832L29.247 14.9771C29.2532 14.9724 29.4106 14.9748 29.4106 14.9748L29.5605 14.9728L29.9401 15.0402L29.967 15.0449L30.095 15.0864L30.243 15.2015L30.3997 15.3545L30.4291 15.383L30.5304 15.4257L30.5611 15.4391L30.6448 15.4257L30.7642 15.3636L30.8542 15.2875L30.9768 15.2204L30.9798 15.2162L31.0489 15.1123L31.051 15.1101L31.0525 15.1105V15.1099H31.0513L31.0786 15.0686L31.3157 14.9762L31.5947 14.9601L31.626 14.9432L31.6435 14.9339L31.7172 14.8473L31.7862 14.8468L31.9534 14.9072L32.0708 14.8839L32.1641 14.9212L32.2366 14.9126L32.3734 14.8966L32.5203 14.9999L32.6059 15.0106L32.9077 15.1871L32.9234 15.1897L32.9315 15.1912L32.9487 15.1941L32.9845 15.1834L33.0379 15.168L33.0449 15.1659L33.0516 15.1752L33.0859 15.2236L33.133 15.2303L33.1886 15.156L33.1665 15.1223L33.1581 15.1101L33.0503 15.0882L32.9535 14.9228L33.0457 14.8236L32.9011 14.6462L32.8771 14.6168L32.869 14.6043L32.819 14.5284L32.5659 14.1426L32.2362 13.8794L32.1207 13.787L32.1199 13.7864L32.0795 13.7544L31.9035 13.5753L31.7778 13.4084L31.7613 13.3725L31.7353 13.3158L31.6599 13.1517L31.5286 13.0503L31.4216 12.9335L31.4163 12.9266L31.1955 12.6266L31.1592 12.5763L31.1071 12.5461L30.9969 12.5454L30.9862 12.5347L30.98 12.5283L30.9838 12.5243L31.0366 12.4718L31.0956 12.457L31.121 12.3989L31.0085 12.0735L31.0078 12.0622L30.9994 11.9582L31.091 11.4859L31.1028 11.4284L31.2589 11.1106L31.3557 11.0314L31.4613 10.8238L31.5519 10.6911L31.6386 10.6067L31.6538 10.5978L31.8102 10.503L31.9417 10.4845L32.0669 10.4669L32.2856 10.5343L32.4936 10.5302L32.5342 10.5259L32.6286 10.5152L32.7838 10.4663L32.8571 10.4211L32.8951 10.3628L32.9744 10.0968L32.9999 10.0122L33.0488 9.92026L33.3318 9.5945L33.5458 9.39663L34.0268 9.04394L34.2622 8.90319L34.3824 8.83135L35.4558 8.35423L35.7348 8.07156L35.8801 7.92447L36.1372 7.75194L36.4381 7.62868L36.697 7.42378L36.7535 7.35263L36.8247 7.1233L36.8841 7.10895L36.9374 6.993L36.9527 6.96004L37.1639 6.81114L37.1878 6.79924L38.0085 6.38804L38.1278 6.40442L38.1918 6.30879L38.4306 6.26874L38.4745 6.26127L38.5332 6.23188L38.5833 6.14655V6.1297L38.5901 5.9018L38.6411 5.8402L38.6689 5.69002L38.6951 5.65535L38.7224 5.6193L38.7901 5.57178L38.7783 5.54346L38.7801 5.54511Z"
        fill="#D57800"
      />
    </g>
    <defs>
      <clipPath id="clip0_5419_21770">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const FranceIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_21780)">
      <path d="M0 0H48V32H0V0Z" fill="#ED2939" />
      <path d="M0 0H32V32H0V0Z" fill="white" />
      <path d="M0 0H16V32H0V0Z" fill="#002395" />
    </g>
    <defs>
      <clipPath id="clip0_5419_21780">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GermanyIcons = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_21789)">
      <path d="M0 0H48V32H0V0Z" fill="black" />
      <path d="M0 10.6665H48V31.9998H0V10.6665Z" fill="#DD0000" />
      <path d="M0 21.333H48V31.9997H0V21.333Z" fill="#FFCE00" />
    </g>
    <defs>
      <clipPath id="clip0_5419_21789">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const IrelandIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_21798)">
      <path d="M0 0H48V32H0V0Z" fill="#169B62" />
      <path d="M16 0H48V32H16V0Z" fill="white" />
      <path d="M32 0H48V32H32V0Z" fill="#FF883E" />
    </g>
    <defs>
      <clipPath id="clip0_5419_21798">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const MaltaIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_21861)">
      <path d="M0 0H48V32H0V0Z" fill="white" />
      <path d="M24 0H48V32H24V0Z" fill="#CF142B" />
      <path
        d="M4.81453 1.85205H7.1849V4.10367C7.27485 4.09728 7.36771 4.11207 7.45627 4.14689C7.54482 4.18171 7.62668 4.23561 7.69549 4.30442C7.7643 4.37323 7.8182 4.45509 7.85302 4.54364C7.88783 4.63219 7.90262 4.72506 7.89624 4.81501H10.1479V7.18538H7.89624C7.90262 7.27534 7.88783 7.3682 7.85302 7.45675C7.8182 7.54531 7.7643 7.62717 7.69549 7.69598C7.62668 7.76478 7.54482 7.81869 7.45627 7.85351C7.36771 7.88832 7.27485 7.90311 7.1849 7.89673V10.1483H4.81453V7.89673C4.72457 7.90311 4.63171 7.88832 4.54315 7.85351C4.4546 7.81869 4.37274 7.76478 4.30393 7.69598C4.23512 7.62717 4.18122 7.54531 4.1464 7.45675C4.11159 7.3682 4.0968 7.27534 4.10318 7.18538H1.85156V4.81501H4.10318C4.0968 4.72506 4.11159 4.63219 4.1464 4.54364C4.18122 4.45509 4.23512 4.37323 4.30393 4.30442C4.37274 4.23561 4.4546 4.18171 4.54315 4.14689C4.63171 4.11207 4.72457 4.09728 4.81453 4.10367V1.85205Z"
        stroke="#CF142B"
        strokeWidth="0.296296"
      />
      <path
        d="M7.17083 4.10466C7.26268 4.09587 7.35808 4.10938 7.44923 4.14406C7.54038 4.17875 7.62471 4.23364 7.69531 4.30425C7.76592 4.37486 7.82081 4.45918 7.8555 4.55033C7.89019 4.64149 7.90369 4.73688 7.89491 4.82873V7.17132C7.90369 7.26317 7.89019 7.35857 7.8555 7.44972C7.82081 7.54087 7.76592 7.62519 7.69531 7.6958C7.62471 7.76641 7.54038 7.8213 7.44923 7.85599C7.35808 7.89068 7.26268 7.90418 7.17083 7.8954H4.82824C4.73639 7.90418 4.641 7.89068 4.54985 7.85599C4.45869 7.8213 4.37437 7.76641 4.30376 7.6958C4.23315 7.62519 4.17826 7.54087 4.14358 7.44972C4.10889 7.35857 4.09538 7.26317 4.10417 7.17132V4.82873C4.09538 4.73688 4.10889 4.64149 4.14358 4.55033C4.17826 4.45918 4.23315 4.37486 4.30376 4.30425C4.37437 4.23364 4.45869 4.17875 4.54985 4.14406C4.641 4.10938 4.73639 4.09587 4.82824 4.10466H7.17083Z"
        fill="white"
      />
      <path
        d="M4.83015 1.86572H7.17274V10.1342H4.83015V1.86572ZM1.86719 4.82869H10.1357V7.17128H1.86719V4.82869Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
      />
      <path
        d="M4.96296 2H7.03704V10H4.96296V2ZM2 4.96296H10V7.03704H2V4.96296Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0555556"
      />
      <path
        d="M6.00029 7.85214C7.02304 7.85214 7.85214 7.02304 7.85214 6.00029C7.85214 4.97754 7.02304 4.14844 6.00029 4.14844C4.97754 4.14844 4.14844 4.97754 4.14844 6.00029C4.14844 7.02304 4.97754 7.85214 6.00029 7.85214Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0555556"
      />
      <path
        d="M6.00318 7.37062C6.76002 7.37062 7.37355 6.75709 7.37355 6.00025C7.37355 5.24342 6.76002 4.62988 6.00318 4.62988C5.24635 4.62988 4.63281 5.24342 4.63281 6.00025C4.63281 6.75709 5.24635 7.37062 6.00318 7.37062Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0555556"
      />
      <path
        d="M7.77836 4.5161C7.71412 4.56529 7.59201 4.69086 7.51794 4.78288L7.44907 4.74005C7.5434 4.65846 7.67419 4.53751 7.74653 4.45128L7.77836 4.5161ZM7.71991 4.40904C7.60359 4.44318 7.38137 4.50857 7.28646 4.56876L7.26562 4.53866C7.30556 4.48137 7.35069 4.24584 7.34896 4.17871L7.4213 4.19491C7.39757 4.25279 7.37442 4.37663 7.36806 4.45707C7.44271 4.44376 7.61979 4.38589 7.67014 4.34943L7.71991 4.40904Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M7.87277 4.67394H7.78099C7.78919 4.62547 7.77603 4.56477 7.74362 4.50167C7.71121 4.43856 7.66146 4.37675 7.60243 4.32626C7.5434 4.27576 7.47854 4.23953 7.41838 4.22344C7.35821 4.20735 7.30626 4.21234 7.27093 4.23761C7.23561 4.26287 7.21898 4.30693 7.22375 4.36264C7.22852 4.41835 7.2544 4.48246 7.2972 4.54456C7.34001 4.60667 7.39722 4.66314 7.45958 4.70482C7.52193 4.7465 7.58578 4.77096 7.64077 4.77423L7.70564 4.69685L7.78556 4.77677L7.69615 4.86612C7.61276 4.85373 7.53071 4.82377 7.45553 4.77829C7.38034 4.7328 7.31378 4.67284 7.26035 4.60246C7.20691 4.53207 7.16784 4.45291 7.14577 4.3703C7.1237 4.2877 7.11916 4.20359 7.13243 4.12365C7.21129 4.11055 7.29422 4.11479 7.37577 4.1361C7.45731 4.15741 7.53563 4.1953 7.60556 4.24728C7.67549 4.29926 7.73546 4.36416 7.78152 4.43769C7.82757 4.51123 7.85867 4.59174 7.87277 4.67394Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M7.48293 7.78519C7.43374 7.72096 7.30816 7.59885 7.21615 7.52478L7.25897 7.45591C7.34057 7.55024 7.46152 7.68103 7.54774 7.75336L7.48293 7.78519ZM7.58999 7.72674C7.55584 7.61042 7.49045 7.3882 7.43027 7.29329L7.46036 7.27246C7.51765 7.31239 7.75318 7.35753 7.82031 7.35579L7.80411 7.42813C7.74624 7.40441 7.6224 7.38126 7.54196 7.37489C7.55527 7.44954 7.61314 7.62663 7.64959 7.67697L7.58999 7.72674Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M7.32509 7.8757V7.78392C7.37355 7.79212 7.43425 7.77896 7.49736 7.74655C7.56046 7.71414 7.62227 7.66439 7.67277 7.60536C7.72327 7.54633 7.75949 7.48147 7.77558 7.42131C7.79167 7.36114 7.78668 7.30919 7.76142 7.27386C7.73615 7.23854 7.69209 7.22191 7.63638 7.22668C7.58067 7.23145 7.51657 7.25733 7.45446 7.30013C7.39236 7.34294 7.33589 7.40015 7.2942 7.46251C7.25252 7.52486 7.22806 7.58871 7.2248 7.6437L7.30217 7.70857L7.22225 7.78849L7.1329 7.69908C7.1453 7.61569 7.17525 7.53364 7.22074 7.45846C7.26622 7.38327 7.32618 7.31671 7.39657 7.26328C7.46695 7.20984 7.54612 7.17077 7.62872 7.1487C7.71132 7.12663 7.79543 7.12209 7.87538 7.13536C7.88848 7.21422 7.88423 7.29715 7.86292 7.3787C7.84161 7.46024 7.80372 7.53856 7.75174 7.60849C7.69976 7.67842 7.63487 7.73839 7.56133 7.78444C7.48779 7.8305 7.40728 7.8616 7.32509 7.8757Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M4.22164 7.48439C4.28588 7.4352 4.40799 7.30962 4.48206 7.21761L4.55093 7.26043C4.4566 7.34203 4.32581 7.46298 4.25347 7.54921L4.22164 7.48439ZM4.28009 7.59145C4.39641 7.55731 4.61863 7.49192 4.71354 7.43173L4.73438 7.46182C4.69444 7.51912 4.64931 7.75465 4.65104 7.82178L4.5787 7.80557C4.60243 7.7477 4.62558 7.62386 4.63194 7.54342C4.55729 7.55673 4.38021 7.6146 4.32986 7.65106L4.28009 7.59145Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M4.12723 7.32655H4.21901C4.21081 7.37502 4.22397 7.43572 4.25638 7.49882C4.28879 7.56193 4.33854 7.62373 4.39757 7.67423C4.4566 7.72473 4.52146 7.76096 4.58162 7.77705C4.64179 7.79314 4.69374 7.78815 4.72907 7.76288C4.76439 7.73762 4.78102 7.69356 4.77625 7.63785C4.77148 7.58213 4.7456 7.51803 4.7028 7.45593C4.65999 7.39382 4.60278 7.33735 4.54042 7.29567C4.47807 7.25398 4.41422 7.22953 4.35923 7.22626L4.29436 7.30364L4.21444 7.22372L4.30385 7.13436C4.38724 7.14676 4.46929 7.17671 4.54447 7.2222C4.61966 7.26769 4.68622 7.32765 4.73965 7.39803C4.79309 7.46842 4.83216 7.54758 4.85423 7.63018C4.8763 7.71279 4.88084 7.7969 4.86757 7.87684C4.78871 7.88994 4.70578 7.8857 4.62423 7.86439C4.54269 7.84308 4.46437 7.80519 4.39444 7.75321C4.32451 7.70123 4.26454 7.63633 4.21848 7.5628C4.17243 7.48926 4.14133 7.40875 4.12723 7.32655Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M4.51707 4.2153C4.56626 4.27953 4.69184 4.40164 4.78385 4.47571L4.74103 4.54458C4.65943 4.45025 4.53848 4.31946 4.45226 4.24712L4.51707 4.2153ZM4.41001 4.27374C4.44416 4.39006 4.50955 4.61229 4.56973 4.70719L4.53964 4.72803C4.48235 4.6881 4.24682 4.64296 4.17969 4.64469L4.19589 4.57236C4.25376 4.59608 4.3776 4.61923 4.45804 4.6256C4.44473 4.55094 4.38686 4.37386 4.35041 4.32351L4.41001 4.27374Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M4.67491 4.12479V4.21657C4.62645 4.20836 4.56575 4.22153 4.50264 4.25394C4.43954 4.28635 4.37773 4.3361 4.32723 4.39513C4.27673 4.45416 4.24051 4.51902 4.22442 4.57918C4.20833 4.63935 4.21332 4.6913 4.23858 4.72663C4.26385 4.76195 4.30791 4.77858 4.36362 4.77381C4.41933 4.76904 4.48343 4.74316 4.54554 4.70036C4.60764 4.65755 4.66411 4.60034 4.7058 4.53798C4.74748 4.47562 4.77194 4.41178 4.7752 4.35679L4.69783 4.29192L4.77775 4.212L4.8671 4.30141C4.8547 4.38479 4.82475 4.46685 4.77926 4.54203C4.73378 4.61722 4.67382 4.68377 4.60343 4.73721C4.53305 4.79065 4.45388 4.82972 4.37128 4.85179C4.28868 4.87386 4.20457 4.8784 4.12462 4.86512C4.11152 4.78627 4.11577 4.70334 4.13708 4.62179C4.15839 4.54025 4.19628 4.46193 4.24826 4.392C4.30024 4.32206 4.36513 4.2621 4.43867 4.21604C4.51221 4.16999 4.59272 4.13889 4.67491 4.12479Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinejoin="round"
      />
      <path
        d="M4.52807 7.03584C4.4864 6.96293 4.43142 6.86976 4.40133 6.84545C4.41985 6.83272 4.44473 6.8142 4.45747 6.81073C4.45689 6.85702 4.52691 6.95309 4.52691 6.95309L4.62992 6.88538C4.60098 6.84082 4.57552 6.80668 4.55469 6.79337C4.58015 6.77485 4.60735 6.75922 4.61487 6.75749C4.61545 6.78006 4.62876 6.81767 4.66811 6.86397C4.66811 6.86397 4.76418 6.81304 4.79543 6.77369L4.83594 6.83966C4.7908 6.84834 4.58825 6.9745 4.52807 7.03584ZM4.38513 6.15795C4.27691 6.17763 4.22193 6.26964 4.24045 6.37323C4.25897 6.47797 4.35272 6.54973 4.45573 6.53237C4.55874 6.51443 4.61719 6.41952 4.59751 6.30957C4.57784 6.19962 4.49334 6.13827 4.38513 6.15795ZM4.40075 6.22045C4.48756 6.20482 4.56047 6.24707 4.57263 6.3142C4.58478 6.38133 4.53096 6.44788 4.44358 6.46351C4.35619 6.47913 4.28675 6.42357 4.27691 6.36744C4.26649 6.31015 4.31337 6.23607 4.40075 6.22045ZM4.61256 5.58388C4.57668 5.64059 4.4974 5.69267 4.42737 5.7407C4.41753 5.69094 4.3805 5.65911 4.33767 5.65621C4.29196 5.6539 4.24508 5.69036 4.23698 5.71466C4.22541 5.74823 4.21094 5.89232 4.21094 5.89232C4.30122 5.88538 4.49855 5.90101 4.56626 5.92589L4.57436 5.8495C4.5298 5.86107 4.42911 5.84024 4.42911 5.84024L4.43142 5.80668L4.53559 5.7245C4.5489 5.71408 4.62703 5.64117 4.62934 5.58908C4.62992 5.57288 4.61603 5.57693 4.61256 5.58388ZM4.40365 5.83908C4.36256 5.84024 4.27691 5.83561 4.25318 5.8252C4.26244 5.74244 4.28791 5.71293 4.33189 5.71698C4.3724 5.72103 4.41522 5.74418 4.40365 5.83908ZM4.79832 4.81362C4.71962 4.81999 4.62124 4.89406 4.62355 4.95772C4.62413 4.99128 4.63571 5.03758 4.68027 5.07114C4.72425 5.10471 4.76997 5.11455 4.80642 5.1076C4.84172 5.10124 4.90017 5.05205 4.89959 5.02485C4.89959 4.99823 4.83709 4.92415 4.79774 4.92415L4.86314 4.85413C4.87992 4.89464 4.94705 4.95367 4.97193 4.96119C4.94358 5.0289 4.90828 5.0995 4.8342 5.13364C4.76013 5.16837 4.68316 5.16663 4.61314 5.10066C4.54716 5.03816 4.57263 4.91779 4.61429 4.87091C4.66001 4.81941 4.74508 4.79742 4.74682 4.75749L4.79832 4.81362ZM5.16753 4.42415L5.18142 4.68689C5.18142 4.68689 5.18663 4.78006 5.16522 4.83793L5.24682 4.78064C5.21499 4.75517 5.22135 4.67705 5.22135 4.67705L5.3533 4.60645C5.3533 4.60645 5.4158 4.64638 5.40943 4.69499L5.5217 4.64927C5.45631 4.62439 5.37529 4.56709 5.37529 4.56709L5.16753 4.42415ZM5.20978 4.50575L5.33015 4.58561L5.21267 4.64869L5.20978 4.50575ZM5.7989 4.23145C5.78385 4.29568 5.80006 4.42242 5.82378 4.52774C5.90538 4.52022 5.96788 4.51212 5.99566 4.47739L6.00318 4.5642C5.92274 4.5642 5.8342 4.57346 5.75318 4.58619C5.75434 4.46756 5.74219 4.31189 5.70862 4.24476L5.7989 4.23145ZM6.41175 4.27022C6.37413 4.32462 6.34288 4.44846 6.32668 4.55494C6.40538 4.57809 6.46672 4.59314 6.5055 4.57057L6.48061 4.65448C6.40596 4.62554 6.31973 4.60124 6.23987 4.5833C6.28385 4.47392 6.32957 4.32404 6.32321 4.24996L6.41175 4.27022ZM7.03154 4.55089L6.80237 4.6811C6.80237 4.6811 6.72135 4.72797 6.66001 4.73492L6.7474 4.78121C6.75608 4.74186 6.82899 4.71235 6.82899 4.71235L6.95168 4.79857C6.95168 4.79857 6.94358 4.87323 6.89728 4.88885L6.98814 4.96871C6.98177 4.89927 6.99624 4.80031 6.99624 4.80031L7.03154 4.55089ZM6.97714 4.62496L6.9592 4.76906L6.84983 4.69209L6.97714 4.62496ZM7.15307 5.16432L7.11719 5.09661C7.17622 5.09198 7.35388 4.98781 7.43547 4.93457L7.44821 4.95772L7.37182 5.30668C7.4401 5.27948 7.54832 5.22276 7.57784 5.19151L7.61835 5.26848C7.54253 5.25749 7.40191 5.32693 7.29543 5.39175L7.28501 5.37323L7.35041 5.03353C7.35041 5.03353 7.1739 5.11339 7.15307 5.16432ZM7.69126 5.66895C7.68432 5.61744 7.68316 5.58214 7.65828 5.57057L7.65538 5.54915L7.71846 5.53874C7.7445 5.60645 7.77402 5.7951 7.76997 5.84371L7.70515 5.85413L7.70226 5.83619C7.72367 5.81189 7.70226 5.72276 7.70226 5.72276C7.60619 5.7326 7.43895 5.7598 7.41522 5.79279L7.40017 5.70367C7.43432 5.71524 7.60272 5.6973 7.69126 5.66895ZM7.3805 6.43515C7.41638 6.37844 7.49682 6.32693 7.56684 6.27948C7.57668 6.32925 7.61314 6.36165 7.65654 6.36397C7.70226 6.36686 7.74913 6.33156 7.75723 6.30668C7.76939 6.27311 7.78443 6.12959 7.78443 6.12959C7.69416 6.13538 7.4974 6.1186 7.42969 6.09314L7.42101 6.16952C7.46557 6.15853 7.56626 6.17936 7.56626 6.17936L7.56395 6.21293L7.4592 6.29452C7.44531 6.30494 7.36661 6.37728 7.36372 6.42936C7.36314 6.44557 7.37703 6.44094 7.3805 6.43515ZM7.59172 6.1811C7.63281 6.18052 7.71846 6.18573 7.74219 6.19614C7.73235 6.2789 7.70631 6.30841 7.66233 6.30378C7.62182 6.29915 7.57957 6.27601 7.59172 6.1811ZM7.26418 6.66489L7.21036 6.75749C7.25203 6.75112 7.3099 6.78411 7.35677 6.81478C7.3724 6.85645 7.43374 6.96293 7.42911 7.06709L7.49855 6.94788C7.46788 6.93399 7.432 6.91895 7.40885 6.80726C7.50029 6.77311 7.56858 6.76212 7.59751 6.77832L7.65885 6.67415C7.58767 6.71698 7.42043 6.76096 7.39265 6.7517C7.36372 6.73492 7.28154 6.70945 7.26418 6.66489Z"
        fill="black"
      />
      <path
        d="M6.85359 7.43862C6.89354 7.43862 6.92593 7.40623 6.92593 7.36628C6.92593 7.32633 6.89354 7.29395 6.85359 7.29395C6.81364 7.29395 6.78125 7.32633 6.78125 7.36628C6.78125 7.40623 6.81364 7.43862 6.85359 7.43862Z"
        fill="black"
      />
      <path
        d="M5.14265 7.43862C5.1826 7.43862 5.21499 7.40623 5.21499 7.36628C5.21499 7.32633 5.1826 7.29395 5.14265 7.29395C5.1027 7.29395 5.07031 7.32633 5.07031 7.36628C5.07031 7.40623 5.1027 7.43862 5.14265 7.43862Z"
        fill="black"
      />
      <path
        d="M6.11622 7.76608C6.10869 7.77129 6.08844 7.76087 6.08381 7.74467C6.08381 7.74987 6.08265 7.76608 6.07281 7.77534C6.04909 7.79791 6.02362 7.78691 6.00337 7.78691C5.98311 7.78691 5.95765 7.79791 5.93392 7.77534C5.92409 7.76608 5.92293 7.74987 5.92293 7.74467C5.9183 7.76087 5.89804 7.77129 5.89052 7.76608C5.88358 7.76087 5.88705 7.7383 5.90094 7.72904C5.89631 7.7302 5.8801 7.73425 5.86853 7.72788C5.83959 7.71226 5.84249 7.68448 5.83612 7.66538C5.82976 7.64629 5.81124 7.62545 5.82571 7.59594C5.83149 7.58379 5.84654 7.57742 5.85117 7.57568C5.83439 7.57626 5.81876 7.56006 5.82108 7.55196C5.82397 7.54328 5.84654 7.5398 5.85985 7.55022C5.85638 7.54617 5.84828 7.53228 5.85059 7.51897C5.85638 7.48656 5.88358 7.48078 5.89978 7.46862C5.91656 7.45647 5.93045 7.43274 5.96286 7.43737C5.97617 7.43911 5.98659 7.45126 5.99006 7.45531C5.98427 7.43969 5.99469 7.41943 6.00337 7.41943C6.01205 7.41943 6.02247 7.43969 6.01668 7.45531C6.02015 7.45126 6.03057 7.43911 6.04388 7.43737C6.07628 7.43274 6.09017 7.45647 6.10696 7.46862C6.12316 7.48078 6.15036 7.48656 6.15615 7.51897C6.15846 7.53228 6.15036 7.54617 6.14689 7.55022C6.1602 7.5398 6.18277 7.54328 6.18566 7.55196C6.18797 7.56006 6.17235 7.57626 6.15557 7.57568C6.1602 7.57742 6.17524 7.58379 6.18103 7.59594C6.1955 7.62545 6.17698 7.64629 6.17061 7.66538C6.16425 7.68448 6.16714 7.71226 6.13821 7.72788C6.12663 7.73425 6.11043 7.7302 6.1058 7.72904C6.11969 7.7383 6.12316 7.76087 6.11622 7.76608ZM5.94955 7.68506C5.95881 7.692 5.93392 7.71284 5.94376 7.73888C5.95476 7.76955 5.98543 7.76029 6.00337 7.76029C6.02131 7.76029 6.05198 7.76955 6.06297 7.73888C6.07281 7.71284 6.04793 7.692 6.05719 7.68506C6.06645 7.67811 6.07918 7.70821 6.10638 7.70763C6.13936 7.70589 6.13994 7.67464 6.14515 7.65728C6.15094 7.63992 6.16946 7.61388 6.14341 7.59362C6.122 7.57626 6.09365 7.59362 6.09017 7.58263C6.0867 7.57163 6.11911 7.56932 6.12721 7.5427C6.13589 7.51087 6.1058 7.50103 6.09133 7.49004C6.07628 7.47962 6.05719 7.45416 6.02999 7.4721C6.00742 7.48772 6.01494 7.51955 6.00337 7.51955C5.99179 7.51955 5.99932 7.48772 5.97675 7.4721C5.94955 7.45416 5.93045 7.47962 5.9154 7.49004C5.90094 7.50103 5.87084 7.51087 5.87953 7.5427C5.88763 7.56932 5.92003 7.57163 5.91656 7.58263C5.91309 7.59362 5.88473 7.57626 5.86332 7.59362C5.83728 7.61388 5.8558 7.63992 5.86159 7.65728C5.86679 7.67464 5.86737 7.70589 5.90036 7.70763C5.92756 7.70821 5.94029 7.67811 5.94955 7.68506Z"
        fill="black"
      />
      <path
        d="M6.00036 7.72613C5.99515 7.72613 5.98878 7.71398 5.99226 7.70414C5.99052 7.70703 5.98415 7.71398 5.97605 7.71513C5.95638 7.71803 5.94828 7.70356 5.93844 7.69661C5.9286 7.68909 5.9124 7.68562 5.90892 7.66652C5.90719 7.65842 5.9124 7.64974 5.91413 7.64742C5.90603 7.65379 5.89272 7.65148 5.89098 7.64627C5.88925 7.64164 5.89909 7.6318 5.90892 7.6318C5.90603 7.63122 5.89735 7.62717 5.89388 7.62023C5.8852 7.60229 5.89619 7.59013 5.90024 7.57856C5.90372 7.56698 5.90198 7.5502 5.91934 7.54094C5.92628 7.53689 5.93612 7.53921 5.93902 7.54036C5.93034 7.53458 5.9286 7.52127 5.93265 7.5178C5.93728 7.5149 5.94943 7.52127 5.95233 7.53053C5.95233 7.52763 5.9529 7.5178 5.95869 7.51259C5.97316 7.4987 5.98821 7.50564 6.00036 7.50564C6.01251 7.50564 6.02756 7.4987 6.04203 7.51259C6.04781 7.5178 6.04839 7.52763 6.04839 7.53053C6.05128 7.52127 6.06344 7.5149 6.06807 7.5178C6.07212 7.52127 6.07038 7.53458 6.0617 7.54036C6.06459 7.53921 6.07443 7.53689 6.08138 7.54094C6.09874 7.5502 6.097 7.56698 6.10047 7.57856C6.10453 7.59013 6.11552 7.60229 6.10684 7.62023C6.10337 7.62717 6.09469 7.63122 6.09179 7.6318C6.10163 7.6318 6.11147 7.64164 6.10973 7.64627C6.108 7.65148 6.09469 7.65379 6.08659 7.64742C6.08832 7.64974 6.09353 7.65842 6.09179 7.66652C6.08832 7.68562 6.07212 7.68909 6.06228 7.69661C6.05244 7.70356 6.04434 7.71803 6.02466 7.71513C6.01656 7.71398 6.0102 7.70703 6.00846 7.70414C6.01193 7.71398 6.00557 7.72613 6.00036 7.72613ZM6.00036 7.66016C6.00672 7.66016 6.00267 7.67752 6.01483 7.68562C6.02929 7.69546 6.03971 7.68215 6.04781 7.67636C6.05591 7.67057 6.07212 7.66479 6.06691 7.648C6.06286 7.63354 6.0455 7.63238 6.04723 7.62601C6.04897 7.62023 6.06402 7.62948 6.07617 7.62023C6.09006 7.60923 6.08022 7.59534 6.07733 7.58608C6.07385 7.57682 6.07385 7.55946 6.05591 7.55888C6.04087 7.5583 6.0345 7.57451 6.02929 7.57104C6.02409 7.56756 6.03797 7.55599 6.03277 7.5421C6.0264 7.52532 6.0102 7.53053 6.00036 7.53053C5.99052 7.53053 5.97432 7.52532 5.96795 7.5421C5.96274 7.55599 5.97663 7.56756 5.97142 7.57104C5.96622 7.57451 5.95985 7.5583 5.9448 7.55888C5.92686 7.55946 5.92686 7.57682 5.92339 7.58608C5.9205 7.59534 5.91066 7.60923 5.92455 7.62023C5.9367 7.62948 5.95175 7.62023 5.95348 7.62601C5.95522 7.63238 5.93786 7.63354 5.93381 7.648C5.9286 7.66479 5.9448 7.67057 5.9529 7.67636C5.96101 7.68215 5.97142 7.69546 5.98589 7.68562C5.99804 7.67752 5.99399 7.66016 6.00036 7.66016Z"
        fill="black"
      />
      <path
        d="M6.00434 7.63856C6.01968 7.63856 6.03212 7.62613 6.03212 7.61079C6.03212 7.59544 6.01968 7.58301 6.00434 7.58301C5.989 7.58301 5.97656 7.59544 5.97656 7.61079C5.97656 7.62613 5.989 7.63856 6.00434 7.63856Z"
        fill="black"
      />
      <path
        d="M5.05469 6.99433C5.68328 6.96869 6.31266 6.96869 6.94126 6.99433"
        stroke="black"
        strokeWidth="0.0277778"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.92969 5.3208C5.97251 5.36825 5.97714 5.38041 5.97714 5.38041M6.05642 6.13446C6.05353 6.18365 6.05584 6.23457 6.06395 6.26062M5.93779 6.14256C5.95631 6.16281 5.98119 6.23284 5.97772 6.25888"
        stroke="black"
        strokeWidth="0.0138889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3257 6.98709C6.30313 6.99403 6.26378 7.0166 6.26436 7.03686C6.26494 7.05653 6.31124 7.05943 6.32513 7.06348C6.30024 7.07389 6.22096 7.08894 6.18566 7.071C6.16019 7.08605 5.97848 7.04438 5.94144 7.04322C5.9183 7.04264 5.88531 7.02297 5.88936 6.97841C5.88994 6.96857 5.89631 6.946 5.9183 6.93848C5.90556 6.91649 5.9617 6.87945 6.01725 6.84588C5.93392 6.85688 5.82918 6.82447 5.80256 6.79264C5.7389 6.77065 5.71112 6.79206 5.6845 6.84762C5.68681 6.94311 5.63357 6.98825 5.56992 6.98072C5.52651 6.97551 5.51725 6.99577 5.50568 7.0004L5.63531 7.04033C5.7198 7.12193 5.67003 7.18153 5.65151 7.19658C5.63357 7.21105 5.58554 7.2041 5.55719 7.2041C5.52883 7.2041 5.52825 7.21278 5.5161 7.21915C5.49584 7.22956 5.47559 7.23535 5.46691 7.22609C5.47212 7.21278 5.48022 7.1607 5.51494 7.1526C5.53577 7.15086 5.57339 7.14102 5.57455 7.12135C5.57513 7.10225 5.5051 7.10514 5.45013 7.08431C5.40383 7.06695 5.3882 7.04322 5.40499 6.97088C5.4183 6.89044 5.51263 6.88118 5.55834 6.88061C5.55198 6.84646 5.55603 6.78743 5.59885 6.74866C5.66135 6.69137 5.758 6.7122 5.84017 6.71741C5.88705 6.69137 5.97385 6.6526 6.05892 6.64912C6.13531 6.64623 6.47385 6.55885 6.62779 6.57563C6.59306 6.52412 6.60117 6.4026 6.66425 6.36672C6.74469 6.32158 6.83149 6.44368 6.85232 6.42227C6.87316 6.40028 6.82628 6.36845 6.76725 6.30711C6.75279 6.27991 6.75568 6.28338 6.7551 6.2747C6.75394 6.25503 6.75857 6.2313 6.7661 6.22609C6.77304 6.22146 6.82107 6.2394 6.83265 6.25676C6.84827 6.28049 6.86795 6.29149 6.88357 6.27875C6.90383 6.26313 6.87779 6.26892 6.86621 6.23477C6.86043 6.21799 6.84712 6.20468 6.84769 6.1879C6.85927 6.17459 6.90441 6.13755 6.93971 6.12598C6.95418 6.13987 6.96344 6.15838 6.97501 6.1769C7.00337 6.21973 7.02941 6.20815 7.0485 6.23709C7.05545 6.24866 7.05545 6.27933 7.06934 6.30537C7.09422 6.35341 7.14341 6.40781 7.20823 6.44658C7.21806 6.45294 7.23195 6.4651 7.23311 6.47493C7.23485 6.48998 7.22269 6.50503 7.21691 6.51197C7.20881 6.52239 7.17987 6.52297 7.15209 6.50966C7.10985 6.4894 7.0948 6.47899 7.06992 6.48246C7.01552 6.49056 6.97964 6.57737 6.90267 6.57852C6.82975 6.56811 6.78056 6.46336 6.73774 6.49403C6.6955 6.5247 6.83728 6.6144 6.81992 6.65202C6.83207 6.66128 6.85175 6.69253 6.84712 6.71857C6.91945 6.70294 6.97732 6.65375 6.99874 6.61382C7.03577 6.56232 7.06529 6.53338 7.08728 6.52412C7.10869 6.51487 7.13647 6.52818 7.13647 6.54496C7.14457 6.54322 7.15672 6.55306 7.17177 6.55537C7.19376 6.56579 7.18508 6.5872 7.17871 6.59473C7.17813 6.59125 7.16656 6.5872 7.15556 6.582C7.14399 6.57737 7.12605 6.59183 7.10927 6.60572C7.09249 6.61903 7.08033 6.65144 7.06355 6.67227C7.04677 6.69253 7.00337 6.73419 6.98485 6.75676C6.99526 6.77239 6.99006 6.80132 6.99179 6.81521C6.99584 6.81521 7.00973 6.81868 7.01783 6.82447C7.02536 6.83026 7.0242 6.83662 7.02073 6.85225C7.01552 6.87135 6.94376 6.957 6.92293 6.95642C6.8911 6.95642 6.87084 6.9188 6.87374 6.90318C6.83901 6.91938 6.82339 6.88118 6.82223 6.8673C6.80892 6.88524 6.75626 6.91417 6.73716 6.92112C6.71864 6.92806 6.71112 6.93037 6.70533 6.90549C6.69955 6.92227 6.65267 6.93963 6.64168 6.94195C6.58091 6.9541 6.51899 6.98072 6.45881 6.98014L6.31124 6.97725L6.3257 6.98709Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0208333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.53299 6.42631C6.53357 6.44946 6.5 6.50907 6.54919 6.55131C6.57929 6.57678 6.63195 6.59819 6.64931 6.63118C6.66378 6.65895 6.64352 6.68384 6.63716 6.6821C6.60475 6.67516 6.56192 6.73129 6.5463 6.76949C6.52836 6.71567 6.49306 6.72898 6.44792 6.7365C6.46007 6.68036 6.41493 6.64506 6.34549 6.6358C6.35706 6.62423 6.33797 6.60629 6.32118 6.59124C6.30382 6.5762 6.24942 6.58835 6.24422 6.5762C6.23901 6.56405 6.27026 6.5409 6.25463 6.51601C6.23959 6.49055 6.17419 6.5056 6.15336 6.49692C6.15799 6.46567 6.16146 6.4483 6.14584 6.42053C6.12963 6.39217 6.05614 6.40085 6.02026 6.39275C6.04977 6.37192 6.06308 6.34124 6.04688 6.30768C6.0301 6.27296 5.95255 6.31405 5.95313 6.26775C5.95544 6.25155 6.04398 6.23824 6.07986 6.23592C6.11285 6.23418 6.22859 6.2608 6.33623 6.28685C6.36169 6.30826 6.53067 6.36034 6.53299 6.42631Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0127315"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.82321 6.86695C6.87703 6.84033 6.92969 6.80561 6.98582 6.75642M5.97656 6.71533C6.02517 6.71765 6.12992 6.73327 6.16001 6.7732C6.1901 6.81371 6.2092 6.87795 6.00029 6.93235C6.06279 6.93292 6.15654 6.9173 6.18953 6.9254C6.21904 6.92019 6.28617 6.8982 6.31453 6.90746C6.30353 6.91267 6.26823 6.92251 6.26707 6.94334C6.26591 6.96417 6.28212 6.96765 6.31221 6.97691M6.5136 6.83686C6.58594 6.85075 6.69126 6.82934 6.70631 6.90515"
        stroke="black"
        strokeWidth="0.0208333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75781 6.24609C6.78038 6.26808 6.83478 6.30628 6.86429 6.32711C6.90307 6.35431 6.92101 6.32017 6.89091 6.27098"
        stroke="black"
        strokeWidth="0.0138889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.2474 6.57603C6.32089 6.56098 6.42564 6.54593 6.48756 6.54883M6.15654 6.49674C6.2717 6.46549 6.39786 6.4788 6.47714 6.47996M6.45631 6.7317C6.47772 6.7045 6.52575 6.66573 6.56221 6.63274M6.34925 6.63505C6.38455 6.62059 6.4511 6.5957 6.50666 6.58586M6.33941 6.28667C6.40133 6.22591 6.47425 6.23459 6.54369 6.19755C6.58536 6.17614 6.62124 6.11654 6.66348 6.07545C6.68258 6.05924 6.69647 6.04651 6.7445 6.05056C6.79485 6.05461 6.80122 6.07024 6.7364 6.07776C6.6901 6.08355 6.68837 6.10612 6.66985 6.14142C6.65422 6.17151 6.66927 6.20681 6.67853 6.23112C6.66696 6.25542 6.65249 6.29015 6.64844 6.31677C6.64612 6.33008 6.65191 6.34049 6.66811 6.36017M6.02344 6.39258C6.18605 6.35728 6.41927 6.41804 6.46325 6.42093"
        stroke="black"
        strokeWidth="0.0127315"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.01447 6.65005C7.06713 6.62169 7.06771 6.56787 7.13773 6.54472M6.875 6.90294C6.94213 6.87111 6.9566 6.84391 6.99306 6.81498M7.04109 6.39773C7.00926 6.40236 7.00405 6.37632 6.9728 6.37111C6.93924 6.36475 6.91667 6.38674 6.91667 6.40699C6.91667 6.42782 6.9375 6.44576 6.95833 6.44692C6.97917 6.44808 6.99653 6.43303 7.03993 6.43766M6.88831 6.15641C6.91377 6.15873 6.93981 6.16336 6.95891 6.146M7.02604 6.27563C7.02083 6.28083 7.00405 6.27389 6.99595 6.26405C6.98843 6.25363 6.98437 6.23975 6.99074 6.23338C6.99653 6.22759 7.00579 6.22875 7.01968 6.24032C7.03356 6.2519 7.03125 6.26984 7.02604 6.27563Z"
        stroke="black"
        strokeWidth="0.00925926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.03278 5.61132C6.03114 5.61221 6.02911 5.61169 6.02713 5.60988C6.02516 5.60807 6.0234 5.60511 6.02225 5.60166C6.0211 5.59821 6.02065 5.59454 6.02099 5.59147C6.02134 5.5884 6.02246 5.58617 6.0241 5.58528C6.02233 5.58591 6.02024 5.58509 6.01828 5.58299C6.01633 5.58089 6.01467 5.57769 6.01367 5.57408C6.01267 5.57048 6.01242 5.56676 6.01296 5.56376C6.01351 5.56076 6.01481 5.55872 6.01658 5.55808C6.01483 5.55879 6.01276 5.55805 6.01083 5.55602C6.00889 5.55399 6.00725 5.55083 6.00625 5.54723C6.00526 5.54364 6.00499 5.5399 6.00552 5.53683C6.00604 5.53377 6.00732 5.53163 6.00906 5.53088C6.00727 5.53161 6.0052 5.53086 6.0033 5.52879C6.0014 5.52672 5.99981 5.52349 5.9989 5.51983C5.99798 5.51616 5.9978 5.51234 5.99841 5.5092C5.99901 5.50607 6.00034 5.50388 6.00211 5.5031C6.00028 5.50379 5.99818 5.50295 5.99629 5.50078C5.9944 5.4986 5.99286 5.49527 5.99201 5.49151C5.99117 5.48775 5.99109 5.48387 5.99179 5.48073C5.99249 5.47758 5.99391 5.47543 5.99574 5.47474C5.9939 5.47531 5.99186 5.47436 5.99008 5.47212C5.98829 5.46987 5.9869 5.46651 5.98621 5.46276C5.98552 5.45901 5.98559 5.45518 5.9864 5.45212C5.98721 5.44905 5.9887 5.44699 5.99054 5.44639C5.9896 5.44664 5.98861 5.44652 5.98763 5.44603C5.98665 5.44554 5.98569 5.44469 5.98481 5.44353C5.98394 5.44237 5.98315 5.44092 5.98251 5.43926C5.98188 5.4376 5.98139 5.43577 5.98109 5.43387C5.98078 5.43197 5.98067 5.43004 5.98074 5.42819C5.98082 5.42634 5.98109 5.4246 5.98154 5.42307C5.98199 5.42155 5.9826 5.42027 5.98335 5.4193C5.9841 5.41834 5.98497 5.41771 5.98591 5.41745C5.98398 5.41801 5.98191 5.41699 5.98016 5.41462C5.97842 5.41225 5.97714 5.40872 5.9766 5.4048C5.97606 5.40089 5.97631 5.39691 5.9773 5.39375C5.97829 5.39059 5.97992 5.3885 5.98186 5.38794C5.97995 5.38839 5.97798 5.3873 5.97637 5.38492C5.97476 5.38254 5.97364 5.37905 5.97326 5.37522C5.97287 5.37139 5.97326 5.36753 5.97433 5.3645C5.9754 5.36146 5.97706 5.35948 5.97896 5.359C5.97702 5.35933 5.97507 5.35811 5.97353 5.35559C5.972 5.35308 5.97101 5.34948 5.97079 5.34559C5.97056 5.34169 5.9711 5.33781 5.97231 5.3348C5.97352 5.33178 5.97528 5.32987 5.97723 5.32949C5.97526 5.3299 5.97332 5.32874 5.97182 5.32626C5.97033 5.32378 5.9694 5.32019 5.96925 5.31628C5.96909 5.31236 5.96973 5.30845 5.97101 5.30539C5.97229 5.30233 5.97411 5.30039 5.97607 5.29998C5.97405 5.30024 5.97215 5.29891 5.97078 5.29627C5.96941 5.29364 5.96868 5.28991 5.96876 5.28592C5.96883 5.28193 5.96971 5.278 5.97119 5.27499C5.97267 5.27199 5.97463 5.27015 5.97665 5.26988C5.97467 5.27002 5.97286 5.26861 5.97163 5.26595C5.97039 5.26329 5.96983 5.25961 5.97006 5.2557C5.97029 5.2518 5.97129 5.24799 5.97285 5.24512C5.97441 5.24224 5.9764 5.24054 5.97838 5.24037C5.97637 5.24052 5.9746 5.23912 5.97344 5.23646C5.97229 5.2338 5.97186 5.23011 5.97225 5.22619C5.97263 5.22228 5.9738 5.21846 5.97549 5.21559C5.97718 5.21271 5.97927 5.21101 5.98128 5.21086C5.97922 5.21087 5.97749 5.2093 5.97647 5.2065C5.97545 5.2037 5.97522 5.1999 5.97584 5.19592C5.97645 5.19194 5.97785 5.18811 5.97974 5.18527C5.98163 5.18243 5.98384 5.18081 5.98591 5.18076C5.98389 5.1806 5.98229 5.17891 5.98145 5.17605C5.98062 5.17319 5.98063 5.1694 5.98147 5.1655C5.98231 5.1616 5.98392 5.15791 5.98594 5.15524C5.98797 5.15257 5.99024 5.15114 5.99227 5.15125C5.99025 5.15103 5.98874 5.1493 5.98807 5.14644C5.9874 5.14359 5.98762 5.13983 5.98869 5.13601C5.98976 5.13218 5.99159 5.12859 5.99378 5.12603C5.99597 5.12346 5.99834 5.12212 6.00037 5.12231C5.9983 5.12205 5.99683 5.12028 5.99628 5.1174C5.99574 5.11452 5.99616 5.11077 5.99746 5.10695C5.99876 5.10313 6.00083 5.09956 6.00321 5.09702C6.0056 5.09448 6.00812 5.09317 6.01021 5.09338C6.0081 5.09296 6.00672 5.09105 6.00636 5.08806C6.006 5.08507 6.00671 5.08125 6.00831 5.07742C6.00992 5.0736 6.0123 5.07009 6.01493 5.06766C6.01756 5.06522 6.02024 5.06407 6.02237 5.06444C6.02028 5.06384 6.01904 5.06178 6.01891 5.05872C6.01879 5.05565 6.01979 5.05182 6.0217 5.04808C6.02362 5.04433 6.02628 5.04097 6.02911 5.03872C6.03195 5.03647 6.03472 5.03553 6.03683 5.03609C6.03482 5.03528 6.03377 5.03307 6.03392 5.02994C6.03407 5.02682 6.0354 5.02304 6.03763 5.01943C6.03985 5.01582 6.04279 5.01269 6.04579 5.01071C6.04878 5.00873 6.0516 5.00808 6.05362 5.00889C6.05153 5.008 6.05054 5.00575 6.05086 5.00262C6.05118 4.9995 6.05278 4.99576 6.05531 4.99223C6.05784 4.9887 6.0611 4.98567 6.06436 4.9838C6.06763 4.98193 6.07063 4.98138 6.07271 4.98227C6.07175 4.98169 6.07109 4.98079 6.07075 4.97963C6.07042 4.97847 6.07042 4.97707 6.07077 4.9755C6.07146 4.97234 6.07349 4.96871 6.0764 4.96541C6.07932 4.96211 6.08288 4.95941 6.08632 4.95791C6.08975 4.9564 6.09277 4.95621 6.0947 4.95738C6.09273 4.95609 6.09212 4.95356 6.09301 4.95036C6.09389 4.94716 6.0962 4.94356 6.09942 4.94033C6.10265 4.93711 6.10652 4.93454 6.11019 4.93318C6.11387 4.93181 6.11704 4.93178 6.11901 4.93308"
        fill="white"
      />
      <path
        d="M6.03278 5.61132C6.03114 5.61221 6.02911 5.61169 6.02713 5.60988C6.02516 5.60807 6.0234 5.60511 6.02225 5.60166C6.0211 5.59821 6.02065 5.59454 6.02099 5.59147C6.02134 5.5884 6.02246 5.58617 6.0241 5.58528C6.02233 5.58591 6.02024 5.58509 6.01828 5.58299C6.01633 5.58089 6.01467 5.57769 6.01367 5.57408C6.01267 5.57048 6.01242 5.56676 6.01296 5.56376C6.01351 5.56076 6.01481 5.55872 6.01658 5.55808C6.01483 5.55879 6.01276 5.55805 6.01083 5.55602C6.00889 5.55399 6.00725 5.55083 6.00625 5.54723C6.00526 5.54364 6.00499 5.5399 6.00552 5.53683C6.00604 5.53377 6.00732 5.53163 6.00906 5.53088C6.00727 5.53161 6.0052 5.53086 6.0033 5.52879C6.0014 5.52672 5.99981 5.52349 5.9989 5.51983C5.99798 5.51616 5.9978 5.51234 5.99841 5.5092C5.99901 5.50607 6.00034 5.50388 6.00211 5.5031C6.00028 5.50379 5.99818 5.50295 5.99629 5.50078C5.9944 5.4986 5.99286 5.49527 5.99201 5.49151C5.99117 5.48775 5.99109 5.48387 5.99179 5.48073C5.99249 5.47758 5.99391 5.47543 5.99574 5.47474C5.9939 5.47531 5.99186 5.47436 5.99008 5.47212C5.98829 5.46987 5.9869 5.46651 5.98621 5.46276C5.98552 5.45901 5.98559 5.45518 5.9864 5.45212C5.98721 5.44905 5.9887 5.44699 5.99054 5.44639C5.9896 5.44664 5.98861 5.44652 5.98763 5.44603C5.98665 5.44554 5.98569 5.44469 5.98481 5.44353C5.98394 5.44237 5.98315 5.44092 5.98251 5.43926C5.98188 5.4376 5.98139 5.43577 5.98109 5.43387C5.98078 5.43197 5.98067 5.43004 5.98074 5.42819C5.98082 5.42634 5.98109 5.4246 5.98154 5.42307C5.98199 5.42155 5.9826 5.42027 5.98335 5.4193C5.9841 5.41834 5.98497 5.41771 5.98591 5.41745C5.98398 5.41801 5.98191 5.41699 5.98016 5.41462C5.97842 5.41225 5.97714 5.40872 5.9766 5.4048C5.97606 5.40089 5.97631 5.39691 5.9773 5.39375C5.97829 5.39059 5.97992 5.3885 5.98186 5.38794C5.97995 5.38839 5.97798 5.3873 5.97637 5.38492C5.97476 5.38254 5.97364 5.37905 5.97326 5.37522C5.97287 5.37139 5.97326 5.36753 5.97433 5.3645C5.9754 5.36146 5.97706 5.35948 5.97896 5.359C5.97702 5.35933 5.97507 5.35811 5.97353 5.35559C5.972 5.35308 5.97101 5.34948 5.97079 5.34559C5.97056 5.34169 5.9711 5.33781 5.97231 5.3348C5.97352 5.33178 5.97528 5.32987 5.97723 5.32949C5.97526 5.3299 5.97332 5.32874 5.97182 5.32626C5.97033 5.32378 5.9694 5.32019 5.96925 5.31628C5.96909 5.31236 5.96973 5.30845 5.97101 5.30539C5.97229 5.30233 5.97411 5.30039 5.97607 5.29998C5.97405 5.30024 5.97215 5.29891 5.97078 5.29627C5.96941 5.29364 5.96868 5.28991 5.96876 5.28592C5.96883 5.28193 5.96971 5.278 5.97119 5.27499C5.97267 5.27199 5.97463 5.27015 5.97665 5.26988C5.97467 5.27002 5.97286 5.26861 5.97163 5.26595C5.97039 5.26329 5.96983 5.25961 5.97006 5.2557C5.97029 5.2518 5.97129 5.24799 5.97285 5.24512C5.97441 5.24224 5.9764 5.24054 5.97838 5.24037C5.97637 5.24052 5.9746 5.23912 5.97344 5.23646C5.97229 5.2338 5.97186 5.23011 5.97225 5.22619C5.97263 5.22228 5.9738 5.21846 5.97549 5.21559C5.97718 5.21271 5.97927 5.21101 5.98128 5.21086C5.97922 5.21087 5.97749 5.2093 5.97647 5.2065C5.97545 5.2037 5.97522 5.1999 5.97584 5.19592C5.97645 5.19194 5.97785 5.18811 5.97974 5.18527C5.98163 5.18243 5.98384 5.18081 5.98591 5.18076C5.98389 5.1806 5.98229 5.17891 5.98145 5.17605C5.98062 5.17319 5.98063 5.1694 5.98147 5.1655C5.98231 5.1616 5.98392 5.15791 5.98594 5.15524C5.98797 5.15257 5.99024 5.15114 5.99227 5.15125C5.99025 5.15103 5.98874 5.1493 5.98807 5.14644C5.9874 5.14359 5.98762 5.13983 5.98869 5.13601C5.98976 5.13218 5.99159 5.12859 5.99378 5.12603C5.99597 5.12346 5.99834 5.12212 6.00037 5.12231C5.9983 5.12205 5.99683 5.12028 5.99628 5.1174C5.99574 5.11452 5.99616 5.11077 5.99746 5.10695C5.99876 5.10313 6.00083 5.09956 6.00321 5.09702C6.0056 5.09448 6.00812 5.09317 6.01021 5.09338C6.0081 5.09296 6.00672 5.09105 6.00636 5.08806C6.006 5.08507 6.00671 5.08125 6.00831 5.07742C6.00992 5.0736 6.0123 5.07009 6.01493 5.06766C6.01756 5.06522 6.02024 5.06407 6.02237 5.06444C6.02028 5.06384 6.01904 5.06178 6.01891 5.05872C6.01879 5.05565 6.01979 5.05182 6.0217 5.04808C6.02362 5.04433 6.02628 5.04097 6.02911 5.03872C6.03195 5.03647 6.03472 5.03553 6.03683 5.03609C6.03482 5.03528 6.03377 5.03307 6.03392 5.02994C6.03407 5.02682 6.0354 5.02304 6.03763 5.01943C6.03985 5.01582 6.04279 5.01269 6.04579 5.01071C6.04878 5.00873 6.0516 5.00808 6.05362 5.00889C6.05153 5.008 6.05054 5.00575 6.05086 5.00262C6.05118 4.9995 6.05278 4.99576 6.05531 4.99223C6.05784 4.9887 6.0611 4.98567 6.06436 4.9838C6.06763 4.98193 6.07063 4.98138 6.07271 4.98227C6.07175 4.98169 6.07109 4.98079 6.07075 4.97963C6.07042 4.97847 6.07042 4.97707 6.07077 4.9755C6.07146 4.97234 6.07349 4.96871 6.0764 4.96541C6.07932 4.96211 6.08288 4.95941 6.08632 4.95791C6.08975 4.9564 6.09277 4.95621 6.0947 4.95738C6.09273 4.95609 6.09212 4.95356 6.09301 4.95036C6.09389 4.94716 6.0962 4.94356 6.09942 4.94033C6.10265 4.93711 6.10652 4.93454 6.11019 4.93318C6.11387 4.93181 6.11704 4.93178 6.11901 4.93308"
        stroke="black"
        strokeWidth="0.00578704"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.06626 5.60151L6.03328 5.61135M6.06047 5.57547L6.02459 5.5853M6.05527 5.54885L6.01707 5.55811M6.05006 5.52165L6.00955 5.53091M6.04601 5.49445L6.0026 5.50313M6.04196 5.46667L5.99624 5.47477M6.03906 5.43889L5.99103 5.44642M6.03675 5.41111L5.9864 5.41748M6.03559 5.38334L5.98235 5.38797M6.03501 5.35614L5.97946 5.35903M6.03559 5.32836L5.97772 5.32952M6.03675 5.30116L5.97656 5.3M6.03906 5.27396L5.97714 5.26991M6.04311 5.24734L5.97888 5.2404M6.04774 5.2213L5.98177 5.21088M6.05411 5.19584L5.9864 5.18079M6.06163 5.17037L5.99277 5.15128M6.07089 5.14607L6.00087 5.12234M6.08131 5.12292L6.01071 5.09341M6.09288 5.09977L6.02286 5.06447M6.10677 5.07836L6.03733 5.03611M6.12182 5.05753L6.05411 5.00892M6.13918 5.03727L6.07321 4.9823M6.1577 5.01875L6.0952 4.95741M6.17853 5.00139L6.1195 4.93311"
        stroke="black"
        strokeWidth="0.00578704"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.43512 5.22002C6.40098 5.22754 6.38362 5.2287 6.33964 5.23043C6.33096 5.25069 6.33038 5.30566 6.33096 5.32534C6.42413 5.41388 6.5144 5.52789 6.52019 5.63553C6.54913 5.65867 6.56765 5.6824 6.58385 5.72522C6.6504 5.69224 6.71753 5.63553 6.77424 5.62106C6.81128 5.6118 6.87667 5.6089 6.90908 5.628C6.92702 5.63842 7.08558 5.73506 7.13188 5.76342C7.1776 5.79235 7.20943 5.82997 7.232 5.86296C7.25457 5.89594 7.25688 5.95555 7.24936 5.97059L7.11626 5.9324C7.107 5.91041 7.11452 5.88495 7.12494 5.86296C7.13477 5.84212 7.13477 5.84096 7.11568 5.82592C7.10295 5.8155 7.08501 5.8184 7.07227 5.82129C7.05954 5.8236 7.03929 5.8184 7.02771 5.79988C7.01498 5.78078 6.87552 5.71944 6.85179 5.71596C6.82864 5.71249 6.79334 5.71191 6.7644 5.73911C6.75052 5.76168 6.70364 5.8346 6.6666 5.86759C6.65677 5.87742 6.65503 5.88842 6.66082 5.89999C6.66082 5.89999 6.74936 5.89652 6.80318 5.90404C6.85758 5.91215 6.92528 5.96828 6.9548 6.00358C7.09021 6.128 7.14172 6.19571 7.1857 6.23853C7.20538 6.25763 7.22679 6.27904 7.22216 6.30856L7.09021 6.30624C7.09195 6.25879 7.08269 6.22465 7.07459 6.1986C7.05896 6.17719 7.03119 6.18761 7.02019 6.18819C7.0092 6.18934 6.99241 6.16562 6.9791 6.14421C6.96232 6.10659 6.89056 6.05624 6.85873 6.03657C6.8269 6.01689 6.81591 6.02557 6.78234 6.02268C6.76209 6.01631 6.71579 6.00821 6.68223 6.02152C6.64866 6.03483 6.55028 6.06608 6.45943 6.0765C6.42586 6.09154 6.3269 6.11006 6.22216 6.13263C6.14346 6.14941 5.96695 6.17777 5.92933 6.17835C5.91776 6.26342 5.82864 6.38263 5.80318 6.39594C5.77714 6.43066 5.77829 6.46134 5.79623 6.47696C5.81475 6.49316 5.94959 6.49316 5.98315 6.49432C6.0173 6.4949 6.08443 6.49722 6.09427 6.49895C6.11741 6.50242 6.14635 6.5302 6.18107 6.5493C6.20596 6.56261 6.21116 6.5765 6.22679 6.60138C6.23663 6.61759 6.25167 6.63321 6.25688 6.6471L6.09774 6.64363C6.09947 6.61006 6.0798 6.58171 6.05723 6.58171C6.03524 6.59733 6.00804 6.61585 5.97795 6.6037C5.85468 6.59617 5.77598 6.60138 5.6614 6.59386C5.62899 6.59212 5.60005 6.54525 5.61221 6.50242C5.62436 6.45902 5.61915 6.42951 5.61105 6.39826C5.59947 6.41099 5.55433 6.45555 5.52887 6.48506C5.48952 6.52962 5.51209 6.57765 5.52656 6.60196C5.55028 6.62222 5.68107 6.74837 5.69843 6.78657C5.71174 6.80682 5.76383 6.84791 5.81591 6.89131C5.83269 6.93009 5.86394 6.94918 5.88883 6.97465L5.68686 6.97522C5.69322 6.96249 5.69612 6.95034 5.69901 6.92198C5.70017 6.91157 5.68686 6.88842 5.66082 6.89131C5.6342 6.89478 5.61105 6.86411 5.60295 6.83923C5.59484 6.81377 5.50572 6.69976 5.4791 6.6743C5.45248 6.64941 5.37204 6.56724 5.35815 6.56203C5.34369 6.55682 5.34021 6.52731 5.357 6.50995C5.37436 6.49259 5.42413 6.4133 5.43975 6.3618C5.45017 6.3265 5.43744 6.3236 5.42933 6.31261C5.34137 6.24722 5.2644 6.16041 5.21869 6.07765C5.2019 6.08807 5.10584 6.08749 5.05781 6.06377C5.02135 6.0464 4.97274 6.0412 4.9467 6.08228C4.93165 6.10659 4.93223 6.15231 4.95885 6.17256C4.99704 6.2015 5.04276 6.24895 5.08674 6.30335C5.13072 6.35775 5.09253 6.39363 5.03697 6.44108C5.04508 6.46191 5.03582 6.45844 5.04623 6.49316C5.06475 6.51978 5.06475 6.58691 5.04102 6.6008C5.01788 6.61585 4.98778 6.6309 4.96001 6.6633C4.93223 6.69687 4.92008 6.66446 4.93223 6.6089C4.93917 6.57418 4.91082 6.54525 4.88651 6.51863C4.86278 6.49201 4.87494 6.41446 4.89056 6.39131C4.90561 6.36932 4.92123 6.32418 4.88767 6.29062C4.8541 6.25705 4.78755 6.18645 4.79797 6.0927C4.8107 5.96886 4.93049 5.92951 5.00167 5.96191C5.11741 6.014 5.18628 6.00242 5.221 5.9949C5.25572 5.93877 5.29913 5.88553 5.37031 5.84502C5.43686 5.80682 5.56822 5.75416 5.69727 5.7339L6.01788 5.61932C6.06128 5.60659 6.05954 5.5684 6.05549 5.5464C6.01383 5.32997 6.02656 5.10138 6.20248 4.98506C6.221 4.96828 6.21521 4.92083 6.24299 4.88379C6.2482 4.89999 6.28408 4.94397 6.29218 4.97233C6.36799 4.99721 6.50515 5.04525 6.55896 5.07245C6.58501 5.08518 6.61221 5.08691 6.62841 5.09328C6.64288 5.09907 6.65619 5.11353 6.66545 5.13147C6.67991 5.15752 6.66371 5.18298 6.64982 5.1905C6.6394 5.19571 6.57575 5.1743 6.56012 5.18877C6.56302 5.20323 6.57922 5.21886 6.61336 5.23275C6.62899 5.23969 6.60526 5.26863 6.58674 5.27036C6.57633 5.27152 6.56186 5.26689 6.5526 5.25995C6.51498 5.24895 6.47447 5.23333 6.43512 5.22002Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0208333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.21354 5.0791C6.21181 5.2122 6.25694 5.27933 6.32928 5.32563M6.58218 5.72551C6.59491 5.78165 6.59317 5.8372 6.58275 5.88581M5.60938 6.39855C5.71007 6.35109 5.79745 6.23709 5.79456 6.1688M5.79456 6.1688C5.79282 6.12887 5.76157 6.06753 5.67187 6.06463M5.79456 6.1688C5.82234 6.1798 5.88368 6.17285 5.92766 6.17864M6.42477 5.85456C6.50289 5.85804 6.60764 5.9026 6.65914 5.90028M6.38831 6.01024C6.45428 6.0247 6.45544 6.05653 6.59259 6.04959M6.35532 5.56868C6.43229 5.571 6.47627 5.60862 6.51852 5.63581"
        stroke="black"
        strokeWidth="0.0208333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.78125 6.2313C5.83507 6.23072 5.87558 6.22378 5.89757 6.17632M6.2147 5.0791C6.21181 5.1879 6.25579 5.2151 6.33912 5.23072"
        stroke="black"
        strokeWidth="0.0127315"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.63802 5.09729C6.63281 5.12507 6.63223 5.14706 6.67737 5.14301M6.43721 5.02148C6.40249 5.1106 6.57784 5.12218 6.58478 5.17831M5.60156 5.75702C5.68721 5.79463 5.67737 5.96477 5.67679 6.06431"
        stroke="black"
        strokeWidth="0.00925926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.54011 5.17869C6.51233 5.23309 6.45157 5.31758 6.38907 5.36271C6.29647 5.42869 6.19636 5.47788 6.07078 5.50739C6.054 5.51144 6.03258 5.51665 6.00828 5.51144C5.98455 5.50681 5.95851 5.49119 5.94173 5.45704C5.93247 5.4391 5.9371 5.35346 5.96893 5.3413C6.00249 5.32915 6.03316 5.3251 6.06499 5.32684C6.08235 5.32799 6.10666 5.3332 6.10492 5.35693C6.10376 5.37718 6.08467 5.38934 6.06441 5.38355C6.04011 5.3766 6.00307 5.36271 5.98224 5.3766C5.96777 5.38586 5.95909 5.42464 5.96893 5.442C5.98397 5.46978 5.99902 5.47846 6.01464 5.48135C6.03027 5.48482 6.04705 5.48135 6.06383 5.4773C6.1842 5.44894 6.27969 5.40207 6.37055 5.33725C6.43015 5.29443 6.49207 5.20531 6.51291 5.16422L6.54011 5.17869ZM6.06846 5.34825C6.03258 5.34072 5.97471 5.3494 5.9695 5.36445C5.99613 5.34767 6.02911 5.35288 6.06673 5.36445C6.0783 5.36792 6.08525 5.35114 6.06846 5.34825ZM6.30284 5.05484L6.31673 5.02822C6.31962 5.02244 6.30631 4.95878 6.37228 4.99292C6.43825 5.02707 6.38501 5.05658 6.38212 5.06295C6.37923 5.06873 6.36823 5.08899 6.36823 5.08899"
        fill="white"
      />
      <path
        d="M6.30284 5.05484L6.31673 5.02822C6.31962 5.02244 6.30631 4.95878 6.37228 4.99292C6.43825 5.02707 6.38501 5.05658 6.38212 5.06295C6.37923 5.06873 6.36823 5.08899 6.36823 5.08899M6.54011 5.17869C6.51233 5.23309 6.45157 5.31758 6.38907 5.36271C6.29647 5.42869 6.19636 5.47788 6.07078 5.50739C6.054 5.51144 6.03258 5.51665 6.00828 5.51144C5.98455 5.50681 5.95851 5.49119 5.94173 5.45704C5.93247 5.4391 5.9371 5.35346 5.96893 5.3413C6.00249 5.32915 6.03316 5.3251 6.06499 5.32684C6.08235 5.32799 6.10666 5.3332 6.10492 5.35693C6.10376 5.37718 6.08467 5.38934 6.06441 5.38355C6.04011 5.3766 6.00307 5.36271 5.98224 5.3766C5.96777 5.38586 5.95909 5.42464 5.96893 5.442C5.98397 5.46978 5.99902 5.47846 6.01464 5.48135C6.03027 5.48482 6.04705 5.48135 6.06383 5.4773C6.1842 5.44894 6.27969 5.40207 6.37055 5.33725C6.43015 5.29443 6.49207 5.20531 6.51291 5.16422L6.54011 5.17869ZM6.06846 5.34825C6.03258 5.34072 5.97471 5.3494 5.9695 5.36445C5.99613 5.34767 6.02911 5.35288 6.06673 5.36445C6.0783 5.36792 6.08525 5.35114 6.06846 5.34825Z"
        stroke="black"
        strokeWidth="0.00810185"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.19531 4.99609L6.568 5.19112"
        stroke="black"
        strokeWidth="0.0138889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.71853 5.0104C5.65255 5.01677 5.53103 5.00346 5.46505 4.99189C5.43322 4.9861 5.34353 5.11631 5.29607 5.12557C5.24862 5.13483 5.20348 5.03008 5.13346 5.05497C5.10105 5.07985 5.13519 5.20832 5.11552 5.22453C5.09526 5.24073 5.03334 5.15971 4.99515 5.18691C4.95695 5.21411 5.02755 5.38483 5.00903 5.4045C4.99167 5.42302 4.90487 5.32985 4.87883 5.34721C4.85278 5.36457 4.90718 5.6302 4.88172 5.64409C4.85568 5.65797 4.73531 5.57406 4.71968 5.60994C4.70406 5.64582 4.88924 5.73031 4.94133 5.73263L4.99341 5.71295C5.01077 5.72221 5.15892 5.73436 5.17339 5.73552L5.25846 5.64929C5.38866 5.47973 5.5316 5.32059 5.71853 5.33043V5.0104Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0127315"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1441 5.05223L5.39236 5.04297M4.99537 5.18533L5.1169 5.14366M4.88021 5.34389L4.99074 5.29528M4.71875 5.6072L4.87326 5.46716M4.99248 5.70964C5.05787 5.59447 5.19155 5.46716 5.30093 5.40003M4.88079 5.64366C4.97396 5.53139 5.24074 5.34332 5.32581 5.3329M5.11285 5.22468C5.22338 5.17376 5.38137 5.16797 5.50694 5.15755M5.29109 5.1263C5.30671 5.12457 5.49653 5.10084 5.57755 5.10489M5.00521 5.40697C5.15278 5.32075 5.29688 5.25072 5.45949 5.1998"
        stroke="black"
        strokeWidth="0.0127315"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25086 7.20803C6.26244 7.2115 6.27459 7.23638 6.27459 7.23638C6.27459 7.23638 6.24971 7.24854 6.23929 7.24622L5.08188 6.90016C5.04774 6.88974 5.06221 6.83708 5.09809 6.84807L6.25086 7.20803ZM5.14496 5.59055C5.13802 5.56682 5.11718 5.54541 5.10156 5.54252C5.09172 5.54136 5.06626 5.5674 5.06742 5.5755C5.07031 5.59229 5.10387 5.6137 5.11718 5.61833L5.14496 5.59055ZM5.25434 5.63337L5.15711 5.7306C5.14496 5.74333 5.16753 5.76358 5.1791 5.75201L5.27633 5.65479C5.28848 5.64263 5.26533 5.62238 5.25434 5.63337ZM5.2063 5.72481L5.50781 6.03731L5.57031 6.04657L5.56105 5.98407L5.24855 5.68256L5.2063 5.72481Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0162037"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.52517 6.00231L5.22656 5.70312"
        stroke="black"
        strokeWidth="0.00462963"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.92411 5.13449C5.92179 5.11828 5.93048 5.10844 5.94263 5.09976C5.96346 5.0853 5.95767 5.09224 5.96925 5.09803C5.98024 5.10381 5.99182 5.11307 5.99818 5.11828C6.00629 5.12407 6.01091 5.12117 6.01381 5.11655C6.01902 5.10844 6.02075 5.09224 6.02596 5.08703C6.03001 5.08761 6.03638 5.08472 6.0358 5.07719C6.04216 5.07604 6.0439 5.07199 6.04332 5.06562C6.04216 5.06099 6.04622 5.04826 6.05374 5.05057C6.06184 5.05289 6.07862 5.06041 6.0792 5.04942C6.08036 5.04131 6.08557 5.01122 6.08846 4.98807C6.11219 4.99212 6.10409 4.96492 6.11277 4.96145C6.13823 4.97071 6.14749 4.9302 6.13302 4.91574C6.13534 4.88333 6.15906 4.87754 6.19841 4.87812C6.19552 4.85613 6.16543 4.84976 6.1446 4.82199C6.1255 4.79363 6.06242 4.75717 5.99471 4.75833C5.927 4.76006 5.87145 4.82314 5.84656 4.85092C5.82168 4.8787 5.77017 4.89085 5.75455 4.88796C5.7395 4.88449 5.73256 4.87349 5.7152 4.87175C5.7152 4.87175 5.67122 4.87291 5.64807 4.87349C5.62492 4.87349 5.61624 4.88969 5.5902 4.88622C5.57457 4.88506 5.51091 4.88564 5.4924 4.89201C5.47388 4.89837 5.49182 4.94004 5.51149 4.94178C5.52075 4.94293 5.56936 4.94583 5.5873 4.95624C5.60756 4.96724 5.66716 4.97013 5.69379 4.9603C5.74355 4.94236 5.77654 4.97592 5.83152 4.98923L5.84888 4.9956C5.84772 5.02453 5.84946 5.03958 5.83499 5.03958C5.82168 5.03958 5.79969 5.03842 5.78754 5.03726C5.78059 5.03726 5.75223 5.01817 5.73603 5.01469C5.71115 5.00949 5.6961 5.0199 5.68626 5.02395C5.62203 5.05057 5.38418 5.23576 5.36103 5.278C5.33499 5.32488 5.29622 5.35266 5.25918 5.42268C5.23835 5.46145 5.19899 5.50891 5.17527 5.5743C5.13534 5.59224 5.09425 5.62986 5.08788 5.63854C5.08094 5.6478 5.09425 5.66284 5.10177 5.66226C5.09888 5.66805 5.11277 5.68367 5.12376 5.68252C5.1174 5.68946 5.13476 5.70219 5.14286 5.69988C5.13823 5.70682 5.15038 5.72592 5.16022 5.72534L5.25629 5.62928C5.25629 5.58819 5.28059 5.54247 5.29332 5.5199C5.34483 5.4574 5.41196 5.35381 5.43048 5.32604C5.44031 5.31041 5.55316 5.26585 5.58267 5.23692C5.57515 5.31793 5.57747 5.37349 5.58788 5.42152C5.60409 5.50023 5.63013 5.55057 5.64575 5.61712C5.66196 5.6831 5.64575 5.72361 5.64865 5.75486C5.6498 5.77916 5.65848 5.78148 5.68163 5.79479C5.70536 5.80925 5.79679 5.7971 5.82573 5.80578C5.87955 5.82256 5.92874 5.82372 5.94841 5.82719C6.01554 5.81793 6.06589 5.83645 6.0873 5.85324C6.10929 5.8706 6.15212 5.97013 6.16832 6.00717C6.18395 6.04363 6.27075 6.09455 6.28869 6.11539C6.30721 6.13564 6.32052 6.19467 6.31705 6.22071C6.31416 6.24617 6.31763 6.25775 6.34425 6.25486C6.36508 6.25196 6.44205 6.26643 6.45652 6.27395C6.47041 6.2809 6.50397 6.30752 6.51554 6.30867C6.52712 6.30983 6.5821 6.31562 6.60756 6.3133C6.63302 6.31099 6.63186 6.26932 6.62087 6.26759C6.61045 6.26643 6.56647 6.25717 6.54043 6.2508C6.51497 6.24502 6.45767 6.19409 6.4351 6.16631C6.41196 6.13796 6.40038 6.09861 6.38591 6.07025C6.37087 6.04189 6.28464 5.92094 6.26207 5.89374C6.25513 5.88043 6.20941 5.77106 6.19899 5.74386C6.18916 5.71666 6.16659 5.71377 6.14923 5.70856C6.07747 5.68773 6.04969 5.67847 5.97619 5.66458C5.92295 5.65474 5.9108 5.65185 5.90617 5.61249C5.9027 5.58298 5.88013 5.52685 5.8917 5.48807C5.89575 5.47534 5.90328 5.43425 5.90675 5.41574C5.9108 5.39722 5.92237 5.36655 5.92527 5.34803C5.92874 5.32314 5.93337 5.24733 5.93337 5.22766C5.93337 5.19178 5.92816 5.164 5.92411 5.13449ZM5.97966 5.4603C5.97272 5.46203 5.93916 5.46666 5.92179 5.45972C5.91601 5.45682 5.91716 5.44525 5.92295 5.44525C5.91948 5.44293 5.91369 5.43078 5.92179 5.42905C5.91716 5.42789 5.91138 5.41053 5.91948 5.40995C5.91138 5.40474 5.91138 5.3949 5.91948 5.39143C5.92527 5.3868 5.96115 5.38564 5.97619 5.38796C5.98545 5.40648 5.98314 5.44062 5.97966 5.4603Z"
        fill="white"
        stroke="black"
        strokeWidth="0.0208333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.85272 4.99919C5.8695 5.0096 5.86719 4.99803 5.89728 4.98935C5.92679 4.98067 5.94647 5.00671 5.93721 5.03101C5.92853 5.05532 5.92737 5.07558 5.9592 5.07731C5.99103 5.07905 5.99855 5.05185 6.0055 5.03854C6.01302 5.02581 6.02691 5.02639 6.03501 5.01076C6.04138 4.97835 6.07436 4.98588 6.09462 4.98935M6.13571 4.91701C6.1195 4.92569 6.08478 4.89791 6.07899 4.87129C6.06916 4.84004 6.04659 4.81747 6.00666 4.81689C5.96672 4.81689 5.89091 4.83946 5.87471 4.88634C5.8695 4.92164 5.86661 4.94479 5.86603 4.95115C5.85156 4.95636 5.83767 4.95173 5.83652 4.9581C5.83767 4.97199 5.84057 4.98414 5.83247 4.98993M5.58594 5.23703L5.66638 5.20231"
        stroke="black"
        strokeWidth="0.0208333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.66464 5.20215C5.68721 5.25307 5.70284 5.30516 5.73409 5.3231M5.77807 5.34277C5.81163 5.35956 5.8342 5.35377 5.87413 5.3474M5.67332 5.72125C5.75666 5.7253 5.7908 5.76291 5.85966 5.78432C5.92795 5.80516 6.02517 5.79358 6.11372 5.83525M5.64844 5.45446C5.66927 5.47009 5.69936 5.4805 5.72425 5.4805M5.76071 5.48224C5.80469 5.48919 5.8452 5.50655 5.85156 5.53201M5.74277 5.57831C5.7827 5.61708 5.85561 5.64659 5.9077 5.64949"
        stroke="black"
        strokeWidth="0.0104167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.80874 5.0378C5.84635 5.15932 5.85156 5.20909 5.93953 5.22761M5.93953 5.22761C5.85561 5.21777 5.81453 5.15238 5.77691 5.03027M5.93953 5.22761C5.83709 5.2224 5.7798 5.13675 5.74219 5.01465M6.39439 6.20157C6.37587 6.18768 6.37124 6.179 6.35793 6.15238L6.32668 6.09046L6.307 6.10088C6.29832 6.10493 6.28906 6.0893 6.2989 6.08467L6.31568 6.07657L6.29311 6.03143C6.28038 6.02912 6.29253 6.02159 6.30122 6.01754C6.31047 6.01291 6.32378 6.00713 6.318 6.0187L6.34057 6.06384L6.35677 6.05574C6.36661 6.05053 6.37413 6.06731 6.36487 6.07136L6.3452 6.0812L6.37645 6.14312C6.38976 6.16974 6.39439 6.17842 6.39439 6.20157Z"
        stroke="black"
        strokeWidth="0.00925926"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38947 6.07004L6.29456 6.11807M6.20718 6.04805L6.33218 5.98497M6.1875 6.02837L6.31771 5.9624"
        stroke="black"
        strokeWidth="0.00694444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.14265 5.7L5.1849 5.6618M5.12355 5.68264L5.16406 5.64618M5.10156 5.66238L5.14554 5.62534M5.92274 5.44537L5.96383 5.44363M5.91927 5.41007L5.95804 5.40891M5.92159 5.42916L5.95978 5.42569M6.00955 5.06689C6.01823 5.0721 6.02633 5.07615 6.03443 5.07731"
        stroke="black"
        strokeWidth="0.00462963"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5419_21861">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const NetherLandsIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_21924)">
      <path d="M0 0H48V32H0V0Z" fill="#21468B" />
      <path d="M0 0H48V21.3333H0V0Z" fill="white" />
      <path d="M0 0H48V10.6667H0V0Z" fill="#AE1C28" />
    </g>
    <defs>
      <clipPath id="clip0_5419_21924">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ItalyIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H16V32H0V0Z" fill="#009246" />
    <path d="M16 0H32V32H16V0Z" fill="white" />
    <path d="M32 0H48V32H32V0Z" fill="#CE2B37" />
  </svg>
);

export const SpainIcon = () => (
  <svg
    className="w-full h-full"
    width="48"
    height="32"
    viewBox="0 0 48 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5419_22298)">
      <path d="M0 0H48V32H0V0Z" fill="#C60B1E" />
      <path d="M0 8H48V24H0V8Z" fill="#FFC400" />
      <path
        d="M10.745 14.2237C10.745 14.2237 10.7123 14.2237 10.6944 14.2134C10.6765 14.2032 10.6221 14.152 10.6221 14.152L10.5786 14.1206L10.5389 14.0662C10.5389 14.0662 10.4922 13.9907 10.5133 13.9325C10.5351 13.8742 10.5715 13.8537 10.6042 13.8365C10.6368 13.8198 10.7053 13.7987 10.7053 13.7987C10.7053 13.7987 10.7597 13.775 10.7776 13.7718C10.7955 13.768 10.8608 13.7513 10.8608 13.7513C10.8608 13.7513 10.8787 13.7411 10.8967 13.7341C10.9152 13.727 10.9402 13.727 10.9549 13.7238C10.969 13.72 11.0055 13.7085 11.0272 13.7072C11.0605 13.7059 11.1143 13.7136 11.1322 13.7136C11.1501 13.7136 11.2115 13.7168 11.2371 13.7168C11.2621 13.7168 11.3523 13.7097 11.3779 13.7097C11.4029 13.7097 11.4215 13.7065 11.4503 13.7097C11.4791 13.7136 11.5296 13.7302 11.5443 13.7373C11.5591 13.7443 11.6455 13.775 11.6781 13.7853C11.7107 13.7955 11.7901 13.8089 11.8266 13.8262C11.8624 13.8435 11.8848 13.8723 11.9027 13.8966C11.9207 13.9203 11.9245 13.9465 11.9315 13.9638C11.9386 13.9805 11.9386 14.0176 11.9315 14.0349C11.9245 14.0515 11.8989 14.0867 11.8989 14.0867L11.8592 14.152L11.8087 14.1929C11.8087 14.1929 11.7722 14.2275 11.7434 14.2237C11.7146 14.2211 11.4215 14.1686 11.2333 14.1686C11.0451 14.1686 10.7443 14.2237 10.7443 14.2237H10.745Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
        strokeLinejoin="round"
      />
      <path
        d="M11.2368 13.9636C11.2855 13.9636 11.3251 13.8919 11.3251 13.8036C11.3251 13.7152 11.2855 13.6436 11.2368 13.6436C11.188 13.6436 11.1484 13.7152 11.1484 13.8036C11.1484 13.8919 11.188 13.9636 11.2368 13.9636Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2363 13.9506C11.2589 13.9506 11.2772 13.8847 11.2772 13.8034C11.2772 13.7222 11.2589 13.6562 11.2363 13.6562C11.2137 13.6562 11.1953 13.7222 11.1953 13.8034C11.1953 13.8847 11.2137 13.9506 11.2363 13.9506Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2392 13.6905C11.2721 13.6905 11.2987 13.6655 11.2987 13.6348C11.2987 13.604 11.2721 13.5791 11.2392 13.5791C11.2063 13.5791 11.1797 13.604 11.1797 13.6348C11.1797 13.6655 11.2063 13.6905 11.2392 13.6905Z"
        fill="#C8B100"
      />
      <path
        d="M11.3182 13.6154V13.6526H11.1562V13.6154H11.2164V13.531H11.1767V13.4945H11.2164V13.458H11.2548V13.4945H11.2945V13.531H11.2548V13.6154H11.3182Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.0192"
      />
      <path
        d="M11.2552 13.5811C11.2691 13.5847 11.2811 13.5929 11.289 13.6041C11.2969 13.6154 11.3001 13.6289 11.2982 13.6422C11.2962 13.6556 11.2892 13.6678 11.2783 13.6766C11.2675 13.6855 11.2536 13.6904 11.2392 13.6904C11.2248 13.6904 11.2109 13.6855 11.2001 13.6766C11.1892 13.6678 11.1822 13.6556 11.1802 13.6422C11.1783 13.6289 11.1816 13.6154 11.1895 13.6041C11.1974 13.5929 11.2094 13.5847 11.2232 13.5811"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2369 14.2132H10.929L10.922 14.1377L10.9073 14.059L10.8926 13.961C10.8074 13.849 10.7294 13.7754 10.7031 13.7914C10.7095 13.771 10.7172 13.7556 10.7332 13.746C10.8087 13.7012 10.9642 13.8087 11.0814 13.9854C11.0916 14.0014 11.1018 14.0174 11.1108 14.0334H11.3649C11.3738 14.0174 11.3841 14.0014 11.3943 13.9854C11.5108 13.8087 11.667 13.7012 11.7418 13.746C11.7585 13.7556 11.7655 13.771 11.7719 13.7914C11.7457 13.7761 11.6682 13.849 11.5825 13.961L11.5678 14.059L11.553 14.1377L11.5466 14.2132H11.2369Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M10.7188 13.788C10.777 13.7541 10.912 13.861 11.0215 14.0274M11.7607 13.788C11.7024 13.7541 11.568 13.861 11.458 14.0274"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M10.7871 14.3519C10.7743 14.3155 10.75 14.2828 10.75 14.2828C10.8748 14.2463 11.0482 14.2233 11.2409 14.2227C11.4335 14.2233 11.6089 14.2463 11.733 14.2828C11.733 14.2828 11.719 14.3071 11.6998 14.3411C11.6889 14.3603 11.6748 14.3929 11.6754 14.3929C11.5634 14.3583 11.4182 14.3411 11.2402 14.3404C11.0617 14.3411 10.8908 14.3628 10.8012 14.3955C10.8025 14.3955 10.7948 14.375 10.7865 14.3519H10.7871Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2428 14.5108C11.3983 14.5102 11.5698 14.4865 11.6332 14.4705C11.6754 14.4577 11.7004 14.4391 11.6959 14.4167C11.6934 14.4065 11.6844 14.3975 11.6722 14.3924C11.5788 14.3623 11.4118 14.3412 11.2428 14.3412C11.0745 14.3412 10.9055 14.3623 10.8127 14.3924C10.8006 14.3975 10.7916 14.4065 10.789 14.4167C10.7846 14.4391 10.8095 14.4577 10.8518 14.4705C10.9151 14.4865 11.0873 14.5102 11.2428 14.5108ZM11.7426 14.2132L11.7049 14.1793C11.7049 14.1793 11.6684 14.201 11.623 14.1946C11.5782 14.1876 11.5634 14.1326 11.5634 14.1326C11.5634 14.1326 11.5129 14.1754 11.4713 14.1722C11.4297 14.1684 11.4028 14.1326 11.4028 14.1326C11.4028 14.1326 11.3574 14.1652 11.3177 14.162C11.278 14.1582 11.2402 14.1089 11.2402 14.1089C11.2402 14.1089 11.1999 14.1601 11.1602 14.1639C11.1206 14.1671 11.0879 14.1294 11.0879 14.1294C11.0879 14.1294 11.07 14.1671 11.0194 14.1754C10.9689 14.1838 10.9254 14.1358 10.9254 14.1358C10.9254 14.1358 10.8966 14.1825 10.862 14.1946C10.8274 14.2062 10.7826 14.1774 10.7826 14.1774C10.7826 14.1774 10.775 14.1946 10.7698 14.2049C10.7647 14.2151 10.75 14.217 10.75 14.217L10.7615 14.2471C10.885 14.2113 11.0534 14.1889 11.2434 14.1889C11.4335 14.1889 11.6063 14.2113 11.7305 14.2478L11.7433 14.2132H11.7426Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2386 14.0474L11.2565 14.0506C11.2533 14.0582 11.2527 14.0659 11.2527 14.0749C11.2527 14.112 11.2847 14.1421 11.3244 14.1421C11.3557 14.1421 11.3826 14.1222 11.3922 14.0954C11.3929 14.096 11.3993 14.071 11.4018 14.071C11.4037 14.071 11.4037 14.0973 11.405 14.0973C11.4095 14.1312 11.4402 14.1542 11.4754 14.1542C11.5151 14.1542 11.5465 14.1242 11.5465 14.0864C11.5465 14.0838 11.5465 14.0813 11.5458 14.0787L11.5682 14.0563L11.5804 14.0845C11.5759 14.0934 11.574 14.103 11.574 14.1139C11.574 14.1498 11.6041 14.1786 11.6418 14.1786C11.6655 14.1786 11.686 14.167 11.6981 14.1498L11.7129 14.1312V14.1542C11.7129 14.176 11.7218 14.1965 11.7442 14.1997C11.7442 14.1997 11.7685 14.2016 11.8025 14.1754C11.8357 14.1491 11.8537 14.1274 11.8537 14.1274L11.8556 14.1542C11.8556 14.1542 11.8229 14.208 11.7935 14.2246C11.7775 14.2342 11.7525 14.2445 11.7327 14.2406C11.7122 14.2374 11.6975 14.2208 11.6898 14.2016C11.6751 14.2106 11.6572 14.2157 11.6386 14.2157C11.5983 14.2157 11.5618 14.1933 11.5477 14.1606C11.5292 14.1805 11.5036 14.1926 11.4735 14.1926C11.4409 14.1926 11.4114 14.1779 11.3929 14.1555C11.3749 14.1728 11.35 14.183 11.3231 14.183C11.2879 14.183 11.2559 14.1651 11.238 14.1389C11.2194 14.1651 11.1881 14.183 11.1522 14.183C11.1253 14.183 11.1004 14.1728 11.0825 14.1555C11.0639 14.1779 11.0345 14.1926 11.0025 14.1926C10.9717 14.1926 10.9461 14.1805 10.9276 14.1606C10.9135 14.1933 10.877 14.2157 10.8367 14.2157C10.8181 14.2157 10.8009 14.2106 10.7861 14.2016C10.7785 14.2208 10.7637 14.2374 10.7426 14.2406C10.7234 14.2445 10.6985 14.2342 10.6825 14.2246C10.6524 14.208 10.6172 14.1542 10.6172 14.1542L10.6217 14.1274C10.6217 14.1274 10.6402 14.1491 10.6735 14.1754C10.7068 14.2016 10.7317 14.1997 10.7317 14.1997C10.7535 14.1965 10.7631 14.176 10.7631 14.1542V14.1312L10.7772 14.1498C10.7893 14.167 10.8098 14.1786 10.8335 14.1786C10.8713 14.1786 10.9013 14.1498 10.9013 14.1139C10.9019 14.1037 10.8997 14.0935 10.8949 14.0845L10.9071 14.0563L10.9295 14.0787C10.9289 14.0813 10.9289 14.0838 10.9289 14.0864C10.9289 14.1242 10.9602 14.1542 10.9999 14.1542C11.0351 14.1542 11.0658 14.1312 11.0709 14.0973C11.0716 14.0973 11.0716 14.071 11.0735 14.071C11.0767 14.071 11.0825 14.096 11.0837 14.0954C11.0927 14.1222 11.1196 14.1421 11.1516 14.1421C11.1906 14.1421 11.2226 14.112 11.2226 14.0749C11.2226 14.0659 11.2226 14.0582 11.2194 14.0506L11.238 14.0474H11.2386Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2392 14.2224C11.0465 14.223 10.8731 14.2461 10.7483 14.2826C10.74 14.2851 10.7297 14.2787 10.7272 14.2717C10.7246 14.2634 10.7304 14.2538 10.7387 14.2512C10.8635 14.2128 11.0414 14.1885 11.2392 14.1885C11.4369 14.1885 11.6155 14.2128 11.7403 14.2512C11.7486 14.2538 11.7544 14.2634 11.7518 14.2717C11.7493 14.2787 11.739 14.2851 11.7307 14.2826C11.6059 14.2461 11.4318 14.223 11.2392 14.2224Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
        strokeLinejoin="round"
      />
      <path
        d="M10.5851 14.1439C10.5845 14.1445 10.5608 14.1131 10.5435 14.0971C10.5307 14.0856 10.5 14.076 10.5 14.076C10.5 14.0709 10.5179 14.0581 10.5371 14.0581C10.5486 14.0581 10.5595 14.0626 10.5659 14.0709L10.5685 14.0581C10.5685 14.0581 10.5838 14.0613 10.5909 14.0786C10.5986 14.0971 10.5941 14.1247 10.5941 14.1247C10.5941 14.1247 10.5909 14.1375 10.5851 14.1439ZM10.7061 14.0939L10.699 14.1362L10.6094 14.1458L10.596 14.1381L10.5986 14.1234L10.6664 14.0677L10.7061 14.0939Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M10.5821 14.128C10.5898 14.1203 10.6052 14.1223 10.616 14.1319C10.6276 14.1415 10.6314 14.1562 10.6237 14.1639C10.616 14.1722 10.6007 14.1703 10.5898 14.16C10.5783 14.1504 10.5744 14.1357 10.5821 14.128ZM10.7466 14.1363C10.7428 14.1248 10.7466 14.1127 10.7549 14.1095C10.7639 14.1075 10.7741 14.1152 10.7786 14.1267C10.7824 14.1389 10.7786 14.1511 10.7696 14.1536C10.7613 14.1562 10.7511 14.1485 10.7466 14.1363ZM10.7882 14.0826L10.8208 14.1133L10.8989 14.0711L10.9047 14.0576L10.8938 14.0467L10.8042 14.0391L10.7882 14.0826Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M10.8788 13.9365L10.8359 13.9775L10.891 14.0504L10.9057 14.0562L10.9166 14.0447L10.9358 13.957L10.8788 13.9365Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.024 14.0352L11.0074 14.0756L10.9178 14.0672L10.9062 14.057L10.9126 14.0429L10.9907 14.002L11.024 14.0352Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M10.9064 14.0875C10.9237 14.0875 10.9377 14.074 10.9377 14.0574C10.9377 14.0408 10.9237 14.0273 10.9064 14.0273C10.889 14.0273 10.875 14.0408 10.875 14.0574C10.875 14.074 10.889 14.0875 10.9064 14.0875Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.0628 14.0768C11.0609 14.064 11.0673 14.0531 11.0763 14.0519C11.0852 14.0506 11.0942 14.0602 11.0955 14.073C11.0974 14.0851 11.091 14.0967 11.082 14.0973C11.0731 14.0986 11.0641 14.089 11.0628 14.0768ZM11.1211 14.0314L11.1467 14.0679L11.2324 14.041L11.2414 14.0295L11.2318 14.0167L11.1467 13.9917L11.1211 14.0314Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2347 13.8975L11.1797 13.9307L11.2206 14.0191L11.2347 14.028L11.2488 14.0191L11.2898 13.9307L11.2347 13.8975Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.3619 14.0314L11.3369 14.0679L11.2511 14.041L11.2422 14.0295L11.2511 14.0167L11.3369 13.9917L11.3619 14.0314Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2423 14.0592C11.2596 14.0592 11.2737 14.0457 11.2737 14.0291C11.2737 14.0125 11.2596 13.999 11.2423 13.999C11.225 13.999 11.2109 14.0125 11.2109 14.0291C11.2109 14.0457 11.225 14.0592 11.2423 14.0592Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.4241 14.0768C11.4254 14.064 11.419 14.0532 11.41 14.0519C11.401 14.0506 11.3921 14.0602 11.3908 14.073C11.3895 14.0852 11.3953 14.0967 11.4042 14.0973C11.4132 14.0986 11.4222 14.089 11.4241 14.0768ZM11.4554 14.0352L11.4721 14.0756L11.5617 14.0672L11.5732 14.057L11.5668 14.0429L11.4887 14.002L11.4554 14.0352Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.596 13.9365L11.6389 13.9775L11.5839 14.0504L11.5691 14.0562L11.5583 14.0447L11.5391 13.957L11.596 13.9365Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.6874 14.0826L11.6548 14.1133L11.5767 14.0711L11.5703 14.0576L11.5825 14.0467L11.6721 14.0391L11.6874 14.0826Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.5704 14.0875C11.5877 14.0875 11.6018 14.074 11.6018 14.0574C11.6018 14.0408 11.5877 14.0273 11.5704 14.0273C11.5531 14.0273 11.5391 14.0408 11.5391 14.0574C11.5391 14.074 11.5531 14.0875 11.5704 14.0875Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.7288 14.1362C11.7326 14.1247 11.7288 14.1125 11.7205 14.1093C11.7115 14.1074 11.7013 14.1151 11.6968 14.1266C11.693 14.1387 11.6968 14.1509 11.7058 14.1535C11.7141 14.156 11.7243 14.1483 11.7288 14.1362ZM11.8818 14.1439C11.8824 14.1445 11.9061 14.1131 11.924 14.0971C11.9362 14.0856 11.9669 14.076 11.9669 14.076C11.9669 14.0709 11.949 14.0581 11.9298 14.0581C11.9182 14.0581 11.9074 14.0626 11.901 14.0709L11.8984 14.0581C11.8984 14.0581 11.883 14.0613 11.8754 14.0786C11.8683 14.0971 11.8734 14.1247 11.8734 14.1247C11.8734 14.1247 11.876 14.1375 11.8818 14.1439ZM11.7608 14.0939L11.7678 14.1362L11.8574 14.1458L11.8709 14.1381L11.8677 14.1234L11.8005 14.0677L11.7608 14.0939Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.8815 14.1278C11.8745 14.1201 11.8591 14.122 11.8476 14.1316C11.8361 14.1412 11.8323 14.1559 11.8399 14.1636C11.8476 14.1719 11.863 14.17 11.8745 14.1598C11.886 14.1502 11.8892 14.1355 11.8815 14.1278Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M10.75 14.3552L10.7698 14.3232L10.8114 14.3316L10.7871 14.3674L10.75 14.3552Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M10.928 14.3239L10.8838 14.3309C10.8723 14.3322 10.8614 14.3252 10.8595 14.3143C10.8589 14.3091 10.8604 14.3038 10.8636 14.2996C10.8669 14.2955 10.8716 14.2927 10.8768 14.2919L10.9216 14.2855L10.967 14.2785C10.9785 14.2772 10.9888 14.2842 10.9907 14.2945C10.992 14.3054 10.9843 14.3156 10.9734 14.3169L10.928 14.3239Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.0828 14.3176C11.0984 14.3176 11.111 14.3059 11.111 14.2914C11.111 14.2769 11.0984 14.2651 11.0828 14.2651C11.0673 14.2651 11.0547 14.2769 11.0547 14.2914C11.0547 14.3059 11.0673 14.3176 11.0828 14.3176Z"
        fill="white"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2388 14.3029H11.1774C11.1659 14.3029 11.1562 14.2939 11.1562 14.283C11.1562 14.2721 11.1652 14.2632 11.1767 14.2632H11.3022C11.3143 14.2632 11.3233 14.2721 11.3233 14.283C11.3233 14.2939 11.3137 14.3029 11.3022 14.3029H11.2388Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.3953 14.3176C11.4109 14.3176 11.4235 14.3059 11.4235 14.2914C11.4235 14.2769 11.4109 14.2651 11.3953 14.2651C11.3798 14.2651 11.3672 14.2769 11.3672 14.2914C11.3672 14.3059 11.3798 14.3176 11.3953 14.3176Z"
        fill="white"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.5474 14.3239L11.5915 14.3309C11.6031 14.3322 11.6139 14.3252 11.6159 14.3143C11.6165 14.309 11.6151 14.3037 11.6118 14.2995C11.6086 14.2953 11.6038 14.2926 11.5986 14.2919L11.5538 14.2855L11.5083 14.2785C11.4968 14.2772 11.4859 14.2842 11.4847 14.2945C11.4842 14.2971 11.4843 14.2998 11.4849 14.3024C11.4856 14.3049 11.4867 14.3074 11.4884 14.3095C11.49 14.3116 11.492 14.3133 11.4944 14.3146C11.4967 14.3159 11.4993 14.3166 11.5019 14.3169L11.5474 14.3239Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.7229 14.3572L11.7069 14.3232L11.6641 14.3271L11.6845 14.3648L11.7229 14.3572Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M11.2391 14.4746C11.0836 14.4746 10.9428 14.4605 10.8359 14.433C10.9428 14.4055 11.0836 14.3888 11.2391 14.3882C11.3953 14.3882 11.5367 14.4055 11.6443 14.433C11.5367 14.4605 11.3953 14.4746 11.2391 14.4746Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
        strokeLinejoin="round"
      />
      <path
        d="M11.314 14.4694V14.3951M11.2769 14.4719L11.2775 14.3932M11.25 14.4732V14.3926"
        stroke="black"
        strokeWidth="0.00064"
      />
      <path
        d="M11.1852 14.4739V14.3926M11.1641 14.4739V14.3926"
        stroke="black"
        strokeWidth="0.00256"
      />
      <path
        d="M11.11 14.4692L11.1094 14.3956M11.1267 14.4705V14.3931"
        stroke="black"
        strokeWidth="0.00384"
      />
      <path
        d="M11.0781 14.4659V14.3981M11.0948 14.4678L11.0941 14.3955"
        stroke="black"
        strokeWidth="0.00448"
      />
      <path
        d="M11.0312 14.4625V14.403M11.046 14.4631V14.4004M11.0607 14.4657V14.4004"
        stroke="black"
        strokeWidth="0.00512"
      />
      <path
        d="M10.9535 14.4524L10.9529 14.4127M10.9695 14.455V14.4102M10.9375 14.4492V14.414"
        stroke="black"
        strokeWidth="0.00768"
      />
      <path d="M10.9219 14.4469V14.4175" stroke="black" strokeWidth="0.00832" />
      <path d="M10.9062 14.443V14.4199" stroke="black" strokeWidth="0.00896" />
      <path d="M10.8906 14.4411V14.4238" stroke="black" strokeWidth="0.0096" />
      <path d="M10.875 14.437V14.4287" stroke="black" strokeWidth="0.01152" />
      <path
        d="M12.2436 21.1638C12.145 21.1638 12.0574 21.1427 11.9921 21.1081C11.9281 21.0755 11.841 21.0557 11.745 21.0557C11.6484 21.0557 11.5594 21.0761 11.4948 21.1088C11.4302 21.1427 11.3412 21.1638 11.2439 21.1638C11.1454 21.1638 11.057 21.1408 10.9924 21.1062C10.9284 21.0749 10.8433 21.0557 10.7498 21.0557C10.6526 21.0557 10.5668 21.0742 10.5028 21.1075C10.4375 21.1421 10.3479 21.1638 10.25 21.1638V21.3181C10.3479 21.3181 10.4375 21.2957 10.5028 21.2617C10.5668 21.2285 10.6526 21.2093 10.7498 21.2093C10.8426 21.2093 10.9284 21.2291 10.9924 21.2605C11.057 21.2944 11.1454 21.3181 11.2439 21.3181C11.3412 21.3181 11.4302 21.2969 11.4948 21.263C11.5594 21.2297 11.6484 21.2093 11.745 21.2093C11.841 21.2093 11.9281 21.2297 11.9921 21.2624C12.0574 21.2969 12.1438 21.3181 12.2423 21.3181L12.2436 21.1638Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.2436 21.3183C12.145 21.3183 12.0574 21.2972 11.9921 21.2626C11.9281 21.23 11.841 21.2095 11.745 21.2095C11.6484 21.2095 11.5594 21.23 11.4948 21.2632C11.4302 21.2972 11.3412 21.3183 11.2439 21.3183C11.1454 21.3183 11.057 21.2946 10.9924 21.2607C10.9284 21.2293 10.8433 21.2095 10.7498 21.2095C10.6526 21.2095 10.5668 21.2287 10.5028 21.262C10.4375 21.2959 10.3479 21.3183 10.25 21.3183V21.4725C10.3479 21.4725 10.4375 21.4501 10.5028 21.4162C10.5668 21.3829 10.6526 21.3637 10.7498 21.3637C10.8426 21.3637 10.9284 21.3836 10.9924 21.4149C11.057 21.4495 11.1454 21.4725 11.2439 21.4725C11.3412 21.4725 11.4302 21.4508 11.4948 21.4175C11.5594 21.3842 11.6484 21.3637 11.745 21.3637C11.841 21.3637 11.9281 21.3842 11.9921 21.4175C12.0574 21.4514 12.1438 21.4725 12.2423 21.4725L12.2436 21.3183Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.2436 21.4721C12.145 21.4721 12.0574 21.451 11.9921 21.417C11.9281 21.3838 11.841 21.3633 11.745 21.3633C11.6484 21.3633 11.5594 21.3838 11.4948 21.417C11.4302 21.4503 11.3412 21.4721 11.2439 21.4721C11.1454 21.4721 11.057 21.449 10.9924 21.4145C10.9284 21.3831 10.8433 21.3633 10.7498 21.3633C10.6526 21.3633 10.5668 21.3825 10.5028 21.4158C10.4375 21.4497 10.3479 21.4721 10.25 21.4721V21.6257C10.3479 21.6257 10.4375 21.6039 10.5028 21.5694C10.5668 21.5367 10.6526 21.5182 10.7498 21.5182C10.8426 21.5182 10.9284 21.5374 10.9924 21.5687C11.057 21.6033 11.1454 21.6257 11.2439 21.6257C11.3412 21.6257 11.4302 21.6052 11.4948 21.5713C11.5594 21.538 11.6484 21.5182 11.745 21.5182C11.841 21.5182 11.9281 21.538 11.9921 21.5706C12.0574 21.6058 12.1438 21.6257 12.2423 21.6257L12.2436 21.4721Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.2423 21.781C12.1438 21.781 12.0574 21.7598 11.9921 21.7253C11.9281 21.6926 11.841 21.6728 11.745 21.6728C11.6484 21.6728 11.5594 21.6926 11.4948 21.7259C11.4302 21.7592 11.3412 21.781 11.2439 21.781C11.1454 21.781 11.057 21.7573 10.9924 21.7234C10.9284 21.6914 10.8433 21.6728 10.7498 21.6728C10.6526 21.6728 10.5668 21.6914 10.5028 21.7246C10.4375 21.7586 10.3479 21.781 10.25 21.781V21.6274C10.3479 21.6274 10.4375 21.6043 10.5028 21.5698C10.5668 21.5371 10.6526 21.5186 10.7498 21.5186C10.8426 21.5186 10.9284 21.5378 10.9924 21.5691C11.057 21.6037 11.1454 21.6261 11.2439 21.6261C11.3412 21.6261 11.4302 21.6056 11.4948 21.5717C11.5594 21.5384 11.6484 21.5186 11.745 21.5186C11.841 21.5186 11.9281 21.5384 11.9921 21.571C12.0574 21.6062 12.145 21.6261 12.2436 21.6261L12.2423 21.781Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.2423 21.9353C12.1438 21.9353 12.0574 21.9141 11.9921 21.8802C11.9281 21.8469 11.841 21.8265 11.745 21.8265C11.6484 21.8265 11.5594 21.8469 11.4948 21.8802C11.4302 21.9135 11.3412 21.9353 11.2439 21.9353C11.1454 21.9353 11.057 21.9116 10.9924 21.8777C10.9284 21.8457 10.8433 21.8265 10.7498 21.8265C10.6526 21.8265 10.5668 21.8457 10.5028 21.8789C10.4375 21.9129 10.3479 21.9353 10.25 21.9353V21.7823C10.3479 21.7823 10.4375 21.7586 10.5028 21.7247C10.5668 21.6914 10.6526 21.6729 10.7498 21.6729C10.8426 21.6729 10.9284 21.6921 10.9924 21.7234C11.057 21.7573 11.1454 21.781 11.2439 21.781C11.3412 21.781 11.4302 21.7593 11.4948 21.726C11.5594 21.6927 11.6484 21.6729 11.745 21.6729C11.841 21.6729 11.9281 21.6927 11.9921 21.7253C12.0574 21.7599 12.1444 21.781 12.2436 21.781L12.2423 21.9353Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M10.6793 20.5303C10.6825 20.5437 10.6877 20.5559 10.6877 20.57C10.6877 20.6634 10.6064 20.7383 10.5078 20.7383H11.976C11.8768 20.7383 11.7961 20.6634 11.7961 20.57C11.7961 20.5565 11.7987 20.5437 11.8019 20.5303C11.7936 20.5335 11.7833 20.5341 11.7737 20.5341H10.7056C10.6973 20.5341 10.687 20.5328 10.6793 20.5303Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M10.7037 20.4336H11.7718C11.8083 20.4336 11.8371 20.456 11.8371 20.4835C11.8371 20.511 11.8083 20.5341 11.7718 20.5341H10.7037C10.6678 20.5341 10.6384 20.511 10.6384 20.4835C10.6384 20.456 10.6678 20.4336 10.7037 20.4336ZM10.5078 21.1114H11.9715V20.7382H10.5078V21.1114Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M10.7266 20.3727H11.7666V15.2764H10.7266V20.3727Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M11.4609 15.2832V20.3686M11.5781 15.2832V20.3686"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M10.5312 14.8718H11.9578V14.498H10.5312V14.8718Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M10.6835 15.1206C10.6918 15.1171 10.7008 15.1156 10.7098 15.1161H11.7779C11.7888 15.1161 11.7984 15.1181 11.8074 15.1213C11.7702 15.1091 11.744 15.0758 11.744 15.0368C11.744 14.9977 11.7728 14.9638 11.8099 14.9517C11.801 14.9542 11.7888 14.9568 11.7786 14.9568H10.7098C10.6989 14.9568 10.6886 14.9561 10.6797 14.9529L10.6854 14.9542C10.7238 14.9657 10.7456 14.9997 10.7456 15.0368C10.7456 15.0726 10.7213 15.1091 10.6835 15.1206Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M10.7059 15.1161H11.7741C11.8105 15.1161 11.8393 15.1385 11.8393 15.166C11.8393 15.1941 11.8105 15.2165 11.7741 15.2165H10.7059C10.6701 15.2165 10.6406 15.1941 10.6406 15.166C10.6406 15.1385 10.6701 15.1161 10.7059 15.1161ZM10.7059 14.8716H11.7747C11.8112 14.8716 11.8406 14.8908 11.8406 14.9138C11.8406 14.9375 11.8112 14.9567 11.7747 14.9567H10.7059C10.6701 14.9567 10.6406 14.9375 10.6406 14.9138C10.6406 14.8908 10.6701 14.8716 10.7059 14.8716Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M10.4008 19.1118C10.2561 19.195 10.1576 19.2808 10.1736 19.3237C10.1813 19.3627 10.2273 19.3921 10.2933 19.4357C10.3969 19.508 10.4597 19.6366 10.4104 19.6961C10.4961 19.627 10.5505 19.524 10.5505 19.4088C10.5505 19.2891 10.4929 19.1809 10.4008 19.1118Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.825 17.182C12.5984 17.0886 12.2125 17.0188 11.7696 17.0041C11.6166 17.0054 11.447 17.0201 11.271 17.0489C10.649 17.1532 10.1747 17.4015 10.2125 17.6038C10.2131 17.6076 10.215 17.6166 10.2157 17.6204C10.2157 17.6204 9.98271 17.095 9.97887 17.0751C9.93727 16.8505 10.4627 16.5747 11.1533 16.4595C11.3702 16.423 11.5814 16.4089 11.7651 16.4108C12.2067 16.4108 12.5907 16.4678 12.8224 16.5535L12.825 17.182Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M10.7212 17.822C10.4326 17.8015 10.2361 17.724 10.213 17.6037C10.1951 17.5077 10.293 17.4008 10.4671 17.3042C10.5446 17.3132 10.6322 17.3234 10.7231 17.3234L10.7212 17.822ZM11.765 17.4322C11.9455 17.4597 12.0806 17.5045 12.1478 17.5596L12.1542 17.5704C12.1862 17.6364 12.0281 17.7765 11.7631 17.9333L11.765 17.4322Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M10.0722 18.8049C10.0446 18.7229 10.3262 18.5578 10.7237 18.4119C10.9054 18.3473 11.0552 18.2794 11.2414 18.1975C11.7938 17.953 12.2014 17.6727 12.1515 17.5709L12.1458 17.5601C12.1752 17.5844 12.2213 18.0874 12.2213 18.0874C12.2712 18.1809 11.8981 18.4573 11.3893 18.7005C11.2267 18.7786 10.883 18.9053 10.7211 18.9623C10.4306 19.0628 10.1426 19.2529 10.1688 19.3233L10.0722 18.8055V18.8049Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M20.7885 14.1068C20.7885 14.1068 20.7411 14.1567 20.7066 14.1637C20.6727 14.1701 20.6291 14.1324 20.6291 14.1324C20.6291 14.1324 20.5984 14.165 20.56 14.1733C20.5223 14.1823 20.4698 14.1311 20.4698 14.1311C20.4698 14.1311 20.4333 14.1823 20.4013 14.1944C20.3687 14.206 20.329 14.1791 20.329 14.1791C20.329 14.1791 20.3143 14.204 20.2874 14.2181C20.2759 14.2239 20.2567 14.2149 20.2567 14.2149L20.2183 14.1906L20.1747 14.1445L20.1351 14.1292C20.1351 14.1292 20.1171 14.0709 20.1152 14.0607C20.1139 14.0504 20.1101 14.0242 20.1101 14.0242C20.1018 13.9826 20.1658 13.9346 20.2573 13.9141C20.3098 13.902 20.3559 13.9026 20.3891 13.9128C20.4256 13.8821 20.5031 13.8604 20.5939 13.8604C20.6765 13.8604 20.7488 13.8776 20.7885 13.9052C20.8275 13.8776 20.8999 13.8604 20.9824 13.8604C21.0733 13.8604 21.1501 13.8821 21.1866 13.9128C21.2205 13.9026 21.2659 13.902 21.3191 13.9141C21.4099 13.9346 21.4746 13.9826 21.4663 14.0242C21.4663 14.0242 21.4624 14.0504 21.4611 14.0607C21.4592 14.0709 21.4407 14.1292 21.4407 14.1292L21.401 14.1445L21.3575 14.1906L21.3203 14.2149C21.3203 14.2149 21.3011 14.2239 21.2896 14.2181C21.2621 14.2047 21.2474 14.1791 21.2474 14.1791C21.2474 14.1791 21.2077 14.206 21.1751 14.1944C21.1424 14.1823 21.1066 14.1311 21.1066 14.1311C21.1066 14.1311 21.0541 14.1823 21.0157 14.1733C20.9779 14.165 20.9472 14.1324 20.9472 14.1324C20.9472 14.1324 20.9037 14.1701 20.8698 14.1637C20.8352 14.1567 20.7885 14.1068 20.7885 14.1068Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01728"
      />
      <path
        d="M20.7914 13.9623C20.8402 13.9623 20.8798 13.9061 20.8798 13.8369C20.8798 13.7676 20.8402 13.7114 20.7914 13.7114C20.7427 13.7114 20.7031 13.7676 20.7031 13.8369C20.7031 13.9061 20.7427 13.9623 20.7914 13.9623Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7981 13.9529C20.8204 13.9529 20.8385 13.901 20.8385 13.837C20.8385 13.7731 20.8204 13.7212 20.7981 13.7212C20.7759 13.7212 20.7578 13.7731 20.7578 13.837C20.7578 13.901 20.7759 13.9529 20.7981 13.9529Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7939 13.7494C20.8268 13.7494 20.8534 13.7241 20.8534 13.693C20.8534 13.6619 20.8268 13.6367 20.7939 13.6367C20.761 13.6367 20.7344 13.6619 20.7344 13.693C20.7344 13.7241 20.761 13.7494 20.7939 13.7494Z"
        fill="#C8B100"
      />
      <path
        d="M20.8729 13.6731V13.7102H20.7109V13.6731H20.7711V13.5899H20.7314V13.5527H20.7711V13.5156H20.8101V13.5527H20.8492V13.5899H20.8101V13.6731H20.8729Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.0192"
      />
      <path
        d="M20.8114 13.6398C20.8251 13.6438 20.8369 13.6524 20.8444 13.6639C20.852 13.6754 20.8549 13.6892 20.8527 13.7026C20.8504 13.716 20.843 13.7282 20.832 13.7369C20.821 13.7456 20.807 13.7502 20.7927 13.7499C20.7783 13.7497 20.7645 13.7445 20.7539 13.7353C20.7433 13.7262 20.7365 13.7138 20.7348 13.7003C20.7331 13.6868 20.7366 13.6732 20.7447 13.6619C20.7528 13.6507 20.7649 13.6426 20.7788 13.6392"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.1235 14.0796C20.1151 14.0585 20.1094 14.0348 20.1094 14.0105C20.1094 13.9087 20.19 13.8262 20.2905 13.8262C20.3225 13.8262 20.3519 13.8345 20.3782 13.8499"
        stroke="black"
        strokeWidth="0.01664"
        strokeLinecap="round"
      />
      <path
        d="M20.4482 13.9476C20.4386 13.931 20.4297 13.9131 20.4297 13.8939C20.4297 13.8203 20.5058 13.7607 20.5986 13.7607C20.6383 13.7607 20.6754 13.7716 20.7042 13.7895M21.1324 13.9495C21.142 13.9329 21.1484 13.9131 21.1484 13.8939C21.1484 13.8203 21.0729 13.7607 20.9794 13.7607C20.9398 13.7607 20.9033 13.7716 20.8745 13.7895"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.4507 14.0796C21.459 14.0585 21.4641 14.0348 21.4641 14.0105C21.4641 13.9087 21.3835 13.8262 21.2836 13.8262C21.2516 13.8262 21.2216 13.8345 21.1953 13.8499"
        stroke="black"
        strokeWidth="0.01664"
        strokeLinecap="round"
      />
      <path
        d="M20.0679 14.0233C20.0838 14.0233 20.0967 14.011 20.0967 13.9958C20.0967 13.9806 20.0838 13.9683 20.0679 13.9683C20.052 13.9683 20.0391 13.9806 20.0391 13.9958C20.0391 14.011 20.052 14.0233 20.0679 14.0233Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.0757 13.9217C20.0916 13.9217 20.1045 13.9094 20.1045 13.8942C20.1045 13.879 20.0916 13.8667 20.0757 13.8667C20.0598 13.8667 20.0469 13.879 20.0469 13.8942C20.0469 13.9094 20.0598 13.9217 20.0757 13.9217Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.146 13.8451C20.1619 13.8451 20.1748 13.8328 20.1748 13.8176C20.1748 13.8024 20.1619 13.79 20.146 13.79C20.1301 13.79 20.1172 13.8024 20.1172 13.8176C20.1172 13.8328 20.1301 13.8451 20.146 13.8451Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.2319 13.8036C20.2478 13.8036 20.2607 13.7913 20.2607 13.7761C20.2607 13.7609 20.2478 13.7485 20.2319 13.7485C20.216 13.7485 20.2031 13.7609 20.2031 13.7761C20.2031 13.7913 20.216 13.8036 20.2319 13.8036Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.3257 13.8075C20.3416 13.8075 20.3545 13.7952 20.3545 13.78C20.3545 13.7648 20.3416 13.7524 20.3257 13.7524C20.3098 13.7524 20.2969 13.7648 20.2969 13.78C20.2969 13.7952 20.3098 13.8075 20.3257 13.8075Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.3804 13.9208C20.3963 13.9208 20.4092 13.9084 20.4092 13.8932C20.4092 13.878 20.3963 13.8657 20.3804 13.8657C20.3645 13.8657 20.3516 13.878 20.3516 13.8932C20.3516 13.9084 20.3645 13.9208 20.3804 13.9208Z"
        fill="white"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.396 13.8246C20.4119 13.8246 20.4248 13.8123 20.4248 13.7971C20.4248 13.7819 20.4119 13.7695 20.396 13.7695C20.3801 13.7695 20.3672 13.7819 20.3672 13.7971C20.3672 13.8123 20.3801 13.8246 20.396 13.8246Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.4663 13.7645C20.4822 13.7645 20.4951 13.7522 20.4951 13.737C20.4951 13.7218 20.4822 13.7095 20.4663 13.7095C20.4504 13.7095 20.4375 13.7218 20.4375 13.737C20.4375 13.7522 20.4504 13.7645 20.4663 13.7645Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.5601 13.7357C20.576 13.7357 20.5888 13.7234 20.5888 13.7082C20.5888 13.693 20.576 13.6807 20.5601 13.6807C20.5441 13.6807 20.5312 13.693 20.5312 13.7082C20.5312 13.7234 20.5441 13.7357 20.5601 13.7357Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.6538 13.7391C20.6697 13.7391 20.6826 13.7268 20.6826 13.7116C20.6826 13.6964 20.6697 13.6841 20.6538 13.6841C20.6379 13.6841 20.625 13.6964 20.625 13.7116C20.625 13.7268 20.6379 13.7391 20.6538 13.7391Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.9272 13.7391C20.9431 13.7391 20.956 13.7268 20.956 13.7116C20.956 13.6964 20.9431 13.6841 20.9272 13.6841C20.9113 13.6841 20.8984 13.6964 20.8984 13.7116C20.8984 13.7268 20.9113 13.7391 20.9272 13.7391Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.0132 13.7357C21.0291 13.7357 21.042 13.7234 21.042 13.7082C21.042 13.693 21.0291 13.6807 21.0132 13.6807C20.9973 13.6807 20.9844 13.693 20.9844 13.7082C20.9844 13.7234 20.9973 13.7357 21.0132 13.7357Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.1069 13.7645C21.1228 13.7645 21.1357 13.7522 21.1357 13.737C21.1357 13.7218 21.1228 13.7095 21.1069 13.7095C21.091 13.7095 21.0781 13.7218 21.0781 13.737C21.0781 13.7522 21.091 13.7645 21.1069 13.7645Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.1772 13.8246C21.1931 13.8246 21.206 13.8123 21.206 13.7971C21.206 13.7819 21.1931 13.7695 21.1772 13.7695C21.1613 13.7695 21.1484 13.7819 21.1484 13.7971C21.1484 13.8123 21.1613 13.8246 21.1772 13.8246Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.1929 13.9208C21.2088 13.9208 21.2217 13.9084 21.2217 13.8932C21.2217 13.878 21.2088 13.8657 21.1929 13.8657C21.177 13.8657 21.1641 13.878 21.1641 13.8932C21.1641 13.9084 21.177 13.9208 21.1929 13.9208Z"
        fill="white"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.2554 13.8075C21.2713 13.8075 21.2842 13.7952 21.2842 13.78C21.2842 13.7648 21.2713 13.7524 21.2554 13.7524C21.2395 13.7524 21.2266 13.7648 21.2266 13.78C21.2266 13.7952 21.2395 13.8075 21.2554 13.8075Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.3413 13.8036C21.3572 13.8036 21.3701 13.7913 21.3701 13.7761C21.3701 13.7609 21.3572 13.7485 21.3413 13.7485C21.3254 13.7485 21.3125 13.7609 21.3125 13.7761C21.3125 13.7913 21.3254 13.8036 21.3413 13.8036Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.4272 13.8451C21.4431 13.8451 21.456 13.8328 21.456 13.8176C21.456 13.8024 21.4431 13.79 21.4272 13.79C21.4113 13.79 21.3984 13.8024 21.3984 13.8176C21.3984 13.8328 21.4113 13.8451 21.4272 13.8451Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.4976 13.9217C21.5135 13.9217 21.5263 13.9094 21.5263 13.8942C21.5263 13.879 21.5135 13.8667 21.4976 13.8667C21.4816 13.8667 21.4688 13.879 21.4688 13.8942C21.4688 13.9094 21.4816 13.9217 21.4976 13.9217Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M21.5054 14.0233C21.5213 14.0233 21.5342 14.011 21.5342 13.9958C21.5342 13.9806 21.5213 13.9683 21.5054 13.9683C21.4895 13.9683 21.4766 13.9806 21.4766 13.9958C21.4766 14.011 21.4895 14.0233 21.5054 14.0233Z"
        stroke="black"
        strokeWidth="0.01344"
      />
      <path
        d="M20.334 14.3519C20.3212 14.3155 20.2969 14.2828 20.2969 14.2828C20.4217 14.2463 20.5951 14.2233 20.7878 14.2227C20.9804 14.2233 21.1558 14.2463 21.2799 14.2828C21.2799 14.2828 21.2658 14.3071 21.2466 14.3411C21.2358 14.3603 21.2217 14.3929 21.2223 14.3929C21.1103 14.3583 20.965 14.3411 20.7871 14.3404C20.6086 14.3411 20.4377 14.3628 20.3481 14.3955C20.3494 14.3955 20.3417 14.375 20.3334 14.3519H20.334Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7897 14.5108C20.9452 14.5102 21.1167 14.4865 21.1801 14.4705C21.2223 14.4577 21.2473 14.4391 21.2428 14.4167C21.2402 14.4065 21.2313 14.3975 21.2191 14.3924C21.1257 14.3623 20.9586 14.3412 20.7897 14.3412C20.6214 14.3412 20.4524 14.3623 20.3596 14.3924C20.3474 14.3975 20.3385 14.4065 20.3359 14.4167C20.3314 14.4391 20.3564 14.4577 20.3986 14.4705C20.462 14.4865 20.6342 14.5102 20.7897 14.5108ZM21.2895 14.2132L21.2518 14.1793C21.2518 14.1793 21.2153 14.201 21.1698 14.1946C21.125 14.1876 21.1103 14.1326 21.1103 14.1326C21.1103 14.1326 21.0598 14.1754 21.0182 14.1722C20.9766 14.1684 20.9497 14.1326 20.9497 14.1326C20.9497 14.1326 20.9042 14.1652 20.8646 14.162C20.8249 14.1582 20.7871 14.1089 20.7871 14.1089C20.7871 14.1089 20.7468 14.1601 20.7071 14.1639C20.6674 14.1671 20.6348 14.1294 20.6348 14.1294C20.6348 14.1294 20.6169 14.1671 20.5663 14.1754C20.5158 14.1838 20.4722 14.1358 20.4722 14.1358C20.4722 14.1358 20.4434 14.1825 20.4089 14.1946C20.3743 14.2062 20.3295 14.1774 20.3295 14.1774C20.3295 14.1774 20.3218 14.1946 20.3167 14.2049C20.3116 14.2151 20.2969 14.217 20.2969 14.217L20.3084 14.2471C20.4319 14.2113 20.6002 14.1889 20.7903 14.1889C20.9804 14.1889 21.1532 14.2113 21.2774 14.2478L21.2902 14.2132H21.2895Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7855 14.0474L20.8034 14.0506C20.8002 14.0582 20.7996 14.0659 20.7996 14.0749C20.7996 14.112 20.8316 14.1421 20.8713 14.1421C20.9026 14.1421 20.9295 14.1222 20.9391 14.0954C20.9397 14.096 20.9461 14.071 20.9487 14.071C20.9506 14.071 20.9506 14.0973 20.9519 14.0973C20.9564 14.1312 20.9871 14.1542 21.0223 14.1542C21.062 14.1542 21.0933 14.1242 21.0933 14.0864C21.0933 14.0838 21.0933 14.0813 21.0927 14.0787L21.1151 14.0563L21.1273 14.0845C21.1228 14.0934 21.1209 14.103 21.1209 14.1139C21.1209 14.1498 21.1509 14.1786 21.1887 14.1786C21.2124 14.1786 21.2329 14.167 21.245 14.1498L21.2597 14.1312V14.1542C21.2597 14.176 21.2687 14.1965 21.2911 14.1997C21.2911 14.1997 21.3154 14.2016 21.3493 14.1754C21.3826 14.1491 21.4005 14.1274 21.4005 14.1274L21.4025 14.1542C21.4025 14.1542 21.3698 14.208 21.3404 14.2246C21.3244 14.2342 21.2994 14.2445 21.2796 14.2406C21.2591 14.2374 21.2444 14.2208 21.2367 14.2016C21.222 14.2106 21.2041 14.2157 21.1855 14.2157C21.1452 14.2157 21.1087 14.1933 21.0946 14.1606C21.0761 14.1805 21.0505 14.1926 21.0204 14.1926C20.9877 14.1926 20.9583 14.1779 20.9397 14.1555C20.9218 14.1728 20.8969 14.183 20.87 14.183C20.8348 14.183 20.8028 14.1651 20.7849 14.1389C20.7663 14.1651 20.7349 14.183 20.6991 14.183C20.6722 14.183 20.6473 14.1728 20.6293 14.1555C20.6108 14.1779 20.5813 14.1926 20.5493 14.1926C20.5186 14.1926 20.493 14.1805 20.4745 14.1606C20.4604 14.1933 20.4239 14.2157 20.3836 14.2157C20.365 14.2157 20.3477 14.2106 20.333 14.2016C20.3253 14.2208 20.3106 14.2374 20.2895 14.2406C20.2703 14.2445 20.2453 14.2342 20.2293 14.2246C20.1993 14.208 20.1641 14.1542 20.1641 14.1542L20.1685 14.1274C20.1685 14.1274 20.1871 14.1491 20.2204 14.1754C20.2537 14.2016 20.2786 14.1997 20.2786 14.1997C20.3004 14.1965 20.31 14.176 20.31 14.1542V14.1312L20.3241 14.1498C20.3362 14.167 20.3567 14.1786 20.3804 14.1786C20.4181 14.1786 20.4482 14.1498 20.4482 14.1139C20.4488 14.1037 20.4466 14.0935 20.4418 14.0845L20.454 14.0563L20.4764 14.0787C20.4757 14.0813 20.4757 14.0838 20.4757 14.0864C20.4757 14.1242 20.5071 14.1542 20.5468 14.1542C20.582 14.1542 20.6127 14.1312 20.6178 14.0973C20.6185 14.0973 20.6185 14.071 20.6204 14.071C20.6236 14.071 20.6293 14.096 20.6306 14.0954C20.6396 14.1222 20.6665 14.1421 20.6985 14.1421C20.7375 14.1421 20.7695 14.112 20.7695 14.0749C20.7695 14.0659 20.7695 14.0582 20.7663 14.0506L20.7849 14.0474H20.7855Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7861 14.2224C20.5934 14.223 20.42 14.2461 20.2952 14.2826C20.2869 14.2851 20.2766 14.2787 20.2741 14.2717C20.2715 14.2634 20.2773 14.2538 20.2856 14.2512C20.4104 14.2128 20.5883 14.1885 20.7861 14.1885C20.9838 14.1885 21.1624 14.2128 21.2872 14.2512C21.2955 14.2538 21.3013 14.2634 21.2987 14.2717C21.2961 14.2787 21.2859 14.2851 21.2776 14.2826C21.1528 14.2461 20.9787 14.223 20.7861 14.2224Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
        strokeLinejoin="round"
      />
      <path
        d="M20.132 14.1439C20.1314 14.1445 20.1077 14.1131 20.0904 14.0971C20.0776 14.0856 20.0469 14.076 20.0469 14.076C20.0469 14.0709 20.0648 14.0581 20.084 14.0581C20.0955 14.0581 20.1064 14.0626 20.1128 14.0709L20.1154 14.0581C20.1154 14.0581 20.1307 14.0613 20.1378 14.0786C20.1454 14.0971 20.141 14.1247 20.141 14.1247C20.141 14.1247 20.1378 14.1375 20.132 14.1439ZM20.253 14.0939L20.2459 14.1362L20.1563 14.1458L20.1429 14.1381L20.1454 14.1234L20.2133 14.0677L20.253 14.0939Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.129 14.128C20.1367 14.1203 20.152 14.1223 20.1629 14.1319C20.1744 14.1415 20.1783 14.1562 20.1706 14.1639C20.1629 14.1722 20.1476 14.1703 20.1367 14.16C20.1252 14.1504 20.1213 14.1357 20.129 14.128ZM20.2935 14.1363C20.2896 14.1248 20.2935 14.1127 20.3018 14.1095C20.3108 14.1075 20.321 14.1152 20.3255 14.1267C20.3293 14.1389 20.3255 14.1511 20.3165 14.1536C20.3082 14.1562 20.298 14.1485 20.2935 14.1363ZM20.3351 14.0826L20.3677 14.1133L20.4458 14.0711L20.4516 14.0576L20.4407 14.0467L20.3511 14.0391L20.3351 14.0826Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.4257 13.9365L20.3828 13.9775L20.4379 14.0504L20.4526 14.0562L20.4635 14.0447L20.4827 13.957L20.4257 13.9365Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.5709 14.0352L20.5542 14.0756L20.4646 14.0672L20.4531 14.057L20.4595 14.0429L20.5376 14.002L20.5709 14.0352Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.4532 14.0875C20.4706 14.0875 20.4846 14.074 20.4846 14.0574C20.4846 14.0408 20.4706 14.0273 20.4532 14.0273C20.4359 14.0273 20.4219 14.0408 20.4219 14.0574C20.4219 14.074 20.4359 14.0875 20.4532 14.0875Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.6097 14.0768C20.6078 14.064 20.6142 14.0531 20.6232 14.0519C20.6321 14.0506 20.6411 14.0602 20.6424 14.073C20.6443 14.0851 20.6379 14.0967 20.6289 14.0973C20.62 14.0986 20.611 14.089 20.6097 14.0768ZM20.668 14.0314L20.6936 14.0679L20.7793 14.041L20.7883 14.0295L20.7787 14.0167L20.6936 13.9917L20.668 14.0314Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7816 13.8975L20.7266 13.9307L20.7675 14.0191L20.7816 14.028L20.7957 14.0191L20.8366 13.9307L20.7816 13.8975Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.9087 14.0314L20.8838 14.0679L20.798 14.041L20.7891 14.0295L20.798 14.0167L20.8838 13.9917L20.9087 14.0314Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7892 14.0592C20.8065 14.0592 20.8205 14.0457 20.8205 14.0291C20.8205 14.0125 20.8065 13.999 20.7892 13.999C20.7719 13.999 20.7578 14.0125 20.7578 14.0291C20.7578 14.0457 20.7719 14.0592 20.7892 14.0592Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.971 14.0768C20.9722 14.064 20.9658 14.0532 20.9569 14.0519C20.9479 14.0506 20.939 14.0602 20.9377 14.073C20.9364 14.0852 20.9422 14.0967 20.9511 14.0973C20.9601 14.0986 20.969 14.089 20.971 14.0768ZM21.0023 14.0352L21.019 14.0756L21.1086 14.0672L21.1201 14.057L21.1137 14.0429L21.0356 14.002L21.0023 14.0352Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.1429 13.9365L21.1858 13.9775L21.1307 14.0504L21.116 14.0562L21.1051 14.0447L21.0859 13.957L21.1429 13.9365Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.2343 14.0826L21.2017 14.1133L21.1236 14.0711L21.1172 14.0576L21.1293 14.0467L21.2189 14.0391L21.2343 14.0826Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.1173 14.0875C21.1346 14.0875 21.1487 14.074 21.1487 14.0574C21.1487 14.0408 21.1346 14.0273 21.1173 14.0273C21.1 14.0273 21.0859 14.0408 21.0859 14.0574C21.0859 14.074 21.1 14.0875 21.1173 14.0875Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.2757 14.1362C21.2795 14.1247 21.2757 14.1125 21.2674 14.1093C21.2584 14.1074 21.2482 14.1151 21.2437 14.1266C21.2398 14.1387 21.2437 14.1509 21.2526 14.1535C21.261 14.156 21.2712 14.1483 21.2757 14.1362ZM21.4286 14.1439C21.4293 14.1445 21.453 14.1131 21.4709 14.0971C21.483 14.0856 21.5138 14.076 21.5138 14.076C21.5138 14.0709 21.4958 14.0581 21.4766 14.0581C21.4651 14.0581 21.4542 14.0626 21.4478 14.0709L21.4453 14.0581C21.4453 14.0581 21.4299 14.0613 21.4222 14.0786C21.4152 14.0971 21.4203 14.1247 21.4203 14.1247C21.4203 14.1247 21.4229 14.1375 21.4286 14.1439ZM21.3077 14.0939L21.3147 14.1362L21.4043 14.1458L21.4178 14.1381L21.4146 14.1234L21.3474 14.0677L21.3077 14.0939Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.4284 14.1278C21.4214 14.1201 21.406 14.122 21.3945 14.1316C21.383 14.1412 21.3791 14.1559 21.3868 14.1636C21.3945 14.1719 21.4098 14.17 21.4214 14.1598C21.4329 14.1502 21.4361 14.1355 21.4284 14.1278Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.3047 14.3552L20.3245 14.3232L20.3661 14.3316L20.3418 14.3674L20.3047 14.3552Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.4827 14.3239L20.4385 14.3309C20.427 14.3322 20.4161 14.3252 20.4142 14.3143C20.4136 14.3091 20.4151 14.3038 20.4183 14.2996C20.4215 14.2955 20.4262 14.2927 20.4315 14.2919L20.4763 14.2855L20.5217 14.2785C20.5332 14.2772 20.5435 14.2842 20.5454 14.2945C20.5467 14.3054 20.539 14.3156 20.5281 14.3169L20.4827 14.3239Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.6375 14.3176C20.6531 14.3176 20.6657 14.3059 20.6657 14.2914C20.6657 14.2769 20.6531 14.2651 20.6375 14.2651C20.622 14.2651 20.6094 14.2769 20.6094 14.2914C20.6094 14.3059 20.622 14.3176 20.6375 14.3176Z"
        fill="white"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7935 14.3029H20.7321C20.7205 14.3029 20.7109 14.2939 20.7109 14.283C20.7109 14.2721 20.7199 14.2632 20.7314 14.2632H20.8569C20.869 14.2632 20.878 14.2721 20.878 14.283C20.878 14.2939 20.8684 14.3029 20.8569 14.3029H20.7935Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.95 14.3176C20.9656 14.3176 20.9782 14.3059 20.9782 14.2914C20.9782 14.2769 20.9656 14.2651 20.95 14.2651C20.9345 14.2651 20.9219 14.2769 20.9219 14.2914C20.9219 14.3059 20.9345 14.3176 20.95 14.3176Z"
        fill="white"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.1021 14.3239L21.1462 14.3309C21.1577 14.3322 21.1686 14.3252 21.1705 14.3143C21.1712 14.309 21.1698 14.3037 21.1665 14.2995C21.1633 14.2953 21.1585 14.2926 21.1533 14.2919L21.1085 14.2855L21.063 14.2785C21.0515 14.2772 21.0406 14.2842 21.0393 14.2945C21.0389 14.2971 21.039 14.2998 21.0396 14.3024C21.0403 14.3049 21.0414 14.3074 21.0431 14.3095C21.0447 14.3116 21.0467 14.3133 21.0491 14.3146C21.0514 14.3159 21.054 14.3166 21.0566 14.3169L21.1021 14.3239Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M21.2776 14.3572L21.2616 14.3232L21.2188 14.3271L21.2392 14.3648L21.2776 14.3572Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M20.7938 14.4746C20.6383 14.4746 20.4975 14.4605 20.3906 14.433C20.4975 14.4055 20.6383 14.3888 20.7938 14.3882C20.95 14.3882 21.0914 14.4055 21.1989 14.433C21.0914 14.4605 20.95 14.4746 20.7938 14.4746Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
        strokeLinejoin="round"
      />
      <path
        d="M20.8687 14.4694V14.3951M20.8316 14.4719L20.8322 14.3932M20.8047 14.4732V14.3926"
        stroke="black"
        strokeWidth="0.00064"
      />
      <path
        d="M20.7399 14.4739V14.3926M20.7188 14.4739V14.3926"
        stroke="black"
        strokeWidth="0.00256"
      />
      <path
        d="M20.6647 14.4692L20.6641 14.3956M20.6813 14.4705V14.3931"
        stroke="black"
        strokeWidth="0.00384"
      />
      <path
        d="M20.6328 14.4659V14.3981M20.6495 14.4678L20.6488 14.3955"
        stroke="black"
        strokeWidth="0.00448"
      />
      <path
        d="M20.5859 14.4625V14.403M20.6007 14.4631V14.4004M20.6154 14.4657V14.4004"
        stroke="black"
        strokeWidth="0.00512"
      />
      <path
        d="M20.5082 14.4524L20.5075 14.4127M20.5242 14.455V14.4102M20.4922 14.4492V14.414"
        stroke="black"
        strokeWidth="0.00768"
      />
      <path d="M20.4766 14.4469V14.4175" stroke="black" strokeWidth="0.00832" />
      <path d="M20.4609 14.443V14.4199" stroke="black" strokeWidth="0.00896" />
      <path d="M20.4453 14.4411V14.4238" stroke="black" strokeWidth="0.0096" />
      <path d="M20.4297 14.437V14.4287" stroke="black" strokeWidth="0.01152" />
      <path
        d="M21.7905 21.1638C21.6919 21.1638 21.6042 21.1427 21.539 21.1081C21.475 21.0755 21.3879 21.0557 21.2919 21.0557C21.1953 21.0557 21.1063 21.0761 21.0417 21.1088C20.977 21.1427 20.8881 21.1638 20.7908 21.1638C20.6922 21.1638 20.6039 21.1408 20.5393 21.1062C20.4753 21.0749 20.3902 21.0557 20.2967 21.0557C20.1994 21.0557 20.1137 21.0742 20.0497 21.1075C19.9844 21.1421 19.8948 21.1638 19.7969 21.1638V21.3181C19.8948 21.3181 19.9844 21.2957 20.0497 21.2617C20.1137 21.2285 20.1994 21.2093 20.2967 21.2093C20.3895 21.2093 20.4753 21.2291 20.5393 21.2605C20.6039 21.2944 20.6922 21.3181 20.7908 21.3181C20.8881 21.3181 20.977 21.2969 21.0417 21.263C21.1063 21.2297 21.1953 21.2093 21.2919 21.2093C21.3879 21.2093 21.475 21.2297 21.539 21.2624C21.6042 21.2969 21.6906 21.3181 21.7892 21.3181L21.7905 21.1638Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M21.7905 21.3183C21.6919 21.3183 21.6042 21.2972 21.539 21.2626C21.475 21.23 21.3879 21.2095 21.2919 21.2095C21.1953 21.2095 21.1063 21.23 21.0417 21.2632C20.977 21.2972 20.8881 21.3183 20.7908 21.3183C20.6922 21.3183 20.6039 21.2946 20.5393 21.2607C20.4753 21.2293 20.3902 21.2095 20.2967 21.2095C20.1994 21.2095 20.1137 21.2287 20.0497 21.262C19.9844 21.2959 19.8948 21.3183 19.7969 21.3183V21.4725C19.8948 21.4725 19.9844 21.4501 20.0497 21.4162C20.1137 21.3829 20.1994 21.3637 20.2967 21.3637C20.3895 21.3637 20.4753 21.3836 20.5393 21.4149C20.6039 21.4495 20.6922 21.4725 20.7908 21.4725C20.8881 21.4725 20.977 21.4508 21.0417 21.4175C21.1063 21.3842 21.1953 21.3637 21.2919 21.3637C21.3879 21.3637 21.475 21.3842 21.539 21.4175C21.6042 21.4514 21.6906 21.4725 21.7892 21.4725L21.7905 21.3183Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M21.7905 21.4721C21.6919 21.4721 21.6042 21.451 21.539 21.417C21.475 21.3838 21.3879 21.3633 21.2919 21.3633C21.1953 21.3633 21.1063 21.3838 21.0417 21.417C20.977 21.4503 20.8881 21.4721 20.7908 21.4721C20.6922 21.4721 20.6039 21.449 20.5393 21.4145C20.4753 21.3831 20.3902 21.3633 20.2967 21.3633C20.1994 21.3633 20.1137 21.3825 20.0497 21.4158C19.9844 21.4497 19.8948 21.4721 19.7969 21.4721V21.6257C19.8948 21.6257 19.9844 21.6039 20.0497 21.5694C20.1137 21.5367 20.1994 21.5182 20.2967 21.5182C20.3895 21.5182 20.4753 21.5374 20.5393 21.5687C20.6039 21.6033 20.6922 21.6257 20.7908 21.6257C20.8881 21.6257 20.977 21.6052 21.0417 21.5713C21.1063 21.538 21.1953 21.5182 21.2919 21.5182C21.3879 21.5182 21.475 21.538 21.539 21.5706C21.6042 21.6058 21.6906 21.6257 21.7892 21.6257L21.7905 21.4721Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M21.7892 21.781C21.6906 21.781 21.6042 21.7598 21.539 21.7253C21.475 21.6926 21.3879 21.6728 21.2919 21.6728C21.1953 21.6728 21.1063 21.6926 21.0417 21.7259C20.977 21.7592 20.8881 21.781 20.7908 21.781C20.6922 21.781 20.6039 21.7573 20.5393 21.7234C20.4753 21.6914 20.3902 21.6728 20.2967 21.6728C20.1994 21.6728 20.1137 21.6914 20.0497 21.7246C19.9844 21.7586 19.8948 21.781 19.7969 21.781V21.6274C19.8948 21.6274 19.9844 21.6043 20.0497 21.5698C20.1137 21.5371 20.1994 21.5186 20.2967 21.5186C20.3895 21.5186 20.4753 21.5378 20.5393 21.5691C20.6039 21.6037 20.6922 21.6261 20.7908 21.6261C20.8881 21.6261 20.977 21.6056 21.0417 21.5717C21.1063 21.5384 21.1953 21.5186 21.2919 21.5186C21.3879 21.5186 21.475 21.5384 21.539 21.571C21.6042 21.6062 21.6919 21.6261 21.7905 21.6261L21.7892 21.781Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M21.7892 21.9353C21.6906 21.9353 21.6042 21.9141 21.539 21.8802C21.475 21.8469 21.3879 21.8265 21.2919 21.8265C21.1953 21.8265 21.1063 21.8469 21.0417 21.8802C20.977 21.9135 20.8881 21.9353 20.7908 21.9353C20.6922 21.9353 20.6039 21.9116 20.5393 21.8777C20.4753 21.8457 20.3902 21.8265 20.2967 21.8265C20.1994 21.8265 20.1137 21.8457 20.0497 21.8789C19.9844 21.9129 19.8948 21.9353 19.7969 21.9353V21.7823C19.8948 21.7823 19.9844 21.7586 20.0497 21.7247C20.1137 21.6914 20.1994 21.6729 20.2967 21.6729C20.3895 21.6729 20.4753 21.6921 20.5393 21.7234C20.6039 21.7573 20.6922 21.781 20.7908 21.781C20.8881 21.781 20.977 21.7593 21.0417 21.726C21.1063 21.6927 21.1953 21.6729 21.2919 21.6729C21.3879 21.6729 21.475 21.6927 21.539 21.7253C21.6042 21.7599 21.6913 21.781 21.7905 21.781L21.7892 21.9353Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M20.2262 20.5303C20.2294 20.5437 20.2345 20.5559 20.2345 20.57C20.2345 20.6634 20.1532 20.7383 20.0547 20.7383H21.5228C21.4236 20.7383 21.343 20.6634 21.343 20.57C21.343 20.5565 21.3456 20.5437 21.3488 20.5303C21.3404 20.5335 21.3302 20.5341 21.3206 20.5341H20.2524C20.2441 20.5341 20.2339 20.5328 20.2262 20.5303Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M20.2505 20.4336H21.3187C21.3552 20.4336 21.384 20.456 21.384 20.4835C21.384 20.511 21.3552 20.5341 21.3187 20.5341H20.2505C20.2147 20.5341 20.1852 20.511 20.1852 20.4835C20.1852 20.456 20.2147 20.4336 20.2505 20.4336ZM20.0547 21.1114H21.5184V20.7382H20.0547V21.1114Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M20.2734 20.3727H21.3134V15.2764H20.2734V20.3727Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M21.0078 15.2832V20.3686M21.1249 15.2832V20.3686"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M20.0781 14.8718H21.5047V14.498H20.0781V14.8718Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M20.2304 15.1206C20.2387 15.1171 20.2477 15.1156 20.2566 15.1161H21.3248C21.3357 15.1161 21.3453 15.1181 21.3542 15.1213C21.3171 15.1091 21.2909 15.0758 21.2909 15.0368C21.2909 14.9977 21.3197 14.9638 21.3568 14.9517C21.3478 14.9542 21.3357 14.9568 21.3254 14.9568H20.2566C20.2458 14.9568 20.2355 14.9561 20.2266 14.9529L20.2323 14.9542C20.2707 14.9657 20.2925 14.9997 20.2925 15.0368C20.2925 15.0726 20.2682 15.1091 20.2304 15.1206Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M20.2528 15.1161H21.3209C21.3574 15.1161 21.3862 15.1385 21.3862 15.166C21.3862 15.1941 21.3574 15.2165 21.3209 15.2165H20.2528C20.2169 15.2165 20.1875 15.1941 20.1875 15.166C20.1875 15.1385 20.2169 15.1161 20.2528 15.1161ZM20.2528 14.8716H21.3216C21.3581 14.8716 21.3875 14.8908 21.3875 14.9138C21.3875 14.9375 21.3581 14.9567 21.3216 14.9567H20.2528C20.2169 14.9567 20.1875 14.9375 20.1875 14.9138C20.1875 14.8908 20.2169 14.8716 20.2528 14.8716Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M21.6383 19.1118C21.7829 19.195 21.8815 19.2808 21.8655 19.3237C21.8578 19.3627 21.8117 19.3921 21.7458 19.4357C21.6421 19.508 21.5794 19.6366 21.6287 19.6961C21.5429 19.627 21.4885 19.524 21.4885 19.4088C21.4885 19.2891 21.5461 19.1809 21.6383 19.1118Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.2141 17.182C19.4407 17.0886 19.8266 17.0188 20.2695 17.0041C20.4224 17.0054 20.592 17.0201 20.768 17.0489C21.3901 17.1532 21.8644 17.4015 21.8266 17.6038C21.826 17.6076 21.824 17.6166 21.8234 17.6204C21.8234 17.6204 22.0564 17.095 22.0602 17.0751C22.1018 16.8505 21.5764 16.5747 20.8858 16.4595C20.6688 16.423 20.4576 16.4089 20.274 16.4108C19.8324 16.4108 19.4484 16.4678 19.2167 16.5535L19.2141 17.182Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M21.3179 17.822C21.6065 17.8015 21.803 17.724 21.826 17.6037C21.8439 17.5077 21.746 17.4008 21.5719 17.3042C21.4945 17.3132 21.4068 17.3234 21.3159 17.3234L21.3179 17.822ZM20.274 17.4322C20.0935 17.4597 19.9585 17.5045 19.8913 17.5596L19.8849 17.5704C19.8529 17.6364 20.011 17.7765 20.2759 17.9333L20.274 17.4322Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M21.9669 18.8049C21.9944 18.7229 21.7128 18.5578 21.3154 18.4119C21.1336 18.3473 20.9839 18.2794 20.7976 18.1975C20.2453 17.953 19.8376 17.6727 19.8875 17.5709L19.8933 17.5601C19.8639 17.5844 19.8178 18.0874 19.8178 18.0874C19.7679 18.1809 20.141 18.4573 20.6498 18.7005C20.8123 18.7786 21.156 18.9053 21.3179 18.9623C21.6085 19.0628 21.8965 19.2529 21.8703 19.3233L21.9669 18.8055V18.8049Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M10.6542 16.9374C10.7816 16.8914 10.8648 16.8363 10.8245 16.7365C10.7982 16.6725 10.7329 16.6603 10.6344 16.6962L10.4609 16.7595L10.6171 17.1454C10.6344 17.1378 10.6517 17.1301 10.6689 17.1237C10.6869 17.1173 10.7054 17.1122 10.7233 17.107L10.6542 16.9381V16.9374ZM10.5787 16.7512L10.6229 16.7352C10.6593 16.7218 10.7003 16.7416 10.7189 16.7864C10.7323 16.8203 10.7291 16.8587 10.6869 16.8856C10.6734 16.8939 10.6574 16.9003 10.6421 16.9067L10.5787 16.7512ZM11.0613 16.5899C11.0427 16.595 11.0248 16.6002 11.0062 16.604C10.9877 16.6072 10.9685 16.6098 10.9499 16.6117L11.0401 17.0136L11.3205 16.9573C11.3173 16.9496 11.3128 16.9406 11.3115 16.933C11.3096 16.924 11.3096 16.915 11.3089 16.9067C11.2597 16.9208 11.2059 16.9362 11.1419 16.949L11.0613 16.5899ZM11.6232 16.9362C11.6757 16.7902 11.7397 16.6507 11.803 16.5093C11.7915 16.5112 11.78 16.5131 11.7685 16.5138C11.7569 16.5144 11.7448 16.5144 11.7339 16.5138C11.7 16.6168 11.6584 16.7192 11.6142 16.821C11.5617 16.7243 11.5035 16.6296 11.4587 16.5323C11.4369 16.5349 11.4145 16.5381 11.3928 16.54C11.371 16.5413 11.348 16.5406 11.3262 16.5413C11.4069 16.6731 11.4849 16.8043 11.5592 16.94C11.5694 16.9381 11.5797 16.9362 11.5912 16.9349C11.6014 16.9342 11.6123 16.9355 11.6232 16.9362ZM12.2094 16.627C12.219 16.6072 12.2293 16.5886 12.2401 16.5701C12.2248 16.556 12.1787 16.5349 12.1243 16.5298C12.0097 16.5182 11.9445 16.5688 11.9368 16.6379C11.9201 16.7826 12.1486 16.7704 12.1377 16.8664C12.1333 16.9074 12.0897 16.924 12.043 16.9195C11.9912 16.9144 11.9528 16.8856 11.9464 16.8434L11.9323 16.8421C11.9246 16.867 11.9137 16.8914 11.9016 16.9157C11.9355 16.9374 11.979 16.9496 12.02 16.9534C12.1371 16.9656 12.2261 16.9189 12.2344 16.8421C12.2491 16.7045 12.0187 16.6968 12.0277 16.6155C12.0315 16.5816 12.0577 16.5592 12.1173 16.565C12.1601 16.5694 12.1864 16.5925 12.1979 16.6258L12.2094 16.627ZM19.8625 16.9586C19.9022 16.8094 19.9528 16.6654 20.0027 16.5189C19.9918 16.5221 19.9803 16.5246 19.9688 16.5259C19.9579 16.5278 19.9457 16.5285 19.9342 16.5291C19.9105 16.6341 19.8779 16.7397 19.8433 16.8453C19.7819 16.7531 19.7153 16.6635 19.6622 16.5701C19.6405 16.5746 19.6187 16.5797 19.5969 16.5829C19.5752 16.5861 19.5528 16.5874 19.5304 16.5899C19.6232 16.7141 19.7128 16.8389 19.7992 16.9682C19.8094 16.9656 19.8197 16.9618 19.8312 16.9605C19.8414 16.9592 19.8523 16.9592 19.8625 16.9586ZM20.2581 16.5221C20.2395 16.5227 20.2203 16.5246 20.2017 16.524C20.1825 16.524 20.1633 16.5214 20.1448 16.5202L20.1371 16.9304L20.4245 16.9355C20.4225 16.9272 20.4206 16.9176 20.4206 16.9093C20.4206 16.901 20.4232 16.892 20.4251 16.8837C20.3733 16.8869 20.3176 16.8901 20.2517 16.8888L20.2581 16.5221ZM20.7086 16.5893C20.7547 16.5931 20.7989 16.6014 20.843 16.6091C20.8424 16.6008 20.8411 16.5918 20.8417 16.5829C20.8424 16.5746 20.8456 16.5662 20.8481 16.5579L20.4597 16.5259C20.4603 16.5349 20.4616 16.5432 20.4609 16.5515C20.4603 16.5605 20.4571 16.5688 20.4545 16.5771C20.4942 16.5758 20.5422 16.5758 20.596 16.5803L20.5621 16.9496C20.5806 16.9496 20.5998 16.9496 20.6184 16.9515C20.6376 16.9528 20.6561 16.956 20.6747 16.9586L20.7086 16.5893ZM20.868 16.9938C20.8865 16.997 20.9057 16.9995 20.9243 17.0034C20.9422 17.0072 20.9608 17.013 20.9787 17.0181L21.0248 16.8299L21.0299 16.8306C21.0401 16.8568 21.0542 16.8882 21.0613 16.9067L21.1189 17.0488C21.1419 17.0526 21.1643 17.0558 21.1861 17.0603C21.2091 17.0654 21.2309 17.0718 21.2526 17.0782L21.2328 17.0354C21.2021 16.9714 21.1694 16.9067 21.1425 16.8421C21.2142 16.8446 21.2693 16.819 21.2833 16.7614C21.2929 16.7218 21.2769 16.6904 21.2398 16.6635C21.2117 16.6437 21.1579 16.6334 21.1227 16.6251L20.9665 16.5912L20.868 16.9938ZM21.0689 16.6469C21.1144 16.6571 21.1707 16.6642 21.1707 16.7154C21.1701 16.7288 21.1688 16.7378 21.1669 16.7461C21.1521 16.8062 21.1067 16.8267 21.0305 16.8043L21.0689 16.6469ZM21.6078 17.1173C21.6046 17.1614 21.5963 17.205 21.588 17.2517C21.6072 17.2606 21.627 17.269 21.6456 17.2798C21.6648 17.2901 21.6821 17.3016 21.7006 17.3131L21.739 16.8504C21.7301 16.8466 21.7217 16.8427 21.7128 16.8382C21.7045 16.8338 21.6968 16.8286 21.6891 16.8229L21.2808 17.0821C21.2917 17.0872 21.3032 17.0923 21.3134 17.0981C21.3243 17.1038 21.3333 17.1102 21.3435 17.116C21.3781 17.0872 21.4139 17.0635 21.4549 17.0328L21.6078 17.1166V17.1173ZM21.492 17.011L21.6283 16.9234L21.6123 17.077L21.492 17.011Z"
        fill="#C8B100"
      />
      <path
        d="M15.9809 11.6943C16.4058 11.6943 16.7847 11.7577 17.0311 11.855C17.1719 11.919 17.3614 11.9657 17.5687 11.9939C17.7268 12.015 17.8766 12.0188 18.0071 12.0092C18.1818 12.0054 18.434 12.0566 18.6868 12.1679C18.8954 12.2607 19.0702 12.3734 19.186 12.4822L19.0855 12.5718L19.0567 12.8252L18.7815 13.1401L18.6439 13.2572L18.3182 13.5177L18.1518 13.5311L18.1012 13.6751L15.995 13.4281L13.8817 13.6751L13.8311 13.5311L13.6641 13.5177L13.339 13.2572L13.2014 13.1401L12.9262 12.8252L12.898 12.5718L12.7969 12.4822C12.9134 12.3734 13.0874 12.2607 13.2961 12.1679C13.5489 12.0566 13.801 12.0054 13.9758 12.0092C14.1063 12.0188 14.2561 12.015 14.4142 11.9939C14.6215 11.9657 14.811 11.919 14.9518 11.855C15.1988 11.7577 15.5559 11.6943 15.9809 11.6943Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M14.4273 12.2507L14.5156 12.3217L14.6487 12.1041C14.5047 12.0158 14.4055 11.8622 14.4055 11.6875C14.4055 11.6676 14.4068 11.6484 14.4094 11.6292C14.4228 11.3515 14.7614 11.1224 15.1902 11.1224C15.4129 11.1224 15.6145 11.1832 15.7559 11.2811C15.7598 11.2382 15.7636 11.2011 15.7694 11.162C15.6139 11.0712 15.411 11.0161 15.1902 11.0161C14.6967 11.0161 14.3108 11.2971 14.2923 11.6286C14.2903 11.6484 14.2891 11.6676 14.2891 11.6875C14.2891 11.8641 14.3697 12.0241 14.4977 12.1348L14.4273 12.2507Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.4295 12.2533C14.2612 12.1273 14.1562 11.9564 14.1562 11.7682C14.1562 11.5519 14.2983 11.3586 14.5134 11.23C14.3809 11.3369 14.3002 11.4751 14.2887 11.6287C14.2868 11.6485 14.2855 11.6677 14.2855 11.6876C14.2855 11.8642 14.3662 12.0242 14.4942 12.1349L14.4295 12.2533Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.9492 12.4732C12.8545 12.3676 12.7969 12.2306 12.7969 12.0815C12.7969 11.9913 12.818 11.9055 12.8551 11.8287C12.9914 11.5484 13.4196 11.3442 13.9278 11.3442C14.066 11.3442 14.1985 11.359 14.3207 11.3871C14.2938 11.4166 14.2727 11.4492 14.2516 11.4818C14.1498 11.462 14.041 11.4511 13.9278 11.4511C13.4625 11.4511 13.0727 11.6322 12.9601 11.8767C12.9292 11.9406 12.9132 12.0106 12.9134 12.0815C12.9134 12.23 12.9831 12.3631 13.0919 12.454L12.9236 12.7292L12.8334 12.6575L12.9492 12.4732Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.1169 11.5509C12.9947 11.6283 12.9019 11.723 12.8507 11.8286C12.8136 11.9054 12.7925 11.9912 12.7925 12.0814C12.7925 12.2305 12.8501 12.3675 12.9448 12.4731L12.8424 12.6389C12.7445 12.5134 12.6875 12.3662 12.6875 12.2101C12.6875 11.9413 12.8584 11.7064 13.1169 11.5509ZM16.0059 10.9614C16.1185 10.9614 16.2158 11.0357 16.2389 11.1361C16.2536 11.2245 16.2632 11.3249 16.2651 11.4318C16.2657 11.4433 16.2645 11.4542 16.2645 11.4651C16.2645 11.4779 16.267 11.4913 16.2677 11.5041C16.2715 11.7294 16.3035 11.9278 16.3489 12.0494L16.0059 12.3784L15.6584 12.0494C15.7045 11.9278 15.7365 11.7294 15.7409 11.5041C15.7409 11.4913 15.7435 11.4779 15.7435 11.4651C15.7435 11.4542 15.7429 11.4433 15.7429 11.4318C15.7448 11.3249 15.7544 11.2245 15.7691 11.1361C15.7921 11.0357 15.8933 10.9614 16.0059 10.9614Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0097 11.068C16.068 11.068 16.1173 11.1051 16.1294 11.1569C16.1441 11.2408 16.1531 11.3361 16.155 11.4372C16.155 11.4475 16.1544 11.4577 16.1544 11.468C16.1544 11.4808 16.1563 11.4929 16.1569 11.5057C16.1601 11.7182 16.1909 11.9057 16.2344 12.0209L16.0078 12.2353L15.7812 12.0209C15.8241 11.9057 15.8548 11.7182 15.8587 11.5057C15.8587 11.4929 15.8612 11.4808 15.8612 11.468C15.8612 11.4577 15.8606 11.4475 15.8606 11.4372C15.8625 11.3361 15.8715 11.2408 15.8862 11.1569C15.8977 11.1051 15.9515 11.068 16.0097 11.068ZM17.588 12.2507L17.499 12.3217L17.3659 12.1041C17.5105 12.0158 17.6097 11.8622 17.6097 11.6875C17.6097 11.6676 17.6085 11.6484 17.6059 11.6292C17.5925 11.3515 17.2539 11.1224 16.8251 11.1224C16.6017 11.1224 16.4008 11.1832 16.2593 11.2811C16.2555 11.2382 16.2516 11.2011 16.2452 11.162C16.4014 11.0712 16.6036 11.0161 16.8251 11.0161C17.3185 11.0161 17.7044 11.2971 17.723 11.6286C17.7249 11.6484 17.7262 11.6676 17.7262 11.6875C17.7262 11.8641 17.6449 12.0241 17.5169 12.1348L17.588 12.2507Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.576 12.2533C17.7443 12.1273 17.8493 11.9564 17.8493 11.7682C17.8493 11.5519 17.7072 11.3586 17.4922 11.23C17.6247 11.3369 17.7053 11.4751 17.7168 11.6287C17.7187 11.6485 17.72 11.6677 17.72 11.6876C17.72 11.8642 17.6387 12.0242 17.5107 12.1349L17.576 12.2533Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.0675 12.4732C19.1616 12.3676 19.2198 12.2306 19.2198 12.0815C19.2198 11.9913 19.1987 11.9055 19.1616 11.8287C19.0246 11.5484 18.5971 11.3442 18.0889 11.3442C17.9507 11.3442 17.8182 11.359 17.6953 11.3871C17.7228 11.4166 17.744 11.4492 17.7651 11.4818C17.8662 11.462 17.9756 11.4511 18.0889 11.4511C18.5542 11.4511 18.9433 11.6322 19.056 11.8767C19.086 11.9388 19.1027 12.0086 19.1027 12.0815C19.1027 12.23 19.0329 12.3631 18.9241 12.454L19.0924 12.7292L19.1833 12.6575L19.0675 12.4732Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.8906 11.5508C19.0129 11.6282 19.1057 11.7229 19.1569 11.8285C19.194 11.9053 19.2151 11.9911 19.2151 12.0813C19.2151 12.2305 19.1569 12.3674 19.0628 12.473L19.1652 12.6388C19.2631 12.5133 19.3194 12.3661 19.3194 12.21C19.3194 11.9412 19.1485 11.7063 18.8906 11.5508Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0101 10.9761C16.1667 10.9761 16.2936 10.8557 16.2936 10.7073C16.2936 10.5588 16.1667 10.4385 16.0101 10.4385C15.8535 10.4385 15.7266 10.5588 15.7266 10.7073C15.7266 10.8557 15.8535 10.9761 16.0101 10.9761Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M15.9358 9.95459V10.0992H15.781V10.2464H15.9358V10.6695H15.7406C15.7387 10.6829 15.7266 10.6932 15.7266 10.7072C15.7266 10.7444 15.7342 10.7802 15.749 10.8122C15.749 10.8135 15.7502 10.8135 15.7509 10.8141H16.2706C16.2706 10.8135 16.2718 10.8135 16.2725 10.8122C16.2866 10.7802 16.2949 10.7444 16.2949 10.7072C16.2949 10.6932 16.2827 10.6829 16.2808 10.6695H16.0914V10.2464H16.2462V10.0992H16.0914V9.95459H15.9358Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M16.0051 12.2075C16.0726 12.2075 16.1273 12.1559 16.1273 12.0923C16.1273 12.0286 16.0726 11.9771 16.0051 11.9771C15.9375 11.9771 15.8828 12.0286 15.8828 12.0923C15.8828 12.1559 15.9375 12.2075 16.0051 12.2075Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0051 11.9809C16.0726 11.9809 16.1273 11.9293 16.1273 11.8657C16.1273 11.8021 16.0726 11.7505 16.0051 11.7505C15.9375 11.7505 15.8828 11.8021 15.8828 11.8657C15.8828 11.9293 15.9375 11.9809 16.0051 11.9809Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0035 11.7146C16.0573 11.7146 16.1008 11.6733 16.1008 11.6224C16.1008 11.5715 16.0573 11.5303 16.0035 11.5303C15.9498 11.5303 15.9062 11.5715 15.9062 11.6224C15.9062 11.6733 15.9498 11.7146 16.0035 11.7146Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0001 11.47C16.039 11.47 16.0705 11.4402 16.0705 11.4035C16.0705 11.3667 16.039 11.3369 16.0001 11.3369C15.9612 11.3369 15.9297 11.3667 15.9297 11.4035C15.9297 11.4402 15.9612 11.47 16.0001 11.47Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0016 11.2644C16.0327 11.2644 16.058 11.2407 16.058 11.2113C16.058 11.182 16.0327 11.1582 16.0016 11.1582C15.9705 11.1582 15.9453 11.182 15.9453 11.2113C15.9453 11.2407 15.9705 11.2644 16.0016 11.2644Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.7345 12.7816C12.7733 12.7816 12.8049 12.7518 12.8049 12.715C12.8049 12.6782 12.7733 12.6484 12.7345 12.6484C12.6956 12.6484 12.6641 12.6782 12.6641 12.715C12.6641 12.7518 12.6956 12.7816 12.7345 12.7816Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.6329 12.6116C12.6718 12.6116 12.7033 12.5818 12.7033 12.5451C12.7033 12.5083 12.6718 12.4785 12.6329 12.4785C12.594 12.4785 12.5625 12.5083 12.5625 12.5451C12.5625 12.5818 12.594 12.6116 12.6329 12.6116Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.5704 12.4149C12.6093 12.4149 12.6408 12.3851 12.6408 12.3483C12.6408 12.3115 12.6093 12.2817 12.5704 12.2817C12.5315 12.2817 12.5 12.3115 12.5 12.3483C12.5 12.3851 12.5315 12.4149 12.5704 12.4149Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.5626 12.2034C12.6015 12.2034 12.633 12.1736 12.633 12.1369C12.633 12.1001 12.6015 12.0703 12.5626 12.0703C12.5237 12.0703 12.4922 12.1001 12.4922 12.1369C12.4922 12.1736 12.5237 12.2034 12.5626 12.2034Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.6173 11.9959C12.6562 11.9959 12.6877 11.9661 12.6877 11.9294C12.6877 11.8926 12.6562 11.8628 12.6173 11.8628C12.5784 11.8628 12.5469 11.8926 12.5469 11.9294C12.5469 11.9661 12.5784 11.9959 12.6173 11.9959Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.7266 11.8074C12.7655 11.8074 12.797 11.7776 12.797 11.7409C12.797 11.7041 12.7655 11.6743 12.7266 11.6743C12.6878 11.6743 12.6562 11.7041 12.6562 11.7409C12.6562 11.7776 12.6878 11.8074 12.7266 11.8074Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M12.8673 11.6517C12.9062 11.6517 12.9377 11.6219 12.9377 11.5851C12.9377 11.5484 12.9062 11.5186 12.8673 11.5186C12.8284 11.5186 12.7969 11.5484 12.7969 11.5851C12.7969 11.6219 12.8284 11.6517 12.8673 11.6517Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.0391 11.5233C13.078 11.5233 13.1095 11.4935 13.1095 11.4567C13.1095 11.4199 13.078 11.3901 13.0391 11.3901C13.0003 11.3901 12.9688 11.4199 12.9688 11.4567C12.9688 11.4935 13.0003 11.5233 13.0391 11.5233Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.2345 11.4178C13.2733 11.4178 13.3049 11.388 13.3049 11.3512C13.3049 11.3145 13.2733 11.2847 13.2345 11.2847C13.1956 11.2847 13.1641 11.3145 13.1641 11.3512C13.1641 11.388 13.1956 11.4178 13.2345 11.4178Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.4454 11.3426C13.4843 11.3426 13.5158 11.3128 13.5158 11.276C13.5158 11.2393 13.4843 11.2095 13.4454 11.2095C13.4065 11.2095 13.375 11.2393 13.375 11.276C13.375 11.3128 13.4065 11.3426 13.4454 11.3426Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.672 11.3011C13.7108 11.3011 13.7424 11.2713 13.7424 11.2345C13.7424 11.1978 13.7108 11.168 13.672 11.168C13.6331 11.168 13.6016 11.1978 13.6016 11.2345C13.6016 11.2713 13.6331 11.3011 13.672 11.3011Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.8907 11.2894C13.9296 11.2894 13.9611 11.2596 13.9611 11.2228C13.9611 11.186 13.9296 11.1562 13.8907 11.1562C13.8518 11.1562 13.8203 11.186 13.8203 11.2228C13.8203 11.2596 13.8518 11.2894 13.8907 11.2894Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.1095 11.2972C14.1483 11.2972 14.1799 11.2674 14.1799 11.2306C14.1799 11.1939 14.1483 11.1641 14.1095 11.1641C14.0706 11.1641 14.0391 11.1939 14.0391 11.2306C14.0391 11.2674 14.0706 11.2972 14.1095 11.2972Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.3517 12.2469C14.3905 12.2469 14.422 12.2171 14.422 12.1803C14.422 12.1436 14.3905 12.1138 14.3517 12.1138C14.3128 12.1138 14.2812 12.1436 14.2812 12.1803C14.2812 12.2171 14.3128 12.2469 14.3517 12.2469Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.2266 12.076C14.2655 12.076 14.297 12.0462 14.297 12.0094C14.297 11.9727 14.2655 11.9429 14.2266 11.9429C14.1878 11.9429 14.1562 11.9727 14.1562 12.0094C14.1562 12.0462 14.1878 12.076 14.2266 12.076Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.1642 11.8904C14.203 11.8904 14.2345 11.8606 14.2345 11.8239C14.2345 11.7871 14.203 11.7573 14.1642 11.7573C14.1253 11.7573 14.0938 11.7871 14.0938 11.8239C14.0938 11.8606 14.1253 11.8904 14.1642 11.8904Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.172 11.6868C14.2108 11.6868 14.2424 11.657 14.2424 11.6203C14.2424 11.5835 14.2108 11.5537 14.172 11.5537C14.1331 11.5537 14.1016 11.5835 14.1016 11.6203C14.1016 11.657 14.1331 11.6868 14.172 11.6868Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.2188 11.4822C14.2577 11.4822 14.2892 11.4524 14.2892 11.4157C14.2892 11.3789 14.2577 11.3491 14.2188 11.3491C14.18 11.3491 14.1484 11.3789 14.1484 11.4157C14.1484 11.4524 14.18 11.4822 14.2188 11.4822Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.3282 11.2972C14.3671 11.2972 14.3986 11.2674 14.3986 11.2306C14.3986 11.1939 14.3671 11.1641 14.3282 11.1641C14.2893 11.1641 14.2578 11.1939 14.2578 11.2306C14.2578 11.2674 14.2893 11.2972 14.3282 11.2972Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.4923 11.1688C14.5312 11.1688 14.5627 11.139 14.5627 11.1022C14.5627 11.0654 14.5312 11.0356 14.4923 11.0356C14.4534 11.0356 14.4219 11.0654 14.4219 11.1022C14.4219 11.139 14.4534 11.1688 14.4923 11.1688Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.6798 11.0623C14.7187 11.0623 14.7502 11.0325 14.7502 10.9958C14.7502 10.959 14.7187 10.9292 14.6798 10.9292C14.6409 10.9292 14.6094 10.959 14.6094 10.9958C14.6094 11.0325 14.6409 11.0623 14.6798 11.0623Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.8907 10.9988C14.9296 10.9988 14.9611 10.969 14.9611 10.9323C14.9611 10.8955 14.9296 10.8657 14.8907 10.8657C14.8518 10.8657 14.8203 10.8955 14.8203 10.9323C14.8203 10.969 14.8518 10.9988 14.8907 10.9988Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M15.1095 10.9612C15.1483 10.9612 15.1799 10.9314 15.1799 10.8947C15.1799 10.8579 15.1483 10.8281 15.1095 10.8281C15.0706 10.8281 15.0391 10.8579 15.0391 10.8947C15.0391 10.9314 15.0706 10.9612 15.1095 10.9612Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M15.3282 10.9647C15.3671 10.9647 15.3986 10.9349 15.3986 10.8981C15.3986 10.8613 15.3671 10.8315 15.3282 10.8315C15.2893 10.8315 15.2578 10.8613 15.2578 10.8981C15.2578 10.9349 15.2893 10.9647 15.3282 10.9647Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M15.5548 11.0023C15.5937 11.0023 15.6252 10.9725 15.6252 10.9357C15.6252 10.8989 15.5937 10.8691 15.5548 10.8691C15.5159 10.8691 15.4844 10.8989 15.4844 10.9357C15.4844 10.9725 15.5159 11.0023 15.5548 11.0023Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M15.7579 11.074C15.7968 11.074 15.8283 11.0442 15.8283 11.0075C15.8283 10.9707 15.7968 10.9409 15.7579 10.9409C15.719 10.9409 15.6875 10.9707 15.6875 11.0075C15.6875 11.0442 15.719 11.074 15.7579 11.074Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.2423 11.074C16.2812 11.074 16.3127 11.0442 16.3127 11.0075C16.3127 10.9707 16.2812 10.9409 16.2423 10.9409C16.2034 10.9409 16.1719 10.9707 16.1719 11.0075C16.1719 11.0442 16.2034 11.074 16.2423 11.074Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.4532 11.0023C16.4921 11.0023 16.5236 10.9725 16.5236 10.9357C16.5236 10.8989 16.4921 10.8691 16.4532 10.8691C16.4143 10.8691 16.3828 10.8989 16.3828 10.9357C16.3828 10.9725 16.4143 11.0023 16.4532 11.0023Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.672 10.9647C16.7108 10.9647 16.7424 10.9349 16.7424 10.8981C16.7424 10.8613 16.7108 10.8315 16.672 10.8315C16.6331 10.8315 16.6016 10.8613 16.6016 10.8981C16.6016 10.9349 16.6331 10.9647 16.672 10.9647Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.8907 10.9612C16.9296 10.9612 16.9611 10.9314 16.9611 10.8947C16.9611 10.8579 16.9296 10.8281 16.8907 10.8281C16.8518 10.8281 16.8203 10.8579 16.8203 10.8947C16.8203 10.9314 16.8518 10.9612 16.8907 10.9612Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.1095 10.9988C17.1483 10.9988 17.1799 10.969 17.1799 10.9323C17.1799 10.8955 17.1483 10.8657 17.1095 10.8657C17.0706 10.8657 17.0391 10.8955 17.0391 10.9323C17.0391 10.969 17.0706 10.9988 17.1095 10.9988Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.3204 11.0623C17.3593 11.0623 17.3908 11.0325 17.3908 10.9958C17.3908 10.959 17.3593 10.9292 17.3204 10.9292C17.2815 10.9292 17.25 10.959 17.25 10.9958C17.25 11.0325 17.2815 11.0623 17.3204 11.0623Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.5157 11.1688C17.5546 11.1688 17.5861 11.139 17.5861 11.1022C17.5861 11.0654 17.5546 11.0356 17.5157 11.0356C17.4768 11.0356 17.4453 11.0654 17.4453 11.1022C17.4453 11.139 17.4768 11.1688 17.5157 11.1688Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.6798 11.2972C17.7187 11.2972 17.7502 11.2674 17.7502 11.2306C17.7502 11.1939 17.7187 11.1641 17.6798 11.1641C17.6409 11.1641 17.6094 11.1939 17.6094 11.2306C17.6094 11.2674 17.6409 11.2972 17.6798 11.2972Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.7813 11.4822C17.8202 11.4822 17.8517 11.4524 17.8517 11.4157C17.8517 11.3789 17.8202 11.3491 17.7813 11.3491C17.7425 11.3491 17.7109 11.3789 17.7109 11.4157C17.7109 11.4524 17.7425 11.4822 17.7813 11.4822Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.8282 11.6868C17.8671 11.6868 17.8986 11.657 17.8986 11.6203C17.8986 11.5835 17.8671 11.5537 17.8282 11.5537C17.7893 11.5537 17.7578 11.5835 17.7578 11.6203C17.7578 11.657 17.7893 11.6868 17.8282 11.6868Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.836 11.8904C17.8749 11.8904 17.9064 11.8606 17.9064 11.8239C17.9064 11.7871 17.8749 11.7573 17.836 11.7573C17.7971 11.7573 17.7656 11.7871 17.7656 11.8239C17.7656 11.8606 17.7971 11.8904 17.836 11.8904Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.7735 12.076C17.8124 12.076 17.8439 12.0462 17.8439 12.0094C17.8439 11.9727 17.8124 11.9429 17.7735 11.9429C17.7346 11.9429 17.7031 11.9727 17.7031 12.0094C17.7031 12.0462 17.7346 12.076 17.7735 12.076Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.6563 12.2469C17.6952 12.2469 17.7267 12.2171 17.7267 12.1803C17.7267 12.1436 17.6952 12.1138 17.6563 12.1138C17.6175 12.1138 17.5859 12.1436 17.5859 12.1803C17.5859 12.2171 17.6175 12.2469 17.6563 12.2469Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.8907 11.2972C17.9296 11.2972 17.9611 11.2674 17.9611 11.2306C17.9611 11.1939 17.9296 11.1641 17.8907 11.1641C17.8518 11.1641 17.8203 11.1939 17.8203 11.2306C17.8203 11.2674 17.8518 11.2972 17.8907 11.2972Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.1095 11.2894C18.1483 11.2894 18.1799 11.2596 18.1799 11.2228C18.1799 11.186 18.1483 11.1562 18.1095 11.1562C18.0706 11.1562 18.0391 11.186 18.0391 11.2228C18.0391 11.2596 18.0706 11.2894 18.1095 11.2894Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.3282 11.3011C18.3671 11.3011 18.3986 11.2713 18.3986 11.2345C18.3986 11.1978 18.3671 11.168 18.3282 11.168C18.2893 11.168 18.2578 11.1978 18.2578 11.2345C18.2578 11.2713 18.2893 11.3011 18.3282 11.3011Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.5626 11.3426C18.6015 11.3426 18.633 11.3128 18.633 11.276C18.633 11.2393 18.6015 11.2095 18.5626 11.2095C18.5237 11.2095 18.4922 11.2393 18.4922 11.276C18.4922 11.3128 18.5237 11.3426 18.5626 11.3426Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.7657 11.4178C18.8046 11.4178 18.8361 11.388 18.8361 11.3512C18.8361 11.3145 18.8046 11.2847 18.7657 11.2847C18.7268 11.2847 18.6953 11.3145 18.6953 11.3512C18.6953 11.388 18.7268 11.4178 18.7657 11.4178Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.9688 11.5233C19.0077 11.5233 19.0392 11.4935 19.0392 11.4567C19.0392 11.4199 19.0077 11.3901 18.9688 11.3901C18.93 11.3901 18.8984 11.4199 18.8984 11.4567C18.8984 11.4935 18.93 11.5233 18.9688 11.5233Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.1329 11.6517C19.1718 11.6517 19.2033 11.6219 19.2033 11.5851C19.2033 11.5484 19.1718 11.5186 19.1329 11.5186C19.094 11.5186 19.0625 11.5484 19.0625 11.5851C19.0625 11.6219 19.094 11.6517 19.1329 11.6517Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.2813 11.8074C19.3202 11.8074 19.3517 11.7776 19.3517 11.7409C19.3517 11.7041 19.3202 11.6743 19.2813 11.6743C19.2425 11.6743 19.2109 11.7041 19.2109 11.7409C19.2109 11.7776 19.2425 11.8074 19.2813 11.8074Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.3829 11.9959C19.4218 11.9959 19.4533 11.9661 19.4533 11.9294C19.4533 11.8926 19.4218 11.8628 19.3829 11.8628C19.344 11.8628 19.3125 11.8926 19.3125 11.9294C19.3125 11.9661 19.344 11.9959 19.3829 11.9959Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.4376 12.2034C19.4765 12.2034 19.508 12.1736 19.508 12.1369C19.508 12.1001 19.4765 12.0703 19.4376 12.0703C19.3987 12.0703 19.3672 12.1001 19.3672 12.1369C19.3672 12.1736 19.3987 12.2034 19.4376 12.2034Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.4298 12.4149C19.4687 12.4149 19.5002 12.3851 19.5002 12.3483C19.5002 12.3115 19.4687 12.2817 19.4298 12.2817C19.3909 12.2817 19.3594 12.3115 19.3594 12.3483C19.3594 12.3851 19.3909 12.4149 19.4298 12.4149Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.3673 12.6116C19.4062 12.6116 19.4377 12.5818 19.4377 12.5451C19.4377 12.5083 19.4062 12.4785 19.3673 12.4785C19.3284 12.4785 19.2969 12.5083 19.2969 12.5451C19.2969 12.5818 19.3284 12.6116 19.3673 12.6116Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M19.2735 12.7816C19.3124 12.7816 19.3439 12.7518 19.3439 12.715C19.3439 12.6782 19.3124 12.6484 19.2735 12.6484C19.2346 12.6484 19.2031 12.6782 19.2031 12.715C19.2031 12.7518 19.2346 12.7816 19.2735 12.7816Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0124 14.4757C15.2278 14.4744 14.5244 14.3816 14.0226 14.2306C13.9862 14.219 13.967 14.1858 13.9689 14.1506C13.9682 14.1173 13.9874 14.0866 14.0226 14.0757C14.5244 13.9246 15.2278 13.8318 16.0124 13.8306C16.7977 13.8318 17.5004 13.9246 18.0022 14.0757C18.0374 14.0866 18.0559 14.1173 18.0553 14.1506C18.0572 14.1858 18.038 14.219 18.0022 14.2306C17.5004 14.3816 16.7977 14.4744 16.0124 14.4757Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0034 13.8297C15.2091 13.8316 14.4962 13.9308 13.9944 14.0857C14.036 14.0659 14.0322 14.014 13.9803 13.8809C13.9176 13.719 13.8203 13.726 13.8203 13.726C14.3746 13.5622 15.147 13.4598 16.0066 13.4585C16.8667 13.4598 17.645 13.5622 18.1998 13.726C18.1998 13.726 18.1019 13.719 18.0392 13.8809C17.9874 14.014 17.9835 14.0659 18.0258 14.0857C17.524 13.9308 16.7976 13.8316 16.0034 13.8297Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0047 13.4594C15.1452 13.4607 14.3727 13.5631 13.8185 13.7269C13.7813 13.7378 13.7423 13.7237 13.7301 13.6885C13.718 13.6533 13.7378 13.613 13.7749 13.6021C14.3324 13.4312 15.1241 13.3237 16.0047 13.3218C16.886 13.3237 17.6809 13.4312 18.2383 13.6021C18.2754 13.613 18.2953 13.6533 18.2831 13.6885C18.2709 13.7237 18.2319 13.7378 18.1948 13.7269C17.6399 13.5631 16.8649 13.4607 16.0047 13.4594Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.014 12.7861L16.0928 12.8002C16.0806 12.8322 16.0774 12.8674 16.0774 12.9045C16.0774 13.069 16.2188 13.2021 16.3923 13.2021C16.5318 13.2021 16.6508 13.1157 16.6912 12.9967C16.6963 12.9999 16.7212 12.8892 16.7347 12.8905C16.7456 12.8917 16.7443 13.0057 16.7488 13.0037C16.7686 13.1535 16.9062 13.2553 17.0604 13.2553C17.2339 13.2553 17.3747 13.1221 17.3747 12.9577C17.3747 12.9455 17.3741 12.9333 17.3721 12.9212L17.4707 12.8239L17.5238 12.9481C17.5027 12.9871 17.4944 13.0313 17.4944 13.078C17.4944 13.2354 17.6288 13.3621 17.7945 13.3621C17.8988 13.3621 17.9904 13.3122 18.0441 13.2361L18.1075 13.1561L18.1068 13.254C18.1068 13.3532 18.1491 13.4415 18.2451 13.4575C18.2451 13.4575 18.3558 13.4639 18.503 13.3487C18.6496 13.2335 18.7302 13.1381 18.7302 13.1381L18.743 13.2533C18.743 13.2533 18.6214 13.4421 18.4889 13.5189C18.416 13.5612 18.3059 13.6053 18.2182 13.5913C18.1261 13.5759 18.0595 13.5017 18.0256 13.4159C17.9597 13.4549 17.8816 13.478 17.7984 13.478C17.6185 13.478 17.4573 13.3794 17.3939 13.2309C17.3113 13.3205 17.1961 13.3749 17.0611 13.3749C16.9177 13.3749 16.7865 13.3103 16.7046 13.2111C16.6192 13.2887 16.5077 13.3314 16.3923 13.3308C16.2336 13.3308 16.0921 13.2527 16.0121 13.1356C15.9321 13.2527 15.7907 13.3308 15.632 13.3308C15.511 13.3308 15.4009 13.2853 15.3203 13.2111C15.2384 13.3103 15.1065 13.3749 14.9632 13.3749C14.8281 13.3749 14.7136 13.3205 14.631 13.2309C14.567 13.3794 14.4057 13.478 14.2265 13.478C14.1427 13.478 14.0653 13.4549 13.9993 13.4159C13.9648 13.5017 13.8988 13.5759 13.806 13.5913C13.719 13.6053 13.6089 13.5612 13.536 13.5189C13.4028 13.4421 13.2812 13.2533 13.2812 13.2533L13.294 13.1381C13.294 13.1381 13.3753 13.2335 13.5219 13.3487C13.6684 13.4645 13.7792 13.4575 13.7792 13.4575C13.8758 13.4415 13.9174 13.3532 13.9174 13.254L13.9168 13.1561L13.9801 13.2361C14.0339 13.3122 14.1261 13.3621 14.2297 13.3621C14.3955 13.3621 14.5299 13.2354 14.5299 13.078C14.5299 13.0313 14.5216 12.9871 14.5005 12.9481L14.5536 12.8239L14.6521 12.9212C14.6508 12.9333 14.6496 12.9455 14.6496 12.9577C14.6496 13.1221 14.7904 13.2553 14.9638 13.2553C15.1187 13.2553 15.2556 13.1535 15.2761 13.0037C15.28 13.0057 15.2793 12.8917 15.2902 12.8905C15.303 12.8892 15.3286 12.9999 15.3331 12.9967C15.374 13.1157 15.4925 13.2021 15.6326 13.2021C15.8061 13.2021 15.9468 13.069 15.9468 12.9045C15.9468 12.8674 15.9449 12.8322 15.9315 12.8002L16.014 12.7861Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.3356 13.2047C13.3272 13.1781 13.3112 13.1545 13.2895 13.1369C13.239 13.0934 13.1718 13.0863 13.1385 13.1209C13.134 13.1254 13.1302 13.1318 13.1276 13.1369C13.1276 13.1369 13.0566 13.0038 12.9734 12.959C12.8908 12.9142 12.75 12.9257 12.75 12.9257C12.75 12.8233 12.8332 12.7407 12.9414 12.7407C13.0047 12.7407 13.0642 12.767 13.1001 12.8118L13.1148 12.7433C13.1148 12.7433 13.2018 12.7606 13.2415 12.8598C13.2812 12.959 13.2377 13.103 13.2377 13.103C13.2377 13.103 13.2594 13.0415 13.2921 12.9999C13.3247 12.959 13.4079 12.9142 13.4514 12.8937C13.4943 12.8738 13.5391 12.8431 13.5391 12.8431C13.5391 12.8431 13.541 12.8546 13.5423 12.8822C13.5442 12.9148 13.5417 12.9353 13.5417 12.9353C13.621 12.9244 13.7138 12.9378 13.7868 12.966C13.7554 13.0268 13.6966 13.0838 13.6191 13.1132C13.6191 13.1132 13.6473 13.1362 13.6722 13.1612C13.694 13.183 13.7004 13.1926 13.7004 13.1926C13.7004 13.1926 13.646 13.2009 13.6191 13.2047C13.5916 13.2079 13.5014 13.2226 13.447 13.2188C13.4073 13.2162 13.3625 13.2098 13.3356 13.2047Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.1346 13.1205C13.1678 13.086 13.235 13.093 13.2856 13.1365C13.3368 13.1794 13.3509 13.2428 13.3182 13.2767C13.2856 13.3113 13.2178 13.3036 13.1672 13.2607C13.1166 13.2172 13.1019 13.1545 13.1346 13.1205Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.8511 13.1782C13.8332 13.1251 13.8492 13.0726 13.8876 13.0611C13.926 13.0489 13.972 13.0822 13.99 13.1353C14.0079 13.1885 13.9919 13.2409 13.9535 13.2531C13.9151 13.2646 13.8696 13.2313 13.8511 13.1782Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.4677 12.9191C14.4466 12.9018 14.4299 12.8782 14.4248 12.85C14.4197 12.8218 14.4254 12.7943 14.4395 12.7713C14.4395 12.7713 14.3832 12.7431 14.3224 12.7271C14.2763 12.715 14.195 12.7143 14.1707 12.7143C14.1464 12.713 14.0971 12.7124 14.0971 12.7124C14.0971 12.7124 14.1016 12.7233 14.115 12.7476C14.1323 12.777 14.147 12.7956 14.147 12.7956C14.0658 12.8142 13.9966 12.8673 13.9531 12.9294C14.0165 12.9729 14.1003 12.9998 14.1835 12.9914C14.1835 12.9914 14.1758 13.0132 14.1707 13.0465C14.1669 13.074 14.1669 13.0855 14.1669 13.0855C14.1669 13.0855 14.2123 13.0689 14.2354 13.0606C14.2578 13.0522 14.3339 13.0254 14.373 12.9991C14.4242 12.9646 14.4677 12.9191 14.4677 12.9191Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.4458 12.2656C14.5137 12.3085 14.5726 12.3802 14.593 12.4595C14.593 12.4595 14.6014 12.4435 14.6385 12.4218C14.6762 12.4007 14.7082 12.4013 14.7082 12.4013C14.7082 12.4013 14.6974 12.4634 14.6922 12.4858C14.6865 12.5075 14.6865 12.5741 14.6718 12.6343C14.657 12.6938 14.6314 12.7418 14.6314 12.7418C14.6046 12.72 14.5681 12.7091 14.5303 12.7155C14.4932 12.7219 14.4625 12.7437 14.4458 12.7731C14.4458 12.7731 14.4036 12.736 14.3684 12.6848C14.3332 12.633 14.3089 12.5709 14.2961 12.5517C14.2826 12.5325 14.25 12.4781 14.25 12.4781C14.25 12.4781 14.2801 12.4666 14.323 12.4749C14.3658 12.4826 14.3793 12.4954 14.3793 12.4954C14.3703 12.4135 14.3972 12.3277 14.4458 12.2656Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.6519 12.8885C14.6667 12.865 14.6721 12.8369 14.6671 12.8096C14.6622 12.7824 14.6471 12.758 14.625 12.7413C14.625 12.7413 14.6679 12.6958 14.7191 12.6606C14.7575 12.6344 14.8343 12.6081 14.8567 12.5998C14.8797 12.5915 14.9252 12.5742 14.9252 12.5742C14.9252 12.5742 14.9252 12.5857 14.9213 12.6133C14.9162 12.6465 14.9085 12.6689 14.9085 12.6689C14.9917 12.66 15.0762 12.6875 15.1396 12.7317C15.0954 12.7937 15.0263 12.8462 14.945 12.8648C14.945 12.8648 14.9597 12.8827 14.977 12.9121C14.9904 12.9371 14.9949 12.948 14.9949 12.948L14.9213 12.9461C14.897 12.9461 14.8157 12.9454 14.7696 12.9333C14.7088 12.9173 14.6519 12.8891 14.6519 12.8891"
        fill="#C8B100"
      />
      <path
        d="M14.6519 12.8885C14.6667 12.865 14.6721 12.8369 14.6671 12.8096C14.6622 12.7824 14.6471 12.758 14.625 12.7413C14.625 12.7413 14.6679 12.6958 14.7191 12.6606C14.7575 12.6344 14.8343 12.6081 14.8567 12.5998C14.8797 12.5915 14.9252 12.5742 14.9252 12.5742C14.9252 12.5742 14.9252 12.5857 14.9213 12.6133C14.9162 12.6465 14.9085 12.6689 14.9085 12.6689C14.9917 12.66 15.0762 12.6875 15.1396 12.7317C15.0954 12.7937 15.0263 12.8462 14.945 12.8648C14.945 12.8648 14.9597 12.8827 14.977 12.9121C14.9904 12.9371 14.9949 12.948 14.9949 12.948L14.9213 12.9461C14.897 12.9461 14.8157 12.9454 14.7696 12.9333C14.7088 12.9173 14.6519 12.8891 14.6519 12.8891"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.5529 12.9609C14.6296 12.9609 14.6918 12.9019 14.6918 12.8291C14.6918 12.7563 14.6296 12.6973 14.5529 12.6973C14.4762 12.6973 14.4141 12.7563 14.4141 12.8291C14.4141 12.9019 14.4762 12.9609 14.5529 12.9609Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M15.2199 12.9133C15.2128 12.8577 15.2397 12.809 15.2794 12.8045C15.3197 12.8001 15.3581 12.841 15.3652 12.8967C15.3722 12.9517 15.346 13.001 15.3056 13.0055C15.266 13.01 15.2276 12.969 15.2199 12.9133Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M15.9041 12.7893C15.8836 12.7662 15.8702 12.7368 15.8702 12.7041C15.8702 12.6721 15.8824 12.6421 15.9028 12.6197C15.9028 12.6197 15.8459 12.5768 15.7819 12.548C15.7326 12.5256 15.6424 12.5102 15.6155 12.5051L15.5336 12.4897C15.5336 12.4897 15.5361 12.5025 15.5464 12.5326C15.5592 12.5685 15.572 12.5921 15.572 12.5921C15.4779 12.5973 15.3896 12.644 15.3281 12.7048C15.3896 12.7649 15.4779 12.811 15.572 12.8168C15.572 12.8168 15.5592 12.8398 15.5464 12.8763C15.5361 12.9057 15.5336 12.9192 15.5336 12.9192L15.6155 12.9038C15.6424 12.8987 15.7326 12.8833 15.7819 12.8609C15.8459 12.8315 15.9041 12.7899 15.9041 12.7899"
        fill="#C8B100"
      />
      <path
        d="M15.9041 12.7893C15.8836 12.7662 15.8702 12.7368 15.8702 12.7041C15.8702 12.6721 15.8824 12.6421 15.9028 12.6197C15.9028 12.6197 15.8459 12.5768 15.7819 12.548C15.7326 12.5256 15.6424 12.5102 15.6155 12.5051L15.5336 12.4897C15.5336 12.4897 15.5361 12.5025 15.5464 12.5326C15.5592 12.5685 15.572 12.5921 15.572 12.5921C15.4779 12.5973 15.3896 12.644 15.3281 12.7048C15.3896 12.7649 15.4779 12.811 15.572 12.8168C15.572 12.8168 15.5592 12.8398 15.5464 12.8763C15.5361 12.9057 15.5336 12.9192 15.5336 12.9192L15.6155 12.9038C15.6424 12.8987 15.7326 12.8833 15.7819 12.8609C15.8459 12.8315 15.9041 12.7899 15.9041 12.7899"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0039 12.0552C16.0711 12.116 16.1223 12.2062 16.1287 12.2997C16.1287 12.2997 16.1409 12.2824 16.187 12.2657C16.2337 12.2491 16.2689 12.2555 16.2689 12.2555C16.2689 12.2555 16.2439 12.3227 16.2337 12.3464C16.2228 12.3701 16.2087 12.4443 16.1799 12.5083C16.1518 12.5723 16.1127 12.6209 16.1127 12.6209C16.0871 12.5921 16.0487 12.5729 16.0059 12.5729C15.9623 12.5729 15.9246 12.5921 15.899 12.6209C15.899 12.6209 15.8599 12.5723 15.8318 12.5083C15.803 12.4443 15.7889 12.3701 15.778 12.3464C15.7671 12.3227 15.7422 12.2555 15.7422 12.2555C15.7422 12.2555 15.778 12.2491 15.8241 12.2657C15.8702 12.2824 15.883 12.2997 15.883 12.2997C15.8894 12.2062 15.938 12.116 16.0039 12.0552Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.1094 12.7893C16.1305 12.7662 16.1433 12.7368 16.1433 12.7041C16.1433 12.6721 16.1311 12.6421 16.1107 12.6197C16.1107 12.6197 16.1676 12.5768 16.2323 12.548C16.2809 12.5256 16.3711 12.5102 16.3987 12.5051L16.4793 12.4897C16.4793 12.4897 16.478 12.5025 16.4671 12.5326C16.4543 12.5685 16.4415 12.5921 16.4415 12.5921C16.5356 12.5973 16.6246 12.644 16.6854 12.7048C16.6246 12.7649 16.5363 12.811 16.4415 12.8168C16.4415 12.8168 16.4543 12.8398 16.4671 12.8763C16.4774 12.9057 16.4793 12.9192 16.4793 12.9192L16.3987 12.9038C16.3711 12.8987 16.2809 12.8833 16.2323 12.8609C16.1676 12.8315 16.1094 12.7899 16.1094 12.7899"
        fill="#C8B100"
      />
      <path
        d="M16.1094 12.7893C16.1305 12.7662 16.1433 12.7368 16.1433 12.7041C16.1433 12.6721 16.1311 12.6421 16.1107 12.6197C16.1107 12.6197 16.1676 12.5768 16.2323 12.548C16.2809 12.5256 16.3711 12.5102 16.3987 12.5051L16.4793 12.4897C16.4793 12.4897 16.478 12.5025 16.4671 12.5326C16.4543 12.5685 16.4415 12.5921 16.4415 12.5921C16.5356 12.5973 16.6246 12.644 16.6854 12.7048C16.6246 12.7649 16.5363 12.811 16.4415 12.8168C16.4415 12.8168 16.4543 12.8398 16.4671 12.8763C16.4774 12.9057 16.4793 12.9192 16.4793 12.9192L16.3987 12.9038C16.3711 12.8987 16.2809 12.8833 16.2323 12.8609C16.1676 12.8315 16.1094 12.7899 16.1094 12.7899"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0061 12.8359C16.0828 12.8359 16.1449 12.7769 16.1449 12.7041C16.1449 12.6313 16.0828 12.5723 16.0061 12.5723C15.9294 12.5723 15.8672 12.6313 15.8672 12.7041C15.8672 12.7769 15.9294 12.8359 16.0061 12.8359Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.8027 12.9133C16.8097 12.8577 16.7835 12.809 16.7431 12.8045C16.7028 12.8001 16.6644 12.841 16.6574 12.8967C16.6503 12.9517 16.6772 13.001 16.7169 13.0055C16.7572 13.01 16.7956 12.969 16.8027 12.9133Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.3705 12.8885C17.3564 12.8661 17.35 12.8379 17.3545 12.8097C17.3603 12.7816 17.3756 12.7579 17.3974 12.7413C17.3974 12.7413 17.3545 12.6958 17.3033 12.6606C17.2643 12.6344 17.1881 12.6081 17.1651 12.5998C17.1427 12.5915 17.0972 12.5742 17.0972 12.5742C17.0972 12.5742 17.0966 12.5857 17.1011 12.6133C17.1062 12.6465 17.1132 12.6689 17.1132 12.6689C17.0307 12.66 16.9462 12.6875 16.8828 12.7317C16.9263 12.7937 16.9961 12.8462 17.0767 12.8648C17.0767 12.8648 17.062 12.8827 17.0454 12.9121C17.0313 12.9371 17.0275 12.948 17.0275 12.948L17.1004 12.9461C17.1247 12.9461 17.2067 12.9454 17.2521 12.9333C17.3129 12.9173 17.3699 12.8891 17.3699 12.8891"
        fill="#C8B100"
      />
      <path
        d="M17.3705 12.8885C17.3564 12.8661 17.35 12.8379 17.3545 12.8097C17.3603 12.7816 17.3756 12.7579 17.3974 12.7413C17.3974 12.7413 17.3545 12.6958 17.3033 12.6606C17.2643 12.6344 17.1881 12.6081 17.1651 12.5998C17.1427 12.5915 17.0972 12.5742 17.0972 12.5742C17.0972 12.5742 17.0966 12.5857 17.1011 12.6133C17.1062 12.6465 17.1132 12.6689 17.1132 12.6689C17.0307 12.66 16.9462 12.6875 16.8828 12.7317C16.9263 12.7937 16.9961 12.8462 17.0767 12.8648C17.0767 12.8648 17.062 12.8827 17.0454 12.9121C17.0313 12.9371 17.0275 12.948 17.0275 12.948L17.1004 12.9461C17.1247 12.9461 17.2067 12.9454 17.2521 12.9333C17.3129 12.9173 17.3699 12.8891 17.3699 12.8891"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.5755 12.2656C17.5077 12.3085 17.4488 12.3802 17.4277 12.4595C17.4277 12.4595 17.42 12.4435 17.3823 12.4218C17.3451 12.4007 17.3125 12.4013 17.3125 12.4013C17.3125 12.4013 17.3234 12.4634 17.3291 12.4858C17.3349 12.5075 17.3349 12.5741 17.349 12.6343C17.3637 12.6938 17.3899 12.7418 17.3899 12.7418C17.4168 12.72 17.4533 12.7091 17.4904 12.7155C17.5282 12.7219 17.5583 12.7437 17.5755 12.7731C17.5755 12.7731 17.6178 12.736 17.653 12.6848C17.6875 12.633 17.7119 12.5709 17.7247 12.5517C17.7381 12.5325 17.7707 12.4781 17.7707 12.4781C17.7707 12.4781 17.7407 12.4666 17.6978 12.4749C17.6549 12.4826 17.6415 12.4954 17.6415 12.4954C17.6511 12.4135 17.6235 12.3277 17.5755 12.2656Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.5469 12.9191C17.5686 12.9018 17.5853 12.8782 17.5898 12.85C17.5955 12.8218 17.5898 12.7943 17.5757 12.7713C17.5757 12.7713 17.632 12.7431 17.6928 12.7271C17.7389 12.715 17.8202 12.7143 17.8438 12.7143C17.8688 12.713 17.9174 12.7124 17.9174 12.7124C17.9174 12.7124 17.9136 12.7233 17.8995 12.7476C17.8829 12.777 17.8682 12.7956 17.8682 12.7956C17.9488 12.8142 18.0179 12.8673 18.0621 12.9294C17.9987 12.9729 17.9142 12.9998 17.8317 12.9914C17.8317 12.9914 17.8387 13.0132 17.8438 13.0465C17.8477 13.074 17.8477 13.0855 17.8477 13.0855C17.8477 13.0855 17.8022 13.0689 17.7798 13.0606C17.7568 13.0522 17.6806 13.0254 17.6416 12.9991C17.591 12.9646 17.5469 12.9191 17.5469 12.9191Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.467 12.9609C17.5437 12.9609 17.6059 12.9019 17.6059 12.8291C17.6059 12.7563 17.5437 12.6973 17.467 12.6973C17.3903 12.6973 17.3281 12.7563 17.3281 12.8291C17.3281 12.9019 17.3903 12.9609 17.467 12.9609Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.1703 13.1782C18.1882 13.1251 18.1722 13.0726 18.1338 13.0611C18.0954 13.0489 18.0493 13.0822 18.0308 13.1353C18.0128 13.1885 18.0288 13.2409 18.0672 13.2531C18.1056 13.2646 18.1517 13.2313 18.1703 13.1782Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.6849 13.2047C18.692 13.181 18.708 13.1567 18.731 13.1369C18.7816 13.0934 18.8494 13.0863 18.8821 13.1209C18.8865 13.1254 18.891 13.1318 18.8936 13.1369C18.8936 13.1369 18.964 13.0038 19.0472 12.959C19.1304 12.9142 19.2712 12.9257 19.2712 12.9257C19.2712 12.8233 19.1873 12.7407 19.0792 12.7407C19.0158 12.7407 18.9563 12.767 18.9211 12.8118L18.9064 12.7433C18.9064 12.7433 18.8193 12.7606 18.7797 12.8598C18.74 12.959 18.7829 13.103 18.7829 13.103C18.7829 13.103 18.7617 13.0415 18.7291 12.9999C18.6965 12.959 18.6133 12.9142 18.5697 12.8937C18.5262 12.8738 18.4821 12.8431 18.4821 12.8431C18.4821 12.8431 18.4801 12.8546 18.4782 12.8822C18.4769 12.9148 18.4795 12.9353 18.4795 12.9353C18.3995 12.9244 18.3067 12.9378 18.2344 12.966C18.2651 13.0268 18.324 13.0838 18.4014 13.1132C18.4014 13.1132 18.3739 13.1362 18.3483 13.1612C18.3272 13.183 18.3208 13.1926 18.3208 13.1926C18.3208 13.1926 18.3752 13.2009 18.4021 13.2047C18.4296 13.2079 18.5198 13.2226 18.5736 13.2188C18.6139 13.2162 18.6581 13.2098 18.6849 13.2047Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.8807 13.1205C18.8481 13.086 18.7803 13.093 18.7297 13.1365C18.6791 13.1794 18.6644 13.2428 18.6971 13.2767C18.7297 13.3113 18.7975 13.3036 18.8481 13.2607C18.8987 13.2172 18.9134 13.1545 18.8807 13.1205Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0074 14.3723C15.2996 14.3716 14.6589 14.2897 14.1719 14.1636C14.6589 14.0376 15.2996 13.9608 16.0074 13.9595C16.7159 13.9608 17.3597 14.0376 17.8468 14.1636C17.3597 14.2897 16.7159 14.3716 16.0074 14.3723Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
        strokeLinejoin="round"
      />
      <path
        d="M16.5138 14.354V13.9693M16.3205 14.3668L16.323 13.9591M16.1797 14.3719V13.9565"
        stroke="black"
        strokeWidth="0.0032"
      />
      <path d="M15.9453 14.377V13.9565" stroke="black" strokeWidth="0.00896" />
      <path d="M15.8359 14.377V13.9565" stroke="black" strokeWidth="0.01152" />
      <path d="M15.7266 14.377V13.9565" stroke="black" strokeWidth="0.01472" />
      <path d="M15.6328 14.377V13.9565" stroke="black" strokeWidth="0.01792" />
      <path
        d="M15.4479 14.3539L15.4453 13.9718M15.5343 14.359V13.959"
        stroke="black"
        strokeWidth="0.02112"
      />
      <path
        d="M15.2812 14.3365V13.9845M15.3664 14.3467L15.3638 13.9717"
        stroke="black"
        strokeWidth="0.02368"
      />
      <path
        d="M15.0547 14.3167V14.0069M15.1283 14.3218V13.9967M15.2044 14.3321V13.9941"
        stroke="black"
        strokeWidth="0.02688"
      />
      <path d="M14.9766 14.3142V14.0146" stroke="black" strokeWidth="0.02944" />
      <path d="M14.9062 14.2991V14.02" stroke="black" strokeWidth="0.03264" />
      <path d="M14.8281 14.2916V14.0317" stroke="black" strokeWidth="0.03584" />
      <path
        d="M14.6666 14.2688L14.6641 14.0627M14.7492 14.279V14.0474"
        stroke="black"
        strokeWidth="0.0384"
      />
      <path d="M14.5859 14.2516V14.0698" stroke="black" strokeWidth="0.04032" />
      <path d="M14.5078 14.237V14.0859" stroke="black" strokeWidth="0.04352" />
      <path d="M14.4219 14.2161V14.0977" stroke="black" strokeWidth="0.04672" />
      <path d="M14.3359 14.2065V14.1182" stroke="black" strokeWidth="0.04928" />
      <path d="M14.25 14.1864V14.1436" stroke="black" strokeWidth="0.05824" />
      <path
        d="M14.0859 14.186C14.5819 14.0465 15.2565 13.9608 16.0059 13.9595C16.756 13.9608 17.4338 14.0465 17.9298 14.186"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M13.8672 13.8981L13.9453 13.7964L14.1609 13.8239L13.9888 13.9493L13.8672 13.8981Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.3359 13.778C14.3359 13.7409 14.3673 13.7114 14.4063 13.7114C14.4454 13.7114 14.4767 13.7409 14.4767 13.778C14.4767 13.8145 14.4454 13.8445 14.4063 13.8445C14.3673 13.8445 14.3359 13.8145 14.3359 13.778Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M14.9498 13.7645L14.7987 13.7818C14.7597 13.7863 14.7238 13.7607 14.7194 13.7242C14.7142 13.6877 14.7418 13.6544 14.7808 13.6506L14.9325 13.6327L15.0874 13.6148C15.1258 13.6103 15.161 13.6359 15.1654 13.6724C15.1699 13.7088 15.1424 13.7421 15.104 13.7466L14.9498 13.7645Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M15.3906 13.6545C15.3906 13.6173 15.422 13.5879 15.461 13.5879C15.4994 13.5879 15.5314 13.6173 15.5314 13.6545C15.5314 13.6909 15.4994 13.721 15.461 13.721C15.422 13.721 15.3906 13.6909 15.3906 13.6545Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0082 13.7062H15.7976C15.7592 13.7062 15.7266 13.6768 15.7266 13.6403C15.7266 13.6032 15.7579 13.5737 15.797 13.5737H16.2219C16.261 13.5737 16.2923 13.6032 16.2923 13.6403C16.2923 13.6768 16.2597 13.7062 16.2213 13.7062H16.0082Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.4766 13.6545C16.4766 13.6173 16.5086 13.5879 16.547 13.5879C16.586 13.5879 16.6174 13.6173 16.6174 13.6545C16.6174 13.6909 16.586 13.721 16.547 13.721C16.5086 13.721 16.4766 13.6909 16.4766 13.6545Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.06 13.7645L17.2111 13.7818C17.2495 13.7863 17.286 13.7607 17.2904 13.7242C17.2949 13.6877 17.2674 13.6544 17.229 13.6506L17.0773 13.6327L16.9224 13.6148C16.8834 13.6103 16.8488 13.6359 16.8444 13.6724C16.8392 13.7088 16.8674 13.7421 16.9058 13.7466L17.06 13.7645Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.5391 13.778C17.5391 13.7409 17.5704 13.7114 17.6095 13.7114C17.6485 13.7114 17.6799 13.7409 17.6799 13.778C17.6799 13.8145 17.6485 13.8445 17.6095 13.8445C17.5704 13.8445 17.5391 13.8145 17.5391 13.778Z"
        fill="white"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.1447 13.8981L18.0672 13.7964L17.8516 13.8239L18.0237 13.9493L18.1447 13.8981Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M16.0323 22.0373C15.1952 22.0373 14.3651 21.8325 13.6675 21.4908C13.1536 21.2361 12.8125 20.7228 12.8125 20.1346V18.0034H19.2394V20.1346C19.2394 20.7228 18.8989 21.2361 18.3843 21.4908C17.6867 21.8325 16.8701 22.0373 16.0323 22.0373Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M16.1876 21.0912C16.3214 21.1315 16.3892 21.2313 16.3892 21.3478C16.3892 21.5001 16.242 21.6153 16.05 21.6153C15.8586 21.6153 15.7031 21.5001 15.7031 21.3478C15.7031 21.2333 15.7671 21.1046 15.9002 21.0957C15.9002 21.0957 15.8964 21.0835 15.8849 21.0637C15.8708 21.0489 15.8439 21.0214 15.8439 21.0214C15.8439 21.0214 15.8945 21.0118 15.9239 21.0227C15.9534 21.0342 15.9732 21.0528 15.9732 21.0528C15.9732 21.0528 15.9866 21.0253 16.0065 21.0041C16.0257 20.983 16.0513 20.9702 16.0513 20.9702C16.0513 20.9702 16.0807 20.9945 16.0903 21.0112C16.0999 21.0285 16.1063 21.0489 16.1063 21.0489C16.1063 21.0489 16.1332 21.0265 16.1569 21.0176C16.1806 21.008 16.2106 21.0009 16.2106 21.0009C16.2106 21.0009 16.2023 21.0304 16.1966 21.0451C16.1908 21.0598 16.1876 21.0912 16.1876 21.0912Z"
        fill="#FFD691"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M16.0225 21.7806C16.0225 21.7806 15.7678 21.6091 15.6577 21.5861C15.5163 21.556 15.3575 21.5803 15.2891 21.5765C15.291 21.5784 15.3716 21.636 15.4068 21.6712C15.442 21.7064 15.5598 21.7768 15.6263 21.7934C15.8324 21.8453 16.0225 21.7806 16.0225 21.7806ZM16.0955 21.796C16.0955 21.796 16.258 21.6258 16.4289 21.6027C16.6305 21.5746 16.763 21.6194 16.8411 21.6398C16.843 21.6398 16.7764 21.6712 16.7412 21.6955C16.706 21.7192 16.6151 21.796 16.4763 21.7973C16.3367 21.7992 16.1831 21.7826 16.1582 21.7864C16.1326 21.7902 16.0955 21.796 16.0955 21.796Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M16.049 21.5859C15.985 21.5264 15.9453 21.4419 15.9453 21.3478C15.9453 21.2544 15.985 21.1699 16.0496 21.1104C16.0822 21.1408 16.1082 21.1777 16.1259 21.2186C16.1436 21.2595 16.1527 21.3036 16.1527 21.3483C16.1526 21.3929 16.1434 21.437 16.1255 21.4778C16.1077 21.5187 16.0817 21.5555 16.049 21.5859Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M15.9844 21.9338C15.9844 21.9338 16.0234 21.8365 16.0273 21.7527C16.0311 21.6829 16.0177 21.6138 16.0177 21.6138H16.0689C16.0689 21.6138 16.0938 21.688 16.0938 21.7527C16.0938 21.8179 16.0823 21.9043 16.0823 21.9043C16.0823 21.9043 16.0471 21.9095 16.0356 21.9152C16.0234 21.921 15.9844 21.9338 15.9844 21.9338Z"
        fill="#058E6E"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M16.0253 20.1329C16.0253 20.9752 15.3111 21.6574 14.4221 21.6574C13.5331 21.6574 12.8125 20.9752 12.8125 20.1329V17.9985H16.0253V20.1329Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M12.8047 20.104C12.8143 20.5533 12.9935 20.888 13.1714 21.1069V17.9408H12.8092L12.8047 20.104ZM13.5119 21.391C13.6124 21.4441 13.75 21.5331 13.8978 21.5683L13.8882 17.9229H13.5119V21.391ZM14.2287 21.6483C14.3759 21.663 14.4853 21.6605 14.6044 21.6483V17.9229H14.2287V21.6483ZM14.9352 21.5683C15.0824 21.5389 15.2488 21.4473 15.3212 21.4V17.9229H14.9448L14.9352 21.5683ZM15.6706 21.0717C15.8274 20.9321 15.9746 20.616 16.0284 20.255L16.0373 17.9229H15.6616L15.6706 21.0717Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M19.2446 17.998V20.1324C19.2446 20.9747 18.5226 21.6569 17.6337 21.6569C16.7441 21.6569 16.0234 20.9747 16.0234 20.1324V17.998H19.2446Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M17.4565 19.5933C17.4597 19.5844 17.4641 19.5761 17.4686 19.5677L17.196 19.2644L17.0891 19.3105L16.8933 19.0935L16.9573 19.0001L16.6155 18.6167C16.611 18.618 16.6027 18.618 16.5982 18.6193L16.6001 18.8765L16.7121 18.9085V19.194L16.6001 19.2247L16.5982 19.4858C16.652 19.5025 16.6929 19.5421 16.7096 19.5927L16.915 19.5933L16.9477 19.4865H17.2497L17.2817 19.5933H17.4565ZM17.0097 18.4093V18.5124H17.1864V18.4093H17.0097ZM16.5425 19.713C16.5835 19.713 16.6168 19.6817 16.6168 19.6426C16.6168 19.6036 16.5835 19.5716 16.5425 19.5716C16.5009 19.5716 16.4677 19.6036 16.4677 19.6426C16.4677 19.6817 16.5009 19.713 16.5425 19.713ZM17.5659 19.0903L17.4533 19.0596V18.7741L17.5659 18.7421L17.5653 18.6193C17.5109 18.6033 17.4686 18.5636 17.4507 18.5124H17.2792L17.2465 18.6193H16.9451L16.9125 18.5124H16.7147C16.7096 18.5265 16.7038 18.5393 16.6961 18.5514L17.0405 18.9329L17.1473 18.8874L17.3432 19.105L17.2792 19.1978L17.5467 19.4948C17.5525 19.4922 17.5582 19.4897 17.5646 19.4871L17.5659 19.0903ZM17.1019 19.0013L17.0193 19.0679L17.1326 19.1946L17.2152 19.1274L17.1019 19.0013ZM17.6142 21.3172C17.5348 21.3131 17.4698 21.2595 17.4533 21.1882C17.3464 21.1735 17.2453 21.146 17.1505 21.105L17.2043 21.0135C17.2869 21.0487 17.3745 21.0717 17.4654 21.0845C17.4853 21.0423 17.5205 21.0103 17.5665 20.9949L17.5672 20.6353L17.4545 20.6039V20.3185L17.5672 20.2877V19.7988C17.5627 19.7974 17.5584 19.7955 17.5544 19.793L17.2997 20.0759L17.3637 20.1681L17.1678 20.3857L17.0609 20.3402L16.8497 20.5751C16.8862 20.6308 16.8849 20.7031 16.8427 20.7575C16.9035 20.8254 16.9732 20.8846 17.0501 20.9335L16.9963 21.0257C16.9054 20.9687 16.8235 20.8983 16.7537 20.8196C16.6981 20.8362 16.6347 20.8266 16.5873 20.7876C16.5137 20.7281 16.5048 20.6237 16.5681 20.5546L16.5771 20.5444C16.5329 20.4445 16.5029 20.337 16.4926 20.2244L16.6021 20.225C16.611 20.321 16.6347 20.4125 16.6718 20.4983C16.7032 20.4945 16.7358 20.4977 16.7653 20.5085L16.9777 20.273L16.9137 20.1802L17.1096 19.9626L17.2165 20.0087L17.4718 19.7252C17.4662 19.7159 17.4617 19.706 17.4584 19.6957L17.2817 19.6964L17.2497 19.8033H16.9477L16.915 19.6964L16.7077 19.6957C16.6904 19.7444 16.6501 19.7828 16.5995 19.7994L16.5989 20.058L16.4894 20.0573V19.8007C16.419 19.7796 16.3672 19.7169 16.3672 19.6426C16.3672 19.569 16.4197 19.505 16.4901 19.4839L16.4907 19.2247L16.3781 19.194V18.9085L16.4907 18.8765V18.6173C16.4216 18.5949 16.3729 18.5329 16.3729 18.4605C16.3729 18.369 16.451 18.2954 16.5477 18.2954C16.6257 18.2954 16.6917 18.3428 16.7147 18.4093H16.9125L16.9451 18.3025H17.2465L17.2792 18.4093H17.4507C17.4736 18.3433 17.5379 18.2962 17.6145 18.2954L17.619 18.8311H17.5646V18.9981H17.6187L17.6174 20.3799H17.5672V20.5469H17.6171L17.6142 21.3172ZM17.2357 20.1457L17.1531 20.0791L17.0392 20.2058L17.1217 20.2724L17.2357 20.1457ZM16.5982 18.9655H16.4901L16.4894 19.1325H16.5982V18.9655ZM17.1845 19.6957V19.5933H17.0021V19.6957H17.1845ZM16.5061 20.3159L16.3934 20.2909L16.3774 20.0061L16.4894 19.969V20.1329C16.4894 20.1962 16.4952 20.2557 16.5061 20.3159ZM16.5995 19.9626L16.7115 19.9889C16.7115 19.9889 16.7173 20.1725 16.7147 20.1309C16.7121 20.0836 16.7269 20.2743 16.7269 20.2743L16.6142 20.3114C16.6027 20.2538 16.5989 20.1937 16.5989 20.1329L16.5995 19.9626ZM17.2913 21.0461L17.3163 20.9373C17.219 20.9066 17.1288 20.8618 17.0494 20.8036L16.9688 20.8746C17.0635 20.9482 17.1729 21.0077 17.2913 21.0461ZM17.2369 21.1383L17.1537 21.2164C17.0597 21.1818 16.9707 21.1357 16.8901 21.0813L16.9144 20.9681C17.0104 21.0404 17.1198 21.098 17.2369 21.1383Z"
        fill="#C8B100"
        stroke="#C8B100"
        strokeWidth="0.01664"
      />
      <path
        d="M17.7779 19.5933C17.7747 19.5844 17.7702 19.5761 17.7657 19.5677L18.0384 19.2644L18.1453 19.3105L18.3411 19.0935L18.2771 19.0001L18.6189 18.6167C18.6233 18.618 18.6317 18.618 18.6361 18.6193L18.6342 18.8765L18.5222 18.9085V19.194L18.6342 19.2247L18.6361 19.4858C18.5824 19.5025 18.5414 19.5421 18.5248 19.5927L18.3193 19.5933L18.2867 19.4865H17.9846L17.9526 19.5933H17.7779ZM18.2246 18.4093V18.5124H18.048V18.4093H18.2246ZM18.6918 19.713C18.6509 19.713 18.6176 19.6817 18.6176 19.6426C18.6176 19.6036 18.6509 19.5716 18.6918 19.5716C18.7334 19.5716 18.7667 19.6036 18.7667 19.6426C18.7667 19.6817 18.7334 19.713 18.6918 19.713ZM17.6685 19.0903L17.7811 19.0596V18.7741L17.6685 18.7421L17.6691 18.6193C17.7235 18.6033 17.7657 18.5636 17.7837 18.5124H17.9552L17.9878 18.6193H18.2893L18.3219 18.5124H18.5197C18.5248 18.5265 18.5305 18.5393 18.5382 18.5514L18.1939 18.9329L18.087 18.8874L17.8912 19.105L17.9552 19.1978L17.6877 19.4948C17.6819 19.4922 17.6761 19.4897 17.6697 19.4871L17.6685 19.0903ZM18.1325 19.0013L18.215 19.0679L18.1017 19.1946L18.0192 19.1274L18.1325 19.0013ZM17.6202 21.3172C17.6996 21.3131 17.7645 21.2595 17.7811 21.1882C17.888 21.1735 17.9891 21.146 18.0838 21.105L18.0301 21.0135C17.9475 21.0487 17.8598 21.0717 17.7689 21.0845C17.7491 21.0423 17.7139 21.0103 17.6678 20.9949L17.6672 20.6353L17.7798 20.6039V20.3185L17.6672 20.2877V19.7988C17.6717 19.7974 17.676 19.7955 17.68 19.793L17.9347 20.0759L17.8707 20.1681L18.0665 20.3857L18.1734 20.3402L18.3846 20.5751C18.3481 20.6308 18.3494 20.7031 18.3917 20.7575C18.3309 20.8254 18.2611 20.8846 18.1843 20.9335L18.2381 21.0257C18.3289 20.9687 18.4109 20.8983 18.4806 20.8196C18.5363 20.8362 18.5997 20.8266 18.647 20.7876C18.7206 20.7281 18.7296 20.6237 18.6662 20.5546L18.6573 20.5444C18.7014 20.4445 18.7315 20.337 18.7417 20.2244L18.6323 20.225C18.6233 20.321 18.5997 20.4125 18.5625 20.4983C18.5312 20.4945 18.4985 20.4977 18.4691 20.5085L18.2566 20.273L18.3206 20.1802L18.1248 19.9626L18.0179 20.0087L17.7625 19.7252C17.7682 19.7159 17.7727 19.706 17.776 19.6957L17.9526 19.6964L17.9846 19.8033H18.2867L18.3193 19.6964L18.5267 19.6957C18.544 19.7444 18.5843 19.7828 18.6349 19.7994L18.6355 20.058L18.7449 20.0573V19.8007C18.8153 19.7796 18.8672 19.7169 18.8672 19.6426C18.8672 19.569 18.8147 19.505 18.7443 19.4839L18.7437 19.2247L18.8563 19.194V18.9085L18.7437 18.8765V18.6173C18.8128 18.5949 18.8614 18.5329 18.8614 18.4605C18.8614 18.369 18.7833 18.2954 18.6867 18.2954C18.6086 18.2954 18.5427 18.3428 18.5197 18.4093H18.3219L18.2893 18.3025H17.9878L17.9552 18.4093H17.7837C17.7608 18.3433 17.6964 18.2962 17.6199 18.2954L17.6153 18.8311H17.6697V18.9981H17.6157L17.617 20.3799H17.6672V20.5469H17.6173L17.6202 21.3172ZM17.9987 20.1457L18.0813 20.0791L18.1952 20.2058L18.1126 20.2724L17.9987 20.1457ZM18.6361 18.9655H18.7443L18.7449 19.1325H18.6361V18.9655ZM18.0499 19.6957V19.5933H18.2323V19.6957H18.0499ZM18.7283 20.3159L18.8409 20.2909L18.8569 20.0061L18.7449 19.969V20.1329C18.7449 20.1962 18.7392 20.2557 18.7283 20.3159ZM18.6349 19.9626L18.5229 19.9889C18.5229 19.9889 18.5171 20.1725 18.5197 20.1309C18.5222 20.0836 18.5075 20.2743 18.5075 20.2743L18.6201 20.3114C18.6317 20.2538 18.6355 20.1937 18.6355 20.1329L18.6349 19.9626ZM17.943 21.0461L17.9181 20.9373C18.0153 20.9066 18.1056 20.8618 18.1849 20.8036L18.2656 20.8746C18.1709 20.9482 18.0614 21.0077 17.943 21.0461ZM17.9974 21.1383L18.0806 21.2164C18.1747 21.1818 18.2637 21.1357 18.3443 21.0813L18.32 20.9681C18.224 21.0404 18.1145 21.098 17.9974 21.1383Z"
        fill="#C8B100"
        stroke="#C8B100"
        strokeWidth="0.01664"
      />
      <path
        d="M17.4531 19.6444C17.4531 19.5523 17.5318 19.478 17.6285 19.478C17.7251 19.478 17.8032 19.5523 17.8032 19.6444C17.8032 19.7359 17.7251 19.8095 17.6285 19.8095C17.5318 19.8095 17.4531 19.7359 17.4531 19.6444Z"
        fill="#058E6E"
      />
      <path
        d="M12.8125 18.0002H16.024V14.4341H12.8125V18.0002Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M13.915 15.2583H13.8561V15.1994H13.7524V15.4356H13.8561V15.5988H13.634V16.0718H13.7524V17.0183H13.5156V17.5066H15.3345V17.0183H15.0983V16.0718H15.2167V15.5988H14.9947V15.4356H15.0983V15.1994H14.9947V15.2583H14.9351V15.1994H14.8321V15.2583H14.7579V15.1994H14.6542V15.4356H14.7579V15.5988H14.5364V15.081H14.6542V14.8442H14.5364V14.9038H14.4769V14.8442H14.3732V14.9038H14.3143V14.8442H14.1959V15.081H14.3143V15.5988H14.0923V15.4356H14.1959V15.1994H14.0923V15.2583H14.0334V15.1994H13.915V15.2583ZM13.5156 17.5066H15.3345H13.5156ZM13.5156 17.3882H15.3345H13.5156ZM13.5156 17.2698H15.3345H13.5156ZM13.5156 17.1514H15.3345H13.5156ZM13.5156 17.0183H15.3345H13.5156ZM13.7524 16.9146H15.0983H13.7524ZM13.7524 16.7962H15.0983H13.7524ZM13.7524 16.6631H15.0983H13.7524ZM13.7524 16.5454H15.0983H13.7524ZM13.7524 16.427H15.0983H13.7524ZM13.7524 16.3086H15.0983H13.7524ZM13.7524 16.1902H15.0983H13.7524ZM13.634 16.0718H15.2167H13.634ZM13.634 15.9534H15.2167H13.634ZM13.634 15.835H15.2167H13.634ZM13.634 15.7172H15.2167H13.634ZM13.8561 15.5988H14.9947H13.8561ZM14.3143 15.4804H14.5364H14.3143ZM14.3143 15.362H14.5364H14.3143ZM14.3143 15.2436H14.5364H14.3143ZM14.3143 15.1252H14.5364H14.3143ZM14.1959 14.9774H14.6542H14.1959ZM13.8561 15.4804H14.0923H13.8561ZM13.7524 15.3326H14.1959H13.7524ZM13.7524 17.5066V17.3882V17.5066ZM13.7524 17.2698V17.1514V17.2698ZM13.634 17.2698V17.3882V17.2698ZM13.8561 17.3882V17.2698V17.3882ZM13.9739 17.5066V17.3882V17.5066ZM13.9739 17.2698V17.1514V17.2698ZM13.9739 17.0183V16.9146V17.0183ZM13.9739 16.7962V16.6631V16.7962ZM13.8561 17.1514V17.0183V17.1514ZM13.634 17.1514V17.0183V17.1514ZM14.0923 17.0183V17.1514V17.0183ZM14.1959 17.0183V16.9146V17.0183ZM13.8561 16.7962V16.9146V16.7962ZM14.0923 16.7962V16.9146V16.7962ZM14.3143 16.7962V16.9146V16.7962ZM14.1959 16.7962V16.6631V16.7962ZM14.3143 16.5454V16.6631V16.5454ZM14.3143 16.3086V16.427V16.3086ZM14.1959 16.1902V16.3086V16.1902ZM14.3143 16.0718V16.1902V16.0718ZM14.0923 16.0718V16.1902V16.0718ZM13.8561 16.0718V16.1902V16.0718ZM13.7524 15.9534V16.0718V15.9534ZM13.9739 15.9534V16.0718V15.9534ZM14.1959 15.9534V16.0718V15.9534ZM14.3143 15.835V15.9534V15.835ZM14.0923 15.835V15.9534V15.835ZM13.8561 15.835V15.9534V15.835ZM13.7524 15.7172V15.835V15.7172ZM14.1959 15.7172V15.835V15.7172ZM13.9739 15.4804V15.5988V15.4804ZM14.9947 15.4804H14.7579H14.9947ZM15.0983 15.3326H14.6542H15.0983ZM15.0983 17.5066V17.3882V17.5066ZM15.0983 17.2698V17.1514V17.2698ZM15.2167 17.2698V17.3882V17.2698ZM14.9947 17.3882V17.2698V17.3882ZM14.8763 17.5066V17.3882V17.5066ZM14.8763 17.2698V17.1514V17.2698ZM14.8763 17.0183V16.9146V17.0183ZM14.8763 16.7962V16.6631V16.7962ZM14.9947 17.1514V17.0183V17.1514ZM15.2167 17.1514V17.0183V17.1514ZM14.7579 17.0183V17.1514V17.0183ZM14.6542 17.0183V16.9146V17.0183ZM14.9947 16.7962V16.9146V16.7962ZM14.7579 16.7962V16.9146V16.7962ZM14.5364 16.7962V16.9146V16.7962ZM14.6542 16.7962V16.6631V16.7962ZM14.5364 16.5454V16.6631V16.5454ZM14.5364 16.3086V16.427V16.3086ZM14.6542 16.1902V16.3086V16.1902ZM14.5364 16.0718V16.1902V16.0718ZM14.7579 16.0718V16.1902V16.0718ZM14.9947 16.0718V16.1902V16.0718ZM15.0983 15.9534V16.0718V15.9534ZM14.8763 15.9534V16.0718V15.9534ZM14.6542 15.9534V16.0718V15.9534ZM14.5364 15.835V15.9534V15.835ZM14.7579 15.835V15.9534V15.835ZM14.9947 15.835V15.9534V15.835ZM15.0983 15.7172V15.835V15.7172ZM14.6542 15.7172V15.835V15.7172ZM14.8763 15.4804V15.5988V15.4804ZM14.418 16.7962V16.6631V16.7962ZM14.418 16.3086V16.1902V16.3086ZM14.418 16.5454V16.427V16.5454ZM14.418 16.0718V15.9534V16.0718ZM14.418 15.835V15.7172V15.835ZM14.418 15.4804V15.362V15.4804ZM14.418 15.2436V15.1252V15.2436ZM13.8561 15.4356H14.0923H13.8561ZM14.3143 15.081H14.5364H14.3143ZM14.7579 15.4356H14.9947H14.7579Z"
        fill="#C8B100"
      />
      <path
        d="M13.8561 15.4356H13.7524V15.1994H13.8561V15.2583H13.915V15.1994H14.0334V15.2583H14.0923V15.1994H14.1959V15.4356H14.0923M13.8561 15.4356V15.5988M13.8561 15.4356H14.0923M13.8561 15.5988H13.634V16.0718M13.8561 15.5988H14.9947M13.634 16.0718H13.7524M13.634 16.0718H15.2167M13.7524 16.0718V17.0183H13.5156M13.7524 16.0718V15.9534M13.5156 17.0183V17.5066H15.3345V17.0183M13.5156 17.0183H15.3345M15.3345 17.0183H15.0983V16.0718M15.0983 16.0718H15.2167M15.0983 16.0718V15.9534M15.2167 16.0718V15.5988H14.9947M14.9947 15.5988V15.4356M14.9947 15.4356H15.0983V15.1994H14.9947V15.2583H14.9351V15.1994H14.8321V15.2583H14.7579V15.1994H14.6542V15.4356H14.7579M14.9947 15.4356H14.7579M14.7579 15.4356V15.5988H14.5364V15.081M14.5364 15.081H14.6542V14.8442H14.5364V14.9038H14.4769V14.8442H14.3732V14.9038H14.3143V14.8442H14.1959V15.081H14.3143M14.5364 15.081H14.3143M14.3143 15.081V15.5988H14.0923V15.4356M13.5156 17.3882H15.3345M13.5156 17.2698H15.3345M13.5156 17.1514H15.3345M13.7524 16.9146H15.0983M13.7524 16.7962H15.0983M13.7524 16.6631H15.0983M13.7524 16.5454H15.0983M13.7524 16.427H15.0983M13.7524 16.3086H15.0983M13.7524 16.1902H15.0983M13.634 15.9534H15.2167M13.634 15.835H15.2167M13.634 15.7172H15.2167M14.3143 15.4804H14.5364M14.3143 15.362H14.5364M14.3143 15.2436H14.5364M14.3143 15.1252H14.5364M14.1959 14.9774H14.6542M13.8561 15.4804H14.0923M13.7524 15.3326H14.1959M13.7524 17.5066V17.3882M13.7524 17.2698V17.1514M13.634 17.2698V17.3882M13.8561 17.3882V17.2698M13.9739 17.5066V17.3882M13.9739 17.2698V17.1514M13.9739 17.0183V16.9146M13.9739 16.7962V16.6631M13.8561 17.1514V17.0183M13.634 17.1514V17.0183M14.0923 17.0183V17.1514M14.1959 17.0183V16.9146M13.8561 16.7962V16.9146M14.0923 16.7962V16.9146M14.3143 16.7962V16.9146M14.1959 16.7962V16.6631M14.3143 16.5454V16.6631M14.3143 16.3086V16.427M14.1959 16.1902V16.3086M14.3143 16.0718V16.1902M14.0923 16.0718V16.1902M13.8561 16.0718V16.1902M13.9739 15.9534V16.0718M14.1959 15.9534V16.0718M14.3143 15.835V15.9534M14.0923 15.835V15.9534M13.8561 15.835V15.9534M13.7524 15.7172V15.835M14.1959 15.7172V15.835M13.9739 15.4804V15.5988M14.9947 15.4804H14.7579M15.0983 15.3326H14.6542M15.0983 17.5066V17.3882M15.0983 17.2698V17.1514M15.2167 17.2698V17.3882M14.9947 17.3882V17.2698M14.8763 17.5066V17.3882M14.8763 17.2698V17.1514M14.8763 17.0183V16.9146M14.8763 16.7962V16.6631M14.9947 17.1514V17.0183M15.2167 17.1514V17.0183M14.7579 17.0183V17.1514M14.6542 17.0183V16.9146M14.9947 16.7962V16.9146M14.7579 16.7962V16.9146M14.5364 16.7962V16.9146M14.6542 16.7962V16.6631M14.5364 16.5454V16.6631M14.5364 16.3086V16.427M14.6542 16.1902V16.3086M14.5364 16.0718V16.1902M14.7579 16.0718V16.1902M14.9947 16.0718V16.1902M14.8763 15.9534V16.0718M14.6542 15.9534V16.0718M14.5364 15.835V15.9534M14.7579 15.835V15.9534M14.9947 15.835V15.9534M15.0983 15.7172V15.835M14.6542 15.7172V15.835M14.8763 15.4804V15.5988M14.418 16.7962V16.6631M14.418 16.3086V16.1902M14.418 16.5454V16.427M14.418 16.0718V15.9534M14.418 15.835V15.7172M14.418 15.4804V15.362M14.418 15.2436V15.1252"
        stroke="black"
        strokeWidth="0.02944"
      />
      <path
        d="M14.7311 17.5068V17.1958C14.7311 17.1369 14.7016 16.959 14.4207 16.959C14.1544 16.959 14.125 17.1369 14.125 17.1958V17.5068H14.7311Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02944"
      />
      <path
        d="M14.2275 17.2102L14.0796 17.1954C14.0796 17.1366 14.0944 17.0476 14.1392 17.0182L14.2723 17.1218C14.2576 17.1366 14.2275 17.1807 14.2275 17.2102ZM14.479 17.0623L14.5532 16.9292C14.5238 16.9145 14.4643 16.8998 14.4201 16.8998C14.3907 16.8998 14.3312 16.9145 14.3017 16.9292L14.3753 17.0623H14.479ZM14.6268 17.2102L14.7747 17.1954C14.7747 17.1366 14.76 17.0476 14.7158 17.0182L14.5827 17.1218C14.5974 17.1366 14.6268 17.1807 14.6268 17.2102ZM14.198 16.693V16.3673C14.198 16.279 14.1392 16.2047 14.0355 16.2047C13.9318 16.2047 13.8729 16.279 13.8729 16.3673V16.693H14.198ZM14.6563 16.693V16.3673C14.6563 16.279 14.7158 16.2047 14.8195 16.2047C14.9225 16.2047 14.982 16.279 14.982 16.3673V16.693H14.6563ZM14.0944 15.8943L14.1091 15.5986H13.8281L13.8582 15.8943H14.0944ZM14.5385 15.8943L14.568 15.5986H14.287L14.3017 15.8943H14.5385ZM14.76 15.8943L14.7305 15.5986H15.0262L14.9968 15.8943H14.76Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02944"
      />
      <path
        d="M14.6229 17.5067V17.2405C14.6229 17.1957 14.5935 17.0625 14.4162 17.0625C14.2536 17.0625 14.2236 17.1957 14.2236 17.2405V17.5067H14.6229ZM14.1647 16.6632V16.3822C14.1647 16.3086 14.1205 16.2344 14.0316 16.2344C13.9426 16.2344 13.8984 16.3086 13.8984 16.3822V16.6632H14.1647ZM14.6824 16.6632V16.3822C14.6824 16.3086 14.7266 16.2344 14.8156 16.2344C14.9039 16.2344 14.9487 16.3086 14.9487 16.3822V16.6632H14.6824Z"
        fill="#0039F0"
      />
      <path
        d="M16.0234 18.0002H19.2439V14.4341H16.0234V18.0002Z"
        fill="#CCCCCC"
        stroke="black"
        strokeWidth="0.03328"
      />
      <path
        d="M17.6641 15.313L17.6673 15.2733L17.6731 15.2515C17.6731 15.2515 17.57 15.2598 17.5156 15.2445C17.4612 15.2291 17.4126 15.2067 17.362 15.1645C17.3115 15.121 17.2916 15.0941 17.2552 15.089C17.1681 15.0749 17.1016 15.1146 17.1016 15.1146C17.1016 15.1146 17.1668 15.1382 17.2155 15.1984C17.2641 15.2586 17.3172 15.2886 17.3403 15.2963C17.378 15.3078 17.5105 15.2995 17.5464 15.3008C17.5828 15.3027 17.6641 15.313 17.6641 15.313Z"
        fill="#DB4446"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.1453 15.1679C18.1453 15.1679 18.146 15.214 18.1504 15.2575C18.1543 15.3004 18.1363 15.3369 18.1434 15.3605C18.1504 15.3842 18.1536 15.4028 18.1626 15.4201C18.1716 15.4367 18.176 15.4802 18.176 15.4802C18.176 15.4802 18.1517 15.4623 18.1287 15.4457C18.1063 15.4284 18.0903 15.4175 18.0903 15.4175L18.0967 15.4834C18.0992 15.5033 18.1107 15.5404 18.1293 15.5628C18.1479 15.5839 18.185 15.6198 18.1965 15.6479C18.208 15.6767 18.2055 15.7401 18.2055 15.7401C18.2055 15.7401 18.176 15.6921 18.1498 15.6831C18.1248 15.6742 18.0691 15.6434 18.0691 15.6434C18.0691 15.6434 18.1197 15.694 18.1197 15.7426C18.1197 15.7906 18.0992 15.845 18.0992 15.845C18.0992 15.845 18.0762 15.8015 18.0461 15.7734C18.016 15.7446 17.9738 15.7157 17.9738 15.7157C17.9738 15.7157 18.0071 15.7906 18.0071 15.8405C18.0071 15.8911 17.9975 15.9986 17.9975 15.9986C17.9975 15.9986 17.9725 15.9577 17.9469 15.9372C17.9213 15.9174 17.8912 15.9001 17.8816 15.8873C17.8727 15.8738 17.9124 15.9282 17.9162 15.9615C17.9207 15.9941 17.9367 16.1119 18.0391 16.2617C18.0992 16.3493 18.192 16.503 18.3911 16.4524C18.5901 16.4025 18.5165 16.1343 18.4743 16.0095C18.4327 15.8847 18.4116 15.7465 18.4141 15.6978C18.4167 15.6498 18.4512 15.5078 18.4468 15.4809C18.4423 15.4546 18.4314 15.3529 18.4557 15.271C18.4813 15.1858 18.5024 15.1526 18.5165 15.1174C18.53 15.0822 18.5415 15.0623 18.546 15.0316C18.5504 15.0009 18.5504 14.9439 18.5504 14.9439C18.5504 14.9439 18.5875 15.0118 18.5971 15.0361C18.6061 15.0604 18.6061 15.1321 18.6061 15.1321C18.6061 15.1321 18.6132 15.0604 18.6688 15.0252C18.7245 14.99 18.7891 14.9529 18.8051 14.933C18.8211 14.9132 18.8263 14.9004 18.8263 14.9004C18.8263 14.9004 18.8212 15.0233 18.7866 15.0713C18.7636 15.1026 18.6733 15.205 18.6733 15.205C18.6733 15.205 18.72 15.1871 18.752 15.1858C18.7847 15.1833 18.8077 15.1858 18.8077 15.1858C18.8077 15.1858 18.768 15.2166 18.7175 15.2908C18.6663 15.365 18.6874 15.3714 18.6503 15.4329C18.6132 15.4943 18.5831 15.4969 18.5364 15.534C18.4672 15.5897 18.5043 15.8118 18.5133 15.845C18.5229 15.8777 18.6432 16.1497 18.6458 16.2156C18.6477 16.2815 18.6592 16.4287 18.5434 16.5228C18.4691 16.5836 18.3469 16.5842 18.3188 16.6015C18.2912 16.6194 18.2362 16.6738 18.2362 16.7877C18.2362 16.9023 18.2772 16.9196 18.3098 16.9484C18.3424 16.9766 18.384 16.9612 18.393 16.9836C18.4026 17.0053 18.4071 17.0181 18.4211 17.0316C18.4346 17.0444 18.4442 17.0598 18.4397 17.0841C18.4346 17.1084 18.3815 17.1628 18.3629 17.2025C18.3443 17.2415 18.3072 17.3452 18.3072 17.3606C18.3072 17.3759 18.3028 17.4239 18.3188 17.4482C18.3188 17.4482 18.377 17.5161 18.3373 17.5289C18.3117 17.5378 18.2874 17.5129 18.2752 17.5161C18.2407 17.525 18.2221 17.5462 18.2125 17.5449C18.1895 17.5404 18.1895 17.5289 18.1869 17.4962C18.185 17.4636 18.1863 17.4502 18.176 17.4502C18.162 17.4502 18.1549 17.4617 18.1524 17.4789C18.1498 17.4962 18.1498 17.5359 18.1338 17.5359C18.1178 17.5359 18.0948 17.5071 18.0807 17.5007C18.0666 17.4943 18.0275 17.4879 18.025 17.47C18.0231 17.4527 18.048 17.4156 18.0736 17.4086C18.0992 17.4022 18.1223 17.3893 18.1063 17.3759C18.0896 17.3631 18.0736 17.3631 18.0576 17.3759C18.0416 17.3893 18.0071 17.3785 18.009 17.3586C18.0115 17.3388 18.016 17.3145 18.0135 17.3036C18.0115 17.2927 17.9834 17.2709 18.0199 17.2511C18.0576 17.2313 18.0736 17.2684 18.1108 17.262C18.1479 17.2556 18.1658 17.2422 18.1799 17.2204C18.194 17.1986 18.1914 17.1526 18.1658 17.1244C18.1408 17.0956 18.1152 17.0911 18.1056 17.0732C18.0967 17.0559 18.0826 17.0143 18.0826 17.0143C18.0826 17.0143 18.0896 17.0911 18.0851 17.102C18.0807 17.1129 18.0826 17.1589 18.0826 17.1589C18.0826 17.1589 18.0576 17.1302 18.0365 17.1084C18.016 17.0866 17.9949 17.0207 17.9949 17.0207C17.9949 17.0207 17.993 17.0822 17.993 17.1065C17.993 17.1302 18.0205 17.1525 18.0115 17.1615C18.002 17.1698 17.9584 17.1154 17.9463 17.1065C17.9348 17.0975 17.8976 17.0694 17.8816 17.0386C17.8656 17.0079 17.8535 16.9644 17.849 16.9484C17.8445 16.933 17.8368 16.8645 17.8445 16.8473C17.856 16.8217 17.8746 16.7749 17.8746 16.7749H17.7844C17.7357 16.7749 17.7012 16.7602 17.6826 16.7929C17.664 16.8255 17.673 16.8914 17.696 16.9772C17.7197 17.0623 17.7332 17.1039 17.7268 17.1193C17.7197 17.1346 17.6896 17.1698 17.6781 17.1762C17.666 17.1833 17.634 17.1807 17.6199 17.1743C17.6064 17.1679 17.5834 17.157 17.5392 17.157C17.4951 17.157 17.4675 17.1589 17.4515 17.1551C17.4349 17.1506 17.3952 17.1308 17.3767 17.1353C17.3581 17.1397 17.3261 17.1557 17.3351 17.1813C17.3491 17.2204 17.3216 17.2293 17.3024 17.2274C17.2839 17.2249 17.2685 17.2185 17.2448 17.2121C17.2218 17.205 17.1872 17.2121 17.1917 17.1852C17.1962 17.1589 17.2058 17.157 17.2173 17.1378C17.2288 17.1173 17.2333 17.1045 17.2199 17.1033C17.2039 17.102 17.1872 17.1001 17.1751 17.1103C17.1623 17.1206 17.1424 17.143 17.1264 17.1346C17.1098 17.1257 17.097 17.1071 17.097 17.0655C17.097 17.0245 17.0535 16.9887 17.0938 16.9906C17.1335 16.9926 17.184 17.0213 17.193 16.9989C17.2019 16.9765 17.1968 16.9663 17.1751 16.949C17.1533 16.9317 17.1264 16.9215 17.1552 16.8997C17.184 16.8773 17.1911 16.8773 17.2026 16.8652C17.2135 16.8537 17.2288 16.8146 17.2493 16.8242C17.289 16.8434 17.2506 16.8709 17.2909 16.9151C17.3306 16.9593 17.3556 16.9753 17.4228 16.9682C17.4893 16.9612 17.5079 16.9529 17.5079 16.9337C17.5079 16.9151 17.5021 16.8812 17.5002 16.8671C17.4989 16.8537 17.5098 16.8037 17.5098 16.8037C17.5098 16.8037 17.4791 16.8229 17.4695 16.8415C17.4611 16.8601 17.4426 16.8927 17.4426 16.8927C17.4426 16.8927 17.4355 16.8543 17.4375 16.8229C17.4387 16.8044 17.4452 16.7724 17.4445 16.766C17.4426 16.7487 17.4298 16.7058 17.4298 16.7058C17.4298 16.7058 17.4196 16.7526 17.4119 16.766C17.4048 16.7794 17.4016 16.8345 17.4016 16.8345C17.4016 16.8345 17.3587 16.7973 17.3709 16.7353C17.3792 16.6873 17.3632 16.6239 17.378 16.6034C17.392 16.5823 17.426 16.4985 17.5098 16.4953C17.593 16.4921 17.6576 16.4985 17.6871 16.4972C17.7159 16.4953 17.8189 16.4761 17.8189 16.4761C17.8189 16.4761 17.6288 16.3788 17.586 16.3494C17.5424 16.3206 17.4752 16.245 17.4535 16.2111C17.4317 16.1766 17.4119 16.11 17.4119 16.11C17.4119 16.11 17.378 16.1113 17.3466 16.1285C17.3159 16.1458 17.2851 16.1714 17.2672 16.1919C17.2493 16.2124 17.2205 16.2591 17.2205 16.2591C17.2205 16.2591 17.2256 16.199 17.2256 16.1804C17.2256 16.1618 17.2218 16.1254 17.2218 16.1254C17.2218 16.1254 17.2007 16.2073 17.1571 16.238C17.1136 16.2694 17.0631 16.3116 17.0631 16.3116C17.0631 16.3116 17.0682 16.2662 17.0682 16.2553C17.0682 16.245 17.0791 16.1919 17.0791 16.1919C17.0791 16.1919 17.0484 16.238 17.0016 16.247C16.9543 16.2553 16.8858 16.254 16.88 16.2828C16.8749 16.3116 16.8928 16.3513 16.882 16.3717C16.8711 16.3922 16.8474 16.4063 16.8474 16.4063C16.8474 16.4063 16.8205 16.3839 16.7968 16.382C16.7738 16.3801 16.7514 16.3922 16.7514 16.3922C16.7514 16.3922 16.7315 16.3666 16.7392 16.3494C16.7463 16.3327 16.7821 16.3071 16.7738 16.2962C16.7642 16.286 16.7354 16.3001 16.7175 16.3084C16.6995 16.3174 16.6611 16.3257 16.665 16.2962C16.6682 16.2674 16.6778 16.2501 16.6682 16.2297C16.6592 16.2092 16.665 16.1957 16.6797 16.1906C16.6938 16.1855 16.7514 16.1919 16.7571 16.1785C16.7623 16.165 16.7431 16.1477 16.7047 16.1394C16.6669 16.1305 16.6484 16.1081 16.6682 16.0895C16.6887 16.0703 16.6938 16.0652 16.7028 16.0485C16.7117 16.0313 16.7156 15.9999 16.7501 16.0159C16.784 16.0313 16.777 16.069 16.8135 16.0805C16.8493 16.0927 16.9344 16.0754 16.9524 16.0652C16.9703 16.055 17.0285 16.0121 17.0484 16.0018C17.0682 15.9922 17.1514 15.9302 17.1514 15.9302C17.1514 15.9302 17.1028 15.8962 17.0842 15.879C17.0663 15.8617 17.0343 15.8207 17.0176 15.8117C17.0016 15.8034 16.9216 15.7727 16.8948 15.7708C16.8679 15.7695 16.7847 15.7401 16.7847 15.7401C16.7847 15.7401 16.8224 15.7279 16.8352 15.7177C16.8474 15.7074 16.8762 15.6818 16.8909 15.6837C16.905 15.685 16.9088 15.685 16.9088 15.685C16.9088 15.685 16.8314 15.6818 16.8148 15.6767C16.7988 15.6716 16.7514 15.6422 16.7335 15.6422C16.7155 15.6422 16.6797 15.6492 16.6797 15.6492C16.6797 15.6492 16.7284 15.6185 16.768 15.6114C16.8077 15.605 16.8384 15.6063 16.8384 15.6063C16.8384 15.6063 16.777 15.589 16.7623 15.5692C16.7482 15.5481 16.7335 15.518 16.7226 15.5039C16.7117 15.4905 16.7047 15.4681 16.6848 15.4662C16.665 15.4642 16.6304 15.4905 16.6106 15.4885C16.5908 15.4866 16.576 15.4745 16.5741 15.4457C16.5728 15.4162 16.5741 15.4265 16.5677 15.4111C16.56 15.3958 16.5312 15.3599 16.5581 15.3516C16.5856 15.3426 16.6432 15.3567 16.649 15.3465C16.6541 15.3362 16.6183 15.3049 16.5946 15.2934C16.5709 15.2812 16.5331 15.2607 16.553 15.2434C16.5728 15.2268 16.5927 15.2198 16.6035 15.2044C16.6144 15.189 16.6272 15.1461 16.6509 15.1596C16.6739 15.173 16.7066 15.2402 16.7251 15.2351C16.7431 15.23 16.7443 15.182 16.7411 15.1615C16.7373 15.141 16.7411 15.1052 16.7591 15.1084C16.777 15.1116 16.7917 15.1359 16.8205 15.1378C16.8493 15.1391 16.8928 15.1308 16.889 15.1513C16.8858 15.1718 16.8691 15.1967 16.8493 15.2191C16.8301 15.2422 16.8205 15.2863 16.8333 15.3151C16.8461 15.3446 16.8787 15.3913 16.9075 15.4098C16.9363 15.4284 16.9907 15.4425 17.0253 15.4642C17.0592 15.4866 17.1392 15.55 17.1661 15.557C17.193 15.5641 17.2205 15.5775 17.2205 15.5775C17.2205 15.5775 17.2512 15.5641 17.2928 15.5641C17.3344 15.5641 17.4298 15.5705 17.4663 15.5551C17.5028 15.5398 17.5495 15.5141 17.5354 15.4815C17.5207 15.4489 17.4413 15.4201 17.4484 15.3945C17.4554 15.3689 17.4848 15.367 17.5335 15.365C17.5821 15.3638 17.6487 15.374 17.6615 15.3049C17.6743 15.237 17.6781 15.1974 17.6096 15.182C17.5405 15.1666 17.4899 15.1647 17.4771 15.1154C17.4643 15.0655 17.4522 15.0534 17.4663 15.0399C17.481 15.0265 17.506 15.0194 17.5565 15.0162C17.6077 15.0124 17.6653 15.0124 17.682 15.0002C17.698 14.9887 17.7011 14.9561 17.721 14.942C17.7408 14.9286 17.8189 14.9164 17.8189 14.9164C17.8189 14.9164 17.9124 14.9618 17.9981 15.0258C18.0756 15.0834 18.1453 15.1685 18.1453 15.1685"
        fill="#ED72AA"
      />
      <path
        d="M18.1453 15.1679C18.1453 15.1679 18.146 15.214 18.1504 15.2575C18.1543 15.3004 18.1363 15.3369 18.1434 15.3605C18.1504 15.3842 18.1536 15.4028 18.1626 15.4201C18.1716 15.4367 18.176 15.4802 18.176 15.4802C18.176 15.4802 18.1517 15.4623 18.1287 15.4457C18.1063 15.4284 18.0903 15.4175 18.0903 15.4175L18.0967 15.4834C18.0992 15.5033 18.1107 15.5404 18.1293 15.5628C18.1479 15.5839 18.185 15.6198 18.1965 15.6479C18.208 15.6767 18.2055 15.7401 18.2055 15.7401C18.2055 15.7401 18.176 15.6921 18.1498 15.6831C18.1248 15.6742 18.0691 15.6434 18.0691 15.6434C18.0691 15.6434 18.1197 15.694 18.1197 15.7426C18.1197 15.7906 18.0992 15.845 18.0992 15.845C18.0992 15.845 18.0762 15.8015 18.0461 15.7734C18.016 15.7446 17.9738 15.7157 17.9738 15.7157C17.9738 15.7157 18.0071 15.7906 18.0071 15.8405C18.0071 15.8911 17.9975 15.9986 17.9975 15.9986C17.9975 15.9986 17.9725 15.9577 17.9469 15.9372C17.9213 15.9174 17.8912 15.9001 17.8816 15.8873C17.8727 15.8738 17.9124 15.9282 17.9162 15.9615C17.9207 15.9941 17.9367 16.1119 18.0391 16.2617C18.0992 16.3493 18.192 16.503 18.3911 16.4524C18.5901 16.4025 18.5165 16.1343 18.4743 16.0095C18.4327 15.8847 18.4116 15.7465 18.4141 15.6978C18.4167 15.6498 18.4512 15.5078 18.4468 15.4809C18.4423 15.4546 18.4314 15.3529 18.4557 15.271C18.4813 15.1858 18.5024 15.1526 18.5165 15.1174C18.53 15.0822 18.5415 15.0623 18.546 15.0316C18.5504 15.0009 18.5504 14.9439 18.5504 14.9439C18.5504 14.9439 18.5875 15.0118 18.5971 15.0361C18.6061 15.0604 18.6061 15.1321 18.6061 15.1321C18.6061 15.1321 18.6132 15.0604 18.6688 15.0252C18.7245 14.99 18.7891 14.9529 18.8051 14.933C18.8211 14.9132 18.8263 14.9004 18.8263 14.9004C18.8263 14.9004 18.8212 15.0233 18.7866 15.0713C18.7636 15.1026 18.6733 15.205 18.6733 15.205C18.6733 15.205 18.72 15.1871 18.752 15.1858C18.7847 15.1833 18.8077 15.1858 18.8077 15.1858C18.8077 15.1858 18.768 15.2166 18.7175 15.2908C18.6663 15.365 18.6874 15.3714 18.6503 15.4329C18.6132 15.4943 18.5831 15.4969 18.5364 15.534C18.4672 15.5897 18.5043 15.8118 18.5133 15.845C18.5229 15.8777 18.6432 16.1497 18.6458 16.2156C18.6477 16.2815 18.6592 16.4287 18.5434 16.5228C18.4691 16.5836 18.3469 16.5842 18.3188 16.6015C18.2912 16.6194 18.2362 16.6738 18.2362 16.7877C18.2362 16.9023 18.2772 16.9196 18.3098 16.9484C18.3424 16.9766 18.384 16.9612 18.393 16.9836C18.4026 17.0053 18.4071 17.0181 18.4211 17.0316C18.4346 17.0444 18.4442 17.0598 18.4397 17.0841C18.4346 17.1084 18.3815 17.1628 18.3629 17.2025C18.3443 17.2415 18.3072 17.3452 18.3072 17.3606C18.3072 17.3759 18.3028 17.4239 18.3188 17.4482C18.3188 17.4482 18.377 17.5161 18.3373 17.5289C18.3117 17.5378 18.2874 17.5129 18.2752 17.5161C18.2407 17.525 18.2221 17.5462 18.2125 17.5449C18.1895 17.5404 18.1895 17.5289 18.1869 17.4962C18.185 17.4636 18.1863 17.4502 18.176 17.4502C18.162 17.4502 18.1549 17.4617 18.1524 17.4789C18.1498 17.4962 18.1498 17.5359 18.1338 17.5359C18.1178 17.5359 18.0948 17.5071 18.0807 17.5007C18.0666 17.4943 18.0275 17.4879 18.025 17.47C18.0231 17.4527 18.048 17.4156 18.0736 17.4086C18.0992 17.4022 18.1223 17.3893 18.1063 17.3759C18.0896 17.3631 18.0736 17.3631 18.0576 17.3759C18.0416 17.3893 18.0071 17.3785 18.009 17.3586C18.0115 17.3388 18.016 17.3145 18.0135 17.3036C18.0115 17.2927 17.9834 17.2709 18.0199 17.2511C18.0576 17.2313 18.0736 17.2684 18.1108 17.262C18.1479 17.2556 18.1658 17.2422 18.1799 17.2204C18.194 17.1986 18.1914 17.1526 18.1658 17.1244C18.1408 17.0956 18.1152 17.0911 18.1056 17.0732C18.0967 17.0559 18.0826 17.0143 18.0826 17.0143C18.0826 17.0143 18.0896 17.0911 18.0851 17.102C18.0807 17.1129 18.0826 17.1589 18.0826 17.1589C18.0826 17.1589 18.0576 17.1302 18.0365 17.1084C18.016 17.0866 17.9949 17.0207 17.9949 17.0207C17.9949 17.0207 17.993 17.0822 17.993 17.1065C17.993 17.1302 18.0205 17.1525 18.0115 17.1615C18.0019 17.1698 17.9584 17.1154 17.9463 17.1065C17.9348 17.0975 17.8976 17.0694 17.8816 17.0386C17.8656 17.0079 17.8535 16.9644 17.849 16.9484C17.8445 16.933 17.8368 16.8645 17.8445 16.8473C17.856 16.8217 17.8746 16.7749 17.8746 16.7749H17.7844C17.7357 16.7749 17.7012 16.7602 17.6826 16.7929C17.664 16.8255 17.673 16.8914 17.696 16.9772C17.7197 17.0623 17.7332 17.1039 17.7268 17.1193C17.7197 17.1346 17.6896 17.1698 17.6781 17.1762C17.666 17.1833 17.634 17.1807 17.6199 17.1743C17.6064 17.1679 17.5834 17.157 17.5392 17.157C17.4951 17.157 17.4675 17.1589 17.4515 17.1551C17.4349 17.1506 17.3952 17.1308 17.3767 17.1353C17.3581 17.1397 17.3261 17.1557 17.3351 17.1813C17.3491 17.2204 17.3216 17.2293 17.3024 17.2274C17.2839 17.2249 17.2685 17.2185 17.2448 17.2121C17.2218 17.205 17.1872 17.2121 17.1917 17.1852C17.1962 17.1589 17.2058 17.157 17.2173 17.1378C17.2288 17.1173 17.2333 17.1045 17.2199 17.1033C17.2039 17.102 17.1872 17.1001 17.1751 17.1103C17.1623 17.1206 17.1424 17.143 17.1264 17.1346C17.1098 17.1257 17.097 17.1071 17.097 17.0655C17.097 17.0245 17.0535 16.9887 17.0938 16.9906C17.1335 16.9926 17.184 17.0213 17.193 16.9989C17.2019 16.9765 17.1968 16.9663 17.1751 16.949C17.1533 16.9317 17.1264 16.9215 17.1552 16.8997C17.184 16.8773 17.1911 16.8773 17.2026 16.8652C17.2135 16.8537 17.2288 16.8146 17.2493 16.8242C17.289 16.8434 17.2506 16.8709 17.2909 16.9151C17.3306 16.9593 17.3556 16.9753 17.4228 16.9682C17.4893 16.9612 17.5079 16.9529 17.5079 16.9337C17.5079 16.9151 17.5021 16.8812 17.5002 16.8671C17.4989 16.8537 17.5098 16.8037 17.5098 16.8037C17.5098 16.8037 17.4791 16.8229 17.4695 16.8415C17.4611 16.8601 17.4426 16.8927 17.4426 16.8927C17.4426 16.8927 17.4355 16.8543 17.4375 16.8229C17.4387 16.8044 17.4452 16.7724 17.4445 16.766C17.4426 16.7487 17.4298 16.7058 17.4298 16.7058C17.4298 16.7058 17.4196 16.7526 17.4119 16.766C17.4048 16.7794 17.4016 16.8345 17.4016 16.8345C17.4016 16.8345 17.3587 16.7973 17.3709 16.7353C17.3792 16.6873 17.3632 16.6239 17.378 16.6034C17.392 16.5823 17.426 16.4985 17.5098 16.4953C17.593 16.4921 17.6576 16.4985 17.6871 16.4972C17.7159 16.4953 17.8189 16.4761 17.8189 16.4761C17.8189 16.4761 17.6288 16.3788 17.586 16.3494C17.5424 16.3206 17.4752 16.245 17.4535 16.2111C17.4317 16.1766 17.4119 16.11 17.4119 16.11C17.4119 16.11 17.378 16.1113 17.3466 16.1285C17.3159 16.1458 17.2851 16.1714 17.2672 16.1919C17.2493 16.2124 17.2205 16.2591 17.2205 16.2591C17.2205 16.2591 17.2256 16.199 17.2256 16.1804C17.2256 16.1618 17.2218 16.1254 17.2218 16.1254C17.2218 16.1254 17.2007 16.2073 17.1571 16.238C17.1136 16.2694 17.0631 16.3116 17.0631 16.3116C17.0631 16.3116 17.0682 16.2662 17.0682 16.2553C17.0682 16.245 17.0791 16.1919 17.0791 16.1919C17.0791 16.1919 17.0484 16.238 17.0016 16.247C16.9543 16.2553 16.8858 16.254 16.88 16.2828C16.8749 16.3116 16.8928 16.3513 16.882 16.3717C16.8711 16.3922 16.8474 16.4063 16.8474 16.4063C16.8474 16.4063 16.8205 16.3839 16.7968 16.382C16.7738 16.3801 16.7514 16.3922 16.7514 16.3922C16.7514 16.3922 16.7315 16.3666 16.7392 16.3494C16.7463 16.3327 16.7821 16.3071 16.7738 16.2962C16.7642 16.286 16.7354 16.3001 16.7175 16.3084C16.6995 16.3174 16.6611 16.3257 16.665 16.2962C16.6682 16.2674 16.6778 16.2501 16.6682 16.2297C16.6592 16.2092 16.665 16.1957 16.6797 16.1906C16.6938 16.1855 16.7514 16.1919 16.7571 16.1785C16.7623 16.165 16.7431 16.1477 16.7047 16.1394C16.6669 16.1305 16.6484 16.1081 16.6682 16.0895C16.6887 16.0703 16.6938 16.0652 16.7028 16.0485C16.7117 16.0313 16.7156 15.9999 16.7501 16.0159C16.784 16.0313 16.777 16.069 16.8135 16.0805C16.8493 16.0927 16.9344 16.0754 16.9524 16.0652C16.9703 16.055 17.0285 16.0121 17.0484 16.0018C17.0682 15.9922 17.1514 15.9302 17.1514 15.9302C17.1514 15.9302 17.1028 15.8962 17.0842 15.879C17.0663 15.8617 17.0343 15.8207 17.0176 15.8117C17.0016 15.8034 16.9216 15.7727 16.8948 15.7708C16.8679 15.7695 16.7847 15.7401 16.7847 15.7401C16.7847 15.7401 16.8224 15.7279 16.8352 15.7177C16.8474 15.7074 16.8762 15.6818 16.8909 15.6837C16.905 15.685 16.9088 15.685 16.9088 15.685C16.9088 15.685 16.8314 15.6818 16.8148 15.6767C16.7988 15.6716 16.7514 15.6422 16.7335 15.6422C16.7155 15.6422 16.6797 15.6492 16.6797 15.6492C16.6797 15.6492 16.7284 15.6185 16.768 15.6114C16.8077 15.605 16.8384 15.6063 16.8384 15.6063C16.8384 15.6063 16.777 15.589 16.7623 15.5692C16.7482 15.5481 16.7335 15.518 16.7226 15.5039C16.7117 15.4905 16.7047 15.4681 16.6848 15.4662C16.665 15.4642 16.6304 15.4905 16.6106 15.4885C16.5908 15.4866 16.576 15.4745 16.5741 15.4457C16.5728 15.4162 16.5741 15.4265 16.5677 15.4111C16.56 15.3958 16.5312 15.3599 16.5581 15.3516C16.5856 15.3426 16.6432 15.3567 16.649 15.3465C16.6541 15.3362 16.6183 15.3049 16.5946 15.2934C16.5709 15.2812 16.5331 15.2607 16.553 15.2434C16.5728 15.2268 16.5927 15.2198 16.6035 15.2044C16.6144 15.189 16.6272 15.1461 16.6509 15.1596C16.6739 15.173 16.7066 15.2402 16.7251 15.2351C16.7431 15.23 16.7443 15.182 16.7411 15.1615C16.7373 15.141 16.7411 15.1052 16.7591 15.1084C16.777 15.1116 16.7917 15.1359 16.8205 15.1378C16.8493 15.1391 16.8928 15.1308 16.889 15.1513C16.8858 15.1718 16.8691 15.1967 16.8493 15.2191C16.8301 15.2422 16.8205 15.2863 16.8333 15.3151C16.8461 15.3446 16.8787 15.3913 16.9075 15.4098C16.9363 15.4284 16.9907 15.4425 17.0253 15.4642C17.0592 15.4866 17.1392 15.55 17.1661 15.557C17.193 15.5641 17.2205 15.5775 17.2205 15.5775C17.2205 15.5775 17.2512 15.5641 17.2928 15.5641C17.3344 15.5641 17.4298 15.5705 17.4663 15.5551C17.5028 15.5398 17.5495 15.5141 17.5354 15.4815C17.5207 15.4489 17.4413 15.4201 17.4484 15.3945C17.4554 15.3689 17.4848 15.367 17.5335 15.365C17.5821 15.3638 17.6487 15.374 17.6615 15.3049C17.6743 15.237 17.6781 15.1974 17.6096 15.182C17.5405 15.1666 17.4899 15.1647 17.4771 15.1154C17.4643 15.0655 17.4522 15.0534 17.4663 15.0399C17.481 15.0265 17.506 15.0194 17.5565 15.0162C17.6077 15.0124 17.6653 15.0124 17.682 15.0002C17.698 14.9887 17.7011 14.9561 17.721 14.942C17.7408 14.9286 17.8189 14.9164 17.8189 14.9164C17.8189 14.9164 17.9124 14.9618 17.9981 15.0258C18.0756 15.0834 18.1453 15.1685 18.1453 15.1685"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.2172 15.5767C17.2172 15.5767 17.166 15.5914 17.1468 15.6195C17.1231 15.6535 17.125 15.688 17.125 15.688C17.125 15.688 17.1686 15.6522 17.2249 15.6669C17.2806 15.6823 17.2863 15.688 17.31 15.6861C17.3337 15.6842 17.3913 15.6637 17.3913 15.6637C17.3913 15.6637 17.3439 15.7187 17.3497 15.7565C17.3548 15.7936 17.3618 15.8109 17.3606 15.8301C17.3567 15.8762 17.3222 15.9331 17.3222 15.9331C17.3222 15.9331 17.342 15.921 17.3894 15.9107C17.4361 15.9005 17.4764 15.8781 17.5014 15.8589C17.5263 15.8403 17.559 15.7936 17.559 15.7936C17.559 15.7936 17.5487 15.8576 17.559 15.8845C17.5698 15.9127 17.5737 15.9914 17.5737 15.9914C17.5737 15.9914 17.6038 15.9645 17.6281 15.9517C17.6402 15.9447 17.6729 15.9274 17.6857 15.9069C17.6946 15.8928 17.7062 15.8391 17.7062 15.8391C17.7062 15.8391 17.7132 15.8967 17.7311 15.9248C17.749 15.9517 17.7759 16.0362 17.7759 16.0362C17.7759 16.0362 17.7945 15.9811 17.8143 15.9587C17.8342 15.9363 17.8578 15.9075 17.8591 15.8903C17.861 15.873 17.854 15.8359 17.854 15.8359L17.879 15.8903M17.1487 15.9293C17.1487 15.9293 17.1794 15.8762 17.2082 15.8589C17.2377 15.8423 17.2774 15.8115 17.2882 15.8077C17.2985 15.8045 17.3458 15.7783 17.3458 15.7783M17.4092 16.1091C17.4092 16.1091 17.479 16.0739 17.4994 16.0611C17.543 16.0355 17.5737 15.9895 17.5737 15.9895"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.0885 15.4175C18.0885 15.4175 18.0667 15.3868 18.0616 15.3759C18.0558 15.3663 18.0469 15.3452 18.0469 15.3452"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M17.8203 16.4741C17.8203 16.4741 17.9509 16.5548 17.947 16.622C17.9432 16.6885 17.8747 16.7762 17.8747 16.7762"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M17.4814 15.1193C17.4814 15.1193 17.4705 15.0886 17.4686 15.0796C17.4667 15.0713 17.4609 15.061 17.4609 15.061C17.4609 15.061 17.5173 15.061 17.5153 15.0783C17.5141 15.0956 17.4974 15.0956 17.4936 15.102C17.4904 15.109 17.4814 15.1193 17.4814 15.1193Z"
        fill="black"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M17.7382 15.0305L17.7344 15.0029C17.7344 15.0029 17.7837 15.0029 17.8067 15.0196C17.8432 15.0452 17.8662 15.0848 17.8649 15.0868C17.8585 15.0925 17.8304 15.0695 17.8105 15.0631C17.8105 15.0631 17.7958 15.0663 17.7817 15.0663C17.767 15.0663 17.76 15.0592 17.7581 15.0528C17.7561 15.0452 17.76 15.0336 17.76 15.0336L17.7382 15.0305Z"
        fill="black"
        stroke="black"
        strokeWidth="0.0032"
      />
      <path
        d="M17.4844 15.3691L17.5055 15.3351L17.5273 15.3665L17.4844 15.3691ZM17.5362 15.3678L17.5618 15.3339L17.5893 15.3646L17.5362 15.3678ZM17.5132 15.1572L17.5657 15.1758L17.5183 15.2001L17.5132 15.1572ZM17.5765 15.1745L17.6233 15.186L17.5855 15.2155L17.5765 15.1745Z"
        fill="black"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M16.7652 15.1094C16.7652 15.1094 16.7959 15.1311 16.8196 15.135C16.8433 15.1382 16.8682 15.1382 16.8721 15.1382C16.8753 15.1382 16.8829 15.1036 16.8791 15.0799C16.8663 15.0031 16.7959 14.9858 16.7959 14.9858C16.7959 14.9858 16.817 15.0326 16.8068 15.0543C16.7921 15.085 16.7652 15.1094 16.7652 15.1094ZM16.6186 15.1759C16.6186 15.1759 16.5911 15.1266 16.5335 15.133C16.4759 15.1401 16.4375 15.1849 16.4375 15.1849C16.4375 15.1849 16.5015 15.183 16.5175 15.1932C16.5412 15.2086 16.5482 15.2482 16.5482 15.2482C16.5482 15.2482 16.5828 15.2278 16.5937 15.2137C16.6039 15.2002 16.6186 15.1759 16.6186 15.1759ZM16.5482 15.3762C16.5482 15.3762 16.4989 15.3833 16.4721 15.414C16.4445 15.4454 16.449 15.5036 16.449 15.5036C16.449 15.5036 16.481 15.469 16.5098 15.469C16.5393 15.469 16.5841 15.4793 16.5841 15.4793C16.5841 15.4793 16.57 15.4434 16.57 15.4281C16.57 15.4127 16.5482 15.3762 16.5482 15.3762ZM16.7127 16.0239C16.7127 16.0239 16.6858 15.9951 16.6385 16.0034C16.5911 16.0124 16.5604 16.0655 16.5604 16.0655C16.5604 16.0655 16.6007 16.0546 16.6244 16.0604C16.6474 16.0655 16.6641 16.0892 16.6641 16.0892C16.6641 16.0892 16.6858 16.0706 16.6929 16.0604C16.6999 16.0502 16.7127 16.0239 16.7127 16.0239ZM16.6583 16.214C16.6583 16.214 16.6186 16.2076 16.5841 16.2351C16.5501 16.2626 16.5482 16.3151 16.5482 16.3151C16.5482 16.3151 16.5809 16.2876 16.6065 16.2914C16.6314 16.2946 16.6621 16.3087 16.6621 16.3087C16.6621 16.3087 16.6673 16.2761 16.6692 16.2678C16.6749 16.2434 16.6583 16.214 16.6583 16.214ZM16.7511 16.3894C16.7511 16.3894 16.7479 16.4399 16.7722 16.4713C16.7978 16.5039 16.8445 16.509 16.8445 16.509C16.8445 16.509 16.8292 16.4751 16.8266 16.4578C16.8228 16.4322 16.8484 16.4098 16.8484 16.4098C16.8484 16.4098 16.8247 16.3855 16.8017 16.3855C16.778 16.3855 16.7511 16.3894 16.7511 16.3894ZM17.2209 16.8399C17.2209 16.8399 17.1882 16.799 17.1434 16.8002C17.098 16.8022 17.0506 16.8444 17.0506 16.8444C17.0506 16.8444 17.1069 16.8399 17.1217 16.8585C17.1364 16.8777 17.1505 16.9014 17.1505 16.9014C17.1505 16.9014 17.1761 16.8879 17.1869 16.879C17.1978 16.8706 17.2209 16.8399 17.2209 16.8399ZM17.082 17.0198C17.082 17.0198 17.0225 17.0108 16.993 17.0422C16.9642 17.0729 16.9661 17.1292 16.9661 17.1292C16.9661 17.1292 17.002 17.0902 17.0346 17.0934C17.0673 17.0966 17.1037 17.1138 17.1037 17.1138C17.1037 17.1138 17.098 17.0799 17.0941 17.0639C17.0909 17.0486 17.082 17.0198 17.082 17.0198ZM17.2106 17.2098C17.2106 17.2098 17.1812 17.2508 17.2029 17.2834C17.2247 17.3161 17.2701 17.3314 17.2701 17.3314C17.2701 17.3314 17.2535 17.3078 17.2612 17.2802C17.2669 17.2585 17.3041 17.229 17.3041 17.229L17.2106 17.2098ZM18.0042 17.2873C18.0042 17.2873 17.9524 17.2751 17.9229 17.2924C17.8941 17.309 17.8705 17.3814 17.8705 17.3814C17.8705 17.3814 17.9178 17.3417 17.9524 17.3468C17.9863 17.3519 18.0119 17.366 18.0119 17.366C18.0119 17.366 18.017 17.3366 18.0132 17.3161C18.0113 17.3039 18.0042 17.2873 18.0042 17.2873ZM18.0298 17.4786C18.0298 17.4786 17.9901 17.5196 18.0042 17.5542C18.0189 17.5887 18.0439 17.6246 18.0439 17.6246C18.0439 17.6246 18.0426 17.5734 18.0586 17.5593C18.0823 17.5388 18.1258 17.5356 18.1258 17.5356C18.1258 17.5356 18.0913 17.5049 18.0804 17.501C18.0695 17.4978 18.0298 17.4786 18.0298 17.4786ZM18.2289 17.5388C18.2289 17.5388 18.209 17.5887 18.2468 17.6207C18.2845 17.654 18.3178 17.6572 18.3178 17.6572C18.3178 17.6572 18.2884 17.6054 18.2973 17.5785C18.3069 17.5497 18.3319 17.5324 18.3319 17.5324C18.3319 17.5324 18.2845 17.5164 18.2775 17.5183C18.2705 17.5196 18.2289 17.5388 18.2289 17.5388Z"
        fill="#DB4446"
        stroke="black"
        strokeWidth="0.02496"
      />
      <path
        d="M18.1139 14.8934L18.0954 14.8947C18.0947 14.8966 18.0864 14.9101 18.0787 14.9171C18.0621 14.9331 18.0371 14.935 18.0237 14.9216C18.0203 14.9182 18.0177 14.9141 18.0161 14.9095C18.0146 14.905 18.0141 14.9001 18.0147 14.8953C18.0039 14.9011 17.9923 14.9011 17.9821 14.8947C17.9655 14.8851 17.9616 14.8627 17.9731 14.8441C17.9751 14.8403 17.977 14.8352 17.9802 14.8326L17.9789 14.8121L17.9565 14.8173L17.9501 14.8294C17.936 14.8454 17.9155 14.8493 17.9053 14.8403C17.9009 14.8355 17.898 14.8295 17.897 14.823C17.897 14.8237 17.8912 14.8288 17.8861 14.8301C17.8515 14.8384 17.8381 14.7629 17.8368 14.7437L17.8259 14.7597C17.8259 14.7597 17.8362 14.8045 17.8311 14.8429C17.8259 14.8806 17.8125 14.919 17.8125 14.919C17.8599 14.9312 17.9315 14.9702 18.0026 15.0246C18.0736 15.079 18.1293 15.1385 18.1523 15.1795C18.1523 15.1795 18.1895 15.159 18.2279 15.1469C18.2663 15.1347 18.3149 15.1341 18.3149 15.1341L18.329 15.1206C18.3085 15.1238 18.2279 15.127 18.2291 15.0931C18.2291 15.088 18.2336 15.0816 18.2343 15.0816C18.2277 15.0817 18.2211 15.0804 18.2151 15.0777C18.2035 15.0694 18.2035 15.0502 18.2163 15.0336L18.2279 15.0253L18.2285 15.0035L18.2067 15.0067C18.2048 15.0093 18.1997 15.0125 18.1971 15.015C18.1799 15.0297 18.1555 15.031 18.1421 15.0169C18.1381 15.0133 18.1352 15.0086 18.134 15.0033C18.1327 14.9981 18.1331 14.9925 18.1351 14.9875C18.1303 14.9889 18.1253 14.9894 18.1203 14.9888C18.1154 14.9883 18.1106 14.9867 18.1063 14.9843C18.0896 14.9747 18.0864 14.951 18.0992 14.9331C18.105 14.9241 18.1171 14.9133 18.1191 14.9126L18.1146 14.8934H18.1139Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M17.97 14.9377C17.9732 14.9332 17.9796 14.9338 17.9847 14.9377C17.9898 14.9415 17.9911 14.9479 17.9885 14.9511C17.9853 14.955 17.9789 14.955 17.9732 14.9505C17.9687 14.9473 17.9668 14.9409 17.97 14.9377ZM18.0308 14.9883L18.0096 14.9723C18.0058 14.9697 18.0052 14.9646 18.0071 14.962C18.0096 14.9594 18.0148 14.9594 18.0186 14.962L18.0397 14.9786L18.0608 14.9946C18.064 14.9972 18.066 15.0023 18.0634 15.0049C18.0608 15.0074 18.0557 15.0074 18.0519 15.0049L18.0308 14.9883ZM17.9194 14.9121L17.9028 14.9025C17.8983 14.8999 17.8964 14.8948 17.8983 14.8916C17.9002 14.8884 17.9053 14.8878 17.9092 14.8903L17.9258 14.9006L17.9424 14.9102C17.9463 14.9121 17.9482 14.9172 17.9469 14.9204C17.945 14.9236 17.9399 14.9242 17.936 14.9217L17.9194 14.9121ZM17.8528 14.8666C17.856 14.8628 17.8631 14.8628 17.8682 14.8666C17.8733 14.8711 17.8746 14.8769 17.8714 14.8807C17.8682 14.8839 17.8618 14.8839 17.8567 14.8801C17.8516 14.8762 17.8503 14.8705 17.8528 14.8666ZM18.098 15.035C18.1012 15.0318 18.0999 15.026 18.0948 15.0215C18.0896 15.0177 18.0826 15.0177 18.0794 15.0215C18.0768 15.0247 18.0781 15.0311 18.0832 15.035C18.0884 15.0388 18.0948 15.0388 18.098 15.035ZM18.1344 15.0772L18.1485 15.0906C18.1517 15.0938 18.1568 15.0951 18.16 15.0926C18.1626 15.09 18.1626 15.0855 18.1594 15.0823L18.146 15.0689L18.1319 15.0555C18.1287 15.0523 18.1229 15.051 18.1204 15.0535C18.1172 15.0555 18.1178 15.0606 18.121 15.0638L18.1344 15.0772ZM18.1952 15.129C18.1984 15.1252 18.1972 15.1194 18.192 15.1156C18.1869 15.1111 18.1805 15.1111 18.1773 15.115C18.1741 15.1188 18.1754 15.1246 18.1805 15.129C18.1856 15.1322 18.192 15.1329 18.1952 15.129Z"
        fill="black"
        stroke="black"
        strokeWidth="0.0032"
      />
      <path
        d="M18.0135 14.7432L17.9758 14.7438L17.9688 14.7995L17.9726 14.8084L17.9822 14.8078L18.0308 14.7752L18.0135 14.7432Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.0135 14.7432L17.9758 14.7438L17.9688 14.7995L17.9726 14.8084L17.9822 14.8078L18.0308 14.7752L18.0135 14.7432Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M17.9153 14.7741L17.9141 14.8087L17.9729 14.8164L17.9825 14.8119L17.9813 14.8023L17.9473 14.7568L17.9153 14.7741Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.0353 14.8429L18.0039 14.8601L17.9694 14.8147L17.9688 14.8051L17.9777 14.8013L18.0372 14.8083L18.0353 14.8429Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M17.9605 14.8002C17.9656 14.7919 17.9771 14.7893 17.9854 14.7944C17.9944 14.7989 17.9969 14.8098 17.9918 14.8181C17.9867 14.8264 17.9752 14.829 17.9668 14.8239C17.9648 14.8228 17.963 14.8213 17.9616 14.8195C17.9601 14.8177 17.959 14.8157 17.9584 14.8134C17.9578 14.8112 17.9577 14.8089 17.9581 14.8066C17.9584 14.8043 17.9592 14.8021 17.9605 14.8002ZM17.8228 14.7426C17.8216 14.7432 17.8145 14.7132 17.8062 14.6972C17.8011 14.685 17.7812 14.6696 17.7812 14.6696C17.7832 14.6664 17.8081 14.6575 17.8369 14.6754C17.8612 14.6952 17.835 14.7311 17.835 14.7311C17.835 14.7311 17.8292 14.74 17.8228 14.7426Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M17.8907 14.7624L17.8638 14.7861L17.8203 14.7477L17.8242 14.7426L17.8261 14.733L17.885 14.7285L17.8907 14.7624Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M17.8143 14.7388C17.8175 14.7292 17.8258 14.7241 17.8322 14.726C17.8392 14.7285 17.8418 14.7375 17.8386 14.7471C17.8354 14.7567 17.8271 14.7618 17.82 14.7599C17.813 14.7573 17.8104 14.7484 17.8143 14.7388ZM18.1618 14.8335L18.124 14.8297L18.108 14.8841L18.1112 14.893L18.1208 14.8937L18.174 14.8674L18.1618 14.8335Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.0533 14.8502L18.0469 14.8848L18.1045 14.8995L18.1141 14.8969L18.1147 14.888L18.0872 14.8374L18.0533 14.8502Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.1702 14.9354L18.1363 14.9482L18.1094 14.8982L18.11 14.8886L18.1196 14.8867L18.1766 14.9014L18.1702 14.9354Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.0979 14.8829C18.1043 14.8752 18.1158 14.8745 18.1235 14.8803C18.1318 14.8861 18.1331 14.8969 18.1267 14.9046C18.1203 14.9123 18.1088 14.9129 18.1004 14.9072C18.0986 14.9058 18.0971 14.9041 18.0959 14.9021C18.0948 14.9001 18.0941 14.8979 18.0938 14.8956C18.0936 14.8933 18.0938 14.891 18.0945 14.8888C18.0952 14.8866 18.0964 14.8846 18.0979 14.8829ZM18.2892 14.9513L18.2963 14.9865L18.2406 15.0057L18.2304 15.0032L18.2297 14.9942L18.2528 14.9424L18.2892 14.9513Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.2822 15.0528L18.2464 15.0611L18.2266 15.008L18.2291 14.9984L18.2387 14.9971L18.2931 15.0195L18.2822 15.0528Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.1834 14.9546L18.1719 14.9879L18.2263 15.0096L18.2365 15.0084L18.2384 14.9994L18.2192 14.9463L18.1834 14.9546Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.2415 15.0163C18.2492 15.0092 18.2492 14.9983 18.2428 14.9913C18.2393 14.988 18.2347 14.9861 18.2299 14.9859C18.2251 14.9856 18.2204 14.9871 18.2165 14.99C18.2095 14.9971 18.2089 15.0079 18.2159 15.015C18.2223 15.022 18.2345 15.0227 18.2415 15.0163ZM18.3298 15.1315C18.3298 15.1321 18.3618 15.1334 18.3804 15.1372C18.3932 15.1398 18.4137 15.1545 18.4137 15.1545C18.4175 15.1519 18.4213 15.1276 18.3957 15.1039C18.3708 15.086 18.3394 15.118 18.3394 15.118C18.3394 15.118 18.3317 15.1257 18.3298 15.1315Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.292 15.0747L18.2734 15.1041L18.3221 15.1368L18.3278 15.1316L18.3362 15.1291L18.3285 15.0728L18.292 15.0747Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M18.3364 15.1379C18.3453 15.1334 18.3498 15.1238 18.346 15.118C18.3421 15.1123 18.3319 15.1116 18.3229 15.1168C18.314 15.1219 18.3101 15.1308 18.314 15.1366C18.3172 15.1424 18.3274 15.143 18.3364 15.1379Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.01664"
      />
      <path
        d="M16.0328 19.1559C16.6076 19.1559 17.0735 18.6315 17.0735 17.9847C17.0735 17.3378 16.6076 16.8135 16.0328 16.8135C15.4581 16.8135 14.9922 17.3378 14.9922 17.9847C14.9922 18.6315 15.4581 19.1559 16.0328 19.1559Z"
        fill="#AD1519"
        stroke="black"
        strokeWidth="0.03904"
      />
      <path
        d="M16.029 18.8408C16.4334 18.8408 16.7612 18.4563 16.7612 17.9819C16.7612 17.5076 16.4334 17.123 16.029 17.123C15.6247 17.123 15.2969 17.5076 15.2969 17.9819C15.2969 18.4563 15.6247 18.8408 16.029 18.8408Z"
        fill="#005BBF"
        stroke="black"
        strokeWidth="0.03904"
      />
      <path
        d="M15.6893 17.3916C15.6893 17.3916 15.6029 17.4863 15.6029 17.5746C15.6029 17.6636 15.6394 17.7372 15.6394 17.7372C15.6259 17.702 15.5907 17.677 15.5491 17.677C15.496 17.677 15.4531 17.7174 15.4531 17.7679C15.4531 17.782 15.4621 17.805 15.4685 17.8172L15.4998 17.8806C15.5101 17.8569 15.5344 17.8441 15.5626 17.8441C15.6003 17.8441 15.6317 17.8729 15.6317 17.9087C15.6317 17.9145 15.631 17.9196 15.6291 17.9247L15.551 17.9254V17.9913H15.6208L15.569 18.0943L15.6374 18.0674L15.6893 18.1257L15.743 18.0674L15.8115 18.0943L15.7603 17.9913H15.8294V17.9254L15.7514 17.9247C15.7501 17.9196 15.7501 17.9145 15.7501 17.9087C15.7501 17.8729 15.7802 17.8441 15.8179 17.8441C15.8461 17.8441 15.8704 17.8569 15.8806 17.8806L15.912 17.8172C15.9184 17.805 15.9274 17.782 15.9274 17.7679C15.9274 17.7174 15.8845 17.677 15.832 17.677C15.7898 17.677 15.7546 17.702 15.7418 17.7372C15.7418 17.7372 15.7782 17.6636 15.7782 17.5746C15.7782 17.4863 15.6893 17.3916 15.6893 17.3916Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02176"
        strokeLinejoin="round"
      />
      <path
        d="M15.5547 17.9912H15.8337V17.9253H15.5547V17.9912Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02176"
      />
      <path
        d="M16.369 17.3916C16.369 17.3916 16.2826 17.4863 16.2826 17.5746C16.2826 17.6636 16.3191 17.7372 16.3191 17.7372C16.3056 17.702 16.2704 17.677 16.2288 17.677C16.1757 17.677 16.1328 17.7174 16.1328 17.7679C16.1328 17.782 16.1418 17.805 16.1482 17.8172L16.1795 17.8806C16.1898 17.8569 16.2141 17.8441 16.2423 17.8441C16.28 17.8441 16.3114 17.8729 16.3114 17.9087C16.3114 17.9145 16.3107 17.9196 16.3088 17.9247L16.2307 17.9254V17.9913H16.3005L16.2487 18.0943L16.3171 18.0674L16.369 18.1257L16.4227 18.0674L16.4912 18.0943L16.44 17.9913H16.5091V17.9254L16.4311 17.9247C16.4298 17.9196 16.4298 17.9145 16.4298 17.9087C16.4298 17.8729 16.4599 17.8441 16.4976 17.8441C16.5258 17.8441 16.5501 17.8569 16.5603 17.8806L16.5917 17.8172C16.5981 17.805 16.6071 17.782 16.6071 17.7679C16.6071 17.7174 16.5642 17.677 16.5117 17.677C16.4695 17.677 16.4343 17.702 16.4215 17.7372C16.4215 17.7372 16.4579 17.6636 16.4579 17.5746C16.4579 17.4863 16.369 17.3916 16.369 17.3916Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02176"
        strokeLinejoin="round"
      />
      <path
        d="M16.2344 17.9912H16.5134V17.9253H16.2344V17.9912Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02176"
      />
      <path
        d="M16.0252 17.9766C16.0252 17.9766 15.9388 18.0713 15.9388 18.1596C15.9388 18.2486 15.9753 18.3222 15.9753 18.3222C15.9619 18.287 15.9267 18.262 15.8851 18.262C15.8319 18.262 15.7891 18.3023 15.7891 18.3529C15.7891 18.367 15.798 18.39 15.8044 18.4022L15.8358 18.4655C15.846 18.4418 15.8703 18.429 15.8985 18.429C15.9363 18.429 15.9676 18.4578 15.9676 18.4937C15.9676 18.4994 15.967 18.5046 15.9651 18.5097L15.887 18.5103V18.5762H15.9567L15.9049 18.6793L15.9734 18.6524L16.0252 18.7106L16.079 18.6524L16.1475 18.6793L16.0963 18.5762H16.1654V18.5103L16.0873 18.5097C16.086 18.5046 16.086 18.4994 16.086 18.4937C16.086 18.4578 16.1161 18.429 16.1539 18.429C16.182 18.429 16.2063 18.4418 16.2166 18.4655L16.2479 18.4022C16.2543 18.39 16.2633 18.367 16.2633 18.3529C16.2633 18.3023 16.2204 18.262 16.1679 18.262C16.1257 18.262 16.0905 18.287 16.0777 18.3222C16.0777 18.3222 16.1142 18.2486 16.1142 18.1596C16.1142 18.0713 16.0252 17.9766 16.0252 17.9766Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02176"
        strokeLinejoin="round"
      />
      <path
        d="M15.8906 18.5762H16.1697V18.5103H15.8906V18.5762Z"
        fill="#C8B100"
        stroke="black"
        strokeWidth="0.02176"
      />
    </g>
    <defs>
      <clipPath id="clip0_5419_22298">
        <rect width="48" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const GuideSuccess = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.633 15.6909H22.7724C22.4356 15.6909 22.1661 15.9604 22.1661 16.2635V19.8001H15.6993C15.3625 19.8001 15.093 20.0695 15.093 20.4063V23.9429H8.62616C8.28935 23.9429 8.0199 24.2123 8.05358 24.5155V28.0857H1.55305C1.21624 28.0857 0.980469 28.3551 0.980469 28.6583V31.6223C0.980469 31.9254 1.24992 32.1948 1.58674 32.1948H28.6666C29.0035 32.1948 29.2392 31.9254 29.2392 31.6223V16.2972C29.2392 15.9604 28.9698 15.6909 28.633 15.6909Z"
      fill="black"
    />
    <path
      d="M1.45091 22.023L15.3614 13.9732L14.7214 16.3645C14.5867 16.8698 14.8898 17.4087 15.395 17.5434C15.4624 17.5771 15.5634 17.5771 15.6308 17.5771C16.0687 17.5771 16.4392 17.3076 16.5739 16.8698L17.8201 12.2217C17.9548 11.7165 17.6517 11.1776 17.1465 11.0429L12.4984 9.79666C11.9932 9.66193 11.4543 9.96506 11.3196 10.4703C11.1849 10.9755 11.488 11.5144 11.9932 11.6491L14.3846 12.2891L0.474146 20.339C0.00260507 20.6084 -0.132121 21.181 0.137331 21.6525C0.305738 21.9557 0.642553 22.1241 0.979368 22.1241C1.11409 22.1241 1.2825 22.0904 1.45091 22.023Z"
      fill="black"
    />
    <path
      d="M25.6007 0.736328C22.0641 0.736328 19.2012 3.59925 19.2012 7.13581C19.2012 10.6724 22.0641 13.5353 25.6007 13.5353C29.1372 13.5353 32.0001 10.6724 32.0001 7.13581C32.0001 3.59925 29.1372 0.736328 25.6007 0.736328ZM28.733 6.22641L25.4996 9.42615C25.2975 9.62824 25.0281 9.72928 24.7923 9.72928C24.5228 9.72928 24.2871 9.62824 24.085 9.42615L22.502 7.84312C22.0978 7.43894 22.0978 6.79899 22.502 6.39481C22.9061 5.99064 23.5461 5.99064 23.9503 6.39481L24.826 7.27053L27.3184 4.7781C27.7226 4.37393 28.3625 4.37393 28.7667 4.7781C29.1035 5.18228 29.1035 5.82223 28.733 6.22641Z"
      fill="black"
    />
  </svg>
);

export const Calculator = () => (
  <svg
    width="22"
    height="30"
    viewBox="0 0 22 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4957 0H4.50565C2.02081 0 0 1.9973 0 4.45179V25.5482C0 28.0028 2.02088 30 4.50565 30H17.4957C19.9792 30 22 28.0027 22 25.5482V4.45179C22 1.99721 19.9791 0 17.4957 0ZM2.81867 5.47082C2.81867 4.20086 3.8652 3.16653 5.15144 3.16653H16.9481C18.233 3.16653 19.2796 4.20086 19.2796 5.47082V6.69366C19.2796 7.96489 18.233 8.99922 16.9481 8.99922H5.15144C3.8652 8.99922 2.81867 7.96489 2.81867 6.69366V5.47082ZM5.11405 10.5507C6.4119 10.5507 7.46873 11.5939 7.46873 12.8766C7.46873 14.1593 6.41319 15.2025 5.11405 15.2025C3.81492 15.2025 2.75938 14.1593 2.75938 12.8766C2.75938 11.5952 3.81621 10.5507 5.11405 10.5507ZM5.10761 27.1444C3.80848 27.1444 2.75293 26.1012 2.75293 24.8185C2.75293 23.5358 3.80976 22.4925 5.10761 22.4925C6.40546 22.4925 7.461 23.5358 7.461 24.8185C7.461 26.1012 6.40546 27.1444 5.10761 27.1444ZM5.14241 21.1385C3.84456 21.1385 2.78902 20.0953 2.78902 18.8126C2.78902 17.5298 3.84456 16.4866 5.14241 16.4866C6.44154 16.4866 7.49708 17.5298 7.49708 18.8126C7.49708 20.094 6.44154 21.1385 5.14241 21.1385ZM10.7953 27.0717C9.49741 27.0717 8.44186 26.0285 8.44186 24.7458C8.44186 23.4631 9.49741 22.4198 10.7953 22.4198C12.0944 22.4198 13.1499 23.4631 13.1499 24.7458C13.1499 26.0285 12.0931 27.0717 10.7953 27.0717ZM10.8416 21.234C9.5438 21.234 8.48826 20.1908 8.48826 18.9081C8.48826 17.6254 9.5438 16.5822 10.8416 16.5822C12.1395 16.5822 13.195 17.6254 13.195 18.9081C13.1963 20.1908 12.1395 21.234 10.8416 21.234ZM10.9576 15.3403C9.65979 15.3403 8.60425 14.297 8.60425 13.0143C8.60425 11.7316 9.65979 10.6884 10.9576 10.6884C12.2555 10.6884 13.311 11.7316 13.311 13.0143C13.311 14.297 12.2555 15.3403 10.9576 15.3403ZM16.889 10.6107C18.1881 10.6107 19.2436 11.6539 19.2436 12.9366C19.2436 14.2193 18.1868 15.2625 16.889 15.2625C15.5911 15.2625 14.5356 14.2193 14.5356 12.9366C14.5356 11.6539 15.5911 10.6107 16.889 10.6107ZM19.4215 24.7764C19.4215 26.1024 18.3312 27.18 16.9908 27.18C15.6491 27.18 14.5588 26.1011 14.5588 24.7764L14.5575 18.9716C14.5575 17.6469 15.6491 16.5692 16.9895 16.5692C18.3299 16.5692 19.4202 17.6469 19.4202 18.9716L19.4215 24.7764Z"
      fill="black"
    />
  </svg>
);

export const BinIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 17.4754C22.0361 12.1996 37.964 12.1996 52.5 17.4754"
      stroke="white"
      strokeWidth="3.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.0234 14.2998C20.0234 11.6476 21.077 9.10425 22.9524 7.22888C24.8277 5.35353 27.3713 4.2998 30.0235 4.2998C32.6755 4.2998 35.2193 5.35353 37.0945 7.22888C38.9698 9.10425 40.0235 11.6476 40.0235 14.2998"
      stroke="white"
      strokeWidth="3.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 32.5V45"
      stroke="white"
      strokeWidth="3.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.5 24.9746L45.825 44.9746C45.5562 47.6771 44.3063 50.1874 42.3115 52.0304C40.3165 53.8731 37.7152 54.9206 35 54.9746H25C22.2847 54.9206 19.6834 53.8731 17.6885 52.0304C15.6936 50.1874 14.4436 47.6771 14.175 44.9746L12.5 24.9746"
      stroke="white"
      strokeWidth="3.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarningIcon = () => (
  <svg
    className="w-full h-full max-w-[100px]"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30 42.475V42.5M30 17.5V35M52.5 30C52.5 42.4265 42.4265 52.5 30 52.5C17.5736 52.5 7.5 42.4265 7.5 30C7.5 17.5736 17.5736 7.5 30 7.5C42.4265 7.5 52.5 17.5736 52.5 30Z"
      stroke="#1776f0"
      strokeWidth="3.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PoundIcons = () => (
  <svg
    className="w-full h-full max-w-[40px]"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.75 20.4167C37.5 17.6389 35 16.25 32.5 16.25C28.3577 16.25 25 19.981 25 24.5833V31.25M25 31.25V35.6945C25 41.25 20 41.25 20 41.25H40M25 31.25H20M25 31.25H35M52.5 30C52.5 42.4265 42.4265 52.5 30 52.5C17.5736 52.5 7.5 42.4265 7.5 30C7.5 17.5736 17.5736 7.5 30 7.5C42.4265 7.5 52.5 17.5736 52.5 30Z"
      stroke="black"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OfferResponse = () => (
  <svg
    className="w-full h-full max-w-[25px] sm:max-w-[32px] max-h-[25px] sm:max-h-[32px]"
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8152 15.1515C16.8152 15.7225 16.3519 16.1868 15.7799 16.1868C15.2081 16.1868 14.7441 15.7225 14.7441 15.1515V6.89058C14.7441 6.3185 15.2081 5.85486 15.7799 5.85486C16.3519 5.85486 16.8152 6.3185 16.8152 6.89058V15.1515Z"
      fill="black"
    />
    <path
      d="M15.0471 15.896C14.6432 15.4928 14.6432 14.8361 15.0471 14.4329C15.452 14.0265 16.108 14.0265 16.5127 14.4315L20.4191 18.3461C20.8241 18.7511 20.8241 19.4074 20.4191 19.811C20.0148 20.2149 19.3592 20.2149 18.9557 19.811L15.0471 15.896Z"
      fill="black"
    />
    <path
      d="M17.0893 29.263C14.2224 29.1859 11.436 27.9137 9.58818 26.852C8.92116 26.5043 8.29183 26.0972 7.69948 25.6428C7.50251 25.5016 7.38553 25.4113 7.38553 25.4113L7.40935 25.4262C4.518 23.0739 2.66451 19.491 2.66451 15.4815C2.66451 8.4145 8.41379 2.66486 15.4807 2.66486C20.7646 2.66486 25.3103 5.88048 27.2687 10.4568L27.8742 9.84524L30.7816 13.1209C29.641 5.70057 23.2136 0 15.4811 0C6.94465 0 0 6.94536 0 15.4815C0 24.0179 6.94465 30.9626 15.4811 30.9626C18.6501 30.9626 21.5987 30.004 24.0556 28.3628C22.403 29.0251 20.3184 29.263 17.0893 29.263Z"
      fill="black"
    />
    <path
      d="M10.1268 27.1113C10.0795 27.0892 10.0333 27.0657 9.98633 27.0437L10.0894 27.1084L10.1268 27.1113Z"
      fill="black"
    />
    <path
      d="M30.3043 16.1317C30.3043 16.1317 30.3712 30.026 15.3359 28.6845C15.3359 28.6845 26.3442 30.026 25.3369 15.997H23.2111L27.8357 11.3268L32.0007 16.0201L30.3043 16.1317Z"
      fill="black"
    />
    <path
      d="M15.7795 16.5879C16.6641 16.5879 17.3813 15.8708 17.3813 14.9862C17.3813 14.1015 16.6641 13.3844 15.7795 13.3844C14.8949 13.3844 14.1777 14.1015 14.1777 14.9862C14.1777 15.8708 14.8949 16.5879 15.7795 16.5879Z"
      fill="black"
    />
    <path
      d="M15.7795 26.2987C16.6641 26.2987 17.3813 25.5816 17.3813 24.697C17.3813 23.8123 16.6641 23.0952 15.7795 23.0952C14.8949 23.0952 14.1777 23.8123 14.1777 24.697C14.1777 25.5816 14.8949 26.2987 15.7795 26.2987Z"
      fill="black"
    />
    <path
      d="M5.967 16.5883C6.85163 16.5883 7.56876 15.8712 7.56876 14.9865C7.56876 14.1019 6.85163 13.3848 5.967 13.3848C5.08237 13.3848 4.36523 14.1019 4.36523 14.9865C4.36523 15.8712 5.08237 16.5883 5.967 16.5883Z"
      fill="black"
    />
  </svg>
);

export const GreenTik = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0C7.16667 0 0 7.16667 0 16C0 24.8333 7.16667 32 16 32C24.8333 32 32 24.8333 32 16C32 7.16667 24.8333 0 16 0ZM24.2333 12.1333L14.8333 21.5667C14.5333 21.8667 14.1 22.0667 13.6667 22.0667C13.2333 22.0667 12.8 21.9 12.5 21.5667L7.76667 16.8333C7.1 16.1667 7.1 15.1333 7.76667 14.4667C8.43333 13.8 9.46667 13.8 10.1333 14.4667L13.6667 18L21.9 9.76667C22.5667 9.1 23.6 9.1 24.2667 9.76667C24.9 10.4333 24.9 11.4667 24.2333 12.1333Z"
      fill="#168A2F"
    />
  </svg>
);

export const Scholarships = ({ color }: { color?: string }) => (
  <svg
    width="29"
    height="33"
    viewBox="0 0 29 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.57426 9.60548L0.186306 7.29307C0.0382872 7.14739 -0.0281727 6.93577 0.0111008 6.73029C0.0518822 6.52481 0.19235 6.3546 0.384169 6.27795L14.2812 0.766798C14.4217 0.711596 14.5788 0.711596 14.7208 0.768331L28.6151 6.27791C28.8085 6.35458 28.9489 6.52479 28.9882 6.72872C29.029 6.93574 28.9625 7.14735 28.813 7.29303L23.4283 12.5113V10.7187C23.4283 10.1636 23.0613 9.67756 22.5342 9.53341C17.3293 8.11497 11.9794 8.1211 6.48453 9.52881C5.94834 9.66682 5.57223 10.1575 5.57223 10.7187V12.5113L3.78241 10.7755V13.4268C3.9561 13.5264 4.11923 13.6691 4.26121 13.8546C4.58293 14.2747 4.81101 14.9448 4.81252 15.7085C4.81101 16.4706 4.58294 17.1423 4.26272 17.5609C3.96366 17.9504 3.57701 18.1498 3.17825 18.1498C2.77797 18.1498 2.39285 17.9504 2.09377 17.5609C1.77206 17.1408 1.54397 16.4707 1.54397 15.7085C1.54397 14.9464 1.77054 14.2748 2.09377 13.8546C2.23726 13.669 2.39887 13.5264 2.57408 13.4268L2.57426 9.60548ZM8.19287 31.5091L5.74602 32.6684C5.44394 32.811 5.08297 32.6776 4.9425 32.3709L1.90054 25.748L4.96214 24.4738L8.19287 31.5091ZM6.08134 24.0077L11.1594 21.8977C11.6684 21.6861 12.2439 21.7198 12.7242 21.9897L18.3293 25.1394C18.4848 25.2283 18.5936 25.3801 18.6283 25.5565C18.6631 25.7344 18.6208 25.9168 18.5105 26.0579L18.1858 26.4719C18.003 26.705 17.6843 26.7725 17.4276 26.6329L12.4872 23.951C12.1926 23.7915 11.8271 23.9034 11.6685 24.2025C11.5114 24.5015 11.6232 24.8726 11.9162 25.0336L16.8582 27.714C17.63 28.1342 18.5876 27.9318 19.1328 27.2356L19.4545 26.82C19.7038 26.5041 19.8397 26.1161 19.8487 25.7205L24.9206 23.3207C25.8269 22.8913 26.9053 23.2915 27.3282 24.2116L27.5729 24.7468C27.9958 25.6684 27.6046 26.7632 26.6969 27.1926L15.81 32.3465C15.6786 32.4094 15.5305 32.4217 15.3916 32.3818L9.73665 30.7794L9.28959 30.991L6.08134 24.0077ZM18.4244 23.0907L21.8742 21.4576C22.782 21.0282 23.8604 21.4269 24.2833 22.347L24.5083 22.8392L20.3034 24.8281C20.104 24.2807 19.7173 23.8176 19.2068 23.5308L18.4244 23.0907ZM14.5005 15.7318C18.0273 15.7333 21.0193 16.1121 22.0784 16.6028C22.3321 16.7194 22.5073 16.8558 22.6146 16.9831L22.7596 17.2177L22.8064 17.3695L22.8245 17.5367L22.8079 17.7038L22.7596 17.8556L22.6146 18.0918C22.5073 18.2175 22.3306 18.354 22.0769 18.4705C21.0196 18.9612 18.0273 19.3416 14.5006 19.3416C10.9738 19.3416 7.98028 18.9613 6.92276 18.4721C6.66901 18.354 6.49379 18.2176 6.38657 18.0918L6.24006 17.8557L6.19475 17.7054L6.17662 17.5367L6.19323 17.3696L6.24157 17.2178L6.38657 16.9831C6.4938 16.8574 6.67052 16.7194 6.92426 16.6029C7.98155 16.1122 10.9738 15.7318 14.5005 15.7318ZM6.17684 16.3544V10.7192C6.17684 10.4386 6.36564 10.1917 6.63299 10.1242C12.0235 8.74259 17.2724 8.73643 22.3775 10.1273C22.6404 10.1993 22.8246 10.4401 22.8246 10.7192V16.3532L22.7657 16.298C22.6494 16.2121 22.5044 16.1263 22.3277 16.045C21.2357 15.5389 18.1455 15.1188 14.5008 15.1188C10.8562 15.1188 7.76594 15.5389 6.674 16.045C6.4988 16.1263 6.35228 16.2137 6.2375 16.298L6.17684 16.3544Z"
      fill={color ? color : "black"}
    />
  </svg>
);
export const EmploymentIcon = ({ color }: { color?: string }) => (
  <svg
    width="32"
    height="28"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0521 20.718C16.0521 15.7232 20.1168 11.6585 25.1115 11.6585C27.385 11.6585 29.4518 12.4853 31.0708 13.8976V6.1471C31.0708 5.14815 30.2785 4.35589 29.2795 4.35589H22.3558V3.28804C22.3558 1.46238 20.8746 0.015625 19.0834 0.015625H11.9185C10.0928 0.015625 8.64607 1.49682 8.64607 3.28804V4.35589H1.79122C0.79227 4.35589 0 5.14815 0 6.1471V25.6438C0 26.6428 0.79227 27.435 1.79122 27.435H19.0145C17.1888 25.7816 16.0521 23.3704 16.0521 20.718ZM10.644 3.28804C10.644 2.59911 11.2296 2.01352 11.9185 2.01352H19.0489C19.7379 2.01352 20.3234 2.59911 20.3234 3.28804V4.35589H10.644V3.28804Z"
      fill={color ? color : "black"}
    />
    <path
      d="M32.0019 19.1676C32.0019 15.9985 29.4184 13.415 26.2148 13.415V19.1332L32.0019 19.1676Z"
      fill={color ? color : "black"}
    />
    <path
      d="M24.8723 20.4085V14.4492H24.7C20.9798 14.4492 17.9141 17.2049 17.9141 20.6151C17.9141 24.3354 20.9454 27.4011 24.7 27.4011C28.0758 27.4011 30.8659 24.3698 30.8659 20.6151V20.4429L24.8723 20.4085Z"
      fill={color ? color : "black"}
    />
  </svg>
);

export const WorkIcon = () => (
  <svg
    width="32"
    height="29"
    viewBox="0 0 32 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0521 21.479C16.0521 16.4842 20.1168 12.4195 25.1115 12.4195C27.385 12.4195 29.4518 13.2462 31.0708 14.6586V6.90809C31.0708 5.90914 30.2785 5.11687 29.2795 5.11687H22.3558V4.04903C22.3558 2.22336 20.8746 0.776611 19.0834 0.776611H11.9185C10.0928 0.776611 8.64607 2.25781 8.64607 4.04903V5.11687H1.79122C0.79227 5.11687 0 5.90914 0 6.90809V26.4048C0 27.4038 0.79227 28.196 1.79122 28.196H19.0145C17.1888 26.5426 16.0521 24.1313 16.0521 21.479ZM10.644 4.04903C10.644 3.3601 11.2296 2.77451 11.9185 2.77451H19.0489C19.7379 2.77451 20.3234 3.3601 20.3234 4.04903V5.11687H10.644V4.04903Z"
      fill="black"
    />
    <path
      d="M32.0019 19.9286C32.0019 16.7595 29.4184 14.176 26.2148 14.176V19.8941L32.0019 19.9286Z"
      fill="black"
    />
    <path
      d="M24.8723 21.1695V15.2102H24.7C20.9798 15.2102 17.9141 17.9659 17.9141 21.3761C17.9141 25.0964 20.9454 28.1621 24.7 28.1621C28.0758 28.1621 30.8659 25.1308 30.8659 21.3761V21.2039L24.8723 21.1695Z"
      fill="black"
    />
  </svg>
);
export const BacklogsIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.9554 15.4878C31.7974 15.0269 31.1692 15.1437 30.7982 15.1326C30.5262 11.227 28.7836 7.56977 25.9218 4.89819C23.0599 2.2266 19.2916 0.739373 15.3765 0.736328C-5.12542 1.58123 -5.12562 30.8039 15.3766 31.6486C15.5284 31.6481 15.6738 31.5876 15.7811 31.4802C15.8885 31.3729 15.9489 31.2275 15.9494 31.0757V27.7702C15.9497 27.6949 15.935 27.6203 15.9063 27.5506C15.8776 27.481 15.8354 27.4178 15.7822 27.3645C15.7289 27.3113 15.6657 27.2691 15.5961 27.2404C15.5264 27.2117 15.4518 27.197 15.3765 27.1973C12.459 27.1935 9.66207 26.0329 7.59907 23.9699C5.53608 21.9069 4.37543 19.11 4.37165 16.1925C4.81439 2.25176 24.549 1.35742 26.3298 15.1327L25.7856 15.1326C25.6727 15.134 25.5627 15.1684 25.4692 15.2316C25.3757 15.2949 25.3028 15.3842 25.2595 15.4884C25.2162 15.5927 25.2044 15.7074 25.2257 15.8182C25.2469 15.9291 25.3002 16.0313 25.3789 16.1122L28.2031 18.9365C28.2561 18.9896 28.3191 19.0317 28.3884 19.0605C28.4577 19.0893 28.532 19.1041 28.607 19.1041C28.6821 19.1041 28.7563 19.0893 28.8257 19.0605C28.895 19.0317 28.9579 18.9896 29.0109 18.9365L31.8352 16.1122C31.9145 16.0316 31.9682 15.9293 31.9896 15.8182C32.011 15.7071 31.9991 15.5922 31.9554 15.4878Z"
      fill="black"
    />
    <path
      d="M28.1465 20.5744C28.0766 20.547 28.0019 20.5337 27.9268 20.5353C27.8517 20.5369 27.7777 20.5533 27.709 20.5837C27.6402 20.614 27.5782 20.6577 27.5265 20.7122C27.4747 20.7666 27.4343 20.8308 27.4075 20.901C26.5947 22.9694 25.2626 24.7935 23.5397 26.1973C21.8168 27.6011 19.7613 28.5373 17.5713 28.9154C17.4323 28.9429 17.3083 29.0208 17.2231 29.134C17.1379 29.2472 17.0974 29.3879 17.1095 29.5291C17.1216 29.6703 17.1853 29.802 17.2885 29.8992C17.3917 29.9963 17.527 30.052 17.6687 30.0555C20.0732 29.6607 22.3336 28.6471 24.2279 27.1144C26.1222 25.5817 27.5851 23.5826 28.4731 21.3135C28.5005 21.2435 28.5138 21.1688 28.5122 21.0937C28.5106 21.0186 28.4942 20.9446 28.4638 20.8759C28.4334 20.8072 28.3898 20.7452 28.3353 20.6934C28.2809 20.6417 28.2167 20.6012 28.1465 20.5744Z"
      fill="black"
    />
    <path
      d="M22.1258 10.8698L18.9062 7.64453V9.90739C18.9071 10.1634 19.0096 10.4085 19.1911 10.589C19.3727 10.7694 19.6184 10.8705 19.8744 10.8698H22.1258Z"
      fill="black"
    />
    <path
      d="M11.8076 7.3125C11.1835 7.31345 10.5851 7.56181 10.1438 8.00316C9.70244 8.44451 9.45407 9.04284 9.45312 9.667V22.717C9.45408 23.3412 9.70244 23.9395 10.1438 24.3809C10.5851 24.8222 11.1835 25.0706 11.8076 25.0715H20.1143C20.7384 25.0706 21.3368 24.8222 21.7781 24.3809C22.2194 23.9395 22.4678 23.3412 22.4688 22.717V12.0158H19.8737C19.3141 12.0155 18.7774 11.7935 18.3812 11.3984C17.985 11.0032 17.7615 10.4672 17.7598 9.9076V7.3125H11.8076ZM19.3982 21.7775H12.5237C12.3732 21.7753 12.2297 21.714 12.1241 21.6068C12.0185 21.4996 11.9593 21.3551 11.9593 21.2046C11.9593 21.0542 12.0185 20.9097 12.1241 20.8025C12.2297 20.6953 12.3733 20.634 12.5237 20.6318H19.3982C19.5486 20.634 19.6922 20.6954 19.7978 20.8025C19.9034 20.9097 19.9626 21.0542 19.9626 21.2046C19.9626 21.3551 19.9034 21.4996 19.7978 21.6068C19.6922 21.714 19.5487 21.7753 19.3982 21.7775ZM19.3982 18.6955H12.5237C12.3732 18.6932 12.2297 18.6319 12.1241 18.5247C12.0185 18.4175 11.9593 18.2731 11.9593 18.1226C11.9593 17.9721 12.0185 17.8277 12.1241 17.7205C12.2297 17.6133 12.3733 17.552 12.5237 17.5497H19.3982C19.5486 17.552 19.6922 17.6133 19.7978 17.7205C19.9034 17.8277 19.9626 17.9721 19.9626 18.1226C19.9626 18.2731 19.9034 18.4175 19.7978 18.5247C19.6922 18.6319 19.5487 18.6932 19.3982 18.6955ZM19.3982 14.4734C19.5485 14.4758 19.6919 14.5373 19.7973 14.6444C19.9028 14.7516 19.9619 14.8959 19.9619 15.0463C19.9619 15.1966 19.9028 15.341 19.7973 15.4481C19.6919 15.5553 19.5485 15.6167 19.3982 15.6191H12.5237C12.3734 15.6167 12.23 15.5553 12.1246 15.4481C12.0191 15.3409 11.96 15.1966 11.96 15.0463C11.96 14.8959 12.0191 14.7516 12.1246 14.6444C12.2301 14.5372 12.3734 14.4758 12.5238 14.4734H19.3982Z"
      fill="black"
    />
  </svg>
);

export const CompareEmpty = () => (
  <svg
    className="w-full h-full"
    width="439"
    height="405"
    viewBox="0 0 439 405"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M237.367 349.159C311.896 324.019 349.386 235.668 321.104 151.82C292.821 67.9722 209.476 20.3796 134.947 45.5189C60.4177 70.6582 22.9276 159.01 51.2101 242.857C79.4927 326.705 162.838 374.298 237.367 349.159Z"
      fill="#F5F5FF"
    />
    <path
      d="M329.227 402.21C362.872 402.21 390.147 397.152 390.147 390.912C390.147 384.673 362.872 379.614 329.227 379.614C295.581 379.614 268.307 384.673 268.307 390.912C268.307 397.152 295.581 402.21 329.227 402.21Z"
      fill="#DFDFEB"
    />
    <path
      d="M267.116 266.995H38.533C32.923 266.995 28.375 262.447 28.375 256.837V113.139C28.375 107.529 32.923 102.981 38.533 102.981H267.116C272.726 102.981 277.274 107.529 277.274 113.139V256.837C277.274 262.447 272.726 266.995 267.116 266.995Z"
      fill="#89AFFF"
    />
    <path
      d="M267.116 102.981H38.533C32.923 102.981 28.375 107.529 28.375 113.139V123.123H277.273V113.139C277.274 107.529 272.726 102.981 267.116 102.981Z"
      fill="#1776f0"
    />
    <path
      d="M235.988 116.969C237.974 116.969 239.585 115.359 239.585 113.372C239.585 111.386 237.974 109.775 235.988 109.775C234.001 109.775 232.391 111.386 232.391 113.372C232.391 115.359 234.001 116.969 235.988 116.969Z"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M249.437 116.969C251.423 116.969 253.034 115.359 253.034 113.372C253.034 111.386 251.423 109.775 249.437 109.775C247.45 109.775 245.84 111.386 245.84 113.372C245.84 115.359 247.45 116.969 249.437 116.969Z"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M262.887 116.969C264.874 116.969 266.484 115.359 266.484 113.372C266.484 111.386 264.874 109.775 262.887 109.775C260.9 109.775 259.29 111.386 259.29 113.372C259.29 115.359 260.9 116.969 262.887 116.969Z"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M130.435 153.251C127.598 153.251 124.852 151.356 122.674 149.538L120.022 147.325C118.382 145.956 116.433 145.223 114.436 145.223H91.8108C89.7578 145.223 88.0938 146.887 88.0938 148.94V153.251V232.273C88.0938 235.029 90.3277 237.262 93.0827 237.262H207.291C210.047 237.262 212.28 235.028 212.28 232.273V158.241C212.28 155.485 210.046 153.252 207.291 153.252H130.435V153.251Z"
      fill="#1776f0"
    />
    <path
      d="M203.185 169.236H170.877C169.437 169.236 168.269 168.069 168.269 166.629C168.269 165.189 169.437 164.021 170.877 164.021H203.185C204.625 164.021 205.793 165.189 205.793 166.629C205.793 168.07 204.625 169.236 203.185 169.236Z"
      stroke="black"
      strokeMiterlimit="10"
    />
    <path
      d="M395.744 147.025C395.744 147.025 401.48 160.515 402.22 164.429C404.487 176.409 415.253 209.355 418.895 213.484C418.895 213.484 425.695 214.213 429.094 212.27C429.094 212.27 420.594 158.358 416.952 151.073C413.309 143.788 410.881 131.888 410.881 131.888L395.744 147.025Z"
      fill="#BA6F4C"
    />
    <path
      d="M428.265 210.396C424.504 207.267 416.915 209.125 415.592 213.835C414.515 217.669 414.477 219.829 414.379 220.483C414.188 221.762 409.534 229.678 410.426 231.302C411.071 232.478 414.362 228.782 416.009 226.188C416.348 225.654 417.167 225.858 417.223 226.488C417.535 230.01 418.227 237.055 418.834 237.931C419.647 239.104 422.604 244.072 423.481 243.534C424.358 242.995 423.374 239.536 422.604 237.221C421.834 234.906 422.782 229.755 422.782 229.755C422.782 229.755 426.687 241.51 428.341 243.633C430.805 246.795 431.625 241.634 431.625 241.634C433.103 243.251 434.539 239.402 434.283 238.193C433.778 235.804 430.077 227.341 430.732 227.651C431.387 227.961 435.562 236.901 437.457 237.162C439.352 237.424 438.434 234.197 437.371 232.061C436.308 229.926 433.429 223.778 433.429 223.778C433.429 223.778 432.465 217.955 428.887 211.698C428.857 211.648 428.309 210.433 428.265 210.396Z"
      fill="#BA6F4C"
    />
    <path
      d="M431.547 241.35L426.42 229.429"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M393.04 124.561L339.367 122.369V43.1742L367.618 39.0952L393.04 124.561Z"
      fill="black"
    />
    <path
      d="M366.78 38.4224C366.78 38.4224 377.269 63.0784 386.259 96.3154"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M271.836 136.839C271.836 136.839 284.465 142.452 313.758 120.351L301.304 106.494L271.836 136.839Z"
      fill="#BA6F4C"
    />
    <path
      d="M363.835 81.0611C364.369 80.9681 367.651 84.0411 368.232 84.3961C373.82 87.8091 378.453 88.3052 384.76 89.5042C397.201 91.8692 405.971 111.698 407.236 115.84C408.731 120.735 411.326 129.153 412.822 134.048C412.822 134.048 410.369 147.67 394.618 147.364L386.725 130.525C386.725 130.525 377.779 150.696 377.253 152.275C376.727 153.854 382.691 173.499 382.691 173.499C382.691 173.499 335.683 191.566 308.32 181.831C308.32 181.831 317.601 146.369 315.107 145.218C312.746 144.128 313.757 140.125 313.757 120.352C313.757 120.352 303.847 114.564 301.479 99.3031C301.479 99.3031 314.371 87.3762 322.527 87.1122C330.682 86.8492 363.822 81.0631 363.835 81.0611Z"
      fill="#EB9757"
    />
    <path
      d="M344.103 94.611C344.103 94.611 347.523 103.688 357.916 98.558C366.477 94.332 369.319 87.44 370.057 85.137C366.485 83.098 363.835 81.061 363.835 81.061C363.835 81.061 349.267 83.604 337.069 85.396C336.409 86.765 330.52 99.595 344.103 94.611Z"
      fill="white"
    />
    <path
      d="M362.915 64.0913L363.836 81.0613C363.836 81.0613 355.943 93.0323 346.471 91.7173L344.629 80.9303L362.915 64.0913Z"
      fill="#BA6F4C"
    />
    <path
      d="M346.876 260.675L352.518 331.714L353.749 378.107C353.749 378.107 363.994 384.733 369.273 375.025C369.273 375.025 378.741 326.876 377.678 310.323C376.615 293.771 378.482 274.286 378.482 274.286L346.876 260.675Z"
      fill="#BA6F4C"
    />
    <path
      d="M306.808 371.004C306.808 371.004 277.873 395.911 280.477 395.911C283.081 395.911 295.379 394.157 303.336 392.228C311.293 390.299 314.476 385.212 314.476 385.212L315.055 390.123L320.553 389.421C320.553 389.421 326.774 376.266 322.434 368.899C318.093 361.532 306.808 371.004 306.808 371.004Z"
      fill="black"
    />
    <path
      d="M310.859 386.44L315.055 390.123L317.08 383.896L313.825 383.107L310.859 386.44Z"
      fill="black"
    />
    <path
      d="M353.711 371.969C353.711 371.969 342.903 404.311 346.55 404.726C353.494 405.515 361.922 397.841 364.526 392.93C367.13 388.019 366.841 380.301 366.841 380.301L364.381 386.089H369.445C369.445 386.089 372.194 383.458 370.024 370.829C370.024 370.829 353.711 386.834 353.711 371.969Z"
      fill="black"
    />
    <path
      d="M308.978 258.396L306.808 371.005C306.808 371.005 316.791 377.846 322.433 368.9C322.433 368.9 333.718 323.646 333.284 307.859C332.85 292.073 335.454 273.655 335.454 273.655L308.978 258.396Z"
      fill="#BA6F4C"
    />
    <path
      d="M313.056 160.52C313.056 160.52 325.685 183.673 379.885 163.677C379.885 163.677 400.933 218.403 384.621 279.444C384.621 279.444 338.314 301.019 294.113 275.234C294.113 275.234 301.48 199.46 313.056 160.52Z"
      fill="black"
    />
    <path
      d="M313.758 83.166C313.758 83.166 273.678 111.406 270.696 116.317C267.714 121.228 261.487 132.454 270.257 136.664C279.027 140.874 313.845 102.548 322.264 89.568L313.758 83.166Z"
      fill="#BA6F4C"
    />
    <path
      d="M277.625 135.261C277.625 135.261 290.123 128.464 305.032 111.45"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M386.726 130.525L379.585 119.336"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M313.758 120.352L317.792 112.283"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M335.343 74.1893C333.089 73.9743 330.942 76.3363 330.083 76.0673C329.399 75.8533 328.477 72.6113 328.131 71.3013C329.433 63.6953 328.539 57.7943 326.756 59.3753C326.661 59.4603 326.549 59.6373 326.432 59.8653C326.169 57.4523 325.484 56.2453 324.556 57.0683C324.302 57.2933 323.941 58.1373 323.618 59.0113C323.339 56.7383 322.666 55.6263 321.765 56.4243C321.321 56.8173 320.557 59.0873 320.226 60.1173C320.048 59.9003 319.787 59.8083 319.457 59.6983C318.169 59.2693 315.199 70.3963 315.056 70.9693C314.913 71.5423 311.764 83.9933 311.764 83.9933C310.619 88.5013 319.617 90.5703 322.265 89.5693C324.913 88.5673 330.942 82.0613 330.942 82.0613C330.935 82.0493 330.925 82.0383 330.918 82.0263C331.126 81.7253 331.43 81.2663 331.854 80.5763C332.766 79.0913 337.382 75.3703 337.489 75.0483C337.596 74.7263 337.597 74.4033 335.343 74.1893Z"
      fill="#BA6F4C"
    />
    <path
      d="M337.49 75.0474C337.597 74.7254 337.597 74.4034 335.343 74.1884C333.089 73.9734 330.942 76.3354 330.083 76.0664C329.399 75.8524 328.477 72.6104 328.131 71.3004C329.433 63.6944 328.539 57.7934 326.756 59.3744C326.661 59.4594 326.549 59.6364 326.432 59.8644C326.169 57.4514 325.484 56.2444 324.556 57.0674C324.302 57.2924 323.941 58.1364 323.618 59.0104C323.487 57.9474 323.268 57.1514 322.982 56.6724C322.688 64.4374 323.548 76.2104 330.441 82.5914C330.753 82.2644 330.943 82.0604 330.943 82.0604C330.936 82.0484 330.926 82.0374 330.919 82.0254C331.127 81.7244 331.431 81.2654 331.855 80.5754C332.767 79.0914 337.383 75.3694 337.49 75.0474Z"
      fill="black"
    />
    <path
      d="M360.876 67.3143L362.915 64.0913L344.629 80.9303L346.024 89.1013C353.617 87.8603 357.172 75.5923 360.876 67.3143Z"
      fill="black"
    />
    <path
      d="M325.937 48.2573C325.937 48.2573 320.529 78.9973 338.363 85.2063C356.198 91.4153 362.471 62.0813 362.509 51.7983C362.548 41.5153 357.762 36.1243 345.063 34.8393C326.277 32.9373 325.937 48.2573 325.937 48.2573Z"
      fill="#BA6F4C"
    />
    <path
      d="M366.471 36.3932C362.822 31.1142 357.462 28.2102 344.022 28.4542C333.792 28.6402 327.371 35.4712 325.189 39.0172C324.482 40.1662 322.735 43.4132 326.099 46.8992C326.099 46.8992 326.211 44.4342 328.486 41.6892C328.486 41.6892 349.774 53.2272 358.28 51.5332L360.308 59.5102C360.308 59.5102 363.186 55.4262 366.143 54.1052C366.143 54.1052 370.12 41.6732 366.471 36.3932Z"
      fill="black"
    />
    <path
      d="M369.848 61.7772C368.463 65.7902 365.074 68.2822 362.278 67.3432C359.482 66.4052 358.339 62.3912 359.724 58.3782C361.109 54.3652 364.498 51.8732 367.294 52.8122C370.089 53.7502 371.233 57.7642 369.848 61.7772Z"
      fill="#BA6F4C"
    />
    <path
      d="M343.575 61.4422C343.558 62.4972 343.001 63.3462 342.33 63.3362C341.659 63.3272 341.128 62.4632 341.145 61.4082C341.162 60.3522 341.719 59.5042 342.39 59.5142C343.061 59.5232 343.591 60.3862 343.575 61.4422Z"
      fill="black"
    />
    <path
      d="M329.511 61.3981C329.55 62.3911 329.091 63.2161 328.486 63.2411C327.88 63.2661 327.357 62.4821 327.318 61.4891C327.279 60.4961 327.738 59.6711 328.343 59.6461C328.948 59.6201 329.471 60.4051 329.511 61.3981Z"
      fill="black"
    />
    <path
      d="M348.114 53.367C348.114 53.367 343.237 54.086 343.212 49.502"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M331.839 51.9351C331.839 51.9351 330.338 56.0961 326.881 53.4061"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M343.313 78.4581C343.313 78.4581 345.319 72.0991 350.001 76.1231L343.313 78.4581Z"
      fill="black"
    />
    <path
      d="M367.225 58.0342C367.225 58.0342 364.204 55.0742 362.129 59.9942C362.129 59.9942 363.87 62.0992 362.589 63.5792C362.589 63.5792 364.404 64.1172 365.419 62.5512"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M365.714 59.8703C365.714 59.8703 365.609 58.7403 364.449 57.3833"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M331.348 65.3262C330.697 66.0502 330.513 66.9522 330.753 67.9552C330.99 68.9462 331.941 69.6002 332.945 69.6452"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M364.493 67.3462C364.493 68.8542 363.271 70.0762 361.763 70.0762C360.255 70.0762 359.033 68.8542 359.033 67.3462C359.033 65.8382 360.255 64.6162 361.763 64.6162C363.271 64.6162 364.493 65.8392 364.493 67.3462Z"
      fill="white"
    />
    <path
      d="M318.669 87.7261C318.669 87.7261 319.721 90.0061 322.265 89.5681"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M320.226 60.1172C320.226 60.1172 322.133 61.1312 319.042 72.0502C319.042 72.0502 320.95 78.9572 320.423 80.2722C319.897 81.5872 317.266 83.7802 316.476 83.8682"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M325.598 76.939C325.598 76.939 322.967 79.921 322.879 84.043"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M323.617 59.0112C323.617 59.0112 324.238 67.3802 322.922 71.9182"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M244.481 3.83828C261.482 4.30128 275.548 17.9183 276.526 34.8973C277.101 44.8813 273.232 53.9663 266.721 60.3753C265.759 61.3223 265.312 62.6723 265.537 64.0033L267.982 78.4733L252.937 69.7073C252.08 69.2083 251.07 69.0243 250.098 69.2213C246.42 69.9633 242.523 70.0993 238.507 69.4913C223.644 67.2393 212.048 54.9353 210.677 39.9643C208.85 20.0123 224.787 3.30128 244.481 3.83828Z"
      fill="#89AFFF"
    />
    <path
      d="M242.653 51.5982C242.196 51.5982 241.846 51.4532 241.603 51.1642C241.359 50.8752 241.238 50.4722 241.238 49.9542C241.238 49.4672 241.367 49.0712 241.626 48.7672C241.884 48.4632 242.227 48.3102 242.653 48.3102C243.139 48.3102 243.498 48.4552 243.726 48.7442C243.955 49.0342 244.069 49.4372 244.069 49.9542C244.069 50.4112 243.947 50.7992 243.703 51.1192C243.459 51.4382 243.11 51.5982 242.653 51.5982ZM242.372 40.2262C242.337 39.2832 242.303 38.3162 242.268 37.3262C242.233 36.3372 242.207 35.3472 242.19 34.3572C242.172 33.3682 242.18 32.3552 242.216 31.3202V19.2632H243.362L243.414 31.3202C243.414 32.3552 243.405 33.3682 243.388 34.3572C243.37 35.3472 243.344 36.3372 243.31 37.3262C243.274 38.3162 243.24 39.2832 243.205 40.2262H242.372Z"
      fill="black"
    />
  </svg>
);

export const WhiteStar = () => (
  <svg
    className="w-full h-full"
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.168 0.0976562L17.5014 12.7642L30.168 15.0977L17.5014 17.4311L15.168 30.0977L12.8345 17.4311L0.167969 15.0977L12.8345 12.7642L15.168 0.0976562Z"
      fill="white"
    />
  </svg>
);

export const BlueArrow = () => (
  <svg
    className="w-full h-[55px] sm:h-auto"
    width="768"
    height="77"
    viewBox="0 0 768 77"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M700 0L768 38L700 76.21V76H0V0H700Z" fill="#5E57EB" />
  </svg>
);
export const BlueArrowMobile = () => (
  <svg
    className="w-full"
    width="768"
    height="100"
    viewBox="0 0 768 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M700 0L768 49.8623L700 100V99.7246H0V0H700Z" fill="#5E57EB" />
  </svg>
);

export const LoadingIcon = ({ color }: { color?: string }) => (
  <svg
    className="animate-spin size-7"
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.639 5.60895C39.5795 6.7434 42.2677 8.44592 44.5502 10.6193C46.8327 12.7927 48.6648 15.3943 49.9419 18.2757C51.2189 21.1571 51.9159 24.2619 51.9931 27.4126C52.0703 30.5634 51.5261 33.6985 50.3916 36.639C49.2572 39.5795 47.5547 42.2677 45.3813 44.5502C43.2079 46.8327 40.6063 48.6648 37.7249 49.9419C34.8435 51.2189 31.7387 51.9159 28.5879 51.9931C25.4372 52.0703 22.302 51.5261 19.3616 50.3916C16.4211 49.2572 13.7329 47.5547 11.4503 45.3813C9.16784 43.2079 7.33576 40.6063 6.05871 37.7249C4.78166 34.8435 4.08465 31.7387 4.00748 28.588C3.93031 25.4372 4.47448 22.3021 5.60894 19.3616C6.74339 16.4211 8.4459 13.7329 10.6193 11.4504C12.7926 9.16786 15.3943 7.33578 18.2757 6.05873C21.1571 4.78168 24.2618 4.08467 27.4126 4.0075C30.5634 3.93032 33.6985 4.4745 36.639 5.60895L36.639 5.60895Z"
      stroke={color ? color : "white"}
      strokeOpacity="0.4"
      strokeWidth="8"
    />
    <path
      d="M36.639 5.60895C40.1726 6.97223 43.3334 9.15245 45.8629 11.9714C48.3924 14.7903 50.2189 18.1678 51.193 21.8279C52.1671 25.4879 52.2611 29.3265 51.4674 33.0299C50.6736 36.7332 49.0147 40.1962 46.6262 43.1355"
      stroke={color ? color : "white"}
      strokeWidth="8"
      strokeLinecap="round"
    />
  </svg>
);
export const WhiteWhatAppIcon = ({ color }: { color?: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5917_22022)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6288 4.35626C22.8091 1.54848 19.0588 0.00142454 15.063 0C6.82925 0 0.128205 6.66331 0.12534 14.8537C0.123908 17.472 0.812205 20.0277 2.11933 22.2799L0 29.9781L7.91863 27.9125C10.1003 29.0964 12.5569 29.7196 15.0566 29.7203H15.063C23.2953 29.7203 29.9972 23.0562 30 14.8658C30.0014 10.8964 28.4493 7.16475 25.6288 4.35697V4.35626ZM15.063 27.2117H15.058C12.8305 27.211 10.6453 26.6155 8.73875 25.4908L8.28535 25.223L3.58617 26.4488L4.84028 21.8924L4.54519 21.4251C3.30253 19.4593 2.64575 17.1871 2.64718 14.8545C2.65005 8.04726 8.21945 2.50862 15.0681 2.50862C18.3842 2.51005 21.5012 3.7957 23.8454 6.12982C26.1897 8.46323 27.4796 11.5659 27.4782 14.8644C27.4753 21.6723 21.9059 27.211 15.063 27.211V27.2117ZM21.8729 17.9649C21.4998 17.7791 19.6648 16.8815 19.3224 16.7577C18.9801 16.6337 18.7316 16.5718 18.483 16.9435C18.2345 17.3154 17.519 18.1516 17.3013 18.3987C17.0835 18.6466 16.8657 18.6772 16.4926 18.4913C16.1195 18.3054 14.9169 17.9136 13.4909 16.6493C12.3815 15.665 11.6323 14.4499 11.4146 14.078C11.1968 13.7063 11.3917 13.5054 11.5778 13.3209C11.7454 13.1543 11.951 12.8872 12.1379 12.6706C12.3249 12.4541 12.3865 12.2988 12.5111 12.0516C12.6357 11.8038 12.5734 11.5873 12.4803 11.4013C12.3872 11.2154 11.6409 9.38842 11.3293 8.64555C11.0263 7.9219 10.7184 8.02019 10.4899 8.00809C10.2722 7.99739 10.0237 7.99527 9.77442 7.99527C9.52517 7.99527 9.12117 8.08786 8.77883 8.45967C8.4365 8.83144 7.47242 9.72961 7.47242 11.5559C7.47242 13.3822 8.80967 15.1479 8.99658 15.3958C9.1835 15.6437 11.6287 19.3923 15.3724 21.0007C16.2628 21.3831 16.9582 21.6118 17.5003 21.7827C18.3943 22.0655 19.2078 22.0256 19.851 21.9302C20.568 21.8233 22.0592 21.032 22.37 20.1651C22.6808 19.2983 22.6808 18.5547 22.5878 18.4001C22.4947 18.2456 22.2454 18.1522 21.8723 17.9664L21.8729 17.9649Z"
        fill={color ? color : "white"}
      />
    </g>
    <defs>
      <clipPath id="clip0_5917_22022">
        <rect width="30" height="30" fill={color ? color : "white"} />
      </clipPath>
    </defs>
  </svg>
);

export const WhiteFaceBookIcon = ({ color }: { color?: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5917_22027)">
      <path
        d="M30 15.0001C30 6.71582 23.2843 9.53674e-05 15 9.53674e-05C6.71572 9.53674e-05 0 6.71582 0 15.0001C0 22.487 5.48528 28.6926 12.6562 29.8179V19.336H8.84766V15.0001H12.6562V11.6954C12.6562 7.93603 14.8956 5.85947 18.322 5.85947C19.9631 5.85947 21.6797 6.15244 21.6797 6.15244V9.84385H19.7882C17.9249 9.84385 17.3438 11.0001 17.3438 12.1863V15.0001H21.5039L20.8389 19.336H17.3438V29.8179C24.5147 28.6926 30 22.487 30 15.0001Z"
        fill={color ? color : "white"}
      />
    </g>
    <defs>
      <clipPath id="clip0_5917_22027">
        <rect width="30" height="30" fill={color ? color : "white"} />
      </clipPath>
    </defs>
  </svg>
);

export const WhiteCopyIcon = ({ color }: { color?: string }) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="15" r="15" fill={color ? color : "white"} />
    <g clipPath="url(#clip0_5917_22044)">
      <path
        d="M13.667 15.6667C13.9533 16.0495 14.3186 16.3662 14.738 16.5954C15.1575 16.8245 15.6213 16.9608 16.0981 16.9949C16.5749 17.0291 17.0534 16.9603 17.5012 16.7932C17.9491 16.6262 18.3557 16.3648 18.6937 16.0267L20.6937 14.0267C21.3009 13.3981 21.6368 12.556 21.6292 11.6821C21.6216 10.8081 21.2711 9.97202 20.6531 9.354C20.035 8.73597 19.199 8.38541 18.325 8.37781C17.451 8.37022 16.609 8.7062 15.9803 9.31339L14.8337 10.4534"
        stroke={color ? "white" : "#7C76FF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3335 14.3333C16.0472 13.9506 15.6819 13.6339 15.2624 13.4047C14.843 13.1755 14.3791 13.0392 13.9024 13.0051C13.4256 12.971 12.9471 13.0397 12.4992 13.2068C12.0514 13.3739 11.6447 13.6353 11.3068 13.9733L9.3068 15.9733C8.69961 16.602 8.36363 17.444 8.37122 18.318C8.37881 19.192 8.72938 20.028 9.3474 20.646C9.96543 21.2641 10.8015 21.6146 11.6755 21.6222C12.5495 21.6298 13.3915 21.2938 14.0201 20.6867L15.1601 19.5467"
        stroke={color ? "white" : "#7C76FF"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5917_22044">
        <rect
          width="16"
          height="16"
          fill={color ? color : "white"}
          transform="translate(7 7)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const WhiteClockIcon = () => (
  <svg
    className="w-full h-full"
    width="49"
    height="47"
    viewBox="0 0 49 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.7231 22.7274C25.7231 23.5839 25.0281 24.2805 24.17 24.2805C23.3124 24.2805 22.6164 23.5839 22.6164 22.7274V10.3361C22.6164 9.47793 23.3124 8.78247 24.17 8.78247C25.0281 8.78247 25.7231 9.47793 25.7231 10.3361V22.7274Z"
      fill="white"
    />
    <path
      d="M23.0708 23.844C22.465 23.2392 22.465 22.2542 23.0708 21.6494C23.6783 21.0398 24.6623 21.0398 25.2692 21.6472L31.1289 27.5192C31.7363 28.1266 31.7363 29.1112 31.1289 29.7165C30.5225 30.3223 29.539 30.3223 28.9337 29.7165L23.0708 23.844Z"
      fill="white"
    />
    <path
      d="M26.1339 43.8945C21.8337 43.7788 17.654 41.8705 14.8823 40.278C13.8817 39.7564 12.9378 39.1458 12.0492 38.4642C11.7538 38.2524 11.5783 38.117 11.5783 38.117L11.614 38.1394C7.277 34.6109 4.49676 29.2365 4.49676 23.2222C4.49676 12.6217 13.1207 3.9973 23.7211 3.9973C31.6469 3.9973 38.4655 8.82072 41.4031 15.6852L42.3113 14.7679L46.6724 19.6814C44.9614 8.55085 35.3205 0 23.7216 0C10.917 0 0.5 10.418 0.5 23.2222C0.5 36.0269 10.917 46.4438 23.7216 46.4438C28.4752 46.4438 32.8981 45.006 36.5834 42.5441C34.1045 43.5377 30.9776 43.8945 26.1339 43.8945Z"
      fill="white"
    />
    <path
      d="M15.6897 40.6669C15.6188 40.6338 15.5494 40.5986 15.479 40.5656L15.6337 40.6626L15.6897 40.6669Z"
      fill="white"
    />
    <path
      d="M45.9555 24.1978C45.9555 24.1978 46.0558 45.0392 23.5029 43.0269C23.5029 43.0269 40.0153 45.0392 38.5044 23.9956H35.3156L42.2526 16.9904L48.5 24.0303L45.9555 24.1978Z"
      fill="white"
    />
    <path
      d="M24.1691 24.8821C25.496 24.8821 26.5717 23.8064 26.5717 22.4794C26.5717 21.1525 25.496 20.0768 24.1691 20.0768C22.8421 20.0768 21.7664 21.1525 21.7664 22.4794C21.7664 23.8064 22.8421 24.8821 24.1691 24.8821Z"
      fill="white"
    />
    <path
      d="M24.1691 39.4481C25.496 39.4481 26.5717 38.3724 26.5717 37.0455C26.5717 35.7185 25.496 34.6428 24.1691 34.6428C22.8421 34.6428 21.7664 35.7185 21.7664 37.0455C21.7664 38.3724 22.8421 39.4481 24.1691 39.4481Z"
      fill="white"
    />
    <path
      d="M9.4505 24.8824C10.7774 24.8824 11.8531 23.8067 11.8531 22.4798C11.8531 21.1528 10.7774 20.0771 9.4505 20.0771C8.12355 20.0771 7.04785 21.1528 7.04785 22.4798C7.04785 23.8067 8.12355 24.8824 9.4505 24.8824Z"
      fill="white"
    />
  </svg>
);

export const BackLogsDocIcon = () => (
  <svg
    className="w-full h-full"
    width="49"
    height="47"
    viewBox="0 0 49 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48.4332 22.1272C48.1962 21.4359 47.2539 21.6111 46.6973 21.5944C46.2894 15.736 43.6755 10.2502 39.3827 6.24279C35.0898 2.23541 29.4374 0.00456692 23.5648 0C-7.18814 1.26735 -7.18843 45.1014 23.5649 46.3684C23.7926 46.3676 24.0107 46.2769 24.1717 46.1159C24.3327 45.9548 24.4234 45.7367 24.4241 45.509V40.5508C24.4245 40.4378 24.4025 40.3259 24.3595 40.2215C24.3164 40.117 24.2532 40.0221 24.1733 39.9423C24.0934 39.8624 23.9985 39.7991 23.8941 39.7561C23.7896 39.713 23.6777 39.6911 23.5648 39.6915C19.1885 39.6858 14.9931 37.9448 11.8986 34.8503C8.80412 31.7559 7.06314 27.5605 7.05748 23.1842C7.72158 2.27315 37.3235 0.931637 39.9947 21.5945L39.1784 21.5944C39.0091 21.5965 38.8441 21.6481 38.7038 21.743C38.5635 21.8378 38.4542 21.9718 38.3892 22.1282C38.3243 22.2845 38.3067 22.4566 38.3385 22.6229C38.3703 22.7892 38.4502 22.9425 38.5683 23.0639L42.8047 27.3002C42.8842 27.3799 42.9786 27.4431 43.0826 27.4863C43.1865 27.5294 43.298 27.5516 43.4105 27.5516C43.5231 27.5516 43.6345 27.5294 43.7385 27.4863C43.8424 27.4431 43.9369 27.3799 44.0164 27.3002L48.2527 23.0639C48.3717 22.9429 48.4524 22.7894 48.4845 22.6228C48.5166 22.4561 48.4987 22.2837 48.4332 22.1272Z"
      fill="white"
    />
    <path
      d="M42.7198 29.7571C42.6149 29.716 42.5029 29.696 42.3902 29.6984C42.2776 29.7008 42.1665 29.7255 42.0634 29.771C41.9604 29.8166 41.8673 29.8821 41.7897 29.9638C41.7121 30.0454 41.6514 30.1417 41.6112 30.247C40.3921 33.3496 38.3939 36.0857 35.8096 38.1915C33.2253 40.2972 30.1419 41.7014 26.8569 42.2687C26.6484 42.3099 26.4625 42.4267 26.3346 42.5965C26.2068 42.7663 26.1462 42.9773 26.1643 43.1891C26.1824 43.4009 26.278 43.5986 26.4327 43.7443C26.5875 43.89 26.7906 43.9734 27.0031 43.9787C30.6098 43.3865 34.0004 41.8662 36.8418 39.5671C39.6833 37.2681 41.8777 34.2694 43.2096 30.8657C43.2507 30.7608 43.2707 30.6488 43.2683 30.5361C43.2659 30.4235 43.2412 30.3124 43.1957 30.2093C43.1502 30.1063 43.0847 30.0132 43.003 29.9356C42.9213 29.858 42.825 29.7974 42.7198 29.7571Z"
      fill="white"
    />
    <path
      d="M33.6887 15.2002L28.8594 10.3623V13.7566C28.8607 14.1406 29.0144 14.5083 29.2867 14.779C29.559 15.0497 29.9276 15.2012 30.3116 15.2002H33.6887Z"
      fill="white"
    />
    <path
      d="M18.2114 9.86426C17.2752 9.86568 16.3777 10.2382 15.7157 10.9003C15.0537 11.5623 14.6811 12.4598 14.6797 13.396V32.9711C14.6811 33.9073 15.0537 34.8048 15.7157 35.4668C16.3777 36.1288 17.2752 36.5014 18.2114 36.5028H30.6714C31.6076 36.5014 32.5051 36.1288 33.1672 35.4668C33.8292 34.8048 34.2017 33.9073 34.2032 32.9711V16.9191H30.3105C29.4711 16.9188 28.6661 16.5858 28.0718 15.9931C27.4775 15.4004 27.1423 14.5963 27.1397 13.7569V9.86426H18.2114ZM29.5973 31.5618H19.2856C19.0599 31.5585 18.8446 31.4664 18.6861 31.3057C18.5277 31.1449 18.4389 30.9282 18.4389 30.7025C18.4389 30.4768 18.5277 30.2601 18.6862 30.0993C18.8446 29.9385 19.0599 29.8465 19.2856 29.8432H29.5973C29.823 29.8465 30.0383 29.9385 30.1967 30.0993C30.3551 30.2601 30.4439 30.4768 30.4439 30.7025C30.4439 30.9282 30.3551 31.1449 30.1967 31.3057C30.0383 31.4664 29.823 31.5585 29.5973 31.5618ZM29.5973 26.9387H19.2856C19.0599 26.9354 18.8446 26.8434 18.6861 26.6826C18.5277 26.5218 18.4389 26.3051 18.4389 26.0794C18.4389 25.8537 18.5277 25.637 18.6862 25.4762C18.8446 25.3154 19.0599 25.2234 19.2856 25.2201H29.5973C29.823 25.2235 30.0383 25.3155 30.1967 25.4762C30.3551 25.637 30.4439 25.8537 30.4439 26.0794C30.4439 26.3051 30.3551 26.5218 30.1967 26.6826C30.0383 26.8434 29.823 26.9354 29.5973 26.9387ZM29.5973 20.6056C29.8228 20.6093 30.0378 20.7014 30.196 20.8622C30.3542 21.0229 30.4429 21.2394 30.4428 21.4649C30.4428 21.6905 30.3542 21.907 30.196 22.0677C30.0378 22.2285 29.8227 22.3206 29.5972 22.3242H19.2856C19.0601 22.3206 18.8451 22.2284 18.6869 22.0677C18.5287 21.9069 18.44 21.6904 18.4401 21.4649C18.4401 21.2394 18.5287 21.0229 18.6869 20.8621C18.8451 20.7014 19.0602 20.6092 19.2857 20.6056H29.5973Z"
      fill="white"
    />
  </svg>
);

export const WorkPermitBag = () => (
  <svg
    className="w-full h-full"
    width="49"
    height="42"
    viewBox="0 0 49 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.5767 31.0535C24.5767 23.5614 30.6734 17.4644 38.1651 17.4644C41.5751 17.4644 44.6751 18.7045 47.1034 20.8229V9.19722C47.1034 7.69879 45.9151 6.51039 44.4167 6.51039H34.0317V4.90863C34.0317 2.17013 31.8101 0 29.1234 0H18.3767C15.6384 0 13.4684 2.2218 13.4684 4.90863V6.51039H3.18667C1.68834 6.51039 0.5 7.69879 0.5 9.19722V38.4423C0.5 39.9407 1.68834 41.1291 3.18667 41.1291H29.0201C26.2817 38.649 24.5767 35.0321 24.5767 31.0535ZM16.465 4.90863C16.465 3.87523 17.3434 2.99685 18.3767 2.99685H29.0717C30.1051 2.99685 30.9834 3.87523 30.9834 4.90863V6.51039H16.465V4.90863Z"
      fill="white"
    />
    <path
      d="M48.5 28.728C48.5 23.9744 44.625 20.0991 39.82 20.0991V28.6763L48.5 28.728Z"
      fill="white"
    />
    <path
      d="M37.8062 30.5893V21.6504H37.5479C31.9679 21.6504 27.3695 25.784 27.3695 30.8993C27.3695 36.4796 31.9162 41.0782 37.5479 41.0782C42.6112 41.0782 46.7962 36.5313 46.7962 30.8993V30.6409L37.8062 30.5893Z"
      fill="white"
    />
  </svg>
);

export const BackToTop = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.1429 12.2142L10 5.07136L2.85714 12.2142L0 10.7856L10 0.785645L20 10.7856L17.1429 12.2142Z"
      fill="black"
    ></path>
    <g clipPath="url(#clip0_609_234)">
      <path
        d="M17.1429 19.2142L10 12.0714L2.85714 19.2142L0 17.7856L10 7.78564L20 17.7856L17.1429 19.2142Z"
        fill="black"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_609_234">
        <rect
          width="20"
          height="15"
          fill="black"
          transform="translate(0 6)"
        ></rect>
      </clipPath>
    </defs>
  </svg>
);

export const WhiteInstagramIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5917_22025)">
      <path
        d="M8.78763 0.104967C7.19163 0.180267 6.10172 0.434967 5.14892 0.809367C4.16282 1.19367 3.32702 1.70937 2.49542 2.54397C1.66382 3.37857 1.15172 4.21497 0.770124 5.20257C0.400824 6.15747 0.150624 7.24827 0.0801243 8.84517C0.00962433 10.4421 -0.00597568 10.9554 0.00182432 15.0288C0.00962432 19.1022 0.0276243 19.6128 0.105024 21.213C0.181224 22.8087 0.435024 23.8983 0.809424 24.8514C1.19432 25.8375 1.70942 26.673 2.54432 27.5049C3.37922 28.3368 4.21502 28.8477 5.20502 29.2299C6.15902 29.5986 7.25013 29.85 8.84673 29.9199C10.4433 29.9898 10.9572 30.006 15.0294 29.9982C19.1016 29.9904 19.6143 29.9724 21.2142 29.8965C22.8141 29.8206 23.898 29.565 24.8514 29.1924C25.8375 28.8066 26.6736 28.2924 27.5049 27.4572C28.3362 26.622 28.848 25.785 29.2293 24.7968C29.5989 23.8428 29.85 22.7517 29.9193 21.1563C29.9892 19.5552 30.0057 19.044 29.9979 14.9712C29.9901 10.8984 29.9718 10.3878 29.8959 8.78817C29.82 7.18857 29.5659 6.10227 29.1918 5.14857C28.8063 4.16247 28.2918 3.32757 27.4572 2.49507C26.6226 1.66257 25.785 1.15107 24.7971 0.770667C23.8425 0.401367 22.752 0.149667 21.1554 0.0806675C19.5588 0.0116675 19.0449 -0.00603255 14.9712 0.00176745C10.8975 0.00956745 10.3875 0.0269675 8.78763 0.104967ZM8.96283 27.2214C7.50033 27.1578 6.70622 26.9148 6.17702 26.7114C5.47622 26.4414 4.97702 26.115 4.44962 25.5927C3.92222 25.0704 3.59822 24.5694 3.32462 23.8701C3.11912 23.3409 2.87162 22.5477 2.80322 21.0852C2.72882 19.5045 2.71322 19.0299 2.70452 15.0252C2.69582 11.0205 2.71112 10.5465 2.78042 8.96517C2.84282 7.50387 3.08732 6.70887 3.29042 6.17997C3.56042 5.47827 3.88562 4.97997 4.40912 4.45287C4.93262 3.92577 5.43212 3.60117 6.13202 3.32757C6.66062 3.12117 7.45382 2.87577 8.91572 2.80617C10.4976 2.73117 10.9716 2.71617 14.9757 2.70747C18.9798 2.69877 19.455 2.71377 21.0375 2.78337C22.4988 2.84697 23.2941 3.08907 23.8224 3.29337C24.5235 3.56337 25.0224 3.88767 25.5495 4.41207C26.0766 4.93647 26.4015 5.43417 26.6751 6.13557C26.8818 6.66267 27.1272 7.45557 27.1962 8.91837C27.2715 10.5003 27.2886 10.9746 27.2958 14.9784C27.303 18.9822 27.2889 19.4577 27.2196 21.0384C27.1557 22.5009 26.9133 23.2953 26.7096 23.8251C26.4396 24.5256 26.1141 25.0251 25.5903 25.5519C25.0665 26.0787 24.5676 26.4033 23.8674 26.6769C23.3394 26.883 22.5453 27.129 21.0846 27.1986C19.5027 27.273 19.0287 27.2886 15.0231 27.2973C11.0175 27.306 10.545 27.2898 8.96312 27.2214M21.1911 6.98307C21.1917 7.3391 21.2979 7.68696 21.4962 7.98265C21.6945 8.27834 21.976 8.50858 22.3052 8.64425C22.6344 8.77992 22.9964 8.81493 23.3454 8.74484C23.6945 8.67476 24.015 8.50273 24.2662 8.25052C24.5175 7.99831 24.6884 7.67724 24.7572 7.32792C24.826 6.9786 24.7897 6.61672 24.6528 6.28805C24.5159 5.95938 24.2846 5.67868 23.9882 5.48146C23.6918 5.28424 23.3436 5.17936 22.9875 5.18007C22.5102 5.18102 22.0529 5.3715 21.716 5.70961C21.3791 6.04772 21.1903 6.50578 21.1911 6.98307ZM7.29812 15.015C7.30652 19.269 10.7613 22.7097 15.0144 22.7016C19.2675 22.6935 22.7106 19.239 22.7025 14.985C22.6944 10.731 19.2387 7.28937 14.985 7.29777C10.7313 7.30617 7.29002 10.7616 7.29812 15.015ZM9.99992 15.0096C9.99797 14.0206 10.2893 13.0533 10.8371 12.23C11.3849 11.4067 12.1645 10.7642 13.0774 10.384C13.9903 10.0037 14.9955 9.90272 15.9658 10.0937C16.9361 10.2847 17.828 10.7592 18.5286 11.4571C19.2293 12.155 19.7072 13.045 19.9021 14.0145C20.0969 14.984 19.9999 15.9896 19.6233 16.904C19.2467 17.8184 18.6073 18.6005 17.7862 19.1516C16.965 19.7026 15.9988 19.9978 15.0099 19.9998C14.3533 20.0011 13.7028 19.8732 13.0956 19.6231C12.4884 19.3731 11.9365 19.0059 11.4712 18.5425C11.006 18.0791 10.6366 17.5285 10.3842 16.9224C10.1317 16.3162 10.0011 15.6662 9.99992 15.0096Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5917_22025">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const WhiteLinkedinIcon = ({ color }: { color?: string }) => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.9368 25.3516H21.4264V18.4474C21.4264 16.8011 21.3964 14.6817 19.0806 14.6817C16.7315 14.6817 16.372 16.4755 16.372 18.3276V25.3511H11.8617V11.1534H16.1916V13.0937H16.2522C16.6856 12.3695 17.3117 11.7737 18.064 11.3698C18.8164 10.966 19.6667 10.7691 20.5244 10.8002C25.0958 10.8002 25.9387 13.7393 25.9387 17.5629L25.9368 25.3516ZM6.77254 9.21266C6.25487 9.21275 5.74878 9.0628 5.3183 8.78175C4.88782 8.50071 4.55229 8.1012 4.3541 7.63374C4.15591 7.16629 4.10397 6.65189 4.20487 6.1556C4.30577 5.6593 4.55498 5.20339 4.92096 4.84553C5.28695 4.48767 5.75328 4.24392 6.26099 4.14511C6.7687 4.04631 7.29497 4.09688 7.77327 4.29044C8.25158 4.48399 8.66042 4.81183 8.9481 5.23251C9.23578 5.65319 9.38939 6.1478 9.38948 6.65381C9.38954 6.98978 9.32189 7.32247 9.19041 7.6329C9.05893 7.94332 8.86621 8.22539 8.6232 8.463C8.3802 8.70061 8.09167 8.88911 7.77414 9.01774C7.4566 9.14637 7.11626 9.2126 6.77254 9.21266ZM9.0277 25.3516H4.51268V11.1534H9.0277V25.3516ZM28.1854 0.001783H2.24624C1.6575 -0.00471121 1.09017 0.217529 0.668981 0.619669C0.247789 1.02181 0.00718531 1.57094 0 2.14641V27.606C0.00693938 28.1817 0.247401 28.7312 0.66858 29.1338C1.08976 29.5363 1.65721 29.759 2.24624 29.7529H28.1854C28.7756 29.7601 29.3446 29.5381 29.7674 29.1355C30.1903 28.733 30.4324 28.1828 30.4405 27.606V2.14457C30.4321 1.56797 30.1899 1.01821 29.767 0.616076C29.3442 0.213946 28.7753 -0.00765944 28.1854 -5.46843e-05"
      fill={color ? color : "white"}
    />
  </svg>
);

// Chevron Down Icon Component
export const ChevronDown = ({ isOpen }: { isOpen: boolean }) => (
  <svg
    className={`w-4 h-4 transition-transform duration-200 ${isOpen ? "rotate-180" : ""
      }`}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 9l-7 7-7-7"
    />
  </svg>
);

export const EligibilityGradient = () => (
  <svg
    className="w-full h-full"
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="120"
      height="120"
      rx="16"
      fill="url(#paint0_linear_6131_22389)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.3751 68.513C41.2609 68.5166 41.1473 68.4971 41.0408 68.4559C40.9343 68.4147 40.8372 68.3525 40.7553 68.273C40.6733 68.1936 40.6081 68.0985 40.5636 67.9934C40.5191 67.8883 40.4962 67.7754 40.4962 67.6612C40.4962 67.5471 40.5191 67.4342 40.5636 67.3291C40.6081 67.224 40.6733 67.1289 40.7553 67.0494C40.8372 66.97 40.9343 66.9078 41.0408 66.8666C41.1473 66.8254 41.2609 66.8059 41.3751 66.8095H62.6162C62.8376 66.8163 63.0478 66.909 63.202 67.068C63.3563 67.227 63.4425 67.4398 63.4425 67.6612C63.4425 67.8827 63.3563 68.0955 63.202 68.2545C63.0478 68.4135 62.8376 68.5062 62.6162 68.513H41.3751ZM41.3751 76.1804C41.1489 76.1804 40.9321 76.0906 40.7722 75.9308C40.6123 75.771 40.5224 75.5542 40.5224 75.3282C40.5224 75.1022 40.6123 74.8854 40.7722 74.7256C40.9321 74.5658 41.1489 74.476 41.3751 74.476H64.8532C65.0793 74.476 65.2962 74.5658 65.4561 74.7256C65.616 74.8854 65.7058 75.1022 65.7058 75.3282C65.7058 75.5542 65.616 75.771 65.4561 75.9308C65.2962 76.0906 65.0793 76.1804 64.8532 76.1804H41.3751ZM41.3751 83.8478C41.1489 83.8478 40.9321 83.758 40.7722 83.5982C40.6123 83.4384 40.5224 83.2216 40.5224 82.9956C40.5224 82.7696 40.6123 82.5528 40.7722 82.393C40.9321 82.2332 41.1489 82.1434 41.3751 82.1434H72.2318C72.4579 82.1434 72.6747 82.2332 72.8346 82.393C72.9945 82.5528 73.0844 82.7696 73.0844 82.9956C73.0844 83.2216 72.9945 83.4384 72.8346 83.5982C72.6747 83.758 72.4579 83.8478 72.2318 83.8478H41.3751ZM34.1985 33.9582H40.0408C40.4152 33.9548 40.7732 33.8044 41.0377 33.5395C41.3021 33.2746 41.4517 32.9164 41.4543 32.5422V26.706L34.1985 33.9582ZM70.5039 65.6745C70.8927 63.2562 72.1084 61.0475 73.9439 59.4246C75.7793 57.8017 78.1209 56.8651 80.5697 56.7743C83.0186 56.6836 85.4232 57.4442 87.3738 58.9267C89.3245 60.4093 90.7006 62.5219 91.2676 64.9048C91.8346 67.2876 91.5575 69.7933 90.4834 71.9948C89.4094 74.1964 87.6049 75.9576 85.3774 76.9785C83.1499 77.9994 80.6371 78.2168 78.2672 77.5936C75.8973 76.9704 73.8169 75.5452 72.3805 73.5608C71.5633 72.4347 70.9768 71.1583 70.6547 69.8049C70.3327 68.4515 70.2814 67.0478 70.5039 65.6745ZM75.7529 60.1469C74.0873 61.3523 72.8912 63.0975 72.3684 65.0853C71.8456 67.0731 72.0285 69.1806 72.8858 71.0488C73.7432 72.9169 75.222 74.4303 77.0703 75.331C78.9187 76.2317 81.0223 76.4641 83.0229 75.9886C85.0235 75.5131 86.7972 74.3591 88.0421 72.7232C89.2869 71.0872 89.9258 69.0705 89.85 67.0166C89.7742 64.9626 88.9883 62.9985 87.6262 61.4587C86.2641 59.9189 84.4101 58.8986 82.3799 58.5718C81.226 58.3848 80.0464 58.4277 78.9091 58.698C77.7718 58.9684 76.6992 59.4608 75.7529 60.1469ZM66.261 64.9936C66.5678 63.0627 67.2534 61.2115 68.2783 59.5463C69.3033 57.8812 70.6474 56.4349 72.2334 55.2906C73.8168 54.1427 75.6116 53.3189 77.5146 52.8664C79.4176 52.4139 81.3913 52.3418 83.3223 52.6541C83.9779 52.7599 84.6258 52.9088 85.2619 53.0999V26.9128C85.2602 26.5386 85.1107 26.1803 84.846 25.9157C84.5813 25.6511 84.2227 25.5017 83.8484 25.5H43.1587V32.5373C43.1576 33.3633 42.8287 34.1551 42.2441 34.7389C41.6596 35.3227 40.8671 35.6508 40.0408 35.6513H33V93.1178C33.0017 93.4919 33.1512 93.8503 33.4159 94.1149C33.6806 94.3795 34.0391 94.5289 34.4135 94.5306H83.8516C84.226 94.5289 84.5845 94.3795 84.8492 94.1149C85.1139 93.8503 85.2634 93.4919 85.2651 93.1178V81.6062C82.8484 82.3346 80.2862 82.4371 77.819 81.9042C75.3518 81.3714 73.0606 80.2205 71.1605 78.5598C69.2603 76.8991 67.8136 74.7829 66.9562 72.41C66.0987 70.0372 65.8587 67.4854 66.2586 64.9944L66.261 64.9936ZM73.2007 56.6913C70.6114 58.5769 68.7968 61.3397 68.0955 64.4642C67.3943 67.5887 67.8544 70.8615 69.3899 73.6719C70.9254 76.4823 73.4315 78.6383 76.4405 79.7377C79.4495 80.837 82.7559 80.8047 85.7427 79.6466C85.7831 79.6267 85.825 79.6099 85.868 79.5965L85.9658 79.5569C86.1421 79.4845 86.3377 79.4734 86.5211 79.5256C86.7045 79.5777 86.865 79.6901 86.9768 79.8445L88.1559 81.4737C88.2915 81.6593 88.4948 81.784 88.7217 81.8207C88.9486 81.8574 89.1809 81.8033 89.3682 81.67L91.9317 79.8122C92.1176 79.6768 92.2424 79.4734 92.2789 79.2464C92.3154 79.0195 92.2606 78.7873 92.1264 78.6005L90.9506 76.9712C90.8343 76.8111 90.7775 76.6155 90.79 76.418C90.8025 76.2206 90.8836 76.0337 91.0193 75.8896C92.9263 73.6448 94.0268 70.8267 94.1454 67.8842C94.2641 64.9418 93.394 62.0443 91.6739 59.6534C91.6568 59.6325 91.6409 59.6106 91.6262 59.588C89.5753 56.7714 86.4923 54.8807 83.0511 54.329C79.6098 53.7773 76.0899 54.6095 73.2606 56.6436C73.2395 56.6606 73.2177 56.676 73.1959 56.6905L73.2007 56.6913ZM94.9429 86.5538C94.3818 86.9778 94.0055 87.6015 93.8923 88.2954C93.7806 88.982 93.9463 89.6848 94.353 90.2494L98.6726 96.2891L98.6783 96.2972C98.7562 96.4023 98.8723 96.4727 99.0015 96.4934C99.1349 96.515 99.2714 96.483 99.3814 96.4046L99.3895 96.3989L102.784 93.9207C102.896 93.8371 102.971 93.713 102.992 93.575C103.004 93.5049 103.002 93.4332 102.986 93.3639C102.971 93.2945 102.941 93.229 102.9 93.1711L98.5853 87.1378L98.5651 87.1096C98.1612 86.5601 97.5571 86.1916 96.8835 86.0838C96.2099 85.976 95.5209 86.1376 94.9655 86.5336L94.9437 86.549L94.9429 86.5538ZM90.5586 82.9124L92.8538 81.2532L95.2339 84.5368C94.7839 84.6721 94.3593 84.8806 93.9772 85.1539V85.158L93.9359 85.1879C93.5556 85.4734 93.2231 85.8175 92.9508 86.2073L90.5602 82.9124H90.5586ZM60.7032 43.1539C61.0677 43.5162 61.2951 43.9937 61.3468 44.5049C61.3985 45.0161 61.2713 45.5294 60.9867 45.9573C60.7022 46.3852 60.278 46.7013 59.7864 46.8516C59.2949 47.0019 58.7664 46.9772 58.291 46.7817C57.8156 46.5861 57.4228 46.2319 57.1794 45.7793C56.9361 45.3267 56.8574 44.8037 56.9566 44.2996C57.0558 43.7955 57.3269 43.3413 57.7236 43.0145C58.1203 42.6878 58.6181 42.5086 59.1321 42.5076C59.4237 42.5067 59.7125 42.5633 59.9822 42.6742C60.2518 42.7851 60.4968 42.9481 60.7032 43.1539ZM59.1321 40.7992C60.0407 40.798 60.9215 41.1118 61.6244 41.6871C62.3274 42.2624 62.809 43.0636 62.9871 43.954C63.1652 44.8445 63.0288 45.7691 62.6012 46.5703C62.1736 47.3716 61.4812 47.9997 60.642 48.3478C59.8029 48.6959 58.869 48.7423 57.9994 48.4791C57.1299 48.2159 56.3786 47.6595 55.8735 46.9046C55.3685 46.1498 55.1411 45.2432 55.2299 44.3395C55.3188 43.4357 55.7185 42.5908 56.3609 41.9487C56.725 41.5838 57.1575 41.2944 57.6338 41.0971C58.1101 40.8999 58.6206 40.7986 59.1362 40.7992H59.1321ZM52.8858 54.9166C53.4728 53.7659 54.3667 52.7998 55.4687 52.1251C56.5707 51.4504 57.8378 51.0933 59.1301 51.0933C60.4224 51.0933 61.6896 51.4504 62.7915 52.1251C63.8935 52.7998 64.7874 53.7659 65.3744 54.9166C63.5941 56.3159 61.395 57.0766 59.1301 57.0766C56.8653 57.0766 54.6662 56.3159 52.8858 54.9166ZM66.2747 39.842C68.1008 41.6675 69.1579 44.1227 69.229 46.7031C69.3001 49.2835 68.3797 51.7931 66.657 53.7163C65.891 52.4002 64.7929 51.3081 63.4725 50.549C62.152 49.79 60.6554 49.3905 59.1321 49.3905C57.6089 49.3905 56.1122 49.79 54.7918 50.549C53.4713 51.3081 52.3733 52.4002 51.6073 53.7163C49.8627 51.7557 48.9503 49.1933 49.0632 46.5719C49.1761 43.9505 50.3054 41.476 52.2121 39.6725C54.1187 37.869 56.6528 36.8781 59.2778 36.9097C61.9027 36.9414 64.4122 37.993 66.2747 39.842ZM59.1321 35.1811C56.4009 35.1812 53.7541 36.1278 51.6428 37.8596C49.5314 39.5915 48.0862 42.0015 47.5534 44.679C47.0205 47.3565 47.433 50.1358 48.7205 52.5434C50.008 54.9511 52.0909 56.838 54.6143 57.8827C57.1376 58.9275 59.9454 59.0654 62.5591 58.273C65.1728 57.4806 67.4307 55.8069 68.9482 53.537C70.4657 51.2672 71.1488 48.5417 70.8812 45.8249C70.6136 43.1081 69.4118 40.568 67.4805 38.6376C66.3855 37.5401 65.0842 36.6698 63.6515 36.0766C62.2188 35.4834 60.6829 35.1791 59.1321 35.1811ZM76.7801 68.3426L79.5166 70.3491C79.6799 70.4696 79.881 70.5277 80.0835 70.5129C80.286 70.4981 80.4765 70.4113 80.6205 70.2683L85.2465 65.6446C85.3996 65.4835 85.4836 65.2689 85.4806 65.0467C85.4777 64.8245 85.388 64.6123 85.2308 64.4552C85.0735 64.2981 84.8611 64.2086 84.6388 64.2058C84.4165 64.2031 84.2019 64.2872 84.0407 64.4403L79.932 68.5454L77.7855 66.9718C77.6953 66.9058 77.593 66.8583 77.4843 66.8318C77.3757 66.8054 77.263 66.8005 77.1525 66.8176C77.042 66.8347 76.936 66.8734 76.8405 66.9315C76.745 66.9895 76.6619 67.0658 76.5959 67.156C76.5299 67.2462 76.4823 67.3484 76.4558 67.457C76.4293 67.5655 76.4245 67.6782 76.4416 67.7887C76.4587 67.8991 76.4974 68.005 76.5555 68.1005C76.6136 68.1959 76.6899 68.279 76.7801 68.345V68.3426Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6131_22389"
        x1="105.926"
        y1="0.499999"
        x2="8.14816"
        y2="120.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
    </defs>
  </svg>
);

export const InstitutesGradient = () => (
  <svg
    className="w-full h-full"
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="120"
      height="120"
      rx="16"
      fill="url(#paint0_linear_6131_22436)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.0966 85.6726H35.9314C35.5378 85.6726 35.2182 85.347 35.2182 84.9534V82.2956C35.2182 81.9019 35.5437 81.5823 35.9314 81.5823H47.1831C47.5767 81.5823 47.8963 81.9019 47.8963 82.2956V84.9563C47.8963 85.35 47.5767 85.6755 47.1831 85.6755H54.3802C53.9867 85.6755 53.667 85.35 53.667 84.9563V82.2956C53.667 81.9019 53.9926 81.5823 54.3802 81.5823H65.632C66.0256 81.5823 66.3452 81.9019 66.3452 82.2956V84.9563C66.3452 85.35 66.0256 85.6755 65.632 85.6755H72.8291C72.4355 85.6755 72.11 85.35 72.11 84.9563L72.107 82.2956C72.107 81.9019 72.4325 81.5823 72.8261 81.5823H84.0778C84.4714 81.5823 84.797 81.9019 84.797 82.2956V84.9563C84.797 85.35 84.4714 85.6755 84.0778 85.6755H85.9127C88.2831 85.6755 90.2688 87.41 90.6564 89.677L29.3568 89.6741C29.7415 87.4099 31.7272 85.6726 34.0977 85.6726L34.0966 85.6726ZM67.2798 49.813C62.4531 50.843 57.6501 50.843 52.8265 49.813H29.3564C29.75 52.0772 31.7268 53.8145 34.1002 53.8145H35.935C35.5414 53.8145 35.2218 54.1341 35.2218 54.5278V57.1885C35.2218 57.5821 35.5473 57.9018 35.935 57.9018H47.1867C47.5803 57.9018 47.8999 57.5821 47.8999 57.1885V54.5278C47.8999 54.1341 47.5803 53.8145 47.1867 53.8145H54.3838C53.9902 53.8145 53.6706 54.1341 53.6706 54.5278V57.1885C53.6706 57.5821 53.9961 57.9018 54.3838 57.9018H65.6355C66.0291 57.9018 66.3487 57.5821 66.3487 57.1885V54.5278C66.3487 54.1341 66.0291 53.8145 65.6355 53.8145H72.8326C72.439 53.8145 72.1135 54.1341 72.1135 54.5278V57.1885C72.1135 57.5821 72.439 57.9018 72.8326 57.9018H84.0844C84.478 57.9018 84.8035 57.5821 84.8035 57.1885V54.5278C84.8035 54.1341 84.478 53.8145 84.0844 53.8145H85.9192C88.2896 53.8145 90.2753 52.0801 90.663 49.813H67.2798ZM91.7894 92.0833H28.2109C26.4471 92.0833 25 93.5307 25 95.2946V97.3191C25 97.9702 25.5386 98.5 26.1896 98.5H93.8136C94.4647 98.5 94.9944 97.9702 94.9944 97.3191V95.2946C94.9944 93.5307 93.5532 92.0833 91.7894 92.0833ZM93.562 40.4541L79.0905 35.1977C78.8922 35.3486 78.6732 35.4848 78.4454 35.5913L72.0355 38.6457V44.7663C72.0355 45.7282 71.7691 46.6309 71.2927 47.3886H92.8249C94.0204 47.3886 95 46.4119 95 45.2132V42.4933C94.9941 41.5698 94.4409 40.7738 93.562 40.4541ZM27.1812 47.3886H48.796C48.3254 46.6221 48.0532 45.7223 48.0532 44.7604V43.8044C47.4998 44.5325 46.6445 44.9706 45.7124 44.9706H42.5311C41.4776 44.9706 40.5158 44.4171 39.992 43.4996C39.4622 42.5821 39.4622 41.4751 39.992 40.5665L40.501 39.6875V35.3456L26.4386 40.454C25.5596 40.7737 25.0004 41.5669 25.0004 42.4992V45.2191C25.0063 46.4177 25.9856 47.3886 27.1812 47.3886ZM48.0535 40.2203V38.6457L47.7517 38.5007V39.6964L48.0535 40.2203ZM38.1276 60.3223V79.1576H44.9695V60.3223H38.1276ZM75.0306 60.3223V79.1576H81.8785V60.3223H75.0306ZM56.5764 60.3223V79.1576H63.4184V60.3223H56.5764ZM58.4704 43.6064L50.471 39.7943V44.7636C50.471 45.9534 51.2582 46.9597 52.4182 47.2409C57.1976 48.3922 62.2374 48.558 67.6769 47.2498C68.8369 46.9686 69.6241 45.9623 69.6241 44.7725V39.8032L61.6247 43.6152C60.6126 44.0858 59.4706 44.0858 58.4704 43.6064ZM42.5224 42.5527H45.7036C45.893 42.5527 46.0588 42.4551 46.1505 42.2952C46.2482 42.1295 46.2482 41.9401 46.1505 41.7714L45.3159 40.333V34.6592L59.4973 41.4192C59.8376 41.5849 60.2253 41.5849 60.5656 41.4192L77.3925 33.4044C77.7712 33.2239 77.9843 32.9042 77.9843 32.5165C77.9843 32.1377 77.7653 31.8121 77.3925 31.6286L60.5777 23.6199C60.2374 23.46 59.8497 23.46 59.5094 23.6199L42.6826 31.6346C42.3126 31.8152 42.0907 32.1437 42.0907 32.5226C42.0907 32.9014 42.3097 33.227 42.6826 33.4105L42.9104 33.517V40.345L42.0759 41.7834C41.9782 41.9492 41.9782 42.1386 42.0759 42.3073C42.1735 42.4553 42.333 42.5527 42.5224 42.5527Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6131_22436"
        x1="105.926"
        y1="0.499999"
        x2="8.14816"
        y2="120.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
    </defs>
  </svg>
);

export const ProgramGradient = () => (
  <svg
    className="h-full w-full"
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="120"
      height="120"
      rx="16"
      fill="url(#paint0_linear_6131_22415)"
    />
    <path
      d="M86.8235 27.5L61.1627 29.748L61.2059 84.3743L86.8234 81.1698L86.8235 27.5ZM33.1514 27.5352V81.2415L58.8738 84.3913L58.8306 29.7512L54.1845 29.3503L54.2072 40.2414C54.2087 40.4869 54.1328 40.7266 53.9901 40.9264C53.8474 41.1262 53.6454 41.2759 53.4127 41.3541C53.18 41.4323 52.9285 41.4351 52.6942 41.362C52.4598 41.289 52.2544 41.1439 52.1073 40.9474L49.5246 37.5038L46.9419 40.9474C46.7942 41.1396 46.5902 41.281 46.3584 41.352C46.1266 41.4229 45.8784 41.4197 45.6485 41.3431C45.4185 41.2664 45.2181 41.1201 45.0752 40.9242C44.9323 40.7284 44.854 40.4929 44.8511 40.2505L44.817 28.5417L33.1514 27.5352ZM47.1491 28.7401L47.1742 36.7546L48.5953 34.8621C48.7041 34.7187 48.8446 34.6023 49.0058 34.5222C49.167 34.4421 49.3446 34.4005 49.5246 34.4005C49.7046 34.4005 49.8821 34.4421 50.0433 34.5222C50.2045 34.6023 50.345 34.7187 50.4538 34.8621L51.8659 36.7388L51.8476 29.1455L47.1491 28.7401ZM93.8292 29.5942L89.1557 29.6075V82.3207C89.155 82.605 89.0505 82.8793 88.8617 83.0919C88.673 83.3046 88.4131 83.4409 88.1308 83.4754L60.1287 86.9782C60.0349 86.9896 59.9401 86.9896 59.8463 86.9782L31.8441 83.5437C31.5607 83.5091 31.2999 83.3718 31.111 83.1577C30.9221 82.9436 30.8183 82.6677 30.8193 82.3822V29.8375L26.1617 29.8595C26.0072 29.8601 25.8544 29.8914 25.7121 29.9515C25.5698 30.0117 25.4409 30.0995 25.3328 30.2099C25.2248 30.3203 25.1397 30.451 25.0826 30.5946C25.0255 30.7381 24.9975 30.8916 25.0002 31.0461L26.1959 89.2367C26.2013 89.542 26.3262 89.833 26.5438 90.0472C26.7614 90.2614 27.0544 90.3818 27.3597 90.3823L55.1113 90.3735L59.45 92.5759C59.6121 92.6593 59.7916 92.7036 59.9739 92.7051C60.1562 92.7067 60.3364 92.6654 60.4999 92.5846L64.9935 90.3732L92.6494 90.3643C92.9559 90.3655 93.2506 90.2461 93.4697 90.0317C93.6888 89.8173 93.8147 89.5253 93.8201 89.2188L94.9998 30.7798C95.0025 30.6245 94.9742 30.4704 94.9166 30.3262C94.8589 30.1821 94.773 30.0509 94.664 29.9404C94.5549 29.8298 94.4249 29.7423 94.2816 29.6827C94.1382 29.623 93.9844 29.5935 93.8292 29.5942ZM83.2592 37.2877C83.5681 37.2888 83.8639 37.4123 84.0819 37.631C84.2999 37.8498 84.4223 38.146 84.4223 38.4548C84.4223 38.7637 84.2999 39.06 84.0819 39.2788C83.8639 39.4976 83.5681 39.621 83.2592 39.6222L66.9726 39.6574C66.8173 39.6609 66.6628 39.6333 66.5182 39.5763C66.3736 39.5193 66.2419 39.4339 66.1308 39.3253C66.0197 39.2167 65.9314 39.087 65.8711 38.9437C65.8108 38.8005 65.7798 38.6467 65.7798 38.4913C65.7798 38.3359 65.8108 38.1821 65.8711 38.0388C65.9314 37.8956 66.0197 37.7659 66.1308 37.6573C66.2419 37.5486 66.3736 37.4633 66.5182 37.4063C66.6628 37.3493 66.8173 37.3216 66.9726 37.3252L83.2592 37.2877ZM55.3004 44.2865C55.4556 44.2831 55.61 44.3108 55.7545 44.3678C55.8989 44.4249 56.0305 44.5102 56.1416 44.6188C56.2526 44.7274 56.3408 44.8571 56.401 45.0002C56.4612 45.1434 56.4923 45.2972 56.4923 45.4526C56.4923 45.6079 56.4612 45.7616 56.401 45.9048C56.3408 46.0479 56.2526 46.1777 56.1416 46.2863C56.0305 46.3949 55.8989 46.4802 55.7545 46.5373C55.61 46.5944 55.4556 46.6221 55.3004 46.6187L36.6816 46.6539C36.528 46.6545 36.3757 46.6246 36.2336 46.5662C36.0915 46.5078 35.9624 46.4219 35.8535 46.3135C35.7447 46.2051 35.6584 46.0762 35.5994 45.9343C35.5405 45.7925 35.5102 45.6404 35.5102 45.4867C35.5102 45.3331 35.5405 45.1809 35.5994 45.039C35.6584 44.8971 35.7447 44.7683 35.8535 44.6598C35.9624 44.5514 36.0915 44.4655 36.2336 44.4071C36.3757 44.3487 36.528 44.3189 36.6816 44.3194L55.3004 44.2865ZM83.2592 44.2865C83.4145 44.2831 83.5689 44.3108 83.7133 44.3678C83.8578 44.4249 83.9894 44.5102 84.1004 44.6188C84.2114 44.7274 84.2997 44.8571 84.3599 45.0002C84.4201 45.1434 84.4511 45.2972 84.4511 45.4526C84.4511 45.6079 84.4201 45.7616 84.3599 45.9048C84.2997 46.0479 84.2114 46.1777 84.1004 46.2863C83.9894 46.3949 83.8578 46.4802 83.7133 46.5373C83.5689 46.5944 83.4145 46.6221 83.2592 46.6187L64.6405 46.6539C64.4868 46.6545 64.3346 46.6246 64.1925 46.5662C64.0504 46.5078 63.9212 46.4219 63.8124 46.3135C63.7036 46.2051 63.6172 46.0762 63.5583 45.9343C63.4994 45.7925 63.4691 45.6404 63.4691 45.4867C63.4691 45.3331 63.4994 45.1809 63.5583 45.039C63.6172 44.8971 63.7036 44.7683 63.8124 44.6598C63.9212 44.5514 64.0504 44.4655 64.1925 44.4071C64.3346 44.3487 64.4868 44.3189 64.6405 44.3194L83.2592 44.2865ZM55.3004 51.2853C55.6052 51.2919 55.8953 51.4178 56.1085 51.6358C56.3218 51.8537 56.4412 52.1465 56.4412 52.4514C56.4412 52.7563 56.3218 53.0492 56.1085 53.2671C55.8953 53.4851 55.6052 53.6108 55.3004 53.6175L36.6816 53.644C36.5213 53.6565 36.3602 53.6357 36.2083 53.5829C36.0564 53.5302 35.9171 53.4465 35.799 53.3373C35.681 53.2281 35.5869 53.0957 35.5224 52.9484C35.458 52.801 35.4248 52.642 35.4248 52.4812C35.4248 52.3204 35.458 52.1614 35.5224 52.0141C35.5869 51.8668 35.681 51.7343 35.799 51.6251C35.9171 51.516 36.0564 51.4324 36.2083 51.3797C36.3602 51.3269 36.5213 51.3061 36.6816 51.3186L55.3004 51.2853ZM83.2592 51.2853C83.5641 51.2919 83.8542 51.4178 84.0674 51.6358C84.2806 51.8537 84.4 52.1465 84.4 52.4514C84.4 52.7563 84.2806 53.0492 84.0674 53.2671C83.8542 53.4851 83.5641 53.6108 83.2592 53.6175L64.6405 53.644C64.4802 53.6565 64.319 53.6357 64.1671 53.5829C64.0153 53.5302 63.8759 53.4465 63.7579 53.3373C63.6399 53.2281 63.5457 53.0957 63.4813 52.9484C63.4169 52.801 63.3837 52.642 63.3837 52.4812C63.3837 52.3204 63.4169 52.1614 63.4813 52.0141C63.5457 51.8668 63.6399 51.7343 63.7579 51.6251C63.8759 51.516 64.0153 51.4324 64.1671 51.3797C64.319 51.3269 64.4802 51.3061 64.6405 51.3186L83.2592 51.2853ZM55.3004 58.2841C55.605 58.291 55.8949 58.4169 56.1079 58.6348C56.3209 58.8528 56.4402 59.1454 56.4402 59.4502C56.4402 59.7549 56.3209 60.0476 56.1079 60.2655C55.8949 60.4834 55.605 60.6094 55.3004 60.6163L36.6816 60.6428C36.3768 60.6361 36.0866 60.5102 35.8734 60.2923C35.6602 60.0743 35.5408 59.7816 35.5408 59.4767C35.5408 59.1718 35.6602 58.8789 35.8734 58.6609C36.0866 58.443 36.3768 58.3172 36.6816 58.3106L55.3004 58.2841ZM83.2592 58.2841C83.5639 58.291 83.8537 58.4169 84.0668 58.6348C84.2798 58.8528 84.3991 59.1454 84.3991 59.4502C84.3991 59.7549 84.2798 60.0476 84.0668 60.2655C83.8537 60.4834 83.5639 60.6094 83.2592 60.6163L64.6405 60.6428C64.3356 60.6361 64.0455 60.5102 63.8323 60.2923C63.619 60.0743 63.4996 59.7816 63.4996 59.4767C63.4996 59.1718 63.619 58.8789 63.8323 58.6609C64.0455 58.443 64.3356 58.3172 64.6405 58.3106L83.2592 58.2841ZM55.4165 65.2784C55.4204 65.2784 55.4243 65.2784 55.4282 65.2784C55.5846 65.2818 55.7387 65.3164 55.8814 65.3805C56.0241 65.4446 56.1525 65.5368 56.2588 65.6515C56.3651 65.7663 56.4473 65.9013 56.5004 66.0485C56.5535 66.1956 56.5765 66.352 56.5679 66.5082C56.5594 66.6644 56.5195 66.8172 56.4506 66.9577C56.3817 67.0981 56.2853 67.2234 56.1671 67.3258C56.0488 67.4282 55.9112 67.5058 55.7623 67.5539C55.6135 67.602 55.4565 67.6197 55.3006 67.606L36.6819 67.6412C36.3771 67.6345 36.0869 67.5088 35.8737 67.2908C35.6605 67.0729 35.5411 66.7801 35.5411 66.4752C35.5411 66.1703 35.6605 65.8774 35.8737 65.6595C36.0869 65.4415 36.3771 65.3158 36.6819 65.3091L55.3006 65.2826C55.3393 65.2792 55.3777 65.278 55.4165 65.2784ZM83.3754 65.2784C83.3792 65.2784 83.383 65.2784 83.3868 65.2784C83.5432 65.2818 83.6974 65.3164 83.8401 65.3805C83.9828 65.4446 84.1111 65.5368 84.2174 65.6515C84.3238 65.7663 84.4059 65.9013 84.459 66.0485C84.5121 66.1956 84.5351 66.352 84.5265 66.5082C84.518 66.6644 84.4781 66.8172 84.4092 66.9577C84.3404 67.0981 84.2439 67.2234 84.1257 67.3258C84.0075 67.4282 83.8698 67.5058 83.721 67.5539C83.5721 67.602 83.4151 67.6197 83.2593 67.606L64.6405 67.6412C64.3357 67.6345 64.0456 67.5088 63.8323 67.2908C63.6191 67.0729 63.4997 66.7801 63.4997 66.4752C63.4997 66.1703 63.6191 65.8774 63.8323 65.6595C64.0456 65.4415 64.3357 65.3158 64.6405 65.3091L83.2593 65.2826C83.2979 65.2792 83.3366 65.278 83.3754 65.2784ZM55.3004 72.2704C55.6092 72.2715 55.905 72.395 56.123 72.6138C56.341 72.8325 56.4634 73.1287 56.4634 73.4376C56.4634 73.7464 56.341 74.0427 56.123 74.2615C55.905 74.4803 55.6092 74.6038 55.3004 74.6049L36.6816 74.6401C36.3769 74.6332 36.0871 74.5073 35.8741 74.2894C35.661 74.0714 35.5418 73.7788 35.5418 73.474C35.5418 73.1693 35.661 72.8766 35.8741 72.6587C36.0871 72.4408 36.3769 72.3148 36.6816 72.3079L55.3004 72.2704ZM83.2592 72.2704C83.5681 72.2715 83.8639 72.395 84.0819 72.6138C84.2999 72.8325 84.4223 73.1287 84.4223 73.4376C84.4223 73.7464 84.2999 74.0427 84.0819 74.2615C83.8639 74.4803 83.5681 74.6038 83.2592 74.6049L64.6405 74.6401C64.3358 74.6332 64.0459 74.5073 63.8329 74.2894C63.6199 74.0714 63.5006 73.7788 63.5006 73.474C63.5006 73.1693 63.6199 72.8766 63.8329 72.6587C64.0459 72.4408 64.3358 72.3148 64.6405 72.3079L83.2592 72.2704Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6131_22415"
        x1="105.926"
        y1="0.499999"
        x2="8.14816"
        y2="120.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
    </defs>
  </svg>
);

export const ScholarshipGradient = () => (
  <svg
    className="w-full h-full"
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="120"
      height="120"
      rx="16"
      fill="url(#paint0_linear_6131_22509)"
    />
    <path
      d="M90.797 37.9844C89.7419 37.9844 88.8867 38.8395 88.8867 39.8947V51.1224C88.8867 52.1775 89.7419 53.0327 90.797 53.0327C91.8522 53.0327 92.7074 52.1775 92.7074 51.1224V39.8947C92.7074 38.8395 91.8522 37.9844 90.797 37.9844Z"
      fill="white"
    />
    <path
      d="M91.6136 68.1796C91.2298 68.7715 90.3657 68.7714 89.9821 68.1794C88.4512 65.8171 86.5957 62.3249 86.5957 60.7165C86.5957 58.3991 88.4802 56.5137 90.7976 56.5137C93.115 56.5137 95.0005 58.3992 95.0005 60.7165C95.0005 62.3248 93.145 65.8176 91.6136 68.1796Z"
      fill="white"
    />
    <path
      d="M89.5871 33.3957L57.8045 22.0445C57.6383 21.9852 57.4567 21.9852 57.2905 22.0445L25.5071 33.3957C24.8309 33.6372 24.831 34.5935 25.5071 34.835L57.2905 46.1855C57.4567 46.2449 57.6383 46.2449 57.8045 46.1855L89.5871 34.835C90.2633 34.5935 90.2633 33.6372 89.5871 33.3957ZM52.5724 34.1154C52.5724 31.3723 54.8044 29.1411 57.5475 29.1411C59.7574 29.1411 61.6327 30.59 62.2792 32.5871H78.2252C79.0692 32.5871 79.7535 33.2714 79.7535 34.1154C79.7535 34.9594 79.0692 35.6436 78.2252 35.6436H62.2792C61.6326 37.6407 59.7574 39.0897 57.5475 39.0897C54.8044 39.0897 52.5724 36.8585 52.5724 34.1154Z"
      fill="white"
    />
    <path
      d="M57.034 49.34L38.0407 42.5569C37.543 42.3792 37.0195 42.7481 37.0195 43.2765V55.3293C37.0195 55.8189 37.4731 56.1763 37.9506 56.0679C42.8421 54.9575 47.7747 54.2556 52.6501 53.9789C52.6811 53.978 52.7121 53.9771 52.7432 53.9763L62.3978 53.9785C62.4243 53.9793 62.4675 53.9805 62.494 53.9812C67.3537 54.2601 72.2686 54.9606 77.1447 56.0678C77.6222 56.1762 78.0759 55.8188 78.0759 55.3292V43.2766C78.0759 42.7482 77.5524 42.3793 77.0548 42.557L58.0622 49.34C57.8958 49.399 57.722 49.4288 57.5481 49.4288C57.3742 49.4288 57.2004 49.3989 57.034 49.34Z"
      fill="white"
    />
    <path
      d="M77.9062 59.3942C72.736 58.1302 67.512 57.3333 62.3545 57.0354L52.7872 57.0332C47.6148 57.3291 42.3756 58.1267 37.1908 59.3942C37.1501 59.5026 37.1001 59.6088 37.033 59.7091C34.319 63.7663 32.8848 68.5019 32.8848 73.4038C32.8848 87.0037 43.949 98.0679 57.5489 98.0679C71.148 98.0679 82.2122 87.0037 82.2122 73.4038C82.2122 68.5019 80.778 63.7663 78.064 59.7091C77.9968 59.6088 77.9468 59.5026 77.9062 59.3942ZM65.9692 69.9578C65.9692 70.8017 65.2849 71.486 64.4409 71.486C63.597 71.486 62.9127 70.8017 62.9127 69.9578V69.2683C62.9127 68.2109 62.0523 67.3505 60.9949 67.3505H54.1021C53.0446 67.3505 52.1843 68.2109 52.1843 69.2683V72.715C52.1843 73.7725 53.0446 74.6328 54.1021 74.6328H60.9949C63.738 74.6328 65.9692 76.8648 65.9692 79.6079V83.0539C65.9692 85.797 63.738 88.0283 60.9949 88.0283H59.0771V90.6356C59.0771 91.4795 58.3928 92.1638 57.5488 92.1638C56.7049 92.1638 56.0206 91.4795 56.0206 90.6356V88.0283H54.1021C51.359 88.0283 49.1277 85.797 49.1277 83.0539V82.3644C49.1277 81.5205 49.812 80.8362 50.656 80.8362C51.5 80.8362 52.1843 81.5205 52.1843 82.3644V83.0539C52.1843 84.1114 53.0446 84.9717 54.1021 84.9717H60.9949C62.0523 84.9717 62.9127 84.1114 62.9127 83.0539V79.6079C62.9127 78.5497 62.0523 77.6894 60.9949 77.6894H54.1021C51.359 77.6894 49.1277 75.4582 49.1277 72.715V69.2683C49.1277 66.5252 51.359 64.2939 54.1021 64.2939H56.0206V61.6867C56.0206 60.8427 56.7049 60.1584 57.5488 60.1584C58.3928 60.1584 59.0771 60.8427 59.0771 61.6867V64.2939H60.9949C63.738 64.2939 65.9692 66.5252 65.9692 69.2683V69.9578Z"
      fill="white"
    />
    <path
      d="M59.4652 34.116C59.4652 33.0586 58.6048 32.1982 57.5474 32.1982C56.4893 32.1982 55.6289 33.0586 55.6289 34.116C55.6289 35.1734 56.4893 36.0338 57.5474 36.0338C58.6048 36.0338 59.4652 35.1734 59.4652 34.116Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6131_22509"
        x1="105.926"
        y1="-1.18719e-06"
        x2="8.14816"
        y2="120"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
    </defs>
  </svg>
);

export const ExpertGradient = () => (
  <svg
    className="w-full h-full"
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="120"
      height="120"
      rx="16"
      fill="url(#paint0_linear_6131_22480)"
    />
    <path
      d="M59.4805 45.5929C58.6478 46.431 57.6248 47.1498 56.9262 46.9834C56.3867 46.8485 56.0935 46.1453 55.8533 45.4109V45.4077C57.026 45.7875 58.2767 45.8503 59.4805 45.5929ZM37.7144 74.5373L36.3421 80.1779C36.9908 80.1779 37.6302 80.2375 38.2726 80.2783L37.7144 74.5373ZM30.9623 41.7671C30.2075 40.9918 29.9425 39.8618 30.273 38.8291C31.1806 36.4184 35.8525 35.2885 37.1842 35.0122C37.546 31.8513 38.7717 28.8505 40.7271 26.349C43.8365 22.5729 50.573 25.6458 51.8553 26.283C53.7889 25.7149 55.7631 25.2911 57.7591 25.0181C61.3862 24.4154 62.5246 25.9629 63.8563 27.7458C64.7826 29.1301 65.9833 30.3071 67.3805 31.2049C68.4284 31.7762 69.1363 32.8183 69.286 34.0079C69.601 36.8958 66.5821 40.1853 65.8679 40.9293C66.133 43.1674 65.4687 45.4148 64.0309 47.1412C62.2439 49.1408 59.1813 50.1546 54.9395 50.1546H54.3158V50.8734C51.5463 49.938 48.624 49.5488 45.7082 49.7277C46.6687 48.447 47.5451 47.1036 48.3373 45.7099C47.5264 45.7883 46.7343 45.4399 46.2415 44.7902C46.0731 44.4732 46.0232 44.109 46.098 43.7607C45.1811 44.2472 44.3391 44.8718 43.603 45.6095C42.658 46.4445 41.4261 46.8839 40.1692 46.8305H39.611C36.6263 46.5888 33.2327 44.5953 30.9623 41.7671ZM54.6246 39.8336C54.6246 39.256 54.8991 38.8699 55.0831 38.8699C55.2671 38.8699 55.5415 39.256 55.5415 39.8336H55.5384C55.5384 40.0878 55.7442 40.295 55.9969 40.295C56.2495 40.295 56.4522 40.0878 56.4522 39.8336C56.4522 38.7789 55.8534 37.9502 55.0799 37.9502C54.3064 37.9502 53.7076 38.7883 53.7076 39.8336C53.7076 40.0878 53.9134 40.295 54.1661 40.295C54.2877 40.295 54.4031 40.2448 54.4904 40.16C54.5746 40.0721 54.6246 39.956 54.6246 39.8336ZM61.2769 44.3442C61.1459 44.1841 60.9276 44.1308 60.7374 44.2124C59.0782 45.0379 57.1321 45.0379 55.4728 44.2124C55.32 44.1214 55.1298 44.1276 54.9832 44.2281C54.8397 44.3285 54.7618 44.5043 54.7898 44.6801C55.0799 46.5383 55.7286 47.6087 56.7204 47.8535C56.8607 47.8849 57.0073 47.9037 57.1508 47.9037C59.0064 47.9037 61.043 45.2168 61.3081 44.881H61.3112C61.411 44.7115 61.3923 44.498 61.2675 44.3442L61.2769 44.3442ZM57.7247 42.5864L59.0314 42.7873H59.0969C59.3214 42.7936 59.5148 42.6335 59.5554 42.4106L60.0045 39.8995C60.0512 39.6515 59.8859 39.413 59.6396 39.3659C59.5179 39.3408 59.3963 39.3659 59.2934 39.4349C59.1936 39.504 59.125 39.6107 59.1062 39.7331L58.732 41.7766L57.8587 41.6416C57.7308 41.6071 57.5967 41.6291 57.4876 41.6981C57.3784 41.7703 57.3036 41.8865 57.2848 42.0183C57.2661 42.147 57.3036 42.282 57.3878 42.3824C57.472 42.4829 57.5936 42.5425 57.7246 42.5456L57.7247 42.5864ZM63.9466 41.5976C63.9466 40.543 63.3385 39.7237 62.5743 39.7237C61.8102 39.7237 61.1927 40.5618 61.1927 41.5976V41.6008C61.1864 41.7232 61.2301 41.8456 61.3143 41.9398C61.4016 42.0308 61.517 42.0842 61.6418 42.0842C61.8944 42.0842 62.1002 41.8801 62.1002 41.6259C62.1002 41.0483 62.3841 40.6717 62.5649 40.6717C62.7489 40.6717 63.0234 41.0483 63.0234 41.6259C63.0234 41.8802 63.2292 42.0842 63.4819 42.0842C63.7345 42.0842 63.9372 41.8801 63.9372 41.6259L63.9466 41.5976ZM51.2472 31.6375C51.9053 31.9137 52.6132 32.0518 53.3274 32.0392C54.4845 32.033 55.626 31.7473 56.6521 31.2043C56.8829 31.0881 56.9764 30.8056 56.861 30.5765C56.7456 30.3442 56.4681 30.25 56.2373 30.3662C54.8588 31.1885 53.1902 31.3487 51.6808 30.8088C51.45 30.702 51.1755 30.7993 51.0695 31.0316C50.9603 31.2639 51.0602 31.537 51.2878 31.6468L51.2472 31.6375ZM50.7076 33.3136C50.6889 33.4329 50.7232 33.5553 50.795 33.6526C50.8698 33.7499 50.9759 33.8158 51.0975 33.8315C51.9676 33.9383 52.8409 33.9885 53.7172 33.9822C56.1124 33.9822 59.621 33.615 61.9352 31.7222C62.1317 31.5621 62.1629 31.2733 62.0038 31.0724C61.8479 30.8747 61.5578 30.8433 61.3613 31.0034C57.9338 33.8065 51.2911 32.9275 51.2224 32.9212V32.9181C51.1008 32.9024 50.9791 32.9338 50.8825 33.0091C50.7858 33.0813 50.7232 33.1912 50.7076 33.3136ZM47.9444 35.4732C47.2739 36.3426 47.171 37.5292 47.6887 38.5022C48.2127 39.8331 49.3635 40.8093 50.7576 41.1044C50.4083 41.8326 49.7503 43.1887 48.902 44.711V44.7142C48.8427 44.8209 48.8271 44.9465 48.8614 45.0626C48.8926 45.1819 48.9706 45.2823 49.0766 45.342C49.1452 45.3796 49.2232 45.4016 49.3012 45.3985C49.4665 45.4016 49.6193 45.3106 49.7004 45.1662C50.9822 42.8465 51.8554 40.9318 51.8617 40.9067V40.9035C51.9334 40.7685 51.9334 40.6053 51.8617 40.4704C51.7774 40.3417 51.634 40.2632 51.4812 40.26C50.1806 40.191 49.0392 39.3686 48.562 38.1507C48.2096 37.5072 48.2377 36.7225 48.6369 36.1072C48.9862 35.74 49.6755 35.7054 50.558 36.0319C54.5906 37.504 61.2119 34.6351 62.9429 33.8315H62.9397C63.8723 35.7556 64.5241 37.8054 64.8703 39.9178C64.8859 40.0403 64.9483 40.1501 65.0449 40.2223C65.1416 40.2977 65.2664 40.329 65.3849 40.3102C65.5065 40.2945 65.6157 40.2286 65.6874 40.1313C65.7623 40.034 65.7934 39.9116 65.7778 39.7923C65.3911 37.4255 64.6395 35.1341 63.5479 33.0028C63.4263 32.7862 63.1612 32.7046 62.9397 32.8113C62.8649 32.8521 55.0648 36.7036 50.8735 35.1718C49.1675 34.5503 48.3374 35.0965 47.9444 35.4732ZM34.5871 41.3336L34.5903 41.3304C34.6682 41.3869 34.7587 41.4152 34.8554 41.4152C35.0019 41.4152 35.1423 41.343 35.2296 41.2237C35.2296 41.1735 38.7133 36.3615 42.0316 35.7494C42.1844 35.7212 42.3154 35.6176 42.3747 35.4732C42.4339 35.3257 42.4152 35.1593 42.3248 35.0275C41.9599 34.5158 41.0928 32.984 41.411 32.0643H41.4079C41.5763 31.6814 41.9287 31.4052 42.3404 31.3361C45.1255 30.5482 48.4033 29.7541 48.4376 29.7447V29.7478C48.6809 29.6819 48.8274 29.4339 48.7682 29.1859C48.7089 28.9411 48.4626 28.7936 48.2193 28.8501C48.2193 28.8501 44.8915 29.6882 42.0909 30.4478V30.4509C41.386 30.5953 40.8059 31.0913 40.544 31.763C40.1604 32.8679 40.7841 34.2741 41.227 35.0023C37.7745 36.0821 34.6246 40.4923 34.4811 40.6869C34.3532 40.8909 34.4 41.1577 34.5903 41.3053L34.5871 41.3336ZM93.9932 57.2385C92.2561 57.2385 90.94 58.5193 90.2164 59.4829V59.4327L90.2195 59.4295C89.8484 58.8771 89.2683 58.5005 88.6133 58.3905C86.4177 57.8726 83.7574 62.2325 82.591 64.3922H82.5941C83.0494 66.0401 84.0381 67.4903 85.4041 68.5104C89.9044 67.1042 95.1941 60.1389 94.9945 58.1236C94.9852 57.8662 94.8729 57.6276 94.6858 57.4581C94.4986 57.2855 94.2491 57.2007 93.9965 57.2196L93.9932 57.2385ZM84.6463 69.104C82.5162 71.8066 73.8335 82.3282 69.012 79.7608C66.1926 78.2039 63.813 75.947 62.1008 73.2068C61.5862 76.4117 60.4385 84.7829 61.8264 87.5544C62.1881 87.9656 62.525 88.402 62.8337 88.8602C63.2547 89.4786 63.4076 90.2414 63.2579 90.9759C62.2317 89.5916 60.9188 88.449 59.4062 87.6297C59.1754 87.5199 58.9041 87.6203 58.7949 87.8495C58.6858 88.0817 58.7856 88.358 59.0163 88.4647C60.5477 89.3373 61.8575 90.5521 62.8493 92.0148C62.6404 92.3099 62.3784 92.5641 62.0759 92.7588C62.0166 92.7996 61.9574 92.8309 61.8919 92.8592C61.1309 91.3086 60.0799 89.9212 58.798 88.766C58.6047 88.6091 58.3209 88.6342 58.1587 88.8256C57.9996 89.0171 58.0215 89.3059 58.2086 89.4691C59.3563 90.5175 60.3075 91.7606 61.0186 93.1448C60.8814 93.1573 60.741 93.1573 60.6038 93.1448C59.8397 93.1448 59.113 92.8183 58.5984 92.2502C57.5412 91.0542 55.4703 89.0767 53.309 88.9009C53.2341 89.0045 53.1156 89.0673 52.9846 89.0767C52.8755 89.0767 44.9168 89.5381 37.8245 89.5381C35.4792 89.5381 33.2337 89.4879 31.3874 89.3529C30.3676 89.309 29.4226 88.7973 28.8269 87.9624C26.3974 84.6131 28.618 75.6421 30.4144 68.4414V68.4445C31.0849 65.9836 31.6213 63.4881 32.0268 60.9676C32.5414 56.2969 36.1093 55.1072 39.2623 54.0118C40.962 53.5723 42.5526 52.7908 43.9467 51.7203C44.2617 51.4284 44.5861 51.0831 44.9291 50.7002C47.1653 50.5495 51.1261 50.5338 54.32 51.8553V52.6432C56.3004 52.8692 64.0661 54.7871 72.0254 70.7829C74.3115 68.3722 77.6298 65.7198 81.7156 64.7405L81.7125 64.7342C82.2146 66.4637 83.2407 67.9924 84.6473 69.1036L84.6463 69.104ZM60.6878 86.4497C58.6169 84.6448 55.9348 83.722 53.2027 83.8695V83.8193C53.1934 83.6373 53.078 83.4772 52.9096 83.4113C48.4778 81.8355 43.8684 80.8091 39.1866 80.3539L38.357 71.8L38.7718 64.6433C38.7874 64.389 38.5971 64.1693 38.3445 64.1536C38.0919 64.1379 37.8736 64.3294 37.858 64.5836L37.4432 71.731L35.4035 80.1619C33.8535 80.1494 32.3034 80.2341 30.7628 80.4131C30.5133 80.4445 30.3355 80.6705 30.3636 80.9247C30.376 81.044 30.4384 81.157 30.532 81.2323C30.6287 81.3076 30.7503 81.3422 30.8719 81.3265C40.543 80.1557 50.5231 83.5017 52.3131 84.139L52.494 87.9119C52.4971 88.0344 52.547 88.1474 52.6312 88.229C52.7185 88.3137 52.8308 88.3577 52.9524 88.3577C53.2019 88.342 53.3984 88.1317 53.3922 87.8805L53.2518 84.773C55.7437 84.6537 58.1919 85.4981 60.0882 87.1335C60.1692 87.2057 60.2753 87.2465 60.3876 87.2433C60.5217 87.2433 60.6495 87.1868 60.7369 87.0833C60.8866 86.8918 60.8647 86.6156 60.687 86.4492L60.6878 86.4497ZM60.4975 63.1624H60.4944C60.2979 63.0306 60.0297 63.0714 59.8831 63.2597C59.7366 63.448 59.7553 63.718 59.9299 63.8812C60.0204 63.966 62.2846 65.8305 61.5423 68.5268C61.5111 68.6461 61.5267 68.7748 61.586 68.8815C61.6483 68.9882 61.7481 69.0667 61.8667 69.0981H61.9852C62.191 69.0981 62.375 68.9568 62.4249 68.7528C63.3076 65.4475 60.6129 63.222 60.4944 63.1278L60.4975 63.1624ZM71.7814 71.7099C71.6972 71.622 71.5818 71.575 71.4602 71.575C71.3416 71.575 71.2263 71.622 71.142 71.7099C70.3 72.6642 69.5328 73.6811 68.8466 74.7547C68.7624 74.8583 68.7281 74.9933 68.75 75.122C68.7718 75.2538 68.8498 75.3668 68.962 75.439C69.0743 75.508 69.2115 75.5237 69.3363 75.4861C69.461 75.4453 69.5639 75.3542 69.6201 75.2318C70.2844 74.2086 71.0235 73.2354 71.8313 72.3189C71.9716 72.1337 71.9498 71.87 71.7814 71.7099ZM66.7914 41.291C66.9785 43.6452 66.2269 45.9743 64.7049 47.7697C62.7744 49.9199 59.5745 51.0342 55.1991 51.119C55.171 51.2163 55.1336 51.3073 55.0806 51.3952C55.1741 51.5427 55.224 51.7122 55.224 51.888C58.1588 52.5252 65.1386 55.5197 72.2556 69.2555C74.7537 66.7443 77.8507 64.9144 81.2472 63.9412V45.9519C81.241 43.2963 79.1046 41.143 76.463 41.1399H66.9317L66.7914 41.291ZM28.0847 88.51C25.4057 84.7936 27.5951 75.9543 29.5225 68.22H29.5256C30.1899 65.7999 30.7201 63.3484 31.1131 60.8687C31.6963 55.611 35.7288 54.2393 38.9724 53.1344C40.5536 52.7358 42.0413 52.0232 43.3481 51.0439C43.6693 50.7425 43.9749 50.4255 44.2618 50.0896C44.4022 49.917 44.6018 49.8103 44.8201 49.7883C44.8076 49.5623 44.8731 49.3394 45.0103 49.1605C45.6185 48.3224 46.2485 47.4373 46.8972 46.3826V46.3794C46.3015 46.1974 45.7932 45.7925 45.4751 45.2495C45.0416 45.5696 44.6268 45.9086 44.2276 46.2727C43.1111 47.2646 41.6609 47.7888 40.1701 47.7355H39.5463C36.3184 47.4938 32.6694 45.3844 30.2489 42.3522V42.3554C29.9589 41.9881 29.7156 41.5895 29.5254 41.1657C26.9898 41.3007 25 43.4069 25 45.962V84.7243C25.0031 87.0973 26.7215 89.1125 29.0513 89.4798C28.6801 89.2099 28.3529 88.8835 28.0847 88.51ZM70.6931 81.0833C69.9602 81.0959 69.2398 80.9264 68.5879 80.5905C66.2988 79.335 64.2841 77.6242 62.6654 75.5682C61.9075 81.1524 61.8763 85.4216 62.5905 87.019C62.9492 87.4302 63.2829 87.8634 63.5885 88.3154C63.8443 88.6858 64.0314 89.1002 64.1374 89.5396H65.9682C66.3767 91.6866 67.6149 93.5857 69.4113 94.8192C71.3075 95.9775 73.4969 96.5582 75.7143 96.4954C76.6905 96.4954 77.6666 96.4075 78.6272 96.2254C78.8081 96.1878 78.9484 96.0434 78.9827 95.8613C79.0202 95.6793 78.9391 95.4909 78.7831 95.3905C75.6893 93.3408 75.6144 90.9552 75.9482 89.5301H76.4721C79.1106 89.527 81.2501 87.3736 81.2532 84.7181V74.4228C78.0845 77.7187 74.043 81.0833 70.6931 81.0833Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6131_22480"
        x1="105.926"
        y1="0.499999"
        x2="8.14816"
        y2="120.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
    </defs>
  </svg>
);

export const VisaGradient = () => (
  <svg
    className="w-full h-full"
    width="120"
    height="121"
    viewBox="0 0 120 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="120"
      height="120"
      rx="16"
      fill="url(#paint0_linear_6131_22448)"
    />
    <path
      d="M75.1667 90.1662C75.248 90.05 75.3228 89.9164 75.4 89.8045H63.5117C60.8167 89.8045 58.5417 87.9612 57.8883 85.4762C57.55 85.5518 40.4842 85.4708 40.1664 85.4996C39.525 85.4996 39 84.9745 39 84.3329C39 83.6912 39.525 83.1662 40.1667 83.1662H57.6783V77.3913L54.1083 75.3263C53.98 75.8163 53.525 76.1663 53 76.1663H40.1667C38.637 76.1379 38.6318 73.8625 40.1667 73.833C40.1667 73.833 52.1483 73.833 52.1483 73.833C51.0019 72.5982 50.4985 70.8608 50.7133 69.1664C27.4435 68.2244 27.4471 35.1317 50.6668 34.1666C62.2746 33.9642 71.0268 45.9704 67.35 56.9397L71.0833 54.7814C72.6502 53.8626 74.6767 53.7477 76.3333 54.4781V35.3333C76.3322 34.0635 75.8832 32.8673 75.1667 31.8333C77.0928 31.834 78.666 33.4071 78.6666 35.3333V55.7848L81 57.1381V35.3333C81 32.1133 78.3867 29.5 75.1667 29.5H30.8333C27.6133 29.5 25 32.1133 25 35.3333V86.6662C25 89.8862 27.6133 92.4995 30.8333 92.4995H75.1667C77.2317 92.4995 79.0517 91.4261 80.09 89.8045H76.7067C76.24 90.0379 75.715 90.1662 75.1667 90.1662ZM40.1667 78.4996H55.3333C56.8623 78.5279 56.8688 80.8033 55.3333 80.8329C55.3333 80.8329 40.1667 80.8329 40.1667 80.8329C38.6388 80.805 38.6304 78.5293 40.1667 78.4996ZM36.6667 85.4996C36.6667 86.7829 35.6166 87.8329 34.3333 87.8329H32C30.7167 87.8329 29.6667 86.7829 29.6667 85.4996V67.9997C29.6667 66.7163 30.7167 65.6664 32 65.6664H34.3333C35.6166 65.6664 36.6667 66.7163 36.6667 67.9997V85.4996Z"
      fill="white"
    />
    <path
      d="M49.4987 36.6816C46.9073 37.4068 44.6684 40.4785 43.459 44.667H49.4987V36.6816Z"
      fill="white"
    />
    <path
      d="M49.4987 66.6524V58.667H43.459C44.6684 62.8555 46.9073 65.9272 49.4987 66.6524Z"
      fill="white"
    />
    <path
      d="M51.834 66.4603C52.5775 65.3553 54.3132 64.5075 55.4507 63.8353C56.454 62.4819 57.2823 60.7086 57.8773 58.667H51.834L51.834 66.4603Z"
      fill="white"
    />
    <path
      d="M51.834 36.6816V44.667H57.8737C56.6643 40.4785 54.4254 37.4068 51.834 36.6816Z"
      fill="white"
    />
    <path
      d="M64.108 44.6664C62.6152 41.8121 60.2405 39.4989 57.3477 38.0713C58.6339 39.8181 59.656 42.0721 60.3184 44.6664H64.108Z"
      fill="white"
    />
    <path
      d="M35.5 51.6666C35.5 53.2953 35.7649 54.8616 36.2422 56.3333H40.5418C40.0473 53.3996 40.0473 49.9337 40.5418 47H36.2422C35.7649 48.4716 35.5 50.038 35.5 51.6666Z"
      fill="white"
    />
    <path
      d="M49.5001 47H42.9176C42.366 49.9305 42.366 53.4027 42.9176 56.3333H49.5001V47Z"
      fill="white"
    />
    <path
      d="M58.834 51.6666C58.834 50.0457 58.6839 48.4783 58.4165 47H51.834V56.3333H58.4165C58.6839 54.855 58.834 53.2875 58.834 51.6666Z"
      fill="white"
    />
    <path
      d="M43.9849 65.2621C42.6987 63.5154 41.6766 61.2613 41.0142 58.667H37.2246C38.7173 61.5213 41.0921 63.8346 43.9849 65.2621Z"
      fill="white"
    />
    <path
      d="M64.1078 58.667H60.3161C60.0594 59.6937 59.7444 60.6619 59.3711 61.572L63.9794 58.9003C64.0261 58.8303 64.061 58.7487 64.1078 58.667Z"
      fill="white"
    />
    <path
      d="M43.9849 38.0713C41.0921 39.4988 38.7173 41.8121 37.2246 44.6664H41.0142C41.6766 42.0721 42.6987 39.8181 43.9849 38.0713Z"
      fill="white"
    />
    <path
      d="M65.8328 51.6666C65.8328 50.038 65.5679 48.4716 65.0906 47H60.791C61.2855 49.9337 61.2855 53.3996 60.791 56.3333H65.0906C65.5679 54.8616 65.8328 53.2953 65.8328 51.6666Z"
      fill="white"
    />
    <path
      d="M93.2726 66.9411L75.7635 56.8035C74.68 56.1768 73.3367 56.178 72.2555 56.804L54.7464 66.9411C52.4447 68.172 52.4431 71.7688 54.7464 72.9988C54.7464 72.9988 60.0115 76.0469 60.0115 76.0469V83.971C60.0115 85.896 61.5748 87.471 63.5115 87.471H84.5115C84.9548 87.471 85.3748 87.3893 85.7715 87.226C84.9665 86.7127 84.3132 85.9893 83.9048 85.1377H63.5115C62.8698 85.1377 62.3448 84.6127 62.3448 83.971V77.3977L72.2555 83.1353C72.7967 83.4486 73.4028 83.6058 74.01 83.6058C74.6162 83.6058 75.2223 83.4486 75.7635 83.1353L81.893 79.5867C82.2287 81.6259 83.6976 83.5828 85.9025 83.9299C86.3439 84.9806 87.3827 85.7204 88.5922 85.7204H90.9256C92.5343 85.7204 93.8422 84.4124 93.8422 82.8037C93.8422 81.195 92.5343 79.8871 90.9256 79.8871H88.5922C87.4355 79.8871 86.443 80.5686 85.9717 81.5467C84.6123 81.0951 84.1779 79.6491 84.0805 78.3203L85.6781 77.3954V78.4411C86.3664 77.9861 87.1598 77.6827 88.0115 77.5894V76.0446L93.2726 72.9988C95.5748 71.7686 95.5756 68.1715 93.2726 66.9411ZM88.4566 82.2479C88.5014 82.2369 88.5442 82.2204 88.5922 82.2204H90.9256C91.2469 82.2204 91.5089 82.4824 91.5089 82.8037C91.5089 83.125 91.2469 83.3871 90.9256 83.3871C90.7327 83.3559 88.3973 83.4726 88.3002 83.2969C88.5115 82.9969 88.5864 82.6155 88.4566 82.2479Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6131_22448"
        x1="105.926"
        y1="0.499999"
        x2="8.14816"
        y2="120.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB57E3" />
        <stop offset="1" stopColor="#EB9757" />
      </linearGradient>
    </defs>
  </svg>
);

export const GradientUnderline = () => (
  <svg
    className="w-full h-full"
    width="253"
    height="40"
    viewBox="0 0 253 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 37.002C33.86 29.082 56.1 24.012 68.74 22.512C87.0226 20.3423 93.8 24.322 99.645 26.162C105.49 28.002 110.14 29.322 117.79 30.832C135.505 34.3286 144.46 24.362 154.63 19.517C160.964 16.4997 170.12 17.342 179.3 17.167C186.582 17.0281 197.74 20.982 209.455 23.662C218.493 25.7295 225.82 23.672 228.81 22.842C236.81 18.692 242.82 12.022 245.315 8.52695C246.49 7.01195 247.48 6.02195 249.5 3.00195"
      stroke="#1776F0"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6153_22090"
        x1="3.5"
        y1="20.002"
        x2="249.5"
        y2="20.002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB9757" />
        <stop offset="1" stopColor="#EB57E3" />
      </linearGradient>
    </defs>
  </svg>
);

export const GradientSquare = () => (
  <svg
    className="w-full h-full"
    width="147"
    height="147"
    viewBox="0 0 147 147"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="146.908"
      y="99.0361"
      width="110"
      height="110"
      transform="rotate(154.202 146.908 99.0361)"
      fill="url(#paint0_linear_6153_22112)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6153_22112"
        x1="201.908"
        y1="99.0361"
        x2="201.908"
        y2="209.036"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CDEAE8" />
        <stop offset="1" stopColor="#B5BCEC" />
      </linearGradient>
    </defs>
  </svg>
);
export const OrangeCircle = () => (
  <svg
    className="w-full h-full"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="22" cy="22" r="22" fill="url(#paint0_linear_6153_22109)" />
    <defs>
      <linearGradient
        id="paint0_linear_6153_22109"
        x1="22"
        y1="0"
        x2="22"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FC82A5" />
        <stop offset="1" stopColor="#FDAD82" />
      </linearGradient>
    </defs>
  </svg>
);
export const YellowCircle = () => (
  <svg
    className="w-full h-full"
    width="49"
    height="49"
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="24.5"
      cy="24.499"
      r="24.5"
      fill="url(#paint0_linear_6153_22110)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6153_22110"
        x1="24.5"
        y1="-0.000976563"
        x2="24.5"
        y2="48.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCE082" />
        <stop offset="1" stopColor="#FDAD82" />
      </linearGradient>
    </defs>
  </svg>
);

export const GradientConvex = () => (
  <svg
    className="w-full h-full"
    width="85"
    height="97"
    viewBox="0 0 85 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00541 1.68683C28.6479 -1.93709 53.5244 6.79556 69.5769 26.7871C85.6295 46.7789 88.7821 72.9546 80.1368 95.2564C56.4947 98.8798 31.6183 90.1469 15.5661 70.1556C-0.486195 50.164 -3.63951 23.9884 5.00541 1.68683Z"
      fill="url(#paint0_linear_6153_22117)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6153_22117"
        x1="5.00541"
        y1="1.68683"
        x2="80.1376"
        y2="95.2558"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEDFFB" />
        <stop offset="1" stopColor="#FCA08D" />
      </linearGradient>
    </defs>
  </svg>
);

export const BluePencilWIthStar = () => (
  <svg
    className="w-full h-full"
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.4657 18.3873C27.3716 18.1684 27.0605 18.1684 26.9664 18.3873C26.08 20.4604 24.4844 21.7973 22.6084 22.9207C22.3751 23.0618 22.3751 23.4019 22.6084 23.543C24.4844 24.6664 26.08 26.0033 26.9664 28.0764C27.0605 28.2953 27.3716 28.2953 27.4657 28.0764C28.3521 26.0033 29.9477 24.6664 31.8236 23.543C32.0588 23.4019 32.0588 23.0618 31.8236 22.9207C29.9477 21.7973 28.3521 20.4604 27.4657 18.3873ZM5.0336 2.46788C4.93954 2.24899 4.62838 2.24899 4.53432 2.46788C3.64789 4.54103 2.05234 5.87789 0.17638 7.0013C-0.0587921 7.14241 -0.0587921 7.48252 0.17638 7.62363C2.05234 8.74704 3.64789 10.0839 4.53432 12.157C4.62839 12.3759 4.93955 12.3759 5.0336 12.157C5.92004 10.0839 7.51559 8.74704 9.39155 7.62363C9.62672 7.48252 9.62672 7.14241 9.39155 7.0013C7.51559 5.87789 5.92004 4.54103 5.0336 2.46788Z"
      fill="#5E57EB"
    />
    <path
      d="M2.19168 25.3136L1.34327 30.0767L5.94903 29.0889L6.59845 28.4395L2.83207 24.6732L2.19168 25.3136ZM30.4918 0.779465C29.4516 -0.260724 27.7656 -0.258918 26.7254 0.779465L3.85573 23.6492L7.6221 27.4155L30.4918 4.54584C31.5049 3.53279 31.5266 1.81604 30.4918 0.779465Z"
      fill="#5E57EB"
    />
  </svg>
);

export const BlueElectric = () => (
  <svg
    className="w-full h-full"
    width="25"
    height="32"
    viewBox="0 0 25 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5926 0.136853C15.982 -0.147463 15.0592 0.0118172 14.5827 0.609184L0.393145 18.3908C-0.0968228 19.0049 -0.107558 19.8699 0.24315 20.4683C0.593859 21.0666 1.36786 21.4944 2.15309 21.3839L8.95287 20.4289L6.79294 30.0286C6.62501 30.771 7.08273 31.5728 7.69291 31.8599C8.30319 32.1472 9.23173 31.9925 9.71284 31.3971C9.71981 31.3871 9.72663 31.3771 9.73331 31.3669L23.8729 13.8807C24.3669 13.2695 24.3838 12.4081 24.0429 11.8032C23.7019 11.1984 22.9512 10.7585 22.1629 10.8482L15.3231 11.626L17.4931 1.96722C17.66 1.22558 17.2033 0.421371 16.5926 0.136853ZM13.8427 5.8474L12.4128 12.1783C12.1435 13.373 13.2179 14.5434 14.4527 14.4035L20.5525 13.7143L10.4228 26.2382L11.8728 19.8187C12.1441 18.616 11.0415 17.4389 9.80284 17.6132L3.77304 18.46L13.8427 5.8474Z"
      fill="#5E57EB"
    />
    <path
      d="M8.65629 30.5684L22.8174 13.0549C22.8857 12.9704 22.9271 12.8678 22.9361 12.7602C22.9452 12.6525 22.9216 12.5447 22.8684 12.4502C22.8152 12.3558 22.7347 12.279 22.6371 12.2296C22.5395 12.1803 22.4292 12.1606 22.3202 12.1729L14.3039 13.0816C14.2226 13.0908 14.1403 13.0808 14.0638 13.0523C13.9872 13.0238 13.9188 12.9777 13.864 12.9178C13.8092 12.858 13.7698 12.7861 13.7489 12.7082C13.7281 12.6303 13.7265 12.5486 13.7442 12.4699L16.179 1.67859C16.1938 1.61307 16.1855 1.54456 16.1555 1.48429C16.1255 1.42401 16.0757 1.37554 16.0141 1.34683C15.9525 1.31812 15.8828 1.31086 15.8164 1.32625C15.7501 1.34165 15.6911 1.37878 15.649 1.43156L1.46652 19.2107C1.40015 19.2939 1.36058 19.3947 1.35293 19.5002C1.34528 19.6058 1.36985 19.7111 1.42355 19.8027C1.47725 19.8944 1.55763 19.968 1.65425 20.0143C1.75086 20.0606 1.85929 20.0773 1.96564 20.0623L9.99671 18.9323C10.0765 18.9211 10.158 18.9291 10.234 18.9556C10.31 18.9822 10.3782 19.0264 10.433 19.0847C10.4878 19.1429 10.5274 19.2134 10.5485 19.29C10.5695 19.3667 10.5714 19.4472 10.554 19.5247L8.11927 30.316C8.10426 30.3824 8.11257 30.4518 8.14279 30.5129C8.17301 30.5741 8.22337 30.6233 8.28567 30.6526C8.34798 30.6819 8.41854 30.6896 8.48582 30.6743C8.55311 30.6591 8.61329 30.6216 8.65629 30.5684Z"
      fill="#5E57EB"
    />
  </svg>
);

export const BlueThreeStarts = ({ colors }: { colors?: string }) => (
  <svg
    className="w-full h-full"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.5663 15.4306C23.4596 13.1921 21.7737 11.5045 19.5349 3.39941C19.4638 3.14163 19.2298 2.96387 18.9631 2.96387C18.6964 2.96387 18.4623 3.14164 18.3912 3.39941C16.1527 11.506 14.4651 13.1918 6.35985 15.4306C6.10207 15.5017 5.92578 15.7358 5.92578 16.0024C5.92578 16.2691 6.10356 16.5032 6.35985 16.5743C14.4666 18.8128 16.1524 20.5004 18.3912 28.6055C18.4623 28.8633 18.6964 29.041 18.9631 29.041C19.2298 29.041 19.4638 28.8633 19.5349 28.6055C21.7735 20.4989 23.4611 18.8131 31.5663 16.5743C31.8241 16.5032 32.0004 16.2691 32.0004 16.0024C32.0004 15.7358 31.8226 15.5017 31.5663 15.4306Z"
      fill={colors ? colors : "#5E57EB"}
    />
    <path
      d="M5.94667 12.6043C6.01778 12.862 6.25186 13.0398 6.51852 13.0398C6.78519 13.0398 7.01926 12.862 7.09038 12.6043C8.12744 8.85021 8.84891 8.12863 12.603 7.09174C12.8608 7.02063 13.037 6.78656 13.037 6.5199C13.037 6.25324 12.8593 6.01916 12.603 5.94805C8.84887 4.91101 8.12728 4.19103 7.09038 0.43554C7.01926 0.177762 6.78519 0 6.51852 0C6.25186 0 6.01778 0.177777 5.94667 0.43554C4.90961 4.18959 4.18814 4.91116 0.434067 5.94805C0.176286 6.01916 0 6.25324 0 6.5199C0 6.78656 0.17778 7.02063 0.434067 7.09174C4.18817 8.12879 4.90976 8.84877 5.94667 12.6043Z"
      fill={colors ? colors : "#5E57EB"}
    />
    <path
      d="M13.493 25.8013C10.3433 24.9316 9.73885 24.3272 8.86935 21.1777C8.79824 20.9199 8.56416 20.7422 8.2975 20.7422C8.03083 20.7422 7.79675 20.92 7.72564 21.1777C6.85599 24.3273 6.25156 24.9318 3.10204 25.8013C2.84425 25.8724 2.66797 26.1064 2.66797 26.3731C2.66797 26.6398 2.84575 26.8738 3.10204 26.945C6.25171 27.8146 6.85614 28.419 7.72564 31.5685C7.79675 31.8263 8.03083 32.004 8.2975 32.004C8.56416 32.004 8.79824 31.8262 8.86935 31.5685C9.739 28.4189 10.3434 27.8144 13.493 26.945C13.7507 26.8738 13.927 26.6398 13.927 26.3731C13.927 26.1064 13.7492 25.8724 13.493 25.8013Z"
      fill={colors ? colors : "#5E57EB"}
    />
  </svg>
);

export const BlueTrophy = () => (
  <svg
    className="w-full h-full"
    width="30"
    height="32"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6604 4.44595L22.2856 5.1121C22.8761 5.22089 23.3684 5.55934 23.6828 6.01597C24 6.47528 24.1433 7.05953 24.0385 7.65448L24.0106 7.77401C23.9708 7.94592 23.9124 8.10843 23.8368 8.25749C23.7412 8.44686 23.6192 8.6228 23.4732 8.77858L20.9202 11.4821L21.4192 15.2133C21.4908 15.8028 21.3223 16.3696 20.9919 16.8088C20.6575 17.2534 20.152 17.5703 19.5496 17.6536C19.3386 17.6804 19.1342 17.6764 18.9312 17.6442C18.7203 17.6106 18.5159 17.5461 18.3275 17.4548L15.0036 15.8351L11.6545 17.4669C11.1237 17.718 10.5385 17.7315 10.0237 17.5502C9.49954 17.3648 9.04443 16.9767 8.77903 16.422C8.68216 16.2139 8.62113 16.0084 8.59194 15.8069L8.58132 15.6968C8.56407 15.5222 8.56805 15.3449 8.59194 15.1757L9.08554 11.4851L6.51399 8.76141C6.11459 8.32761 5.92351 7.7689 5.93679 7.2169C5.95139 6.65551 6.17431 6.10083 6.60557 5.68316C6.77276 5.52199 6.95722 5.39171 7.15227 5.29636L7.2279 5.26278C7.40571 5.18354 7.5928 5.12714 7.78652 5.09893L11.3441 4.44757L13.0943 1.15577C13.3769 0.622573 13.8493 0.254583 14.3814 0.0920596C14.9108 -0.0677615 15.5026 -0.024784 16.0294 0.262625L16.1011 0.305603C16.2616 0.400957 16.4062 0.513775 16.5349 0.644052C16.6849 0.795817 16.8109 0.967727 16.9118 1.15576L18.662 4.44756L18.6604 4.44595ZM2.03813 29.9371H27.9618V26.8817H2.03813V29.9371ZM28.9809 32H1.01907C0.456473 32 0 31.538 0 30.9685V25.8501C0 25.2807 0.456473 24.8186 1.01907 24.8186H4.20894V20.7317C4.20894 20.1622 4.66542 19.7002 5.22801 19.7002H24.772C25.3346 19.7002 25.7911 20.1622 25.7911 20.7317V24.8186H28.9809C29.5435 24.8186 30 25.2807 30 25.8501V30.9685C30 31.538 29.5435 32 28.9809 32ZM23.7527 21.7645H6.24687V24.8199H23.7527V21.7645Z"
      fill="#5E57EB"
    />
  </svg>
);

export const DropdownDownArrow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L12 15L18 9"
      stroke="black"
      strokeOpacity="0.6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Personal = () => (
  <svg
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.554688"
      y="0.551758"
      width="45"
      height="46"
      rx="12.6695"
      fill="#2B7FFF"
    />
    <path
      d="M30.349 33.4268V31.3434C30.349 30.2384 29.91 29.1785 29.1286 28.3971C28.3472 27.6157 27.2874 27.1768 26.1823 27.1768H19.9323C18.8272 27.1768 17.7674 27.6157 16.986 28.3971C16.2046 29.1785 15.7656 30.2384 15.7656 31.3434V33.4268"
      stroke="white"
      strokeWidth="2.11159"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.0553 23.0101C25.3565 23.0101 27.222 21.1446 27.222 18.8434C27.222 16.5422 25.3565 14.6768 23.0553 14.6768C20.7542 14.6768 18.8887 16.5422 18.8887 18.8434C18.8887 21.1446 20.7542 23.0101 23.0553 23.0101Z"
      stroke="white"
      strokeWidth="2.11159"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Guardain = () => (
  <svg
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.554688"
      y="0.551758"
      width="45"
      height="46"
      rx="12.6695"
      fill="#FF6900"
    />
    <path
      d="M31.8327 25.0832C31.8327 30.4998 28.1868 33.2082 23.8535 34.779C23.6266 34.859 23.3801 34.8551 23.1556 34.7682C18.8118 33.2082 15.166 30.4998 15.166 25.0832V17.4998C15.166 17.2125 15.2758 16.937 15.4711 16.7338C15.6665 16.5306 15.9314 16.4165 16.2077 16.4165C18.291 16.4165 20.8952 15.1165 22.7077 13.4698C22.9284 13.2738 23.2091 13.166 23.4993 13.166C23.7896 13.166 24.0703 13.2738 24.291 13.4698C26.1139 15.1273 28.7077 16.4165 30.791 16.4165C31.0673 16.4165 31.3322 16.5306 31.5276 16.7338C31.7229 16.937 31.8327 17.2125 31.8327 17.4998V25.0832Z"
      stroke="white"
      strokeWidth="2.11149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Spouse = () => (
  <svg
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.554688"
      y="0.551758"
      width="45"
      height="46"
      rx="12.6695"
      fill="#F6339A"
    />
    <path
      d="M30.7923 26.5833C32.3444 25.0625 33.9173 23.2396 33.9173 20.8542C33.9173 19.3347 33.3137 17.8775 32.2393 16.803C31.1649 15.7286 29.7076 15.125 28.1882 15.125C26.3548 15.125 25.0632 15.6458 23.5007 17.2083C21.9382 15.6458 20.6465 15.125 18.8132 15.125C17.2937 15.125 15.8364 15.7286 14.762 16.803C13.6876 17.8775 13.084 19.3347 13.084 20.8542C13.084 23.25 14.6465 25.0729 16.209 26.5833L23.5007 33.875L30.7923 26.5833Z"
      stroke="white"
      strokeWidth="2.11159"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Parent = () => (
  <svg
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.554688"
      y="0.551758"
      width="45"
      height="46"
      rx="12.6695"
      fill="#AD46FF"
    />
    <path
      d="M27.222 33.4277V31.3444C27.222 30.2393 26.783 29.1795 26.0016 28.3981C25.2202 27.6167 24.1604 27.1777 23.0553 27.1777H16.8053C15.7003 27.1777 14.6405 27.6167 13.8591 28.3981C13.0777 29.1795 12.6387 30.2393 12.6387 31.3444V33.4277"
      stroke="white"
      strokeWidth="2.11149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.2207 14.8115C28.1142 15.0432 28.9055 15.5649 29.4704 16.2949C30.0353 17.0249 30.3417 17.9218 30.3417 18.8449C30.3417 19.7679 30.0353 20.6648 29.4704 21.3948C28.9055 22.1248 28.1142 22.6466 27.2207 22.8782"
      stroke="white"
      strokeWidth="2.11149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.4707 33.4271V31.3438C33.47 30.4205 33.1627 29.5237 32.5971 28.7941C32.0315 28.0644 31.2396 27.5433 30.3457 27.3125"
      stroke="white"
      strokeWidth="2.11149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9323 23.0111C22.2335 23.0111 24.099 21.1456 24.099 18.8444C24.099 16.5432 22.2335 14.6777 19.9323 14.6777C17.6311 14.6777 15.7656 16.5432 15.7656 18.8444C15.7656 21.1456 17.6311 23.0111 19.9323 23.0111Z"
      stroke="white"
      strokeWidth="2.11149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PersonalGreen = () => (
  <svg
    width="46"
    height="47"
    viewBox="0 0 46 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.554688"
      y="0.551758"
      width="45"
      height="46"
      rx="12.6695"
      fill="#00C950"
    />
    <path
      d="M31.3887 16.4688H14.722C13.5714 16.4688 12.6387 17.4388 12.6387 18.6354V29.4688C12.6387 30.6654 13.5714 31.6354 14.722 31.6354H31.3887C32.5393 31.6354 33.472 30.6654 33.472 29.4688V18.6354C33.472 17.4388 32.5393 16.4688 31.3887 16.4688Z"
      stroke="white"
      strokeWidth="2.11149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6387 21.8867H33.472"
      stroke="white"
      strokeWidth="2.11149"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircularCheckmark = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00065 15.1663C11.6825 15.1663 14.6673 12.1816 14.6673 8.49967C14.6673 4.81778 11.6825 1.83301 8.00065 1.83301C4.31875 1.83301 1.33398 4.81778 1.33398 8.49967C1.33398 12.1816 4.31875 15.1663 8.00065 15.1663Z"
      stroke="#0A0A0A"
      strokeWidth="1.26695"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.00195 8.49935L7.33529 9.83268L10.002 7.16602"
      stroke="#0A0A0A"
      strokeWidth="1.26695"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ContactUsIcon = () => (
  <svg
    className="w-full h-full"
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60.5162 44.127C59.1764 44.127 58.0279 44.6075 57.0865 45.5489L44.8755 57.7679C44.4458 58.1976 43.8443 58.3187 43.2857 58.0883C42.7271 57.8578 42.3872 57.35 42.3872 56.7485L42.3833 46.5575C42.3833 45.2177 41.2935 44.1278 39.9536 44.1278H35.5317C34.8599 44.1278 34.2309 43.9559 33.6801 43.6473L52.8991 27.0063L57.3991 30.9047C58.2976 31.6859 59.3991 32.0766 60.5085 32.0766C61.6101 32.0766 62.7194 31.686 63.6179 30.9047L68.1179 27.0063L87.3449 43.6473C86.7942 43.9559 86.1652 44.1278 85.4933 44.1278L60.5162 44.127ZM13.2862 29.377L19.755 25.6465C21.7159 24.5176 22.9659 22.7871 23.4269 20.5762C25.0988 12.5957 22.7784 5.33824 22.7784 5.33824C22.7784 5.33824 21.2979 -0.46256 14.7979 0.0296401C10.4463 0.35777 6.43854 3.42024 4.24694 5.40854C3.08674 6.46714 2.35634 7.67804 1.96574 9.19764C-6.69446 43.4086 14.0867 79.4086 48.0437 89.0066C49.5554 89.4363 50.9656 89.4051 52.4656 88.9363C55.2742 88.0379 59.9344 86.0847 62.3953 82.4871C66.075 77.1082 61.786 72.9285 61.786 72.9285C61.786 72.9285 56.6649 67.2879 48.915 64.7371C46.7666 64.0262 44.6455 64.2488 42.6845 65.3777L36.2157 69.1161C26.1647 63.6161 13.0047 40.839 13.2857 29.378L13.2862 29.377ZM51.4932 25.7754L32.3332 9.17344C31.9426 9.775 31.7238 10.482 31.7238 11.2437V40.2947C31.7238 41.0565 31.9425 41.7635 32.3332 42.365L51.4932 25.7754ZM33.6842 7.91644L58.6142 29.5064C59.165 29.9752 59.833 30.2174 60.5126 30.2174C61.1845 30.2174 61.8642 29.9791 62.411 29.5064L87.341 7.91644C86.7902 7.60785 86.1613 7.43597 85.4894 7.43597H35.5444C34.8764 7.43597 34.235 7.60785 33.6842 7.91644ZM88.7152 9.18594L69.5552 25.7759L88.7152 42.3659C89.1058 41.7644 89.3246 41.0573 89.3246 40.2956V11.2566C89.3246 10.4988 89.0941 9.78744 88.7152 9.18594Z"
      fill="black"
    />
  </svg>
);

export const Star = () => (
  <svg
    className="w-full h-full"
    width="56"
    height="57"
    viewBox="0 0 56 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.5158 9.65824L0 41.6059L26.5909 3.72656L26.5158 9.65824Z"
      fill="#E28C0E"
    />
    <path
      d="M33.8004 36.7383L8.55957 55.3552L32.8883 33.3105L33.8004 36.7383Z"
      fill="#E28C0E"
    />
    <path
      d="M31.4695 29.1635L1.71875 54.7237L27.2789 24.9727L30.6383 25.8041L31.4695 29.1635Z"
      fill="#E28C0E"
    />
    <path
      d="M23.1312 23.5534L1.08691 47.8821L19.7034 22.6416L23.1312 23.5534Z"
      fill="#E28C0E"
    />
    <path
      d="M45.9696 29.9445L51.9013 29.8691L15.71 56.5L45.9696 29.9445Z"
      fill="#E28C0E"
    />
    <path
      d="M30.3765 13.5986L29.8172 0.5L40.0856 8.65168L52.3702 4.07215L47.7906 16.3567L55.9423 26.6247L42.8437 26.0655L35.597 36.9911L32.0812 24.3608L19.4512 20.8453L30.3765 13.5986Z"
      fill="#FFB103"
    />
  </svg>
);

export const HomePageHeroAirplaneIcon = () => (
  <svg
    className="w-full"
    width="175"
    height="62"
    viewBox="0 0 175 62"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M140.781 58.9492L172.125 2.10547L112.625 23.8867L130.156 34.5117L140.781 58.9492Z"
      stroke="black"
      strokeWidth="2.26667"
    />
    <path
      d="M123.781 52.5742L151.406 18.5742L123.781 30.793V52.5742Z"
      fill="black"
      stroke="black"
      strokeWidth="0.566667"
    />
    <path
      d="M1 6.19141C2.44606 10.0622 6.6674 16.5622 11.7676 22.4706C20.2208 32.2634 22.5693 34.5869 25.8972 36.2911C34.3727 40.6311 46.1057 36.7098 48.2139 35.4147C50.9482 33.7349 50.1761 29.5768 49.8547 27.0645C49.7134 25.9598 48.8907 25.3555 47.8366 24.8637C45.454 23.7522 42.2397 23.7195 39.1626 24.0409C36.2588 24.3441 33.9577 27.7559 32.1732 31.242C30.0161 35.4561 31.5086 42.6791 31.7545 49.1767C31.8532 51.7835 36.7495 55.9866 38.125 57.6055C41.5757 61.6669 45.4435 59.2626 52.019 60.0709C56.0086 60.5613 62.4652 61.2102 66.801 60.7257C70.1439 60.3522 73.3716 59.9151 78.4694 59.3454C87.7734 58.3057 90.7342 58.2888 95.5179 56.4314C101.383 54.154 106.149 51.3165 109.808 47.7549C111.028 45.9705 111.685 44.5001 112.25 43.2049C112.654 42.5525 113.297 41.9098 113.959 40.7607"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeDasharray="8 8"
    />
  </svg>
);

export const WhiteStarts = ({ color }: { color?: string }) => (
  <svg
    className="w-full max-w-[24px] sm:max-w-[32px]"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.26587 8.92437C3.90134 5.91223 3.14973 5.14728 0.190007 4.77658C-0.0633358 4.74507 -0.0633358 4.37265 0.190007 4.34116C3.14991 3.97019 3.90159 3.20674 4.26587 0.193361C4.29683 -0.0644536 4.66279 -0.0644536 4.69374 0.193361C5.05827 3.2055 5.80988 3.97045 8.7696 4.34116C9.02294 4.37267 9.02294 4.74508 8.7696 4.77658C5.8097 5.14754 5.05802 5.91099 4.69374 8.92437C4.66278 9.18219 4.29682 9.18219 4.26587 8.92437ZM31.81 28.2234C28.8501 27.8525 28.0984 27.0876 27.7341 24.0756C27.7032 23.8178 27.3372 23.8178 27.3063 24.0756C26.9417 27.0878 26.1901 27.8527 23.2304 28.2234C22.9771 28.2549 22.9771 28.6273 23.2304 28.6588C26.1903 29.0298 26.942 29.7933 27.3063 32.8066C27.3372 33.0645 27.7032 33.0645 27.7341 32.8066C28.0987 29.7945 28.8503 29.0296 31.81 28.6588C32.0633 28.6273 32.0633 28.2549 31.81 28.2234ZM27.0315 15.4658C19.4185 14.5133 17.4861 12.5468 16.5515 4.80078C16.4712 4.13762 15.5296 4.13762 15.4494 4.80078C14.5134 12.5482 12.581 14.5147 4.96934 15.4658C4.31768 15.5474 4.31768 16.5056 4.96934 16.5873C12.5824 17.5398 14.5148 19.5063 15.4494 27.2523C15.5296 27.9155 16.4712 27.9155 16.5515 27.2523C17.4874 19.5049 19.4199 17.5385 27.0315 16.5873C27.6832 16.5057 27.6832 15.5475 27.0315 15.4658Z"
      fill={color ? color : "white"}
    />
  </svg>
);

export const GradientStar = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full max-w-[32px] sm:max-w-[40px] md:max-w-[45px] 2xl:max-w-[48px]"
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.3988 13.2513C5.85201 8.77877 4.72459 7.64294 0.285011 7.09249C-0.0950037 7.04571 -0.0950037 6.49273 0.285011 6.44596C4.72486 5.89513 5.85239 4.76153 6.3988 0.287112C6.44525 -0.0957038 6.99418 -0.0957038 7.04061 0.287112C7.5874 4.75968 8.71482 5.89552 13.1544 6.44596C13.5344 6.49275 13.5344 7.04573 13.1544 7.09249C8.71455 7.64332 7.58702 8.77692 7.04061 13.2513C6.99416 13.6342 6.44523 13.6342 6.3988 13.2513ZM47.715 41.9075C43.2751 41.3567 42.1476 40.221 41.6012 35.7487C41.5548 35.3658 41.0058 35.3658 40.9594 35.7487C40.4126 40.2212 39.2852 41.3571 34.8456 41.9075C34.4656 41.9543 34.4656 42.5073 34.8456 42.554C39.2854 43.1049 40.413 44.2385 40.9594 48.7129C41.0058 49.0957 41.5548 49.0957 41.6012 48.7129C42.148 44.2403 43.2754 43.1045 47.715 42.554C48.095 42.5073 48.095 41.9543 47.715 41.9075ZM40.5473 22.9644C29.1277 21.55 26.2292 18.63 24.8272 7.12843C24.7068 6.14373 23.2945 6.14373 23.1741 7.12843C21.7701 18.6322 18.8715 21.5521 7.45401 22.9644C6.47652 23.0856 6.47652 24.5084 7.45401 24.6296C18.8736 26.044 21.7721 28.964 23.1741 40.4656C23.2944 41.4503 24.7068 41.4503 24.8272 40.4656C26.2312 28.9618 29.1298 26.0419 40.5473 24.6296C41.5248 24.5084 41.5248 23.0856 40.5473 22.9644Z"
      fill={color ? color : "url(#paint0_linear_7830_23860)"}
    />
    <defs>
      <linearGradient
        id="paint0_linear_7830_23860"
        x1="0"
        y1="24.5"
        x2="48"
        y2="24.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color ? color : "#8F3EBC"} />
        <stop offset="1" stopColor={color ? color : "#1776F0"} />
      </linearGradient>
    </defs>
  </svg>
);

export const WhiteRocket = () => (
  <svg
    width="34"
    height="17"
    viewBox="0 0 34 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.7805 8.01121C30.3569 9.14271 28.9336 10.2174 27.2224 11.0169C27.0519 10.5545 26.9008 10.0921 26.8027 9.54117C26.7273 9.11707 26.6828 8.63671 26.6828 8.14634C26.6828 7.82131 26.7023 7.49459 26.7443 7.17914C26.841 6.45246 27.0583 5.76617 27.3003 5.045C28.9767 5.83986 30.3785 6.89801 31.7805 8.01121ZM23.5596 8.03014C23.5596 9.09443 22.6919 9.95721 21.6217 9.9572C20.5513 9.95721 19.6837 9.09443 19.6837 8.03016C19.6836 6.96584 20.5513 6.10307 21.6216 6.10305C22.6919 6.10307 23.5596 6.96583 23.5596 8.03014ZM24.5378 8.03014C24.5378 6.4286 23.2323 5.13031 21.6216 5.13028C20.011 5.13028 18.7054 6.42861 18.7054 8.03014C18.7054 9.63166 20.011 10.93 21.6216 10.93C23.2322 10.9299 24.5378 9.63166 24.5378 8.03014ZM16.6433 8.03C16.6433 7.76159 16.4246 7.54388 16.1546 7.54362H16.1536H11.0063C10.7361 7.54366 10.5171 7.76139 10.5171 8.03C10.5171 8.29862 10.7361 8.51637 11.0063 8.51637L16.1531 8.51637C16.4232 8.5166 16.6431 8.2986 16.6433 8.03ZM26.3998 4.65549C26.148 5.40294 25.8882 6.19645 25.7745 7.05157C25.7263 7.41385 25.7046 7.78349 25.7046 8.14632C25.7046 8.69272 25.7539 9.22978 25.8395 9.71068C25.9552 10.3609 26.1366 10.9017 26.3218 11.4003C25.7797 11.609 25.2075 11.7899 24.5976 11.9373C21.3114 12.7312 16.9007 12.5596 14.3656 12.3873C12.3944 12.2533 11.6388 12.1255 11.1475 12.0034L11.121 11.4638C11.1108 11.2542 10.9758 11.0711 10.7779 10.9982L9.81718 10.6447L9.81429 8.17541L9.81571 5.38211L10.7834 5.02411C10.9826 4.95046 11.1176 4.76498 11.126 4.55384L11.1469 4.01997C11.6408 3.89873 12.3995 3.77189 14.3671 3.63869C16.903 3.46705 21.3124 3.29564 24.598 4.0889C25.237 4.24312 25.8346 4.43422 26.3998 4.65549ZM15.0352 13.4787L13.5508 15.0428L8.38083 13.9862L10.7366 12.9788C11.3083 13.1324 12.0621 13.2803 14.2938 13.432C14.5248 13.4477 14.7727 13.4636 15.0352 13.4787ZM15.001 2.54954C14.7518 2.56403 14.5161 2.57906 14.2957 2.59397C12.0002 2.74937 11.2663 2.90049 10.6861 3.05758L8.37881 2.06766L13.5501 1.01715L15.001 2.54954ZM8.7641 10.6099L8.18139 10.8053L8.18147 5.27097L8.76263 5.50214L8.7614 8.01883C8.7612 8.02415 8.76113 8.02943 8.76113 8.03478L8.76128 8.17608L8.76121 8.37898C8.76121 8.3855 8.7613 8.39226 8.76156 8.39869L8.7641 10.6099ZM33.1484 8.01089C33.1484 7.85228 33.076 7.70224 32.9517 7.6029C30.6934 5.79844 28.3477 3.91658 24.8465 3.07135C22.1671 2.42446 18.8302 2.3904 16.2857 2.48742L14.0755 0.152983C13.9593 0.0302769 13.7875 -0.0238792 13.6214 0.00984952L6.65771 1.42444C6.44839 1.46695 6.29108 1.63968 6.26915 1.85099C6.26741 1.8678 6.26657 1.88454 6.26657 1.90117C6.26647 2.09355 6.38132 2.27006 6.56188 2.34755L10.0992 3.86514L10.0874 4.16438L9.10588 4.52748C9.08007 4.53703 9.05534 4.54842 9.03185 4.56154L7.87397 4.10102C7.72331 4.04107 7.55245 4.05937 7.41806 4.14985C7.28366 4.24033 7.20321 4.3912 7.20321 4.55257L7.20317 11.4826C7.20321 11.6393 7.27906 11.7863 7.40702 11.8777C7.53497 11.9691 7.69936 11.9935 7.84867 11.9434L9.13761 11.5112L10.0862 11.8602L10.1024 12.1911L6.56418 13.7043C6.38336 13.7816 6.2683 13.9582 6.26828 14.1508C6.26828 14.1673 6.2691 14.1838 6.27082 14.2004C6.29249 14.4118 6.44968 14.5847 6.65894 14.6275L13.621 16.0502C13.7869 16.0842 13.9589 16.0302 14.0752 15.9076L16.3218 13.5404C18.8616 13.6361 22.1796 13.599 24.8462 12.9548C28.3482 12.1088 30.6938 10.2251 32.9519 8.41899C33.0762 8.31962 33.1484 8.16945 33.1484 8.01089ZM6.68785 5.83998C6.68785 5.56988 6.46758 5.35097 6.19596 5.35097L2.91468 5.35095C2.64312 5.35095 2.42287 5.56991 2.42287 5.83998C2.42287 6.11012 2.64313 6.32902 2.91472 6.32903L6.19596 6.32905C6.46758 6.32905 6.68782 6.1101 6.68785 5.83998ZM6.68781 10.2202C6.68781 9.95013 6.46759 9.73119 6.196 9.73119H2.91472C2.64313 9.73117 2.42287 9.95015 2.42287 10.2203C2.42287 10.4904 2.64308 10.7093 2.91468 10.7093H6.19596C6.46758 10.7093 6.68784 10.4903 6.68781 10.2202ZM4.91921 8.04239C4.9193 7.77227 4.69909 7.55332 4.4274 7.55334L0.491924 7.55334C0.220306 7.55334 0.000156403 7.77227 0.000156403 8.04239C0.000190735 8.31246 0.220379 8.53143 0.491966 8.53143H4.42744C4.69909 8.53141 4.91928 8.31246 4.91921 8.04239Z"
      fill="white"
    />
  </svg>
);

export const PurpleGradientDelete = ({ color }: { color?: string }) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.48521 20.649C2.54411 21.405 3.22144 22 4.02076 22H15.9791C16.7795 22 17.4558 21.405 17.5157 20.649L18.8946 3.48999H1.10645L2.48521 20.649ZM12.8766 6.55586C12.8766 6.21986 13.1616 5.94885 13.515 5.94885C13.8684 5.94885 14.1534 6.21986 14.1534 6.55586V17.3988C14.1534 17.7348 13.8684 18.0058 13.515 18.0058C13.1616 18.0058 12.8766 17.7348 12.8766 17.3988V6.55586ZM9.36153 6.55586C9.36153 6.21986 9.64656 5.94885 9.99994 5.94885C10.3533 5.94885 10.6384 6.21986 10.6384 6.55586V17.3988C10.6384 17.7348 10.3533 18.0058 9.99994 18.0058C9.64656 18.0058 9.36153 17.7348 9.36153 17.3988V6.55586ZM5.8465 6.55586C5.8465 6.21986 6.13153 5.94885 6.48491 5.94885C6.8383 5.94885 7.12333 6.21986 7.12333 6.55586V17.3988C7.12333 17.7348 6.8383 18.0058 6.48491 18.0058C6.13153 18.0058 5.8465 17.7348 5.8465 17.3988V6.55586Z"
      fill={color ? color : "url(#paint0_linear_7932_23568)"}
    />
    <path
      d="M19.7984 2.18802H14.3324C13.8875 1.94902 13.5572 1.54102 13.4374 1.05201C13.2859 0.432002 12.7127 0 12.0448 0H7.95549C7.28762 0 6.71442 0.432002 6.56297 1.05101C6.44307 1.54003 6.11282 1.94901 5.66794 2.18702L0.201936 2.18802C0.0904511 2.18802 0 2.27802 0 2.39002C0 2.50202 0.0904511 2.59202 0.201936 2.59202H19.7981C19.9095 2.59202 20 2.50202 20 2.39002C20 2.27802 19.9095 2.18802 19.7981 2.18802L19.7984 2.18802Z"
      fill={color ? color : "url(#paint1_linear_7932_23568)"}
    />
    <defs>
      <linearGradient
        id="paint0_linear_7932_23568"
        x1="10.0005"
        y1="3.48999"
        x2="10.0005"
        y2="22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AC82F7" />
        <stop offset="1" stopColor="#645BEC" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7932_23568"
        x1="10"
        y1="0"
        x2="10"
        y2="2.59202"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AC82F7" />
        <stop offset="1" stopColor="#645BEC" />
      </linearGradient>
    </defs>
  </svg>
);

export const MiniMizeIcon = () => (
  <svg
    className="max-w-[32px] w-full"
    width="32"
    height="32"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.7515 20.5405C37.4863 20.5405 37.2319 20.6459 37.0444 20.8334C36.8568 21.021 36.7515 21.2753 36.7515 21.5405V41.8589H2V7.3291H21.874C22.1392 7.3291 22.3936 7.22374 22.5811 7.03621C22.7686 6.84867 22.874 6.59432 22.874 6.3291C22.874 6.06389 22.7686 5.80953 22.5811 5.62199C22.3936 5.43446 22.1392 5.3291 21.874 5.3291H1C0.734788 5.32911 0.480441 5.43448 0.292908 5.62201C0.105374 5.80954 1.32934e-05 6.06389 3.38206e-08 6.3291V42.8589C-3.41257e-05 42.9902 0.0258084 43.1203 0.076051 43.2416C0.126294 43.363 0.199952 43.4732 0.292817 43.5661C0.385683 43.6589 0.495935 43.7326 0.617276 43.7828C0.738617 43.8331 0.868668 43.8589 1 43.8589H37.7515C37.8828 43.8589 38.0129 43.8331 38.1342 43.7828C38.2555 43.7326 38.3658 43.6589 38.4587 43.5661C38.5515 43.4732 38.6252 43.363 38.6754 43.2416C38.7257 43.1203 38.7515 42.9902 38.7515 42.8589V21.5405C38.7515 21.2753 38.6461 21.021 38.4586 20.8334C38.271 20.6459 38.0167 20.5405 37.7515 20.5405Z"
      fill="#1776f0"
    />
    <path
      d="M43.3364 0.285159C43.1468 0.0998421 42.8914 -0.00269274 42.6263 5.37876e-05C42.3612 0.00280032 42.108 0.110604 41.9223 0.299809L23.0991 19.5156L22.7969 9.58736C22.7943 9.45565 22.7655 9.32578 22.7121 9.20536C22.6587 9.08495 22.5818 8.97641 22.4858 8.88613C22.3899 8.79584 22.2769 8.72563 22.1535 8.67961C22.0301 8.63358 21.8987 8.61268 21.7671 8.61812C21.502 8.62616 21.2509 8.73916 21.0692 8.93229C20.8874 9.12541 20.7898 9.38282 20.7978 9.64791L21.1713 21.9223C21.1769 22.0397 21.2033 22.1551 21.2494 22.2631C21.2634 22.2949 21.2791 22.3259 21.2965 22.356C21.395 22.5483 21.5553 22.7019 21.7517 22.792C21.7679 22.7995 21.7808 22.8114 21.7974 22.8182L21.8071 22.8237C21.9202 22.8671 22.0402 22.8897 22.1613 22.8902L22.1703 22.892L22.1991 22.8915L34.9481 22.5322C35.2132 22.5246 35.4645 22.4121 35.6466 22.2194C35.8287 22.0266 35.9268 21.7694 35.9193 21.5043C35.9184 21.3722 35.8908 21.2416 35.8381 21.1205C35.7854 20.9993 35.7087 20.8901 35.6127 20.7994C35.5166 20.7086 35.4032 20.6383 35.2793 20.5925C35.1554 20.5468 35.0234 20.5266 34.8915 20.5331L24.618 20.8228L43.351 1.69916C43.443 1.60537 43.5155 1.49439 43.5645 1.37256C43.6135 1.25073 43.638 1.12044 43.6367 0.989126C43.6353 0.857816 43.6081 0.72806 43.5566 0.607271C43.505 0.486482 43.4302 0.377027 43.3364 0.285159Z"
      fill="#1776f0"
    />
  </svg>
);
export const MaxiMizeIcon = () => (
  <svg
    className="max-w-[32px] w-full"
    width="32"
    height="32"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.7515 20.5405C37.4863 20.5405 37.2319 20.6459 37.0444 20.8334C36.8568 21.021 36.7515 21.2753 36.7515 21.5405V41.8589H2V7.3291H21.874C22.1392 7.3291 22.3936 7.22374 22.5811 7.03621C22.7686 6.84867 22.874 6.59432 22.874 6.3291C22.874 6.06389 22.7686 5.80953 22.5811 5.62199C22.3936 5.43446 22.1392 5.3291 21.874 5.3291H1C0.734788 5.32911 0.480441 5.43448 0.292908 5.62201C0.105374 5.80954 1.32934e-05 6.06389 3.38206e-08 6.3291V42.8589C-3.41257e-05 42.9902 0.0258084 43.1203 0.076051 43.2416C0.126294 43.363 0.199952 43.4732 0.292817 43.5661C0.385683 43.6589 0.495935 43.7326 0.617276 43.7828C0.738617 43.8331 0.868668 43.8589 1 43.8589H37.7515C37.8828 43.8589 38.0129 43.8331 38.1342 43.7828C38.2555 43.7326 38.3658 43.6589 38.4587 43.5661C38.5515 43.4732 38.6252 43.363 38.6754 43.2416C38.7257 43.1203 38.7515 42.9902 38.7515 42.8589V21.5405C38.7515 21.2753 38.6461 21.021 38.4586 20.8334C38.271 20.6459 38.0167 20.5405 37.7515 20.5405Z"
      fill="#1776f0"
    />
    <path
      d="M43.2633 0.969264C43.2578 0.851878 43.2313 0.736425 43.1852 0.628324C43.1694 0.591725 43.1514 0.556152 43.1311 0.521815C43.0955 0.456935 43.0526 0.396307 43.0033 0.341094C42.9752 0.306936 42.9447 0.274772 42.9121 0.244835C42.8442 0.187616 42.7689 0.139785 42.6882 0.102625C42.6564 0.0863452 42.6237 0.0718981 42.5902 0.0593545C42.4888 0.0248814 42.3824 0.00709033 42.2753 0.00667447C42.2613 0.00655447 42.2496 -0.000465497 42.2355 2.45035e-05L29.4865 0.359405C29.2244 0.367567 28.9759 0.478361 28.7947 0.667919C28.6135 0.857476 28.514 1.11063 28.5177 1.37284C28.5213 1.63505 28.6278 1.88533 28.8142 2.06977C29.0007 2.25421 29.2521 2.35805 29.5143 2.35891L29.5431 2.35842L39.8165 2.06881L21.0832 21.1924C20.991 21.2862 20.9183 21.3972 20.8691 21.5191C20.8199 21.641 20.7952 21.7714 20.7964 21.9029C20.7977 22.0343 20.8248 22.1642 20.8763 22.2852C20.9279 22.4061 21.0027 22.5157 21.0966 22.6077C21.1905 22.6997 21.3017 22.7723 21.4237 22.8213C21.5456 22.8703 21.6761 22.8947 21.8075 22.8932C21.939 22.8918 22.0689 22.8644 22.1897 22.8127C22.3106 22.761 22.42 22.6859 22.5119 22.5919L41.3356 3.37604L41.6374 13.3043C41.6402 13.4363 41.6691 13.5665 41.7225 13.6873C41.7759 13.8082 41.8527 13.9172 41.9485 14.0082C42.0442 14.0991 42.1571 14.1702 42.2805 14.2173C42.4039 14.2644 42.5354 14.2866 42.6674 14.2826C42.7994 14.2786 42.9294 14.2485 43.0497 14.194C43.17 14.1395 43.2784 14.0617 43.3684 13.9652C43.4585 13.8686 43.5286 13.7551 43.5746 13.6312C43.6206 13.5074 43.6416 13.3757 43.6364 13.2437L43.2633 0.969264Z"
      fill="#1776f0"
    />
  </svg>
);

export const RedirectIcon = () => (
  <svg
    className="max-w-[50px] w-full"
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 27.5V6.5C1.5 3.73858 3.73858 1.5 6.5 1.5H44C46.7614 1.5 49 3.73858 49 6.5V44C49 46.7614 46.7614 49 44 49H12.2601C9.9073 49 8 47.0927 8 44.7399C8 43.6247 8.42899 42.5624 9.20974 41.7661C13.0024 37.8975 24.8898 25.7724 33 17.5M33 17.5C26.5 17 16 17.5 16 17.5M33 17.5C34 24 33 33.5 33 33.5"
      stroke="#1776f0"
      strokeWidth="5"
      strokeLinecap="round"
    />
  </svg>
);
export const VideoPlayIcon = ({ className }: { className?: string }) => (
  <svg
    className={`w-full h-full ${className}`}
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.0007 58.6667C46.7282 58.6667 58.6673 46.7276 58.6673 32C58.6673 17.2724 46.7282 5.33337 32.0007 5.33337C17.2731 5.33337 5.33398 17.2724 5.33398 32C5.33398 46.7276 17.2731 58.6667 32.0007 58.6667Z"
      fill="white"
      fillOpacity="0.34"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.666 21.3334L42.666 32L26.666 42.6667V21.3334Z"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlueQuotes = () => (
  <svg
    className="max-w-[24px] sm:max-w-[26px] 4xl:max-w-[34px] w-full h-full"
    width="34"
    height="30"
    viewBox="0 0 34 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6008 29.6L24.2008 -5.72205e-06H33.1008V29.6H18.6008ZM0.000781298 29.6L5.60078 -5.72205e-06H14.4008V29.6H0.000781298Z"
      fill="#5E57EB"
      fillOpacity="0.8"
    />
  </svg>
);

export const WhiteGridLines = () => (
  <svg
    className="w-full h-full"
    width="365"
    height="420"
    viewBox="0 0 365 420"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.1">
      <line x1="38.5" y1="2.18558e-08" x2="38.5" y2="420" stroke="white" />
      <line x1="86.5" y1="2.18558e-08" x2="86.5" y2="420" stroke="white" />
      <line x1="134.5" y1="2.18558e-08" x2="134.5" y2="420" stroke="white" />
      <line x1="182.5" y1="2.18558e-08" x2="182.5" y2="420" stroke="white" />
      <line x1="230.5" y1="2.18558e-08" x2="230.5" y2="420" stroke="white" />
      <line x1="278.5" y1="2.18558e-08" x2="278.5" y2="420" stroke="white" />
      <line x1="326.5" y1="2.18558e-08" x2="326.5" y2="420" stroke="white" />
      <g clipPath="url(#clip0_560_2733)">
        <line x1="392.5" y1="41.5" x2="-27.5" y2="41.5" stroke="white" />
        <line x1="392.5" y1="89.5" x2="-27.5" y2="89.5" stroke="white" />
        <line x1="392.5" y1="137.5" x2="-27.5" y2="137.5" stroke="white" />
        <line x1="392.5" y1="185.5" x2="-27.5" y2="185.5" stroke="white" />
        <line x1="392.5" y1="233.5" x2="-27.5" y2="233.5" stroke="white" />
        <line x1="392.5" y1="281.5" x2="-27.5" y2="281.5" stroke="white" />
        <line x1="392.5" y1="329.5" x2="-27.5" y2="329.5" stroke="white" />
        <line x1="392.5" y1="377.5" x2="-27.5" y2="377.5" stroke="white" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_560_2733">
        <rect
          width="379"
          height="365"
          fill="white"
          transform="matrix(0 1 -1 0 365 41)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const BlueEmail = () => (
  <svg
    className="max-w-[30px] md:max-w-[35px] lg:max-w-[40px] 3xl:max-w-[49px] w-full h-full"
    width="49"
    height="36"
    viewBox="0 0 49 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M44.6954 0.00012546H3.77548C2.68826 0.00012546 1.71189 0.470738 1.01953 1.21181L23.2776 16.5282C24.1025 17.0962 25.2086 17.0962 26.0335 16.5364L47.8346 1.70391C47.1666 0.678822 46.0091 0 44.6946 0L44.6954 0.00012546Z"
      fill="#8f3ebc"
    />
    <path
      d="M24.6625 21.6633C23.2561 21.6633 21.8444 21.2413 20.6192 20.3975L0 6.20898V32.2277C0 34.3049 1.69033 36.0007 3.77282 36.0007H44.6928C46.7699 36.0007 48.4656 34.3103 48.4656 32.2277V6.95539L28.6793 20.4162C27.4595 21.2492 26.0608 21.6633 24.6625 21.6633Z"
      fill="#8f3ebc"
    />
  </svg>
);
export const BlueLinkedIn = () => (
  <svg
    className="max-w-[24px] lg:max-w-[32px] 3xl:max-w-[36px] w-full h-full"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.6737 30.6744H25.3396V22.3208C25.3396 20.3287 25.3041 17.7644 22.5654 17.7644C19.7872 17.7644 19.3621 19.9348 19.3621 22.1757V30.6739H14.028V13.4953H19.1488V15.843H19.2204C19.7329 14.9667 20.4734 14.2459 21.3632 13.7572C22.2529 13.2686 23.2585 13.0304 24.2728 13.068C29.6791 13.068 30.6759 16.6242 30.6759 21.2506L30.6737 30.6744ZM8.00944 11.1472C7.39722 11.1473 6.7987 10.9658 6.2896 10.6258C5.7805 10.2857 5.38369 9.80234 5.14931 9.23675C4.91492 8.67115 4.85349 8.04876 4.97282 7.44826C5.09215 6.84776 5.38687 6.29614 5.8197 5.86314C6.25253 5.43015 6.80403 5.13523 7.40446 5.01568C8.0049 4.89613 8.62728 4.95732 9.19294 5.19151C9.7586 5.4257 10.2421 5.82238 10.5823 6.33137C10.9226 6.84037 11.1042 7.43883 11.1043 8.05107C11.1044 8.45758 11.0244 8.86012 10.8689 9.23572C10.7134 9.61131 10.4855 9.95261 10.1981 10.2401C9.91071 10.5276 9.56949 10.7557 9.19396 10.9113C8.81843 11.0669 8.41594 11.1471 8.00944 11.1472ZM10.6765 30.6744H5.33685V13.4953H10.6765V30.6744ZM33.333 0.00245274H2.65649C1.96022 -0.00540493 1.28928 0.263495 0.79116 0.750064C0.293043 1.23663 0.00849759 1.90106 0 2.59735V33.4021C0.00820675 34.0988 0.292585 34.7636 0.790685 35.2507C1.28878 35.7378 1.95987 36.0072 2.65649 35.9998H33.333C34.031 36.0085 34.7039 35.7399 35.204 35.2528C35.7041 34.7658 35.9903 34.1001 36 33.4021V2.59512C35.99 1.89746 35.7036 1.23227 35.2035 0.745716C34.7034 0.25916 34.0306 -0.00897215 33.333 0.000229233"
      fill="#8f3ebc"
    />
  </svg>
);

export const ArrowDown = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="20"
    height="12"
    viewBox="0 0 20 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L10 10L18 2"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DigiLocker = () => (
  <svg
    width="77"
    height="19"
    viewBox="0 0 77 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8091_23403)">
      <path
        d="M11.8284 6.82272V0H5.52194C5.20043 0.000959877 4.89237 0.129314 4.66503 0.357029C4.43769 0.584745 4.30955 0.893317 4.30859 1.21535V17.6481C4.30955 17.9701 4.43769 18.2787 4.66503 18.5064C4.89237 18.7341 5.20043 18.8625 5.52194 18.8635H19.1012C19.4227 18.8625 19.7308 18.7341 19.9581 18.5064C20.1854 18.2787 20.3136 17.9701 20.3145 17.6481V6.82272H11.8284Z"
        fill="#6334FA"
      />
      <path
        d="M23.3398 14.2044V5.39488H26.2025C26.7069 5.38811 27.2078 5.47956 27.6774 5.66415C28.0995 5.84121 28.4732 6.11696 28.7672 6.46832C29.0875 6.86298 29.3247 7.31848 29.4647 7.80739C29.6357 8.41327 29.7177 9.04089 29.7081 9.67045C29.7177 10.3383 29.6358 11.0044 29.4647 11.65C29.3277 12.1632 29.0906 12.6443 28.7672 13.0654C28.478 13.4342 28.1041 13.7276 27.6774 13.9206C27.2103 14.1153 26.7083 14.2119 26.2025 14.2044H23.3398ZM24.9819 6.86131V12.7452H26.0462C26.3344 12.7516 26.6202 12.6919 26.8818 12.5706C27.1303 12.4541 27.3462 12.2778 27.5103 12.0575C27.6962 11.7995 27.8307 11.5079 27.9062 11.1987C28.0037 10.8036 28.05 10.3976 28.0443 9.99066V9.35024C28.0498 8.98166 28.0034 8.61415 27.9062 8.2586C27.8275 7.97624 27.6929 7.71265 27.5103 7.48354C27.3399 7.2813 27.1247 7.12179 26.8818 7.01778C26.6212 6.91161 26.3421 6.85843 26.0608 6.86131H24.9819Z"
        fill="#6334FA"
      />
      <path
        d="M32.3846 6.31162H30.8516V4.91797H32.3846V6.31162ZM32.3846 14.1932H30.8516V7.45056H32.3846V14.1932Z"
        fill="#6334FA"
      />
      <path
        d="M39.311 6.31223C39.3326 6.71337 39.2326 7.11169 39.024 7.45481C38.8316 7.7344 38.5476 7.93778 38.2212 8.02974C38.4003 8.22819 38.5374 8.46089 38.6244 8.71383C38.7189 8.99513 38.7656 9.29034 38.7625 9.58714C38.7666 9.90871 38.7112 10.2283 38.599 10.5296C38.4952 10.804 38.3328 11.0524 38.1231 11.2573C37.899 11.4678 37.631 11.6256 37.3384 11.7195C36.9871 11.8358 36.6185 11.8912 36.2486 11.8832H35.6237C35.501 11.8782 35.3811 11.9212 35.2895 12.0033C35.2488 12.0407 35.2165 12.0863 35.1945 12.1371C35.1726 12.1879 35.1617 12.2427 35.1624 12.298C35.1604 12.3503 35.169 12.4024 35.1878 12.4512C35.2065 12.4999 35.235 12.5444 35.2714 12.5819C35.3076 12.6201 35.3517 12.65 35.4007 12.6695C35.4496 12.689 35.5022 12.6975 35.5547 12.6947H37.8906C38.0965 12.693 38.3006 12.7338 38.49 12.8147C38.6766 12.8994 38.8427 13.0235 38.9768 13.1786C39.1231 13.3402 39.2355 13.5295 39.3074 13.7354C39.3931 13.9682 39.435 14.215 39.4309 14.4631C39.434 14.7569 39.3759 15.0482 39.2601 15.3182C39.15 15.5673 38.9906 15.7913 38.7915 15.9768C38.5915 16.1609 38.3569 16.3032 38.1013 16.3953C37.8291 16.4954 37.5412 16.546 37.2512 16.5445H34.7737C34.5786 16.5466 34.3852 16.5093 34.2048 16.4349C34.0244 16.3606 33.8608 16.2505 33.7238 16.1115C33.5939 15.9678 33.4917 15.8012 33.4223 15.6202C33.345 15.4195 33.3068 15.2058 33.3097 14.9907C33.2978 14.6927 33.3833 14.3989 33.5531 14.1538C33.7083 13.9314 33.9121 13.7472 34.1488 13.6153C33.9839 13.5144 33.8476 13.3728 33.7529 13.2041C33.653 13.0188 33.6029 12.8106 33.6076 12.6001C33.6074 12.4615 33.6345 12.3242 33.6875 12.1961C33.7384 12.0727 33.811 11.9593 33.9018 11.8614C33.9919 11.7571 34.0987 11.6685 34.2179 11.5994C34.3327 11.528 34.4544 11.4682 34.5811 11.4211C34.3227 11.2285 34.1177 10.973 33.9854 10.6788C33.8404 10.3338 33.7722 9.96123 33.7856 9.58714C33.7818 9.26473 33.8359 8.94427 33.9454 8.64105C34.0464 8.36521 34.2092 8.11624 34.4213 7.9133C34.6446 7.70461 34.9096 7.54584 35.1987 7.44753C35.5435 7.32972 35.9062 7.27308 36.2704 7.28015C36.4724 7.27861 36.6741 7.29444 36.8734 7.32745C37.0528 7.35588 37.2283 7.40471 37.3965 7.473C37.5181 7.3896 37.626 7.2877 37.7162 7.17099C37.7951 7.06855 37.8622 6.95746 37.916 6.83986C37.9634 6.74352 37.9999 6.64223 38.025 6.53784C38.0415 6.46244 38.0512 6.38572 38.0541 6.30859L39.311 6.31223ZM35.4566 14.1283C35.3728 14.128 35.2899 14.1453 35.2132 14.1793C35.1422 14.2134 35.0772 14.2589 35.0207 14.3139C34.9642 14.3698 34.9197 14.4367 34.8899 14.5104C34.8576 14.5837 34.8415 14.6632 34.8427 14.7433C34.8376 14.8261 34.8498 14.909 34.8786 14.9867C34.9075 15.0645 34.9523 15.1353 35.0101 15.1946C35.068 15.2539 35.1376 15.3004 35.2145 15.3311C35.2914 15.3618 35.3739 15.376 35.4566 15.3728H37.1822C37.3632 15.3777 37.54 15.317 37.6799 15.2018C37.7455 15.1454 37.7976 15.0748 37.8322 14.9954C37.8668 14.9161 37.883 14.8299 37.8797 14.7433C37.8837 14.6594 37.8695 14.5757 37.8382 14.4978C37.8068 14.4199 37.759 14.3497 37.6981 14.2921C37.5753 14.1826 37.4155 14.1241 37.2512 14.1283H35.4566ZM36.2631 8.43728C36.1264 8.42632 35.9891 8.44836 35.8627 8.50154C35.7363 8.55473 35.6244 8.63751 35.5366 8.74294C35.3706 8.99178 35.2914 9.28856 35.3113 9.58714C35.2943 9.88753 35.3788 10.1849 35.5511 10.4313C35.6436 10.5319 35.756 10.6122 35.881 10.667C36.0061 10.7219 36.1411 10.7503 36.2776 10.7503C36.4142 10.7503 36.5492 10.7219 36.6743 10.667C36.7993 10.6122 36.9117 10.5319 37.0042 10.4313C37.1765 10.1849 37.261 9.88753 37.244 9.58714C37.262 9.28323 37.1776 8.98206 37.0042 8.73202C36.9136 8.62668 36.7988 8.54486 36.6698 8.49354C36.5407 8.44222 36.4012 8.42292 36.2631 8.43728Z"
        fill="#6334FA"
      />
      <path
        d="M41.7322 6.31162H40.1992V4.91797H41.7322V6.31162ZM41.7322 14.1932H40.1992V7.45056H41.7322V14.1932Z"
        fill="#6334FA"
      />
      <path
        d="M43.1953 5.39453H44.8373V12.6721H48.5573V14.2149H43.1953V5.39453Z"
        fill="#6334FA"
      />
      <path
        d="M52.0669 7.29544C52.4471 7.26769 52.8284 7.33074 53.1796 7.4794C53.5307 7.62806 53.8416 7.85808 54.0867 8.15056C54.5372 8.72185 54.7588 9.60607 54.7588 10.8251C54.7588 12.0441 54.5372 12.9319 54.0867 13.5032C53.8251 13.7747 53.5116 13.9906 53.1649 14.1381C52.8182 14.2856 52.4454 14.3616 52.0687 14.3616C51.692 14.3616 51.3192 14.2856 50.9725 14.1381C50.6258 13.9906 50.3123 13.7747 50.0507 13.5032C49.6002 12.9307 49.375 12.038 49.375 10.8251C49.375 9.61213 49.6002 8.72063 50.0507 8.15056C50.295 7.85814 50.6053 7.62811 50.9558 7.47943C51.3064 7.33075 51.6872 7.26769 52.0669 7.29544ZM52.0669 8.59449C51.8919 8.5837 51.7177 8.6267 51.5677 8.71774C51.4178 8.80877 51.2991 8.94351 51.2277 9.10392C51.0386 9.57236 50.9542 10.0766 50.9807 10.5813V11.0725C50.9539 11.5783 51.0383 12.0838 51.2277 12.5535C51.3078 12.7076 51.4286 12.8367 51.5769 12.9268C51.7251 13.017 51.8953 13.0646 52.0687 13.0646C52.2421 13.0646 52.4123 13.017 52.5605 12.9268C52.7088 12.8367 52.8296 12.7076 52.9097 12.5535C53.0991 12.0838 53.1834 11.5783 53.1567 11.0725V10.5813C53.1832 10.0766 53.0988 9.57236 52.9097 9.10392C52.838 8.9429 52.7188 8.80774 52.5681 8.71666C52.4174 8.62557 52.2425 8.58294 52.0669 8.59449Z"
        fill="#6334FA"
      />
      <path
        d="M58.2977 7.29732C58.6301 7.29218 58.9608 7.34513 59.2749 7.45379C59.5592 7.55306 59.8148 7.72045 60.0197 7.94139C60.2372 8.18175 60.3985 8.46765 60.4919 8.77831C60.6119 9.17192 60.6683 9.58221 60.659 9.99366H59.0824C59.1057 9.63104 59.0383 9.26833 58.8862 8.93842C58.8306 8.83141 58.7457 8.74245 58.6415 8.68189C58.5373 8.62134 58.4181 8.59168 58.2977 8.59637C58.1431 8.5926 57.9916 8.64016 57.8667 8.73165C57.7419 8.82313 57.6507 8.9534 57.6075 9.10216C57.4498 9.5792 57.3809 10.0812 57.4041 10.5831V11.0744C57.3819 11.5771 57.4546 12.0796 57.6184 12.5554C57.6693 12.7071 57.7672 12.8387 57.8979 12.931C58.0285 13.0232 58.1851 13.0714 58.345 13.0684C58.4686 13.0738 58.591 13.042 58.6966 12.9772C58.8021 12.9123 58.8858 12.8174 58.9371 12.7046C59.0781 12.3728 59.1403 12.0128 59.1187 11.6529H60.6663C60.6743 12.0653 60.6192 12.4764 60.5028 12.8719C60.4105 13.1826 60.2519 13.4694 60.0378 13.7125C59.8385 13.9306 59.5891 14.0967 59.3113 14.1965C59.0057 14.3046 58.6835 14.3576 58.3595 14.3529C57.9691 14.3622 57.581 14.2917 57.2188 14.1455C56.8986 14.0063 56.6223 13.7824 56.4196 13.4978C56.1922 13.1693 56.034 12.7979 55.9546 12.4062C55.8469 11.8869 55.797 11.3572 55.8057 10.8269C55.8057 9.61402 56.0127 8.72251 56.4269 8.15244C56.6444 7.8667 56.9289 7.63915 57.2553 7.48999C57.5816 7.34082 57.9397 7.27464 58.2977 7.29732Z"
        fill="#6334FA"
      />
      <path
        d="M63.3533 10.136L65.2387 7.45056H66.8844L64.8791 10.1978L66.9825 14.2005H65.2823L63.9164 11.4059L63.3533 12.0936V14.2005H61.8203V4.91797H63.3533V10.136Z"
        fill="#6334FA"
      />
      <path
        d="M69.9563 7.29741C70.3063 7.27573 70.6562 7.3427 70.9737 7.49214C71.2911 7.64159 71.5659 7.8687 71.7726 8.15253C72.1795 8.72382 72.3793 9.60804 72.3793 10.827V11.2164H68.9572C68.9582 11.4857 68.9801 11.7546 69.0226 12.0206C69.0531 12.2263 69.1143 12.4262 69.2043 12.6137C69.2742 12.7618 69.3836 12.8877 69.5203 12.9776C69.663 13.0659 69.8285 13.1102 69.9962 13.1049C70.1212 13.1074 70.2447 13.0776 70.3548 13.0183C70.4649 12.959 70.5578 12.8723 70.6247 12.7665C70.7971 12.4823 70.8794 12.1524 70.8608 11.8204H72.3793C72.3878 12.2053 72.3275 12.5885 72.2013 12.9521C72.0959 13.2501 71.926 13.521 71.7036 13.7453C71.4893 13.9548 71.2312 14.1139 70.948 14.2111C70.6414 14.3148 70.3198 14.3664 69.9962 14.3639C69.6234 14.3884 69.2502 14.3232 68.9077 14.1738C68.5652 14.0244 68.2633 13.7952 68.0273 13.5052C67.5768 12.9327 67.3516 12.04 67.3516 10.827C67.3516 9.6141 67.5756 8.7226 68.0236 8.15253C68.2539 7.86541 68.5496 7.63787 68.8859 7.48906C69.2222 7.34026 69.5893 7.27453 69.9563 7.29741ZM69.9563 8.55643C69.809 8.54527 69.6617 8.57758 69.5326 8.64937C69.4034 8.72115 69.2982 8.82926 69.2297 8.96034C69.0621 9.3167 68.9741 9.70537 68.9718 10.0993H70.7627C70.7828 9.70939 70.7145 9.32002 70.5629 8.96034C70.5136 8.84004 70.4295 8.73729 70.3214 8.66531C70.2132 8.59332 70.0861 8.5554 69.9563 8.55643Z"
        fill="#6334FA"
      />
      <path
        d="M76.2298 7.29331C76.3173 7.29342 76.4047 7.2995 76.4914 7.3115L76.6985 7.35153C76.755 7.3644 76.8107 7.38019 76.8656 7.39883V8.8871H76.317C76.1544 8.88701 75.9928 8.91154 75.8375 8.95987C75.6857 9.0112 75.5486 9.0986 75.4379 9.21459C75.3126 9.35167 75.2184 9.51428 75.1618 9.69127C75.0857 9.93362 75.0501 10.1869 75.0565 10.4409V14.2034H73.5234V7.44978H74.8022L74.9838 8.43589H75.0565C75.1034 8.29355 75.1579 8.15386 75.2199 8.01743C75.28 7.885 75.3596 7.76234 75.4561 7.65355C75.5489 7.54871 75.6596 7.46123 75.783 7.39519C75.921 7.32414 76.0747 7.28909 76.2298 7.29331Z"
        fill="#6334FA"
      />
      <path
        d="M3.26984 16.3356C2.53839 16.3314 1.82952 16.0815 1.25657 15.626C0.68362 15.1706 0.279695 14.5358 0.109389 13.8233C-0.0609168 13.1108 0.0122341 12.3616 0.317144 11.6956C0.622053 11.0297 1.14111 10.4853 1.7913 10.1497C1.81626 9.23015 2.13541 8.34292 2.70172 7.61872C3.26803 6.89453 4.05157 6.37166 4.93692 6.12713C5.82226 5.8826 6.76261 5.92935 7.61943 6.26049C8.47625 6.59162 9.20425 7.18964 9.69619 7.96645C10.0796 7.81616 10.4869 7.73605 10.8986 7.72993C11.6226 7.72808 12.3281 7.95847 12.9119 8.38736C13.4957 8.81625 13.927 9.42111 14.1427 10.1133C14.6897 10.3852 15.1498 10.805 15.4708 11.3253C15.7918 11.8456 15.9609 12.4455 15.9591 13.0571C15.9605 13.8441 15.6789 14.6052 15.1659 15.2012C14.6529 15.7973 13.9428 16.1884 13.1655 16.3029V16.3356H3.26984Z"
        fill="#6334FF"
      />
      <path
        d="M13.73 10.449C13.6262 10.0126 13.4238 9.60583 13.1384 9.26005C12.8529 8.91426 12.4921 8.63867 12.0837 8.4545C11.6752 8.27032 11.23 8.18247 10.7824 8.1977C10.3347 8.21292 9.89651 8.33082 9.50147 8.54233C9.11688 7.77159 8.48393 7.15337 7.70503 6.78766C6.92613 6.42196 6.04683 6.33018 5.20939 6.52715C4.37195 6.72413 3.62534 7.19835 3.09036 7.87309C2.55537 8.54783 2.26329 9.38363 2.26138 10.2453C2.26138 10.3071 2.26138 10.3726 2.26138 10.4345C1.65111 10.671 1.14261 11.1138 0.823902 11.6862C0.505194 12.2586 0.396347 12.9246 0.516206 13.569C0.636065 14.2133 0.977083 14.7954 1.48022 15.2144C1.98336 15.6335 2.61695 15.8631 3.27129 15.8636H12.6947C13.3446 15.8605 13.9734 15.6314 14.4734 15.2154C14.9734 14.7994 15.3136 14.2223 15.4359 13.5829C15.5581 12.9434 15.4549 12.2813 15.1437 11.7097C14.8326 11.1381 14.3329 10.6925 13.73 10.449Z"
        fill="white"
      />
      <path
        opacity="0.6"
        d="M12.7656 6.03674H20.3145L12.7656 0V6.03674Z"
        fill="black"
      />
      <path d="M12.7656 6.03674H20.3145L12.7656 0V6.03674Z" fill="#6334FF" />
      <path
        d="M7.23292 11.9408C7.61613 11.9408 7.92678 11.6296 7.92678 11.2458C7.92678 10.8619 7.61613 10.5508 7.23292 10.5508C6.84971 10.5508 6.53906 10.8619 6.53906 11.2458C6.53906 11.6296 6.84971 11.9408 7.23292 11.9408Z"
        fill="#6334FA"
      />
      <path
        d="M7.43436 11.5H7.03113L6.5625 13.4395H7.90662L7.43436 11.5Z"
        fill="#6334FA"
      />
    </g>
    <defs>
      <clipPath id="clip0_8091_23403">
        <rect width="77" height="18.8635" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const AvgSalary = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8267 17.6346C22.488 17.4159 22.8052 16.1642 22.0926 15.6659C21.8308 15.4823 21.4218 15.3405 20.8267 15.2203V17.6346ZM19.998 11.8204C18.3367 12.0392 18.0195 13.2909 18.7321 13.7891C18.9939 13.9728 19.4029 14.1145 19.998 14.2347V11.8204ZM16.1531 6.98903C18.8171 7.72088 22.0074 7.72088 24.6715 6.98903C25.8767 6.65821 26.6635 6.3139 26.6635 6.12216C26.6635 5.60366 26.2694 5.14323 25.7431 5.01225C24.3112 5.93584 22.527 6.0047 20.4121 6.0047C18.2973 6.0047 16.5132 5.93719 15.0812 5.01225C14.5548 5.14323 14.1607 5.60366 14.1607 6.12216C14.1607 6.3139 14.9479 6.65822 16.1531 6.98903ZM24.723 4.62742C23.0239 5.38896 17.9603 5.35522 16.2975 4.70978C16.759 2.65603 15.373 1.25579 15.2394 0.879081C14.9276 -0.00265084 16.4769 -0.0755524 16.9817 0.297113C18.0857 1.11134 19.2234 3.423 21.2005 2.0322C21.7876 1.62172 25.4746 -1.00049 25.4746 0.41592C25.4746 0.947939 25.1765 3.71451 24.723 4.62742ZM21.237 24.7924C21.7822 24.2293 22.3288 23.4259 22.2586 22.6792C22.1722 21.7651 21.407 21.5976 20.6863 21.4774C17.9831 20.778 16.2934 19.8179 14.9667 19.0645C13.2433 18.0856 12.0907 17.432 10.2797 17.9573C10.0004 15.0461 12.4755 9.99617 14.6119 7.31448C17.6201 8.70794 23.206 8.70794 26.2128 7.31448C27.4369 8.85108 28.4315 10.6091 29.1617 12.27C30.5315 15.3877 31.2387 18.1394 29.6381 20.4606C29.0415 21.3261 28.1859 22.0323 27.1616 22.5832L21.237 24.7924ZM2.81117 22.293C2.48997 22.478 0.0391443 23.8283 0 23.9741L0.0148455 24.097L4.51419 31.8949C4.59517 32.0245 4.66804 32.0191 4.78411 31.9597C5.07967 31.8071 7.52511 30.4366 7.56156 30.2989L3.36037 22.9171C3.17683 22.5958 3.02304 22.1715 2.81117 22.293ZM4.25118 22.8088C10.6604 17.5685 11.7629 18.1948 14.5593 19.7829C15.9318 20.5633 17.6836 21.5585 20.5218 22.2876C20.5461 22.2944 20.5717 22.2984 20.596 22.2998V22.3011C22.5043 22.4334 20.6797 24.2658 20.0481 24.7464C19.7134 25.0003 18.9158 25.2596 18.6135 25.211L15.4393 24.178C14.9211 24.0092 14.666 24.7964 15.1829 24.9652L19.2949 26.3033C19.3962 26.3357 19.5001 26.3276 19.5905 26.2884L27.1982 23.4502L27.2158 23.4839L30.2119 22.3254C31.8327 21.7205 33.0595 23.9241 30.633 24.9719L17.7606 30.5323C14.2625 32.0433 12.1816 26.4154 7.79244 28.9458L4.25118 22.8088ZM23.2737 13.053C23.2737 13.5985 22.445 13.5985 22.445 13.053C22.445 12.3468 21.5341 11.9134 20.8269 11.8202V14.3789C22.1603 14.6274 23.2737 15.0433 23.2737 16.4017C23.2737 17.6075 22.0105 18.3447 20.8269 18.4689C20.8269 19.0117 20.9524 19.7058 20.4126 19.7058C19.8714 19.7058 19.9982 19.0117 19.9982 18.4689C17.5649 18.2137 17.0616 15.9871 17.9658 15.9871C18.623 15.9871 18.0683 16.6636 18.9159 17.2442C19.202 17.44 19.5758 17.5791 19.9982 17.6345V15.0757C18.6649 14.8273 17.5515 14.4114 17.5515 13.053C17.5515 11.8472 18.8147 11.11 19.9982 10.9857C19.9982 10.4429 19.8727 9.74888 20.4126 9.74888C20.9537 9.74888 20.8269 10.4429 20.8269 10.9857C22.0105 11.1099 23.2737 11.8472 23.2737 13.053Z"
      fill="#1776f0"
    />
  </svg>
);

export const PayBack = () => (
  <svg
    width="32"
    height="30"
    viewBox="0 0 32 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.66862 0H4.78507C4.66158 0.000665131 4.54334 0.0508302 4.45606 0.13959C4.36877 0.22835 4.31949 0.348531 4.31893 0.474007V2.71181C4.31987 2.83697 4.36934 2.95671 4.4566 3.04504C4.54387 3.13337 4.66189 3.18318 4.78507 3.18365H5.66862C5.79205 3.18299 5.91023 3.13287 5.99751 3.04419C6.08478 2.95551 6.1341 2.83542 6.13476 2.71001V0.474007C6.1341 0.348594 6.08478 0.228505 5.99751 0.139823C5.91023 0.0511406 5.79205 0.00102576 5.66862 0.000361432V0ZM14.3893 0H13.5058C13.3823 0.000665131 13.2641 0.0508302 13.1768 0.13959C13.0895 0.22835 13.0402 0.348531 13.0396 0.474007V2.71181C13.0406 2.83697 13.09 2.95671 13.1773 3.04504C13.2646 3.13337 13.3826 3.18318 13.5058 3.18365H14.3893C14.5128 3.18299 14.6309 3.13287 14.7182 3.04419C14.8055 2.95551 14.8548 2.83542 14.8555 2.71001V0.474007C14.8549 0.348531 14.8056 0.22835 14.7183 0.13959C14.6311 0.0508302 14.5128 0.000665131 14.3893 0ZM23.1111 0H22.2265C22.1029 0.000570208 21.9846 0.0506932 21.8973 0.139464C21.8099 0.228234 21.7606 0.348469 21.76 0.474007V2.71181C21.7609 2.83703 21.8105 2.95682 21.8978 3.04517C21.9851 3.13351 22.1033 3.18328 22.2265 3.18365H23.1111C23.2345 3.18299 23.3527 3.13287 23.44 3.04419C23.5273 2.95551 23.5766 2.83542 23.5772 2.71001V0.474007C23.5767 0.348531 23.5274 0.22835 23.4401 0.13959C23.3528 0.0508302 23.2346 0.000665131 23.1111 0ZM17.9762 25.7832C17.9762 25.6796 18.0167 25.5803 18.0888 25.507C18.1608 25.4338 18.2586 25.3926 18.3605 25.3926C18.4625 25.3926 18.5602 25.4338 18.6323 25.507C18.7044 25.5803 18.7449 25.6796 18.7449 25.7832C18.7474 25.8877 18.7724 25.9904 18.8181 26.084C18.8639 26.1777 18.9293 26.2599 19.0098 26.3251C19.2155 26.4897 19.4697 26.5791 19.7316 26.5791C19.9934 26.5791 20.2476 26.4897 20.4533 26.3251C20.5338 26.2599 20.5992 26.1777 20.645 26.084C20.6907 25.9904 20.7157 25.8877 20.7182 25.7832C20.7182 25.1871 20.1849 25.0754 19.6498 24.9638C18.8117 24.7889 17.9762 24.6144 17.9762 23.3976C17.9786 23.1799 18.028 22.9654 18.121 22.7693C18.2139 22.5731 18.3481 22.4001 18.5141 22.2624C18.7537 22.0591 19.0405 21.9213 19.3472 21.8621V21.3047C19.3472 21.2011 19.3877 21.1018 19.4598 21.0285C19.5319 20.9553 19.6296 20.9141 19.7316 20.9141C19.8335 20.9141 19.9313 20.9553 20.0033 21.0285C20.0754 21.1018 20.1159 21.2011 20.1159 21.3047V21.8621C20.4228 21.9218 20.7096 22.0602 20.949 22.2643C21.115 22.4019 21.2492 22.5749 21.3421 22.7711C21.4351 22.9672 21.4845 23.1817 21.4869 23.3994C21.4869 23.503 21.4464 23.6023 21.3744 23.6756C21.3023 23.7488 21.2045 23.79 21.1026 23.79C21.0006 23.79 20.9029 23.7488 20.8308 23.6756C20.7587 23.6023 20.7182 23.503 20.7182 23.3994C20.7158 23.2949 20.6908 23.1922 20.645 23.0985C20.5993 23.0049 20.5338 22.9226 20.4533 22.8575C20.2476 22.6929 19.9934 22.6035 19.7316 22.6035C19.4697 22.6035 19.2155 22.6929 19.0098 22.8575C18.9293 22.9226 18.8638 23.0049 18.8181 23.0985C18.7723 23.1922 18.7473 23.2949 18.7449 23.3994C18.7449 23.9818 19.2732 24.0924 19.803 24.2029C20.6439 24.3785 21.4869 24.5544 21.4869 25.785C21.4845 26.0027 21.435 26.2172 21.3421 26.4133C21.2491 26.6094 21.1149 26.7825 20.949 26.9201C20.7094 27.1239 20.4227 27.2623 20.1159 27.3223V27.8776C20.1159 27.9811 20.0754 28.0805 20.0033 28.1537C19.9313 28.227 19.8335 28.2681 19.7316 28.2681C19.6296 28.2681 19.5319 28.227 19.4598 28.1537C19.3877 28.0805 19.3472 27.9811 19.3472 27.8776V27.3208C19.0405 27.2613 18.7539 27.1234 18.5141 26.9201C18.3481 26.7824 18.2139 26.6093 18.121 26.4131C18.028 26.2169 17.9786 26.0024 17.9762 25.7846V25.7832ZM19.7689 16.3641L21.578 17.0845C21.6379 17.0611 21.6912 17.0229 21.733 16.9732C21.7997 16.9001 21.8382 16.8051 21.8414 16.7055C21.841 16.6151 21.8056 16.5286 21.7427 16.4646C21.6799 16.4007 21.5947 16.3646 21.5058 16.3641H19.7689ZM18.032 16.9725C18.1014 16.8234 18.1967 16.6881 18.3132 16.5733C18.3974 16.4906 18.4924 16.4202 18.5956 16.3641H18.0309C17.942 16.3646 17.8568 16.4007 17.794 16.4646C17.7311 16.5286 17.6957 16.6151 17.6953 16.7055C17.6884 16.8031 17.7085 16.9007 17.7532 16.9873C17.7645 17.0029 17.7794 17.0153 17.7966 17.0234C17.8746 17.0044 17.9531 16.9869 18.032 16.9711V16.9725ZM24.5031 21.2718C23.195 21.2863 22.752 20.9932 21.6295 20.2512C21.5012 20.1659 21.3607 20.0731 21.1051 19.9079L18.7022 18.8053C18.4969 18.7198 18.3165 18.5821 18.1785 18.4055C18.0405 18.2289 17.9494 18.0192 17.914 17.7966C17.1338 17.9899 16.4219 18.3998 15.8578 18.9805C15.2908 19.5568 14.9686 20.3359 14.9604 21.1508C14.9604 21.3856 14.9639 21.5865 14.9696 21.765C14.976 21.9557 14.9852 22.158 14.9966 22.3658C15.008 22.5735 15.0229 22.8127 15.0375 23.0472C15.1737 25.2188 15.2935 27.1297 13.6832 28.9997C13.6255 29.0568 13.5865 29.1306 13.5716 29.211C13.5567 29.2915 13.5666 29.3746 13.6 29.4491C13.6481 29.5487 13.7165 29.6367 13.8005 29.7075C13.9019 29.7951 14.017 29.8649 14.1412 29.9138C14.2905 29.9863 14.4572 30.014 14.6215 29.9933C14.7859 29.9727 14.9409 29.9047 15.0684 29.7974C15.2584 29.6124 15.4784 29.4622 15.7188 29.3534C15.9451 29.2525 16.1846 29.1855 16.4299 29.1543C17.0623 29.1027 17.6987 29.1419 18.3204 29.2707C18.7867 29.3557 19.2587 29.4052 19.7323 29.4188C20.2059 29.4052 20.6778 29.3557 21.1442 29.2707C22.3381 29.0853 23.4759 28.9094 24.3957 29.7974C24.5232 29.9048 24.6782 29.9727 24.8425 29.9934C25.0067 30.014 25.1734 29.9864 25.3227 29.9138C25.4468 29.8649 25.5619 29.7951 25.6633 29.7075C25.7471 29.6367 25.8152 29.5486 25.8631 29.4491C25.8968 29.3747 25.9071 29.2915 25.8924 29.2109C25.8778 29.1303 25.839 29.0563 25.7813 28.999C24.1682 27.1264 24.2916 25.1224 24.4277 22.9073C24.4604 22.3788 24.4935 21.8372 24.502 21.2736L24.5031 21.2718ZM27.8972 21.7346V21.7368L27.8916 21.7516L27.6562 22.3614L29.7184 23.1826L32 17.2622L29.9378 16.4429L27.8962 21.7357L27.8972 21.7346ZM22.3598 17.4234C22.4253 17.4849 22.4676 17.5676 22.4795 17.6574C22.4915 17.7471 22.4723 17.8383 22.4252 17.9153C22.3782 17.9922 22.3063 18.0501 22.2218 18.079C22.1373 18.1079 22.0456 18.106 21.9623 18.0737L19.3988 17.0527C19.3089 17.0086 19.208 16.9929 19.1092 17.0075C19.0105 17.0221 18.9182 17.0664 18.8444 17.1347C18.7868 17.1919 18.7413 17.2605 18.7108 17.3363C18.6785 17.4153 18.6621 17.5001 18.6624 17.5856C18.6654 17.6967 18.7007 17.8043 18.7641 17.8949C18.8274 17.9855 18.9157 18.0549 19.018 18.0943L21.4471 19.2107C21.4636 19.2184 21.4797 19.2273 21.4951 19.237C21.6309 19.3248 21.8482 19.4683 22.0462 19.5983C23.2441 20.3906 23.5548 20.5958 25.4667 20.4401C25.5327 20.4351 25.5988 20.4475 25.6587 20.4762L27.3159 21.1034L28.8185 17.2081L27.2512 16.5798C27.2219 16.5682 27.1942 16.5529 27.1687 16.5343L24.4523 14.5642C24.2607 14.4439 24.0583 14.3424 23.8478 14.261C23.5989 14.1559 23.3223 14.0529 23.0756 13.9677L22.1291 15.7817C22.1852 15.821 22.2377 15.8654 22.2859 15.9143C22.3888 16.0185 22.4705 16.1424 22.5261 16.2788C22.5818 16.4152 22.6103 16.5615 22.6101 16.7091C22.607 16.9697 22.5195 17.222 22.3612 17.427L22.3598 17.4234ZM17.3184 15.4833L15.5303 15.9417C15.4084 15.9634 15.2957 16.0218 15.2069 16.1094C15.1181 16.1971 15.0573 16.3099 15.0325 16.4331C15.0162 16.5327 15.02 16.6346 15.0436 16.7326C15.0661 16.833 15.1082 16.9278 15.1673 17.0115C15.2474 17.1202 15.3577 17.2021 15.484 17.2466C15.6102 17.2912 15.7467 17.2964 15.8759 17.2615L16.9593 17.0357C16.9358 16.9273 16.9239 16.8166 16.9237 16.7055C16.9243 16.5229 16.9685 16.3432 17.0526 16.1817C17.1366 16.0203 17.258 15.882 17.4062 15.7788L17.3159 15.4833H17.3184ZM17.9179 14.8171L17.6053 13.7946L18.0764 13.3484L18.2709 14.2517C18.2924 14.3529 18.3525 14.4413 18.4382 14.4975C18.5238 14.5536 18.6278 14.573 18.7275 14.5512C18.8271 14.5294 18.9141 14.4682 18.9694 14.3812C19.0247 14.2942 19.0437 14.1885 19.0222 14.0873L18.4398 11.387L21.4133 11.1952L20.635 14.205C20.6205 14.2551 20.616 14.3076 20.6217 14.3594C20.6275 14.4113 20.6435 14.4614 20.6687 14.5069C20.6939 14.5523 20.7278 14.5922 20.7685 14.624C20.8091 14.6559 20.8556 14.6792 20.9053 14.6925C20.955 14.7058 21.0067 14.7088 21.0576 14.7014C21.1084 14.6939 21.1572 14.6762 21.2012 14.6492C21.2451 14.6223 21.2833 14.5866 21.3135 14.5444C21.3436 14.5022 21.3651 14.4542 21.3767 14.4034L21.8162 12.7053L22.7908 12.8499L21.3639 15.583H18.1515L17.9676 14.9814C17.9659 14.9601 17.9625 14.939 17.9573 14.9182C17.9487 14.8832 17.9355 14.8495 17.9179 14.8181V14.8171ZM25.5054 27.0719C25.018 25.8074 25.1026 24.4309 25.1936 22.9532C25.2292 22.3925 25.2647 21.8181 25.2715 21.2389L25.4446 21.2263L27.0364 21.8285L26.8988 22.1851C26.8362 22.3496 26.8401 22.5327 26.9099 22.6942C26.9797 22.8558 27.1095 22.9827 27.2711 23.0472L27.8951 23.2961V25.9353C27.894 26.2364 27.7758 26.5248 27.5662 26.7377C27.3567 26.9506 27.0729 27.0707 26.7765 27.0719H25.5054ZM7.1232 20.4553H3.81902V23.8131H7.1232V20.4553ZM3.43467 19.6742H7.50756C7.55815 19.674 7.60828 19.684 7.65508 19.7035C7.70188 19.723 7.74441 19.7518 7.78026 19.7881C7.8161 19.8244 7.84454 19.8675 7.86394 19.915C7.88335 19.9624 7.89333 20.0133 7.89333 20.0647V24.2033C7.89333 24.3069 7.85285 24.4063 7.78078 24.4796C7.70871 24.5529 7.61095 24.5941 7.50898 24.5942H3.43467C3.3327 24.5941 3.23494 24.5529 3.16286 24.4796C3.09079 24.4063 3.05031 24.3069 3.05031 24.2033V20.0647C3.05031 19.9612 3.09081 19.8618 3.16289 19.7886C3.23497 19.7153 3.33273 19.6742 3.43467 19.6742ZM14.2542 20.4553C14.2116 20.6846 14.1902 20.9174 14.1902 21.1508C14.1902 21.3376 14.1948 21.5532 14.2023 21.7877C14.2098 22.0081 14.219 22.2119 14.2293 22.4055C14.2432 22.6584 14.2567 22.8774 14.2702 23.092C14.2855 23.3347 14.3004 23.5743 14.3125 23.8102H12.2197V20.4553H14.2542ZM7.1232 13.3853H3.81902V16.7427H7.1232V13.3853ZM3.43467 12.6042H7.50756C7.55815 12.604 7.60828 12.614 7.65508 12.6335C7.70188 12.653 7.74441 12.6818 7.78026 12.7181C7.8161 12.7543 7.84454 12.7975 7.86394 12.8449C7.88335 12.8924 7.89333 12.9433 7.89333 12.9947V17.1333C7.89333 17.2368 7.85284 17.3362 7.78076 17.4094C7.70868 17.4827 7.61092 17.5238 7.50898 17.5238H3.43467C3.33273 17.5238 3.23497 17.4827 3.16289 17.4094C3.09081 17.3362 3.05031 17.2368 3.05031 17.1333V12.9947C3.05031 12.8912 3.09081 12.7918 3.16289 12.7186C3.23497 12.6453 3.33273 12.6042 3.43467 12.6042ZM15.5236 15.139L15.3436 15.1849C15.0769 15.2399 14.8326 15.3753 14.6427 15.5735C14.4528 15.7717 14.3261 16.0234 14.2791 16.2958C14.2533 16.4433 14.2492 16.594 14.267 16.7427H12.2197V13.3853H15.5239L15.5236 15.139ZM27.8948 8.53069H0V25.9353C0.00112385 26.2364 0.119334 26.5248 0.328865 26.7377C0.538396 26.9506 0.822258 27.0707 1.11858 27.0719H13.9644C14.248 26.2789 14.3752 25.437 14.3388 24.5942H11.835C11.7331 24.5941 11.6353 24.5529 11.5632 24.4796C11.4911 24.4063 11.4507 24.3069 11.4507 24.2033V20.0647C11.4507 20.0135 11.4606 19.9627 11.4799 19.9153C11.4992 19.8679 11.5276 19.8248 11.5632 19.7886C11.5989 19.7523 11.6413 19.7235 11.6879 19.7039C11.7346 19.6843 11.7845 19.6742 11.835 19.6742H14.4896C14.6857 19.2165 14.9615 18.7985 15.3038 18.4404C15.4314 18.3054 15.567 18.1785 15.7099 18.0603C15.4951 18.0656 15.282 18.0198 15.0877 17.9267C14.8934 17.8335 14.7232 17.6956 14.5906 17.5238H11.835C11.7845 17.5238 11.7346 17.5137 11.6879 17.4941C11.6413 17.4745 11.5989 17.4457 11.5632 17.4094C11.5276 17.3732 11.4992 17.3301 11.4799 17.2827C11.4606 17.2353 11.4507 17.1846 11.4507 17.1333V12.9947C11.4507 12.9434 11.4606 12.8927 11.4799 12.8453C11.4992 12.7979 11.5276 12.7548 11.5632 12.7186C11.5989 12.6823 11.6413 12.6535 11.6879 12.6339C11.7346 12.6143 11.7845 12.6042 11.835 12.6042H15.9083C16.0102 12.6042 16.108 12.6453 16.18 12.7186C16.2521 12.7918 16.2926 12.8912 16.2926 12.9947V14.9417L17.0905 14.7372L16.8014 13.7914C16.7806 13.7213 16.7795 13.6467 16.7984 13.576C16.8172 13.5054 16.8552 13.4415 16.9081 13.3918L17.8844 12.4651L17.5922 11.1092C17.5706 11.008 17.5895 10.9024 17.6447 10.8154C17.6998 10.7284 17.7867 10.6672 17.8862 10.6453C17.9109 10.6399 17.936 10.637 17.9612 10.6366L21.8937 10.3837C21.9952 10.3773 22.0951 10.4121 22.1713 10.4804C22.2476 10.5488 22.294 10.6451 22.3004 10.7483C22.3032 10.7945 22.298 10.8408 22.2852 10.8852L22.011 11.9456L23.4382 12.1587C23.4881 12.1661 23.536 12.1834 23.5793 12.2096C23.6226 12.2359 23.6604 12.2705 23.6905 12.3116C23.7206 12.3526 23.7425 12.3993 23.7548 12.449C23.7672 12.4986 23.7698 12.5503 23.7625 12.6009C23.7555 12.652 23.7384 12.7012 23.7124 12.7454L23.4386 13.2708C23.6683 13.3524 23.9147 13.446 24.1412 13.5414C24.4049 13.6445 24.6575 13.7746 24.8953 13.9297L27.5726 15.8731L27.8926 16.0017V8.53069H27.8948ZM0 7.75139V3.02722C0.00112385 2.72612 0.119334 2.43768 0.328865 2.22478C0.538396 2.01187 0.822258 1.89175 1.11858 1.89061H3.54987V2.71145C3.55081 3.044 3.68126 3.36265 3.91271 3.59777C4.14416 3.83288 4.45779 3.96534 4.78507 3.9662H5.66862C5.99589 3.96543 6.30954 3.83299 6.54096 3.59785C6.77238 3.3627 6.90272 3.044 6.90347 2.71145V1.89061H12.2724V2.71145C12.2733 3.044 12.4037 3.36265 12.6352 3.59777C12.8666 3.83288 13.1803 3.96534 13.5076 3.9662H14.3893C14.7166 3.96543 15.0303 3.83299 15.2617 3.59785C15.4931 3.3627 15.6234 3.044 15.6242 2.71145V1.89061H20.9931V2.71145C20.994 3.044 21.1245 3.36265 21.3559 3.59777C21.5874 3.83288 21.901 3.96534 22.2283 3.9662H23.1111C23.4384 3.96543 23.752 3.83299 23.9834 3.59785C24.2149 3.3627 24.3452 3.044 24.346 2.71145V1.89061H26.7772C27.0736 1.89175 27.3574 2.01187 27.567 2.22478C27.7765 2.43768 27.8947 2.72612 27.8958 3.02722V7.75139H0Z"
      fill="#1776f0"
    />
  </svg>
);

export const LivingExpense = () => (
  <svg
    width="32"
    height="34"
    viewBox="0 0 32 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.96113 14.5415L9.4035 11.5584C8.86114 10.8255 8.43601 9.99724 8.16484 9.11035L0 12.885V17.5904H2.96108L2.96113 14.5415Z"
      fill="#1776f0"
    />
    <path
      d="M23.8344 9.11047C23.5632 9.99732 23.1381 10.8255 22.5957 11.5585L29.0381 14.5416V17.5906H31.9992V12.8853L23.8344 9.11047Z"
      fill="#1776f0"
    />
    <path d="M12.9648 23.0947H19.0338V33.422H12.9648V23.0947Z" fill="#1776f0" />
    <path
      d="M27.5732 15.4798L21.5779 12.7019C20.112 14.0725 18.155 14.908 16 14.908C13.845 14.908 11.8882 14.0725 10.4222 12.7019L4.42682 15.4798V19.0565H2.96094V33.4221H11.4996V22.3621C11.4996 21.959 11.8295 21.6292 12.2326 21.6292H19.767C20.1701 21.6292 20.4999 21.959 20.4999 22.3621V33.4221H29.0386V19.0565H27.5727L27.5732 15.4798ZM9.42535 27.8959H5.79729V22.3621H9.42535V27.8959ZM26.2025 27.8959H22.5745V22.3621H26.2025V27.8959Z"
      fill="#1776f0"
    />
    <path
      d="M16.0003 13.442C19.7163 13.442 22.7213 10.437 22.7213 6.721C22.7213 3.00503 19.7163 0 16.0003 0C12.2843 0 9.2793 3.00503 9.2793 6.721C9.2793 10.437 12.2843 13.442 16.0003 13.442ZM14.6883 3.37129C14.9302 3.12942 15.2234 2.96084 15.5385 2.85089V2.29386C15.5385 1.89074 15.8684 1.56092 16.2715 1.56092C16.6746 1.56092 17.0044 1.89074 17.0044 2.29386V2.71896H17.5908C17.9939 2.71896 18.3237 3.04878 18.3237 3.4519C18.3237 3.86235 17.9939 4.18484 17.5908 4.18484H16.2715C16.0076 4.18484 15.8171 4.31677 15.7071 4.41938C15.5679 4.55865 15.4872 4.75654 15.4872 4.96174C15.4872 5.38684 15.8391 5.73863 16.2641 5.74599H16.2715C17.5101 5.76065 18.5069 6.76479 18.5069 7.98877C18.5069 8.59712 18.2724 9.16147 17.8473 9.57924C17.6054 9.82111 17.3196 9.99701 17.0044 10.107V10.6713C17.0044 11.0744 16.6746 11.4042 16.2715 11.4042C15.8683 11.4042 15.5385 11.0744 15.5385 10.6713V10.2389H14.9375C14.5344 10.2389 14.2046 9.90905 14.2046 9.50593C14.2046 9.10281 14.5344 8.77299 14.9375 8.77299H16.2568C16.528 8.77299 16.7039 8.64839 16.8139 8.54577C16.9605 8.39919 17.0411 8.20862 17.0411 7.98874C17.0411 7.56363 16.6893 7.21185 16.2642 7.21185H16.2569C15.0182 7.18986 14.0214 6.18573 14.0214 4.96171C14.0214 4.36072 14.2632 3.78174 14.6883 3.37129Z"
      fill="#1776f0"
    />
  </svg>
);
export const PurpleGlobeFill = () => (
  <svg
    className="w-full h-full"
    width="130"
    height="130"
    viewBox="0 0 130 130"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.565 98.8144C109.962 101.769 99.2555 103.837 88.4607 105.041C86.945 109.384 85.2 113.262 83.2702 116.556C78.2128 125.198 71.7433 129.999 65.0001 129.999C88.5128 129.999 109.134 117.516 120.565 98.8144ZM9.36883 98.711C20.7849 117.457 41.4419 129.999 65.0001 129.999C58.2568 129.999 51.7881 125.198 46.7308 116.556C44.7714 113.203 42.9968 109.251 41.4739 104.827C30.8562 103.586 20.1561 101.547 9.36883 98.711ZM47.9939 105.491C59.4175 106.474 70.7306 106.533 81.9475 105.654C80.8015 108.572 79.5372 111.231 78.1618 113.579C74.4057 119.998 70.0138 124.09 65.0008 124.09C59.9878 124.09 55.5957 119.998 51.8398 113.579C50.4349 111.186 49.1546 108.475 47.9939 105.491ZM88.6311 67.9538C88.3871 79.6683 86.7383 90.5119 84.0395 99.5295C71.4626 100.689 58.7531 100.63 45.9084 99.3522C43.2391 90.3632 41.6052 79.5869 41.3686 67.9543L88.6311 67.9538ZM129.999 67.9538H94.5462C94.3244 79.2696 92.816 89.8161 90.3613 98.8431C101.541 97.4545 112.602 95.0835 123.567 91.745C123.833 91.6637 124.107 91.612 124.381 91.5972C127.656 84.3291 129.622 76.3447 129.999 67.9538ZM35.4539 67.9538H0.00121125C0.378301 76.3446 2.3451 84.3292 5.62064 91.5973C5.87203 91.6047 6.12342 91.649 6.37483 91.7229C17.5469 94.899 28.608 97.2034 39.5807 98.6289C37.163 89.6399 35.6758 79.1743 35.4539 67.9538ZM39.5945 31.303C28.6886 32.7359 17.6206 35.0552 6.381 38.2756C6.12961 38.342 5.87082 38.3937 5.61943 38.4011C2.34389 45.6693 0.377241 53.6537 0 62.0446H35.4527C35.6745 50.7954 37.1693 40.2997 39.5945 31.303ZM45.9311 30.5643C58.8629 29.2643 71.5506 29.2053 84.0092 30.3575C86.7227 39.4057 88.3863 50.2855 88.6303 62.0448H41.3683C41.6049 50.3819 43.2471 39.5743 45.9311 30.5643ZM90.3312 31.0444C92.8008 40.1074 94.324 50.685 94.5458 62.0453H129.999C129.621 53.6546 127.655 45.67 124.379 38.4018C124.105 38.3871 123.825 38.3354 123.544 38.2541C112.66 34.8785 101.599 32.4626 90.3312 31.0444ZM9.37488 31.2734C20.2365 28.4002 30.9437 26.3467 41.4943 25.0986C43.0101 20.6964 44.7772 16.7744 46.7291 13.443C51.7866 4.80115 58.2561 2.49554e-05 64.9993 2.49554e-05C41.443 2.49554e-05 20.7981 12.5273 9.37488 31.2734ZM88.4232 24.8622C99.2923 26.0735 110.005 28.1786 120.55 31.1552C109.112 12.4755 88.5045 2.49554e-05 64.9993 2.49554e-05C71.7425 2.49554e-05 78.2124 4.80039 83.2696 13.4423C85.1846 16.7144 86.9222 20.5559 88.4232 24.8622ZM48.0227 24.419C49.1761 21.4719 50.4554 18.7906 51.8379 16.4197C55.594 10.0011 59.9859 5.90905 64.9989 5.90905C70.0119 5.90905 74.404 10.0011 78.16 16.4197C79.513 18.739 80.77 21.3611 81.9013 24.2417C70.7809 23.3627 59.4895 23.4145 48.0227 24.419Z"
      fill="#5E57EB"
      fillOpacity="0.5"
    />
  </svg>
);

export const LocationPurple = () => (
  <svg
    className="w-full h-full"
    width="50"
    height="61"
    viewBox="0 0 50 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48 25.3182C48 43.4545 25 59 25 59C25 59 2 43.4545 2 25.3182C2 19.1338 4.42321 13.2027 8.73654 8.82974C13.0499 4.45673 18.9 2 25 2C31.1 2 36.9501 4.45673 41.2635 8.82974C45.5768 13.2027 48 19.1338 48 25.3182Z"
      fill="#F9F3FF"
      stroke="#5E57EB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 33C29.4183 33 33 29.6421 33 25.5C33 21.3579 29.4183 18 25 18C20.5817 18 17 21.3579 17 25.5C17 29.6421 20.5817 33 25 33Z"
      stroke="#5E57EB"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckMark = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#101828"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke="#101828"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CompassIcon = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.3721 10.6902L19.887 18.1443C19.7517 18.5501 19.5238 18.9189 19.2213 19.2213C18.9189 19.5238 18.5501 19.7517 18.1443 19.887L10.6902 22.3721L13.1754 14.918C13.3106 14.5122 13.5385 14.1434 13.841 13.841C14.1434 13.5385 14.5122 13.3106 14.918 13.1754L22.3721 10.6902Z"
      stroke={color ? color : "white"}
      strokeWidth="2.75517"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.531 30.307C24.1392 30.307 30.3069 24.1393 30.3069 16.5311C30.3069 8.92292 24.1392 2.75525 16.531 2.75525C8.9228 2.75525 2.75513 8.92292 2.75513 16.5311C2.75513 24.1393 8.9228 30.307 16.531 30.307Z"
      stroke={color ? color : "white"}
      strokeWidth="2.75517"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AiBrainIcon = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 9.99998C24.0023 9.20004 23.8447 8.40771 23.5364 7.66958C23.228 6.93145 22.7752 6.26243 22.2045 5.70187C21.6338 5.14131 20.9568 4.70052 20.2133 4.40544C19.4698 4.11036 18.6747 3.96693 17.875 3.9836C17.0752 4.00027 16.2868 4.1767 15.5562 4.50251C14.8257 4.82832 14.1676 5.29693 13.6208 5.88079C13.0739 6.46464 12.6494 7.15195 12.3721 7.90228C12.0948 8.65262 11.9703 9.45083 12.006 10.25C10.8304 10.5523 9.73897 11.1181 8.81443 11.9046C7.88989 12.6911 7.15644 13.6777 6.66965 14.7897C6.18286 15.9016 5.95548 17.1098 6.00474 18.3226C6.054 19.5354 6.3786 20.7212 6.95397 21.79C5.94233 22.6118 5.14682 23.6684 4.63664 24.8678C4.12647 26.0673 3.91708 27.3732 4.02669 28.672C4.13631 29.9707 4.5616 31.2231 5.26558 32.32C5.96955 33.417 6.93089 34.3253 8.06597 34.966C7.9258 36.0505 8.00945 37.1521 8.31174 38.203C8.61403 39.2539 9.12856 40.2317 9.82353 41.0759C10.5185 41.9201 11.3792 42.6129 12.3524 43.1115C13.3256 43.6101 14.3907 43.9038 15.4819 43.9746C16.5731 44.0455 17.6672 43.8918 18.6967 43.5232C19.7262 43.1546 20.6692 42.5788 21.4675 41.8315C22.2657 41.0842 22.9023 40.1811 23.3379 39.1781C23.7735 38.1751 23.9988 37.0935 24 36V9.99998Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 26C19.6791 25.4093 21.1454 24.334 22.2133 22.91C23.2813 21.486 23.9031 19.7773 24 18"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.006 10.2499C12.0455 11.2173 12.3186 12.1609 12.802 12.9999"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.95398 21.792C7.31986 21.494 7.71138 21.229 8.12398 21"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 36C10.6216 36.0007 9.26651 35.6452 8.06598 34.968"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 25.9999H32"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 36H36C37.0609 36 38.0783 36.4214 38.8284 37.1716C39.5786 37.9217 40 38.9391 40 40V42"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 16H40"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32 16V10C32 8.93913 32.4214 7.92172 33.1716 7.17157C33.9217 6.42143 34.9391 6 36 6"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.9999 27C32.5522 27 32.9999 26.5523 32.9999 26C32.9999 25.4477 32.5522 25 31.9999 25C31.4477 25 30.9999 25.4477 30.9999 26C30.9999 26.5523 31.4477 27 31.9999 27Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36 6.99988C36.5523 6.99988 37 6.55216 37 5.99988C37 5.44759 36.5523 4.99988 36 4.99988C35.4477 4.99988 35 5.44759 35 5.99988C35 6.55216 35.4477 6.99988 36 6.99988Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40 42.9999C40.5523 42.9999 41 42.5522 41 41.9999C41 41.4476 40.5523 40.9999 40 40.9999C39.4477 40.9999 39 41.4476 39 41.9999C39 42.5522 39.4477 42.9999 40 42.9999Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40 17C40.5523 17 41 16.5523 41 16C41 15.4477 40.5523 15 40 15C39.4477 15 39 15.4477 39 16C39 16.5523 39.4477 17 40 17Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RoundedWhiteCheck = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.6999 17.2399C7.40798 15.925 7.4528 14.5576 7.83021 13.2646C8.20762 11.9716 8.90539 10.7948 9.85883 9.84339C10.8123 8.89195 11.9905 8.19664 13.2843 7.82194C14.5781 7.44724 15.9456 7.40528 17.2599 7.69995C17.9833 6.56855 18.9799 5.63747 20.1578 4.99252C21.3357 4.34758 22.657 4.00952 23.9999 4.00952C25.3428 4.00952 26.6641 4.34758 27.842 4.99252C29.0199 5.63747 30.0165 6.56855 30.7399 7.69995C32.0562 7.404 33.426 7.44577 34.7219 7.82138C36.0178 8.19699 37.1976 8.89423 38.1516 9.84826C39.1056 10.8023 39.8029 11.9821 40.1785 13.278C40.5541 14.5738 40.5958 15.9436 40.2999 17.2599C41.4313 17.9834 42.3624 18.98 43.0073 20.1579C43.6523 21.3357 43.9903 22.657 43.9903 23.9999C43.9903 25.3429 43.6523 26.6642 43.0073 27.842C42.3624 29.0199 41.4313 30.0165 40.2999 30.7399C40.5946 32.0543 40.5526 33.4217 40.1779 34.7155C39.8032 36.0093 39.1079 37.1876 38.1565 38.141C37.205 39.0945 36.0282 39.7922 34.7352 40.1696C33.4422 40.547 32.0748 40.5919 30.7599 40.2999C30.0374 41.4357 29.0401 42.3708 27.8601 43.0186C26.6802 43.6664 25.356 44.0061 24.0099 44.0061C22.6638 44.0061 21.3396 43.6664 20.1596 43.0186C18.9797 42.3708 17.9824 41.4357 17.2599 40.2999C15.9456 40.5946 14.5781 40.5527 13.2843 40.178C11.9905 39.8033 10.8123 39.108 9.85883 38.1565C8.90539 37.2051 8.20762 36.0283 7.83021 34.7353C7.4528 33.4423 7.40798 32.0749 7.6999 30.7599C6.55981 30.0384 5.62073 29.0403 4.96999 27.8584C4.31926 26.6765 3.97803 25.3492 3.97803 23.9999C3.97803 22.6507 4.31926 21.3234 4.96999 20.1415C5.62073 18.9596 6.55981 17.9615 7.6999 17.2399Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 23.9999L22 27.9999L30 19.9999"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhiteAirplane = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 2L23.6 28.4"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50 2L33.2 50L23.6 28.4L2 18.8L50 2Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlueChipIcon = () => (
  <svg
    className="w-full h-full"
    width="198"
    height="198"
    viewBox="0 0 198 198"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M148.5 33H49.5C40.3873 33 33 40.3873 33 49.5V148.5C33 157.613 40.3873 165 49.5 165H148.5C157.613 165 165 157.613 165 148.5V49.5C165 40.3873 157.613 33 148.5 33Z"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M115.5 74.25H82.5C77.9437 74.25 74.25 77.9437 74.25 82.5V115.5C74.25 120.056 77.9437 123.75 82.5 123.75H115.5C120.056 123.75 123.75 120.056 123.75 115.5V82.5C123.75 77.9437 120.056 74.25 115.5 74.25Z"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M123.75 16.5V33"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M123.75 165V181.5"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 123.75H33"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 74.25H33"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M165 123.75H181.5"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M165 74.25H181.5"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.25 16.5V33"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.25 165V181.5"
      stroke="#00B8DB"
      strokeOpacity="0.05"
      strokeWidth="13.3333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlueLightIcon = () => (
  <svg
    className="w-full h-full"
    width="114"
    height="156"
    viewBox="0 0 114 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.9999 91C24.7699 91.0042 23.564 90.6593 22.5221 90.0053C21.4803 89.3514 20.6455 88.4153 20.1145 87.3057C19.5836 86.1962 19.3784 84.9588 19.5227 83.7372C19.667 82.5157 20.155 81.3602 20.9299 80.405L85.2799 14.105C85.7627 13.5478 86.4204 13.1713 87.1453 13.0372C87.8702 12.9032 88.6192 13.0195 89.2692 13.3672C89.9192 13.7149 90.4318 14.2733 90.7226 14.9507C91.0135 15.628 91.0655 16.3842 90.8699 17.095L78.39 56.225C78.022 57.2099 77.8984 58.2693 78.0298 59.3125C78.1612 60.3557 78.5437 61.3514 79.1445 62.2142C79.7453 63.0771 80.5465 63.7813 81.4792 64.2665C82.412 64.7517 83.4485 65.0034 84.5 65H130C131.23 64.9958 132.436 65.3407 133.478 65.9946C134.52 66.6485 135.354 67.5847 135.885 68.6942C136.416 69.8037 136.622 71.0412 136.477 72.2627C136.333 73.4842 135.845 74.6397 135.07 75.595L70.72 141.895C70.2372 142.452 69.5795 142.829 68.8546 142.963C68.1297 143.097 67.3807 142.98 66.7307 142.633C66.0807 142.285 65.5681 141.727 65.2773 141.049C64.9864 140.372 64.9344 139.616 65.13 138.905L77.6099 99.775C77.9779 98.7901 78.1015 97.7306 77.9701 96.6874C77.8387 95.6443 77.4562 94.6485 76.8554 93.7857C76.2546 92.9229 75.4534 92.2186 74.5207 91.7334C73.5879 91.2482 72.5514 90.9966 71.5 91H25.9999Z"
      stroke="#0092B8"
      strokeOpacity="0.1"
      strokeWidth="10.6667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SecorityIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3.5625L7.125 8.3125V16.625C7.125 24.3438 12.4688 31.4688 19 34.4375C25.5313 31.4688 30.875 24.3438 30.875 16.625V8.3125L19 3.5625Z"
      stroke="#0092B8"
      strokeWidth="1.76693"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 19L17.8125 22.5625L24.9375 15.4375"
      stroke="#0092B8"
      strokeWidth="1.76693"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DocumentIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.6875 8.3125H8.3125C7.00082 8.3125 5.9375 9.37582 5.9375 10.6875V27.3125C5.9375 28.6242 7.00082 29.6875 8.3125 29.6875H29.6875C30.9992 29.6875 32.0625 28.6242 32.0625 27.3125V10.6875C32.0625 9.37582 30.9992 8.3125 29.6875 8.3125Z"
      stroke="#0092B8"
      strokeWidth="1.76693"
    />
    <path
      d="M5.9375 14.25H32.0625"
      stroke="#0092B8"
      strokeWidth="1.76693"
      strokeLinecap="round"
    />
    <path
      d="M11.875 19H16.625M11.875 23.75H21.375"
      stroke="#0092B8"
      strokeWidth="1.76693"
      strokeLinecap="round"
    />
    <path
      d="M26.125 24.9375C28.0925 24.9375 29.6875 23.3425 29.6875 21.375C29.6875 19.4075 28.0925 17.8125 26.125 17.8125C24.1575 17.8125 22.5625 19.4075 22.5625 21.375C22.5625 23.3425 24.1575 24.9375 26.125 24.9375Z"
      stroke="#0092B8"
      strokeWidth="1.76693"
    />
    <path
      d="M28.5 23.75L31.4688 26.7188"
      stroke="#0092B8"
      strokeWidth="1.76693"
      strokeLinecap="round"
    />
  </svg>
);
export const PiChartIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.5825 25.159C32.5752 27.5411 30.9997 29.6402 28.9938 31.2728C26.9879 32.9053 24.6125 34.0216 22.0755 34.5241C19.5385 35.0266 16.917 34.8999 14.4402 34.1552C11.9634 33.4105 9.70681 32.0704 7.8676 30.2521C6.02839 28.4338 4.66261 26.1926 3.88966 23.7245C3.11671 21.2564 2.96013 18.6365 3.4336 16.0939C3.90707 13.5513 4.99619 11.1634 6.60573 9.13893C8.21526 7.11448 10.2962 5.51513 12.6667 4.48071"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.8333 19.0001C34.8333 16.9208 34.4238 14.8619 33.6281 12.9409C32.8324 11.0199 31.6661 9.27448 30.1959 7.80422C28.7256 6.33396 26.9801 5.16769 25.0592 4.37199C23.1382 3.57629 21.0793 3.16675 19 3.16675V19.0001H34.8333Z"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GreenClockIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 34.8334C27.7445 34.8334 34.8333 27.7446 34.8333 19.0001C34.8333 10.2556 27.7445 3.16675 19 3.16675C10.2555 3.16675 3.16663 10.2556 3.16663 19.0001C3.16663 27.7446 10.2555 34.8334 19 34.8334Z"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 9.5V19L25.3333 22.1667"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GreenAirplaneIcon = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.8333 3.16675L17.4166 20.5834"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.8333 3.16675L23.75 34.8334L17.4166 20.5834L3.16663 14.2501L34.8333 3.16675Z"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GreenPercent = () => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.0833 7.91675L7.91663 30.0834"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2917 14.2499C12.4778 14.2499 14.25 12.4777 14.25 10.2916C14.25 8.10546 12.4778 6.33325 10.2917 6.33325C8.10558 6.33325 6.33337 8.10546 6.33337 10.2916C6.33337 12.4777 8.10558 14.2499 10.2917 14.2499Z"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.7083 31.6667C29.8945 31.6667 31.6667 29.8945 31.6667 27.7083C31.6667 25.5222 29.8945 23.75 27.7083 23.75C25.5222 23.75 23.75 25.5222 23.75 27.7083C23.75 29.8945 25.5222 31.6667 27.7083 31.6667Z"
      stroke="#0092B8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InstituteIcons = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.38306 9.38037H4.71445V19.6571H2.38306V9.38037Z" fill="black" />
    <path d="M6.58936 9.38037H8.92075V19.6571H6.58936V9.38037Z" fill="black" />
    <path d="M10.8213 9.38037H13.1527V19.6571H10.8213V9.38037Z" fill="black" />
    <path d="M15.0547 9.38037H17.3861V19.6571H15.0547V9.38037Z" fill="black" />
    <path d="M19.2869 9.38037H21.6183V19.6571H19.2869V9.38037Z" fill="black" />
    <path
      d="M23.4685 20.9194H0.506868C0.227685 20.9194 0 21.1463 0 21.4244V23.4948C0 23.7729 0.227695 23.9998 0.506868 23.9998H23.4931C23.7723 23.9998 24 23.7729 24 23.4948V21.4244C23.9752 21.1473 23.7467 20.9194 23.4685 20.9194Z"
      fill="black"
    />
    <path
      d="M23.6717 5.26434L12.1909 0.0377281C12.0642 -0.012576 11.9117 -0.012576 11.785 0.0377281L0.304162 5.26434C0.126956 5.34028 0.000244141 5.51684 0.000244141 5.71905V7.61284C0.000244141 7.891 0.22794 8.11785 0.507112 8.11785H23.4933C23.7725 8.11785 24.0002 7.89099 24.0002 7.61284V5.71905C23.9754 5.51685 23.8737 5.34029 23.6717 5.26434ZM11.9879 6.22406C11.0246 6.22406 10.2643 5.46654 10.2643 4.50682C10.2643 3.57275 11.0246 2.78958 11.9879 2.78958C12.9254 2.78958 13.7114 3.5471 13.7114 4.50682C13.7114 5.46654 12.9511 6.22406 11.9879 6.22406Z"
      fill="black"
    />
  </svg>
);
export const DeadlineIcon = ({ color }: { color?: string }) => (
  <svg
    width="20"
    height="30"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75166 0.379289C10.3097 0.905112 10.3336 1.78148 9.80517 2.33671C8.49113 3.71723 7.51985 5.41746 7.01839 7.30028C6.82151 8.03947 6.05966 8.47989 5.31674 8.28401C4.57381 8.08812 4.13115 7.3301 4.32802 6.59092C4.95138 4.25043 6.15743 2.14178 7.78434 0.432529C8.31282 -0.122698 9.19362 -0.146535 9.75166 0.379289Z"
      fill="#FB9318"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.3214 0.379289C25.7634 0.905112 25.7395 1.78148 26.2679 2.33671C27.5819 3.71723 28.5532 5.41746 29.0547 7.30028C29.2514 8.03947 30.0134 8.47989 30.7562 8.28401C31.4993 8.08812 31.9419 7.3301 31.745 6.59092C31.1216 4.25043 29.9156 2.14178 28.2886 0.432529C27.7601 -0.122698 26.8794 -0.146535 26.3214 0.379289Z"
      fill="#FB9318"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9571 0C12.4352 0 7.95876 4.4539 7.95876 9.94806V15.4871C7.95876 16.3566 7.59498 17.187 6.9547 17.7788L4.29373 20.2385C1.69126 22.6442 2.38504 26.8944 5.57029 28.4023C7.16525 29.1574 8.81443 29.76 10.4958 30.21C10.5396 30.3095 10.5888 30.4177 10.6436 30.5333C10.9179 31.1114 11.3407 31.8899 11.9337 32.6767C13.1039 34.2294 15.0903 35.9999 18.034 35.9999C20.9777 35.9999 22.9642 34.2294 24.1343 32.6767C24.7274 31.8899 25.1501 31.1114 25.4244 30.5333C25.4782 30.4199 25.5265 30.3137 25.5697 30.2156C27.2357 29.7697 28.8701 29.1727 30.4516 28.424C33.6693 26.9009 34.2925 22.6104 31.6402 20.243L28.8714 17.7718C28.2126 17.1839 27.8432 16.3403 27.8589 15.46L27.9539 10.1243C28.0529 4.56205 23.5483 0 17.9571 0ZM21.9648 30.9388C19.3561 31.2922 16.709 31.2904 14.1004 30.9349C14.1201 30.9617 14.1401 30.9885 14.1603 31.0153C15.0772 32.2319 16.3379 33.2306 18.034 33.2306C19.7301 33.2306 20.9908 32.2319 21.9077 31.0153C21.9268 30.9898 21.9459 30.9642 21.9648 30.9388ZM29.2559 25.9235C22.1585 29.2834 13.8685 29.2639 6.76605 25.9017C5.33371 25.2236 5.04427 23.3246 6.1881 22.2673L8.84908 19.8076C10.0562 18.6918 10.742 17.1264 10.742 15.4871V9.94806C10.742 5.98331 13.9723 2.76923 17.9571 2.76923C21.992 2.76923 25.2426 6.06134 25.1711 10.0752L25.0761 15.411C25.046 17.0949 25.7529 18.7085 27.0129 19.8332L29.7817 22.3044C30.9549 23.3516 30.6793 25.2497 29.2559 25.9235Z"
      fill="#FB9318"
    />
  </svg>
);

export const ExcitingNewsIcon = ({ color }: { color?: string }) => (
  <svg
    width="20"
    height="30"
    viewBox="0 0 36 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8274_23407)">
      <path
        d="M30.4811 6.89213C30.3161 6.88416 30.1511 6.90799 29.9956 6.96227C29.84 7.01655 29.697 7.1002 29.5746 7.20846C29.4522 7.31671 29.3528 7.44745 29.2822 7.59319C29.2116 7.73894 29.1711 7.89683 29.163 8.05786C29.163 8.05786 29.1405 8.42027 29.0516 8.8008C29.0177 8.94565 29.0757 8.87858 29.0269 8.96388C28.8336 8.84565 28.5998 8.69046 28.2286 8.56523C27.8367 8.43304 27.1964 8.3799 26.6568 8.65583C26.1172 8.93166 25.797 9.47408 25.6852 9.86385C25.5793 10.2331 25.5781 10.5112 25.5677 10.7336C25.4684 10.7242 25.5583 10.7156 25.4192 10.6611C25.048 10.5159 24.7261 10.3229 24.7261 10.3229C24.5856 10.2379 24.4292 10.1807 24.266 10.1547C24.1028 10.1287 23.936 10.1344 23.775 10.1714C23.6141 10.2085 23.4622 10.2761 23.3281 10.3705C23.194 10.4649 23.0802 10.5842 22.9934 10.7215C22.9063 10.8587 22.8477 11.0113 22.8211 11.1706C22.7945 11.3299 22.8003 11.4928 22.8382 11.6498C22.8762 11.8069 22.9455 11.9552 23.0422 12.0861C23.1389 12.217 23.2611 12.328 23.4018 12.4128C23.4018 12.4128 23.8766 12.7003 24.4847 12.9383C25.0929 13.1763 25.8994 13.581 26.9786 13.0289C27.5182 12.7529 27.8384 12.2106 27.9501 11.8208C28.0241 11.5628 28.0184 11.401 28.0306 11.2168C28.1927 11.3121 28.3277 11.4071 28.5875 11.4947C28.9794 11.6269 29.6197 11.6801 30.1593 11.4041C31.2384 10.8522 31.3564 9.9739 31.5021 9.35045C31.6478 8.72699 31.6754 8.18471 31.6754 8.18471C31.6844 8.02319 31.6606 7.86152 31.6054 7.70901C31.5501 7.5565 31.4646 7.41615 31.3536 7.29602C31.2426 7.1759 31.1084 7.07838 30.9586 7.00906C30.8089 6.93975 30.6466 6.90001 30.4811 6.89213Z"
        fill="#1776f0"
      />
      <path
        d="M25.0683 6.75857C24.7539 7.06547 24.3275 7.23788 23.8828 7.23788C23.4382 7.23788 23.0117 7.06547 22.6973 6.75857C22.5416 6.60661 22.4181 6.42621 22.3339 6.22767C22.2496 6.02912 22.2062 5.81632 22.2062 5.60142C22.2062 5.38652 22.2496 5.17372 22.3339 4.97517C22.4181 4.77663 22.5416 4.59622 22.6973 4.44426C22.853 4.2923 23.0378 4.17176 23.2412 4.08952C23.4446 4.00728 23.6626 3.96495 23.8828 3.96495C24.103 3.96495 24.321 4.00728 24.5244 4.08952C24.7278 4.17176 24.9126 4.2923 25.0683 4.44426C25.3827 4.75116 25.5594 5.1674 25.5594 5.60142C25.5594 6.03544 25.3827 6.45168 25.0683 6.75857Z"
        fill="#1776f0"
      />
      <path
        d="M23.5029 16.0614L20.2603 16.907C19.9387 16.9922 19.665 17.1984 19.4991 17.4803C19.3331 17.7623 19.2887 18.0971 19.3754 18.411C19.4179 18.567 19.4915 18.7132 19.592 18.8413C19.6925 18.9695 19.8179 19.077 19.961 19.1578C20.1041 19.2386 20.2622 19.291 20.4261 19.3121C20.59 19.3333 20.7565 19.3226 20.9162 19.2808L24.1526 18.4352C24.3124 18.3937 24.4622 18.3218 24.5935 18.2237C24.7248 18.1257 24.8349 18.0033 24.9177 17.8636C25.0005 17.7239 25.0542 17.5696 25.0758 17.4096C25.0974 17.2496 25.0865 17.0871 25.0437 16.9312C25.0012 16.7753 24.9276 16.629 24.8271 16.5009C24.7266 16.3727 24.6012 16.2652 24.4581 16.1844C24.315 16.1036 24.1569 16.0512 23.993 16.0301C23.8291 16.009 23.6625 16.0196 23.5029 16.0614Z"
        fill="#1776f0"
      />
      <path
        d="M21.4496 14.9075C21.2899 14.949 21.1401 15.0209 21.0088 15.119C20.8775 15.2171 20.7673 15.3395 20.6845 15.4792C20.6018 15.6188 20.548 15.7731 20.5264 15.9331C20.5048 16.0931 20.5157 16.2557 20.5585 16.4115L21.4311 19.5705C21.517 19.8841 21.7268 20.1517 22.0144 20.3147C22.302 20.4777 22.6441 20.5229 22.9657 20.4403C23.1255 20.3988 23.2753 20.3269 23.4066 20.2288C23.5379 20.1307 23.6481 20.0083 23.7308 19.8687C23.8136 19.729 23.8673 19.5747 23.8889 19.4147C23.9106 19.2547 23.8996 19.0921 23.8568 18.9363L22.9905 15.7713C22.9033 15.4574 22.692 15.1902 22.4031 15.0283C22.1142 14.8663 21.7713 14.8229 21.4496 14.9075Z"
        fill="#1776f0"
      />
      <path
        d="M13.0911 5.03242C12.7696 4.94795 12.4268 4.99139 12.1381 5.15322L9.22967 6.79009C9.08651 6.87087 8.96108 6.97842 8.86056 7.10657C8.76005 7.23473 8.68641 7.38098 8.64388 7.53695C8.60134 7.69292 8.59074 7.85555 8.61268 8.01553C8.63462 8.1755 8.68868 8.32968 8.77175 8.46924C8.85451 8.60897 8.96469 8.7314 9.09599 8.82951C9.22729 8.92763 9.37712 8.9995 9.53691 9.04102C9.69671 9.08254 9.86332 9.09288 10.0272 9.07147C10.1911 9.05005 10.3491 8.99729 10.492 8.91621L13.3943 7.27934C13.6817 7.11622 13.8913 6.84861 13.9771 6.53506C14.0629 6.22151 14.018 5.88754 13.8522 5.60623C13.6864 5.32407 13.4127 5.11769 13.0911 5.03242Z"
        fill="#1776f0"
      />
      <path
        d="M9.84759 4.55413C9.70392 4.6344 9.5779 4.74158 9.47676 4.86951C9.37563 4.99744 9.30137 5.1436 9.25825 5.29962C9.21513 5.45563 9.20399 5.61841 9.22548 5.77863C9.24697 5.93885 9.30067 6.09336 9.38348 6.23327L11.0605 9.06608C11.1432 9.20581 11.2534 9.32824 11.3847 9.42636C11.516 9.52447 11.6658 9.59634 11.8256 9.63786C11.9854 9.67938 12.152 9.68973 12.3159 9.66831C12.4798 9.64689 12.6378 9.59413 12.7808 9.51305C13.0682 9.34993 13.2778 9.08232 13.3636 8.76877C13.4494 8.45522 13.4045 8.12125 13.2387 7.83994L11.5617 5.00109C11.3946 4.72052 11.1204 4.51598 10.7992 4.43221C10.4779 4.34845 10.1358 4.39228 9.84759 4.55413Z"
        fill="#1776f0"
      />
      <path
        d="M28.9018 21.4019C27.7129 21.1411 27.0375 21.7371 26.5132 22.1206C25.9889 22.5042 25.6097 22.9059 25.6097 22.9059C25.3818 23.1431 25.2597 23.4588 25.2701 23.7839C25.2806 24.1089 25.4227 24.4166 25.6654 24.6394C25.9084 24.8618 26.2319 24.981 26.5649 24.9708C26.8979 24.9606 27.2131 24.8219 27.4414 24.585C27.4414 24.585 27.7031 24.3177 28.0231 24.0837C28.1446 23.9948 28.0531 24.0091 28.1469 23.975C28.2161 24.1874 28.2926 24.4534 28.4934 24.7843C28.7047 25.1326 29.1552 25.5783 29.7496 25.7085C30.344 25.8387 30.9469 25.6271 31.2904 25.4004C31.615 25.1862 31.8036 24.9774 31.9587 24.8145C32.0282 24.8844 31.9511 24.8369 32.0206 24.9655C32.2074 25.3106 32.33 25.6541 32.33 25.6541C32.3807 25.8077 32.4619 25.9499 32.569 26.0728C32.6761 26.1957 32.8069 26.2968 32.9541 26.3703C33.1012 26.4438 33.2617 26.4882 33.4265 26.5011C33.5912 26.514 33.757 26.495 33.9142 26.4454C34.2308 26.3442 34.4933 26.1245 34.6441 25.8346C34.7949 25.5447 34.8217 25.2083 34.7187 24.8991C34.7187 24.8991 34.5544 24.3833 34.2484 23.8179C33.9423 23.2525 33.593 22.4295 32.4043 22.169C31.8099 22.0386 31.207 22.2503 30.8634 22.477C30.6371 22.6264 30.5303 22.7554 30.3993 22.8877C30.3389 22.7133 30.2974 22.5558 30.158 22.326C29.9467 21.9778 29.4962 21.5321 28.9018 21.4019Z"
        fill="#1776f0"
      />
      <path
        d="M17.6909 2.17471C17.5311 2.21621 17.3813 2.28806 17.25 2.38615C17.1187 2.48423 17.0085 2.60662 16.9258 2.74632C16.843 2.88601 16.7893 3.04027 16.7677 3.20026C16.746 3.36025 16.7569 3.52282 16.7998 3.67869C17.0608 4.62868 17.1077 5.59877 17.0102 6.55378C16.9777 6.8773 17.078 7.20018 17.2892 7.45156C17.5003 7.70295 17.805 7.86231 18.1364 7.89468C18.301 7.91121 18.4674 7.89587 18.6259 7.84953C18.7844 7.80319 18.932 7.72677 19.0602 7.62464C19.1884 7.52251 19.2947 7.39669 19.373 7.25439C19.4512 7.11209 19.5 6.9561 19.5164 6.79538C19.6387 5.59712 19.5835 4.32482 19.2317 3.04448C19.1892 2.88854 19.1156 2.74231 19.0151 2.61416C18.9146 2.48602 18.7892 2.37848 18.6461 2.29769C18.503 2.2169 18.3449 2.16446 18.181 2.14335C18.0171 2.12225 17.8505 2.1329 17.6909 2.17471ZM17.8456 8.29937C17.537 8.25063 17.2209 8.31581 16.9589 8.4822C16.697 8.64859 16.5078 8.90425 16.4285 9.19934C16.3346 9.48995 16.3548 9.80426 16.4852 10.0811C16.6156 10.358 16.8468 10.5776 17.1339 10.6973C17.4433 10.818 17.7891 10.8139 18.0954 10.6859C18.4018 10.558 18.6435 10.3166 18.7676 10.0148C18.7825 9.97833 18.8171 9.89703 18.848 9.73691C18.8792 9.57824 18.878 9.41512 18.8445 9.25691C18.811 9.0987 18.7458 8.94851 18.6526 8.81495C18.5595 8.68139 18.4403 8.5671 18.3018 8.47862C18.1633 8.39014 18.0082 8.32923 17.8456 8.29937ZM16.5213 12.0503C16.3808 11.9652 16.2244 11.9081 16.0612 11.8821C15.898 11.8561 15.7312 11.8618 15.5703 11.8988C15.4093 11.9358 15.2574 12.0035 15.1233 12.0979C14.9892 12.1923 14.8755 12.3116 14.7886 12.4489C14.3345 13.1654 14.0213 13.5482 14.0213 13.5482C13.9186 13.675 13.8425 13.8203 13.7974 13.9759C13.7524 14.1314 13.7392 14.2941 13.7588 14.4546C13.7783 14.6151 13.8302 14.7703 13.9113 14.9112C13.9925 15.0521 14.1014 15.176 14.2317 15.2757C14.4928 15.477 14.8251 15.5691 15.1557 15.5317C15.4863 15.4944 15.7882 15.3306 15.9953 15.0764C15.9953 15.0764 16.4111 14.5597 16.9297 13.7415C17.0168 13.6043 17.0754 13.4517 17.102 13.2924C17.1287 13.1331 17.1228 12.9703 17.0849 12.8132C17.047 12.6561 16.9777 12.5079 16.881 12.3769C16.7842 12.246 16.662 12.135 16.5213 12.0503Z"
        fill="#1776f0"
      />
      <path
        d="M32.4941 17.3777C32.1797 17.6846 31.7532 17.857 31.3086 17.857C30.8639 17.857 30.4375 17.6846 30.1231 17.3777C29.9674 17.2258 29.8439 17.0454 29.7596 16.8468C29.6754 16.6483 29.632 16.4355 29.632 16.2206C29.632 16.0057 29.6754 15.7929 29.7596 15.5943C29.8439 15.3958 29.9674 15.2154 30.1231 15.0634C30.2788 14.9114 30.4636 14.7909 30.667 14.7087C30.8704 14.6264 31.0884 14.5841 31.3086 14.5841C31.5288 14.5841 31.7468 14.6264 31.9502 14.7087C32.1536 14.7909 32.3384 14.9114 32.4941 15.0634C32.8085 15.3703 32.9852 15.7865 32.9852 16.2206C32.9852 16.6546 32.8085 17.0708 32.4941 17.3777Z"
        fill="#1776f0"
      />
      <path
        d="M9.94563 15.4414C9.78039 15.4408 9.61664 15.4719 9.46375 15.533C9.31085 15.5942 9.17179 15.6841 9.05454 15.7978C7.94032 16.8853 7.03825 18.5226 6.14611 20.4426C5.25397 22.3627 4.42331 24.5511 3.7018 26.6277C2.25877 30.7808 1.26367 34.4919 1.26367 34.4919C1.20752 34.7012 1.20905 34.9213 1.2681 35.1298C1.32715 35.3384 1.44163 35.528 1.59994 35.6794C1.75825 35.8309 1.95476 35.9388 2.16955 35.9923C2.38435 36.0457 2.60981 36.0428 2.82308 35.9838C2.82308 35.9838 6.73013 34.9083 11.0347 33.447C13.187 32.7163 15.4382 31.8906 17.3776 31.043C19.3169 30.1954 20.9165 29.3938 21.9506 28.3793C22.1849 28.1484 22.3158 27.8363 22.3147 27.5113C22.3135 27.1863 22.1804 26.8751 21.9444 26.6458C21.7079 26.4171 21.3881 26.2893 21.0551 26.2904C20.7222 26.2916 20.4033 26.4215 20.1684 26.6518C19.6733 27.1376 18.1817 28.0017 16.3503 28.8021C14.519 29.6025 12.3162 30.411 10.2055 31.1276C7.15251 32.164 5.71918 32.5459 4.37012 32.9335C4.73566 31.6406 5.06782 30.3264 6.07804 27.4189C6.78286 25.3904 7.59791 23.2605 8.43572 21.4574C9.27354 19.6542 10.1842 18.1622 10.8305 17.5313C11.0656 17.3012 11.1977 16.9895 11.1977 16.6645C11.1977 16.3396 11.0656 16.0279 10.8305 15.7978C10.5952 15.5698 10.2772 15.4417 9.94563 15.4414Z"
        fill="#1776f0"
      />
      <path
        d="M11.3739 15.0348C10.5823 14.992 9.70234 15.193 9.07809 15.8019C8.84297 16.032 8.71094 16.3437 8.71094 16.6687C8.71094 16.9936 8.84297 17.3053 9.07809 17.5354C9.19492 17.65 9.33379 17.7409 9.48671 17.8029C9.63963 17.8649 9.80359 17.8968 9.96918 17.8968C10.1348 17.8968 10.2987 17.8649 10.4517 17.8029C10.6046 17.7409 10.7434 17.65 10.8603 17.5354C10.8739 17.5222 10.914 17.4696 11.2377 17.4871C11.5615 17.5046 12.0891 17.633 12.7043 17.9099C13.9348 18.4638 15.5006 19.5652 16.9494 20.9783C18.3982 22.3914 19.4427 23.845 19.9383 24.9587C20.1861 25.5155 20.2883 25.9794 20.291 26.2634C20.2937 26.5474 20.2439 26.5993 20.1982 26.6439C20.0808 26.7579 19.9877 26.8935 19.9242 27.0427C19.8606 27.192 19.8279 27.352 19.8279 27.5137C19.8279 27.6753 19.8606 27.8353 19.9242 27.9846C19.9877 28.1339 20.0808 28.2694 20.1982 28.3834C20.315 28.498 20.4539 28.5889 20.6068 28.6509C20.7597 28.7129 20.9237 28.7448 21.0893 28.7448C21.2549 28.7448 21.4188 28.7129 21.5717 28.6509C21.7247 28.5889 21.8635 28.498 21.9804 28.3834C22.5725 27.8059 22.8168 26.9925 22.8096 26.2392C22.8023 25.4859 22.5868 24.745 22.2464 23.9802C21.5658 22.4507 20.3472 20.8206 18.7254 19.2387C17.1036 17.6569 15.3741 16.4094 13.7563 15.6811C12.9474 15.317 12.1655 15.0776 11.3739 15.0348Z"
        fill="#1776f0"
      />
    </g>
    <defs>
      <clipPath id="clip0_8274_23407">
        <rect width="36" height="45" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const UpdateIcon = ({ color }: { color?: string }) => (
  <svg
    width="20"
    height="30"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.5461 4.35914C31.4072 2.26771 28.3722 2.1901 28.0209 4.22842C27.2121 6.8427 31.8361 7.20625 31.5461 4.35914Z"
      fill="#EB5CD9"
    />
    <path
      d="M16.8928 20.2419L16.4598 20.6585C16.3822 20.728 16.3413 20.7484 16.2719 20.7688C16.1453 20.8056 15.9982 20.7811 15.9083 20.7075C15.8512 20.6585 15.8675 20.6667 15.6918 20.4747L15.2915 20.0254C14.2336 18.8204 13.2205 17.5663 12.2851 16.2347C11.848 15.6138 11.1945 14.7355 9.76887 16.1979C8.59652 17.3988 9.45434 17.9871 9.94043 18.4813C11.0392 19.6006 12.183 20.6749 13.3267 21.7451L13.7556 22.1454L13.9721 22.3456C14.0089 22.3782 14.2091 22.5743 14.3643 22.6805C15.0342 23.1666 15.9083 23.3422 16.7008 23.1625C17.097 23.0726 17.4769 22.897 17.7996 22.656C17.8813 22.5947 17.9589 22.5294 18.0324 22.464L18.1346 22.366L18.1836 22.3129L18.3878 22.1005L19.213 21.2631L26.1612 14.3026C26.5411 13.9186 27.3908 13.6367 26.3532 12.5502C25.2299 11.3737 24.9603 12.2887 24.5845 12.64C22.2357 14.8213 20.0299 17.1538 17.7506 19.4086L16.8928 20.25V20.2419Z"
      fill="#EB5CD9"
    />
    <path
      d="M34.1817 13.5044C33.3811 13.6678 33.3158 14.448 33.3893 15.412C33.4628 16.376 33.6793 17.577 33.6017 18.5042L33.5363 19.5867C33.4955 19.9461 33.426 20.2974 33.3689 20.6569L33.2831 21.192L33.1442 21.7149C33.0502 22.0621 32.9645 22.4134 32.8623 22.7565C32.3926 24.1167 31.7839 25.4321 30.9874 26.633C29.378 29.0185 27.1395 30.9874 24.5211 32.1883L24.035 32.4212L23.5285 32.605C23.1895 32.7234 22.8586 32.8623 22.5114 32.9685C21.8129 33.1401 21.1267 33.3607 20.4077 33.4383C18.9903 33.6956 17.532 33.6752 16.1064 33.5282L15.0403 33.3648C14.6849 33.3117 14.3418 33.1932 13.9905 33.1156C13.2838 32.9726 12.6262 32.6663 11.944 32.4375C10.6328 31.8411 9.37056 31.1263 8.25132 30.2154C6.02102 28.3976 4.27272 25.9712 3.35363 23.2467L3.16982 22.7402C3.11671 22.5686 3.07995 22.393 3.03502 22.2173L2.77767 21.1716L2.62654 20.1055C2.60611 19.9298 2.56935 19.7501 2.55709 19.5744L2.53667 19.0352C2.42638 17.6055 2.62654 16.1718 2.91247 14.7789L3.19841 13.7495L3.26785 13.4921L3.36589 13.243L3.56196 12.7446C3.79071 12.0706 4.15426 11.4538 4.4647 10.8207C4.64443 10.5143 4.84459 10.2243 5.03658 9.9261C5.13461 9.77905 5.22448 9.62791 5.3266 9.48085L5.65747 9.0642C5.88213 8.79052 6.08229 8.5005 6.32738 8.24724L7.06264 7.48746C9.0928 5.54309 11.6417 4.16243 14.3459 3.65591C14.9668 3.49252 15.6816 3.45984 16.376 3.34546C16.7273 3.3087 17.0786 3.30053 17.4176 3.2556C17.7567 3.21066 18.0876 3.16982 18.398 3.12897C19.6316 2.96558 20.6447 2.69189 20.7876 1.67477C20.902 0.849641 19.9216 0.269598 18.4797 0.0653572C18.1202 0.00816976 17.7404 0 17.3482 0C16.9561 0 16.5517 0.0122545 16.1473 0.0285938C15.747 0.0816964 15.3466 0.142968 14.9586 0.204241C14.7625 0.236919 14.5746 0.265513 14.3867 0.294107C14.2029 0.334955 14.0232 0.383973 13.8475 0.428906L12.6548 0.735267C12.2667 0.865981 11.8827 1.01303 11.4988 1.15192L10.9228 1.36841L10.3673 1.63393C9.99963 1.81366 9.62382 1.98522 9.26436 2.18129C8.56994 2.61428 7.84693 3.00642 7.21378 3.5252L6.7236 3.89691C6.55613 4.01537 6.4009 4.14609 6.25385 4.28905L5.35111 5.11827C5.04883 5.39604 4.79557 5.71874 4.5178 6.01693C4.24412 6.31921 3.96635 6.62148 3.73761 6.96052L3.01051 7.94905L2.37736 8.99885C2.27524 9.17449 2.16087 9.34606 2.071 9.52987L1.80957 10.0813C1.6421 10.453 1.44602 10.8125 1.30306 11.1965C1.02937 11.9685 0.723012 12.7242 0.55962 13.5248L0.412566 14.1171C0.359464 14.3132 0.314531 14.5133 0.294107 14.7176L0.11846 15.9267L0.0776115 16.229L0.065357 16.5353L0.0367634 17.144L0.0122545 17.7526L0 18.059L0.0163392 18.3653C0.0612722 19.1782 0.0857812 19.9911 0.249174 20.7917L0.347209 21.3922L0.396227 21.6944L0.473838 21.9886L0.784284 23.165C1.2908 24.705 1.91169 26.2204 2.81444 27.5725L3.13305 28.0913L3.4966 28.5774C3.74169 28.9001 3.97861 29.2309 4.23595 29.5414C4.7874 30.1337 5.30209 30.7627 5.92707 31.2856C6.53162 31.8779 7.23012 32.3681 7.90412 32.8746C8.25541 33.1115 8.62304 33.3198 8.98251 33.5445C9.16632 33.6507 9.34197 33.7692 9.52987 33.8672L10.1017 34.145C10.4857 34.3206 10.8574 34.533 11.2577 34.676L12.4505 35.1131C12.8467 35.2601 13.2675 35.3377 13.676 35.4521L14.2928 35.6114C14.497 35.6645 14.7094 35.6809 14.9177 35.7176L16.1759 35.9096L17.4422 35.975C17.6546 35.9831 17.867 36.0036 18.0753 35.9995L18.7085 35.9709C19.1292 35.9423 19.554 35.9423 19.9747 35.8892C21.6577 35.689 23.312 35.2601 24.8847 34.6229C26.4328 33.9407 27.9156 33.0952 29.235 32.0249C29.5741 31.7676 29.8682 31.4653 30.1868 31.1876L30.6565 30.7587L31.0854 30.293C31.3673 29.9744 31.6655 29.6762 31.9269 29.3412L32.6867 28.3241C34.6188 25.5464 35.7748 22.2091 35.881 18.8228C35.975 17.7158 35.9627 16.3107 35.6972 15.2118C35.4317 14.1089 34.917 13.3573 34.1817 13.5085V13.5044Z"
      fill="#EB5CD9"
    />
  </svg>
);

export const ProgressIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 3.5L6.75 7.75L4.25 5.25L1 8.5"
      stroke="#008236"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 3.5H11V6.5"
      stroke="#008236"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DeclineIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 8.5L6.75 4.25L4.25 6.75L1 3.5"
      stroke="#C10007"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.5H11V5.5"
      stroke="#C10007"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlueBorderStar = ({ color }: { color?: string }) => (
  <svg
    className="w-full h-full"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.28086 12.9167C8.20647 12.6283 8.05615 12.3651 7.84555 12.1545C7.63494 11.9439 7.37176 11.7935 7.08336 11.7192L1.97086 10.4008C1.88364 10.3761 1.80687 10.3235 1.75221 10.2512C1.69754 10.1788 1.66797 10.0907 1.66797 9.99998C1.66797 9.90931 1.69754 9.82112 1.75221 9.74878C1.80687 9.67644 1.88364 9.62391 1.97086 9.59915L7.08336 8.27998C7.37166 8.20566 7.63477 8.05546 7.84537 7.84502C8.05596 7.63457 8.20634 7.37156 8.28086 7.08332L9.5992 1.97082C9.6237 1.88325 9.67618 1.8061 9.74863 1.75115C9.82108 1.69619 9.90951 1.66644 10.0004 1.66644C10.0914 1.66644 10.1798 1.69619 10.2523 1.75115C10.3247 1.8061 10.3772 1.88325 10.4017 1.97082L11.7192 7.08332C11.7936 7.37171 11.9439 7.6349 12.1545 7.8455C12.3651 8.0561 12.6283 8.20642 12.9167 8.28082L18.0292 9.59832C18.1171 9.62257 18.1946 9.67499 18.2499 9.74755C18.3052 9.8201 18.3351 9.90878 18.3351 9.99998C18.3351 10.0912 18.3052 10.1799 18.2499 10.2524C18.1946 10.325 18.1171 10.3774 18.0292 10.4017L12.9167 11.7192C12.6283 11.7935 12.3651 11.9439 12.1545 12.1545C11.9439 12.3651 11.7936 12.6283 11.7192 12.9167L10.4009 18.0292C10.3764 18.1167 10.3239 18.1939 10.2514 18.2488C10.179 18.3038 10.0905 18.3335 9.99961 18.3335C9.90868 18.3335 9.82025 18.3038 9.7478 18.2488C9.67535 18.1939 9.62287 18.1167 9.59836 18.0292L8.28086 12.9167Z"
      stroke={color ? color : "#5D5DFF"}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.668 2.5V5.83333"
      stroke={color ? color : "#5D5DFF"}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 4.16666H15"
      stroke={color ? color : "#5D5DFF"}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33203 14.1667V15.8333"
      stroke={color ? color : "#5D5DFF"}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16667 15H2.5"
      stroke={color ? color : "#5D5DFF"}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GreenCheck = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="#05DF72" />
    <g clipPath="url(#clip0_547_1167)">
      <path
        d="M18.5331 10.6667C18.8376 12.1609 18.6206 13.7143 17.9183 15.0679C17.2161 16.4214 16.071 17.4934 14.6741 18.1049C13.2772 18.7164 11.7128 18.8305 10.242 18.4282C8.77107 18.026 7.48255 17.1316 6.59127 15.8943C5.7 14.657 5.25984 13.1515 5.3442 11.6289C5.42856 10.1063 6.03234 8.65872 7.05486 7.52744C8.07737 6.39616 9.45681 5.64961 10.9631 5.4123C12.4695 5.17498 14.0116 5.46123 15.3324 6.22333"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.3334L12 13.3334L18.6667 6.66675"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_547_1167">
        <rect width="16" height="16" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
);

export const HungaryIcon = ({ width = 48, height = 32, ...props }) => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1200 600"
    width={width}
    height={height}
    {...props}
  >
    <path d="M0 0h1200v600H0" fill="#477050" />

    <path d="M0 0h1200v400H0" fill="#fff" />

    <path d="M0 0h1200v200H0" fill="#ce2939" />
  </svg>
);

export const DubaiIcon = () => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 512 356.18"
  >
    <g fillRule="nonzero">
      <path
        fill="#00732F"
        d="M28.137 0H483.86C499.337 0 512 12.663 512 28.14v299.9c0 15.477-12.663 28.14-28.14 28.14H28.137C12.663 356.18 0 343.517 0 328.04V28.14C0 12.663 12.663 0 28.137 0z"
      />
      <path
        fill="#fff"
        d="M512 118.726H0V328.04c0 15.477 12.663 28.14 28.137 28.14H483.86c15.477 0 28.14-12.663 28.14-28.14V118.726z"
      />
      <path d="M512 237.454H0v90.586c0 15.477 12.663 28.14 28.137 28.14H483.86c15.477 0 28.14-12.663 28.14-28.14v-90.586z" />
      <path
        fill="red"
        d="M142.871 356.18V0H28.137C12.663 0 0 12.663 0 28.14v299.9c0 15.477 12.663 28.14 28.137 28.14h114.734z"
      />
    </g>
  </svg>
);

export const PolandIcon = () => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    // width="640"
    // height="400"
    viewBox="0 0 8 5"
  >
    <rect width="8" height="5" fill="#dc143c" />
    <rect width="8" height="2.5" fill="#fff" />
  </svg>
);
export const LatviaIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-full h-full"
    viewBox="0 0 1000 667"
  >
    <rect width="1000" height="667" fill="#9E1B32" />
    <rect y="267" width="1000" height="133" fill="#FFFFFF" />
  </svg>
);

export const FinlandIcon = () => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="25"
  >
    <rect width="38" height="25" fill="#fff" />
    <rect width="38" height="6" y="10" fill="#003580" />
    <rect width="6" height="25" x="12" fill="#003580" />
  </svg>
);
export const GreeceIcon = () => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    width="600"
    height="400"
    viewBox="0 0 27 18"
  >
    <rect fill="#0D5EAF" width="27" height="18" />
    <path fill="none" strokeWidth="2" stroke="#FFF" d="M5,0V11 M0,5H10 M10,3H27 M10,7H27 M0,11H27 M0,15H27" />
  </svg>
);
export const EstoniaIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="38"
    height="25"
    viewBox="0 0 33 21"
  >
    <rect width="33" height="7" fill="#0072ce" />

    <rect width="33" height="7" y="7" fill="#000000" />

    <rect width="33" height="7" y="14" fill="#ffffff" />
  </svg>
);
export const SwedenIcon = () => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 10"
  >
    <rect width="16" height="10" fill="#006aa7" />
    <rect width="2" height="10" x="5" fill="#fecc00" />
    <rect width="16" height="2" y="4" fill="#fecc00" />
  </svg>
);
export const MalaysiaIcon = () => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13440 6720"
  >
    <g transform="scale(480)">
      <path fill="#fff" d="m0 0h28v14H0z" />
      <path stroke="#c00" d="m1 .5h27m0 2H1m0 2h27m0 2H1" />
      <path fill="#006" d="m0 0h14v8.5H0z" />
      <path stroke="#c00" d="m0 8.5h28m0 2H0m0 2h28" />
    </g>
    <path
      fill="#fc0"
      d="m4200 720 107 732 414-613-222 706 639-373-506 540 738-59-690 267 690 267-738-59 506 540-639-373 222 706-414-613-107 732-107-732-414 613 222-706-639 373 506-540-738 59 690-267-690-267 738 59-506-540 639 373-222-706 414 613zm-600 30a1280 1280 0 1 0 0 2340 1440 1440 0 1 1 0-2340z"
    />
  </svg>
);

export const SouthKoreaIcon = () => (
  <svg
    className="w-full h-full"
    xmlns="http://www.w3.org/2000/svg"
    width="900"
    height="600"
    viewBox="-72 -48 144 96"
  >
    <path fill="#fff" d="M-72-48v96H72v-96z" />
    <g stroke="#000" strokeWidth="4">
      <path
        transform="rotate(33.69006752598)"
        d="M-50-12v24m6 0v-24m6 0v24m76 0V1m0-2v-11m6 0v11m0 2v11m6 0V1m0-2v-11"
      />
      <path
        transform="rotate(-33.69006752598)"
        d="M-50-12v24m6 0V1m0-2v-11m6 0v24m76 0V1m0-2v-11m6 0v24m6 0V1m0-2v-11"
      />
    </g>
    <g transform="rotate(33.69006752598)">
      <path fill="#cd2e3a" d="M12 0a18 18 0 11-36 0 24 24 0 1148 0" />
      <path
        fill="#0047a0"
        d="M0 0a12 12 0 1124 0 24 24 0 11-48 0 12 12 0 1024 0"
      />
    </g>
  </svg>
);

export const CalculatorIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.99966 6.99941H14.9991M14.9991 16.9986V13.9988M11.9994 16.9986H12.0094M8.99966 16.9986H9.00966M8.99966 13.9988H9.00966M11.9994 13.9988H12.0094M14.9991 10.9991H15.0091M11.9994 10.9991H12.0094M8.99966 10.9991H9.00966M6.99983 20.9982H16.999C17.5294 20.9982 18.038 20.7875 18.4131 20.4125C18.7881 20.0374 18.9988 19.5288 18.9988 18.9984V4.99959C18.9988 4.4692 18.7881 3.96053 18.4131 3.58549C18.038 3.21045 17.5294 2.99976 16.999 2.99976H6.99983C6.46944 2.99976 5.96078 3.21045 5.58574 3.58549C5.2107 3.96053 5 4.4692 5 4.99959V18.9984C5 19.5288 5.2107 20.0374 5.58574 20.4125C5.96078 20.7875 6.46944 20.9982 6.99983 20.9982Z"
      stroke="white"
      strokeWidth="1.99983"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49957 9.99912L9.1661 11.6656L12.4991 8.33259M17.4987 9.99912C17.4987 10.9839 17.3047 11.9591 16.9279 12.869C16.551 13.7789 15.9986 14.6056 15.3022 15.302C14.6058 15.9983 13.7791 16.5507 12.8692 16.9276C11.9594 17.3045 10.9842 17.4985 9.99936 17.4985C9.01453 17.4985 8.03934 17.3045 7.12948 16.9276C6.21961 16.5507 5.39289 15.9983 4.69651 15.302C4.00013 14.6056 3.44773 13.7789 3.07085 12.869C2.69398 11.9591 2.5 10.9839 2.5 9.99912C2.5 8.01016 3.29011 6.10267 4.69651 4.69627C6.10291 3.28986 8.01041 2.49976 9.99936 2.49976C11.9883 2.49976 13.8958 3.28986 15.3022 4.69627C16.7086 6.10267 17.4987 8.01016 17.4987 9.99912Z"
      stroke="#8F3EBC"
      strokeWidth="1.66652"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GlobeIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.54583 9.16585H4.16652C4.60851 9.16585 5.0324 9.34143 5.34494 9.65397C5.65747 9.9665 5.83305 10.3904 5.83305 10.8324V11.6656C5.83305 12.1076 6.00863 12.5315 6.32116 12.8441C6.6337 13.1566 7.05758 13.3322 7.49957 13.3322C7.94156 13.3322 8.36545 13.5077 8.67798 13.8203C8.99052 14.1328 9.1661 14.5567 9.1661 14.9987V17.4526M6.66631 3.27886V4.58291C6.66631 5.1354 6.88579 5.66526 7.27645 6.05592C7.66712 6.44659 8.19698 6.66607 8.74947 6.66607H9.1661C9.60809 6.66607 10.032 6.84165 10.3445 7.15418C10.657 7.46671 10.8326 7.8906 10.8326 8.33259C10.8326 8.77458 11.0082 9.19847 11.3207 9.511C11.6333 9.82354 12.0572 9.99912 12.4991 9.99912C12.9411 9.99912 13.365 9.82354 13.6776 9.511C13.9901 9.19847 14.1657 8.77458 14.1657 8.33259C14.1657 7.8906 14.3413 7.46671 14.6538 7.15418C14.9663 6.84165 15.3902 6.66607 15.8322 6.66607H16.7188M12.4991 17.0718V14.9987C12.4991 14.5567 12.6747 14.1328 12.9873 13.8203C13.2998 13.5077 13.7237 13.3322 14.1657 13.3322H16.7188M17.4987 9.99912C17.4987 10.9839 17.3047 11.9591 16.9279 12.869C16.551 13.7789 15.9986 14.6056 15.3022 15.302C14.6058 15.9983 13.7791 16.5507 12.8692 16.9276C11.9594 17.3045 10.9842 17.4985 9.99936 17.4985C9.01453 17.4985 8.03934 17.3045 7.12948 16.9276C6.21961 16.5507 5.39289 15.9983 4.69651 15.302C4.00013 14.6056 3.44773 13.7789 3.07085 12.869C2.69398 11.9591 2.5 10.9839 2.5 9.99912C2.5 8.01016 3.29011 6.10267 4.69651 4.69627C6.10291 3.28986 8.01041 2.49976 9.99936 2.49976C11.9883 2.49976 13.8958 3.28986 15.3022 4.69627C16.7086 6.10267 17.4987 8.01016 17.4987 9.99912Z"
      stroke="#8F3EBC"
      strokeWidth="1.66652"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SlidersHorizontalIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 4.99953V3.33301M10.0001 4.99953C9.55809 4.99953 9.13421 5.17511 8.82167 5.48765C8.50914 5.80018 8.33356 6.22407 8.33356 6.66606C8.33356 7.10805 8.50914 7.53193 8.82167 7.84447C9.13421 8.157 9.55809 8.33258 10.0001 8.33258M10.0001 4.99953C10.4421 4.99953 10.866 5.17511 11.1785 5.48765C11.491 5.80018 11.6666 6.22407 11.6666 6.66606C11.6666 7.10805 11.491 7.53193 11.1785 7.84447C10.866 8.157 10.4421 8.33258 10.0001 8.33258M10.0001 8.33258V16.6652M5.00051 14.9987C5.4425 14.9987 5.86639 14.8231 6.17892 14.5106C6.49145 14.198 6.66703 13.7741 6.66703 13.3322C6.66703 12.8902 6.49145 12.4663 6.17892 12.1537C5.86639 11.8412 5.4425 11.6656 5.00051 11.6656M5.00051 14.9987C4.55852 14.9987 4.13463 14.8231 3.8221 14.5106C3.50956 14.198 3.33398 13.7741 3.33398 13.3322C3.33398 12.8902 3.50956 12.4663 3.8221 12.1537C4.13463 11.8412 4.55852 11.6656 5.00051 11.6656M5.00051 14.9987V16.6652M5.00051 11.6656V3.33301M14.9997 14.9987C15.4416 14.9987 15.8655 14.8231 16.1781 14.5106C16.4906 14.198 16.6662 13.7741 16.6662 13.3322C16.6662 12.8902 16.4906 12.4663 16.1781 12.1537C15.8655 11.8412 15.4416 11.6656 14.9997 11.6656M14.9997 14.9987C14.5577 14.9987 14.1338 14.8231 13.8212 14.5106C13.5087 14.198 13.3331 13.7741 13.3331 13.3322C13.3331 12.8902 13.5087 12.4663 13.8212 12.1537C14.1338 11.8412 14.5577 11.6656 14.9997 11.6656M14.9997 14.9987V16.6652M14.9997 11.6656V3.33301"
      stroke="#8F3EBC"
      strokeWidth="1.66652"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DummyProfile = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 15.9986C0 7.16284 7.16284 0 15.9986 0C24.8344 0 31.9973 7.16284 31.9973 15.9986C31.9973 24.8344 24.8344 31.9973 15.9986 31.9973C7.16284 31.9973 0 24.8344 0 15.9986Z"
      fill="url(#paint0_linear_201_731)"
    />
    <path
      d="M20.6646 21.9981V20.6649C20.6646 19.9577 20.3836 19.2795 19.8836 18.7794C19.3835 18.2794 18.7053 17.9985 17.9981 17.9985H13.9985C13.2913 17.9985 12.6131 18.2794 12.113 18.7794C11.613 19.2795 11.332 19.9577 11.332 20.6649V21.9981"
      stroke="white"
      strokeWidth="1.33322"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9985 15.332C17.4711 15.332 18.6649 14.1382 18.6649 12.6656C18.6649 11.193 17.4711 9.99915 15.9985 9.99915C14.5258 9.99915 13.332 11.193 13.332 12.6656C13.332 14.1382 14.5258 15.332 15.9985 15.332Z"
      stroke="white"
      strokeWidth="1.33322"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_201_731"
        x1="0"
        y1="0"
        x2="31.9973"
        y2="31.9973"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C27AFF" />
        <stop offset="1" stopColor="#FB64B6" />
      </linearGradient>
    </defs>
  </svg>
);

export const WhiteTriangle = () => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.5 10L0 0H15.5L9.5 10Z" fill="white" />
  </svg>
);

export const BlueStar = () => (
  <svg
    className="size-[14px] sm:size-[20px] sm:size-[30px]"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1304 -0.000277389L17.1745 12.5145L29.9525 14.1299L17.4377 17.174L15.8224 29.952L12.7783 17.4372L0.000277389 15.8218L12.5151 12.7777L14.1304 -0.000277389Z"
      fill="#ffff"
    />
  </svg>
);

export const StarIcon = ({
  color,
  size,
}: {
  color?: string;
  size?: string;
}) => (
  <svg
    width={size ? size : "40"}
    height={size ? size : "40"}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.187 36.1666C22.9787 35.3591 22.5578 34.6222 21.9681 34.0325C21.3784 33.4428 20.6415 33.0219 19.834 32.8136L5.51901 29.1223C5.27478 29.0529 5.05983 28.9058 4.90677 28.7033C4.75371 28.5008 4.6709 28.2538 4.6709 27.9999C4.6709 27.7461 4.75371 27.4991 4.90677 27.2966C5.05983 27.094 5.27478 26.9469 5.51901 26.8776L19.834 23.1839C20.6412 22.9758 21.378 22.5553 21.9676 21.966C22.5573 21.3768 22.9783 20.6403 23.187 19.8333L26.8783 5.51826C26.947 5.27307 27.0939 5.05706 27.2968 4.90318C27.4996 4.74931 27.7472 4.66602 28.0018 4.66602C28.2565 4.66602 28.5041 4.74931 28.7069 4.90318C28.9098 5.05706 29.0567 5.27307 29.1253 5.51826L32.8143 19.8333C33.0227 20.6408 33.4435 21.3777 34.0332 21.9674C34.6229 22.5571 35.3598 22.9779 36.1673 23.1863L50.4823 26.8753C50.7285 26.9432 50.9456 27.09 51.1003 27.2931C51.255 27.4963 51.3388 27.7446 51.3388 27.9999C51.3388 28.2553 51.255 28.5036 51.1003 28.7067C50.9456 28.9099 50.7285 29.0567 50.4823 29.1246L36.1673 32.8136C35.3598 33.0219 34.6229 33.4428 34.0332 34.0325C33.4435 34.6222 33.0227 35.3591 32.8143 36.1666L29.123 50.4816C29.0544 50.7268 28.9074 50.9428 28.7046 51.0967C28.5017 51.2506 28.2541 51.3338 27.9995 51.3338C27.7449 51.3338 27.4973 51.2506 27.2944 51.0967C27.0916 50.9428 26.9446 50.7268 26.876 50.4816L23.187 36.1666Z"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.666 7.00098V16.3343"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.3324 11.667H41.999"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33301 39.667V44.3337"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6676 41.999H7.00098"
      stroke={color ? color : "white"}
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AnimatedPathWay = () => (
  <svg
    width="1253"
    height="707"
    viewBox="0 0 1253 707"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.04102 705L279.08 535.528C302.175 521.451 330.773 519.831 355.31 531.208L396.935 550.508C433.45 567.439 476.857 554.99 498.848 521.28L561.105 425.849C585.422 388.574 635.257 377.9 672.707 401.945L719.056 431.703C754.2 454.267 800.738 446.411 826.529 413.561L880.577 344.719C902.784 316.433 940.981 306.176 974.37 319.532L1034.43 343.556C1084.82 363.711 1140.38 329.585 1145.2 275.531L1162.97 75.819C1166.69 34.0321 1201.7 2 1243.65 2H1252.54"
      stroke="black"
      strokeWidth="4"
      strokeDasharray="8 8"
      className="svg-elem-1"
    ></path>
    <path
      d="M72.5028 644.196C72.0057 636.975 66.4891 631.143 59.6504 630.614C57.6667 630.46 53.4705 630.367 51.5052 630.98C45.3726 632.892 42.1992 638.536 42.1992 644.97C42.1992 647.693 45.3633 650.563 46.5841 652.751L46.5831 652.751C46.5831 652.751 46.6733 652.914 46.7002 652.96L54.8738 672.484C54.8738 672.484 57.8094 672.503 58.7098 672.503C59.0252 672.503 59.5008 672.423 60.0592 671.586L60.5521 670.706L70.5006 652.96C70.5275 652.914 70.6177 652.751 70.6177 652.751L70.6167 652.751C72 650.272 72.7186 647.33 72.5028 644.196ZM58.3395 654.881C52.6235 654.881 47.9898 649.988 47.9898 643.953C47.9898 637.918 52.6234 633.025 58.3395 633.025C64.0554 633.025 67.4675 637.968 67.4675 644.003C67.4675 650.038 64.0555 654.881 58.3395 654.881Z"
      fill="#AC121B"
      className="svg-elem-2"
    ></path>
    <path
      d="M47.9899 643.953C47.9899 641.238 48.9275 638.756 50.4789 636.845H44.2139C42.8789 639.191 42.1992 641.995 42.1992 644.969C42.1992 646.445 43.1291 647.964 44.1749 649.395H49.3625C48.4894 647.792 47.9899 645.934 47.9899 643.953Z"
      fill="#AC121B"
      className="svg-elem-3"
    ></path>
    <path
      d="M54.6961 658.111C55.8094 657.29 56.7908 656.282 57.5569 655.129C57.6156 655.04 57.6725 654.951 57.7285 654.861C54.189 654.643 51.1273 652.548 49.4238 649.504H44.2549C45.1164 650.672 46.042 651.779 46.5844 652.751L46.5834 652.751C46.5834 652.751 46.6736 652.914 46.7005 652.96L49.7941 660.35C50.1997 660.258 50.6016 660.149 50.9967 660.019C52.3201 659.584 53.575 658.939 54.6961 658.111Z"
      fill="#AC121B"
      className="svg-elem-4"
    ></path>
    <path
      d="M56.8468 633.139C56.8209 632.956 56.7964 632.773 56.7721 632.591C56.6795 631.893 56.5945 631.195 56.4849 630.5C54.6615 630.499 52.6834 630.613 51.5061 630.98C48.2519 631.994 45.8312 634.06 44.2754 636.736H50.5692C52.1553 634.834 54.3576 633.519 56.8468 633.139Z"
      fill="#AC121B"
      className="svg-elem-5"
    ></path>
    <path
      opacity="0.43"
      d="M52.6729 667.226L54.8742 672.484C54.8742 672.484 57.8098 672.503 58.7102 672.503C59.0256 672.503 59.5013 672.423 60.0597 671.585L60.5526 670.706L62.5038 667.226H52.6729Z"
      fill="#AC121B"
      className="svg-elem-6"
    ></path>
    <path
      opacity="0.43"
      d="M56.9533 633.124C57.4068 633.06 57.8695 633.026 58.3397 633.026C62.1455 633.026 64.9295 635.218 66.3655 638.463H70.9458C68.761 634.087 64.5446 630.993 59.6507 630.614C58.8796 630.555 57.7736 630.504 56.5947 630.501C56.7151 631.27 56.8045 632.042 56.91 632.813C56.9243 632.916 56.9387 633.02 56.9533 633.124Z"
      fill="#AC121B"
      className="svg-elem-7"
    ></path>
    <path
      d="M68.3836 644.196C67.8865 636.975 62.3699 631.143 55.5312 630.614C47.3578 629.982 40.541 636.796 40.541 645.292C40.541 648.015 41.2441 650.563 42.465 652.751L42.464 652.751C42.464 652.751 42.5541 652.914 42.581 652.96L52.5295 670.706L52.9777 671.506C53.261 672.024 53.6902 672.503 54.5907 672.503C54.9061 672.503 55.3817 672.423 55.9402 671.586L56.4331 670.706L66.3814 652.96C66.4083 652.914 66.4985 652.751 66.4985 652.751L66.4975 652.751C67.8808 650.272 68.5994 647.33 68.3836 644.196ZM54.2203 654.881C48.5044 654.881 43.8706 649.988 43.8706 643.953C43.8706 637.918 48.5042 633.026 54.2203 633.026C59.9363 633.026 64.5699 637.918 64.5699 643.953C64.57 649.988 59.9363 654.881 54.2203 654.881Z"
      fill="#EE2A25"
      className="svg-elem-8"
    ></path>
    <path
      d="M49.8323 632.802C49.8323 632.802 50.9574 631.677 48.4513 632.547C45.9452 633.416 41.9047 637.968 41.2398 642.52C40.5749 647.072 42.007 651.879 43.8482 653.976C45.6895 656.073 42.7742 652.237 42.2628 647.123C41.7513 642.008 43.2856 637.047 49.8323 632.802Z"
      fill="#FBDBDB"
      className="svg-elem-9"
    ></path>
    <path
      d="M45.6891 655.869C45.6891 655.869 44.7686 655.715 45.4846 657.199C46.2006 658.682 46.8655 656.789 45.6891 655.869Z"
      fill="#FBDBDB"
      className="svg-elem-10"
    ></path>
    <path
      d="M68.3833 644.196C68.0393 639.2 65.2917 634.869 61.3662 632.499C63.312 634.072 68.0913 637.712 68.1296 645.346C68.1554 650.486 63.741 657.273 60.6826 663.126L66.3811 652.961C66.4079 652.914 66.4981 652.752 66.4981 652.752L66.4971 652.752C67.8806 650.273 68.5991 647.331 68.3833 644.196Z"
      fill="#FAC3C1"
      className="svg-elem-11"
    ></path>
    <path
      d="M339.503 499.196C339.006 491.975 333.489 486.143 326.65 485.614C324.667 485.46 320.47 485.367 318.505 485.98C312.373 487.892 309.199 493.536 309.199 499.97C309.199 502.693 312.363 505.563 313.584 507.751L313.583 507.751C313.583 507.751 313.673 507.914 313.7 507.96L321.874 527.484C321.874 527.484 324.809 527.503 325.71 527.503C326.025 527.503 326.501 527.423 327.059 526.586L327.552 525.706L337.501 507.96C337.527 507.914 337.618 507.751 337.618 507.751L337.617 507.751C339 505.272 339.719 502.33 339.503 499.196ZM325.339 509.881C319.624 509.881 314.99 504.988 314.99 498.953C314.99 492.918 319.623 488.025 325.339 488.025C331.055 488.025 334.468 492.968 334.468 499.003C334.468 505.038 331.055 509.881 325.339 509.881Z"
      fill="#AC121B"
      className="svg-elem-12"
    ></path>
    <path
      d="M314.99 498.953C314.99 496.238 315.927 493.756 317.479 491.845H311.214C309.879 494.191 309.199 496.995 309.199 499.969C309.199 501.445 310.129 502.964 311.175 504.395H316.363C315.489 502.792 314.99 500.934 314.99 498.953Z"
      fill="#AC121B"
      className="svg-elem-13"
    ></path>
    <path
      d="M321.696 513.111C322.809 512.29 323.791 511.282 324.557 510.129C324.616 510.04 324.673 509.951 324.729 509.861C321.189 509.643 318.127 507.548 316.424 504.504H311.255C312.116 505.672 313.042 506.779 313.584 507.751L313.583 507.751C313.583 507.751 313.674 507.914 313.701 507.96L316.794 515.35C317.2 515.258 317.602 515.149 317.997 515.019C319.32 514.584 320.575 513.939 321.696 513.111Z"
      fill="#AC121B"
      className="svg-elem-14"
    ></path>
    <path
      d="M323.847 488.139C323.821 487.956 323.796 487.773 323.772 487.591C323.679 486.893 323.595 486.195 323.485 485.5C321.661 485.499 319.683 485.613 318.506 485.98C315.252 486.994 312.831 489.06 311.275 491.736H317.569C319.155 489.834 321.358 488.519 323.847 488.139Z"
      fill="#AC121B"
      className="svg-elem-15"
    ></path>
    <path
      opacity="0.43"
      d="M319.673 522.226L321.874 527.484C321.874 527.484 324.81 527.503 325.71 527.503C326.026 527.503 326.501 527.423 327.06 526.585L327.553 525.706L329.504 522.226H319.673Z"
      fill="#AC121B"
      className="svg-elem-16"
    ></path>
    <path
      opacity="0.43"
      d="M323.953 488.124C324.407 488.06 324.869 488.026 325.34 488.026C329.145 488.026 331.929 490.218 333.365 493.463H337.946C335.761 489.087 331.545 485.993 326.651 485.614C325.88 485.555 324.774 485.504 323.595 485.501C323.715 486.27 323.804 487.042 323.91 487.813C323.924 487.916 323.939 488.02 323.953 488.124Z"
      fill="#AC121B"
      className="svg-elem-17"
    ></path>
    <path
      d="M335.384 499.196C334.887 491.975 329.37 486.143 322.531 485.614C314.358 484.982 307.541 491.796 307.541 500.292C307.541 503.015 308.244 505.563 309.465 507.751L309.464 507.751C309.464 507.751 309.554 507.914 309.581 507.96L319.529 525.706L319.978 526.506C320.261 527.024 320.69 527.503 321.591 527.503C321.906 527.503 322.382 527.423 322.94 526.586L323.433 525.706L333.381 507.96C333.408 507.914 333.499 507.751 333.499 507.751L333.497 507.751C334.881 505.272 335.599 502.33 335.384 499.196ZM321.22 509.881C315.504 509.881 310.871 504.988 310.871 498.953C310.871 492.918 315.504 488.026 321.22 488.026C326.936 488.026 331.57 492.918 331.57 498.953C331.57 504.988 326.936 509.881 321.22 509.881Z"
      fill="#EE2A25"
      className="svg-elem-18"
    ></path>
    <path
      d="M316.832 487.802C316.832 487.802 317.957 486.677 315.451 487.547C312.945 488.416 308.905 492.968 308.24 497.52C307.575 502.072 309.007 506.879 310.848 508.976C312.689 511.073 309.774 507.237 309.263 502.123C308.751 497.008 310.286 492.047 316.832 487.802Z"
      fill="#FBDBDB"
      className="svg-elem-19"
    ></path>
    <path
      d="M312.689 510.869C312.689 510.869 311.769 510.715 312.485 512.199C313.201 513.682 313.866 511.789 312.689 510.869Z"
      fill="#FBDBDB"
      className="svg-elem-20"
    ></path>
    <path
      d="M335.383 499.196C335.039 494.2 332.292 489.869 328.366 487.499C330.312 489.072 335.091 492.712 335.13 500.346C335.155 505.486 330.741 512.273 327.683 518.126L333.381 507.961C333.408 507.914 333.498 507.752 333.498 507.752L333.497 507.752C334.881 505.273 335.599 502.331 335.383 499.196Z"
      fill="#FAC3C1"
      className="svg-elem-21"
    ></path>
    <path
      d="M522.504 478.196C522.007 470.975 516.49 465.143 509.651 464.614C507.668 464.46 503.471 464.367 501.506 464.98C495.374 466.892 492.2 472.536 492.2 478.97C492.2 481.693 495.364 484.563 496.585 486.751L496.584 486.751C496.584 486.751 496.674 486.914 496.701 486.96L504.875 506.484C504.875 506.484 507.81 506.503 508.711 506.503C509.026 506.503 509.502 506.423 510.06 505.586L510.553 504.706L520.502 486.96C520.528 486.914 520.619 486.751 520.619 486.751L520.618 486.751C522.001 484.272 522.72 481.33 522.504 478.196ZM508.34 488.881C502.625 488.881 497.991 483.988 497.991 477.953C497.991 471.918 502.624 467.025 508.34 467.025C514.056 467.025 517.468 471.968 517.468 478.003C517.468 484.038 514.056 488.881 508.34 488.881Z"
      fill="#AC121B"
      className="svg-elem-22"
    ></path>
    <path
      d="M497.991 477.953C497.991 475.238 498.928 472.756 500.48 470.845H494.215C492.88 473.191 492.2 475.995 492.2 478.969C492.2 480.445 493.13 481.964 494.176 483.395H499.364C498.49 481.792 497.991 479.934 497.991 477.953Z"
      fill="#AC121B"
      className="svg-elem-23"
    ></path>
    <path
      d="M504.697 492.111C505.81 491.29 506.792 490.282 507.558 489.129C507.617 489.04 507.673 488.951 507.73 488.861C504.19 488.643 501.128 486.548 499.425 483.504H494.256C495.117 484.672 496.043 485.779 496.585 486.751L496.584 486.751C496.584 486.751 496.675 486.914 496.701 486.96L499.795 494.35C500.201 494.258 500.603 494.149 500.998 494.019C502.321 493.584 503.576 492.939 504.697 492.111Z"
      fill="#AC121B"
      className="svg-elem-24"
    ></path>
    <path
      d="M506.847 467.139C506.821 466.956 506.797 466.773 506.773 466.591C506.68 465.893 506.595 465.195 506.485 464.5C504.662 464.499 502.684 464.613 501.507 464.98C498.252 465.994 495.832 468.06 494.276 470.736H500.57C502.156 468.834 504.358 467.519 506.847 467.139Z"
      fill="#AC121B"
      className="svg-elem-25"
    ></path>
    <path
      opacity="0.43"
      d="M502.673 501.226L504.875 506.484C504.875 506.484 507.81 506.503 508.711 506.503C509.026 506.503 509.502 506.423 510.06 505.585L510.553 504.706L512.504 501.226H502.673Z"
      fill="#AC121B"
      className="svg-elem-26"
    ></path>
    <path
      opacity="0.43"
      d="M506.954 467.124C507.408 467.06 507.87 467.026 508.341 467.026C512.146 467.026 514.93 469.218 516.366 472.463H520.947C518.762 468.087 514.546 464.993 509.652 464.614C508.881 464.555 507.775 464.504 506.596 464.501C506.716 465.27 506.805 466.042 506.911 466.813C506.925 466.916 506.94 467.02 506.954 467.124Z"
      fill="#AC121B"
      className="svg-elem-27"
    ></path>
    <path
      d="M518.384 478.196C517.887 470.975 512.37 465.143 505.531 464.614C497.358 463.982 490.541 470.796 490.541 479.292C490.541 482.015 491.244 484.563 492.465 486.751L492.464 486.751C492.464 486.751 492.554 486.914 492.581 486.96L502.529 504.706L502.978 505.506C503.261 506.024 503.69 506.503 504.591 506.503C504.906 506.503 505.382 506.423 505.94 505.586L506.433 504.706L516.381 486.96C516.408 486.914 516.499 486.751 516.499 486.751L516.497 486.751C517.881 484.272 518.599 481.33 518.384 478.196ZM504.22 488.881C498.504 488.881 493.871 483.988 493.871 477.953C493.871 471.918 498.504 467.026 504.22 467.026C509.936 467.026 514.57 471.918 514.57 477.953C514.57 483.988 509.936 488.881 504.22 488.881Z"
      fill="#EE2A25"
      className="svg-elem-28"
    ></path>
    <path
      d="M499.833 466.802C499.833 466.802 500.958 465.677 498.452 466.547C495.946 467.416 491.905 471.968 491.24 476.52C490.575 481.072 492.007 485.879 493.849 487.976C495.69 490.073 492.775 486.237 492.263 481.123C491.752 476.008 493.286 471.047 499.833 466.802Z"
      fill="#FBDBDB"
      className="svg-elem-29"
    ></path>
    <path
      d="M495.69 489.869C495.69 489.869 494.769 489.715 495.485 491.199C496.201 492.682 496.866 490.789 495.69 489.869Z"
      fill="#FBDBDB"
      className="svg-elem-30"
    ></path>
    <path
      d="M518.383 478.196C518.039 473.2 515.292 468.869 511.366 466.499C513.312 468.072 518.091 471.712 518.13 479.346C518.155 484.486 513.741 491.273 510.683 497.126L516.381 486.961C516.408 486.914 516.498 486.752 516.498 486.752L516.497 486.752C517.881 484.273 518.599 481.331 518.383 478.196Z"
      fill="#FAC3C1"
      className="svg-elem-31"
    ></path>
    <path
      d="M812.504 410.196C812.007 402.975 806.49 397.143 799.651 396.614C797.668 396.46 793.471 396.367 791.506 396.98C785.374 398.892 782.2 404.536 782.2 410.97C782.2 413.693 785.364 416.563 786.585 418.751L786.584 418.751C786.584 418.751 786.674 418.914 786.701 418.96L794.875 438.484C794.875 438.484 797.81 438.503 798.711 438.503C799.026 438.503 799.502 438.423 800.06 437.586L800.553 436.706L810.502 418.96C810.528 418.914 810.619 418.751 810.619 418.751L810.618 418.751C812.001 416.272 812.72 413.33 812.504 410.196ZM798.34 420.881C792.625 420.881 787.991 415.988 787.991 409.953C787.991 403.918 792.624 399.025 798.34 399.025C804.056 399.025 807.468 403.968 807.468 410.003C807.468 416.038 804.056 420.881 798.34 420.881Z"
      fill="#AC121B"
      className="svg-elem-32"
    ></path>
    <path
      d="M787.991 409.953C787.991 407.238 788.928 404.756 790.48 402.845H784.215C782.88 405.191 782.2 407.995 782.2 410.969C782.2 412.445 783.13 413.964 784.176 415.395H789.364C788.49 413.792 787.991 411.934 787.991 409.953Z"
      fill="#AC121B"
      className="svg-elem-33"
    ></path>
    <path
      d="M794.697 424.111C795.81 423.29 796.792 422.282 797.558 421.129C797.617 421.04 797.673 420.951 797.73 420.861C794.19 420.643 791.128 418.548 789.425 415.504H784.256C785.117 416.672 786.043 417.779 786.585 418.751L786.584 418.751C786.584 418.751 786.675 418.914 786.701 418.96L789.795 426.35C790.201 426.258 790.603 426.149 790.998 426.019C792.321 425.584 793.576 424.939 794.697 424.111Z"
      fill="#AC121B"
      className="svg-elem-34"
    ></path>
    <path
      d="M796.847 399.139C796.821 398.956 796.797 398.773 796.773 398.591C796.68 397.893 796.595 397.195 796.485 396.5C794.662 396.499 792.684 396.613 791.507 396.98C788.252 397.994 785.832 400.06 784.276 402.736H790.57C792.156 400.834 794.358 399.519 796.847 399.139Z"
      fill="#AC121B"
      className="svg-elem-35"
    ></path>
    <path
      opacity="0.43"
      d="M792.673 433.226L794.875 438.484C794.875 438.484 797.81 438.503 798.711 438.503C799.026 438.503 799.502 438.423 800.06 437.585L800.553 436.706L802.504 433.226H792.673Z"
      fill="#AC121B"
      className="svg-elem-36"
    ></path>
    <path
      opacity="0.43"
      d="M796.954 399.124C797.408 399.06 797.87 399.026 798.341 399.026C802.146 399.026 804.93 401.218 806.366 404.463H810.947C808.762 400.087 804.546 396.993 799.652 396.614C798.881 396.555 797.775 396.504 796.596 396.501C796.716 397.27 796.805 398.042 796.911 398.813C796.925 398.916 796.94 399.02 796.954 399.124Z"
      fill="#AC121B"
      className="svg-elem-37"
    ></path>
    <path
      d="M808.384 410.196C807.887 402.975 802.37 397.143 795.531 396.614C787.358 395.982 780.541 402.796 780.541 411.292C780.541 414.015 781.244 416.563 782.465 418.751L782.464 418.751C782.464 418.751 782.554 418.914 782.581 418.96L792.529 436.706L792.978 437.506C793.261 438.024 793.69 438.503 794.591 438.503C794.906 438.503 795.382 438.423 795.94 437.586L796.433 436.706L806.381 418.96C806.408 418.914 806.499 418.751 806.499 418.751L806.497 418.751C807.881 416.272 808.599 413.33 808.384 410.196ZM794.22 420.881C788.504 420.881 783.871 415.988 783.871 409.953C783.871 403.918 788.504 399.026 794.22 399.026C799.936 399.026 804.57 403.918 804.57 409.953C804.57 415.988 799.936 420.881 794.22 420.881Z"
      fill="#EE2A25"
      className="svg-elem-38"
    ></path>
    <path
      d="M789.833 398.802C789.833 398.802 790.958 397.677 788.452 398.547C785.946 399.416 781.905 403.968 781.24 408.52C780.575 413.072 782.007 417.879 783.849 419.976C785.69 422.073 782.775 418.237 782.263 413.123C781.752 408.008 783.286 403.047 789.833 398.802Z"
      fill="#FBDBDB"
      className="svg-elem-39"
    ></path>
    <path
      d="M785.69 421.869C785.69 421.869 784.769 421.715 785.485 423.199C786.201 424.682 786.866 422.789 785.69 421.869Z"
      fill="#FBDBDB"
      className="svg-elem-40"
    ></path>
    <path
      d="M808.383 410.196C808.039 405.2 805.292 400.869 801.366 398.499C803.312 400.072 808.091 403.712 808.13 411.346C808.155 416.486 803.741 423.273 800.683 429.126L806.381 418.961C806.408 418.914 806.498 418.752 806.498 418.752L806.497 418.752C807.881 416.273 808.599 413.331 808.383 410.196Z"
      fill="#FAC3C1"
      className="svg-elem-41"
    ></path>
    <path
      d="M970.504 288.196C970.007 280.975 964.49 275.143 957.651 274.614C955.668 274.46 951.471 274.367 949.506 274.98C943.374 276.892 940.2 282.536 940.2 288.97C940.2 291.693 943.364 294.563 944.585 296.751L944.584 296.751C944.584 296.751 944.674 296.914 944.701 296.96L952.875 316.484C952.875 316.484 955.81 316.503 956.711 316.503C957.026 316.503 957.502 316.423 958.06 315.586L958.553 314.706L968.502 296.96C968.528 296.914 968.619 296.751 968.619 296.751L968.618 296.751C970.001 294.272 970.72 291.33 970.504 288.196ZM956.34 298.881C950.625 298.881 945.991 293.988 945.991 287.953C945.991 281.918 950.624 277.025 956.34 277.025C962.056 277.025 965.468 281.968 965.468 288.003C965.468 294.038 962.056 298.881 956.34 298.881Z"
      fill="#AC121B"
      className="svg-elem-42"
    ></path>
    <path
      d="M945.991 287.953C945.991 285.238 946.928 282.756 948.48 280.845H942.215C940.88 283.191 940.2 285.995 940.2 288.969C940.2 290.445 941.13 291.964 942.176 293.395H947.364C946.49 291.792 945.991 289.934 945.991 287.953Z"
      fill="#AC121B"
      className="svg-elem-43"
    ></path>
    <path
      d="M952.697 302.111C953.81 301.29 954.792 300.282 955.558 299.129C955.617 299.04 955.673 298.951 955.73 298.861C952.19 298.643 949.128 296.548 947.425 293.504H942.256C943.117 294.672 944.043 295.779 944.585 296.751L944.584 296.751C944.584 296.751 944.675 296.914 944.701 296.96L947.795 304.35C948.201 304.258 948.603 304.149 948.998 304.019C950.321 303.584 951.576 302.939 952.697 302.111Z"
      fill="#AC121B"
      className="svg-elem-44"
    ></path>
    <path
      d="M954.847 277.139C954.821 276.956 954.797 276.773 954.773 276.591C954.68 275.893 954.595 275.195 954.485 274.5C952.662 274.499 950.684 274.613 949.507 274.98C946.252 275.994 943.832 278.06 942.276 280.736H948.57C950.156 278.834 952.358 277.519 954.847 277.139Z"
      fill="#AC121B"
      className="svg-elem-45"
    ></path>
    <path
      opacity="0.43"
      d="M950.673 311.226L952.875 316.484C952.875 316.484 955.81 316.503 956.711 316.503C957.026 316.503 957.502 316.423 958.06 315.585L958.553 314.706L960.504 311.226H950.673Z"
      fill="#AC121B"
      className="svg-elem-46"
    ></path>
    <path
      opacity="0.43"
      d="M954.954 277.124C955.408 277.06 955.87 277.026 956.341 277.026C960.146 277.026 962.93 279.218 964.366 282.463H968.947C966.762 278.087 962.546 274.993 957.652 274.614C956.881 274.555 955.775 274.504 954.596 274.501C954.716 275.27 954.805 276.042 954.911 276.813C954.925 276.916 954.94 277.02 954.954 277.124Z"
      fill="#AC121B"
      className="svg-elem-47"
    ></path>
    <path
      d="M966.384 288.196C965.887 280.975 960.37 275.143 953.531 274.614C945.358 273.982 938.541 280.796 938.541 289.292C938.541 292.015 939.244 294.563 940.465 296.751L940.464 296.751C940.464 296.751 940.554 296.914 940.581 296.96L950.529 314.706L950.978 315.506C951.261 316.024 951.69 316.503 952.591 316.503C952.906 316.503 953.382 316.423 953.94 315.586L954.433 314.706L964.381 296.96C964.408 296.914 964.499 296.751 964.499 296.751L964.497 296.751C965.881 294.272 966.599 291.33 966.384 288.196ZM952.22 298.881C946.504 298.881 941.871 293.988 941.871 287.953C941.871 281.918 946.504 277.026 952.22 277.026C957.936 277.026 962.57 281.918 962.57 287.953C962.57 293.988 957.936 298.881 952.22 298.881Z"
      fill="#EE2A25"
      className="svg-elem-48"
    ></path>
    <path
      d="M947.833 276.802C947.833 276.802 948.958 275.677 946.452 276.547C943.946 277.416 939.905 281.968 939.24 286.52C938.575 291.072 940.007 295.879 941.849 297.976C943.69 300.073 940.775 296.237 940.263 291.123C939.752 286.008 941.286 281.047 947.833 276.802Z"
      fill="#FBDBDB"
      className="svg-elem-49"
    ></path>
    <path
      d="M943.69 299.869C943.69 299.869 942.769 299.715 943.485 301.199C944.201 302.682 944.866 300.789 943.69 299.869Z"
      fill="#FBDBDB"
      className="svg-elem-50"
    ></path>
    <path
      d="M966.383 288.196C966.039 283.2 963.292 278.869 959.366 276.499C961.312 278.072 966.091 281.712 966.13 289.346C966.155 294.486 961.741 301.273 958.683 307.126L964.381 296.961C964.408 296.914 964.498 296.752 964.498 296.752L964.497 296.752C965.881 294.273 966.599 291.331 966.383 288.196Z"
      fill="#FAC3C1"
      className="svg-elem-51"
    ></path>
    <path
      d="M1171.5 98.1959C1171.01 90.9749 1165.49 85.1425 1158.65 84.6138C1156.67 84.4604 1152.47 84.3674 1150.51 84.9801C1144.37 86.8919 1141.2 92.5359 1141.2 98.9696C1141.2 101.693 1144.36 104.563 1145.59 106.751L1145.58 106.751C1145.58 106.751 1145.67 106.914 1145.7 106.96L1153.87 126.484C1153.87 126.484 1156.81 126.503 1157.71 126.503C1158.03 126.503 1158.5 126.423 1159.06 125.586L1159.55 124.706L1169.5 106.96C1169.53 106.914 1169.62 106.751 1169.62 106.751L1169.62 106.751C1171 104.272 1171.72 101.33 1171.5 98.1959ZM1157.34 108.881C1151.62 108.881 1146.99 103.988 1146.99 97.9531C1146.99 91.918 1151.62 87.0255 1157.34 87.0255C1163.06 87.0255 1166.47 91.9678 1166.47 98.003C1166.47 104.038 1163.06 108.881 1157.34 108.881Z"
      fill="#AC121B"
      className="svg-elem-52"
    ></path>
    <path
      d="M1146.99 97.9526C1146.99 95.2384 1147.93 92.7557 1149.48 90.8447H1143.21C1141.88 93.1906 1141.2 95.9949 1141.2 98.969C1141.2 100.445 1142.13 101.964 1143.18 103.395H1148.36C1147.49 101.792 1146.99 99.934 1146.99 97.9526Z"
      fill="#AC121B"
      className="svg-elem-53"
    ></path>
    <path
      d="M1153.7 112.111C1154.81 111.29 1155.79 110.282 1156.56 109.129C1156.62 109.04 1156.67 108.951 1156.73 108.861C1153.19 108.643 1150.13 106.548 1148.42 103.504H1143.26C1144.12 104.672 1145.04 105.779 1145.59 106.751L1145.58 106.751C1145.58 106.751 1145.67 106.914 1145.7 106.96L1148.8 114.35C1149.2 114.258 1149.6 114.149 1150 114.019C1151.32 113.584 1152.58 112.939 1153.7 112.111Z"
      fill="#AC121B"
      className="svg-elem-54"
    ></path>
    <path
      d="M1155.85 87.139C1155.82 86.9563 1155.8 86.7733 1155.77 86.5908C1155.68 85.8934 1155.6 85.1949 1155.49 84.5C1153.66 84.4992 1151.68 84.6128 1150.51 84.9799C1147.25 85.9944 1144.83 88.0598 1143.28 90.7364H1149.57C1151.16 88.8341 1153.36 87.5191 1155.85 87.139Z"
      fill="#AC121B"
      className="svg-elem-55"
    ></path>
    <path
      opacity="0.43"
      d="M1151.67 121.226L1153.87 126.484C1153.87 126.484 1156.81 126.503 1157.71 126.503C1158.03 126.503 1158.5 126.423 1159.06 125.585L1159.55 124.706L1161.5 121.226H1151.67Z"
      fill="#AC121B"
      className="svg-elem-56"
    ></path>
    <path
      opacity="0.43"
      d="M1155.95 87.1238C1156.41 87.0595 1156.87 87.026 1157.34 87.026C1161.15 87.026 1163.93 89.2176 1165.37 92.4633H1169.95C1167.76 88.0875 1163.55 84.9927 1158.65 84.6144C1157.88 84.5548 1156.77 84.5044 1155.6 84.501C1155.72 85.2695 1155.81 86.0423 1155.91 86.8128C1155.93 86.9162 1155.94 87.02 1155.95 87.1238Z"
      fill="#AC121B"
      className="svg-elem-57"
    ></path>
    <path
      d="M1167.38 98.196C1166.89 90.975 1161.37 85.1427 1154.53 84.6139C1146.36 83.982 1139.54 90.7964 1139.54 99.292C1139.54 102.015 1140.24 104.563 1141.46 106.751L1141.46 106.751C1141.46 106.751 1141.55 106.914 1141.58 106.96L1151.53 124.706L1151.98 125.506C1152.26 126.024 1152.69 126.503 1153.59 126.503C1153.91 126.503 1154.38 126.423 1154.94 125.586L1155.43 124.706L1165.38 106.96C1165.41 106.914 1165.5 106.751 1165.5 106.751L1165.5 106.751C1166.88 104.272 1167.6 101.33 1167.38 98.196ZM1153.22 108.881C1147.5 108.881 1142.87 103.988 1142.87 97.9532C1142.87 91.9181 1147.5 87.0256 1153.22 87.0256C1158.94 87.0256 1163.57 91.9181 1163.57 97.9532C1163.57 103.988 1158.94 108.881 1153.22 108.881Z"
      fill="#EE2A25"
      className="svg-elem-58"
    ></path>
    <path
      d="M1148.83 86.8022C1148.83 86.8022 1149.96 85.677 1147.45 86.5465C1144.95 87.416 1140.91 91.968 1140.24 96.5198C1139.58 101.072 1141.01 105.879 1142.85 107.976C1144.69 110.073 1141.77 106.237 1141.26 101.123C1140.75 96.0085 1142.29 91.0473 1148.83 86.8022Z"
      fill="#FBDBDB"
      className="svg-elem-59"
    ></path>
    <path
      d="M1144.69 109.869C1144.69 109.869 1143.77 109.715 1144.49 111.199C1145.2 112.682 1145.87 110.789 1144.69 109.869Z"
      fill="#FBDBDB"
      className="svg-elem-60"
    ></path>
    <path
      d="M1167.38 98.1963C1167.04 93.1998 1164.29 88.8688 1160.37 86.499C1162.31 88.0722 1167.09 91.7121 1167.13 99.3456C1167.16 104.486 1162.74 111.273 1159.68 117.126L1165.38 106.961C1165.41 106.914 1165.5 106.752 1165.5 106.752L1165.5 106.752C1166.88 104.273 1167.6 101.331 1167.38 98.1963Z"
      fill="#FAC3C1"
      className="svg-elem-61"
    ></path>
  </svg>
);

export const Sparkles = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.26587 8.65394C3.90134 5.73308 3.14973 4.99131 0.190007 4.63183C-0.0633358 4.60128 -0.0633358 4.24015 0.190007 4.20961C3.14991 3.84988 3.90159 3.10957 4.26587 0.187501C4.29683 -0.0625005 4.66279 -0.0625005 4.69374 0.187501C5.05827 3.10836 5.80988 3.85013 8.7696 4.20961C9.02294 4.24016 9.02294 4.60129 8.7696 4.63183C5.8097 4.99155 5.05802 5.73187 4.69374 8.65394C4.66278 8.90394 4.29682 8.90394 4.26587 8.65394ZM31.81 27.3682C28.8501 27.0084 28.0984 26.2667 27.7341 23.3461C27.7032 23.0961 27.3372 23.0961 27.3063 23.3461C26.9417 26.2669 26.1901 27.0087 23.2304 27.3682C22.9771 27.3987 22.9771 27.7599 23.2304 27.7904C26.1903 28.1501 26.942 28.8904 27.3063 31.8125C27.3372 32.0625 27.7032 32.0625 27.7341 31.8125C28.0987 28.8916 28.8503 28.1499 31.81 27.7904C32.0633 27.7598 32.0633 27.3987 31.81 27.3682ZM27.0315 14.9971C19.4185 14.0735 17.4861 12.1666 16.5515 4.6553C16.4712 4.01223 15.5296 4.01223 15.4494 4.6553C14.5134 12.1679 12.581 14.0748 4.96934 14.9971C4.31768 15.0763 4.31768 16.0055 4.96934 16.0847C12.5824 17.0083 14.5148 18.9152 15.4494 26.4265C15.5296 27.0696 16.4712 27.0696 16.5515 26.4265C17.4874 18.9139 19.4199 17.007 27.0315 16.0847C27.6832 16.0055 27.6832 15.0763 27.0315 14.9971Z"
      fill="black"
    />
  </svg>
);
export const TrophyIcon = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0H48C56.8366 0 64 7.16344 64 16V48C64 56.8366 56.8366 64 48 64H16C7.16344 64 0 56.8366 0 48V16Z"
      fill="white"
      fill-opacity="0.2"
    />
    <path
      d="M21.9987 27H19.4987C18.3936 27 17.3338 26.561 16.5524 25.7796C15.771 24.9982 15.332 23.9384 15.332 22.8333C15.332 21.7282 15.771 20.6684 16.5524 19.887C17.3338 19.1056 18.3936 18.6666 19.4987 18.6666H21.9987"
      stroke="#FFD700"
      strokeWidth="3.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42 27H44.5C45.6051 27 46.6649 26.561 47.4463 25.7796C48.2277 24.9982 48.6667 23.9384 48.6667 22.8333C48.6667 21.7282 48.2277 20.6684 47.4463 19.887C46.6649 19.1056 45.6051 18.6666 44.5 18.6666H42"
      stroke="#FFD700"
      strokeWidth="3.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.668 48.6666H45.3346"
      stroke="#FFD700"
      strokeWidth="3.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M28.668 36.4333V40.3333C28.668 41.25 27.8846 41.9667 27.0513 42.35C25.0846 43.25 23.668 45.7333 23.668 48.6667"
      stroke="#FFD700"
      strokeWidth="3.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M35.332 36.4333V40.3333C35.332 41.25 36.1154 41.9667 36.9487 42.35C38.9154 43.25 40.332 45.7333 40.332 48.6667"
      stroke="#FFD700"
      strokeWidth="3.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M42 15.3334H22V27C22 29.6522 23.0536 32.1957 24.9289 34.0711C26.8043 35.9465 29.3478 37 32 37C34.6522 37 37.1957 35.9465 39.0711 34.0711C40.9464 32.1957 42 29.6522 42 27V15.3334Z"
      stroke="#FFD700"
      strokeWidth="3.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const FillWhiteStar = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9987 1.33331L10.0587 5.50665L14.6654 6.17998L11.332 9.42665L12.1187 14.0133L7.9987 11.8466L3.8787 14.0133L4.66536 9.42665L1.33203 6.17998L5.9387 5.50665L7.9987 1.33331Z"
      fill="white"
    />
  </svg>
);

export const BookConfirmCheck = () => (
  <svg
    width="30"
    height="22"
    viewBox="0 0 30 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.3346 1.66669L10.0013 20L1.66797 11.6667"
      stroke="#00A63E"
      strokeWidth="3.33333"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const YellowCircleCancel = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_4022_64" fill="white">
      <path d="M0 50C0 22.3858 22.3858 0 50 0V0C77.6142 0 100 22.3858 100 50V50C100 77.6142 77.6142 100 50 100V100C22.3858 100 0 77.6142 0 50V50Z" />
    </mask>
    <path
      d="M0 50C0 22.3858 22.3858 0 50 0V0C77.6142 0 100 22.3858 100 50V50C100 77.6142 77.6142 100 50 100V100C22.3858 100 0 77.6142 0 50V50Z"
      fill="white"
    />
    <path
      d="M0 50M100 50M100 50M0 50M50 0M100 50M50 100M0 50M50 100V97.2864C23.8844 97.2864 2.71359 76.1156 2.71359 50H0H-2.71359C-2.71359 79.1129 20.8871 102.714 50 102.714V100ZM100 50H97.2864C97.2864 76.1156 76.1156 97.2864 50 97.2864V100V102.714C79.1129 102.714 102.714 79.1129 102.714 50H100ZM50 0V2.71359C76.1156 2.71359 97.2864 23.8844 97.2864 50H100H102.714C102.714 20.8871 79.1129 -2.71359 50 -2.71359V0ZM50 0V-2.71359C20.8871 -2.71359 -2.71359 20.8871 -2.71359 50H0H2.71359C2.71359 23.8844 23.8844 2.71359 50 2.71359V0Z"
      fill="#FFA500"
      mask="url(#path-1-inside-1_4022_64)"
    />
    <path
      d="M49.9997 74.6302C63.6026 74.6302 74.6299 63.6029 74.6299 50C74.6299 36.3971 63.6026 25.3698 49.9997 25.3698C36.3969 25.3698 25.3696 36.3971 25.3696 50C25.3696 63.6029 36.3969 74.6302 49.9997 74.6302Z"
      stroke="#FFA500"
      strokeWidth="3.69453"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.3899 42.611L42.6118 57.3891"
      stroke="#FFA500"
      strokeWidth="3.69453"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.6118 42.611L57.3899 57.3891"
      stroke="#FFA500"
      strokeWidth="3.69453"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Badge = ({ fill }: { fill?: string }) => (
  <svg
    width="30"
    height="32"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1212 26.4274C10.4625 29.892 8.37393 31.8829 8.37393 31.8829C8.27427 31.9776 8.13332 32.0186 7.99808 31.9917C7.86282 31.9649 7.75034 31.873 7.69481 31.7473L6.26817 28.431L0.493239 29.4215C0.29818 29.4554 0.10455 29.3494 0.0305223 29.1671C-0.0435159 28.9849 0.0205559 28.7758 0.185714 28.6655C2.34701 27.213 4.29458 25.0793 6.01896 22.7506L6.49593 24.9139C6.63831 25.5639 7.05119 26.1234 7.63211 26.4569C8.21303 26.7903 8.90782 26.8638 9.54709 26.6618L11.7098 25.9779L12.1212 26.4274ZM23.9813 22.7508C25.7055 25.0794 27.6531 27.213 29.8145 28.6657C29.9783 28.7759 30.0438 28.9851 29.9697 29.1673C29.8957 29.3496 29.7035 29.4556 29.507 29.4217L23.7321 28.4312L22.3054 31.7475C22.2513 31.8732 22.1374 31.9651 22.0022 31.9919C21.8669 32.0188 21.726 31.9778 21.6263 31.8831C21.6263 31.8831 19.5376 29.8908 17.879 26.4275L18.2905 25.9782L20.4532 26.6621C21.0925 26.8641 21.7873 26.7893 22.3682 26.4572C22.9491 26.1237 23.362 25.5642 23.5044 24.9142L23.9813 22.7508ZM13.8595 0.500196C14.1513 0.182271 14.5657 0 14.9999 0C15.4342 0 15.8485 0.180863 16.1404 0.500196L17.7293 2.23254C17.9144 2.43319 18.1992 2.50949 18.4611 2.42613L20.7093 1.7154C21.1222 1.584 21.5721 1.63345 21.9479 1.84823C22.3238 2.063 22.5901 2.42616 22.684 2.84721L23.188 5.13484C23.2464 5.40049 23.4557 5.6082 23.7234 5.66615L26.0285 6.16635C26.4528 6.25819 26.8187 6.52242 27.0351 6.89544C27.2515 7.26846 27.3013 7.71497 27.1689 8.12474L26.4528 10.3559C26.3702 10.6144 26.4457 10.8985 26.6478 11.0807L28.392 12.6576C28.7123 12.9473 28.896 13.3585 28.896 13.788C28.896 14.219 28.7138 14.6302 28.392 14.9199L26.6478 16.4968C26.4457 16.6805 26.3688 16.9631 26.4528 17.2216L27.1689 19.4528C27.3013 19.8625 27.2515 20.309 27.0351 20.6821C26.8187 21.0551 26.4528 21.3207 26.0285 21.4112L23.7234 21.9114C23.4557 21.9707 23.2464 22.177 23.188 22.4427L22.684 24.7303C22.5915 25.1514 22.3238 25.5131 21.9479 25.7293C21.5721 25.9441 21.1222 25.9921 20.7093 25.8621L18.4611 25.1514C18.1991 25.068 17.9144 25.1443 17.7293 25.345L16.1404 27.0773C15.8485 27.3952 15.4342 27.5775 14.9999 27.5775C14.5657 27.5775 14.1528 27.3966 13.8595 27.0773L12.2705 25.345C12.0854 25.1443 11.8007 25.068 11.5387 25.1514L9.29055 25.8621C8.87766 25.9921 8.42773 25.9441 8.05187 25.7293C7.67601 25.5145 7.40976 25.1513 7.31579 24.7303L6.81178 22.4427C6.7534 22.177 6.54411 21.9707 6.27642 21.9114L3.97133 21.4112C3.54703 21.3193 3.18112 21.0551 2.96473 20.6821C2.74833 20.309 2.69848 19.8625 2.83089 19.4528L3.54704 17.2216C3.62961 16.9631 3.55415 16.679 3.35198 16.4968L1.60783 14.9199C1.28748 14.6302 1.10382 14.219 1.10382 13.788C1.10382 13.3585 1.28606 12.9473 1.60783 12.6576L3.35198 11.0807C3.55415 10.897 3.63104 10.6144 3.54704 10.3559L2.83089 8.12474C2.69848 7.71356 2.74831 7.26705 2.96473 6.89544C3.18114 6.52243 3.54707 6.25678 3.97133 6.16635L6.27642 5.66615C6.54409 5.60822 6.75339 5.4005 6.81178 5.13484L7.31579 2.84721C7.40834 2.42612 7.67601 2.0644 8.05187 1.84823C8.42773 1.63345 8.87766 1.584 9.29055 1.7154L11.5387 2.42613C11.8007 2.50808 12.0854 2.43319 12.2705 2.23254L13.8595 0.500196ZM14.9999 4.45388C9.81581 4.45388 5.60708 8.63074 5.60708 13.7756C5.60708 18.9204 9.81581 23.0973 14.9999 23.0973C20.184 23.0973 24.3927 18.9204 24.3927 13.7756C24.3927 8.63074 20.184 4.45388 14.9999 4.45388ZM14.9999 5.28755C19.7197 5.28755 23.5511 9.09002 23.5511 13.774C23.5511 18.458 19.7197 22.2605 14.9999 22.2605C10.2802 22.2605 6.44868 18.458 6.44868 13.774C6.44868 9.09002 10.2802 5.28755 14.9999 5.28755ZM14.9999 6.67937C11.0547 6.67937 7.84977 9.85862 7.84977 13.7739C7.84977 17.6907 11.0533 20.8699 14.9999 20.8699C18.9465 20.8699 22.1501 17.6907 22.1501 13.7739C22.1501 9.85859 18.9465 6.67937 14.9999 6.67937ZM14.9999 7.51445C18.4811 7.51445 21.3088 10.3192 21.3088 13.7741C21.3088 17.2303 18.4826 20.0353 14.9999 20.0353C11.5188 20.0353 8.691 17.2305 8.691 13.7741C8.691 10.3194 11.5172 7.51445 14.9999 7.51445ZM15.3801 9.17188C15.3103 9.02493 15.1622 8.93167 14.9999 8.93167C14.8362 8.93167 14.6881 9.02493 14.6198 9.17188L13.5049 11.5259L11.0219 11.9018C10.8667 11.9258 10.7371 12.0346 10.6858 12.1816C10.636 12.3299 10.673 12.4938 10.7841 12.6055L12.5937 14.4438L12.1651 17.0451C12.1395 17.2034 12.2064 17.3616 12.3374 17.4535C12.4698 17.5453 12.6421 17.5552 12.7831 17.4775L14.9985 16.2623L17.2138 17.4775C17.3548 17.5538 17.5285 17.5453 17.6595 17.4535C17.7919 17.3616 17.8574 17.2034 17.8318 17.0451L17.4032 14.4438L19.2128 12.6055C19.3239 12.4939 19.3609 12.33 19.3111 12.1816C19.2612 12.0346 19.1317 11.9258 18.975 11.9018L16.492 11.5259L15.3772 9.17188H15.3801ZM14.9999 10.3319L15.83 12.0841C15.8898 12.2098 16.0079 12.2974 16.1475 12.3186L18.0439 12.6055L16.6586 14.0128C16.566 14.1075 16.5233 14.2417 16.5447 14.3717L16.8664 16.333L15.2049 15.4216C15.0782 15.3524 14.9244 15.3524 14.7977 15.4216L13.1361 16.333L13.4579 14.3717C13.4793 14.2417 13.4366 14.1075 13.344 14.0128L11.9587 12.6055L13.8551 12.3186C13.9932 12.2974 14.1128 12.2098 14.1726 12.0841L15.0013 10.3319H14.9999Z"
      fill={fill ? fill : "black"}
    />
  </svg>
);

export const StopWatch = ({ className }: { className?: string }) => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.3751 2.93146V1.71859H13.6471C14.1304 1.71859 14.5222 1.33384 14.5222 0.859297C14.5222 0.384753 14.1304 0 13.6471 0H9.35273C8.86943 0 8.47758 0.384753 8.47758 0.859297C8.47758 1.33384 8.86943 1.71859 9.35273 1.71859H10.6249V2.93146C5.10652 3.37059 0.751987 7.91729 0.751987 13.4468C0.751987 19.2659 5.57352 24 11.5 24C17.4264 24 22.2478 19.2659 22.2478 13.4468C22.2478 7.91729 17.8934 3.37059 12.3751 2.93146ZM11.5 22.2814C6.53862 22.2814 2.50228 18.3182 2.50228 13.4468C2.50228 8.57535 6.53862 4.61211 11.5 4.61211C16.4613 4.61211 20.4975 8.57535 20.4975 13.4468C20.4975 18.3182 16.4613 22.2814 11.5 22.2814ZM0.875161 7.04231C0.65114 7.04231 0.427225 6.9584 0.256404 6.79067C-0.0854504 6.45511 -0.0854502 5.91102 0.256297 5.57547L3.03205 2.84988C3.3738 2.51432 3.92792 2.51422 4.26967 2.84978C4.61153 3.18534 4.61153 3.72942 4.26978 4.06498L1.49402 6.79056C1.3231 6.9584 1.09908 7.04231 0.875161 7.04231ZM22.7437 6.79056C22.5728 6.9584 22.3488 7.04231 22.1248 7.04231C21.9008 7.04231 21.6769 6.9584 21.5061 6.79067L18.7301 4.06509C18.3883 3.72953 18.3883 3.18544 18.73 2.84988C19.0718 2.51432 19.6259 2.51422 19.9676 2.84978L22.7436 5.57536C23.0855 5.91092 23.0854 6.45501 22.7437 6.79056ZM12.3751 7.29291V13.4468C12.3751 13.9213 11.9833 14.3061 11.5 14.3061C11.0167 14.3061 10.6249 13.9213 10.6249 13.4468V7.29291C10.6249 6.81836 11.0167 6.43361 11.5 6.43361C11.9833 6.43361 12.3751 6.81836 12.3751 7.29291Z"
        fill="#EB9757"
      />
    </svg>
  );
};

export const CourseFinderNotFount = () => {
  return (
    <svg
      width="260"
      height="200"
      viewBox="0 0 260 200"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <ellipse
        cx="130"
        cy="155"
        rx="68"
        ry="10"
        fill="#E8EBFF"
        opacity="0.7"
      ></ellipse>

      <circle
        cx="130"
        cy="110"
        r="60"
        fill="#EEF1FF"
        stroke="#C7CFFF"
        strokeWidth="1"
      ></circle>

      <ellipse
        cx="130"
        cy="110"
        rx="60"
        ry="18"
        fill="none"
        stroke="#C7CFFF"
        strokeWidth="0.75"
        strokeDasharray="3 2"
      ></ellipse>
      <ellipse
        cx="130"
        cy="90"
        rx="52"
        ry="12"
        fill="none"
        stroke="#C7CFFF"
        strokeWidth="0.75"
        strokeDasharray="3 2"
      ></ellipse>
      <ellipse
        cx="130"
        cy="130"
        rx="52"
        ry="12"
        fill="none"
        stroke="#C7CFFF"
        strokeWidth="0.75"
        strokeDasharray="3 2"
      ></ellipse>

      <line
        x1="130"
        y1="50"
        x2="130"
        y2="170"
        stroke="#C7CFFF"
        strokeWidth="0.75"
        strokeDasharray="3 2"
      ></line>

      <ellipse
        cx="112"
        cy="100"
        rx="14"
        ry="10"
        fill="#B8C3FF"
        opacity="0.7"
      ></ellipse>
      <ellipse
        cx="148"
        cy="96"
        rx="18"
        ry="12"
        fill="#B8C3FF"
        opacity="0.7"
      ></ellipse>
      <ellipse
        cx="136"
        cy="120"
        rx="10"
        ry="6"
        fill="#B8C3FF"
        opacity="0.6"
      ></ellipse>
      <ellipse
        cx="112"
        cy="118"
        rx="7"
        ry="5"
        fill="#B8C3FF"
        opacity="0.5"
      ></ellipse>

      <circle
        cx="130"
        cy="110"
        r="60"
        fill="none"
        stroke="#8FA0FF"
        strokeWidth="1.2"
      ></circle>

      <circle
        cx="164"
        cy="74"
        r="18"
        fill="white"
        stroke="#4F6BFF"
        strokeWidth="2"
      ></circle>
      <line
        x1="177"
        y1="87"
        x2="188"
        y2="98"
        stroke="#4F6BFF"
        strokeWidth="2.5"
        strokeLinecap="round"
      ></line>
      <text
        x="164"
        y="79"
        text-anchor="middle"
        fill="#4F6BFF"
        fontSize="16"
        fontWeight="600"
        fontFamily="DM Sans, sans-serif"
      >
        ?
      </text>

      <rect
        x="20"
        y="54"
        width="70"
        height="34"
        rx="7"
        fill="white"
        stroke="#D0D7FF"
        strokeWidth="0.8"
      ></rect>
      <rect x="28" y="62" width="22" height="5" rx="2.5" fill="#B8C3FF"></rect>
      <rect x="28" y="71" width="40" height="4" rx="2" fill="#DDE2FF"></rect>
      <rect
        x="28"
        y="71"
        width="14"
        height="4"
        rx="2"
        fill="#4F6BFF"
        opacity="0.5"
      ></rect>

      <rect
        x="185"
        y="112"
        width="60"
        height="30"
        rx="7"
        fill="white"
        stroke="#D0D7FF"
        strokeWidth="0.8"
      ></rect>
      <rect x="193" y="119" width="18" height="4" rx="2" fill="#B8C3FF"></rect>
      <rect x="193" y="127" width="36" height="4" rx="2" fill="#DDE2FF"></rect>
      <rect
        x="193"
        y="127"
        width="10"
        height="4"
        rx="2"
        fill="#4F6BFF"
        opacity="0.5"
      ></rect>

      <circle cx="90" cy="54" r="9" fill="#FEE2E2"></circle>
      <line
        x1="86.5"
        y1="50.5"
        x2="93.5"
        y2="57.5"
        stroke="#E24B4A"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></line>
      <line
        x1="93.5"
        y1="50.5"
        x2="86.5"
        y2="57.5"
        stroke="#E24B4A"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></line>

      <circle cx="245" cy="112" r="9" fill="#FEE2E2"></circle>
      <line
        x1="241.5"
        y1="108.5"
        x2="248.5"
        y2="115.5"
        stroke="#E24B4A"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></line>
      <line
        x1="248.5"
        y1="108.5"
        x2="241.5"
        y2="115.5"
        stroke="#E24B4A"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></line>

      <circle cx="48" cy="38" r="2.5" fill="#FFD166"></circle>
      <circle cx="210" cy="58" r="2" fill="#FFD166"></circle>
      <circle cx="178" cy="148" r="1.8" fill="#B8C3FF"></circle>
      <circle cx="68" cy="145" r="1.5" fill="#B8C3FF"></circle>
    </svg>
  );
};
export const HeroStar = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="url(#paint0_linear_2549_3232)" />
      <path
        d="M10.3571 4.64282L12.0125 7.99639L15.7143 8.53747L13.0357 11.1464L13.6679 14.8321L10.3571 13.091L7.04643 14.8321L7.67857 11.1464L5 8.53747L8.70179 7.99639L10.3571 4.64282Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2549_3232"
          x1="2.42424"
          y1="3.31137e-07"
          x2="20"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8F3EBC" />
          <stop offset="1" stopColor="#1776F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const TransparentHeart = ({ isFavorite }: { isFavorite: boolean }) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_2776_4162" fill={"white"}>
      <path d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z" />
    </mask>
    <path
      d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
      fill={"white"}
      fillOpacity="0.12"
    />
    <path
      d="M0 18M36 18M36 18M0 18M18 0M36 18M18 36M0 18M18 36V35C8.61116 35 1 27.3888 1 18H0H-1C-1 28.4934 7.50659 37 18 37V36ZM36 18H35C35 27.3888 27.3888 35 18 35V36V37C28.4934 37 37 28.4934 37 18H36ZM18 0V1C27.3888 1 35 8.61116 35 18H36H37C37 7.50659 28.4934 -1 18 -1V0ZM18 0V-1C7.50659 -1 -1 7.50659 -1 18H0H1C1 8.61116 8.61116 1 18 1V0Z"
      fill={isFavorite ? "#EB4D6E" : "white"}
      fillOpacity="0.2"
      mask="url(#path-1-inside-1_2776_4162)"
    />
    <path
      d="M23.25 19.5C24.3675 18.405 25.5 17.0925 25.5 15.375C25.5 14.281 25.0654 13.2318 24.2918 12.4582C23.5182 11.6846 22.469 11.25 21.375 11.25C20.055 11.25 19.125 11.625 18 12.75C16.875 11.625 15.945 11.25 14.625 11.25C13.531 11.25 12.4818 11.6846 11.7082 12.4582C10.9346 13.2318 10.5 14.281 10.5 15.375C10.5 17.1 11.625 18.4125 12.75 19.5L18 24.75L23.25 19.5Z"
      stroke={isFavorite ? "#EB4D6E" : "white"}
      fill={isFavorite ? "#EB4D6E" : "none"}
      strokeOpacity="0.65"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BlueHeart = ({ isFavorite }: { isFavorite: boolean }) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask id="path-1-inside-1_2776_4176" fill="white">
      <path d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z" />
    </mask>
    <path
      d="M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z"
      fill="#1776F0"
      fillOpacity="0.2"
    />
    <path
      d="M0 18M36 18M36 18M0 18M18 0M36 18M18 36M0 18M18 36V35C8.61116 35 1 27.3888 1 18H0H-1C-1 28.4934 7.50659 37 18 37V36ZM36 18H35C35 27.3888 27.3888 35 18 35V36V37C28.4934 37 37 28.4934 37 18H36ZM18 0V1C27.3888 1 35 8.61116 35 18H36H37C37 7.50659 28.4934 -1 18 -1V0ZM18 0V-1C7.50659 -1 -1 7.50659 -1 18H0H1C1 8.61116 8.61116 1 18 1V0Z"
      fill={isFavorite ? "#EB4D6E" : "#1776F0"}
      mask="url(#path-1-inside-1_2776_4176)"
    />
    <path
      d="M23.25 19.5C24.3675 18.405 25.5 17.0925 25.5 15.375C25.5 14.281 25.0654 13.2318 24.2918 12.4582C23.5182 11.6846 22.469 11.25 21.375 11.25C20.055 11.25 19.125 11.625 18 12.75C16.875 11.625 15.945 11.25 14.625 11.25C13.531 11.25 12.4818 11.6846 11.7082 12.4582C10.9346 13.2318 10.5 14.281 10.5 15.375C10.5 17.1 11.625 18.4125 12.75 19.5L18 24.75L23.25 19.5Z"
      fill={isFavorite ? "#EB4D6E" : "white"}
      stroke={isFavorite ? "#EB4D6E" : "#1776F0"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilledGlobe = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.0808 5.52922C24.4936 5.21255 25.7938 4.80004 26.9397 4.31254C25.0916 2.58475 22.8319 1.29032 20.3261 0.590226C21.522 1.93465 22.4258 3.70547 23.0808 5.52922ZM10.5101 5.83894C11.8131 2.27236 13.7891 0 16.0002 0C18.4601 0 20.3681 2.94724 21.45 5.8457C17.936 6.42486 14.0202 6.42209 10.5105 5.83875L10.5101 5.83894ZM5.06033 4.31254C6.21729 4.80281 7.52721 5.21533 8.95519 5.53615C9.69913 3.50279 10.6572 1.80281 11.7572 0.569387C9.2194 1.2666 6.93036 2.568 5.06143 4.31375L5.06033 4.31254ZM8.91923 26.4708C7.50639 26.7874 6.20621 27.2 5.06033 27.6875C6.9084 29.4152 9.16807 30.7097 11.6739 31.4098C10.478 30.0653 9.57421 28.2945 8.91923 26.4708ZM21.4899 26.1611C20.1869 29.7276 18.2109 32 15.9998 32C13.5399 32 11.6319 29.0528 10.55 26.1543C14.064 25.5751 17.9798 25.5779 21.4895 26.1612L21.4899 26.1611ZM26.9397 27.6875C25.7827 27.1972 24.4728 26.7847 23.0448 26.4639C22.3009 28.4972 21.3428 30.1972 20.2428 31.4306C22.7806 30.7334 25.0696 29.432 26.9386 27.6863L26.9397 27.6875ZM7.25748 16.821H0.00138837C0.186335 20.4835 1.6075 23.8222 3.84926 26.4281C5.18421 25.8128 6.72218 25.2975 8.41586 24.9059C7.73586 22.517 7.3201 19.7613 7.25474 16.8212L7.25748 16.821ZM23.0989 16.821H8.90108C8.96504 19.6654 9.37109 22.3111 10.0302 24.582C13.8934 23.9098 18.14 23.914 21.9989 24.5862C22.6399 22.3209 23.035 19.6697 23.0989 16.821ZM31.9986 16.821H24.7439C24.6758 19.7585 24.2531 22.5099 23.5592 24.8988C25.2612 25.2905 26.809 25.8058 28.1482 26.428C30.394 23.8225 31.811 20.4835 32 16.8209L31.9986 16.821ZM24.7425 15.1793H31.9972C31.8122 11.5167 30.3911 8.17804 28.1493 5.57217C26.8144 6.18746 25.2764 6.70273 23.5827 7.09438C24.2627 9.48328 24.6785 12.2389 24.7438 15.179L24.7425 15.1793ZM8.90108 15.1793H23.0975C23.0335 12.3348 22.6275 9.68915 21.9683 7.41822C18.1052 8.09043 13.8586 8.08627 9.99969 7.41405C9.35863 9.67933 8.96369 12.3307 8.89976 15.1794L8.90108 15.1793ZM0.00138837 15.1793H7.25606C7.3242 12.2418 7.74693 9.4904 8.44082 7.10142C6.73877 6.70973 5.19105 6.19446 3.85178 5.57224C1.606 8.17779 0.189029 11.5168 0 15.1794L0.00138837 15.1793Z"
      fill="white"
    />
  </svg>
);

export const Bank = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66775 8.0418H29.3344C29.6438 8.0418 29.9131 7.83017 29.9821 7.52937C30.0544 7.22723 29.9078 6.91976 29.6318 6.78001L16.2441 0.0703781C16.0561 -0.0241237 15.8334 -0.0227927 15.6441 0.0703781L2.36508 6.78134C2.09042 6.92109 1.94642 7.23122 2.01842 7.5307C2.09042 7.83017 2.35975 8.0418 2.66775 8.0418Z"
      fill="white"
    />
    <path d="M4 9.37281H8V21.3519H4V9.37281Z" fill="white" />
    <path d="M13.332 9.37281H18.6654V21.3519H13.332V9.37281Z" fill="white" />
    <path d="M24 9.37281H28V21.3519H24V9.37281Z" fill="white" />
    <path
      d="M2.66406 23.3484V25.3449H29.3307V23.3484C29.3307 22.9811 29.0307 22.6829 28.6641 22.6829H3.33073C2.96273 22.6829 2.66406 22.9811 2.66406 23.3484Z"
      fill="white"
    />
    <path
      d="M31.3333 26.676H0.666667C0.298667 26.676 0 26.9741 0 27.3415V31.3345C0 31.7005 0.298667 32 0.666667 32H31.3333C31.7 32 32 31.7005 32 31.3345V27.3415C32 26.9741 31.7 26.676 31.3333 26.676Z"
      fill="white"
    />
  </svg>
);

export const StudyBook = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.9872 32C15.9801 32 15.9729 32 15.9658 31.9986L15.9872 32ZM15.5889 30.805V14.7079C13.5787 13.2928 11.4615 12.1692 9.15017 11.2858C6.89729 10.4238 4.46467 9.78916 1.77325 9.32884V25.5917C4.5772 26.062 7.10566 26.7181 9.4411 27.6115C11.634 28.4492 13.6599 29.4998 15.5885 30.8049L15.5889 30.805ZM0.953834 10.6024V25.9391H0.955261C0.955261 26.1377 1.09803 26.3107 1.30076 26.3436C3.75206 26.7396 5.98918 27.2742 8.07061 27.9875C6.5487 27.6902 4.95687 27.47 3.27364 27.2384C2.21717 27.0926 1.12357 26.9425 0 26.7653V10.4322C0.129919 10.4551 0.268404 10.4794 0.415445 10.5051C0.599616 10.5365 0.77964 10.5696 0.953834 10.6024ZM25.8239 2.93632V8.08512L25.0001 8.07797V3.16337L25.8239 2.93632ZM23.928 27.9861C25.4499 27.6888 27.0417 27.4687 28.7249 27.2371C29.7814 27.0913 30.875 26.9412 32 26.7639V10.4308C31.8701 10.4537 31.7316 10.478 31.5846 10.5037C31.3975 10.5366 31.2176 10.5695 31.0449 10.6024V25.939H31.0435C31.0435 26.1377 30.9007 26.3106 30.698 26.3435C28.2467 26.7381 26.0094 27.2728 23.928 27.9861ZM15.9988 0L7.30576 2.3915L9.17459 2.90466C9.19886 2.90895 9.22313 2.9161 9.24597 2.92467L16.0001 4.78296L22.7542 2.92467C22.7771 2.9161 22.8014 2.90895 22.8256 2.90466L24.6945 2.3915L15.9988 0ZM20.5403 12.2762C21.2798 11.9203 22.3491 11.5272 23.477 11.1541L23.133 11.8488L23.7612 12.2462C24.2722 12.5693 24.8405 12.7822 25.4515 12.7808C26.0454 12.7794 26.5951 12.5721 27.0848 12.2448L27.6844 11.8417L26.8364 10.1292C27.9485 9.81325 28.7666 9.60026 28.8736 9.57882C29.3291 9.48733 29.7788 9.40443 30.2228 9.32866V25.5915C27.4188 26.0618 24.8904 26.7179 22.5549 27.6113C20.362 28.4504 18.3362 29.4996 16.409 30.8062V14.7076C17.7353 13.7728 19.1044 12.968 20.5408 12.2761L20.5403 12.2762ZM26.6249 11.5587C26.2337 11.8217 25.8411 11.9546 25.4499 11.9561C25.0487 11.9575 24.6333 11.8217 24.2021 11.5486L25.4114 9.10569L26.6249 11.5587ZM9.51145 3.84828L15.8917 5.60367C15.9674 5.62368 16.043 5.62225 16.113 5.60224L22.4874 3.84828V8.55685C20.2845 9.38736 18.1031 9.79476 15.9416 9.79191C13.783 9.78905 11.6398 9.37451 9.51126 8.55971L9.51145 3.84828Z"
      fill="white"
    />
  </svg>
);

export const DotGrid = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.12">
      <path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        fill="white"
      />
      <path
        d="M30 12.5C31.3807 12.5 32.5 11.3807 32.5 10C32.5 8.61929 31.3807 7.5 30 7.5C28.6193 7.5 27.5 8.61929 27.5 10C27.5 11.3807 28.6193 12.5 30 12.5Z"
        fill="white"
      />
      <path
        d="M50 12.5C51.3807 12.5 52.5 11.3807 52.5 10C52.5 8.61929 51.3807 7.5 50 7.5C48.6193 7.5 47.5 8.61929 47.5 10C47.5 11.3807 48.6193 12.5 50 12.5Z"
        fill="white"
      />
      <path
        d="M70 12.5C71.3807 12.5 72.5 11.3807 72.5 10C72.5 8.61929 71.3807 7.5 70 7.5C68.6193 7.5 67.5 8.61929 67.5 10C67.5 11.3807 68.6193 12.5 70 12.5Z"
        fill="white"
      />
      <path
        d="M10 32.5C11.3807 32.5 12.5 31.3807 12.5 30C12.5 28.6193 11.3807 27.5 10 27.5C8.61929 27.5 7.5 28.6193 7.5 30C7.5 31.3807 8.61929 32.5 10 32.5Z"
        fill="white"
      />
      <path
        d="M30 32.5C31.3807 32.5 32.5 31.3807 32.5 30C32.5 28.6193 31.3807 27.5 30 27.5C28.6193 27.5 27.5 28.6193 27.5 30C27.5 31.3807 28.6193 32.5 30 32.5Z"
        fill="white"
      />
      <path
        d="M50 32.5C51.3807 32.5 52.5 31.3807 52.5 30C52.5 28.6193 51.3807 27.5 50 27.5C48.6193 27.5 47.5 28.6193 47.5 30C47.5 31.3807 48.6193 32.5 50 32.5Z"
        fill="white"
      />
      <path
        d="M70 32.5C71.3807 32.5 72.5 31.3807 72.5 30C72.5 28.6193 71.3807 27.5 70 27.5C68.6193 27.5 67.5 28.6193 67.5 30C67.5 31.3807 68.6193 32.5 70 32.5Z"
        fill="white"
      />
      <path
        d="M10 52.5C11.3807 52.5 12.5 51.3807 12.5 50C12.5 48.6193 11.3807 47.5 10 47.5C8.61929 47.5 7.5 48.6193 7.5 50C7.5 51.3807 8.61929 52.5 10 52.5Z"
        fill="white"
      />
      <path
        d="M30 52.5C31.3807 52.5 32.5 51.3807 32.5 50C32.5 48.6193 31.3807 47.5 30 47.5C28.6193 47.5 27.5 48.6193 27.5 50C27.5 51.3807 28.6193 52.5 30 52.5Z"
        fill="white"
      />
      <path
        d="M50 52.5C51.3807 52.5 52.5 51.3807 52.5 50C52.5 48.6193 51.3807 47.5 50 47.5C48.6193 47.5 47.5 48.6193 47.5 50C47.5 51.3807 48.6193 52.5 50 52.5Z"
        fill="white"
      />
      <path
        d="M70 52.5C71.3807 52.5 72.5 51.3807 72.5 50C72.5 48.6193 71.3807 47.5 70 47.5C68.6193 47.5 67.5 48.6193 67.5 50C67.5 51.3807 68.6193 52.5 70 52.5Z"
        fill="white"
      />
      <path
        d="M10 72.5C11.3807 72.5 12.5 71.3807 12.5 70C12.5 68.6193 11.3807 67.5 10 67.5C8.61929 67.5 7.5 68.6193 7.5 70C7.5 71.3807 8.61929 72.5 10 72.5Z"
        fill="white"
      />
      <path
        d="M30 72.5C31.3807 72.5 32.5 71.3807 32.5 70C32.5 68.6193 31.3807 67.5 30 67.5C28.6193 67.5 27.5 68.6193 27.5 70C27.5 71.3807 28.6193 72.5 30 72.5Z"
        fill="white"
      />
      <path
        d="M50 72.5C51.3807 72.5 52.5 71.3807 52.5 70C52.5 68.6193 51.3807 67.5 50 67.5C48.6193 67.5 47.5 68.6193 47.5 70C47.5 71.3807 48.6193 72.5 50 72.5Z"
        fill="white"
      />
      <path
        d="M70 72.5C71.3807 72.5 72.5 71.3807 72.5 70C72.5 68.6193 71.3807 67.5 70 67.5C68.6193 67.5 67.5 68.6193 67.5 70C67.5 71.3807 68.6193 72.5 70 72.5Z"
        fill="white"
      />
    </g>
  </svg>
);


export const BotMic = () => (
  <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 1.16669C6.53587 1.16669 6.09075 1.35106 5.76256 1.67925C5.43437 2.00744 5.25 2.45256 5.25 2.91669V7.00002C5.25 7.46415 5.43437 7.90927 5.76256 8.23746C6.09075 8.56565 6.53587 8.75002 7 8.75002C7.46413 8.75002 7.90925 8.56565 8.23744 8.23746C8.56563 7.90927 8.75 7.46415 8.75 7.00002V2.91669C8.75 2.45256 8.56563 2.00744 8.23744 1.67925C7.90925 1.35106 7.46413 1.16669 7 1.16669Z" stroke="#6B3FC8" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11.0833 5.83331V6.99998C11.0833 8.08295 10.6531 9.12156 9.88731 9.88733C9.12154 10.6531 8.08293 11.0833 6.99996 11.0833C5.91699 11.0833 4.87838 10.6531 4.11261 9.88733C3.34683 9.12156 2.91663 8.08295 2.91663 6.99998V5.83331" stroke="#6B3FC8" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7 11.0833V12.8333" stroke="#6B3FC8" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)

export const SendIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3043_8510)">
      <path d="M8.4793 12.6502C8.50146 12.7054 8.53999 12.7525 8.58971 12.7852C8.63943 12.8179 8.69797 12.8347 8.75746 12.8331C8.81695 12.8316 8.87455 12.8119 8.92253 12.7767C8.97052 12.7415 9.00658 12.6925 9.02588 12.6362L12.8176 1.55285C12.8362 1.50116 12.8398 1.44522 12.8278 1.39159C12.8159 1.33795 12.7889 1.28883 12.75 1.24997C12.7112 1.21111 12.662 1.18412 12.6084 1.17216C12.5548 1.1602 12.4988 1.16376 12.4471 1.18243L1.3638 4.9741C1.30751 4.9934 1.25847 5.02946 1.22326 5.07745C1.18805 5.12543 1.16837 5.18303 1.16684 5.24252C1.16532 5.30201 1.18203 5.36055 1.21474 5.41027C1.24744 5.45999 1.29457 5.49852 1.3498 5.52068L5.97563 7.37568C6.12187 7.43423 6.25473 7.52178 6.36621 7.63306C6.4777 7.74435 6.56549 7.87705 6.6243 8.02318L8.4793 12.6502Z" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.7481 1.25244L6.36646 7.63352" stroke="white" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3043_8510">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>

)

export const ListningIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
    <rect x="6" y="6" width="12" height="12" rx="2" />
  </svg>
)

export const SortIcon = () => (
  <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.583328H15M3.33333 5.58333H11.6667M6.66667 10.5833H8.33333" stroke="#374151" stroke-width="1.16667" />
  </svg>

)


export const LeadProfileIcon = () => (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.45247 2.03648H2.03581C1.66008 2.03648 1.29975 2.18573 1.03407 2.45141C0.768396 2.71709 0.619141 3.07742 0.619141 3.45315V11.9531C0.619141 12.3289 0.768396 12.6892 1.03407 12.9549C1.29975 13.2206 1.66008 13.3698 2.03581 13.3698H9.11914C9.49486 13.3698 9.8552 13.2206 10.1209 12.9549C10.3866 12.6892 10.5358 12.3289 10.5358 11.9531V3.45315C10.5358 3.07742 10.3866 2.71709 10.1209 2.45141C9.8552 2.18573 9.49486 2.03648 9.11914 2.03648H7.70247M3.45247 2.03648C3.45247 2.4122 3.60173 2.77254 3.86741 3.03821C4.13308 3.30389 4.49342 3.45315 4.86914 3.45315H6.28581C6.66153 3.45315 7.02186 3.30389 7.28754 3.03821C7.55322 2.77254 7.70247 2.4122 7.70247 2.03648M3.45247 2.03648C3.45247 1.66076 3.60173 1.30042 3.86741 1.03474C4.13308 0.769067 4.49342 0.619812 4.86914 0.619812H6.28581C6.66153 0.619812 7.02186 0.769067 7.28754 1.03474C7.55322 1.30042 7.70247 1.66076 7.70247 2.03648" stroke="white" stroke-width="1.23958" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const LeadEligibilityCheckIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_3276_13022)">
      <path d="M15.5827 7.84832V8.49999C15.5818 10.0275 15.0872 11.5137 14.1726 12.7371C13.2581 13.9605 11.9725 14.8555 10.5077 15.2886C9.04295 15.7217 7.47741 15.6697 6.0446 15.1403C4.61179 14.611 3.38848 13.6326 2.55711 12.3512C1.72575 11.0698 1.33087 9.55403 1.43137 8.02987C1.53187 6.50572 2.12237 5.05488 3.1148 3.89375C4.10722 2.73261 5.44841 1.92338 6.93832 1.58676C8.42823 1.25013 9.98704 1.40414 11.3823 2.02582" stroke="white" stroke-width="1.24" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M15.5833 2.83331L8.5 9.92373L6.375 7.79873" stroke="white" stroke-width="1.24" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3276_13022">
        <rect width="17" height="17" fill="white" />
      </clipPath>
    </defs>
  </svg>

)


export const LeadApplyNowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99414 11.9531L13.3691 13.3698L6.99414 0.619812L0.619141 13.3698L6.99414 11.9531ZM6.99414 11.9531V6.28648" stroke="white" stroke-width="1.23958" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

)


export const LeadTrackIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99414 4.16148V6.99481L9.11914 9.11981M13.3691 6.99481C13.3691 7.83199 13.2042 8.66097 12.8839 9.43442C12.5635 10.2079 12.0939 10.9106 11.5019 11.5026C10.91 12.0946 10.2072 12.5642 9.43375 12.8845C8.6603 13.2049 7.83132 13.3698 6.99414 13.3698C6.15696 13.3698 5.32798 13.2049 4.55453 12.8845C3.78108 12.5642 3.07831 12.0946 2.48633 11.5026C1.89436 10.9106 1.42478 10.2079 1.10441 9.43442C0.784035 8.66097 0.619141 7.83199 0.619141 6.99481C0.619141 5.30406 1.29079 3.68255 2.48633 2.48701C3.68188 1.29146 5.30339 0.619812 6.99414 0.619812C8.6849 0.619812 10.3064 1.29146 11.5019 2.48701C12.6975 3.68255 13.3691 5.30406 13.3691 6.99481Z" stroke="white" stroke-width="1.23958" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
)

export const SparkleGradient = () => (
  <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.73263 7.84263C3.41367 5.1956 2.75601 4.52337 0.166257 4.1976C-0.0554188 4.16991 -0.0554188 3.84263 0.166257 3.81495C2.75617 3.48896 3.41389 2.81805 3.73263 0.169923C3.75973 -0.056641 4.07994 -0.056641 4.10702 0.169923C4.42598 2.81695 5.08365 3.48918 7.6734 3.81495C7.89508 3.84265 7.89508 4.16992 7.6734 4.1976C5.08349 4.5236 4.42576 5.1945 4.10702 7.84263C4.07993 8.06919 3.75972 8.06919 3.73263 7.84263ZM27.8337 24.8024C25.2438 24.4764 24.5861 23.8042 24.2674 21.1574C24.2403 20.9308 23.9201 20.9308 23.893 21.1574C23.574 23.8044 22.9164 24.4766 20.3266 24.8024C20.1049 24.8301 20.1049 25.1574 20.3266 25.185C22.9165 25.511 23.5742 26.182 23.893 28.8301C23.9201 29.0566 24.2403 29.0566 24.2674 28.8301C24.5863 26.183 25.244 25.5108 27.8337 25.185C28.0554 25.1574 28.0554 24.8301 27.8337 24.8024ZM23.6526 13.5912C16.9912 12.7541 15.3003 11.0259 14.4825 4.21887C14.4123 3.63609 13.5884 3.63609 13.5182 4.21887C12.6992 11.0272 11.0084 12.7553 4.34818 13.5912C3.77797 13.6629 3.77797 14.505 4.34818 14.5767C11.0096 15.4138 12.7004 17.1419 13.5182 23.949C13.5884 24.5318 14.4123 24.5318 14.4825 23.949C15.3015 17.1407 16.9924 15.4126 23.6526 14.5767C24.2228 14.505 24.2228 13.6629 23.6526 13.5912Z" fill="url(#paint0_linear_3322_2387)" />
    <defs>
      <linearGradient id="paint0_linear_3322_2387" x1="14" y1="0" x2="14" y2="29" gradientUnits="userSpaceOnUse">
        <stop stop-color="#1776F0" />
        <stop offset="1" stop-color="#8F3EBC" />
      </linearGradient>
    </defs>
  </svg>

)


export const QuickSearch = () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.25 8.125C16.25 9.92188 15.6641 11.6016 14.6875 12.9297L19.6094 17.8906C20.1172 18.3594 20.1172 19.1797 19.6094 19.6484C19.1406 20.1562 18.3203 20.1562 17.8516 19.6484L12.8906 14.6875C11.5625 15.7031 9.88281 16.25 8.125 16.25C3.63281 16.25 0 12.6172 0 8.125C0 3.67188 3.63281 0 8.125 0C12.5781 0 16.25 3.67188 16.25 8.125ZM8.125 13.75C10.1172 13.75 11.9531 12.6953 12.9688 10.9375C13.9844 9.21875 13.9844 7.07031 12.9688 5.3125C11.9531 3.59375 10.1172 2.5 8.125 2.5C6.09375 2.5 4.25781 3.59375 3.24219 5.3125C2.22656 7.07031 2.22656 9.21875 3.24219 10.9375C4.25781 12.6953 6.09375 13.75 8.125 13.75Z" fill="#1D6AED" />
  </svg>

)

export const QuickEligibility = () => (
  <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 0H8.75V5C8.75 5.70312 9.29688 6.25 10 6.25H15V17.5C15 18.9062 13.8672 20 12.5 20H2.5C1.09375 20 0 18.9062 0 17.5V2.5C0 1.13281 1.09375 0 2.5 0ZM10 0L15 5H10V0ZM4.375 10C4.02344 10 3.75 10.3125 3.75 10.625C3.75 10.9766 4.02344 11.25 4.375 11.25H10.625C10.9375 11.25 11.25 10.9766 11.25 10.625C11.25 10.3125 10.9375 10 10.625 10H4.375ZM4.375 12.5C4.02344 12.5 3.75 12.8125 3.75 13.125C3.75 13.4766 4.02344 13.75 4.375 13.75H10.625C10.9375 13.75 11.25 13.4766 11.25 13.125C11.25 12.8125 10.9375 12.5 10.625 12.5H4.375ZM4.375 15C4.02344 15 3.75 15.3125 3.75 15.625C3.75 15.9766 4.02344 16.25 4.375 16.25H10.625C10.9375 16.25 11.25 15.9766 11.25 15.625C11.25 15.3125 10.9375 15 10.625 15H4.375Z" fill="#6D28D9" />
  </svg>

)

export const QuickSession = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.75 1.25C3.75 0.585938 4.29688 0 5 0C5.66406 0 6.25 0.585938 6.25 1.25V2.5H11.25V1.25C11.25 0.585938 11.7969 0 12.5 0C13.1641 0 13.75 0.585938 13.75 1.25V2.5H15.625C16.6406 2.5 17.5 3.35938 17.5 4.375V6.25H0V4.375C0 3.35938 0.820312 2.5 1.875 2.5H3.75V1.25ZM17.5 7.5V18.125C17.5 19.1797 16.6406 20 15.625 20H1.875C0.820312 20 0 19.1797 0 18.125V7.5H17.5ZM8.75 9.6875C8.20312 9.6875 7.8125 10.1172 7.8125 10.625V12.8125H5.625C5.07812 12.8125 4.6875 13.2422 4.6875 13.75C4.6875 14.2969 5.07812 14.6875 5.625 14.6875H7.8125V16.875C7.8125 17.4219 8.20312 17.8125 8.75 17.8125C9.25781 17.8125 9.6875 17.4219 9.6875 16.875V14.6875H11.875C12.3828 14.6875 12.8125 14.2969 12.8125 13.75C12.8125 13.2422 12.3828 12.8125 11.875 12.8125H9.6875V10.625C9.6875 10.1172 9.25781 9.6875 8.75 9.6875Z" fill="#E88A00" />
  </svg>

)

export const QuickBot = () => (
  <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 0C13.1641 0 13.75 0.585938 13.75 1.25V3.75H18.4375C19.9609 3.75 21.25 5.03906 21.25 6.5625V17.1875C21.25 18.75 19.9609 20 18.4375 20H6.5625C5 20 3.75 18.75 3.75 17.1875V6.5625C3.75 5.03906 5 3.75 6.5625 3.75H11.25V1.25C11.25 0.585938 11.7969 0 12.5 0ZM8.125 15C7.77344 15 7.5 15.3125 7.5 15.625C7.5 15.9766 7.77344 16.25 8.125 16.25H9.375C9.6875 16.25 10 15.9766 10 15.625C10 15.3125 9.6875 15 9.375 15H8.125ZM11.875 15C11.5234 15 11.25 15.3125 11.25 15.625C11.25 15.9766 11.5234 16.25 11.875 16.25H13.125C13.4375 16.25 13.75 15.9766 13.75 15.625C13.75 15.3125 13.4375 15 13.125 15H11.875ZM15.625 15C15.2734 15 15 15.3125 15 15.625C15 15.9766 15.2734 16.25 15.625 16.25H16.875C17.1875 16.25 17.5 15.9766 17.5 15.625C17.5 15.3125 17.1875 15 16.875 15H15.625ZM10.3125 10C10.3125 9.45312 10 8.94531 9.53125 8.67188C9.02344 8.39844 8.4375 8.39844 7.96875 8.67188C7.46094 8.94531 7.1875 9.45312 7.1875 10C7.1875 10.5859 7.46094 11.0938 7.96875 11.3672C8.4375 11.6406 9.02344 11.6406 9.53125 11.3672C10 11.0938 10.3125 10.5859 10.3125 10ZM16.25 11.5625C16.7969 11.5625 17.3047 11.2891 17.5781 10.7812C17.8516 10.3125 17.8516 9.72656 17.5781 9.21875C17.3047 8.75 16.7969 8.4375 16.25 8.4375C15.6641 8.4375 15.1562 8.75 14.8828 9.21875C14.6094 9.72656 14.6094 10.3125 14.8828 10.7812C15.1562 11.2891 15.6641 11.5625 16.25 11.5625ZM1.875 8.75H2.5V16.25H1.875C0.820312 16.25 0 15.4297 0 14.375V10.625C0 9.60938 0.820312 8.75 1.875 8.75ZM23.125 8.75C24.1406 8.75 25 9.60938 25 10.625V14.375C25 15.4297 24.1406 16.25 23.125 16.25H22.5V8.75H23.125Z" fill="#059669" />
  </svg>

)

export const CheckMark2 = () => (<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z" fill="url(#paint0_linear_3959_4363)" />
  <path d="M24 32.5L29.5 38L40 26" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  <defs>
    <linearGradient id="paint0_linear_3959_4363" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
      <stop stop-color="#3D6FF2" />
      <stop offset="1" stop-color="#8B5CF6" />
    </linearGradient>
  </defs>
</svg>
)